import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSONScalar: { input: any; output: any; }
  JSONString: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AiOpportunityFactorType = {
  __typename?: 'AIOpportunityFactorType';
  column?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  examples?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  relevance?: Maybe<Scalars['String']['output']>;
  rubricHigh?: Maybe<Scalars['String']['output']>;
  rubricLow?: Maybe<Scalars['String']['output']>;
  rubricMedium?: Maybe<Scalars['String']['output']>;
  signals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type AiRiskFactorType = {
  __typename?: 'AIRiskFactorType';
  aiErosionNote?: Maybe<Scalars['String']['output']>;
  aiErosionRisk?: Maybe<Scalars['String']['output']>;
  column?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  examples?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  relevance?: Maybe<Scalars['String']['output']>;
  rubricHigh?: Maybe<Scalars['String']['output']>;
  rubricLow?: Maybe<Scalars['String']['output']>;
  rubricMedium?: Maybe<Scalars['String']['output']>;
  signals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type AcquireValidationLock = {
  __typename?: 'AcquireValidationLock';
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  lockedBy?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivateProbationaryPattern = {
  __typename?: 'ActivateProbationaryPattern';
  error?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<ClassificationPatternType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddBuyAndBuildTarget = {
  __typename?: 'AddBuyAndBuildTarget';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AddBuyAndBuildTargetsFromSourcescrub = {
  __typename?: 'AddBuyAndBuildTargetsFromSourcescrub';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AddCompanyCertification = {
  __typename?: 'AddCompanyCertification';
  companyCertificationId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddCoreKeyword = {
  __typename?: 'AddCoreKeyword';
  dbId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddCustomerSegmentMutation = {
  __typename?: 'AddCustomerSegmentMutation';
  definitionUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  segmentDescription?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddIndustry = {
  __typename?: 'AddIndustry';
  companyId?: Maybe<Scalars['Int']['output']>;
  referencedAt?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
};

export type AddJobDescriptionUrl = {
  __typename?: 'AddJobDescriptionURL';
  jobDescriptionUrl?: Maybe<Scalars['String']['output']>;
};

export type AddSoftwareCategoryToCompany = {
  __typename?: 'AddSoftwareCategoryToCompany';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTechnologyFindingText = {
  __typename?: 'AddTechnologyFindingText';
  companyId?: Maybe<Scalars['Int']['output']>;
  findingText?: Maybe<Scalars['String']['output']>;
};

export type AddTechnologyFindingUrl = {
  __typename?: 'AddTechnologyFindingUrl';
  companyId?: Maybe<Scalars['Int']['output']>;
  findingUrl?: Maybe<Scalars['String']['output']>;
};

export type AdjustPatternWeights = {
  __typename?: 'AdjustPatternWeights';
  result?: Maybe<WeightAdjustmentResultType>;
};

export type AlertType = {
  __typename?: 'AlertType';
  currentValue?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AllowImmediateCrawlMutation = {
  __typename?: 'AllowImmediateCrawlMutation';
  cortexVerificationsDeleted?: Maybe<Scalars['Int']['output']>;
  databaseEntries?: Maybe<Scalars['Int']['output']>;
  databaseEntriesDeleted?: Maybe<Scalars['Int']['output']>;
  databaseEntriesWillPreventCrawl?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
  redisKeysCleared?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AvailableGoogleDriveType = {
  __typename?: 'AvailableGoogleDriveType';
  name?: Maybe<Scalars['String']['output']>;
};

export type BabCompanyType = Node & {
  __typename?: 'BABCompanyType';
  address?: Maybe<Scalars['String']['output']>;
  benchmarkingIndex?: Maybe<Scalars['Int']['output']>;
  buyAndBuildSources?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  buyAndBuildTargets?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  city?: Maybe<Scalars['String']['output']>;
  companyAnalyses?: Maybe<CompanyAnalysisTypeConnection>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactEmailConfidence?: Maybe<Scalars['Float']['output']>;
  contactEmailType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Scalars['String']['output']>;
  crawlResults?: Maybe<Array<Maybe<RecentPlatformCrawlType>>>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  doNotCrawl?: Maybe<Scalars['Boolean']['output']>;
  dueDilligence?: Maybe<Scalars['Boolean']['output']>;
  emailPattern?: Maybe<Scalars['String']['output']>;
  excelFiles?: Maybe<Array<Maybe<UploadExcelFileType>>>;
  foundingYear?: Maybe<Scalars['Int']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  gdriveDirectoryId: Scalars['String']['output'];
  gdriveDirectoryName: Scalars['String']['output'];
  gdriveSharedDriveId: Scalars['String']['output'];
  gdriveSharedDriveName: Scalars['String']['output'];
  genericShareholdings?: Maybe<GenericShareholdingSqlTypeConnection>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  hrbNumber?: Maybe<Scalars['String']['output']>;
  iabDomainCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialSource?: Maybe<Scalars['String']['output']>;
  isBidPortfolioCompany?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isGenericIndustryCompany?: Maybe<Scalars['Boolean']['output']>;
  isHorizontalSoftware?: Maybe<Scalars['Boolean']['output']>;
  isItCompanyCompany?: Maybe<Scalars['Boolean']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  isSaasCompany?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  klazifyDomain?: Maybe<KlazifyDomainType>;
  klazifyDomains?: Maybe<KlazifyDomainConnection>;
  latestCrawlResult?: Maybe<GenericCrawlResultSqlType>;
  legalName?: Maybe<Scalars['String']['output']>;
  linkedinFte?: Maybe<Scalars['Int']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  managingDirector?: Maybe<Scalars['String']['output']>;
  maxFte?: Maybe<Scalars['Int']['output']>;
  maxFteAnalysis?: Maybe<Scalars['Int']['output']>;
  mergedIntoId?: Maybe<Scalars['Int']['output']>;
  numberOfFailedCrawls?: Maybe<Scalars['Int']['output']>;
  parentCompany?: Maybe<BuyAndBuildTargetAssessmentType>;
  patternMatches?: Maybe<Array<Maybe<ClassificationPatternMatchType>>>;
  peOwned?: Maybe<Scalars['Boolean']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  precalculatedKpis?: Maybe<KpiPreCalculationTypeConnection>;
  privateOwned?: Maybe<Scalars['Boolean']['output']>;
  productCategorization?: Maybe<ProductCategorizationConnection>;
  ragValidations?: Maybe<Array<Maybe<RagValidationResultType>>>;
  shareholders?: Maybe<GenericShareHolderTypeConnection>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  sicCodeCertainty?: Maybe<Scalars['Float']['output']>;
  sicCodeDetails?: Maybe<SicCodeSqlType>;
  sicCodeJustification?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  subsidiaries?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  subsidiaryOf?: Maybe<Scalars['Int']['output']>;
  summaryDescription?: Maybe<Scalars['String']['output']>;
  techUse?: Maybe<GenericCompanyTechUseConnection>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
  validated?: Maybe<Scalars['Boolean']['output']>;
  validationDatetime?: Maybe<Scalars['DateTime']['output']>;
  validationLockedAt?: Maybe<Scalars['DateTime']['output']>;
  validationLockedBy?: Maybe<Scalars['Int']['output']>;
  validationSignals?: Maybe<Array<Maybe<RagValidationSignalType>>>;
  validationUser?: Maybe<Scalars['String']['output']>;
  ycCompany?: Maybe<YcCompanyTypeConnection>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type BabCompanyTypeBuyAndBuildSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BabCompanyTypeBuyAndBuildTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BabCompanyTypeCompanyAnalysesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BabCompanyTypeGenericShareholdingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BabCompanyTypeKlazifyDomainsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BabCompanyTypePrecalculatedKpisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BabCompanyTypeProductCategorizationArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BabCompanyTypeShareholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BabCompanyTypeSubsidiariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BabCompanyTypeTechUseArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BabCompanyTypeYcCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BackfillCoreKeywordsInput = {
  numRecords: Scalars['Int']['input'];
  numWorkers: Scalars['Int']['input'];
};

export type BackfillCoreKeywordsMutation = {
  __typename?: 'BackfillCoreKeywordsMutation';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  totalAffected?: Maybe<Scalars['Int']['output']>;
};

export type BackfillEmbeddingsV2Input = {
  chunkSize?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
};

export type BackfillEmbeddingsV2Mutation = {
  __typename?: 'BackfillEmbeddingsV2Mutation';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tasksQueued?: Maybe<Scalars['Int']['output']>;
  totalScds?: Maybe<Scalars['Int']['output']>;
};

export type BackfillHrKeywordsAndSicInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type BackfillHrKeywordsAndSicMutation = {
  __typename?: 'BackfillHRKeywordsAndSicMutation';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  totalAffected?: Maybe<Scalars['Int']['output']>;
};

export type BackfillHrOfficerBridgeInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type BackfillHrOfficerBridgeMutation = {
  __typename?: 'BackfillHROfficerBridgeMutation';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  totalAffected?: Maybe<Scalars['Int']['output']>;
};

export type BackfillHrRelatedPersonsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type BackfillHrRelatedPersonsMutation = {
  __typename?: 'BackfillHRRelatedPersonsMutation';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  totalAffected?: Maybe<Scalars['Int']['output']>;
};

export type BackfillTokensInput = {
  numRecords: Scalars['Int']['input'];
  numWorkers: Scalars['Int']['input'];
};

export type BackfillTokensMutation = {
  __typename?: 'BackfillTokensMutation';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  totalAffected?: Maybe<Scalars['Int']['output']>;
};

export type BenchmarkBalanceSheetConnection = {
  __typename?: 'BenchmarkBalanceSheetConnection';
  edges: Array<Maybe<BenchmarkBalanceSheetEdge>>;
  pageInfo: PageInfo;
};

export type BenchmarkBalanceSheetEdge = {
  __typename?: 'BenchmarkBalanceSheetEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BenchmarkBalanceSheetType>;
};

export enum BenchmarkBalanceSheetSortEnum {
  BenchmarkControlDataIdAsc = 'benchmark_control_data_id_asc',
  BenchmarkControlDataIdDesc = 'benchmark_control_data_id_desc',
  BmTypeAsc = 'bm_type_asc',
  BmTypeDesc = 'bm_type_desc',
  Category_1Asc = 'category_1_asc',
  Category_1Desc = 'category_1_desc',
  Category_2Asc = 'category_2_asc',
  Category_2Desc = 'category_2_desc',
  Category_3Asc = 'category_3_asc',
  Category_3Desc = 'category_3_desc',
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  CurrencyAsc = 'currency_asc',
  CurrencyDesc = 'currency_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DeleteTimeAsc = 'delete_time_asc',
  DeleteTimeDesc = 'delete_time_desc',
  DeletedByAsc = 'deleted_by_asc',
  DeletedByDesc = 'deleted_by_desc',
  FlaggedAsErrorAsc = 'flagged_as_error_asc',
  FlaggedAsErrorDesc = 'flagged_as_error_desc',
  HasBeenOverwrittenAsc = 'has_been_overwritten_asc',
  HasBeenOverwrittenDesc = 'has_been_overwritten_desc',
  HasBeenProcessedAsc = 'has_been_processed_asc',
  HasBeenProcessedDesc = 'has_been_processed_desc',
  HasBeenReplacedAsc = 'has_been_replaced_asc',
  HasBeenReplacedDesc = 'has_been_replaced_desc',
  HasBeenReviewedAsc = 'has_been_reviewed_asc',
  HasBeenReviewedDesc = 'has_been_reviewed_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsFirstActualAsc = 'is_first_actual_asc',
  IsFirstActualDesc = 'is_first_actual_desc',
  IsLastActualAsc = 'is_last_actual_asc',
  IsLastActualDesc = 'is_last_actual_desc',
  MarkedAsDeletedAsc = 'marked_as_deleted_asc',
  MarkedAsDeletedDesc = 'marked_as_deleted_desc',
  OverwriteTimeAsc = 'overwrite_time_asc',
  OverwriteTimeDesc = 'overwrite_time_desc',
  PeriodAsc = 'period_asc',
  PeriodDesc = 'period_desc',
  PeriodEndDateAsc = 'period_end_date_asc',
  PeriodEndDateDesc = 'period_end_date_desc',
  PeriodStartDateAsc = 'period_start_date_asc',
  PeriodStartDateDesc = 'period_start_date_desc',
  PeriodTypeAsc = 'period_type_asc',
  PeriodTypeDesc = 'period_type_desc',
  PipedriveDealIdAsc = 'pipedrive_deal_id_asc',
  PipedriveDealIdDesc = 'pipedrive_deal_id_desc',
  ProcessTimeAsc = 'process_time_asc',
  ProcessTimeDesc = 'process_time_desc',
  ReplaceTimeAsc = 'replace_time_asc',
  ReplaceTimeDesc = 'replace_time_desc',
  ReplacedWithAsc = 'replaced_with_asc',
  ReplacedWithDesc = 'replaced_with_desc',
  ReviewTimeAsc = 'review_time_asc',
  ReviewTimeDesc = 'review_time_desc',
  ReviewedByAsc = 'reviewed_by_asc',
  ReviewedByDesc = 'reviewed_by_desc',
  UploadFileNameAsc = 'upload_file_name_asc',
  UploadFileNameDesc = 'upload_file_name_desc',
  UploadFilePathAsc = 'upload_file_path_asc',
  UploadFilePathDesc = 'upload_file_path_desc',
  UploadTimeAsc = 'upload_time_asc',
  UploadTimeDesc = 'upload_time_desc',
  UploaderNameAsc = 'uploader_name_asc',
  UploaderNameDesc = 'uploader_name_desc',
  UsedInKpiCalculationAsc = 'used_in_kpi_calculation_asc',
  UsedInKpiCalculationDesc = 'used_in_kpi_calculation_desc',
  ValuationLevelAsc = 'valuation_level_asc',
  ValuationLevelDesc = 'valuation_level_desc',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc'
}

export type BenchmarkBalanceSheetType = Node & {
  __typename?: 'BenchmarkBalanceSheetType';
  benchmarkControlDataId?: Maybe<Scalars['Int']['output']>;
  bmType?: Maybe<Scalars['String']['output']>;
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  flaggedAsError?: Maybe<Scalars['Boolean']['output']>;
  hasBeenOverwritten?: Maybe<Scalars['Boolean']['output']>;
  hasBeenProcessed?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReplaced?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReviewed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isFirstActual?: Maybe<Scalars['Boolean']['output']>;
  isLastActual?: Maybe<Scalars['Boolean']['output']>;
  markedAsDeleted?: Maybe<Scalars['Boolean']['output']>;
  overwriteTime?: Maybe<Scalars['DateTime']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  periodStartDate?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  pipedriveDealId?: Maybe<Scalars['Int']['output']>;
  processTime?: Maybe<Scalars['DateTime']['output']>;
  replaceTime?: Maybe<Scalars['DateTime']['output']>;
  replacedWith?: Maybe<Scalars['Int']['output']>;
  reviewTime?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  uploadFileName?: Maybe<Scalars['String']['output']>;
  uploadFilePath?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['DateTime']['output']>;
  uploaderName?: Maybe<Scalars['String']['output']>;
  usedInKpiCalculation?: Maybe<Scalars['String']['output']>;
  valuationLevel?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type BenchmarkCustomersAggregatedConnection = {
  __typename?: 'BenchmarkCustomersAggregatedConnection';
  edges: Array<Maybe<BenchmarkCustomersAggregatedEdge>>;
  pageInfo: PageInfo;
};

export type BenchmarkCustomersAggregatedEdge = {
  __typename?: 'BenchmarkCustomersAggregatedEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BenchmarkCustomersAggregatedType>;
};

export enum BenchmarkCustomersAggregatedSortEnum {
  BenchmarkControlDataIdAsc = 'benchmark_control_data_id_asc',
  BenchmarkControlDataIdDesc = 'benchmark_control_data_id_desc',
  BmTypeAsc = 'bm_type_asc',
  BmTypeDesc = 'bm_type_desc',
  Category_1Asc = 'category_1_asc',
  Category_1Desc = 'category_1_desc',
  Category_2Asc = 'category_2_asc',
  Category_2Desc = 'category_2_desc',
  Category_3Asc = 'category_3_asc',
  Category_3Desc = 'category_3_desc',
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  CurrencyAsc = 'currency_asc',
  CurrencyDesc = 'currency_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DeleteTimeAsc = 'delete_time_asc',
  DeleteTimeDesc = 'delete_time_desc',
  DeletedByAsc = 'deleted_by_asc',
  DeletedByDesc = 'deleted_by_desc',
  FlaggedAsErrorAsc = 'flagged_as_error_asc',
  FlaggedAsErrorDesc = 'flagged_as_error_desc',
  HasBeenOverwrittenAsc = 'has_been_overwritten_asc',
  HasBeenOverwrittenDesc = 'has_been_overwritten_desc',
  HasBeenProcessedAsc = 'has_been_processed_asc',
  HasBeenProcessedDesc = 'has_been_processed_desc',
  HasBeenReplacedAsc = 'has_been_replaced_asc',
  HasBeenReplacedDesc = 'has_been_replaced_desc',
  HasBeenReviewedAsc = 'has_been_reviewed_asc',
  HasBeenReviewedDesc = 'has_been_reviewed_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsFirstActualAsc = 'is_first_actual_asc',
  IsFirstActualDesc = 'is_first_actual_desc',
  IsLastActualAsc = 'is_last_actual_asc',
  IsLastActualDesc = 'is_last_actual_desc',
  MarkedAsDeletedAsc = 'marked_as_deleted_asc',
  MarkedAsDeletedDesc = 'marked_as_deleted_desc',
  OverwriteTimeAsc = 'overwrite_time_asc',
  OverwriteTimeDesc = 'overwrite_time_desc',
  PeriodAsc = 'period_asc',
  PeriodDesc = 'period_desc',
  PeriodEndDateAsc = 'period_end_date_asc',
  PeriodEndDateDesc = 'period_end_date_desc',
  PeriodStartDateAsc = 'period_start_date_asc',
  PeriodStartDateDesc = 'period_start_date_desc',
  PeriodTypeAsc = 'period_type_asc',
  PeriodTypeDesc = 'period_type_desc',
  PipedriveDealIdAsc = 'pipedrive_deal_id_asc',
  PipedriveDealIdDesc = 'pipedrive_deal_id_desc',
  ProcessTimeAsc = 'process_time_asc',
  ProcessTimeDesc = 'process_time_desc',
  ReplaceTimeAsc = 'replace_time_asc',
  ReplaceTimeDesc = 'replace_time_desc',
  ReplacedWithAsc = 'replaced_with_asc',
  ReplacedWithDesc = 'replaced_with_desc',
  ReviewTimeAsc = 'review_time_asc',
  ReviewTimeDesc = 'review_time_desc',
  ReviewedByAsc = 'reviewed_by_asc',
  ReviewedByDesc = 'reviewed_by_desc',
  UploadFileNameAsc = 'upload_file_name_asc',
  UploadFileNameDesc = 'upload_file_name_desc',
  UploadFilePathAsc = 'upload_file_path_asc',
  UploadFilePathDesc = 'upload_file_path_desc',
  UploadTimeAsc = 'upload_time_asc',
  UploadTimeDesc = 'upload_time_desc',
  UploaderNameAsc = 'uploader_name_asc',
  UploaderNameDesc = 'uploader_name_desc',
  UsedInKpiCalculationAsc = 'used_in_kpi_calculation_asc',
  UsedInKpiCalculationDesc = 'used_in_kpi_calculation_desc',
  ValuationLevelAsc = 'valuation_level_asc',
  ValuationLevelDesc = 'valuation_level_desc',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc'
}

export type BenchmarkCustomersAggregatedType = Node & {
  __typename?: 'BenchmarkCustomersAggregatedType';
  benchmarkControlDataId?: Maybe<Scalars['Int']['output']>;
  bmType?: Maybe<Scalars['String']['output']>;
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  flaggedAsError?: Maybe<Scalars['Boolean']['output']>;
  hasBeenOverwritten?: Maybe<Scalars['Boolean']['output']>;
  hasBeenProcessed?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReplaced?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReviewed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isFirstActual?: Maybe<Scalars['Boolean']['output']>;
  isLastActual?: Maybe<Scalars['Boolean']['output']>;
  markedAsDeleted?: Maybe<Scalars['Boolean']['output']>;
  overwriteTime?: Maybe<Scalars['DateTime']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  periodStartDate?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  pipedriveDealId?: Maybe<Scalars['Int']['output']>;
  processTime?: Maybe<Scalars['DateTime']['output']>;
  replaceTime?: Maybe<Scalars['DateTime']['output']>;
  replacedWith?: Maybe<Scalars['Int']['output']>;
  reviewTime?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  uploadFileName?: Maybe<Scalars['String']['output']>;
  uploadFilePath?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['DateTime']['output']>;
  uploaderName?: Maybe<Scalars['String']['output']>;
  usedInKpiCalculation?: Maybe<Scalars['String']['output']>;
  valuationLevel?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type BenchmarkCustomersListConnection = {
  __typename?: 'BenchmarkCustomersListConnection';
  edges: Array<Maybe<BenchmarkCustomersListEdge>>;
  pageInfo: PageInfo;
};

export type BenchmarkCustomersListEdge = {
  __typename?: 'BenchmarkCustomersListEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BenchmarkCustomersListType>;
};

export enum BenchmarkCustomersListSortEnum {
  BenchmarkControlDataIdAsc = 'benchmark_control_data_id_asc',
  BenchmarkControlDataIdDesc = 'benchmark_control_data_id_desc',
  BmTypeAsc = 'bm_type_asc',
  BmTypeDesc = 'bm_type_desc',
  Category_1Asc = 'category_1_asc',
  Category_1Desc = 'category_1_desc',
  Category_2Asc = 'category_2_asc',
  Category_2Desc = 'category_2_desc',
  Category_3Asc = 'category_3_asc',
  Category_3Desc = 'category_3_desc',
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  CurrencyAsc = 'currency_asc',
  CurrencyDesc = 'currency_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DeleteTimeAsc = 'delete_time_asc',
  DeleteTimeDesc = 'delete_time_desc',
  DeletedByAsc = 'deleted_by_asc',
  DeletedByDesc = 'deleted_by_desc',
  FlaggedAsErrorAsc = 'flagged_as_error_asc',
  FlaggedAsErrorDesc = 'flagged_as_error_desc',
  HasBeenOverwrittenAsc = 'has_been_overwritten_asc',
  HasBeenOverwrittenDesc = 'has_been_overwritten_desc',
  HasBeenProcessedAsc = 'has_been_processed_asc',
  HasBeenProcessedDesc = 'has_been_processed_desc',
  HasBeenReplacedAsc = 'has_been_replaced_asc',
  HasBeenReplacedDesc = 'has_been_replaced_desc',
  HasBeenReviewedAsc = 'has_been_reviewed_asc',
  HasBeenReviewedDesc = 'has_been_reviewed_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsFirstActualAsc = 'is_first_actual_asc',
  IsFirstActualDesc = 'is_first_actual_desc',
  IsLastActualAsc = 'is_last_actual_asc',
  IsLastActualDesc = 'is_last_actual_desc',
  MarkedAsDeletedAsc = 'marked_as_deleted_asc',
  MarkedAsDeletedDesc = 'marked_as_deleted_desc',
  OverwriteTimeAsc = 'overwrite_time_asc',
  OverwriteTimeDesc = 'overwrite_time_desc',
  PeriodAsc = 'period_asc',
  PeriodDesc = 'period_desc',
  PeriodEndDateAsc = 'period_end_date_asc',
  PeriodEndDateDesc = 'period_end_date_desc',
  PeriodStartDateAsc = 'period_start_date_asc',
  PeriodStartDateDesc = 'period_start_date_desc',
  PeriodTypeAsc = 'period_type_asc',
  PeriodTypeDesc = 'period_type_desc',
  PipedriveDealIdAsc = 'pipedrive_deal_id_asc',
  PipedriveDealIdDesc = 'pipedrive_deal_id_desc',
  ProcessTimeAsc = 'process_time_asc',
  ProcessTimeDesc = 'process_time_desc',
  ReplaceTimeAsc = 'replace_time_asc',
  ReplaceTimeDesc = 'replace_time_desc',
  ReplacedWithAsc = 'replaced_with_asc',
  ReplacedWithDesc = 'replaced_with_desc',
  ReviewTimeAsc = 'review_time_asc',
  ReviewTimeDesc = 'review_time_desc',
  ReviewedByAsc = 'reviewed_by_asc',
  ReviewedByDesc = 'reviewed_by_desc',
  UploadFileNameAsc = 'upload_file_name_asc',
  UploadFileNameDesc = 'upload_file_name_desc',
  UploadFilePathAsc = 'upload_file_path_asc',
  UploadFilePathDesc = 'upload_file_path_desc',
  UploadTimeAsc = 'upload_time_asc',
  UploadTimeDesc = 'upload_time_desc',
  UploaderNameAsc = 'uploader_name_asc',
  UploaderNameDesc = 'uploader_name_desc',
  UsedInKpiCalculationAsc = 'used_in_kpi_calculation_asc',
  UsedInKpiCalculationDesc = 'used_in_kpi_calculation_desc',
  ValuationLevelAsc = 'valuation_level_asc',
  ValuationLevelDesc = 'valuation_level_desc',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc'
}

export type BenchmarkCustomersListType = Node & {
  __typename?: 'BenchmarkCustomersListType';
  benchmarkControlDataId?: Maybe<Scalars['Int']['output']>;
  bmType?: Maybe<Scalars['String']['output']>;
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  flaggedAsError?: Maybe<Scalars['Boolean']['output']>;
  hasBeenOverwritten?: Maybe<Scalars['Boolean']['output']>;
  hasBeenProcessed?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReplaced?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReviewed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isFirstActual?: Maybe<Scalars['Boolean']['output']>;
  isLastActual?: Maybe<Scalars['Boolean']['output']>;
  markedAsDeleted?: Maybe<Scalars['Boolean']['output']>;
  overwriteTime?: Maybe<Scalars['DateTime']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  periodStartDate?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  pipedriveDealId?: Maybe<Scalars['Int']['output']>;
  processTime?: Maybe<Scalars['DateTime']['output']>;
  replaceTime?: Maybe<Scalars['DateTime']['output']>;
  replacedWith?: Maybe<Scalars['Int']['output']>;
  reviewTime?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  uploadFileName?: Maybe<Scalars['String']['output']>;
  uploadFilePath?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['DateTime']['output']>;
  uploaderName?: Maybe<Scalars['String']['output']>;
  usedInKpiCalculation?: Maybe<Scalars['String']['output']>;
  valuationLevel?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type BenchmarkFteConnection = {
  __typename?: 'BenchmarkFTEConnection';
  edges: Array<Maybe<BenchmarkFteEdge>>;
  pageInfo: PageInfo;
};

export type BenchmarkFteEdge = {
  __typename?: 'BenchmarkFTEEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BenchmarkFteType>;
};

export enum BenchmarkFteSortEnum {
  BenchmarkControlDataIdAsc = 'benchmark_control_data_id_asc',
  BenchmarkControlDataIdDesc = 'benchmark_control_data_id_desc',
  BmTypeAsc = 'bm_type_asc',
  BmTypeDesc = 'bm_type_desc',
  Category_1Asc = 'category_1_asc',
  Category_1Desc = 'category_1_desc',
  Category_2Asc = 'category_2_asc',
  Category_2Desc = 'category_2_desc',
  Category_3Asc = 'category_3_asc',
  Category_3Desc = 'category_3_desc',
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  CurrencyAsc = 'currency_asc',
  CurrencyDesc = 'currency_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DeleteTimeAsc = 'delete_time_asc',
  DeleteTimeDesc = 'delete_time_desc',
  DeletedByAsc = 'deleted_by_asc',
  DeletedByDesc = 'deleted_by_desc',
  FlaggedAsErrorAsc = 'flagged_as_error_asc',
  FlaggedAsErrorDesc = 'flagged_as_error_desc',
  HasBeenOverwrittenAsc = 'has_been_overwritten_asc',
  HasBeenOverwrittenDesc = 'has_been_overwritten_desc',
  HasBeenProcessedAsc = 'has_been_processed_asc',
  HasBeenProcessedDesc = 'has_been_processed_desc',
  HasBeenReplacedAsc = 'has_been_replaced_asc',
  HasBeenReplacedDesc = 'has_been_replaced_desc',
  HasBeenReviewedAsc = 'has_been_reviewed_asc',
  HasBeenReviewedDesc = 'has_been_reviewed_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsFirstActualAsc = 'is_first_actual_asc',
  IsFirstActualDesc = 'is_first_actual_desc',
  IsLastActualAsc = 'is_last_actual_asc',
  IsLastActualDesc = 'is_last_actual_desc',
  MarkedAsDeletedAsc = 'marked_as_deleted_asc',
  MarkedAsDeletedDesc = 'marked_as_deleted_desc',
  OverwriteTimeAsc = 'overwrite_time_asc',
  OverwriteTimeDesc = 'overwrite_time_desc',
  PeriodAsc = 'period_asc',
  PeriodDesc = 'period_desc',
  PeriodEndDateAsc = 'period_end_date_asc',
  PeriodEndDateDesc = 'period_end_date_desc',
  PeriodStartDateAsc = 'period_start_date_asc',
  PeriodStartDateDesc = 'period_start_date_desc',
  PeriodTypeAsc = 'period_type_asc',
  PeriodTypeDesc = 'period_type_desc',
  PipedriveDealIdAsc = 'pipedrive_deal_id_asc',
  PipedriveDealIdDesc = 'pipedrive_deal_id_desc',
  ProcessTimeAsc = 'process_time_asc',
  ProcessTimeDesc = 'process_time_desc',
  ReplaceTimeAsc = 'replace_time_asc',
  ReplaceTimeDesc = 'replace_time_desc',
  ReplacedWithAsc = 'replaced_with_asc',
  ReplacedWithDesc = 'replaced_with_desc',
  ReviewTimeAsc = 'review_time_asc',
  ReviewTimeDesc = 'review_time_desc',
  ReviewedByAsc = 'reviewed_by_asc',
  ReviewedByDesc = 'reviewed_by_desc',
  UploadFileNameAsc = 'upload_file_name_asc',
  UploadFileNameDesc = 'upload_file_name_desc',
  UploadFilePathAsc = 'upload_file_path_asc',
  UploadFilePathDesc = 'upload_file_path_desc',
  UploadTimeAsc = 'upload_time_asc',
  UploadTimeDesc = 'upload_time_desc',
  UploaderNameAsc = 'uploader_name_asc',
  UploaderNameDesc = 'uploader_name_desc',
  UsedInKpiCalculationAsc = 'used_in_kpi_calculation_asc',
  UsedInKpiCalculationDesc = 'used_in_kpi_calculation_desc',
  ValuationLevelAsc = 'valuation_level_asc',
  ValuationLevelDesc = 'valuation_level_desc',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc'
}

export type BenchmarkFteType = Node & {
  __typename?: 'BenchmarkFTEType';
  benchmarkControlDataId?: Maybe<Scalars['Int']['output']>;
  bmType?: Maybe<Scalars['String']['output']>;
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  flaggedAsError?: Maybe<Scalars['Boolean']['output']>;
  hasBeenOverwritten?: Maybe<Scalars['Boolean']['output']>;
  hasBeenProcessed?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReplaced?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReviewed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isFirstActual?: Maybe<Scalars['Boolean']['output']>;
  isLastActual?: Maybe<Scalars['Boolean']['output']>;
  markedAsDeleted?: Maybe<Scalars['Boolean']['output']>;
  overwriteTime?: Maybe<Scalars['DateTime']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  periodStartDate?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  pipedriveDealId?: Maybe<Scalars['Int']['output']>;
  processTime?: Maybe<Scalars['DateTime']['output']>;
  replaceTime?: Maybe<Scalars['DateTime']['output']>;
  replacedWith?: Maybe<Scalars['Int']['output']>;
  reviewTime?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  uploadFileName?: Maybe<Scalars['String']['output']>;
  uploadFilePath?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['DateTime']['output']>;
  uploaderName?: Maybe<Scalars['String']['output']>;
  usedInKpiCalculation?: Maybe<Scalars['String']['output']>;
  valuationLevel?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type BenchmarkPlConnection = {
  __typename?: 'BenchmarkPLConnection';
  edges: Array<Maybe<BenchmarkPlEdge>>;
  pageInfo: PageInfo;
};

export type BenchmarkPlEdge = {
  __typename?: 'BenchmarkPLEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BenchmarkPlType>;
};

export enum BenchmarkPlSortEnum {
  BenchmarkControlDataIdAsc = 'benchmark_control_data_id_asc',
  BenchmarkControlDataIdDesc = 'benchmark_control_data_id_desc',
  BmTypeAsc = 'bm_type_asc',
  BmTypeDesc = 'bm_type_desc',
  Category_1Asc = 'category_1_asc',
  Category_1Desc = 'category_1_desc',
  Category_2Asc = 'category_2_asc',
  Category_2Desc = 'category_2_desc',
  Category_3Asc = 'category_3_asc',
  Category_3Desc = 'category_3_desc',
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  CurrencyAsc = 'currency_asc',
  CurrencyDesc = 'currency_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DeleteTimeAsc = 'delete_time_asc',
  DeleteTimeDesc = 'delete_time_desc',
  DeletedByAsc = 'deleted_by_asc',
  DeletedByDesc = 'deleted_by_desc',
  FlaggedAsErrorAsc = 'flagged_as_error_asc',
  FlaggedAsErrorDesc = 'flagged_as_error_desc',
  HasBeenOverwrittenAsc = 'has_been_overwritten_asc',
  HasBeenOverwrittenDesc = 'has_been_overwritten_desc',
  HasBeenProcessedAsc = 'has_been_processed_asc',
  HasBeenProcessedDesc = 'has_been_processed_desc',
  HasBeenReplacedAsc = 'has_been_replaced_asc',
  HasBeenReplacedDesc = 'has_been_replaced_desc',
  HasBeenReviewedAsc = 'has_been_reviewed_asc',
  HasBeenReviewedDesc = 'has_been_reviewed_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsFirstActualAsc = 'is_first_actual_asc',
  IsFirstActualDesc = 'is_first_actual_desc',
  IsLastActualAsc = 'is_last_actual_asc',
  IsLastActualDesc = 'is_last_actual_desc',
  MarkedAsDeletedAsc = 'marked_as_deleted_asc',
  MarkedAsDeletedDesc = 'marked_as_deleted_desc',
  OverwriteTimeAsc = 'overwrite_time_asc',
  OverwriteTimeDesc = 'overwrite_time_desc',
  PeriodAsc = 'period_asc',
  PeriodDesc = 'period_desc',
  PeriodEndDateAsc = 'period_end_date_asc',
  PeriodEndDateDesc = 'period_end_date_desc',
  PeriodStartDateAsc = 'period_start_date_asc',
  PeriodStartDateDesc = 'period_start_date_desc',
  PeriodTypeAsc = 'period_type_asc',
  PeriodTypeDesc = 'period_type_desc',
  PipedriveDealIdAsc = 'pipedrive_deal_id_asc',
  PipedriveDealIdDesc = 'pipedrive_deal_id_desc',
  ProcessTimeAsc = 'process_time_asc',
  ProcessTimeDesc = 'process_time_desc',
  ReplaceTimeAsc = 'replace_time_asc',
  ReplaceTimeDesc = 'replace_time_desc',
  ReplacedWithAsc = 'replaced_with_asc',
  ReplacedWithDesc = 'replaced_with_desc',
  ReviewTimeAsc = 'review_time_asc',
  ReviewTimeDesc = 'review_time_desc',
  ReviewedByAsc = 'reviewed_by_asc',
  ReviewedByDesc = 'reviewed_by_desc',
  UploadFileNameAsc = 'upload_file_name_asc',
  UploadFileNameDesc = 'upload_file_name_desc',
  UploadFilePathAsc = 'upload_file_path_asc',
  UploadFilePathDesc = 'upload_file_path_desc',
  UploadTimeAsc = 'upload_time_asc',
  UploadTimeDesc = 'upload_time_desc',
  UploaderNameAsc = 'uploader_name_asc',
  UploaderNameDesc = 'uploader_name_desc',
  UsedInKpiCalculationAsc = 'used_in_kpi_calculation_asc',
  UsedInKpiCalculationDesc = 'used_in_kpi_calculation_desc',
  ValuationLevelAsc = 'valuation_level_asc',
  ValuationLevelDesc = 'valuation_level_desc',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc'
}

export type BenchmarkPlType = Node & {
  __typename?: 'BenchmarkPLType';
  benchmarkControlDataId?: Maybe<Scalars['Int']['output']>;
  bmType?: Maybe<Scalars['String']['output']>;
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  flaggedAsError?: Maybe<Scalars['Boolean']['output']>;
  hasBeenOverwritten?: Maybe<Scalars['Boolean']['output']>;
  hasBeenProcessed?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReplaced?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReviewed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isFirstActual?: Maybe<Scalars['Boolean']['output']>;
  isLastActual?: Maybe<Scalars['Boolean']['output']>;
  markedAsDeleted?: Maybe<Scalars['Boolean']['output']>;
  overwriteTime?: Maybe<Scalars['DateTime']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  periodStartDate?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  pipedriveDealId?: Maybe<Scalars['Int']['output']>;
  processTime?: Maybe<Scalars['DateTime']['output']>;
  replaceTime?: Maybe<Scalars['DateTime']['output']>;
  replacedWith?: Maybe<Scalars['Int']['output']>;
  reviewTime?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  uploadFileName?: Maybe<Scalars['String']['output']>;
  uploadFilePath?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['DateTime']['output']>;
  uploaderName?: Maybe<Scalars['String']['output']>;
  usedInKpiCalculation?: Maybe<Scalars['String']['output']>;
  valuationLevel?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type BenchmarkPricingConnection = {
  __typename?: 'BenchmarkPricingConnection';
  edges: Array<Maybe<BenchmarkPricingEdge>>;
  pageInfo: PageInfo;
};

export type BenchmarkPricingEdge = {
  __typename?: 'BenchmarkPricingEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BenchmarkPricingType>;
};

export enum BenchmarkPricingSortEnum {
  BenchmarkControlDataIdAsc = 'benchmark_control_data_id_asc',
  BenchmarkControlDataIdDesc = 'benchmark_control_data_id_desc',
  BmTypeAsc = 'bm_type_asc',
  BmTypeDesc = 'bm_type_desc',
  Category_1Asc = 'category_1_asc',
  Category_1Desc = 'category_1_desc',
  Category_2Asc = 'category_2_asc',
  Category_2Desc = 'category_2_desc',
  Category_3Asc = 'category_3_asc',
  Category_3Desc = 'category_3_desc',
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  CurrencyAsc = 'currency_asc',
  CurrencyDesc = 'currency_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DeleteTimeAsc = 'delete_time_asc',
  DeleteTimeDesc = 'delete_time_desc',
  DeletedByAsc = 'deleted_by_asc',
  DeletedByDesc = 'deleted_by_desc',
  FlaggedAsErrorAsc = 'flagged_as_error_asc',
  FlaggedAsErrorDesc = 'flagged_as_error_desc',
  HasBeenOverwrittenAsc = 'has_been_overwritten_asc',
  HasBeenOverwrittenDesc = 'has_been_overwritten_desc',
  HasBeenProcessedAsc = 'has_been_processed_asc',
  HasBeenProcessedDesc = 'has_been_processed_desc',
  HasBeenReplacedAsc = 'has_been_replaced_asc',
  HasBeenReplacedDesc = 'has_been_replaced_desc',
  HasBeenReviewedAsc = 'has_been_reviewed_asc',
  HasBeenReviewedDesc = 'has_been_reviewed_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsFirstActualAsc = 'is_first_actual_asc',
  IsFirstActualDesc = 'is_first_actual_desc',
  IsLastActualAsc = 'is_last_actual_asc',
  IsLastActualDesc = 'is_last_actual_desc',
  MarkedAsDeletedAsc = 'marked_as_deleted_asc',
  MarkedAsDeletedDesc = 'marked_as_deleted_desc',
  OverwriteTimeAsc = 'overwrite_time_asc',
  OverwriteTimeDesc = 'overwrite_time_desc',
  PeriodAsc = 'period_asc',
  PeriodDesc = 'period_desc',
  PeriodEndDateAsc = 'period_end_date_asc',
  PeriodEndDateDesc = 'period_end_date_desc',
  PeriodStartDateAsc = 'period_start_date_asc',
  PeriodStartDateDesc = 'period_start_date_desc',
  PeriodTypeAsc = 'period_type_asc',
  PeriodTypeDesc = 'period_type_desc',
  PipedriveDealIdAsc = 'pipedrive_deal_id_asc',
  PipedriveDealIdDesc = 'pipedrive_deal_id_desc',
  ProcessTimeAsc = 'process_time_asc',
  ProcessTimeDesc = 'process_time_desc',
  ReplaceTimeAsc = 'replace_time_asc',
  ReplaceTimeDesc = 'replace_time_desc',
  ReplacedWithAsc = 'replaced_with_asc',
  ReplacedWithDesc = 'replaced_with_desc',
  ReviewTimeAsc = 'review_time_asc',
  ReviewTimeDesc = 'review_time_desc',
  ReviewedByAsc = 'reviewed_by_asc',
  ReviewedByDesc = 'reviewed_by_desc',
  UploadFileNameAsc = 'upload_file_name_asc',
  UploadFileNameDesc = 'upload_file_name_desc',
  UploadFilePathAsc = 'upload_file_path_asc',
  UploadFilePathDesc = 'upload_file_path_desc',
  UploadTimeAsc = 'upload_time_asc',
  UploadTimeDesc = 'upload_time_desc',
  UploaderNameAsc = 'uploader_name_asc',
  UploaderNameDesc = 'uploader_name_desc',
  UsedInKpiCalculationAsc = 'used_in_kpi_calculation_asc',
  UsedInKpiCalculationDesc = 'used_in_kpi_calculation_desc',
  ValuationLevelAsc = 'valuation_level_asc',
  ValuationLevelDesc = 'valuation_level_desc',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc'
}

export type BenchmarkPricingType = Node & {
  __typename?: 'BenchmarkPricingType';
  benchmarkControlDataId?: Maybe<Scalars['Int']['output']>;
  bmType?: Maybe<Scalars['String']['output']>;
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  flaggedAsError?: Maybe<Scalars['Boolean']['output']>;
  hasBeenOverwritten?: Maybe<Scalars['Boolean']['output']>;
  hasBeenProcessed?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReplaced?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReviewed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isFirstActual?: Maybe<Scalars['Boolean']['output']>;
  isLastActual?: Maybe<Scalars['Boolean']['output']>;
  markedAsDeleted?: Maybe<Scalars['Boolean']['output']>;
  overwriteTime?: Maybe<Scalars['DateTime']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  periodStartDate?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  pipedriveDealId?: Maybe<Scalars['Int']['output']>;
  processTime?: Maybe<Scalars['DateTime']['output']>;
  replaceTime?: Maybe<Scalars['DateTime']['output']>;
  replacedWith?: Maybe<Scalars['Int']['output']>;
  reviewTime?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  uploadFileName?: Maybe<Scalars['String']['output']>;
  uploadFilePath?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['DateTime']['output']>;
  uploaderName?: Maybe<Scalars['String']['output']>;
  usedInKpiCalculation?: Maybe<Scalars['String']['output']>;
  valuationLevel?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type BenchmarkingBaseModelConnection = {
  __typename?: 'BenchmarkingBaseModelConnection';
  edges: Array<Maybe<BenchmarkingBaseModelEdge>>;
  pageInfo: PageInfo;
};

export type BenchmarkingBaseModelEdge = {
  __typename?: 'BenchmarkingBaseModelEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BenchmarkingBaseModelType>;
};

export enum BenchmarkingBaseModelSortEnum {
  BenchmarkControlDataIdAsc = 'benchmark_control_data_id_asc',
  BenchmarkControlDataIdDesc = 'benchmark_control_data_id_desc',
  BmTypeAsc = 'bm_type_asc',
  BmTypeDesc = 'bm_type_desc',
  Category_1Asc = 'category_1_asc',
  Category_1Desc = 'category_1_desc',
  Category_2Asc = 'category_2_asc',
  Category_2Desc = 'category_2_desc',
  Category_3Asc = 'category_3_asc',
  Category_3Desc = 'category_3_desc',
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  CurrencyAsc = 'currency_asc',
  CurrencyDesc = 'currency_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DeleteTimeAsc = 'delete_time_asc',
  DeleteTimeDesc = 'delete_time_desc',
  DeletedByAsc = 'deleted_by_asc',
  DeletedByDesc = 'deleted_by_desc',
  FlaggedAsErrorAsc = 'flagged_as_error_asc',
  FlaggedAsErrorDesc = 'flagged_as_error_desc',
  HasBeenOverwrittenAsc = 'has_been_overwritten_asc',
  HasBeenOverwrittenDesc = 'has_been_overwritten_desc',
  HasBeenProcessedAsc = 'has_been_processed_asc',
  HasBeenProcessedDesc = 'has_been_processed_desc',
  HasBeenReplacedAsc = 'has_been_replaced_asc',
  HasBeenReplacedDesc = 'has_been_replaced_desc',
  HasBeenReviewedAsc = 'has_been_reviewed_asc',
  HasBeenReviewedDesc = 'has_been_reviewed_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsFirstActualAsc = 'is_first_actual_asc',
  IsFirstActualDesc = 'is_first_actual_desc',
  IsLastActualAsc = 'is_last_actual_asc',
  IsLastActualDesc = 'is_last_actual_desc',
  MarkedAsDeletedAsc = 'marked_as_deleted_asc',
  MarkedAsDeletedDesc = 'marked_as_deleted_desc',
  OverwriteTimeAsc = 'overwrite_time_asc',
  OverwriteTimeDesc = 'overwrite_time_desc',
  PeriodAsc = 'period_asc',
  PeriodDesc = 'period_desc',
  PeriodEndDateAsc = 'period_end_date_asc',
  PeriodEndDateDesc = 'period_end_date_desc',
  PeriodStartDateAsc = 'period_start_date_asc',
  PeriodStartDateDesc = 'period_start_date_desc',
  PeriodTypeAsc = 'period_type_asc',
  PeriodTypeDesc = 'period_type_desc',
  PipedriveDealIdAsc = 'pipedrive_deal_id_asc',
  PipedriveDealIdDesc = 'pipedrive_deal_id_desc',
  ProcessTimeAsc = 'process_time_asc',
  ProcessTimeDesc = 'process_time_desc',
  ReplaceTimeAsc = 'replace_time_asc',
  ReplaceTimeDesc = 'replace_time_desc',
  ReplacedWithAsc = 'replaced_with_asc',
  ReplacedWithDesc = 'replaced_with_desc',
  ReviewTimeAsc = 'review_time_asc',
  ReviewTimeDesc = 'review_time_desc',
  ReviewedByAsc = 'reviewed_by_asc',
  ReviewedByDesc = 'reviewed_by_desc',
  UploadFileNameAsc = 'upload_file_name_asc',
  UploadFileNameDesc = 'upload_file_name_desc',
  UploadFilePathAsc = 'upload_file_path_asc',
  UploadFilePathDesc = 'upload_file_path_desc',
  UploadTimeAsc = 'upload_time_asc',
  UploadTimeDesc = 'upload_time_desc',
  UploaderNameAsc = 'uploader_name_asc',
  UploaderNameDesc = 'uploader_name_desc',
  UsedInKpiCalculationAsc = 'used_in_kpi_calculation_asc',
  UsedInKpiCalculationDesc = 'used_in_kpi_calculation_desc',
  ValuationLevelAsc = 'valuation_level_asc',
  ValuationLevelDesc = 'valuation_level_desc',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc'
}

export type BenchmarkingBaseModelType = Node & {
  __typename?: 'BenchmarkingBaseModelType';
  benchmarkControlDataId?: Maybe<Scalars['Int']['output']>;
  bmType?: Maybe<Scalars['String']['output']>;
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  flaggedAsError?: Maybe<Scalars['Boolean']['output']>;
  hasBeenOverwritten?: Maybe<Scalars['Boolean']['output']>;
  hasBeenProcessed?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReplaced?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReviewed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isFirstActual?: Maybe<Scalars['Boolean']['output']>;
  isLastActual?: Maybe<Scalars['Boolean']['output']>;
  markedAsDeleted?: Maybe<Scalars['Boolean']['output']>;
  overwriteTime?: Maybe<Scalars['DateTime']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  periodStartDate?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  pipedriveDealId?: Maybe<Scalars['Int']['output']>;
  processTime?: Maybe<Scalars['DateTime']['output']>;
  replaceTime?: Maybe<Scalars['DateTime']['output']>;
  replacedWith?: Maybe<Scalars['Int']['output']>;
  reviewTime?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  uploadFileName?: Maybe<Scalars['String']['output']>;
  uploadFilePath?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['DateTime']['output']>;
  uploaderName?: Maybe<Scalars['String']['output']>;
  usedInKpiCalculation?: Maybe<Scalars['String']['output']>;
  valuationLevel?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type BoughtByPe = {
  __typename?: 'BoughtByPE';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkEstimateGDriveConfig = {
  __typename?: 'BulkEstimateGDriveConfig';
  autoConfiguredCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  requiresConfirmationCount?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BulkGDriveConfigEstimateResult>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  totalProcessed?: Maybe<Scalars['Int']['output']>;
};

export type BulkGDriveConfigEstimateResult = {
  __typename?: 'BulkGDriveConfigEstimateResult';
  companyId: Scalars['Int']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  estimate?: Maybe<GDriveConfigEstimateType>;
};

export type BuyAndBuildTargetAssessmentType = Node & {
  __typename?: 'BuyAndBuildTargetAssessmentType';
  address?: Maybe<Scalars['String']['output']>;
  analysis?: Maybe<GenericCompanyAnalysisConnection>;
  benchmarkingIndex?: Maybe<Scalars['Int']['output']>;
  buyAndBuildFocus?: Maybe<Scalars['String']['output']>;
  buyAndBuildShortlist?: Maybe<Array<Maybe<BuyAndBuildTargetAssessmentType>>>;
  buyAndBuildSources?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  buyAndBuildTargets?: Maybe<GenericBuyAndBuildRelevanceConnection>;
  city?: Maybe<Scalars['String']['output']>;
  companyAnalyses?: Maybe<CompanyAnalysisTypeConnection>;
  competitionCpcKeywords?: Maybe<Array<Maybe<KeywordResultType>>>;
  competitionIntensity?: Maybe<Scalars['Float']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactEmailConfidence?: Maybe<Scalars['Float']['output']>;
  contactEmailType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Scalars['String']['output']>;
  crawlResults?: Maybe<GenericCrawlResultConnection>;
  crawlRuns?: Maybe<CrawlRunConnection>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  customerIndustryGrowthRates?: Maybe<Array<Maybe<CustomerGrowthRateType>>>;
  customers?: Maybe<CompanyConnection>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  dealAssessmentFileUrl?: Maybe<DealAssessmentFileType>;
  doNotCrawl?: Maybe<Scalars['Boolean']['output']>;
  dueDilligence?: Maybe<Scalars['Boolean']['output']>;
  emailPattern?: Maybe<Scalars['String']['output']>;
  excelFiles?: Maybe<Array<Maybe<UploadExcelFileType>>>;
  findingsToken?: Maybe<FindingsTokenType>;
  foundingYear?: Maybe<Scalars['Int']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  gdriveDirectoryId: Scalars['String']['output'];
  gdriveDirectoryName: Scalars['String']['output'];
  gdriveSharedDriveId: Scalars['String']['output'];
  gdriveSharedDriveName: Scalars['String']['output'];
  gdriveSyncStatus?: Maybe<GDriveSyncStatusType>;
  genericShareholdings?: Maybe<GenericShareholdingConnection>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  hrbNumber?: Maybe<Scalars['String']['output']>;
  iabDomainCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialSource?: Maybe<Scalars['String']['output']>;
  isBidPortfolioCompany?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isGenericIndustryCompany?: Maybe<Scalars['Boolean']['output']>;
  isHorizontalSoftware?: Maybe<Scalars['Boolean']['output']>;
  isItCompanyCompany?: Maybe<Scalars['Boolean']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  isSaasCompany?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  klazifyDomain?: Maybe<KlazifyDomainType>;
  klazifyDomains?: Maybe<KlazifyDomainConnection>;
  latestCrawlResult?: Maybe<GenericCrawlResultSqlType>;
  latestDatetimeModified?: Maybe<Scalars['DateTime']['output']>;
  latestUrl?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  linkedinDescription?: Maybe<Scalars['String']['output']>;
  linkedinFte?: Maybe<Scalars['Int']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  managingDirector?: Maybe<Scalars['String']['output']>;
  matchUrl?: Maybe<Scalars['String']['output']>;
  maxFte?: Maybe<Scalars['Int']['output']>;
  maxFteAnalysis?: Maybe<Scalars['Int']['output']>;
  mergedIntoId?: Maybe<Scalars['Int']['output']>;
  mlModelApplied?: Maybe<Scalars['Boolean']['output']>;
  numberOfFailedCrawls?: Maybe<Scalars['Int']['output']>;
  openregCompanies?: Maybe<OpenRegCompanyConnection>;
  parentCompany?: Maybe<BuyAndBuildTargetAssessmentType>;
  patternMatches?: Maybe<Array<Maybe<ClassificationPatternMatchType>>>;
  peOwned?: Maybe<Scalars['Boolean']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  precalculatedKpis?: Maybe<KpiPrecalculationConnection>;
  privateOwned?: Maybe<Scalars['Boolean']['output']>;
  productCategories?: Maybe<ProductCategorizationConnection>;
  productCategorization?: Maybe<ProductCategorizationConnection>;
  productTechnologies?: Maybe<Array<Maybe<ProductTechnologylType>>>;
  ragValidations?: Maybe<Array<Maybe<RagValidationResultType>>>;
  recentCrawls?: Maybe<GenericCrawlResultConnection>;
  relevance?: Maybe<Scalars['Float']['output']>;
  shareholders?: Maybe<GenericShareHolderTypeConnection>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  sicCodeCertainty?: Maybe<Scalars['Float']['output']>;
  sicCodeDetails?: Maybe<SicCodeSqlType>;
  sicCodeJustification?: Maybe<Scalars['String']['output']>;
  sizeJustification?: Maybe<Scalars['String']['output']>;
  softwareCategoryGrowthRates?: Maybe<Array<Maybe<SoftwareCategoryGrowthRateType>>>;
  specialCpcKeywords?: Maybe<Array<Maybe<KeywordResultType>>>;
  street?: Maybe<Scalars['String']['output']>;
  subsidiaries?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  subsidiaryOf?: Maybe<Scalars['Int']['output']>;
  summaryDescription?: Maybe<Scalars['String']['output']>;
  teamQuality?: Maybe<TeamQualityType>;
  techUse?: Maybe<GenericCompanyTechUseConnection>;
  topCpcKeywords?: Maybe<Array<Maybe<KeywordResultType>>>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
  validated?: Maybe<Scalars['Boolean']['output']>;
  validationDatetime?: Maybe<Scalars['DateTime']['output']>;
  validationLockedAt?: Maybe<Scalars['DateTime']['output']>;
  validationLockedBy?: Maybe<Scalars['Int']['output']>;
  validationSignals?: Maybe<Array<Maybe<RagValidationSignalType>>>;
  validationUser?: Maybe<Scalars['String']['output']>;
  ycCompany?: Maybe<YcCompanyTypeConnection>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type BuyAndBuildTargetAssessmentTypeAnalysisArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fteGt?: InputMaybe<Scalars['Int']['input']>;
  fteLt?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeBuyAndBuildSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeBuyAndBuildTargetsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isShortlisted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeCompanyAnalysesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeCrawlResultsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeCrawlRunsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeCustomerIndustryGrowthRatesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeCustomersArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeGenericShareholdingsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeKlazifyDomainsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeOpenregCompaniesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypePrecalculatedKpisArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeProductCategoriesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeProductCategorizationArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeProductTechnologiesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeRecentCrawlsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeShareholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeSoftwareCategoryGrowthRatesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeSubsidiariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeTechUseArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyAndBuildTargetAssessmentTypeYcCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyAndBuildTargetAssessmentTypeConnection = {
  __typename?: 'BuyAndBuildTargetAssessmentTypeConnection';
  edges: Array<Maybe<BuyAndBuildTargetAssessmentTypeEdge>>;
  pageInfo: PageInfo;
};

export type BuyAndBuildTargetAssessmentTypeEdge = {
  __typename?: 'BuyAndBuildTargetAssessmentTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BuyAndBuildTargetAssessmentType>;
};

export type CddConfigStatusType = {
  __typename?: 'CDDConfigStatusType';
  anthropicApi: Scalars['Boolean']['output'];
  firecrawlApi: Scalars['Boolean']['output'];
  hasLlmProvider: Scalars['Boolean']['output'];
  langfuse: Scalars['Boolean']['output'];
  openaiApi: Scalars['Boolean']['output'];
  tavilyApi: Scalars['Boolean']['output'];
};

export type CddCustomerSegmentType = {
  __typename?: 'CDDCustomerSegmentType';
  buyingBehavior?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  painPoints: Array<Maybe<Scalars['String']['output']>>;
  segmentName: Scalars['String']['output'];
  sizeEstimate?: Maybe<Scalars['String']['output']>;
};

export type CddJobProgressType = {
  __typename?: 'CDDJobProgressType';
  message?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
};

export type CddJobStatusType = {
  __typename?: 'CDDJobStatusType';
  error?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  progress?: Maybe<CddJobProgressType>;
  result?: Maybe<Scalars['JSONString']['output']>;
  status: Scalars['String']['output'];
};

export type CddReportSummaryType = {
  __typename?: 'CDDReportSummaryType';
  analysisDate?: Maybe<Scalars['DateTime']['output']>;
  companyDomain: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executiveSummary?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  overallRating: CortexRatingEnum;
  processingTime?: Maybe<Scalars['Float']['output']>;
};

export type CddReportType = {
  __typename?: 'CDDReportType';
  analysisDate: Scalars['DateTime']['output'];
  companyDomain: Scalars['String']['output'];
  competitiveAnalysis: CompetitiveAnalysisType;
  cortexScorecard: CortexScorecardType;
  cortexTaxonomy: CortexTaxonomyType;
  deepDiveQuestions: Array<Maybe<Scalars['String']['output']>>;
  executiveSummary: Scalars['String']['output'];
  icpAnalysis: IcpAnalysisType;
  id?: Maybe<Scalars['ID']['output']>;
  langfuseTraceId?: Maybe<Scalars['String']['output']>;
  marketAnalysis: MarketAnalysisType;
  modelUsed?: Maybe<Scalars['String']['output']>;
  overallRating: CortexRatingEnum;
  processingTimeSeconds?: Maybe<Scalars['Float']['output']>;
  promptVariant?: Maybe<Scalars['String']['output']>;
  promptVersion?: Maybe<Scalars['String']['output']>;
  redFlags: Array<Maybe<Scalars['String']['output']>>;
  targetCompany: Scalars['String']['output'];
  unitEconomics: UnitEconomicsType;
};

export type CddReportV2SummaryType = {
  __typename?: 'CDDReportV2SummaryType';
  analysisDate?: Maybe<Scalars['DateTime']['output']>;
  companyDomain: Scalars['String']['output'];
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executiveSummary?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  overallRating: CortexRatingEnumV2;
  processingTime?: Maybe<Scalars['Float']['output']>;
  reportId: Scalars['ID']['output'];
};

export type CddReportV2Type = {
  __typename?: 'CDDReportV2Type';
  analysisDate?: Maybe<Scalars['DateTime']['output']>;
  claimCount?: Maybe<Scalars['Int']['output']>;
  companyDomain: Scalars['String']['output'];
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName: Scalars['String']['output'];
  competitiveAnalysis: CompetitiveAnalysisV2Type;
  cortexScorecard: CortexScorecardV2Type;
  cortexTaxonomy: TaxonomyV2Type;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deepDiveQuestions: Array<Maybe<Scalars['String']['output']>>;
  evidenceSourceCount?: Maybe<Scalars['Int']['output']>;
  evidenceSourceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  executiveSummary: Scalars['String']['output'];
  exhibitCount?: Maybe<Scalars['Int']['output']>;
  icpAnalysis: IcpAnalysisV2Type;
  id?: Maybe<Scalars['ID']['output']>;
  langfuseTraceId?: Maybe<Scalars['String']['output']>;
  marketAnalysis: MarketAnalysisV2Type;
  modelUsed?: Maybe<Scalars['String']['output']>;
  overallRating: CortexRatingEnumV2;
  processingTimeSeconds?: Maybe<Scalars['Float']['output']>;
  promptVariant?: Maybe<Scalars['String']['output']>;
  promptVersion?: Maybe<Scalars['String']['output']>;
  redFlags: Array<Maybe<Scalars['String']['output']>>;
  reportId: Scalars['ID']['output'];
  unitEconomics: UnitEconomicsV2Type;
};

export type CacheImpactType = {
  __typename?: 'CacheImpactType';
  cacheHitRate: Scalars['Float']['output'];
  estimatedSavings: Scalars['Float']['output'];
  pagesCached: Scalars['Int']['output'];
  pagesScraped: Scalars['Int']['output'];
};

export type CacheStatusType = {
  __typename?: 'CacheStatusType';
  contactPageCount: Scalars['Int']['output'];
  domain: Scalars['String']['output'];
  hasRecentPages: Scalars['Boolean']['output'];
  isReadyForParsing: Scalars['Boolean']['output'];
  needsScraping: Scalars['Boolean']['output'];
  newestPageDate?: Maybe<Scalars['DateTime']['output']>;
  oldestPageDate?: Maybe<Scalars['DateTime']['output']>;
  pageCount: Scalars['Int']['output'];
};

export type CalendarMeetingType = {
  __typename?: 'CalendarMeetingType';
  companyId?: Maybe<Scalars['Int']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  meetingDate: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  surveyColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CentroidRatingQueueItemType = {
  __typename?: 'CentroidRatingQueueItemType';
  centroidVersion?: Maybe<Scalars['Int']['output']>;
  companyDomain?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gateDecision?: Maybe<Scalars['String']['output']>;
  passThreshold?: Maybe<Scalars['Float']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
  skipThreshold?: Maybe<Scalars['Float']['output']>;
};

export type CentroidRatingResultType = {
  __typename?: 'CentroidRatingResultType';
  centroidVersion?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  gateDecision?: Maybe<Scalars['String']['output']>;
  ratingId?: Maybe<Scalars['Int']['output']>;
  similarityScore?: Maybe<Scalars['Float']['output']>;
  verdict?: Maybe<Scalars['String']['output']>;
};

export type CentroidThresholdComputeResultType = {
  __typename?: 'CentroidThresholdComputeResultType';
  auc?: Maybe<Scalars['Float']['output']>;
  centroidVersion?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  passPrecision?: Maybe<Scalars['Float']['output']>;
  passRecall?: Maybe<Scalars['Float']['output']>;
  passThreshold?: Maybe<Scalars['Float']['output']>;
  skipCount?: Maybe<Scalars['Int']['output']>;
  skipFalsePassRate?: Maybe<Scalars['Float']['output']>;
  skipRecall?: Maybe<Scalars['Float']['output']>;
  skipThreshold?: Maybe<Scalars['Float']['output']>;
  softwareCount?: Maybe<Scalars['Int']['output']>;
  totalRatings?: Maybe<Scalars['Int']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
  worthCrawlingCount?: Maybe<Scalars['Int']['output']>;
};

export type CentroidThresholdStatsType = {
  __typename?: 'CentroidThresholdStatsType';
  auc?: Maybe<Scalars['Float']['output']>;
  centroidVersion?: Maybe<Scalars['Int']['output']>;
  computedAt?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  passThreshold?: Maybe<Scalars['Float']['output']>;
  precisionAtPass?: Maybe<Scalars['Float']['output']>;
  ratingsCurrentVersion?: Maybe<Scalars['Int']['output']>;
  recallAtSkip?: Maybe<Scalars['Float']['output']>;
  skipThreshold?: Maybe<Scalars['Float']['output']>;
  thresholdsFromRatings?: Maybe<Scalars['Int']['output']>;
  totalRatingsAllVersions?: Maybe<Scalars['Int']['output']>;
};

export type CertificationType = Node & {
  __typename?: 'CertificationType';
  aiMoatLevel?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionEmbedding?: Maybe<Scalars['JSONString']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issuer?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ChatJobStatusType = {
  __typename?: 'ChatJobStatusType';
  error?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  progress?: Maybe<JobProgressType>;
  result?: Maybe<Scalars['JSONString']['output']>;
  status: Scalars['String']['output'];
};

export type ChatMessageListResponseType = {
  __typename?: 'ChatMessageListResponseType';
  messages: Array<Maybe<ChatMessageType>>;
  sessionId: Scalars['ID']['output'];
};

export type ChatMessageType = {
  __typename?: 'ChatMessageType';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  toolCalls: Array<Maybe<ToolCallType>>;
};

export type ChatResponseType = {
  __typename?: 'ChatResponseType';
  isAsync?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  message: ChatMessageType;
  sessionId: Scalars['ID']['output'];
};

export type ChatSessionListResponseType = {
  __typename?: 'ChatSessionListResponseType';
  sessions: Array<Maybe<ChatSessionType>>;
};

export type ChatSessionType = {
  __typename?: 'ChatSessionType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type ClaimV2Type = {
  __typename?: 'ClaimV2Type';
  category?: Maybe<Scalars['String']['output']>;
  claimId: Scalars['ID']['output'];
  confidence: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  evidenceSourceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text: Scalars['String']['output'];
};

export type ClassificationPatternMatchCompanyType = {
  __typename?: 'ClassificationPatternMatchCompanyType';
  dbId?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type ClassificationPatternMatchType = {
  __typename?: 'ClassificationPatternMatchType';
  company?: Maybe<BuyAndBuildTargetAssessmentType>;
  companyId: Scalars['Int']['output'];
  companyInfo?: Maybe<ClassificationPatternMatchCompanyType>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  matchConfidence?: Maybe<Scalars['Float']['output']>;
  matchedIn?: Maybe<Scalars['String']['output']>;
  matchedText?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<ClassificationPatternType>;
  patternId: Scalars['Int']['output'];
  userFeedback?: Maybe<Scalars['String']['output']>;
  validationResult?: Maybe<RagValidationResultType>;
  validationResultId?: Maybe<Scalars['Int']['output']>;
  wasCorrect?: Maybe<Scalars['Boolean']['output']>;
};

export type ClassificationPatternType = {
  __typename?: 'ClassificationPatternType';
  classificationTarget: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isProbationary?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Array<Maybe<ClassificationPatternMatchType>>>;
  patternText: Scalars['String']['output'];
  patternType: Scalars['String']['output'];
  probationMetadata?: Maybe<Scalars['JSONString']['output']>;
  semanticCategory?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CleanupCrawlResults = {
  __typename?: 'CleanupCrawlResults';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CleanupUnknownShareholdersMutation = {
  __typename?: 'CleanupUnknownShareholdersMutation';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  totalAffected?: Maybe<Scalars['Int']['output']>;
};

export type CompanyAnalysisType = Node & {
  __typename?: 'CompanyAnalysisType';
  company?: Maybe<BuyAndBuildTargetAssessmentType>;
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  ebitda?: Maybe<Scalars['Int']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isItCompany?: Maybe<Scalars['Boolean']['output']>;
  isItCompanyScore?: Maybe<Scalars['Float']['output']>;
  isSaasCompany?: Maybe<Scalars['Boolean']['output']>;
  isSaasScore?: Maybe<Scalars['Float']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareScore?: Maybe<Scalars['Float']['output']>;
  lastSynthesisAt?: Maybe<Scalars['DateTime']['output']>;
  lastSynthesisCrawlResultId?: Maybe<Scalars['Int']['output']>;
  lastSynthesisCrawlType?: Maybe<Scalars['String']['output']>;
  linkedinFte?: Maybe<Scalars['Int']['output']>;
  linkedinLowerFte?: Maybe<Scalars['Int']['output']>;
  linkedinUpperFte?: Maybe<Scalars['Int']['output']>;
  noOfCustomers?: Maybe<Scalars['Int']['output']>;
  noOfUsers?: Maybe<Scalars['Int']['output']>;
  recurringShare?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  sizeJustification?: Maybe<Scalars['String']['output']>;
};

export type CompanyAnalysisTypeConnection = {
  __typename?: 'CompanyAnalysisTypeConnection';
  edges: Array<Maybe<CompanyAnalysisTypeEdge>>;
  pageInfo: PageInfo;
};

export type CompanyAnalysisTypeEdge = {
  __typename?: 'CompanyAnalysisTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompanyAnalysisType>;
};

export type CompanyAssesmentConnection = Node & {
  __typename?: 'CompanyAssesmentConnection';
  edges: Array<Maybe<CompanyAssesmentEdge>>;
  id: Scalars['ID']['output'];
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type CompanyAssesmentEdge = {
  __typename?: 'CompanyAssesmentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompanyAssessmentType>;
};

export type CompanyAssessmentType = Node & {
  __typename?: 'CompanyAssessmentType';
  address?: Maybe<Scalars['String']['output']>;
  analysis?: Maybe<GenericCompanyAnalysisConnection>;
  benchmarkingIndex?: Maybe<Scalars['Int']['output']>;
  buyAndBuildFocus?: Maybe<Scalars['String']['output']>;
  buyAndBuildShortlist?: Maybe<Array<Maybe<BuyAndBuildTargetAssessmentType>>>;
  buyAndBuildSources?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  buyAndBuildTargets?: Maybe<GenericBuyAndBuildRelevanceConnection>;
  city?: Maybe<Scalars['String']['output']>;
  companyAnalyses?: Maybe<CompanyAnalysisTypeConnection>;
  competitionCpcKeywords?: Maybe<Array<Maybe<KeywordResultType>>>;
  competitionIntensity?: Maybe<Scalars['Float']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactEmailConfidence?: Maybe<Scalars['Float']['output']>;
  contactEmailType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Scalars['String']['output']>;
  crawlResults?: Maybe<GenericCrawlResultConnection>;
  crawlRuns?: Maybe<CrawlRunConnection>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  customerIndustryGrowthRates?: Maybe<Array<Maybe<CustomerGrowthRateType>>>;
  customers?: Maybe<CompanyConnection>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  dealAssessmentFileUrl?: Maybe<DealAssessmentFileType>;
  doNotCrawl?: Maybe<Scalars['Boolean']['output']>;
  dueDilligence?: Maybe<Scalars['Boolean']['output']>;
  emailPattern?: Maybe<Scalars['String']['output']>;
  excelFiles?: Maybe<Array<Maybe<UploadExcelFileType>>>;
  findingsToken?: Maybe<FindingsTokenType>;
  foundingYear?: Maybe<Scalars['Int']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  gdriveDirectoryId: Scalars['String']['output'];
  gdriveDirectoryName: Scalars['String']['output'];
  gdriveSharedDriveId: Scalars['String']['output'];
  gdriveSharedDriveName: Scalars['String']['output'];
  gdriveSyncStatus?: Maybe<GDriveSyncStatusType>;
  genericShareholdings?: Maybe<GenericShareholdingConnection>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  hrbNumber?: Maybe<Scalars['String']['output']>;
  iabDomainCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialSource?: Maybe<Scalars['String']['output']>;
  isBidPortfolioCompany?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isGenericIndustryCompany?: Maybe<Scalars['Boolean']['output']>;
  isHorizontalSoftware?: Maybe<Scalars['Boolean']['output']>;
  isItCompanyCompany?: Maybe<Scalars['Boolean']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  isSaasCompany?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  klazifyDomain?: Maybe<KlazifyDomainType>;
  klazifyDomains?: Maybe<KlazifyDomainConnection>;
  latestCrawlResult?: Maybe<GenericCrawlResultSqlType>;
  latestDatetimeModified?: Maybe<Scalars['DateTime']['output']>;
  latestUrl?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  linkedinDescription?: Maybe<Scalars['String']['output']>;
  linkedinFte?: Maybe<Scalars['Int']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  managingDirector?: Maybe<Scalars['String']['output']>;
  maxFte?: Maybe<Scalars['Int']['output']>;
  maxFteAnalysis?: Maybe<Scalars['Int']['output']>;
  mergedIntoId?: Maybe<Scalars['Int']['output']>;
  mlModelApplied?: Maybe<Scalars['Boolean']['output']>;
  numberOfFailedCrawls?: Maybe<Scalars['Int']['output']>;
  openregCompanies?: Maybe<OpenRegCompanyConnection>;
  parentCompany?: Maybe<BuyAndBuildTargetAssessmentType>;
  patternMatches?: Maybe<Array<Maybe<ClassificationPatternMatchType>>>;
  peOwned?: Maybe<Scalars['Boolean']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  precalculatedKpis?: Maybe<KpiPrecalculationConnection>;
  privateOwned?: Maybe<Scalars['Boolean']['output']>;
  productCategories?: Maybe<ProductCategorizationConnection>;
  productCategorization?: Maybe<ProductCategorizationConnection>;
  productTechnologies?: Maybe<Array<Maybe<ProductTechnologylType>>>;
  ragValidations?: Maybe<Array<Maybe<RagValidationResultType>>>;
  recentCrawls?: Maybe<GenericCrawlResultConnection>;
  shareholders?: Maybe<GenericShareHolderTypeConnection>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  sicCodeCertainty?: Maybe<Scalars['Float']['output']>;
  sicCodeDetails?: Maybe<SicCodeSqlType>;
  sicCodeJustification?: Maybe<Scalars['String']['output']>;
  sizeJustification?: Maybe<Scalars['String']['output']>;
  softwareCategoryGrowthRates?: Maybe<Array<Maybe<SoftwareCategoryGrowthRateType>>>;
  specialCpcKeywords?: Maybe<Array<Maybe<KeywordResultType>>>;
  street?: Maybe<Scalars['String']['output']>;
  subsidiaries?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  subsidiaryOf?: Maybe<Scalars['Int']['output']>;
  summaryDescription?: Maybe<Scalars['String']['output']>;
  teamQuality?: Maybe<TeamQualityType>;
  techUse?: Maybe<GenericCompanyTechUseConnection>;
  topCpcKeywords?: Maybe<Array<Maybe<KeywordResultType>>>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
  validated?: Maybe<Scalars['Boolean']['output']>;
  validationDatetime?: Maybe<Scalars['DateTime']['output']>;
  validationLockedAt?: Maybe<Scalars['DateTime']['output']>;
  validationLockedBy?: Maybe<Scalars['Int']['output']>;
  validationSignals?: Maybe<Array<Maybe<RagValidationSignalType>>>;
  validationUser?: Maybe<Scalars['String']['output']>;
  ycCompany?: Maybe<YcCompanyTypeConnection>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type CompanyAssessmentTypeAnalysisArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fteGt?: InputMaybe<Scalars['Int']['input']>;
  fteLt?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeBuyAndBuildSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeBuyAndBuildTargetsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isShortlisted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyAssessmentTypeCompanyAnalysesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeCrawlResultsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeCrawlRunsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyAssessmentTypeCustomerIndustryGrowthRatesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeCustomersArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeGenericShareholdingsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeKlazifyDomainsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeOpenregCompaniesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypePrecalculatedKpisArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeProductCategoriesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeProductCategorizationArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeProductTechnologiesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeRecentCrawlsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeShareholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeSoftwareCategoryGrowthRatesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeSubsidiariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeTechUseArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAssessmentTypeYcCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyCertificationType = {
  __typename?: 'CompanyCertificationType';
  certificationAiMoatLevel?: Maybe<Scalars['String']['output']>;
  certificationDescription?: Maybe<Scalars['String']['output']>;
  certificationDomain?: Maybe<Scalars['String']['output']>;
  certificationId?: Maybe<Scalars['Int']['output']>;
  certificationIssuer?: Maybe<Scalars['String']['output']>;
  certificationLevel?: Maybe<Scalars['String']['output']>;
  certificationName?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  contextSnippet?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  extractionConfidence?: Maybe<Scalars['Float']['output']>;
  extractionMethod?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  edges: Array<Maybe<CompanyEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type CompanyContactType = {
  __typename?: 'CompanyContactType';
  contactType: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pdPersonId?: Maybe<Scalars['Int']['output']>;
  sourceId?: Maybe<Scalars['Int']['output']>;
  sourceTable?: Maybe<Scalars['String']['output']>;
};

export type CompanyCoreKeywordConnection = {
  __typename?: 'CompanyCoreKeywordConnection';
  edges: Array<Maybe<CompanyCoreKeywordEdge>>;
  pageInfo: PageInfo;
};

export type CompanyCoreKeywordEdge = {
  __typename?: 'CompanyCoreKeywordEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompanyCoreKeywordType>;
};

export enum CompanyCoreKeywordSortEnum {
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  CompetitionIndexAsc = 'competition_index_asc',
  CompetitionIndexDesc = 'competition_index_desc',
  ConfidenceAsc = 'confidence_asc',
  ConfidenceDesc = 'confidence_desc',
  CpcAsc = 'cpc_asc',
  CpcDesc = 'cpc_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  GoogleTermIdAsc = 'google_term_id_asc',
  GoogleTermIdDesc = 'google_term_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  KeywordAsc = 'keyword_asc',
  KeywordDesc = 'keyword_desc',
  KeywordEmbeddingV2Asc = 'keyword_embedding_v2_asc',
  KeywordEmbeddingV2Desc = 'keyword_embedding_v2_desc',
  KeywordTypeAsc = 'keyword_type_asc',
  KeywordTypeDesc = 'keyword_type_desc',
  SearchVolumeAsc = 'search_volume_asc',
  SearchVolumeDesc = 'search_volume_desc',
  SourceAsc = 'source_asc',
  SourceDesc = 'source_desc'
}

export type CompanyCoreKeywordType = Node & {
  __typename?: 'CompanyCoreKeywordType';
  companyId: Scalars['Int']['output'];
  competitionIndex?: Maybe<Scalars['Float']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  cpc?: Maybe<Scalars['Float']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  googleTermId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  keyword: Scalars['String']['output'];
  keywordType?: Maybe<Scalars['String']['output']>;
  searchVolume?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompanyType>;
};

export type CompanyInboxType = Node & {
  __typename?: 'CompanyInboxType';
  aiValidationScore?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  fteAnalysisResult?: Maybe<Scalars['Float']['output']>;
  hadMlModelApplied?: Maybe<Scalars['Boolean']['output']>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  iabDomainCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  pageInfo?: Maybe<DbIdPageInfo>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  productCategorization?: Maybe<ProductCategorizationConnection>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  sicCodeCertainty?: Maybe<Scalars['Float']['output']>;
  sicCodeJustification?: Maybe<Scalars['String']['output']>;
  systemType?: Maybe<Scalars['String']['output']>;
  topRelatedCompanyLogoUrl?: Maybe<Scalars['String']['output']>;
  topRelatedCompanyName?: Maybe<Scalars['String']['output']>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type CompanyInboxTypeProductCategorizationArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyPnlForecastType = {
  __typename?: 'CompanyPnlForecastType';
  lastFiscalYear?: Maybe<Scalars['Int']['output']>;
  recurringRevenueShare?: Maybe<Scalars['Float']['output']>;
  rows?: Maybe<Array<Maybe<PnlYearRowType>>>;
};

export type CompanyProductConnection = {
  __typename?: 'CompanyProductConnection';
  edges: Array<Maybe<CompanyProductEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type CompanyProductEdge = {
  __typename?: 'CompanyProductEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompanyProductType>;
};

export enum CompanyProductSortEnum {
  ClassificationSessionIdAsc = 'classification_session_id_asc',
  ClassificationSessionIdDesc = 'classification_session_id_desc',
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  ConfidenceAsc = 'confidence_asc',
  ConfidenceDesc = 'confidence_desc',
  CrawlResultIdAsc = 'crawl_result_id_asc',
  CrawlResultIdDesc = 'crawl_result_id_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DescriptionAsc = 'description_asc',
  DescriptionDesc = 'description_desc',
  DescriptionEmbeddingAsc = 'description_embedding_asc',
  DescriptionEmbeddingDesc = 'description_embedding_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  ProductNameAsc = 'product_name_asc',
  ProductNameDesc = 'product_name_desc',
  ProductTypeAsc = 'product_type_asc',
  ProductTypeDesc = 'product_type_desc',
  ProductUrlAsc = 'product_url_asc',
  ProductUrlDesc = 'product_url_desc',
  SoftwareCategoryCertaintyAsc = 'software_category_certainty_asc',
  SoftwareCategoryCertaintyDesc = 'software_category_certainty_desc',
  SoftwareCategoryIdAsc = 'software_category_id_asc',
  SoftwareCategoryIdDesc = 'software_category_id_desc',
  SourceAsc = 'source_asc',
  SourceDesc = 'source_desc',
  SourceUrlAsc = 'source_url_asc',
  SourceUrlDesc = 'source_url_desc'
}

export type CompanyProductType = Node & {
  __typename?: 'CompanyProductType';
  classificationSessionId?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['Int']['output'];
  confidence?: Maybe<Scalars['Float']['output']>;
  crawlResultId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fullProductUrl?: Maybe<Scalars['String']['output']>;
  fullSourceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pricingModels?: Maybe<Array<Maybe<ProductPricingModelType>>>;
  productName: Scalars['String']['output'];
  productType?: Maybe<Scalars['String']['output']>;
  productUrl?: Maybe<Scalars['String']['output']>;
  softwareCategory?: Maybe<SoftwareCategoryType>;
  softwareCategoryCertainty?: Maybe<Scalars['Float']['output']>;
  softwareCategoryId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

export type CompanyProductTypeConnection = {
  __typename?: 'CompanyProductTypeConnection';
  edges: Array<Maybe<CompanyProductTypeEdge>>;
  pageInfo: PageInfo;
};

export type CompanyProductTypeEdge = {
  __typename?: 'CompanyProductTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompanyProductType>;
};

export type CompanySignalSummaryType = {
  __typename?: 'CompanySignalSummaryType';
  companyId?: Maybe<Scalars['Int']['output']>;
  helpfulSignals?: Maybe<Scalars['Int']['output']>;
  misleadingSignals?: Maybe<Scalars['Int']['output']>;
  signals?: Maybe<Array<Maybe<RagValidationSignalType>>>;
  signalsWithFeedback?: Maybe<Scalars['Int']['output']>;
  totalSignals?: Maybe<Scalars['Int']['output']>;
};

export type CompanySurveyAggregationType = {
  __typename?: 'CompanySurveyAggregationType';
  likertScores?: Maybe<Scalars['JSONString']['output']>;
  multiSelectFrequencies?: Maybe<Scalars['JSONString']['output']>;
  responses?: Maybe<Scalars['JSONString']['output']>;
  totalResponses?: Maybe<Scalars['Int']['output']>;
};

export type CompanyTaskSummary = {
  __typename?: 'CompanyTaskSummary';
  bmUploadProgress?: Maybe<Scalars['Float']['output']>;
  companyDomain?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  crawlProgress?: Maybe<Scalars['Float']['output']>;
  daGenerationProgress?: Maybe<Scalars['Float']['output']>;
  kpiCalculationProgress?: Maybe<Scalars['Float']['output']>;
  latestTask?: Maybe<TaskLog>;
};

export type CompanyType = Node & {
  __typename?: 'CompanyType';
  address?: Maybe<Scalars['String']['output']>;
  analysis?: Maybe<GenericCompanyAnalysisConnection>;
  benchmarkingIndex?: Maybe<Scalars['Int']['output']>;
  buyAndBuildFocus?: Maybe<Scalars['String']['output']>;
  buyAndBuildSources?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  buyAndBuildTargets?: Maybe<GenericBuyAndBuildRelevanceConnection>;
  city?: Maybe<Scalars['String']['output']>;
  companyAnalyses?: Maybe<CompanyAnalysisTypeConnection>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactEmailConfidence?: Maybe<Scalars['Float']['output']>;
  contactEmailType?: Maybe<Scalars['String']['output']>;
  contactEnrichmentLog?: Maybe<Array<Maybe<ContactEnrichmentLogEntryType>>>;
  country?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Scalars['String']['output']>;
  crawlResults?: Maybe<GenericCrawlResultConnection>;
  crawlRuns?: Maybe<CrawlRunConnection>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  dealAssessmentFileUrl?: Maybe<DealAssessmentFileType>;
  doNotCrawl?: Maybe<Scalars['Boolean']['output']>;
  dueDilligence?: Maybe<Scalars['Boolean']['output']>;
  emailPattern?: Maybe<Scalars['String']['output']>;
  excelFiles?: Maybe<Array<Maybe<UploadExcelFileType>>>;
  foundingYear?: Maybe<Scalars['Int']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  gdriveDirectoryId: Scalars['String']['output'];
  gdriveDirectoryName: Scalars['String']['output'];
  gdriveSharedDriveId: Scalars['String']['output'];
  gdriveSharedDriveName: Scalars['String']['output'];
  gdriveSyncStatus?: Maybe<GDriveSyncStatusType>;
  genericShareholdings?: Maybe<GenericShareholdingConnection>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  hrbNumber?: Maybe<Scalars['String']['output']>;
  iabDomainCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialSource?: Maybe<Scalars['String']['output']>;
  isBidPortfolioCompany?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isGenericIndustryCompany?: Maybe<Scalars['Boolean']['output']>;
  isHorizontalSoftware?: Maybe<Scalars['Boolean']['output']>;
  isItCompanyCompany?: Maybe<Scalars['Boolean']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  isSaasCompany?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  klazifyDomain?: Maybe<KlazifyDomainType>;
  klazifyDomains?: Maybe<KlazifyDomainConnection>;
  latestCrawlResult?: Maybe<GenericCrawlResultSqlType>;
  latestDatetimeModified?: Maybe<Scalars['DateTime']['output']>;
  latestUrl?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  linkedinDescription?: Maybe<Scalars['String']['output']>;
  linkedinFte?: Maybe<Scalars['Int']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  managingDirector?: Maybe<Scalars['String']['output']>;
  maxFte?: Maybe<Scalars['Int']['output']>;
  maxFteAnalysis?: Maybe<Scalars['Int']['output']>;
  mergedIntoId?: Maybe<Scalars['Int']['output']>;
  mlModelApplied?: Maybe<Scalars['Boolean']['output']>;
  numberOfFailedCrawls?: Maybe<Scalars['Int']['output']>;
  openregCompanies?: Maybe<OpenRegCompanyConnection>;
  parentCompany?: Maybe<BuyAndBuildTargetAssessmentType>;
  patternMatches?: Maybe<Array<Maybe<ClassificationPatternMatchType>>>;
  peOwned?: Maybe<Scalars['Boolean']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  precalculatedKpis?: Maybe<KpiPreCalculationTypeConnection>;
  privateOwned?: Maybe<Scalars['Boolean']['output']>;
  productCategorization?: Maybe<ProductCategorizationConnection>;
  ragValidations?: Maybe<Array<Maybe<RagValidationResultType>>>;
  recentCrawls?: Maybe<GenericCrawlResultConnection>;
  shareholders?: Maybe<GenericShareHolderTypeConnection>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  sicCodeCertainty?: Maybe<Scalars['Float']['output']>;
  sicCodeDetails?: Maybe<SicCodeSqlType>;
  sicCodeJustification?: Maybe<Scalars['String']['output']>;
  sizeJustification?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  subsidiaries?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  subsidiaryOf?: Maybe<Scalars['Int']['output']>;
  techUse?: Maybe<GenericCompanyTechUseConnection>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
  validated?: Maybe<Scalars['Boolean']['output']>;
  validationDatetime?: Maybe<Scalars['DateTime']['output']>;
  validationLockedAt?: Maybe<Scalars['DateTime']['output']>;
  validationLockedBy?: Maybe<Scalars['Int']['output']>;
  validationSignals?: Maybe<Array<Maybe<RagValidationSignalType>>>;
  validationUser?: Maybe<Scalars['String']['output']>;
  ycCompany?: Maybe<YcCompanyTypeConnection>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type CompanyTypeAnalysisArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fteGt?: InputMaybe<Scalars['Int']['input']>;
  fteLt?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeBuyAndBuildSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeBuyAndBuildTargetsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isShortlisted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyTypeCompanyAnalysesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCrawlResultsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCrawlRunsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTypeGenericShareholdingsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeKlazifyDomainsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeOpenregCompaniesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePrecalculatedKpisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeProductCategorizationArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeRecentCrawlsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeShareholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeSubsidiariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeTechUseArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeYcCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyWithLatestUpload = {
  __typename?: 'CompanyWithLatestUpload';
  company?: Maybe<CompanyType>;
  uploadTime?: Maybe<Scalars['DateTime']['output']>;
  uploaderName?: Maybe<Scalars['String']['output']>;
};

export type CompetitiveAnalysisType = {
  __typename?: 'CompetitiveAnalysisType';
  barriersToEntry: Array<Maybe<Scalars['String']['output']>>;
  competitiveAdvantages: Array<Maybe<Scalars['String']['output']>>;
  competitiveThreats: Array<Maybe<Scalars['String']['output']>>;
  cortexRating: CortexRatingEnum;
  mainCompetitors: Array<Maybe<CompetitorType>>;
  marketStructure: Scalars['String']['output'];
  ratingRationale: Scalars['String']['output'];
  switchingCosts: Scalars['String']['output'];
  targetCompanyPositioning: Scalars['String']['output'];
};

export type CompetitiveAnalysisV2Type = {
  __typename?: 'CompetitiveAnalysisV2Type';
  barriersToEntry: Array<Maybe<Scalars['String']['output']>>;
  claimIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  competitiveAdvantages: Array<Maybe<Scalars['String']['output']>>;
  competitiveThreats: Array<Maybe<Scalars['String']['output']>>;
  cortexRating: CortexRatingEnumV2;
  exhibitIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mainCompetitors: Scalars['JSONString']['output'];
  marketStructure: Scalars['String']['output'];
  ratingRationale: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  switchingCosts: Scalars['String']['output'];
  targetCompanyPositioning: Scalars['String']['output'];
};

export type CompetitorType = {
  __typename?: 'CompetitorType';
  domain?: Maybe<Scalars['String']['output']>;
  estimatedMarketShare?: Maybe<Scalars['String']['output']>;
  fundingStage?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  positioning: Scalars['String']['output'];
  strengths: Array<Maybe<Scalars['String']['output']>>;
  weaknesses: Array<Maybe<Scalars['String']['output']>>;
};

export type ComputeHomepageGateCentroidsMutation = {
  __typename?: 'ComputeHomepageGateCentroidsMutation';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ConfirmCompanyGDriveConfig = {
  __typename?: 'ConfirmCompanyGDriveConfig';
  directoryId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfirmFteSize = {
  __typename?: 'ConfirmFteSize';
  fteChanged?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  previousFte?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactEnrichmentLogEntryType = {
  __typename?: 'ContactEnrichmentLogEntryType';
  contactEmailExtracted?: Maybe<Scalars['Boolean']['output']>;
  contactEmailSource?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  extractionMethod?: Maybe<Scalars['String']['output']>;
  firecrawlPagesScraped?: Maybe<Scalars['Int']['output']>;
  firecrawlSuccess?: Maybe<Scalars['Boolean']['output']>;
  hunterCalled?: Maybe<Scalars['Boolean']['output']>;
  hunterCreditsUsed?: Maybe<Scalars['Float']['output']>;
  managingDirectorExtracted?: Maybe<Scalars['Boolean']['output']>;
  managingDirectorSource?: Maybe<Scalars['String']['output']>;
  processingTimeSeconds?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type ConversionTrackingType = {
  __typename?: 'ConversionTrackingType';
  companyName?: Maybe<Scalars['String']['output']>;
  dealClosedAt?: Maybe<Scalars['DateTime']['output']>;
  dealCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  firstCallDate?: Maybe<Scalars['DateTime']['output']>;
  followupCallCount?: Maybe<Scalars['Int']['output']>;
  initialCallCount?: Maybe<Scalars['Int']['output']>;
  linkedMeetingCount?: Maybe<Scalars['Int']['output']>;
  pipedriveDealId?: Maybe<Scalars['Int']['output']>;
  pipelineName?: Maybe<Scalars['String']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CortexConfigType = {
  __typename?: 'CortexConfigType';
  aiValidationOverwriteEnabled?: Maybe<Scalars['Boolean']['output']>;
  assessmentXlsTemplateId?: Maybe<Scalars['String']['output']>;
  assessmentXlsUploadTime?: Maybe<Scalars['DateTime']['output']>;
  authLogOnly?: Maybe<Scalars['Boolean']['output']>;
  cheapOpenrouterTextModel?: Maybe<Scalars['String']['output']>;
  cheapOpenrouterVisionModel?: Maybe<Scalars['String']['output']>;
  crawlIfOlderDays?: Maybe<Scalars['Int']['output']>;
  crawlQueueBatchSize?: Maybe<Scalars['Int']['output']>;
  crawlQueueEnabled?: Maybe<Scalars['Boolean']['output']>;
  crawlQueueIntervalSeconds?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  freeOpenrouterTextModel?: Maybe<Scalars['String']['output']>;
  freeOpenrouterVisionModel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialBbWeightForSourcescrubTags?: Maybe<Scalars['Float']['output']>;
  macAcceptableWebsitePopularity?: Maybe<Scalars['Int']['output']>;
  maxCrawledPagesPerDomain?: Maybe<Scalars['Int']['output']>;
  maxRecursionDepth?: Maybe<Scalars['Int']['output']>;
  midOpenrouterTextModel?: Maybe<Scalars['String']['output']>;
  midOpenrouterVisionModel?: Maybe<Scalars['String']['output']>;
  minFacesForGroupPicture?: Maybe<Scalars['Int']['output']>;
  mongoSiteCacheInDays?: Maybe<Scalars['Int']['output']>;
  openrouterUseFloorVariant?: Maybe<Scalars['Boolean']['output']>;
  pipedriveCortexLabelId?: Maybe<Scalars['Int']['output']>;
  pipedriveDfmTargetDealsFilterId?: Maybe<Scalars['Int']['output']>;
  pipedriveHotLeadLabelId?: Maybe<Scalars['Int']['output']>;
  pipedriveOpenTargetDealsLimit?: Maybe<Scalars['Int']['output']>;
  pipedriveSoftwareCompanyOrgTypeIndicator?: Maybe<Scalars['Int']['output']>;
  postToZapier?: Maybe<Scalars['Boolean']['output']>;
  premiumOpenrouterTextModel?: Maybe<Scalars['String']['output']>;
  premiumOpenrouterVisionModel?: Maybe<Scalars['String']['output']>;
  scheduledCrawlerBatchSize?: Maybe<Scalars['Int']['output']>;
  sourcescrubTagIdForGenericGenericCompanyLabel?: Maybe<Scalars['Int']['output']>;
  useNewClassificationPipeline?: Maybe<Scalars['Boolean']['output']>;
  v2RecrawlBatchSize?: Maybe<Scalars['Int']['output']>;
};

export type CortexFeedbackPipedriveBridge = {
  __typename?: 'CortexFeedbackPipedriveBridge';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CortexIdType = {
  __typename?: 'CortexIdType';
  cortexId?: Maybe<Scalars['Int']['output']>;
};

export enum CortexRatingEnum {
  Critical = 'CRITICAL',
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Sufficient = 'SUFFICIENT'
}

export enum CortexRatingEnumV2 {
  Critical = 'CRITICAL',
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Sufficient = 'SUFFICIENT'
}

export type CortexScorecardType = {
  __typename?: 'CortexScorecardType';
  competitive: CortexRatingEnum;
  icp: CortexRatingEnum;
  market: CortexRatingEnum;
  unitEconomics: CortexRatingEnum;
};

export type CortexScorecardV2Type = {
  __typename?: 'CortexScorecardV2Type';
  competitive?: Maybe<CortexRatingEnumV2>;
  icp?: Maybe<CortexRatingEnumV2>;
  market?: Maybe<CortexRatingEnumV2>;
  unitEconomics?: Maybe<CortexRatingEnumV2>;
};

export type CortexTaxonomyType = {
  __typename?: 'CortexTaxonomyType';
  cortexFitAssessment: Scalars['String']['output'];
  deploymentModel: Scalars['String']['output'];
  horizontalityScore: Scalars['String']['output'];
  integrationEcosystem?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryCategory: Scalars['String']['output'];
  subcategories: Array<Maybe<Scalars['String']['output']>>;
  technologyLayer: Scalars['String']['output'];
};

export type CostAnalysisType = {
  __typename?: 'CostAnalysisType';
  cacheImpact?: Maybe<CacheImpactType>;
  costs?: Maybe<CostsType>;
  projections?: Maybe<ProjectionsType>;
  recommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timeRange: Scalars['String']['output'];
  usage?: Maybe<UsageType>;
};

export type CostsType = {
  __typename?: 'CostsType';
  apolloCost: Scalars['Float']['output'];
  avgCostPerEnrichment: Scalars['Float']['output'];
  firecrawlCost: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
};

export type CrawlHistoryRecordType = {
  __typename?: 'CrawlHistoryRecordType';
  findings?: Maybe<FindingsType>;
  isSkipped?: Maybe<Scalars['Boolean']['output']>;
  iteration?: Maybe<Scalars['Int']['output']>;
  linksFollowed?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type CrawlQueueStatsType = {
  __typename?: 'CrawlQueueStatsType';
  errored?: Maybe<Scalars['Int']['output']>;
  locked?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  started?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CrawlQueueType = {
  __typename?: 'CrawlQueueType';
  asOfDate?: Maybe<Scalars['String']['output']>;
  benchmarkingIndex?: Maybe<Scalars['String']['output']>;
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['Int']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  crawlIfOlder?: Maybe<Scalars['Int']['output']>;
  crawlResultId?: Maybe<Scalars['Int']['output']>;
  crawlRunId?: Maybe<Scalars['Int']['output']>;
  crawlStarted?: Maybe<Scalars['Boolean']['output']>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  domain: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  forceDeepAnalysis?: Maybe<Scalars['Boolean']['output']>;
  forceSw?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  pipedriveId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  quickCrawlOnly?: Maybe<Scalars['Boolean']['output']>;
  triggeredBy?: Maybe<Scalars['String']['output']>;
};

export type CrawlRunConnection = {
  __typename?: 'CrawlRunConnection';
  edges: Array<Maybe<CrawlRunEdge>>;
  pageInfo: PageInfo;
};

export type CrawlRunEdge = {
  __typename?: 'CrawlRunEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CrawlRunSqlType>;
};

export type CrawlRunSqlType = Node & {
  __typename?: 'CrawlRunSQLType';
  asOfDate?: Maybe<Scalars['String']['output']>;
  brightdataCalls?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  costBreakdown?: Maybe<Scalars['JSONString']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  handelsregisterCalls?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  klazifyCalls?: Maybe<Scalars['Int']['output']>;
  llmApiCalls?: Maybe<Scalars['Int']['output']>;
  llmCostUsd?: Maybe<Scalars['Float']['output']>;
  llmInputTokens?: Maybe<Scalars['Int']['output']>;
  llmOutputTokens?: Maybe<Scalars['Int']['output']>;
  openaiBatchRequests?: Maybe<Scalars['Int']['output']>;
  scrapingbeeCalls?: Maybe<Scalars['Int']['output']>;
  scrapingbeeCredits?: Maybe<Scalars['Int']['output']>;
  serpCalls?: Maybe<Scalars['Int']['output']>;
  sourcescrubCalls?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  steps?: Maybe<Array<Maybe<CrawlTimestampStepType>>>;
  tavilyCalls?: Maybe<Scalars['Int']['output']>;
  textractCalls?: Maybe<Scalars['Int']['output']>;
  totalCostUsd?: Maybe<Scalars['Float']['output']>;
  triggeredBy?: Maybe<Scalars['String']['output']>;
  voyageCalls?: Maybe<Scalars['Int']['output']>;
  xoviCalls?: Maybe<Scalars['Int']['output']>;
  xoviCredits?: Maybe<Scalars['Int']['output']>;
};

export type CrawlTimestampStepType = Node & {
  __typename?: 'CrawlTimestampStepType';
  crawlRunId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  finishTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  latestRetryTime?: Maybe<Scalars['DateTime']['output']>;
  noOfAttempts?: Maybe<Scalars['Int']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stepName?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CrawlerFindingTokenConnection = {
  __typename?: 'CrawlerFindingTokenConnection';
  edges: Array<Maybe<CrawlerFindingTokenEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type CrawlerFindingTokenEdge = {
  __typename?: 'CrawlerFindingTokenEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CrawlerFindingTokenType>;
};

export type CrawlerFindingTokenType = {
  __typename?: 'CrawlerFindingTokenType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  genericCompanyAnalysisId?: Maybe<Scalars['Int']['output']>;
  genericCrawlResultId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isImageFinding?: Maybe<Scalars['Boolean']['output']>;
  isTextFinding?: Maybe<Scalars['Boolean']['output']>;
  noOfVotes?: Maybe<Scalars['Int']['output']>;
  tokenizedTitle?: Maybe<Scalars['String']['output']>;
  tokenizedUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  voteDownUrl?: Maybe<Scalars['String']['output']>;
  voteUpUrl?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CrawlerInboxItemType = {
  __typename?: 'CrawlerInboxItemType';
  aiValidationScore?: Maybe<Scalars['Float']['output']>;
  buyAndBuildRelevance?: Maybe<Scalars['Float']['output']>;
  callabilityScore?: Maybe<Scalars['Float']['output']>;
  companyCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  companyValidated?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  crawlCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  crawlResultId?: Maybe<Scalars['Int']['output']>;
  crawlResultValidated?: Maybe<Scalars['Boolean']['output']>;
  crawlRunId?: Maybe<Scalars['Int']['output']>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  customerVertical?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  iabDomainCategory?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isHorizontalSw?: Maybe<Scalars['Boolean']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  manuallyLabeledScore?: Maybe<Scalars['Float']['output']>;
  peOwned?: Maybe<Scalars['Boolean']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  privateOwned?: Maybe<Scalars['Boolean']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  sicCodeCertainty?: Maybe<Scalars['Float']['output']>;
  sicCodeJustification?: Maybe<Scalars['String']['output']>;
  systemType?: Maybe<Scalars['String']['output']>;
  topBidPlatformLogoUrl?: Maybe<Scalars['String']['output']>;
  topBidPlatformName?: Maybe<Scalars['String']['output']>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
  validationLockedAt?: Maybe<Scalars['DateTime']['output']>;
  validationLockedBy?: Maybe<Scalars['Int']['output']>;
  validationNeeded?: Maybe<Scalars['String']['output']>;
};

export type CrawlerOverviewMetrics = {
  __typename?: 'CrawlerOverviewMetrics';
  avgResponseTimeMs?: Maybe<Scalars['Int']['output']>;
  executedCrawls?: Maybe<Scalars['Int']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  skippedCrawls?: Maybe<Scalars['Int']['output']>;
  successCount?: Maybe<Scalars['Int']['output']>;
  successRate?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  totalCrawls?: Maybe<Scalars['Int']['output']>;
  totalRequests?: Maybe<Scalars['Int']['output']>;
  trend?: Maybe<TrendType>;
};

export type CreateBenchmarkBalanceSheet = {
  __typename?: 'CreateBenchmarkBalanceSheet';
  benchmarkingData?: Maybe<BenchmarkBalanceSheetType>;
};

export type CreateBenchmarkCustomersAggregated = {
  __typename?: 'CreateBenchmarkCustomersAggregated';
  benchmarkingData?: Maybe<BenchmarkCustomersAggregatedType>;
};

export type CreateBenchmarkCustomersList = {
  __typename?: 'CreateBenchmarkCustomersList';
  benchmarkingData?: Maybe<BenchmarkCustomersListType>;
};

export type CreateBenchmarkFte = {
  __typename?: 'CreateBenchmarkFTE';
  benchmarkingData?: Maybe<BenchmarkFteType>;
};

export type CreateBenchmarkPl = {
  __typename?: 'CreateBenchmarkPL';
  benchmarkingData?: Maybe<BenchmarkPlType>;
};

export type CreateBenchmarkPricing = {
  __typename?: 'CreateBenchmarkPricing';
  benchmarkingData?: Maybe<BenchmarkPricingType>;
};

export type CreateCertification = {
  __typename?: 'CreateCertification';
  certificationId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateClassificationPattern = {
  __typename?: 'CreateClassificationPattern';
  error?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<ClassificationPatternType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCompanyProduct = {
  __typename?: 'CreateCompanyProduct';
  message?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMeeting = {
  __typename?: 'CreateMeeting';
  error?: Maybe<Scalars['String']['output']>;
  meeting?: Maybe<MeetingType>;
  ok: Scalars['Boolean']['output'];
};

export type CreateQuestionnaireVersion = {
  __typename?: 'CreateQuestionnaireVersion';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  questionnaire?: Maybe<QuestionnaireType>;
};

export type CreateRedBeatSchedule = {
  __typename?: 'CreateRedBeatSchedule';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUpdateCompanyTechUse = {
  __typename?: 'CreateUpdateCompanyTechUse';
  companyId?: Maybe<Scalars['Int']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  findingUrl?: Maybe<Scalars['String']['output']>;
  genericCompanyTechUseId?: Maybe<Scalars['Int']['output']>;
  markedAsFalsePositive?: Maybe<Scalars['Boolean']['output']>;
  stackshareToolId?: Maybe<Scalars['Int']['output']>;
};

export type CreateUpdateGenericShareholder = {
  __typename?: 'CreateUpdateGenericShareholder';
  dbId?: Maybe<Scalars['Int']['output']>;
  genericCompanyId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  typeOfInvestor?: Maybe<Scalars['String']['output']>;
  yearBornOrFounded?: Maybe<Scalars['Int']['output']>;
};

export type CreateUpdateGenericShareholding = {
  __typename?: 'CreateUpdateGenericShareholding';
  dbId?: Maybe<Scalars['Int']['output']>;
  genericCompanyId?: Maybe<Scalars['Int']['output']>;
  genericShareholderId?: Maybe<Scalars['Int']['output']>;
  holding?: Maybe<Scalars['Float']['output']>;
  holdingCount?: Maybe<Scalars['Int']['output']>;
};

export type CreateUpdateKlazifyCategory = {
  __typename?: 'CreateUpdateKlazifyCategory';
  dbId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subCategory1?: Maybe<Scalars['String']['output']>;
  subCategory2?: Maybe<Scalars['String']['output']>;
  subCategory3?: Maybe<Scalars['String']['output']>;
  subCategory4?: Maybe<Scalars['String']['output']>;
};

export type CreateUpdateXoviKeyword = {
  __typename?: 'CreateUpdateXoviKeyword';
  change?: Maybe<Scalars['Int']['output']>;
  competitorDensity?: Maybe<Scalars['Int']['output']>;
  cpc?: Maybe<Scalars['Float']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  markedAsIrrelevant?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  searchEngine?: Maybe<Scalars['String']['output']>;
  sevo?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateXoviKeywords = {
  __typename?: 'CreateXoviKeywords';
  genericCrawlResultId?: Maybe<Scalars['Int']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
};

export type CustomerGrowthRateRawConnection = {
  __typename?: 'CustomerGrowthRateRawConnection';
  edges: Array<Maybe<CustomerGrowthRateRawEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type CustomerGrowthRateRawEdge = {
  __typename?: 'CustomerGrowthRateRawEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CustomerGrowthRateRawType>;
};

export type CustomerGrowthRateRawType = Node & {
  __typename?: 'CustomerGrowthRateRawType';
  adjustedMedianGrowth?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  ebitdaAssets?: Maybe<Scalars['Float']['output']>;
  ebitdaSales?: Maybe<Scalars['Float']['output']>;
  evAssets?: Maybe<Scalars['Float']['output']>;
  evEbitda?: Maybe<Scalars['Float']['output']>;
  genericCompanyId?: Maybe<Scalars['Int']['output']>;
  iabDomainCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  oneYearSalesGrowth?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sampleSize?: Maybe<Scalars['Int']['output']>;
  sic?: Maybe<Scalars['Int']['output']>;
  sicDesc?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
  zScore?: Maybe<Scalars['Float']['output']>;
};

export type CustomerGrowthRateType = Node & {
  __typename?: 'CustomerGrowthRateType';
  adjustedMedianGrowth?: Maybe<Scalars['Float']['output']>;
  iabDomainCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sampleSize?: Maybe<Scalars['Int']['output']>;
  sicDesc?: Maybe<Scalars['String']['output']>;
};

export type CustomerIndustrySicCodeConnection = {
  __typename?: 'CustomerIndustrySicCodeConnection';
  edges: Array<Maybe<CustomerIndustrySicCodeEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type CustomerIndustrySicCodeEdge = {
  __typename?: 'CustomerIndustrySicCodeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CustomerIndustrySicCodeSqlType>;
};

export type CustomerIndustrySicCodeSqlType = Node & {
  __typename?: 'CustomerIndustrySicCodeSQLType';
  active?: Maybe<Scalars['Boolean']['output']>;
  arr?: Maybe<Scalars['Int']['output']>;
  computedCustomerIndustry?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<CompanyType>;
  customerReferenceName?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  extractionConfidence?: Maybe<Scalars['Float']['output']>;
  extractionMethod?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDdDatapoint?: Maybe<Scalars['Boolean']['output']>;
  lossReason?: Maybe<Scalars['String']['output']>;
  lostYear?: Maybe<Scalars['Int']['output']>;
  markedAsDeleted?: Maybe<Scalars['Boolean']['output']>;
  markedAsIrrelevant?: Maybe<Scalars['Boolean']['output']>;
  nps?: Maybe<Scalars['Int']['output']>;
  referenceCompanyId?: Maybe<Scalars['Int']['output']>;
  referencedAt?: Maybe<Scalars['String']['output']>;
  revenueYearOne?: Maybe<Scalars['Int']['output']>;
  revenueYearTwo?: Maybe<Scalars['Int']['output']>;
  shareOfRevenue?: Maybe<Scalars['Float']['output']>;
  sicCode?: Maybe<SicCodeType>;
  softwareCompanyId?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Scalars['Int']['output']>;
  wonYear?: Maybe<Scalars['Int']['output']>;
};

export type CustomerReferenceRawType = Node & {
  __typename?: 'CustomerReferenceRawType';
  IAB1?: Maybe<Scalars['String']['output']>;
  IAB2?: Maybe<Scalars['String']['output']>;
  IAB3?: Maybe<Scalars['String']['output']>;
  ISDd?: Maybe<Scalars['Boolean']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  arr?: Maybe<Scalars['Int']['output']>;
  computedCustomerIndustry?: Maybe<Scalars['String']['output']>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  customerReferenceName?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  extractionConfidence?: Maybe<Scalars['Float']['output']>;
  extractionMethod?: Maybe<Scalars['String']['output']>;
  findingUrl?: Maybe<Scalars['String']['output']>;
  genericCustomer?: Maybe<Scalars['Boolean']['output']>;
  genericCustomerReferenceId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isDdDatapoint?: Maybe<Scalars['Boolean']['output']>;
  lossReason?: Maybe<Scalars['String']['output']>;
  lostYear?: Maybe<Scalars['Int']['output']>;
  markedAsDeleted?: Maybe<Scalars['Boolean']['output']>;
  markedAsIrrelevant?: Maybe<Scalars['Boolean']['output']>;
  nps?: Maybe<Scalars['Int']['output']>;
  referenceCompanyId?: Maybe<Scalars['Int']['output']>;
  referencedAt?: Maybe<Scalars['String']['output']>;
  revenueYearOne?: Maybe<Scalars['Int']['output']>;
  revenueYearTwo?: Maybe<Scalars['Int']['output']>;
  rn?: Maybe<Scalars['Int']['output']>;
  shareOfRevenue?: Maybe<Scalars['Float']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  softwareCompanyId?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Scalars['Int']['output']>;
  wonYear?: Maybe<Scalars['Int']['output']>;
};

export type CustomerReferenceRawTypeConnection = {
  __typename?: 'CustomerReferenceRawTypeConnection';
  edges: Array<Maybe<CustomerReferenceRawTypeEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type CustomerReferenceRawTypeEdge = {
  __typename?: 'CustomerReferenceRawTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CustomerReferenceRawType>;
};

export type CustomerSegment = {
  __typename?: 'CustomerSegment';
  customerDomain?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerSegment?: Maybe<Scalars['String']['output']>;
  customerSegmentCertainty?: Maybe<Scalars['String']['output']>;
  customerSegmentDescription?: Maybe<Scalars['String']['output']>;
  customerSegmentKeyword?: Maybe<Scalars['String']['output']>;
  klazifyCategory?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  softwareDomain?: Maybe<Scalars['String']['output']>;
  softwareId?: Maybe<Scalars['Int']['output']>;
};

export type CustomerSegmentInput = {
  baysianPrior?: InputMaybe<Scalars['Float']['input']>;
  bidGroupCompanyId: Scalars['Int']['input'];
  definitionUrl?: InputMaybe<Scalars['String']['input']>;
  keyword1: Scalars['String']['input'];
  keyword2?: InputMaybe<Scalars['String']['input']>;
  keyword3?: InputMaybe<Scalars['String']['input']>;
  keyword4?: InputMaybe<Scalars['String']['input']>;
  keyword5?: InputMaybe<Scalars['String']['input']>;
  parentSegmentId?: InputMaybe<Scalars['String']['input']>;
  segmentDescription: Scalars['String']['input'];
  segmentName: Scalars['String']['input'];
};

export type CustomerSegmentType = {
  __typename?: 'CustomerSegmentType';
  baysianPrior?: Maybe<Scalars['Float']['output']>;
  bidGroupCompanyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  definitionUrl?: Maybe<Scalars['String']['output']>;
  googleTermId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  keyword1?: Maybe<Scalars['String']['output']>;
  keyword2?: Maybe<Scalars['String']['output']>;
  keyword3?: Maybe<Scalars['String']['output']>;
  keyword4?: Maybe<Scalars['String']['output']>;
  keyword5?: Maybe<Scalars['String']['output']>;
  parentSegment?: Maybe<CustomerSegmentType>;
  segmentDescription?: Maybe<Scalars['String']['output']>;
  segmentDescriptionEmbedding?: Maybe<Scalars['JSONString']['output']>;
  segmentDescriptionEmbeddingV2?: Maybe<Scalars['JSONString']['output']>;
  segmentName?: Maybe<Scalars['String']['output']>;
  segmentPriorityWeight?: Maybe<Scalars['Float']['output']>;
  segmentSimilarityWeight?: Maybe<Scalars['Float']['output']>;
  subsegmentOf?: Maybe<Scalars['Int']['output']>;
  subsegments?: Maybe<Array<Maybe<CustomerSegmentType>>>;
};

export type CustomerSegmentationType = {
  __typename?: 'CustomerSegmentationType';
  companyDomain?: Maybe<Scalars['String']['output']>;
  companyFte?: Maybe<Scalars['Int']['output']>;
  companyFteLowerBound?: Maybe<Scalars['Int']['output']>;
  companyFteUpperBound?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  isLlmHit?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  segmentId?: Maybe<Scalars['Int']['output']>;
  segmentName?: Maybe<Scalars['String']['output']>;
};

export type DataCoverageType = {
  __typename?: 'DataCoverageType';
  apolloCount: Scalars['Int']['output'];
  coverageRate: Scalars['Float']['output'];
  existingCount: Scalars['Int']['output'];
  firecrawlCount: Scalars['Int']['output'];
  totalFound: Scalars['Int']['output'];
};

export type DbIdPageInfo = {
  __typename?: 'DbIdPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  endId?: Maybe<Scalars['Int']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
  startId?: Maybe<Scalars['Int']['output']>;
};

export type DealAssessmentFileType = {
  __typename?: 'DealAssessmentFileType';
  dateOfFile?: Maybe<Scalars['DateTime']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  generationTriggered?: Maybe<Scalars['Boolean']['output']>;
  noDataUploaded?: Maybe<Scalars['Boolean']['output']>;
  previousGenerationStillRunning?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<DealAssessmentProgressType>;
};

export type DealAssessmentProgressType = {
  __typename?: 'DealAssessmentProgressType';
  secondsSinceLastUpdate?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type DeleteCertification = {
  __typename?: 'DeleteCertification';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteClassificationPattern = {
  __typename?: 'DeleteClassificationPattern';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCompanyProduct = {
  __typename?: 'DeleteCompanyProduct';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCompanyTechUse = {
  __typename?: 'DeleteCompanyTechUse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCrawlQueueEntries = {
  __typename?: 'DeleteCrawlQueueEntries';
  deletedCount?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomerReference = {
  __typename?: 'DeleteCustomerReference';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomerSegmentMutation = {
  __typename?: 'DeleteCustomerSegmentMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteGenericShareholder = {
  __typename?: 'DeleteGenericShareholder';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteGenericShareholding = {
  __typename?: 'DeleteGenericShareholding';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePdfDocumentAnnotation = {
  __typename?: 'DeletePDFDocumentAnnotation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProbationaryPattern = {
  __typename?: 'DeleteProbationaryPattern';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRedBeatSchedule = {
  __typename?: 'DeleteRedBeatSchedule';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSelectedCompanyTechUse = {
  __typename?: 'DeleteSelectedCompanyTechUse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSoftwareCategoryAiScore = {
  __typename?: 'DeleteSoftwareCategoryAIScore';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DomainHistoryType = {
  __typename?: 'DomainHistoryType';
  crawlHistory?: Maybe<Array<Maybe<CrawlHistoryRecordType>>>;
  currentReputation?: Maybe<DomainReputationType>;
  domain?: Maybe<Scalars['String']['output']>;
  totalCrawls?: Maybe<Scalars['Int']['output']>;
};

export type DomainPerformanceType = {
  __typename?: 'DomainPerformanceType';
  avgResponseTimeMs?: Maybe<Scalars['Int']['output']>;
  crawlCount?: Maybe<Scalars['Int']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  executedCount?: Maybe<Scalars['Int']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  isAllowlisted?: Maybe<Scalars['Boolean']['output']>;
  isBlocklisted?: Maybe<Scalars['Boolean']['output']>;
  lastCrawl?: Maybe<Scalars['String']['output']>;
  reputationCategory?: Maybe<Scalars['String']['output']>;
  reputationScore?: Maybe<Scalars['Int']['output']>;
  successCount?: Maybe<Scalars['Int']['output']>;
  successRate?: Maybe<Scalars['Float']['output']>;
  totalRequests?: Maybe<Scalars['Int']['output']>;
};

export type DomainReputationType = {
  __typename?: 'DomainReputationType';
  avgResponseTime?: Maybe<Scalars['Int']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  isAllowlisted?: Maybe<Scalars['Boolean']['output']>;
  isBlocklisted?: Maybe<Scalars['Boolean']['output']>;
  reputationCategory?: Maybe<Scalars['String']['output']>;
  reputationScore?: Maybe<Scalars['Int']['output']>;
  successCount?: Maybe<Scalars['Int']['output']>;
  successRate?: Maybe<Scalars['Float']['output']>;
  totalRequests?: Maybe<Scalars['Int']['output']>;
};

export type DomainStatistics = {
  __typename?: 'DomainStatistics';
  failed?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  successRate?: Maybe<Scalars['Float']['output']>;
  successful?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DownvoteFindingsToken = {
  __typename?: 'DownvoteFindingsToken';
  ok?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<FindingsTokenType>;
};

export type DynamoDbEventType = {
  __typename?: 'DynamoDBEventType';
  companyDomain?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type EditCompany = {
  __typename?: 'EditCompany';
  benchmarkingIndex?: Maybe<Scalars['Int']['output']>;
  buyAndBuildFocus?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyDescription?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Scalars['String']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  foundingYear?: Maybe<Scalars['Int']['output']>;
  hrbNumber?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type EditCustomerReference = {
  __typename?: 'EditCustomerReference';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EmployeeStaticsRawConnection = {
  __typename?: 'EmployeeStaticsRawConnection';
  edges: Array<Maybe<EmployeeStaticsRawEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type EmployeeStaticsRawEdge = {
  __typename?: 'EmployeeStaticsRawEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<EmployeeStaticsRawType>;
};

export type EmployeeStaticsRawType = Node & {
  __typename?: 'EmployeeStaticsRawType';
  averageTotalExperienceYears?: Maybe<Scalars['Float']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  employeeId?: Maybe<Scalars['Int']['output']>;
  employmentDuration?: Maybe<Scalars['Int']['output']>;
  employmentEnd?: Maybe<Scalars['DateTime']['output']>;
  employmentStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  medianEmploymentMonths?: Maybe<Scalars['Float']['output']>;
  medianPreviousEmployers?: Maybe<Scalars['Float']['output']>;
  medianTotalEmploymentMonths?: Maybe<Scalars['Float']['output']>;
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  teamQualityPercentage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
};

export type EnrichCompanyContactInput = {
  asyncMode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['Int']['input'];
  enrichmentMaxAgeDays?: InputMaybe<Scalars['Int']['input']>;
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  maxPageAgeDays?: InputMaybe<Scalars['Int']['input']>;
  skipIfRecentEnrichment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrichCompanyContactMutation = {
  __typename?: 'EnrichCompanyContactMutation';
  enrichmentResult?: Maybe<EnrichmentResultType>;
  message: Scalars['String']['output'];
  operationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
};

export type EnrichmentDataPointType = {
  __typename?: 'EnrichmentDataPointType';
  avgCacheRate: Scalars['Float']['output'];
  avgTimeMs: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type EnrichmentJobProgressType = {
  __typename?: 'EnrichmentJobProgressType';
  message?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
};

export type EnrichmentJobStatusType = {
  __typename?: 'EnrichmentJobStatusType';
  error?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  progress?: Maybe<EnrichmentJobProgressType>;
  result?: Maybe<Scalars['JSONString']['output']>;
  status: Scalars['String']['output'];
};

export type EnrichmentMetadataType = {
  __typename?: 'EnrichmentMetadataType';
  enrichmentTimestamp?: Maybe<Scalars['DateTime']['output']>;
  extractionMethod?: Maybe<Scalars['String']['output']>;
  hunterCreditsUsed?: Maybe<Scalars['Float']['output']>;
  hunterUsed?: Maybe<Scalars['Boolean']['output']>;
  modelUsed?: Maybe<Scalars['String']['output']>;
  pagesCached?: Maybe<Scalars['Int']['output']>;
  pagesScraped?: Maybe<Scalars['Int']['output']>;
  processingTimeSeconds?: Maybe<Scalars['Float']['output']>;
};

export type EnrichmentResultType = {
  __typename?: 'EnrichmentResultType';
  companyId: Scalars['Int']['output'];
  enriched: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  extractedData?: Maybe<ExtractedDataType>;
  metadata?: Maybe<EnrichmentMetadataType>;
  reason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
};

export type EnrichmentStatusType = {
  __typename?: 'EnrichmentStatusType';
  companyId: Scalars['Int']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  enrichmentAgeDays?: Maybe<Scalars['Int']['output']>;
  hasEnrichment: Scalars['Boolean']['output'];
  isRecentEnrichment: Scalars['Boolean']['output'];
  lastEnrichmentDate?: Maybe<Scalars['DateTime']['output']>;
  needsEnrichment: Scalars['Boolean']['output'];
};

export type EnrichmentTimeSeriesType = {
  __typename?: 'EnrichmentTimeSeriesType';
  dataPoints?: Maybe<Array<Maybe<EnrichmentDataPointType>>>;
  timeRange: Scalars['String']['output'];
};

export type EnvironmentConfiguration = {
  __typename?: 'EnvironmentConfiguration';
  alembicRevision?: Maybe<Scalars['String']['output']>;
  dopplerConfig?: Maybe<Scalars['String']['output']>;
  dopplerProject?: Maybe<Scalars['String']['output']>;
  gitBranch?: Maybe<Scalars['String']['output']>;
  gitCommit?: Maybe<Scalars['String']['output']>;
  latestMigrationVersion?: Maybe<Scalars['String']['output']>;
  stepsBehindLatestMigration?: Maybe<Scalars['Int']['output']>;
};

export type ErrorBreakdownType = {
  __typename?: 'ErrorBreakdownType';
  categories?: Maybe<ErrorCategoryType>;
  errorRate?: Maybe<Scalars['Float']['output']>;
  totalFailures?: Maybe<Scalars['Int']['output']>;
};

export type ErrorCategoryType = {
  __typename?: 'ErrorCategoryType';
  blocked?: Maybe<Scalars['Int']['output']>;
  fairReputation?: Maybe<Scalars['Int']['output']>;
  poorReputation?: Maybe<Scalars['Int']['output']>;
};

export type EstimateCompanyGDriveConfig = {
  __typename?: 'EstimateCompanyGDriveConfig';
  estimate?: Maybe<GDriveConfigEstimateType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EvaluateSignals = {
  __typename?: 'EvaluateSignals';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<SignalEvaluationResultType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EvidenceSourceType = {
  __typename?: 'EvidenceSourceType';
  relevanceScore?: Maybe<Scalars['Float']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type EvidenceSourceV2Type = {
  __typename?: 'EvidenceSourceV2Type';
  metadata?: Maybe<Scalars['JSONString']['output']>;
  relevanceScore?: Maybe<Scalars['Float']['output']>;
  retrievedAt?: Maybe<Scalars['DateTime']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExcelRowInput = {
  cells: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ExchangeRateHistoryType = Node & {
  __typename?: 'ExchangeRateHistoryType';
  currencyFrom: Scalars['String']['output'];
  currencyTo: Scalars['String']['output'];
  date: Scalars['String']['output'];
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  rate: Scalars['Float']['output'];
};

export type ExhibitV2Type = {
  __typename?: 'ExhibitV2Type';
  claimIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data: Scalars['JSONString']['output'];
  description?: Maybe<Scalars['String']['output']>;
  evidenceSourceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exhibitId: Scalars['ID']['output'];
  exhibitType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ExistingPatternUsageType = {
  __typename?: 'ExistingPatternUsageType';
  confidence?: Maybe<Scalars['Float']['output']>;
  currentWeight?: Maybe<Scalars['Float']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  patternId?: Maybe<Scalars['Int']['output']>;
  patternText?: Maybe<Scalars['String']['output']>;
  suggestedWeight?: Maybe<Scalars['Float']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type ExtractedDataType = {
  __typename?: 'ExtractedDataType';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactEmailConfidence?: Maybe<Scalars['Float']['output']>;
  contactEmailSource?: Maybe<Scalars['String']['output']>;
  managingDirector?: Maybe<Scalars['String']['output']>;
  managingDirectorConfidence?: Maybe<Scalars['Float']['output']>;
  managingDirectorSource?: Maybe<Scalars['String']['output']>;
};

export type FinancialDataAvailabilityType = {
  __typename?: 'FinancialDataAvailabilityType';
  availablePeriods?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  hasBalanceSheetData?: Maybe<Scalars['Boolean']['output']>;
  hasPLData?: Maybe<Scalars['Boolean']['output']>;
  latestDataDate?: Maybe<Scalars['String']['output']>;
};

export type FinancialForecastOutputType = {
  __typename?: 'FinancialForecastOutputType';
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  ebitMarginForecastChange?: Maybe<Scalars['Float']['output']>;
  evModelAppreciation5y?: Maybe<Scalars['Float']['output']>;
  evModelCagr5y?: Maybe<Scalars['Float']['output']>;
  lastCalculated?: Maybe<Scalars['DateTime']['output']>;
};

export type FinancialForecastParamsType = {
  __typename?: 'FinancialForecastParamsType';
  params?: Maybe<Scalars['JSONString']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type FindingStatisticsType = {
  __typename?: 'FindingStatisticsType';
  findingCounts?: Maybe<Scalars['JSONString']['output']>;
  findingRates?: Maybe<Scalars['JSONString']['output']>;
  languageDistribution?: Maybe<Scalars['JSONString']['output']>;
  linkFollowingStats?: Maybe<Scalars['JSONString']['output']>;
  totalExecutedCrawls?: Maybe<Scalars['Int']['output']>;
};

export type FindingsTokenType = Node & {
  __typename?: 'FindingsTokenType';
  id: Scalars['ID']['output'];
};

export type FindingsType = {
  __typename?: 'FindingsType';
  customerReferences?: Maybe<Scalars['Int']['output']>;
  jobPostings?: Maybe<Scalars['Int']['output']>;
};

export type FinishCompanyValidation = {
  __typename?: 'FinishCompanyValidation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FinishCrawlResultValidation = {
  __typename?: 'FinishCrawlResultValidation';
  batchValidatedCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FteHistoryEntryType = {
  __typename?: 'FteHistoryEntryType';
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isConfirmedChange?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  observedAt?: Maybe<Scalars['Date']['output']>;
  sourceCrawlResultId?: Maybe<Scalars['Int']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
};

export type G2ProductAlternativeType = {
  __typename?: 'G2ProductAlternativeType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  g2ProductId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  product?: Maybe<G2ProductType>;
};

export type G2ProductFeatureType = {
  __typename?: 'G2ProductFeatureType';
  category: Scalars['String']['output'];
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featureName: Scalars['String']['output'];
  g2ProductId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  percent?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<G2ProductType>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
};

export type G2ProductPricingType = {
  __typename?: 'G2ProductPricingType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  g2ProductId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  package?: Maybe<Scalars['String']['output']>;
  price: Scalars['String']['output'];
  priceInfo?: Maybe<Scalars['String']['output']>;
  product?: Maybe<G2ProductType>;
};

export type G2ProductReviewType = {
  __typename?: 'G2ProductReviewType';
  author?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  g2ProductId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['String']['output']>;
  product?: Maybe<G2ProductType>;
  reviewId?: Maybe<Scalars['String']['output']>;
  reviewUrl?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Scalars['JSONString']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type G2ProductType = {
  __typename?: 'G2ProductType';
  alternatives?: Maybe<Array<Maybe<G2ProductAlternativeType>>>;
  badge?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Scalars['JSONString']['output']>;
  claimed?: Maybe<Scalars['Boolean']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discussionsCount?: Maybe<Scalars['Int']['output']>;
  features?: Maybe<Array<Maybe<G2ProductFeatureType>>>;
  fullPricingPage?: Maybe<Scalars['String']['output']>;
  genericCompanyId?: Maybe<Scalars['Int']['output']>;
  headquarters?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languagesSupported?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  mainCategory?: Maybe<Scalars['String']['output']>;
  mainSubject?: Maybe<Scalars['String']['output']>;
  numericalId?: Maybe<Scalars['String']['output']>;
  officialDownloads?: Maybe<Scalars['JSONString']['output']>;
  officialScreenshots?: Maybe<Scalars['JSONString']['output']>;
  officialVideos?: Maybe<Scalars['JSONString']['output']>;
  overview?: Maybe<Scalars['String']['output']>;
  overviewProvidedBy?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<Scalars['String']['output']>;
  positionAgainstCompetitors?: Maybe<Scalars['String']['output']>;
  pricingPackages?: Maybe<Array<Maybe<G2ProductPricingType>>>;
  productId?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  productUrl?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<Maybe<G2ProductReviewType>>>;
  reviewsCount?: Maybe<Scalars['Int']['output']>;
  seller?: Maybe<Scalars['String']['output']>;
  sellerDescription?: Maybe<Scalars['String']['output']>;
  sellerWebsite?: Maybe<Scalars['String']['output']>;
  snapshotId?: Maybe<Scalars['String']['output']>;
  snapshotTimestamp?: Maybe<Scalars['DateTime']['output']>;
  softwareProductId?: Maybe<Scalars['String']['output']>;
  topAlternativesUrl?: Maybe<Scalars['String']['output']>;
  totalRevenue?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  userRatings?: Maybe<Scalars['String']['output']>;
  whatIsDescription?: Maybe<Scalars['String']['output']>;
  yearFounded?: Maybe<Scalars['String']['output']>;
};

export type GDriveConfigEstimateType = {
  __typename?: 'GDriveConfigEstimateType';
  alternatives: Array<Maybe<Scalars['String']['output']>>;
  confidence: Scalars['String']['output'];
  directoryId?: Maybe<Scalars['String']['output']>;
  directoryName: Scalars['String']['output'];
  requiresUserConfirmation: Scalars['Boolean']['output'];
  sharedDriveName: Scalars['String']['output'];
};

export type GDriveSyncStatusType = {
  __typename?: 'GDriveSyncStatusType';
  cooldownEndsAt?: Maybe<Scalars['DateTime']['output']>;
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  lastFileModified?: Maybe<Scalars['DateTime']['output']>;
  lastSyncCompleted?: Maybe<Scalars['DateTime']['output']>;
  lastSyncRequested?: Maybe<Scalars['DateTime']['output']>;
  totalFilesSynced?: Maybe<Scalars['Int']['output']>;
};

export type GatherHandelsregisterApiData = {
  __typename?: 'GatherHandelsregisterAPIData';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateCrawlPlanInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateCrawlPlanMutation = {
  __typename?: 'GenerateCrawlPlanMutation';
  crawlPlan?: Maybe<Scalars['JSONString']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GeneratePatternsFromKeywords = {
  __typename?: 'GeneratePatternsFromKeywords';
  result?: Maybe<PatternGenerationResultType>;
};

export type GenerateVibeCodingIdeas = {
  __typename?: 'GenerateVibeCodingIdeas';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GenericBuyAndBuildRelevanceConnection = {
  __typename?: 'GenericBuyAndBuildRelevanceConnection';
  edges: Array<Maybe<GenericBuyAndBuildRelevanceEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type GenericBuyAndBuildRelevanceEdge = {
  __typename?: 'GenericBuyAndBuildRelevanceEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GenericBuyAndBuildRelevanceSqlType>;
};

export type GenericBuyAndBuildRelevanceSqlType = Node & {
  __typename?: 'GenericBuyAndBuildRelevanceSQLType';
  avgKeywordRelevance?: Maybe<Scalars['Float']['output']>;
  avgSemanticFulltextRelevance?: Maybe<Scalars['Float']['output']>;
  avgSemanticShortRelevance?: Maybe<Scalars['Float']['output']>;
  buyAndBuildNotes?: Maybe<Scalars['String']['output']>;
  buyAndBuildRelevance?: Maybe<Scalars['Float']['output']>;
  company?: Maybe<BabCompanyType>;
  cosineSimilarityBbFocus?: Maybe<Scalars['Float']['output']>;
  cosineSimilarityIndustry?: Maybe<Scalars['Float']['output']>;
  cosineSimilarityLinkedin?: Maybe<Scalars['Float']['output']>;
  cosineSimilaritySoftwareCategory?: Maybe<Scalars['Float']['output']>;
  cosineSimilarityWebsite?: Maybe<Scalars['Float']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  hasSourcescrubTags?: Maybe<Scalars['Boolean']['output']>;
  highestSemanticFulltextRelevance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isShortlisted?: Maybe<Scalars['Boolean']['output']>;
  isShortlistedCompany1?: Maybe<Scalars['Boolean']['output']>;
  isShortlistedCompany2?: Maybe<Scalars['Boolean']['output']>;
  keywordAlternative?: Maybe<Scalars['String']['output']>;
  keywordId?: Maybe<Scalars['Int']['output']>;
  lastPipedrivePushDate?: Maybe<Scalars['DateTime']['output']>;
  manuallyLabeledScore?: Maybe<Scalars['Float']['output']>;
  matchUrl?: Maybe<Scalars['String']['output']>;
  noOfKeywordsFound?: Maybe<Scalars['Int']['output']>;
  noOfOverlappingCustomers?: Maybe<Scalars['Int']['output']>;
  noOfOverlappingSwCategories?: Maybe<Scalars['Int']['output']>;
  noOfSemanticShortHits?: Maybe<Scalars['Int']['output']>;
  noOfSematicFulltextHits?: Maybe<Scalars['Int']['output']>;
  platformIsHorizontal?: Maybe<Scalars['Boolean']['output']>;
  shareOfCustomersServedByOtherCompanies?: Maybe<Scalars['Float']['output']>;
  softwareCompany1Id?: Maybe<Scalars['Int']['output']>;
  softwareCompany2Id?: Maybe<Scalars['Int']['output']>;
  softwareCompany2IsCompetitor?: Maybe<Scalars['Boolean']['output']>;
  softwareCompany2IsNotBuyable?: Maybe<Scalars['Boolean']['output']>;
  targetCompanyIsHorizontal?: Maybe<Scalars['Boolean']['output']>;
  totalNoOfCustomers?: Maybe<Scalars['Int']['output']>;
};

export type GenericCompanyAnalysisConnection = {
  __typename?: 'GenericCompanyAnalysisConnection';
  edges: Array<Maybe<GenericCompanyAnalysisEdge>>;
  pageInfo: PageInfo;
};

export type GenericCompanyAnalysisEdge = {
  __typename?: 'GenericCompanyAnalysisEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GenericCompanyAnalysisSqlType>;
};

export type GenericCompanyAnalysisSqlType = Node & {
  __typename?: 'GenericCompanyAnalysisSQLType';
  company?: Maybe<BuyAndBuildTargetAssessmentType>;
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  ebitda?: Maybe<Scalars['Int']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isItCompany?: Maybe<Scalars['Boolean']['output']>;
  isItCompanyScore?: Maybe<Scalars['Float']['output']>;
  isSaasCompany?: Maybe<Scalars['Boolean']['output']>;
  isSaasScore?: Maybe<Scalars['Float']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareScore?: Maybe<Scalars['Float']['output']>;
  lastSynthesisAt?: Maybe<Scalars['DateTime']['output']>;
  lastSynthesisCrawlResultId?: Maybe<Scalars['Int']['output']>;
  lastSynthesisCrawlType?: Maybe<Scalars['String']['output']>;
  linkedinFte?: Maybe<Scalars['Int']['output']>;
  linkedinLowerFte?: Maybe<Scalars['Int']['output']>;
  linkedinUpperFte?: Maybe<Scalars['Int']['output']>;
  noOfCustomers?: Maybe<Scalars['Int']['output']>;
  noOfUsers?: Maybe<Scalars['Int']['output']>;
  recurringShare?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  sizeJustification?: Maybe<Scalars['String']['output']>;
};

export enum GenericCompanySortEnum {
  AddressAsc = 'address_asc',
  AddressDesc = 'address_desc',
  BenchmarkingIndexAsc = 'benchmarking_index_asc',
  BenchmarkingIndexDesc = 'benchmarking_index_desc',
  CityAsc = 'city_asc',
  CityDesc = 'city_desc',
  ContactEmailAsc = 'contact_email_asc',
  ContactEmailConfidenceAsc = 'contact_email_confidence_asc',
  ContactEmailConfidenceDesc = 'contact_email_confidence_desc',
  ContactEmailDesc = 'contact_email_desc',
  ContactEmailTypeAsc = 'contact_email_type_asc',
  ContactEmailTypeDesc = 'contact_email_type_desc',
  CountryAsc = 'country_asc',
  CountryDesc = 'country_desc',
  CourtAsc = 'court_asc',
  CourtDesc = 'court_desc',
  CrawlUrlAsc = 'crawl_url_asc',
  CrawlUrlDesc = 'crawl_url_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DoNotCrawlAsc = 'do_not_crawl_asc',
  DoNotCrawlDesc = 'do_not_crawl_desc',
  DueDilligenceAsc = 'due_dilligence_asc',
  DueDilligenceDesc = 'due_dilligence_desc',
  EmailPatternAsc = 'email_pattern_asc',
  EmailPatternDesc = 'email_pattern_desc',
  FoundingYearAsc = 'founding_year_asc',
  FoundingYearDesc = 'founding_year_desc',
  GdriveDirectoryIdAsc = 'gdrive_directory_id_asc',
  GdriveDirectoryIdDesc = 'gdrive_directory_id_desc',
  GdriveDirectoryNameAsc = 'gdrive_directory_name_asc',
  GdriveDirectoryNameDesc = 'gdrive_directory_name_desc',
  GdriveSharedDriveIdAsc = 'gdrive_shared_drive_id_asc',
  GdriveSharedDriveIdDesc = 'gdrive_shared_drive_id_desc',
  GdriveSharedDriveNameAsc = 'gdrive_shared_drive_name_asc',
  GdriveSharedDriveNameDesc = 'gdrive_shared_drive_name_desc',
  HasBeenValidatedAsc = 'has_been_validated_asc',
  HasBeenValidatedDesc = 'has_been_validated_desc',
  HrbNumberAsc = 'hrb_number_asc',
  HrbNumberDesc = 'hrb_number_desc',
  IabDomainCategoryAsc = 'iab_domain_category_asc',
  IabDomainCategoryDesc = 'iab_domain_category_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  InitialSourceAsc = 'initial_source_asc',
  InitialSourceDesc = 'initial_source_desc',
  IsBidPortfolioCompanyAsc = 'is_bid_portfolio_company_asc',
  IsBidPortfolioCompanyDesc = 'is_bid_portfolio_company_desc',
  IsEnabledAsc = 'is_enabled_asc',
  IsEnabledDesc = 'is_enabled_desc',
  IsGenericIndustryCompanyAsc = 'is_generic_industry_company_asc',
  IsGenericIndustryCompanyDesc = 'is_generic_industry_company_desc',
  IsHorizontalSoftwareAsc = 'is_horizontal_software_asc',
  IsHorizontalSoftwareDesc = 'is_horizontal_software_desc',
  IsItCompanyCompanyAsc = 'is_it_company_company_asc',
  IsItCompanyCompanyDesc = 'is_it_company_company_desc',
  IsSaasCompanyAsc = 'is_saas_company_asc',
  IsSaasCompanyDesc = 'is_saas_company_desc',
  IsSoftwareCompanyAsc = 'is_software_company_asc',
  IsSoftwareCompanyDesc = 'is_software_company_desc',
  LegalNameAsc = 'legal_name_asc',
  LegalNameDesc = 'legal_name_desc',
  LinkedinUrlAsc = 'linkedin_url_asc',
  LinkedinUrlDesc = 'linkedin_url_desc',
  ManagingDirectorAsc = 'managing_director_asc',
  ManagingDirectorDesc = 'managing_director_desc',
  MergedIntoIdAsc = 'merged_into_id_asc',
  MergedIntoIdDesc = 'merged_into_id_desc',
  NumberOfFailedCrawlsAsc = 'number_of_failed_crawls_asc',
  NumberOfFailedCrawlsDesc = 'number_of_failed_crawls_desc',
  PipedriveIdAsc = 'pipedrive_id_asc',
  PipedriveIdDesc = 'pipedrive_id_desc',
  ShortNameAsc = 'short_name_asc',
  ShortNameDesc = 'short_name_desc',
  SicCodeAsc = 'sic_code_asc',
  SicCodeCertaintyAsc = 'sic_code_certainty_asc',
  SicCodeCertaintyDesc = 'sic_code_certainty_desc',
  SicCodeDesc = 'sic_code_desc',
  SicCodeJustificationAsc = 'sic_code_justification_asc',
  SicCodeJustificationDesc = 'sic_code_justification_desc',
  StreetAsc = 'street_asc',
  StreetDesc = 'street_desc',
  SubsidiaryOfAsc = 'subsidiary_of_asc',
  SubsidiaryOfDesc = 'subsidiary_of_desc',
  UniqueDomainAsc = 'unique_domain_asc',
  UniqueDomainDesc = 'unique_domain_desc',
  ValidationDatetimeAsc = 'validation_datetime_asc',
  ValidationDatetimeDesc = 'validation_datetime_desc',
  ValidationLockedAtAsc = 'validation_locked_at_asc',
  ValidationLockedAtDesc = 'validation_locked_at_desc',
  ValidationLockedByAsc = 'validation_locked_by_asc',
  ValidationLockedByDesc = 'validation_locked_by_desc',
  ValidationUserAsc = 'validation_user_asc',
  ValidationUserDesc = 'validation_user_desc',
  ZipCodeAsc = 'zip_code_asc',
  ZipCodeDesc = 'zip_code_desc'
}

export type GenericCompanyTechUseConnection = {
  __typename?: 'GenericCompanyTechUseConnection';
  edges: Array<Maybe<GenericCompanyTechUseEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type GenericCompanyTechUseEdge = {
  __typename?: 'GenericCompanyTechUseEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TechUseType>;
};

export type GenericCompanyTechUseWithStackshareToolSqlType = Node & {
  __typename?: 'GenericCompanyTechUseWithStackshareToolSQLType';
  breadcrumb?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  findingUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isApiFramework?: Maybe<Scalars['Boolean']['output']>;
  isBackendFramework?: Maybe<Scalars['Boolean']['output']>;
  isFrontendFramework?: Maybe<Scalars['Boolean']['output']>;
  markedAsFalsePositive?: Maybe<Scalars['Boolean']['output']>;
  matchRelevance?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stacksUsed?: Maybe<Scalars['Int']['output']>;
  stackshareTool?: Maybe<ProductTechnologylType>;
  stackshareToolId?: Maybe<Scalars['Int']['output']>;
  votes?: Maybe<Scalars['Int']['output']>;
  yearOfInitialRelease?: Maybe<Scalars['Int']['output']>;
};

export type GenericCompanyTechUseWithStackshareToolSqlTypeConnection = {
  __typename?: 'GenericCompanyTechUseWithStackshareToolSQLTypeConnection';
  edges: Array<Maybe<GenericCompanyTechUseWithStackshareToolSqlTypeEdge>>;
  pageInfo: PageInfo;
};

export type GenericCompanyTechUseWithStackshareToolSqlTypeEdge = {
  __typename?: 'GenericCompanyTechUseWithStackshareToolSQLTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GenericCompanyTechUseWithStackshareToolSqlType>;
};

export type GenericCrawlResultConnection = {
  __typename?: 'GenericCrawlResultConnection';
  edges: Array<Maybe<GenericCrawlResultEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type GenericCrawlResultEdge = {
  __typename?: 'GenericCrawlResultEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GenericCrawlResultSqlType>;
};

export type GenericCrawlResultSqlType = Node & {
  __typename?: 'GenericCrawlResultSQLType';
  classificationSessionId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<BuyAndBuildTargetAssessmentType>;
  companyId?: Maybe<Scalars['Int']['output']>;
  crawlFinishedTime?: Maybe<Scalars['DateTime']['output']>;
  crawlResultObject?: Maybe<Scalars['JSONString']['output']>;
  crawlRunId?: Maybe<Scalars['Int']['output']>;
  crawlType: Scalars['String']['output'];
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  employeeEmailCallbackHasHappened?: Maybe<Scalars['Boolean']['output']>;
  expensiveAnalysisExecutionTime?: Maybe<Scalars['DateTime']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  fteAnalysisObject?: Maybe<Scalars['JSONString']['output']>;
  hadMlModelApplied?: Maybe<Scalars['Boolean']['output']>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  hasCompanyBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  linkedinFte?: Maybe<Scalars['Int']['output']>;
  linkedinLowerFte?: Maybe<Scalars['Int']['output']>;
  linkedinUpperFte?: Maybe<Scalars['Int']['output']>;
  listOfEmails?: Maybe<Scalars['JSONString']['output']>;
  listOfMds?: Maybe<Scalars['JSONString']['output']>;
  mongoEmbeddingCreationTime?: Maybe<Scalars['DateTime']['output']>;
  sizeJustification?: Maybe<Scalars['String']['output']>;
  socialResultObject?: Maybe<Scalars['JSONString']['output']>;
  softwareCategory?: Maybe<SoftwareCategorySqlType>;
  softwareCategoryCertainty?: Maybe<Scalars['Float']['output']>;
  softwareCategoryId?: Maybe<Scalars['Int']['output']>;
  specialXoviKeywords?: Maybe<KeywordForCompanySqlTypeConnection>;
  status: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  xoviKeywords?: Maybe<XoviKeywordConnection>;
};


export type GenericCrawlResultSqlTypeSpecialXoviKeywordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GenericCrawlResultSqlTypeXoviKeywordsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  cpc?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPlaceholderForEmptyXoviResponse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  markedAsIrrelevant?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<XoviKeywordOrderEnum>>>;
};

export enum GenericCrawlResultSortEnum {
  ClassificationSessionIdAsc = 'classification_session_id_asc',
  ClassificationSessionIdDesc = 'classification_session_id_desc',
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  CrawlFinishedTimeAsc = 'crawl_finished_time_asc',
  CrawlFinishedTimeDesc = 'crawl_finished_time_desc',
  CrawlResultObjectAsc = 'crawl_result_object_asc',
  CrawlResultObjectDesc = 'crawl_result_object_desc',
  CrawlRunIdAsc = 'crawl_run_id_asc',
  CrawlRunIdDesc = 'crawl_run_id_desc',
  CrawlTypeAsc = 'crawl_type_asc',
  CrawlTypeDesc = 'crawl_type_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  EmployeeEmailCallbackHasHappenedAsc = 'employee_email_callback_has_happened_asc',
  EmployeeEmailCallbackHasHappenedDesc = 'employee_email_callback_has_happened_desc',
  ExpensiveAnalysisExecutionTimeAsc = 'expensive_analysis_execution_time_asc',
  ExpensiveAnalysisExecutionTimeDesc = 'expensive_analysis_execution_time_desc',
  FteAnalysisObjectAsc = 'fte_analysis_object_asc',
  FteAnalysisObjectDesc = 'fte_analysis_object_desc',
  FteAsc = 'fte_asc',
  FteDesc = 'fte_desc',
  HadMlModelAppliedAsc = 'had_ml_model_applied_asc',
  HadMlModelAppliedDesc = 'had_ml_model_applied_desc',
  HasBeenValidatedAsc = 'has_been_validated_asc',
  HasBeenValidatedDesc = 'has_been_validated_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsRelevantAsc = 'is_relevant_asc',
  IsRelevantDesc = 'is_relevant_desc',
  IsSoftwareCompanyAsc = 'is_software_company_asc',
  IsSoftwareCompanyDesc = 'is_software_company_desc',
  LinkedinFteAsc = 'linkedin_fte_asc',
  LinkedinFteDesc = 'linkedin_fte_desc',
  LinkedinLowerFteAsc = 'linkedin_lower_fte_asc',
  LinkedinLowerFteDesc = 'linkedin_lower_fte_desc',
  LinkedinUpperFteAsc = 'linkedin_upper_fte_asc',
  LinkedinUpperFteDesc = 'linkedin_upper_fte_desc',
  ListOfEmailsAsc = 'list_of_emails_asc',
  ListOfEmailsDesc = 'list_of_emails_desc',
  ListOfMdsAsc = 'list_of_mds_asc',
  ListOfMdsDesc = 'list_of_mds_desc',
  MongoEmbeddingCreationTimeAsc = 'mongo_embedding_creation_time_asc',
  MongoEmbeddingCreationTimeDesc = 'mongo_embedding_creation_time_desc',
  SizeJustificationAsc = 'size_justification_asc',
  SizeJustificationDesc = 'size_justification_desc',
  SocialResultObjectAsc = 'social_result_object_asc',
  SocialResultObjectDesc = 'social_result_object_desc',
  SoftwareCategoryCertaintyAsc = 'software_category_certainty_asc',
  SoftwareCategoryCertaintyDesc = 'software_category_certainty_desc',
  SoftwareCategoryIdAsc = 'software_category_id_asc',
  SoftwareCategoryIdDesc = 'software_category_id_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  UrlAsc = 'url_asc',
  UrlDesc = 'url_desc',
  WeightAsc = 'weight_asc',
  WeightDesc = 'weight_desc'
}

export enum GenericCustomerReferenceSortEnum {
  ActiveAsc = 'active_asc',
  ActiveDesc = 'active_desc',
  ArrAsc = 'arr_asc',
  ArrDesc = 'arr_desc',
  ComputedCustomerIndustryAsc = 'computed_customer_industry_asc',
  ComputedCustomerIndustryDesc = 'computed_customer_industry_desc',
  CustomerReferenceNameAsc = 'customer_reference_name_asc',
  CustomerReferenceNameDesc = 'customer_reference_name_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  ExtractionConfidenceAsc = 'extraction_confidence_asc',
  ExtractionConfidenceDesc = 'extraction_confidence_desc',
  ExtractionMethodAsc = 'extraction_method_asc',
  ExtractionMethodDesc = 'extraction_method_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsDdDatapointAsc = 'is_dd_datapoint_asc',
  IsDdDatapointDesc = 'is_dd_datapoint_desc',
  LossReasonAsc = 'loss_reason_asc',
  LossReasonDesc = 'loss_reason_desc',
  LostYearAsc = 'lost_year_asc',
  LostYearDesc = 'lost_year_desc',
  MarkedAsDeletedAsc = 'marked_as_deleted_asc',
  MarkedAsDeletedDesc = 'marked_as_deleted_desc',
  MarkedAsIrrelevantAsc = 'marked_as_irrelevant_asc',
  MarkedAsIrrelevantDesc = 'marked_as_irrelevant_desc',
  NpsAsc = 'nps_asc',
  NpsDesc = 'nps_desc',
  ReferenceCompanyIdAsc = 'reference_company_id_asc',
  ReferenceCompanyIdDesc = 'reference_company_id_desc',
  ReferencedAtAsc = 'referenced_at_asc',
  ReferencedAtDesc = 'referenced_at_desc',
  RevenueYearOneAsc = 'revenue_year_one_asc',
  RevenueYearOneDesc = 'revenue_year_one_desc',
  RevenueYearTwoAsc = 'revenue_year_two_asc',
  RevenueYearTwoDesc = 'revenue_year_two_desc',
  ShareOfRevenueAsc = 'share_of_revenue_asc',
  ShareOfRevenueDesc = 'share_of_revenue_desc',
  SoftwareCompanyIdAsc = 'software_company_id_asc',
  SoftwareCompanyIdDesc = 'software_company_id_desc',
  UsersAsc = 'users_asc',
  UsersDesc = 'users_desc',
  WonYearAsc = 'won_year_asc',
  WonYearDesc = 'won_year_desc'
}

export enum GenericEmploymentSortEnum {
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  EmployeeIdAsc = 'employee_id_asc',
  EmployeeIdDesc = 'employee_id_desc',
  EmploymentDurationAsc = 'employment_duration_asc',
  EmploymentDurationDesc = 'employment_duration_desc',
  EmploymentEndAsc = 'employment_end_asc',
  EmploymentEndDesc = 'employment_end_desc',
  EmploymentStartAsc = 'employment_start_asc',
  EmploymentStartDesc = 'employment_start_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  TitleAsc = 'title_asc',
  TitleDesc = 'title_desc'
}

export enum GenericLanguageModelFindingsSortEnum {
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DetectedLanguageAsc = 'detected_language_asc',
  DetectedLanguageDesc = 'detected_language_desc',
  FindingsUrlAsc = 'findings_url_asc',
  FindingsUrlDesc = 'findings_url_desc',
  HasBeenManuallyCheckedAsc = 'has_been_manually_checked_asc',
  HasBeenManuallyCheckedDesc = 'has_been_manually_checked_desc',
  HasBeenOverwrittenAsc = 'has_been_overwritten_asc',
  HasBeenOverwrittenDesc = 'has_been_overwritten_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  OpenAiVoteAsc = 'open_ai_vote_asc',
  OpenAiVoteDesc = 'open_ai_vote_desc'
}

export type GenericShareHolderConnection = {
  __typename?: 'GenericShareHolderConnection';
  edges: Array<Maybe<GenericShareHolderEdge>>;
  pageInfo: PageInfo;
};

export type GenericShareHolderEdge = {
  __typename?: 'GenericShareHolderEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GenericShareHolderType>;
};

export type GenericShareHolderType = Node & {
  __typename?: 'GenericShareHolderType';
  company?: Maybe<BuyAndBuildTargetAssessmentType>;
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  genericShareholdings?: Maybe<GenericShareholdingSqlTypeConnection>;
  holding?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isNaturalPerson?: Maybe<Scalars['Boolean']['output']>;
  isPe?: Maybe<Scalars['Boolean']['output']>;
  isTradeBuyer?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  typeOfInvestor?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  yearBornOrFounded?: Maybe<Scalars['Int']['output']>;
};


export type GenericShareHolderTypeGenericShareholdingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericShareHolderTypeConnection = {
  __typename?: 'GenericShareHolderTypeConnection';
  edges: Array<Maybe<GenericShareHolderTypeEdge>>;
  pageInfo: PageInfo;
};

export type GenericShareHolderTypeEdge = {
  __typename?: 'GenericShareHolderTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GenericShareHolderType>;
};

export enum GenericShareholderSortEnum {
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  HoldingAsc = 'holding_asc',
  HoldingDesc = 'holding_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsNaturalPersonAsc = 'is_natural_person_asc',
  IsNaturalPersonDesc = 'is_natural_person_desc',
  IsPeAsc = 'is_pe_asc',
  IsPeDesc = 'is_pe_desc',
  IsTradeBuyerAsc = 'is_trade_buyer_asc',
  IsTradeBuyerDesc = 'is_trade_buyer_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  TypeOfInvestorAsc = 'type_of_investor_asc',
  TypeOfInvestorDesc = 'type_of_investor_desc',
  UrlAsc = 'url_asc',
  UrlDesc = 'url_desc',
  YearBornOrFoundedAsc = 'year_born_or_founded_asc',
  YearBornOrFoundedDesc = 'year_born_or_founded_desc'
}

export type GenericShareholdingConnection = {
  __typename?: 'GenericShareholdingConnection';
  edges: Array<Maybe<GenericShareholdingEdge>>;
  pageInfo: PageInfo;
};

export type GenericShareholdingEdge = {
  __typename?: 'GenericShareholdingEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GenericShareholdingSqlType>;
};

export type GenericShareholdingSqlType = Node & {
  __typename?: 'GenericShareholdingSQLType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  genericCompany?: Maybe<BuyAndBuildTargetAssessmentType>;
  genericCompanyId?: Maybe<Scalars['Int']['output']>;
  genericShareholder?: Maybe<GenericShareHolderType>;
  genericShareholderId?: Maybe<Scalars['Int']['output']>;
  holding?: Maybe<Scalars['Float']['output']>;
  holdingCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  investmentTransactions?: Maybe<InvestmentTransactionConnection>;
  shareholdingSold?: Maybe<Scalars['Boolean']['output']>;
};


export type GenericShareholdingSqlTypeInvestmentTransactionsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericShareholdingSqlTypeConnection = {
  __typename?: 'GenericShareholdingSQLTypeConnection';
  edges: Array<Maybe<GenericShareholdingSqlTypeEdge>>;
  pageInfo: PageInfo;
};

export type GenericShareholdingSqlTypeEdge = {
  __typename?: 'GenericShareholdingSQLTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GenericShareholdingSqlType>;
};

export enum GenericUrlFacesCountSortEnum {
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  FacesCountAsc = 'faces_count_asc',
  FacesCountDesc = 'faces_count_desc',
  GenericCrawlResultIdAsc = 'generic_crawl_result_id_asc',
  GenericCrawlResultIdDesc = 'generic_crawl_result_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  UrlAsc = 'url_asc',
  UrlDesc = 'url_desc'
}

export enum GenericUrlTextFindingSortEnum {
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  FteCountAsc = 'fte_count_asc',
  FteCountDesc = 'fte_count_desc',
  GenericCrawlResultIdAsc = 'generic_crawl_result_id_asc',
  GenericCrawlResultIdDesc = 'generic_crawl_result_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  UrlAsc = 'url_asc',
  UrlDesc = 'url_desc'
}

export type GoogleTermType = Node & {
  __typename?: 'GoogleTermType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  googleTrend?: Maybe<GoogleTrendType>;
  googleTrends?: Maybe<Array<Maybe<GoogleTrendType>>>;
  id: Scalars['ID']['output'];
  softwareCategory?: Maybe<SoftwareCategoryTypeConnection>;
  term?: Maybe<Scalars['String']['output']>;
};


export type GoogleTermTypeSoftwareCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleTrendType = Node & {
  __typename?: 'GoogleTrendType';
  date?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  googleTerm?: Maybe<GoogleTermType>;
  googleTermId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  interest?: Maybe<Scalars['Int']['output']>;
};

export type HrAddressType = Node & {
  __typename?: 'HRAddressType';
  city?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<HrCoordinatesType>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  officers?: Maybe<HrOfficerTypeConnection>;
  organizations?: Maybe<HrOrganizationTypeConnection>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};


export type HrAddressTypeOfficersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HrAddressTypeOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type HrAnnualFinancialStatementType = Node & {
  __typename?: 'HRAnnualFinancialStatementType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  documentDate?: Maybe<Scalars['String']['output']>;
  documentMd?: Maybe<Scalars['String']['output']>;
  documentTitle?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<HrOrganizationType>;
  organizationId: Scalars['Int']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type HrAnnualFinancialStatementTypeConnection = {
  __typename?: 'HRAnnualFinancialStatementTypeConnection';
  edges: Array<Maybe<HrAnnualFinancialStatementTypeEdge>>;
  pageInfo: PageInfo;
};

export type HrAnnualFinancialStatementTypeEdge = {
  __typename?: 'HRAnnualFinancialStatementTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<HrAnnualFinancialStatementType>;
};

export type HrContactDataType = Node & {
  __typename?: 'HRContactDataType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<HrOrganizationType>;
  organizationId: Scalars['Int']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type HrCoordinatesType = Node & {
  __typename?: 'HRCoordinatesType';
  address?: Maybe<HrAddressType>;
  addressId: Scalars['Int']['output'];
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type HrFilingType = Node & {
  __typename?: 'HRFilingType';
  date?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<HrOrganizationType>;
  organizationId: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HrFilingTypeConnection = {
  __typename?: 'HRFilingTypeConnection';
  edges: Array<Maybe<HrFilingTypeEdge>>;
  pageInfo: PageInfo;
};

export type HrFilingTypeEdge = {
  __typename?: 'HRFilingTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<HrFilingType>;
};

export type HrIndustryCodeType = Node & {
  __typename?: 'HRIndustryCodeType';
  code?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<HrOrganizationType>;
  organizationId: Scalars['Int']['output'];
};

export type HrIndustryCodeTypeConnection = {
  __typename?: 'HRIndustryCodeTypeConnection';
  edges: Array<Maybe<HrIndustryCodeTypeEdge>>;
  pageInfo: PageInfo;
};

export type HrIndustryCodeTypeEdge = {
  __typename?: 'HRIndustryCodeTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<HrIndustryCodeType>;
};

export type HrOfficerType = Node & {
  __typename?: 'HROfficerType';
  address?: Maybe<HrAddressType>;
  addressId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<HrOrganizationType>;
  organizationId: Scalars['Int']['output'];
  role?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type HrOfficerTypeConnection = {
  __typename?: 'HROfficerTypeConnection';
  edges: Array<Maybe<HrOfficerTypeEdge>>;
  pageInfo: PageInfo;
};

export type HrOfficerTypeEdge = {
  __typename?: 'HROfficerTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<HrOfficerType>;
};

export type HrOrganizationConnection = {
  __typename?: 'HROrganizationConnection';
  edges: Array<Maybe<HrOrganizationEdge>>;
  pageInfo: PageInfo;
};

export type HrOrganizationEdge = {
  __typename?: 'HROrganizationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<HrOrganizationType>;
};

export enum HrOrganizationSortEnum {
  AddressIdAsc = 'address_id_asc',
  AddressIdDesc = 'address_id_desc',
  CompanyIdAsc = 'company_id_asc',
  CompanyIdDesc = 'company_id_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  EntityIdAsc = 'entity_id_asc',
  EntityIdDesc = 'entity_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  KeywordsAsc = 'keywords_asc',
  KeywordsDesc = 'keywords_desc',
  LegalFormAsc = 'legal_form_asc',
  LegalFormDesc = 'legal_form_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  ProductsAndServicesAsc = 'products_and_services_asc',
  ProductsAndServicesDesc = 'products_and_services_desc',
  PurposeAsc = 'purpose_asc',
  PurposeDesc = 'purpose_desc',
  RegistrationDateAsc = 'registration_date_asc',
  RegistrationDateDesc = 'registration_date_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc'
}

export type HrOrganizationType = Node & {
  __typename?: 'HROrganizationType';
  address?: Maybe<HrAddressType>;
  addressId?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['Int']['output'];
  contactData?: Maybe<HrContactDataType>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  filings?: Maybe<HrFilingTypeConnection>;
  financialStatements?: Maybe<HrAnnualFinancialStatementTypeConnection>;
  id: Scalars['ID']['output'];
  industryCodes?: Maybe<HrIndustryCodeTypeConnection>;
  keywords?: Maybe<Scalars['JSONString']['output']>;
  legalForm?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  officers?: Maybe<HrOfficerTypeConnection>;
  productsAndServices?: Maybe<Scalars['JSONString']['output']>;
  profitLossAccounts?: Maybe<HrYearlyProfitLossAccountTypeConnection>;
  purpose?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<HrRegistrationType>;
  registrationDate?: Maybe<Scalars['String']['output']>;
  shareholders?: Maybe<HrShareholderTypeConnection>;
  status?: Maybe<Scalars['String']['output']>;
};


export type HrOrganizationTypeFilingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HrOrganizationTypeFinancialStatementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HrOrganizationTypeIndustryCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HrOrganizationTypeOfficersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HrOrganizationTypeProfitLossAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HrOrganizationTypeShareholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type HrOrganizationTypeConnection = {
  __typename?: 'HROrganizationTypeConnection';
  edges: Array<Maybe<HrOrganizationTypeEdge>>;
  pageInfo: PageInfo;
};

export type HrOrganizationTypeEdge = {
  __typename?: 'HROrganizationTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<HrOrganizationType>;
};

export type HrProfitLossAccountItemType = Node & {
  __typename?: 'HRProfitLossAccountItemType';
  children?: Maybe<HrProfitLossAccountItemTypeConnection>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  nameDe?: Maybe<Scalars['String']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  nameInReport?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<HrProfitLossAccountItemType>;
  parentId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  yearlyAccount?: Maybe<HrYearlyProfitLossAccountType>;
  yearlyAccountId: Scalars['Int']['output'];
};


export type HrProfitLossAccountItemTypeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type HrProfitLossAccountItemTypeConnection = {
  __typename?: 'HRProfitLossAccountItemTypeConnection';
  edges: Array<Maybe<HrProfitLossAccountItemTypeEdge>>;
  pageInfo: PageInfo;
};

export type HrProfitLossAccountItemTypeEdge = {
  __typename?: 'HRProfitLossAccountItemTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<HrProfitLossAccountItemType>;
};

export type HrRegistrationType = Node & {
  __typename?: 'HRRegistrationType';
  court?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<HrOrganizationType>;
  organizationId: Scalars['Int']['output'];
  registerNumber?: Maybe<Scalars['String']['output']>;
  registerType?: Maybe<Scalars['String']['output']>;
};

export type HrShareholderType = Node & {
  __typename?: 'HRShareholderType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<HrOrganizationType>;
  organizationId: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['String']['output']>;
};

export type HrShareholderTypeConnection = {
  __typename?: 'HRShareholderTypeConnection';
  edges: Array<Maybe<HrShareholderTypeEdge>>;
  pageInfo: PageInfo;
};

export type HrShareholderTypeEdge = {
  __typename?: 'HRShareholderTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<HrShareholderType>;
};

export type HrYearlyProfitLossAccountType = Node & {
  __typename?: 'HRYearlyProfitLossAccountType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<HrProfitLossAccountItemTypeConnection>;
  organization?: Maybe<HrOrganizationType>;
  organizationId: Scalars['Int']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};


export type HrYearlyProfitLossAccountTypeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type HrYearlyProfitLossAccountTypeConnection = {
  __typename?: 'HRYearlyProfitLossAccountTypeConnection';
  edges: Array<Maybe<HrYearlyProfitLossAccountTypeEdge>>;
  pageInfo: PageInfo;
};

export type HrYearlyProfitLossAccountTypeEdge = {
  __typename?: 'HRYearlyProfitLossAccountTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<HrYearlyProfitLossAccountType>;
};

export type IcpAnalysisType = {
  __typename?: 'ICPAnalysisType';
  buyingCycleLength?: Maybe<Scalars['String']['output']>;
  cortexRating: CortexRatingEnum;
  customerConcentrationRisk?: Maybe<Scalars['String']['output']>;
  decisionMakers: Array<Maybe<Scalars['String']['output']>>;
  idealCustomerCharacteristics: Array<Maybe<Scalars['String']['output']>>;
  keyValuePropositions: Array<Maybe<Scalars['String']['output']>>;
  npsOrSatisfaction?: Maybe<Scalars['String']['output']>;
  primarySegments: Array<Maybe<CddCustomerSegmentType>>;
  ratingRationale: Scalars['String']['output'];
};

export type IcpAnalysisV2Type = {
  __typename?: 'ICPAnalysisV2Type';
  buyingCycleLength?: Maybe<Scalars['String']['output']>;
  claimIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cortexRating: CortexRatingEnumV2;
  customerConcentrationRisk?: Maybe<Scalars['String']['output']>;
  decisionMakers: Array<Maybe<Scalars['String']['output']>>;
  exhibitIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  idealCustomerCharacteristics: Array<Maybe<Scalars['String']['output']>>;
  keyValuePropositions: Array<Maybe<Scalars['String']['output']>>;
  primarySegments: Scalars['JSONString']['output'];
  ratingRationale: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

export type ImageDownloadTestResponse = {
  __typename?: 'ImageDownloadTestResponse';
  domain?: Maybe<Scalars['String']['output']>;
  domainStatistics?: Maybe<DomainStatistics>;
  error?: Maybe<Scalars['String']['output']>;
  imagesTested?: Maybe<Scalars['Int']['output']>;
  recommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  results?: Maybe<Array<Maybe<ImageTestResult>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  summaryDirect?: Maybe<StrategyStatistics>;
  summaryScrapingbee?: Maybe<StrategyStatistics>;
  summaryTlsClient?: Maybe<StrategyStatistics>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type ImageDownloadTestResult = {
  __typename?: 'ImageDownloadTestResult';
  contentType?: Maybe<Scalars['String']['output']>;
  elapsedMs?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ImageFindingConnection = {
  __typename?: 'ImageFindingConnection';
  edges: Array<Maybe<ImageFindingEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type ImageFindingEdge = {
  __typename?: 'ImageFindingEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ImageFindingType>;
};

export type ImageFindingType = {
  __typename?: 'ImageFindingType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  facesCount?: Maybe<Scalars['Int']['output']>;
  genericCrawlResultId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ImageTestResult = {
  __typename?: 'ImageTestResult';
  imageId?: Maybe<Scalars['Int']['output']>;
  tests?: Maybe<Array<Maybe<ImageDownloadTestResult>>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type IndustryBenchmarkInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  ebitdaAssets?: InputMaybe<Scalars['Float']['input']>;
  ebitdaSales?: InputMaybe<Scalars['Float']['input']>;
  evAssets?: InputMaybe<Scalars['Float']['input']>;
  evEbitda?: InputMaybe<Scalars['Float']['input']>;
  identifier: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  oneYearSalesGrowth?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sic?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  zScore?: InputMaybe<Scalars['Float']['input']>;
};

export enum IndustryClassificationSampleSortEnum {
  CountryAsc = 'country_asc',
  CountryDesc = 'country_desc',
  DateAsc = 'date_asc',
  DateDesc = 'date_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  EbitdaAssetsAsc = 'ebitda_assets_asc',
  EbitdaAssetsDesc = 'ebitda_assets_desc',
  EbitdaSalesAsc = 'ebitda_sales_asc',
  EbitdaSalesDesc = 'ebitda_sales_desc',
  EvAssetsAsc = 'ev_assets_asc',
  EvAssetsDesc = 'ev_assets_desc',
  EvEbitdaAsc = 'ev_ebitda_asc',
  EvEbitdaDesc = 'ev_ebitda_desc',
  GenericCompanyIdAsc = 'generic_company_id_asc',
  GenericCompanyIdDesc = 'generic_company_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IdentifierAsc = 'identifier_asc',
  IdentifierDesc = 'identifier_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  OneYearSalesGrowthAsc = 'one_year_sales_growth_asc',
  OneYearSalesGrowthDesc = 'one_year_sales_growth_desc',
  RegionAsc = 'region_asc',
  RegionDesc = 'region_desc',
  SicAsc = 'sic_asc',
  SicDesc = 'sic_desc',
  UrlAsc = 'url_asc',
  UrlDesc = 'url_desc',
  YearAsc = 'year_asc',
  YearDesc = 'year_desc',
  ZScoreAsc = 'z_score_asc',
  ZScoreDesc = 'z_score_desc'
}

export type InitializeAllCentroids = {
  __typename?: 'InitializeAllCentroids';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
};

export type InsertCertainProductCategory = {
  __typename?: 'InsertCertainProductCategory';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InsightType = {
  __typename?: 'InsightType';
  category: Scalars['String']['output'];
  message: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type InvestTransactionConnection = {
  __typename?: 'InvestTransactionConnection';
  dbId?: Maybe<Scalars['Int']['output']>;
  edges: Array<Maybe<InvestTransactionEdge>>;
  pageInfo: PageInfo;
};

export type InvestTransactionEdge = {
  __typename?: 'InvestTransactionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvestTransactionType>;
};

export type InvestTransactionType = Node & {
  __typename?: 'InvestTransactionType';
  amountRaised?: Maybe<Scalars['Float']['output']>;
  buyer?: Maybe<GenericShareHolderType>;
  dateOfTransaction?: Maybe<Scalars['DateTime']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isSoftwareTransaction?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<GenericShareHolderType>;
  targetCompany?: Maybe<CompanyType>;
  teamWasNotified?: Maybe<Scalars['Boolean']['output']>;
  totalAmountRaised?: Maybe<Scalars['Float']['output']>;
  typeOfTransaction?: Maybe<Scalars['String']['output']>;
};

export type InvestmentTransactionConnection = {
  __typename?: 'InvestmentTransactionConnection';
  edges: Array<Maybe<InvestmentTransactionEdge>>;
  pageInfo: PageInfo;
};

export type InvestmentTransactionEdge = {
  __typename?: 'InvestmentTransactionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvestmentTransactionSqlType>;
};

export type InvestmentTransactionSqlType = Node & {
  __typename?: 'InvestmentTransactionSQLType';
  amountRaised?: Maybe<Scalars['Float']['output']>;
  dateOfTransaction?: Maybe<Scalars['DateTime']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isSoftwareTransaction?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  teamWasNotified?: Maybe<Scalars['Boolean']['output']>;
  totalAmountRaised?: Maybe<Scalars['Float']['output']>;
  typeOfTransaction?: Maybe<Scalars['String']['output']>;
};

export type JobProgressType = {
  __typename?: 'JobProgressType';
  percent?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
};

export type KpiBenchmarkType = {
  __typename?: 'KPIBenchmarkType';
  kpiName?: Maybe<Scalars['String']['output']>;
  nonNullCount?: Maybe<Scalars['Int']['output']>;
  percentile25?: Maybe<Scalars['Float']['output']>;
  percentile50?: Maybe<Scalars['Float']['output']>;
  percentile75?: Maybe<Scalars['Float']['output']>;
};

export type KpiCalculationStatus = {
  __typename?: 'KPICalculationStatus';
  dataAvailability?: Maybe<KpiDataAvailability>;
  displayName?: Maybe<Scalars['String']['output']>;
  isCalculated?: Maybe<Scalars['Boolean']['output']>;
  isUpToDate?: Maybe<Scalars['Boolean']['output']>;
  kpiName?: Maybe<Scalars['String']['output']>;
  kpiType?: Maybe<Scalars['String']['output']>;
  lastCalculated?: Maybe<Scalars['DateTime']['output']>;
  requiredDataMissing?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type KpiDataAvailability = {
  __typename?: 'KPIDataAvailability';
  availableYears?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  dataSources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hasRawData?: Maybe<Scalars['Boolean']['output']>;
  kpiName?: Maybe<Scalars['String']['output']>;
  latestYear?: Maybe<Scalars['Int']['output']>;
};

export type KpiPreCalculationType = Node & {
  __typename?: 'KPIPreCalculationType';
  absEbit?: Maybe<Scalars['Float']['output']>;
  absEbitda?: Maybe<Scalars['Float']['output']>;
  absFte?: Maybe<Scalars['Float']['output']>;
  absSales?: Maybe<Scalars['Float']['output']>;
  ageOfProgrammingLanguage?: Maybe<Scalars['Int']['output']>;
  buyAndBuildScore?: Maybe<Scalars['Float']['output']>;
  cLevelQuality?: Maybe<Scalars['Float']['output']>;
  callabilityScore?: Maybe<Scalars['Float']['output']>;
  cogsRatio?: Maybe<Scalars['Float']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  consultingManRate?: Maybe<Scalars['Float']['output']>;
  customerIndustryGrowth?: Maybe<Scalars['Float']['output']>;
  customerIndustrySic?: Maybe<Scalars['String']['output']>;
  customerLifetimeValueDistribution?: Maybe<Scalars['Float']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  downgradeArr?: Maybe<Scalars['Float']['output']>;
  downgradeArrRate?: Maybe<Scalars['Float']['output']>;
  ebitMargin?: Maybe<Scalars['Float']['output']>;
  ebitMarginForecastChange?: Maybe<Scalars['Float']['output']>;
  ebitdaMargin?: Maybe<Scalars['Float']['output']>;
  employeeConcentrationRatio?: Maybe<Scalars['Float']['output']>;
  enterpriseValueEstimation?: Maybe<Scalars['Float']['output']>;
  evModelAppreciation5y?: Maybe<Scalars['Float']['output']>;
  evModelCagr5y?: Maybe<Scalars['Float']['output']>;
  expansionArr?: Maybe<Scalars['Float']['output']>;
  expansionArrRate?: Maybe<Scalars['Float']['output']>;
  financialBaseForValuation?: Maybe<Scalars['String']['output']>;
  fteNetContributionMargin?: Maybe<Scalars['Float']['output']>;
  grossArrChurn?: Maybe<Scalars['Float']['output']>;
  grossArrChurnRate?: Maybe<Scalars['Float']['output']>;
  grossLogoChurn?: Maybe<Scalars['Float']['output']>;
  grossLogoChurnRate?: Maybe<Scalars['Float']['output']>;
  grossNewCustomerLogoGrowth?: Maybe<Scalars['Float']['output']>;
  grossNewCustomerLogoGrowthRate?: Maybe<Scalars['Float']['output']>;
  grossNewCustomerSalesGrowth?: Maybe<Scalars['Float']['output']>;
  grossNewCustomerSalesGrowthRate?: Maybe<Scalars['Float']['output']>;
  grossRetentionRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  mostExpensiveKeyword?: Maybe<Scalars['String']['output']>;
  netArrChurn?: Maybe<Scalars['Float']['output']>;
  netArrChurnRate?: Maybe<Scalars['Float']['output']>;
  netLogoChurn?: Maybe<Scalars['Float']['output']>;
  netLogoChurnRate?: Maybe<Scalars['Float']['output']>;
  netNewCustomerSalesGrowth?: Maybe<Scalars['Float']['output']>;
  netRetentionRate?: Maybe<Scalars['Float']['output']>;
  onlineVisibility?: Maybe<Scalars['Float']['output']>;
  opexRatio?: Maybe<Scalars['Float']['output']>;
  popularityOfProgrammingLanguage?: Maybe<Scalars['Float']['output']>;
  pricePerGoogleKeywordClick?: Maybe<Scalars['Float']['output']>;
  recurringRevenueShare?: Maybe<Scalars['Float']['output']>;
  salesGrowth?: Maybe<Scalars['Float']['output']>;
  softwareCategoryGrowth?: Maybe<Scalars['Float']['output']>;
  softwareShare?: Maybe<Scalars['Float']['output']>;
  teamQuality?: Maybe<Scalars['Float']['output']>;
  top3CustomerShare?: Maybe<Scalars['Float']['output']>;
  useOfBackendFramework?: Maybe<Scalars['Boolean']['output']>;
  useOfFrontendFramework?: Maybe<Scalars['Boolean']['output']>;
};

export type KpiPreCalculationTypeConnection = {
  __typename?: 'KPIPreCalculationTypeConnection';
  edges: Array<Maybe<KpiPreCalculationTypeEdge>>;
  pageInfo: PageInfo;
};

export type KpiPreCalculationTypeEdge = {
  __typename?: 'KPIPreCalculationTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<KpiPreCalculationType>;
};

export type KpiPrecalculationConnection = {
  __typename?: 'KPIPrecalculationConnection';
  edges: Array<Maybe<KpiPrecalculationEdge>>;
  pageInfo: PageInfo;
};

export type KpiPrecalculationEdge = {
  __typename?: 'KPIPrecalculationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<KpiPreCalculationType>;
};

export type KpiStatusSummary = {
  __typename?: 'KPIStatusSummary';
  benchmarkControlDataId?: Maybe<Scalars['Int']['output']>;
  calculatedKpis?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  kpiStatuses?: Maybe<Array<Maybe<KpiCalculationStatus>>>;
  lastDataUpload?: Maybe<Scalars['DateTime']['output']>;
  lastFiscalYear?: Maybe<Scalars['Int']['output']>;
  lastKpiCalculation?: Maybe<Scalars['DateTime']['output']>;
  missingDataKpis?: Maybe<Scalars['Int']['output']>;
  needsRecalculation?: Maybe<Scalars['Boolean']['output']>;
  outdatedKpis?: Maybe<Scalars['Int']['output']>;
  totalKpis?: Maybe<Scalars['Int']['output']>;
};

export type KeywordAnalysisResultType = {
  __typename?: 'KeywordAnalysisResultType';
  analysisPeriodDays?: Maybe<Scalars['Int']['output']>;
  existingPatternsWithUsage?: Maybe<Array<Maybe<ExistingPatternUsageType>>>;
  frequentKeywords?: Maybe<Scalars['Int']['output']>;
  keywordFrequency?: Maybe<Scalars['JSONString']['output']>;
  suggestedNewPatterns?: Maybe<Array<Maybe<KeywordPatternSuggestionType>>>;
  totalValidationsAnalyzed?: Maybe<Scalars['Int']['output']>;
  uniqueKeywordsFound?: Maybe<Scalars['Int']['output']>;
};

export type KeywordForCompanySqlType = Node & {
  __typename?: 'KeywordForCompanySQLType';
  change?: Maybe<Scalars['Int']['output']>;
  competitorDensity?: Maybe<Scalars['Int']['output']>;
  cpc?: Maybe<Scalars['Float']['output']>;
  createdFromDataForSeo?: Maybe<Scalars['Boolean']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  genericCrawlResultId?: Maybe<Scalars['Int']['output']>;
  genericCrawlResults?: Maybe<RecentPlatformCrawlType>;
  googleTermId?: Maybe<Scalars['Int']['output']>;
  hasBeenSearched?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isPlaceholderForEmptyXoviResponse?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  keywordEmbedding?: Maybe<Scalars['JSONString']['output']>;
  keywordEmbeddingV2?: Maybe<Scalars['JSONString']['output']>;
  keywordLanguage?: Maybe<Scalars['String']['output']>;
  markedAsIrrelevant?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  searchEngine?: Maybe<Scalars['String']['output']>;
  seoDataAnalysisId?: Maybe<Scalars['Int']['output']>;
  sevo?: Maybe<Scalars['Int']['output']>;
  specialGenericCrawlResults?: Maybe<RecentPlatformCrawlType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type KeywordForCompanySqlTypeConnection = {
  __typename?: 'KeywordForCompanySQLTypeConnection';
  edges: Array<Maybe<KeywordForCompanySqlTypeEdge>>;
  pageInfo: PageInfo;
};

export type KeywordForCompanySqlTypeEdge = {
  __typename?: 'KeywordForCompanySQLTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<KeywordForCompanySqlType>;
};

export type KeywordPatternSuggestionType = {
  __typename?: 'KeywordPatternSuggestionType';
  classificationTarget?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  nonSoftwareCount?: Maybe<Scalars['Int']['output']>;
  softwareCount?: Maybe<Scalars['Int']['output']>;
  suggestedType?: Maybe<Scalars['String']['output']>;
  suggestedWeight?: Maybe<Scalars['Float']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type KeywordResultRawConnection = {
  __typename?: 'KeywordResultRawConnection';
  edges: Array<Maybe<KeywordResultRawEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type KeywordResultRawEdge = {
  __typename?: 'KeywordResultRawEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<KeywordResultRawType>;
};

export type KeywordResultRawType = Node & {
  __typename?: 'KeywordResultRawType';
  change?: Maybe<Scalars['Int']['output']>;
  competitorDensity?: Maybe<Scalars['Int']['output']>;
  cpc?: Maybe<Scalars['Float']['output']>;
  createdFromDataForSeo?: Maybe<Scalars['Boolean']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['UUID']['output']>;
  genericCrawlResultId?: Maybe<Scalars['Int']['output']>;
  genericCrawlResults?: Maybe<RecentPlatformCrawlType>;
  googleTermId?: Maybe<Scalars['Int']['output']>;
  hasBeenSearched?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isPlaceholderForEmptyXoviResponse?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  keywordEmbedding?: Maybe<Scalars['JSONString']['output']>;
  keywordEmbeddingV2?: Maybe<Scalars['JSONString']['output']>;
  keywordLanguage?: Maybe<Scalars['String']['output']>;
  markedAsIrrelevant?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  searchEngine?: Maybe<Scalars['String']['output']>;
  seoDataAnalysisId?: Maybe<Scalars['Int']['output']>;
  sevo?: Maybe<Scalars['Int']['output']>;
  specialGenericCrawlResults?: Maybe<RecentPlatformCrawlType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type KeywordResultType = {
  __typename?: 'KeywordResultType';
  cpc?: Maybe<Scalars['Float']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
};

export type KeywordStatistics = {
  __typename?: 'KeywordStatistics';
  avgConfidence?: Maybe<Scalars['Float']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  normalizedKeyword?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Scalars['JSONString']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
  validationCount?: Maybe<Scalars['Int']['output']>;
  variants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type KeywordSuggestion = {
  __typename?: 'KeywordSuggestion';
  confidence?: Maybe<Scalars['Float']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  matchCount?: Maybe<Scalars['Int']['output']>;
  patternId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type KlazifyCategoryConnection = {
  __typename?: 'KlazifyCategoryConnection';
  edges: Array<Maybe<KlazifyCategoryEdge>>;
  pageInfo: PageInfo;
};

export type KlazifyCategoryEdge = {
  __typename?: 'KlazifyCategoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<KlazifyCategorySqlType>;
};

export type KlazifyCategorySqlType = Node & {
  __typename?: 'KlazifyCategorySQLType';
  IAB5?: Maybe<Scalars['String']['output']>;
  IAB7?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  domainId?: Maybe<Scalars['Int']['output']>;
  hasSubcategories?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  subCategory1?: Maybe<Scalars['String']['output']>;
  subCategory2?: Maybe<Scalars['String']['output']>;
  subCategory3?: Maybe<Scalars['String']['output']>;
  subCategory4?: Maybe<Scalars['String']['output']>;
};

export type KlazifyCompanyType = Node & {
  __typename?: 'KlazifyCompanyType';
  id: Scalars['ID']['output'];
};

export type KlazifyDomainConnection = {
  __typename?: 'KlazifyDomainConnection';
  edges: Array<Maybe<KlazifyDomainEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type KlazifyDomainEdge = {
  __typename?: 'KlazifyDomainEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<KlazifyDomainType>;
};

export enum KlazifyDomainSortEnum {
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DomainNameAsc = 'domain_name_asc',
  DomainNameDesc = 'domain_name_desc',
  GenericCompanyIdAsc = 'generic_company_id_asc',
  GenericCompanyIdDesc = 'generic_company_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LogoUrlAsc = 'logo_url_asc',
  LogoUrlDesc = 'logo_url_desc',
  SuccessAsc = 'success_asc',
  SuccessDesc = 'success_desc'
}

export type KlazifyDomainType = Node & {
  __typename?: 'KlazifyDomainType';
  categories?: Maybe<KlazifyCategoryConnection>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  domainName?: Maybe<Scalars['String']['output']>;
  genericCompanyId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  klazifyCompany?: Maybe<KlazifyCompanyType>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};


export type KlazifyDomainTypeCategoriesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelBuyAndBuildTargetQuality = {
  __typename?: 'LabelBuyAndBuildTargetQuality';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type LayerSuccessRatesType = {
  __typename?: 'LayerSuccessRatesType';
  apolloPerformance?: Maybe<LayerSuccessType>;
  contactEmailCoverage?: Maybe<DataCoverageType>;
  endDate: Scalars['DateTime']['output'];
  existingPerformance?: Maybe<LayerSuccessType>;
  firecrawlPerformance?: Maybe<LayerSuccessType>;
  insights?: Maybe<Array<Maybe<InsightType>>>;
  managingDirectorCoverage?: Maybe<DataCoverageType>;
  overallSuccessRate: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  timeRange: Scalars['String']['output'];
  totalEnrichmentsAnalyzed: Scalars['Int']['output'];
};

export type LayerSuccessType = {
  __typename?: 'LayerSuccessType';
  successRate: Scalars['Float']['output'];
  successfulExtractions: Scalars['Int']['output'];
};

export type LayerTimingType = {
  __typename?: 'LayerTimingType';
  apolloPercent?: Maybe<Scalars['Float']['output']>;
  existingPercent?: Maybe<Scalars['Float']['output']>;
  firecrawlPercent?: Maybe<Scalars['Float']['output']>;
};

export type LockCrawlQueueEntries = {
  __typename?: 'LockCrawlQueueEntries';
  ok?: Maybe<Scalars['Boolean']['output']>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

export type LogZapierPipedriveActivity = {
  __typename?: 'LogZapierPipedriveActivity';
  activityLogged?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MlFeatureImportanceType = {
  __typename?: 'MLFeatureImportanceType';
  featureName?: Maybe<Scalars['String']['output']>;
  importance?: Maybe<Scalars['Float']['output']>;
};

export type MlModelDetailedStatsType = {
  __typename?: 'MLModelDetailedStatsType';
  historicalData?: Maybe<Array<Maybe<MlModelHistoricalDataPoint>>>;
  modelName?: Maybe<Scalars['String']['output']>;
  modelType?: Maybe<Scalars['String']['output']>;
  statistics?: Maybe<MlModelStatisticsType>;
};

export type MlModelFindingConnection = {
  __typename?: 'MLModelFindingConnection';
  edges: Array<Maybe<MlModelFindingEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type MlModelFindingEdge = {
  __typename?: 'MLModelFindingEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<MlModelFindingType>;
};

export type MlModelFindingType = {
  __typename?: 'MLModelFindingType';
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  detectedLanguage?: Maybe<Scalars['String']['output']>;
  findingsUrl?: Maybe<Scalars['String']['output']>;
  hasBeenManuallyChecked?: Maybe<Scalars['Boolean']['output']>;
  hasBeenOverwritten?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  openAiVote?: Maybe<Scalars['Int']['output']>;
  resultUrl?: Maybe<Scalars['String']['output']>;
};

export type MlModelHistoricalDataPoint = {
  __typename?: 'MLModelHistoricalDataPoint';
  accuracy?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  f1Score?: Maybe<Scalars['Float']['output']>;
  r2?: Maybe<Scalars['Float']['output']>;
  testSamples?: Maybe<Scalars['Int']['output']>;
  totalSamples?: Maybe<Scalars['Int']['output']>;
  trainingSamples?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type MlModelStatisticsType = {
  __typename?: 'MLModelStatisticsType';
  currentAccuracy?: Maybe<Scalars['Float']['output']>;
  currentF1Score?: Maybe<Scalars['Float']['output']>;
  currentMse?: Maybe<Scalars['Float']['output']>;
  currentPrecision?: Maybe<Scalars['Float']['output']>;
  currentR2?: Maybe<Scalars['Float']['output']>;
  currentRecall?: Maybe<Scalars['Float']['output']>;
  currentRmse?: Maybe<Scalars['Float']['output']>;
  currentTestSamples?: Maybe<Scalars['Int']['output']>;
  currentTrainingSamples?: Maybe<Scalars['Int']['output']>;
  latestVersion?: Maybe<Scalars['Int']['output']>;
  modelCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  modelType?: Maybe<Scalars['String']['output']>;
  modelUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  samplesChange1w?: Maybe<Scalars['Int']['output']>;
  samplesChange1wPercent?: Maybe<Scalars['Float']['output']>;
  samplesChange4w?: Maybe<Scalars['Int']['output']>;
  samplesChange4wPercent?: Maybe<Scalars['Float']['output']>;
  topFeatures?: Maybe<Array<Maybe<MlFeatureImportanceType>>>;
  totalCurrentSamples?: Maybe<Scalars['Int']['output']>;
  totalVersions?: Maybe<Scalars['Int']['output']>;
};

export type MarkAllCrawlResultsAsValidated = {
  __typename?: 'MarkAllCrawlResultsAsValidated';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkCompanyAsNotSoftware = {
  __typename?: 'MarkCompanyAsNotSoftware';
  company?: Maybe<CompanyType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkCompanyAsSoftware = {
  __typename?: 'MarkCompanyAsSoftware';
  company?: Maybe<CompanyType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkProductAsHorizontal = {
  __typename?: 'MarkProductAsHorizontal';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkXoviKeywordAsIrrelevant = {
  __typename?: 'MarkXOVIKeywordAsIrrelevant';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkXoviKeywordsAsIrrelevant = {
  __typename?: 'MarkXOVIKeywordsAsIrrelevant';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MarketAnalysisType = {
  __typename?: 'MarketAnalysisType';
  cagrEstimate: Scalars['Float']['output'];
  cortexRating: CortexRatingEnum;
  evidenceSources?: Maybe<Array<Maybe<EvidenceSourceType>>>;
  growthDrivers: Array<Maybe<Scalars['String']['output']>>;
  marketTrends: Array<Maybe<Scalars['String']['output']>>;
  ratingRationale: Scalars['String']['output'];
  regulatoryFactors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sam: Scalars['String']['output'];
  som: Scalars['String']['output'];
  tam: Scalars['String']['output'];
};

export type MarketAnalysisV2Type = {
  __typename?: 'MarketAnalysisV2Type';
  cagrEstimate: Scalars['Float']['output'];
  claimIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cortexRating: CortexRatingEnumV2;
  exhibitIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  growthDrivers: Array<Maybe<Scalars['String']['output']>>;
  marketTrends: Array<Maybe<Scalars['String']['output']>>;
  ratingRationale: Scalars['String']['output'];
  regulatoryFactors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sam: Scalars['String']['output'];
  som: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  tam: Scalars['String']['output'];
};

export type MatchCompanyWithOpenRegistry = {
  __typename?: 'MatchCompanyWithOpenRegistry';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MeetingAttendeeType = {
  __typename?: 'MeetingAttendeeType';
  id: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type MeetingExternalAttendeeType = {
  __typename?: 'MeetingExternalAttendeeType';
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type MeetingType = {
  __typename?: 'MeetingType';
  attendees?: Maybe<Array<Maybe<MeetingAttendeeType>>>;
  companyId?: Maybe<Scalars['Int']['output']>;
  domain: Scalars['String']['output'];
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  externalAttendees?: Maybe<Array<Maybe<MeetingExternalAttendeeType>>>;
  icalUid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  meetingDate: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  surveyResponses?: Maybe<Array<Maybe<SurveyResponseType>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MergeCompanies = {
  __typename?: 'MergeCompanies';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MethodBreakdownType = {
  __typename?: 'MethodBreakdownType';
  avgTimeMs: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  method: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type MoveCompanyToAnotherSharedDrive = {
  __typename?: 'MoveCompanyToAnotherSharedDrive';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutations = {
  __typename?: 'Mutations';
  acquireValidationLock?: Maybe<AcquireValidationLock>;
  activateProbationaryPattern?: Maybe<ActivateProbationaryPattern>;
  addBuyAndBuildTarget?: Maybe<AddBuyAndBuildTarget>;
  addBuyAndBuildTargetsFromSourcescrub?: Maybe<AddBuyAndBuildTargetsFromSourcescrub>;
  addCompanyCertification?: Maybe<AddCompanyCertification>;
  addCoreKeyword?: Maybe<AddCoreKeyword>;
  addCustomerSegment?: Maybe<AddCustomerSegmentMutation>;
  addIndustry?: Maybe<AddIndustry>;
  addJobDescriptionUrl?: Maybe<AddJobDescriptionUrl>;
  addSoftwareCategoryToCompany?: Maybe<AddSoftwareCategoryToCompany>;
  addTechnologyFindingText?: Maybe<AddTechnologyFindingText>;
  addTechnologyFindingUrl?: Maybe<AddTechnologyFindingUrl>;
  adjustPatternWeights?: Maybe<AdjustPatternWeights>;
  allowImmediateCrawl?: Maybe<AllowImmediateCrawlMutation>;
  backfillCoreKeywords?: Maybe<BackfillCoreKeywordsMutation>;
  backfillEmbeddingsV2?: Maybe<BackfillEmbeddingsV2Mutation>;
  backfillHrKeywordsAndSic?: Maybe<BackfillHrKeywordsAndSicMutation>;
  backfillHrOfficerBridge?: Maybe<BackfillHrOfficerBridgeMutation>;
  backfillHrRelatedPersons?: Maybe<BackfillHrRelatedPersonsMutation>;
  backfillTokens?: Maybe<BackfillTokensMutation>;
  boughtByPe?: Maybe<BoughtByPe>;
  bulkEstimateGdriveConfig?: Maybe<BulkEstimateGDriveConfig>;
  cleanupCrawlResults?: Maybe<CleanupCrawlResults>;
  cleanupUnknownShareholders?: Maybe<CleanupUnknownShareholdersMutation>;
  computeHomepageGateCentroids?: Maybe<ComputeHomepageGateCentroidsMutation>;
  confirmCompanyGdriveConfig?: Maybe<ConfirmCompanyGDriveConfig>;
  confirmFteSize?: Maybe<ConfirmFteSize>;
  cortexFeedbackPipedriveBridge?: Maybe<CortexFeedbackPipedriveBridge>;
  createBenchmarkBalanceSheet?: Maybe<CreateBenchmarkBalanceSheet>;
  createBenchmarkCustomersAggregated?: Maybe<CreateBenchmarkCustomersAggregated>;
  createBenchmarkCustomersList?: Maybe<CreateBenchmarkCustomersList>;
  createBenchmarkFte?: Maybe<CreateBenchmarkFte>;
  createBenchmarkPl?: Maybe<CreateBenchmarkPl>;
  createBenchmarkPricing?: Maybe<CreateBenchmarkPricing>;
  createCertification?: Maybe<CreateCertification>;
  createClassificationPattern?: Maybe<CreateClassificationPattern>;
  createCompanyProduct?: Maybe<CreateCompanyProduct>;
  createKeywords?: Maybe<CreateXoviKeywords>;
  createMeeting?: Maybe<CreateMeeting>;
  createQuestionnaireVersion?: Maybe<CreateQuestionnaireVersion>;
  createRedbeatSchedule?: Maybe<CreateRedBeatSchedule>;
  createUpdateCategory?: Maybe<CreateUpdateKlazifyCategory>;
  createUpdateCompanyTechUse?: Maybe<CreateUpdateCompanyTechUse>;
  createUpdateGenericShareholder?: Maybe<CreateUpdateGenericShareholder>;
  createUpdateGenericShareholding?: Maybe<CreateUpdateGenericShareholding>;
  createUpdateKeyword?: Maybe<CreateUpdateXoviKeyword>;
  deleteAllBmForCompany?: Maybe<DeleteAllBmForCompany>;
  deleteCertification?: Maybe<DeleteCertification>;
  deleteClassificationPattern?: Maybe<DeleteClassificationPattern>;
  deleteCompanyProduct?: Maybe<DeleteCompanyProduct>;
  deleteCompanyTechUse?: Maybe<DeleteCompanyTechUse>;
  deleteCrawlQueueEntries?: Maybe<DeleteCrawlQueueEntries>;
  deleteCustomerReference?: Maybe<DeleteCustomerReference>;
  deleteCustomerSegment?: Maybe<DeleteCustomerSegmentMutation>;
  deleteGenericShareholder?: Maybe<DeleteGenericShareholder>;
  deleteGenericShareholding?: Maybe<DeleteGenericShareholding>;
  deleteKeyword?: Maybe<MarkXoviKeywordAsIrrelevant>;
  deleteKeywords?: Maybe<MarkXoviKeywordsAsIrrelevant>;
  deletePdfDocumentAnnotation?: Maybe<DeletePdfDocumentAnnotation>;
  deleteProbationaryPattern?: Maybe<DeleteProbationaryPattern>;
  deleteRedbeatSchedule?: Maybe<DeleteRedBeatSchedule>;
  deleteSelectedCompanyTechUse?: Maybe<DeleteSelectedCompanyTechUse>;
  deleteSession?: Maybe<Scalars['Boolean']['output']>;
  deleteSoftwareCategoryAiScore?: Maybe<DeleteSoftwareCategoryAiScore>;
  downvoteFindingsToken?: Maybe<DownvoteFindingsToken>;
  editCompany?: Maybe<EditCompany>;
  editCustomerReference?: Maybe<EditCustomerReference>;
  enrichCompanyContact?: Maybe<EnrichCompanyContactMutation>;
  estimateCompanyGdriveConfig?: Maybe<EstimateCompanyGDriveConfig>;
  evaluateSignals?: Maybe<EvaluateSignals>;
  finishCompanyValidation?: Maybe<FinishCompanyValidation>;
  finishCrawlResultValidation?: Maybe<FinishCrawlResultValidation>;
  finishExcelFileUpload?: Maybe<FinishExcelFileUpload>;
  gatherHandelsregisterApiData?: Maybe<GatherHandelsregisterApiData>;
  generateCrawlPlan?: Maybe<GenerateCrawlPlanMutation>;
  generatePatternsFromKeywords?: Maybe<GeneratePatternsFromKeywords>;
  generateVibeCodingIdeas?: Maybe<GenerateVibeCodingIdeas>;
  initializeAllCentroids?: Maybe<InitializeAllCentroids>;
  insertCertainProductCategory?: Maybe<InsertCertainProductCategory>;
  labelBuyAndBuildTargetQuality?: Maybe<LabelBuyAndBuildTargetQuality>;
  loadImageLearner?: Maybe<LoadImageLearnerMutation>;
  lockCrawlQueueEntries?: Maybe<LockCrawlQueueEntries>;
  logZapierPipedriveActivity?: Maybe<LogZapierPipedriveActivity>;
  markAllCrawlResultsAsValidated?: Maybe<MarkAllCrawlResultsAsValidated>;
  markCompanyAsNotSoftware?: Maybe<MarkCompanyAsNotSoftware>;
  markCompanyAsSoftware?: Maybe<MarkCompanyAsSoftware>;
  markCustomerReferenceObsolete?: Maybe<MarkCustomerReferenceObsolete>;
  markProductAsHorizontal?: Maybe<MarkProductAsHorizontal>;
  matchCompanyWithOpenRegistry?: Maybe<MatchCompanyWithOpenRegistry>;
  mergeCompanies?: Maybe<MergeCompanies>;
  moveCompanyToAnotherSharedDrive?: Maybe<MoveCompanyToAnotherSharedDrive>;
  precalculateAllKpis?: Maybe<PreCalculateAllKpIs>;
  precalculateKpis?: Maybe<PreCalculateKpIs>;
  predictBuyAndBuildRelevanceForCompany?: Maybe<PredictBuyAndBuildRelevanceForCompany>;
  predictCallabilityForCompany?: Maybe<PredictCallabilityForCompany>;
  processG2Snapshot?: Maybe<ProcessG2Snapshot>;
  reclassifyCustomerSegment?: Maybe<ReclassifyCustomerSegmentMutation>;
  recomputeCentroidThresholds?: Maybe<RecomputeCentroidThresholds>;
  reconcileCrawlerInbox?: Maybe<ReconcileCrawlerInboxMutation>;
  recordPatternMatchFeedback?: Maybe<RecordPatternMatchFeedback>;
  recordSignalFeedback?: Maybe<RecordSignalFeedback>;
  refreshCompanyGoogleDriveFiles?: Maybe<RefreshCompanyGoogleDriveFiles>;
  refreshResearch?: Maybe<RefreshResearch>;
  refreshValidationInbox?: Maybe<RefreshValidationInbox>;
  regenerateAllDas?: Maybe<RegenerateAllDAs>;
  rejectCoreKeyword?: Maybe<RejectCoreKeyword>;
  releaseValidationLock?: Maybe<ReleaseValidationLock>;
  removeCompanyCertification?: Maybe<RemoveCompanyCertification>;
  removeShortlistedBuyAndBuildTargets?: Maybe<RemoveShortlistedBuyAndBuildTarget>;
  renewValidationLock?: Maybe<RenewValidationLock>;
  resegmentAllCustomers?: Maybe<ResegmentAllCustomersMutation>;
  resegmentAllCustomersWithLlmHits?: Maybe<ResegmentAllCustomerWithLlmHitsMutation>;
  resetDealAssessmentUpload?: Maybe<ResetDealAssessmentUpload>;
  retestFailedImages?: Maybe<ImageDownloadTestResponse>;
  retrieveSeoDataForKeywords?: Maybe<RetrieveSeoDataForKeywords>;
  saveAnnotation?: Maybe<SaveAnnotation>;
  saveDealTransaction?: Maybe<SaveDealTransaction>;
  saveValidationKeyword?: Maybe<SaveValidationKeywordResult>;
  scheduledMongoEmbeddingCreationForCompanies?: Maybe<ScheduledMongoEmbeddingCreationForCompanies>;
  scheduledRetrievalOfOpenaiBatchJobs?: Maybe<ScheduledRetrievalOfOpenaiBatchJobs>;
  searchForSourceScrubTags?: Maybe<SearchForSourceScrubTags>;
  seedCertificationTaxonomy?: Maybe<SeedCertificationTaxonomy>;
  seedHomepageGateData?: Maybe<SeedHomepageGateDataMutation>;
  segmentCustomer?: Maybe<SegmentCustomerMutation>;
  sendMessage?: Maybe<ChatResponseType>;
  setCompanyGoogleDriveRootDir?: Maybe<SetCompanyGoogleDriveRootDir>;
  setCompanySize?: Maybe<SetCompanySize>;
  setProductCategoryToZero?: Maybe<SetProductCategoryToZero>;
  shortlistBuyAndBuildTarget?: Maybe<ShortlistBuyAndBuildTarget>;
  startCddAnalysis?: Maybe<StartCddAnalysisMutation>;
  startCddExperiment?: Maybe<StartCddExperimentMutation>;
  startCompanyVerificationSession?: Maybe<StartCompanyVerificationSession>;
  startCrawler?: Maybe<StartCrawlerMutation>;
  startResearch?: Maybe<StartResearch>;
  submitCentroidRating?: Maybe<SubmitCentroidRating>;
  submitSurveyResponse?: Maybe<SubmitSurveyResponse>;
  syncYcCompanies?: Maybe<SyncYcCompanies>;
  synthesizeCompanyAnalysis?: Maybe<SynthesizeCompanyAnalysisMutation>;
  synthesizeCoreKeywords?: Maybe<SynthesizeCoreKeywords>;
  testBrightdataLinkedinCompanyData?: Maybe<TestBrightdataLinkedinCompanyData>;
  testCompanyNameFinder?: Maybe<TestCompanyNameFinder>;
  testCompanySizeNameValidation?: Maybe<ValidationTestResult>;
  testCustomerValidation?: Maybe<ValidationTestResult>;
  testDirectoryNameFinder?: Maybe<TestDirectoryNameFinder>;
  testEmailSending?: Maybe<TestEmailSending>;
  testFteExtraction?: Maybe<TestFteExtraction>;
  testGetSourcescrubData?: Maybe<TestGetSourcescrubData>;
  testImageDownload?: Maybe<ImageDownloadTestResponse>;
  testKeywordValidation?: Maybe<ValidationTestResult>;
  testLlmCustomerSegmentation?: Maybe<TestLlmCustomerSegmentationMutation>;
  testPipedriveDealCreation?: Maybe<TestPipedriveDealCreation>;
  testRetrievalOfOpenaiBatchJob?: Maybe<TestRetrievalOfOpenaiBatchJob>;
  testS3Event?: Maybe<TestS3Event>;
  testStackshareToolAnalysis?: Maybe<TestStackshareToolAnalysis>;
  testValidationChain?: Maybe<ValidationTestResult>;
  trainBuyAndBuildRelevanceModel?: Maybe<TrainBuyAndBuildRelevanceModel>;
  trainCallabilityModel?: Maybe<TrainCallabilityModel>;
  trainSizeEstimatorModel?: Maybe<TrainSizeEstimatorModel>;
  transferBuyAndBuildTargetsToPipedrive?: Maybe<TransferBuyAndBuildTargetsToPipedrive>;
  transferXoviKeywordToCoreKeywords?: Maybe<TransferXoviKeywordToCoreKeywords>;
  triggerCategoryAiScoring?: Maybe<TriggerCategoryAiScoring>;
  triggerInboxV2Recrawl?: Maybe<TriggerInboxV2Recrawl>;
  triggerPatternEvaluation?: Maybe<TriggerPatternEvaluation>;
  triggerPatternGeneration?: Maybe<TriggerPatternGeneration>;
  triggerScheduledAiValidation?: Maybe<ScheduledValidationResult>;
  triggerValidation?: Maybe<TriggerValidationResult>;
  triggerValuationForecast?: Maybe<TriggerValuationForecast>;
  triggerValuationForecastAll?: Maybe<TriggerValuationForecastAll>;
  triggerYcCrawls?: Maybe<TriggerYcCrawls>;
  unlockCrawlQueueEntries?: Maybe<UnlockCrawlQueueEntries>;
  updateCertification?: Maybe<UpdateCertification>;
  updateClassificationPattern?: Maybe<UpdateClassificationPattern>;
  updateCompanyGoogleDriveConfig?: Maybe<UpdateCompanyGoogleDriveConfig>;
  updateCompanyProduct?: Maybe<UpdateCompanyProduct>;
  updateCortexConfig?: Maybe<UpdateCortexConfig>;
  updateCrawlQueueConfig?: Maybe<UpdateCrawlQueueConfig>;
  updateCustomerSegment?: Maybe<UpdateCustomerSegmentMutation>;
  updateExchangeRates?: Maybe<UpdateAllExchangeRates>;
  updateFinancialForecastParams?: Maybe<UpdateFinancialForecastParams>;
  updatePatternOutcomesForCompany?: Maybe<UpdatePatternOutcomesForCompany>;
  updateProductPricing?: Maybe<UpdateProductPricing>;
  updateRedbeatSchedule?: Maybe<UpdateRedBeatSchedule>;
  updateSoftwareCategoryAiScore?: Maybe<UpdateSoftwareCategoryAiScore>;
  updateVibeCodingIdea?: Maybe<UpdateVibeCodingIdea>;
  upgradeAlembic?: Maybe<UpgradeAlembic>;
  uploadExcelCell?: Maybe<UploadExcelCellMutation>;
  uploadExcelFile?: Maybe<UploadExcelFileMutation>;
  uploadExcelFileChunk?: Maybe<UploadExcelFileChunkMutation>;
  uploadExcelRow?: Maybe<UploadExcelRowMutation>;
  uploadExcelSheet?: Maybe<UploadExcelSheetMutation>;
  uploadFile?: Maybe<UploadFileResponse>;
  uploadIndustryBenchmarkData?: Maybe<UploadIndustryBenchmarkData>;
  upvoteFindingsToken?: Maybe<UpvoteFindingsToken>;
  validateCompanyWithRag?: Maybe<ValidateCompanyWithRag>;
  verifyCompanyCertification?: Maybe<VerifyCompanyCertification>;
};


export type MutationsAcquireValidationLockArgs = {
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationsActivateProbationaryPatternArgs = {
  patternId: Scalars['Int']['input'];
};


export type MutationsAddBuyAndBuildTargetArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Float']['input']>;
  setManualScore?: InputMaybe<Scalars['Boolean']['input']>;
  softwareCompanyId: Scalars['Int']['input'];
  sourcescrubTags?: InputMaybe<Scalars['String']['input']>;
  targetCompanyId?: InputMaybe<Scalars['Int']['input']>;
  targetCompanyUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsAddBuyAndBuildTargetsFromSourcescrubArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  softwareCompanyId: Scalars['Int']['input'];
};


export type MutationsAddCompanyCertificationArgs = {
  certificationId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
};


export type MutationsAddCoreKeywordArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  keyword: Scalars['String']['input'];
};


export type MutationsAddCustomerSegmentArgs = {
  input: CustomerSegmentInput;
};


export type MutationsAddIndustryArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  referencedAt: Scalars['String']['input'];
  sicCode: Scalars['String']['input'];
};


export type MutationsAddJobDescriptionUrlArgs = {
  companyId: Scalars['Int']['input'];
  jobDescriptionUrl: Scalars['String']['input'];
};


export type MutationsAddSoftwareCategoryToCompanyArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  softwareCategoryId: Scalars['Int']['input'];
};


export type MutationsAddTechnologyFindingTextArgs = {
  companyId: Scalars['Int']['input'];
  findingText: Scalars['String']['input'];
};


export type MutationsAddTechnologyFindingUrlArgs = {
  companyId: Scalars['Int']['input'];
  findingUrl: Scalars['String']['input'];
};


export type MutationsAdjustPatternWeightsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsAllowImmediateCrawlArgs = {
  companyId: Scalars['Int']['input'];
  deleteDbEntries?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsBackfillCoreKeywordsArgs = {
  input: BackfillCoreKeywordsInput;
};


export type MutationsBackfillEmbeddingsV2Args = {
  input?: InputMaybe<BackfillEmbeddingsV2Input>;
};


export type MutationsBackfillHrKeywordsAndSicArgs = {
  input?: InputMaybe<BackfillHrKeywordsAndSicInput>;
};


export type MutationsBackfillHrOfficerBridgeArgs = {
  input?: InputMaybe<BackfillHrOfficerBridgeInput>;
};


export type MutationsBackfillHrRelatedPersonsArgs = {
  input?: InputMaybe<BackfillHrRelatedPersonsInput>;
};


export type MutationsBackfillTokensArgs = {
  input: BackfillTokensInput;
};


export type MutationsBoughtByPeArgs = {
  buyerGenericShareholderId: Scalars['Int']['input'];
  targetCompanyId: Scalars['Int']['input'];
};


export type MutationsBulkEstimateGdriveConfigArgs = {
  autoConfigureHighConfidence?: InputMaybe<Scalars['Boolean']['input']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsCleanupCrawlResultsArgs = {
  domain: Scalars['String']['input'];
};


export type MutationsComputeHomepageGateCentroidsArgs = {
  minNonSw?: InputMaybe<Scalars['Int']['input']>;
  minSw?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsConfirmCompanyGdriveConfigArgs = {
  companyId: Scalars['Int']['input'];
  createIfNotExists?: InputMaybe<Scalars['Boolean']['input']>;
  directoryName: Scalars['String']['input'];
  sharedDriveName: Scalars['String']['input'];
};


export type MutationsConfirmFteSizeArgs = {
  companyId: Scalars['Int']['input'];
  crawlResultId: Scalars['Int']['input'];
  isConfirmedChange: Scalars['Boolean']['input'];
  newFte: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationsCortexFeedbackPipedriveBridgeArgs = {
  addOnExisting?: InputMaybe<Scalars['Boolean']['input']>;
  addOnForBidId?: InputMaybe<Scalars['Int']['input']>;
  addOnFuture?: InputMaybe<Scalars['Boolean']['input']>;
  authId?: InputMaybe<Scalars['String']['input']>;
  b2c?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['Int']['input'];
  createDeal?: InputMaybe<Scalars['Boolean']['input']>;
  createOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  newPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  otherOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  partOfGroup?: InputMaybe<Scalars['Boolean']['input']>;
  rejectedAtStep?: InputMaybe<Scalars['String']['input']>;
  reseller?: InputMaybe<Scalars['Boolean']['input']>;
  saas?: InputMaybe<Scalars['Boolean']['input']>;
  selectValue?: InputMaybe<Scalars['String']['input']>;
  sellsHardware?: InputMaybe<Scalars['Boolean']['input']>;
  tooBig?: InputMaybe<Scalars['Boolean']['input']>;
  tooMuchConsulting?: InputMaybe<Scalars['Boolean']['input']>;
  tooSmall?: InputMaybe<Scalars['Boolean']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  venture?: InputMaybe<Scalars['Boolean']['input']>;
  wrongBusinessModel?: InputMaybe<Scalars['Boolean']['input']>;
  wrongGeography?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsCreateBenchmarkBalanceSheetArgs = {
  category1: Scalars['String']['input'];
  category2: Scalars['String']['input'];
  category3: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  period: Scalars['Int']['input'];
  periodEndDate: Scalars['Date']['input'];
  periodStartDate: Scalars['Date']['input'];
  periodType: Scalars['String']['input'];
  pipedriveDealId?: InputMaybe<Scalars['Int']['input']>;
  uploadFileName: Scalars['String']['input'];
  uploadFilePath: Scalars['String']['input'];
  uploaderName: Scalars['String']['input'];
  valuationLevel: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};


export type MutationsCreateBenchmarkCustomersAggregatedArgs = {
  category1: Scalars['String']['input'];
  category2: Scalars['String']['input'];
  category3: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  period: Scalars['Int']['input'];
  periodEndDate: Scalars['Date']['input'];
  periodStartDate: Scalars['Date']['input'];
  periodType: Scalars['String']['input'];
  pipedriveDealId?: InputMaybe<Scalars['Int']['input']>;
  uploadFileName: Scalars['String']['input'];
  uploadFilePath: Scalars['String']['input'];
  uploaderName: Scalars['String']['input'];
  valuationLevel: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};


export type MutationsCreateBenchmarkCustomersListArgs = {
  category1: Scalars['String']['input'];
  category2: Scalars['String']['input'];
  category3: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  period: Scalars['Int']['input'];
  periodEndDate: Scalars['Date']['input'];
  periodStartDate: Scalars['Date']['input'];
  periodType: Scalars['String']['input'];
  pipedriveDealId?: InputMaybe<Scalars['Int']['input']>;
  uploadFileName: Scalars['String']['input'];
  uploadFilePath: Scalars['String']['input'];
  uploaderName: Scalars['String']['input'];
  valuationLevel: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};


export type MutationsCreateBenchmarkFteArgs = {
  category1: Scalars['String']['input'];
  category2: Scalars['String']['input'];
  category3: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  period: Scalars['Int']['input'];
  periodEndDate: Scalars['Date']['input'];
  periodStartDate: Scalars['Date']['input'];
  periodType: Scalars['String']['input'];
  pipedriveDealId?: InputMaybe<Scalars['Int']['input']>;
  uploadFileName: Scalars['String']['input'];
  uploadFilePath: Scalars['String']['input'];
  uploaderName: Scalars['String']['input'];
  valuationLevel: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};


export type MutationsCreateBenchmarkPlArgs = {
  category1: Scalars['String']['input'];
  category2?: InputMaybe<Scalars['String']['input']>;
  category3?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  period: Scalars['Int']['input'];
  periodEndDate?: InputMaybe<Scalars['Date']['input']>;
  periodStartDate?: InputMaybe<Scalars['Date']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  pipedriveDealId?: InputMaybe<Scalars['Int']['input']>;
  uploadFileName?: InputMaybe<Scalars['String']['input']>;
  uploadFilePath?: InputMaybe<Scalars['String']['input']>;
  uploaderName?: InputMaybe<Scalars['String']['input']>;
  valuationLevel: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};


export type MutationsCreateBenchmarkPricingArgs = {
  category1: Scalars['String']['input'];
  category2: Scalars['String']['input'];
  category3: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  period: Scalars['Int']['input'];
  periodEndDate: Scalars['Date']['input'];
  periodStartDate: Scalars['Date']['input'];
  periodType: Scalars['String']['input'];
  pipedriveDealId?: InputMaybe<Scalars['Int']['input']>;
  uploadFileName: Scalars['String']['input'];
  uploadFilePath: Scalars['String']['input'];
  uploaderName: Scalars['String']['input'];
  valuationLevel: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};


export type MutationsCreateCertificationArgs = {
  aiMoatLevel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationsCreateClassificationPatternArgs = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  input: PatternCreateInput;
};


export type MutationsCreateCompanyProductArgs = {
  companyId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  pricing?: InputMaybe<Array<InputMaybe<PricingTierInput>>>;
  productName: Scalars['String']['input'];
  productType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateKeywordsArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  genericCrawlResultId?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchEngine?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateMeetingArgs = {
  attendeeUserIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  domain: Scalars['String']['input'];
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  externalAttendeeEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  meetingDate: Scalars['DateTime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateQuestionnaireVersionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  questions: Scalars['JSONString']['input'];
  title: Scalars['String']['input'];
};


export type MutationsCreateRedbeatScheduleArgs = {
  crontabDayOfMonth?: InputMaybe<Scalars['String']['input']>;
  crontabDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  crontabHour?: InputMaybe<Scalars['String']['input']>;
  crontabMinute?: InputMaybe<Scalars['String']['input']>;
  intervalSeconds?: InputMaybe<Scalars['Float']['input']>;
  kwargs?: InputMaybe<Scalars['JSONString']['input']>;
  name: Scalars['String']['input'];
  queue?: InputMaybe<Scalars['String']['input']>;
  scheduleType: Scalars['String']['input'];
  task: Scalars['String']['input'];
};


export type MutationsCreateUpdateCategoryArgs = {
  companyId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subCategory1?: InputMaybe<Scalars['String']['input']>;
  subCategory2?: InputMaybe<Scalars['String']['input']>;
  subCategory3?: InputMaybe<Scalars['String']['input']>;
  subCategory4?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateUpdateCompanyTechUseArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  findingUrl?: InputMaybe<Scalars['String']['input']>;
  genericCompanyTechUseId?: InputMaybe<Scalars['Int']['input']>;
  markedAsFalsePositive?: InputMaybe<Scalars['Boolean']['input']>;
  stackshareToolId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsCreateUpdateGenericShareholderArgs = {
  genericCompanyId?: InputMaybe<Scalars['Int']['input']>;
  genericShareholderId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  typeOfInvestor?: InputMaybe<Scalars['String']['input']>;
  yearBornOrFounded?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsCreateUpdateGenericShareholdingArgs = {
  genericCompanyId?: InputMaybe<Scalars['Int']['input']>;
  genericShareholderId?: InputMaybe<Scalars['Int']['input']>;
  genericShareholdingId?: InputMaybe<Scalars['Int']['input']>;
  holding?: InputMaybe<Scalars['Float']['input']>;
  holdingCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsCreateUpdateKeywordArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  genericCrawlResultId?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  keywordId?: InputMaybe<Scalars['Int']['input']>;
  searchEngine?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsDeleteAllBmForCompanyArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsDeleteCertificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationsDeleteClassificationPatternArgs = {
  patternId: Scalars['Int']['input'];
};


export type MutationsDeleteCompanyProductArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationsDeleteCompanyTechUseArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  techUseId: Scalars['Int']['input'];
};


export type MutationsDeleteCrawlQueueEntriesArgs = {
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationsDeleteCustomerReferenceArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  customerReferenceId: Scalars['Int']['input'];
};


export type MutationsDeleteCustomerSegmentArgs = {
  segmentId: Scalars['Int']['input'];
};


export type MutationsDeleteGenericShareholderArgs = {
  genericShareholderId: Scalars['Int']['input'];
};


export type MutationsDeleteGenericShareholdingArgs = {
  genericShareholdingId: Scalars['Int']['input'];
};


export type MutationsDeleteKeywordArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  keywordId: Scalars['Int']['input'];
};


export type MutationsDeleteKeywordsArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  keywordIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationsDeletePdfDocumentAnnotationArgs = {
  annotationId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsDeleteProbationaryPatternArgs = {
  patternId: Scalars['Int']['input'];
};


export type MutationsDeleteRedbeatScheduleArgs = {
  name: Scalars['String']['input'];
};


export type MutationsDeleteSelectedCompanyTechUseArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  techUseIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationsDeleteSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationsDeleteSoftwareCategoryAiScoreArgs = {
  categoryId: Scalars['Int']['input'];
};


export type MutationsDownvoteFindingsTokenArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  tokenId: Scalars['Int']['input'];
};


export type MutationsEditCompanyArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  benchmarkingIndex?: InputMaybe<Scalars['Int']['input']>;
  buyAndBuildFocus?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyDescription?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['String']['input']>;
  foundingYear?: InputMaybe<Scalars['Int']['input']>;
  hrbNumber?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  pipedriveId?: InputMaybe<Scalars['Int']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  sicCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsEditCustomerReferenceArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  arr?: InputMaybe<Scalars['Int']['input']>;
  customerReferenceId: Scalars['Int']['input'];
  customerReferenceName?: InputMaybe<Scalars['String']['input']>;
  isDdDatapoint?: InputMaybe<Scalars['Boolean']['input']>;
  lossReason?: InputMaybe<Scalars['String']['input']>;
  lostYear?: InputMaybe<Scalars['Int']['input']>;
  nps?: InputMaybe<Scalars['Int']['input']>;
  revenueYearOne?: InputMaybe<Scalars['Int']['input']>;
  revenueYearTwo?: InputMaybe<Scalars['Int']['input']>;
  shareOfRevenue?: InputMaybe<Scalars['Float']['input']>;
  users?: InputMaybe<Scalars['Int']['input']>;
  wonYear?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsEnrichCompanyContactArgs = {
  input: EnrichCompanyContactInput;
};


export type MutationsEstimateCompanyGdriveConfigArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsEvaluateSignalsArgs = {
  companyId: Scalars['Int']['input'];
  signals: Array<InputMaybe<SignalInput>>;
  validationResultId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsFinishCompanyValidationArgs = {
  authId: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationsFinishCrawlResultValidationArgs = {
  authId: Scalars['String']['input'];
  crawlResultId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationsFinishExcelFileUploadArgs = {
  fileId: Scalars['Int']['input'];
  onlyFinancialKpis?: InputMaybe<Scalars['Boolean']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsGatherHandelsregisterApiDataArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsGenerateCrawlPlanArgs = {
  input: GenerateCrawlPlanInput;
};


export type MutationsGeneratePatternsFromKeywordsArgs = {
  autoActivate?: InputMaybe<Scalars['Boolean']['input']>;
  classificationTarget?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  keywords: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationsGenerateVibeCodingIdeasArgs = {
  maxIdeas?: InputMaybe<Scalars['Int']['input']>;
  portfolioCompanyId: Scalars['Int']['input'];
};


export type MutationsInsertCertainProductCategoryArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  productCategorizationId: Scalars['Int']['input'];
};


export type MutationsLabelBuyAndBuildTargetQualityArgs = {
  quality: Scalars['Float']['input'];
  softwareCompanyId: Scalars['Int']['input'];
  targetCompanyId: Scalars['Int']['input'];
};


export type MutationsLoadImageLearnerArgs = {
  dirPrefix?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsLockCrawlQueueEntriesArgs = {
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationsLogZapierPipedriveActivityArgs = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<Scalars['JSONString']['input']>;
  pipedriveId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uniqueDomain?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsMarkCompanyAsNotSoftwareArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  crawlResultId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsMarkCompanyAsSoftwareArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  crawlResultId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsMarkCustomerReferenceObsoleteArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  customerReferenceId: Scalars['Int']['input'];
};


export type MutationsMarkProductAsHorizontalArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  softwareCompanyId: Scalars['Int']['input'];
};


export type MutationsMatchCompanyWithOpenRegistryArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsMergeCompaniesArgs = {
  sourceCompanyId: Scalars['Int']['input'];
  targetCompanyId: Scalars['Int']['input'];
};


export type MutationsMoveCompanyToAnotherSharedDriveArgs = {
  companyId: Scalars['Int']['input'];
  gdriveDirectoryId?: InputMaybe<Scalars['String']['input']>;
  gdriveDirectoryName: Scalars['String']['input'];
  newSharedDriveName: Scalars['String']['input'];
};


export type MutationsPrecalculateAllKpisArgs = {
  companyId: Scalars['Int']['input'];
  financialOnly?: InputMaybe<Scalars['Boolean']['input']>;
  onlyCreateNew?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsPrecalculateKpisArgs = {
  ageOfProgrammingLanguage?: InputMaybe<Scalars['Boolean']['input']>;
  allBidPortfolioCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  allKpis?: InputMaybe<Scalars['Boolean']['input']>;
  allSoftwareCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  allUnvalidatedCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  allValidatedCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  buyAndBuildScore?: InputMaybe<Scalars['Boolean']['input']>;
  callabilityScore?: InputMaybe<Scalars['Boolean']['input']>;
  customerIndustries?: InputMaybe<Scalars['Boolean']['input']>;
  customerIndustryGrowth?: InputMaybe<Scalars['Boolean']['input']>;
  employeeConcentrationRatio?: InputMaybe<Scalars['Boolean']['input']>;
  financialKpis?: InputMaybe<Scalars['Boolean']['input']>;
  onlineVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  popularityOfProgrammingLanguage?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerGoogleKeywordClick?: InputMaybe<Scalars['Boolean']['input']>;
  softwareCategoryGrowth?: InputMaybe<Scalars['Boolean']['input']>;
  teamQuality?: InputMaybe<Scalars['Boolean']['input']>;
  useOfBackendFramework?: InputMaybe<Scalars['Boolean']['input']>;
  useOfFrontendFramework?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsPredictBuyAndBuildRelevanceForCompanyArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsPredictCallabilityForCompanyArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsProcessG2SnapshotArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  snapshotId: Scalars['String']['input'];
  useBatchedApi?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsReclassifyCustomerSegmentArgs = {
  customerDomain: Scalars['String']['input'];
};


export type MutationsRecomputeCentroidThresholdsArgs = {
  centroidVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsRecordPatternMatchFeedbackArgs = {
  patternMatchId: Scalars['Int']['input'];
  userFeedback?: InputMaybe<Scalars['String']['input']>;
  wasCorrect: Scalars['Boolean']['input'];
};


export type MutationsRecordSignalFeedbackArgs = {
  input: SignalFeedbackInput;
};


export type MutationsRefreshCompanyGoogleDriveFilesArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsRefreshResearchArgs = {
  companyDomain: Scalars['String']['input'];
  researchType: Scalars['String']['input'];
};


export type MutationsRejectCoreKeywordArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  keywordId: Scalars['Int']['input'];
};


export type MutationsReleaseValidationLockArgs = {
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationsRemoveCompanyCertificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationsRemoveShortlistedBuyAndBuildTargetsArgs = {
  softwareCompanyId: Scalars['Int']['input'];
  targetCompanyId: Scalars['Int']['input'];
};


export type MutationsRenewValidationLockArgs = {
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationsResegmentAllCustomersArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsResegmentAllCustomersWithLlmHitsArgs = {
  filterCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxNCustomers?: InputMaybe<Scalars['Int']['input']>;
  onlyCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  softwareCompanyId: Scalars['Int']['input'];
};


export type MutationsResetDealAssessmentUploadArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsRetestFailedImagesArgs = {
  domain: Scalars['String']['input'];
  maxImages?: InputMaybe<Scalars['Int']['input']>;
  useBestStrategy?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsRetrieveSeoDataForKeywordsArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsSaveAnnotationArgs = {
  annotationPageNumber?: InputMaybe<Scalars['Int']['input']>;
  authorId?: InputMaybe<Scalars['Int']['input']>;
  pdfDocumentAnnotationId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  uploadFileId?: InputMaybe<Scalars['Int']['input']>;
  xLocation?: InputMaybe<Scalars['Int']['input']>;
  yLocation?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsSaveDealTransactionArgs = {
  amountRaised?: InputMaybe<Scalars['Float']['input']>;
  dateOfTransaction?: InputMaybe<Scalars['String']['input']>;
  forceTargetIsSoftwareCompany?: InputMaybe<Scalars['Boolean']['input']>;
  listOfBuyers: Array<ShareholderInputType>;
  listOfSellers?: InputMaybe<Array<ShareholderInputType>>;
  targetCompanyCountry?: InputMaybe<Scalars['String']['input']>;
  targetCompanyDomain?: InputMaybe<Scalars['String']['input']>;
  targetCompanyId?: InputMaybe<Scalars['Int']['input']>;
  targetCompanyName?: InputMaybe<Scalars['String']['input']>;
  totalAmountRaised?: InputMaybe<Scalars['Float']['input']>;
  transactionType?: InputMaybe<Scalars['String']['input']>;
  typeOfTransaction?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSaveValidationKeywordArgs = {
  companyId: Scalars['Int']['input'];
  confidence?: InputMaybe<Scalars['Float']['input']>;
  isSoftware?: InputMaybe<Scalars['Boolean']['input']>;
  keyword: Scalars['String']['input'];
  source: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationsScheduledMongoEmbeddingCreationForCompaniesArgs = {
  noOfCompaniesToProcess?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsScheduledRetrievalOfOpenaiBatchJobsArgs = {
  endpoint?: InputMaybe<Scalars['String']['input']>;
  fifo?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsSearchForSourceScrubTagsArgs = {
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationsSeedHomepageGateDataArgs = {
  maxCompanies?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsSegmentCustomerArgs = {
  avoidDomainLookup?: InputMaybe<Scalars['Boolean']['input']>;
  customerCountry?: InputMaybe<Scalars['String']['input']>;
  customerDomain?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerReferenceName?: InputMaybe<Scalars['String']['input']>;
  deepCrawl?: InputMaybe<Scalars['Boolean']['input']>;
  doNotQueue?: InputMaybe<Scalars['Boolean']['input']>;
  estimateSize?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<SegmentCustomerInputType>;
  noCache?: InputMaybe<Scalars['Boolean']['input']>;
  softwareCompanyId: Scalars['Int']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationsSetCompanyGoogleDriveRootDirArgs = {
  companyId: Scalars['Int']['input'];
  gdriveDirectoryId?: InputMaybe<Scalars['String']['input']>;
  gdriveDirectoryName: Scalars['String']['input'];
};


export type MutationsSetCompanySizeArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  findingUrl?: InputMaybe<Scalars['String']['input']>;
  fte: Scalars['Int']['input'];
  typeOfFinding?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsSetProductCategoryToZeroArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  productCategorizationId: Scalars['Int']['input'];
};


export type MutationsShortlistBuyAndBuildTargetArgs = {
  softwareCompanyId: Scalars['Int']['input'];
  targetCompanyId: Scalars['Int']['input'];
};


export type MutationsStartCddAnalysisArgs = {
  input: StartCddAnalysisInput;
};


export type MutationsStartCddExperimentArgs = {
  input: StartCddExperimentInput;
};


export type MutationsStartCompanyVerificationSessionArgs = {
  authId: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
};


export type MutationsStartCrawlerArgs = {
  avoidReCrawl?: InputMaybe<Scalars['Boolean']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyCountry?: InputMaybe<Scalars['String']['input']>;
  companyDescription?: InputMaybe<Scalars['String']['input']>;
  companyFte?: InputMaybe<Scalars['Int']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyYearFounded?: InputMaybe<Scalars['Int']['input']>;
  domain: Scalars['String']['input'];
  forceDeepAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  forceSw?: InputMaybe<Scalars['Boolean']['input']>;
  pipedriveId?: InputMaybe<Scalars['Int']['input']>;
  quickCrawlOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsStartResearchArgs = {
  input: StartResearchInput;
};


export type MutationsSubmitCentroidRatingArgs = {
  companyId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  verdict: Scalars['String']['input'];
};


export type MutationsSubmitSurveyResponseArgs = {
  answers: Scalars['JSONString']['input'];
  meetingId: Scalars['Int']['input'];
};


export type MutationsSyncYcCompaniesArgs = {
  enrich?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsSynthesizeCompanyAnalysisArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsSynthesizeCoreKeywordsArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsTestBrightdataLinkedinCompanyDataArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsTestCompanyNameFinderArgs = {
  companyName: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsTestCompanySizeNameValidationArgs = {
  companyId: Scalars['Int']['input'];
  forceShadowMode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsTestCustomerValidationArgs = {
  companyId: Scalars['Int']['input'];
  shadowMode?: InputMaybe<Scalars['Boolean']['input']>;
  targetCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsTestDirectoryNameFinderArgs = {
  dirName: Scalars['String']['input'];
};


export type MutationsTestEmailSendingArgs = {
  body: Scalars['String']['input'];
  s3Key?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};


export type MutationsTestFteExtractionArgs = {
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsTestGetSourcescrubDataArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsTestImageDownloadArgs = {
  domain: Scalars['String']['input'];
  maxImages?: InputMaybe<Scalars['Int']['input']>;
  testStrategies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationsTestKeywordValidationArgs = {
  companyId: Scalars['Int']['input'];
  shadowMode?: InputMaybe<Scalars['Boolean']['input']>;
  targetCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsTestLlmCustomerSegmentationArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsTestPipedriveDealCreationArgs = {
  companyId: Scalars['Int']['input'];
  platformCompanyId?: InputMaybe<Scalars['Int']['input']>;
  useZapier?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsTestRetrievalOfOpenaiBatchJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationsTestS3EventArgs = {
  bucket: Scalars['String']['input'];
  event?: InputMaybe<Scalars['String']['input']>;
  objectKey: Scalars['String']['input'];
};


export type MutationsTestValidationChainArgs = {
  companyId: Scalars['Int']['input'];
  forceShadowMode?: InputMaybe<Scalars['Boolean']['input']>;
  targetCustomers?: InputMaybe<Scalars['Int']['input']>;
  targetKeywords?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsTransferBuyAndBuildTargetsToPipedriveArgs = {
  shorlistedTargetsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  softwareCompanyId: Scalars['Int']['input'];
};


export type MutationsTransferXoviKeywordToCoreKeywordsArgs = {
  companyId: Scalars['Int']['input'];
  xoviKeywordId: Scalars['Int']['input'];
};


export type MutationsTriggerCategoryAiScoringArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsTriggerPatternGenerationArgs = {
  daysLookback?: InputMaybe<Scalars['Int']['input']>;
  minConsistency?: InputMaybe<Scalars['Float']['input']>;
  minOccurrences?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsTriggerScheduledAiValidationArgs = {
  forceRefreshView?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsTriggerValidationArgs = {
  companyId: Scalars['Int']['input'];
  validationType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsTriggerValuationForecastArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationsTriggerYcCrawlsArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUnlockCrawlQueueEntriesArgs = {
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationsUpdateCertificationArgs = {
  aiMoatLevel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  issuer?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateClassificationPatternArgs = {
  input: PatternUpdateInput;
  patternId: Scalars['Int']['input'];
};


export type MutationsUpdateCompanyGoogleDriveConfigArgs = {
  companyId: Scalars['Int']['input'];
  gdriveDirectoryName?: InputMaybe<Scalars['String']['input']>;
  gdriveSharedDriveName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateCompanyProductArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateCortexConfigArgs = {
  attributes: Scalars['JSONString']['input'];
};


export type MutationsUpdateCrawlQueueConfigArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  intervalSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdateCustomerSegmentArgs = {
  input: CustomerSegmentInput;
  segmentId: Scalars['Int']['input'];
};


export type MutationsUpdateExchangeRatesArgs = {
  lastDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdateFinancialForecastParamsArgs = {
  params: Scalars['JSONString']['input'];
};


export type MutationsUpdatePatternOutcomesForCompanyArgs = {
  companyId: Scalars['Int']['input'];
  wasSoftware: Scalars['Boolean']['input'];
};


export type MutationsUpdateProductPricingArgs = {
  pricing: Array<InputMaybe<PricingTierInput>>;
  productId: Scalars['Int']['input'];
};


export type MutationsUpdateRedbeatScheduleArgs = {
  crontabDayOfMonth?: InputMaybe<Scalars['String']['input']>;
  crontabDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  crontabHour?: InputMaybe<Scalars['String']['input']>;
  crontabMinute?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  intervalSeconds?: InputMaybe<Scalars['Float']['input']>;
  kwargs?: InputMaybe<Scalars['JSONString']['input']>;
  name: Scalars['String']['input'];
  queue?: InputMaybe<Scalars['String']['input']>;
  scheduleType?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateSoftwareCategoryAiScoreArgs = {
  aiOpportunity?: InputMaybe<Scalars['Float']['input']>;
  categoryId: Scalars['Int']['input'];
  dimensionScores?: InputMaybe<Scalars['JSONString']['input']>;
  disruptionRisk?: InputMaybe<Scalars['Float']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateVibeCodingIdeaArgs = {
  id: Scalars['Int']['input'];
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userNotes?: InputMaybe<Scalars['String']['input']>;
  userRating?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpgradeAlembicArgs = {
  pin: Scalars['Int']['input'];
};


export type MutationsUploadExcelCellArgs = {
  input: UploadExcelCellInput;
};


export type MutationsUploadExcelFileArgs = {
  input: UploadExcelFileInput;
};


export type MutationsUploadExcelFileChunkArgs = {
  chunk: Scalars['String']['input'];
  fileId: Scalars['Int']['input'];
  isLastChunk: Scalars['Boolean']['input'];
};


export type MutationsUploadExcelRowArgs = {
  input: UploadExcelRowInput;
};


export type MutationsUploadExcelSheetArgs = {
  input: UploadExcelSheetInput;
};


export type MutationsUploadFileArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  file: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
  isBmFile?: InputMaybe<Scalars['Boolean']['input']>;
  makePubliclyAccessible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsUploadIndustryBenchmarkDataArgs = {
  data: Array<InputMaybe<IndustryBenchmarkInput>>;
};


export type MutationsUpvoteFindingsTokenArgs = {
  authId?: InputMaybe<Scalars['String']['input']>;
  tokenId: Scalars['Int']['input'];
};


export type MutationsValidateCompanyWithRagArgs = {
  companyDomain: Scalars['String']['input'];
  shadowMode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsVerifyCompanyCertificationArgs = {
  id: Scalars['Int']['input'];
  isVerified: Scalars['Boolean']['input'];
};

export type NextBatchRunType = {
  __typename?: 'NextBatchRunType';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  nextRunUtc?: Maybe<Scalars['DateTime']['output']>;
  scheduleLabel?: Maybe<Scalars['String']['output']>;
  weekdaySchedule?: Maybe<Scalars['String']['output']>;
  weekendSchedule?: Maybe<Scalars['String']['output']>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type OpenAiVoteConnection = {
  __typename?: 'OpenAIVoteConnection';
  edges: Array<Maybe<OpenAiVoteEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type OpenAiVoteEdge = {
  __typename?: 'OpenAIVoteEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<OpenAiVoteType>;
};

export type OpenAiVoteType = {
  __typename?: 'OpenAIVoteType';
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  detectedLanguage?: Maybe<Scalars['String']['output']>;
  findingsUrl?: Maybe<Scalars['String']['output']>;
  hasBeenManuallyChecked?: Maybe<Scalars['Boolean']['output']>;
  hasBeenOverwritten?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  openAiVote?: Maybe<Scalars['Int']['output']>;
  serviceVotes?: Maybe<Scalars['Int']['output']>;
  softwareVotes?: Maybe<Scalars['Int']['output']>;
  undecidable?: Maybe<Scalars['Int']['output']>;
};

export type OpenRegCompanyConnection = {
  __typename?: 'OpenRegCompanyConnection';
  edges: Array<Maybe<OpenRegCompanyEdge>>;
  pageInfo: PageInfo;
};

export type OpenRegCompanyEdge = {
  __typename?: 'OpenRegCompanyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<OpenRegCompanySqlType>;
};

export type OpenRegCompanySqlType = Node & {
  __typename?: 'OpenRegCompanySQLType';
  addressFulladdress?: Maybe<Scalars['String']['output']>;
  addressIscurrent?: Maybe<Scalars['String']['output']>;
  addressPlace?: Maybe<Scalars['String']['output']>;
  addressStreet?: Maybe<Scalars['String']['output']>;
  addressValidfrom?: Maybe<Scalars['String']['output']>;
  addressValidtill?: Maybe<Scalars['String']['output']>;
  addressZipandplace?: Maybe<Scalars['String']['output']>;
  addressZipcode?: Maybe<Scalars['String']['output']>;
  capitalAmount?: Maybe<Scalars['String']['output']>;
  capitalCurrency?: Maybe<Scalars['String']['output']>;
  capitalIscurrent?: Maybe<Scalars['String']['output']>;
  capitalValidfrom?: Maybe<Scalars['String']['output']>;
  capitalValidtill?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  dissolutionDate?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  firstSeenDate?: Maybe<Scalars['String']['output']>;
  foundedDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSeenDate?: Maybe<Scalars['String']['output']>;
  nameIscurrent?: Maybe<Scalars['String']['output']>;
  nameValidfrom?: Maybe<Scalars['String']['output']>;
  nameValidtill?: Maybe<Scalars['String']['output']>;
  objectiveEmbedding?: Maybe<Scalars['String']['output']>;
  objectiveIscurrent?: Maybe<Scalars['String']['output']>;
  objectiveText?: Maybe<Scalars['String']['output']>;
  objectiveValidfrom?: Maybe<Scalars['String']['output']>;
  objectiveValidtill?: Maybe<Scalars['String']['output']>;
  positionsAverageMdBirthYear?: Maybe<Scalars['String']['output']>;
  positionsMdCount?: Maybe<Scalars['String']['output']>;
  positionsOldestMd?: Maybe<Scalars['String']['output']>;
  positionsYoungestMd?: Maybe<Scalars['String']['output']>;
  referenceCourtCode?: Maybe<Scalars['String']['output']>;
  referenceCourtName?: Maybe<Scalars['String']['output']>;
  referenceFirstseen?: Maybe<Scalars['String']['output']>;
  referenceNativeReferenceNumber?: Maybe<Scalars['String']['output']>;
  referenceStdRefNo?: Maybe<Scalars['String']['output']>;
  referenceValidtill?: Maybe<Scalars['String']['output']>;
  s3LinkToFolderWithDocuments?: Maybe<Scalars['String']['output']>;
  s3LinkToShareholderList?: Maybe<Scalars['String']['output']>;
  suspectedSw?: Maybe<Scalars['Boolean']['output']>;
};

export type PdfDocumentAnnotationConnection = {
  __typename?: 'PDFDocumentAnnotationConnection';
  edges: Array<Maybe<PdfDocumentAnnotationEdge>>;
  pageInfo: PageInfo;
};

export type PdfDocumentAnnotationEdge = {
  __typename?: 'PDFDocumentAnnotationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PdfDocumentAnnotationType>;
};

export enum PdfDocumentAnnotationSortEnum {
  AnnotationPageNumberAsc = 'annotation_page_number_asc',
  AnnotationPageNumberDesc = 'annotation_page_number_desc',
  AuthorIdAsc = 'author_id_asc',
  AuthorIdDesc = 'author_id_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  GenericCompanyHypothesisIdAsc = 'generic_company_hypothesis_id_asc',
  GenericCompanyHypothesisIdDesc = 'generic_company_hypothesis_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  PdfDocumentAnnotationTypeIdAsc = 'pdf_document_annotation_type_id_asc',
  PdfDocumentAnnotationTypeIdDesc = 'pdf_document_annotation_type_id_desc',
  TextAsc = 'text_asc',
  TextDesc = 'text_desc',
  UploadFileIdAsc = 'upload_file_id_asc',
  UploadFileIdDesc = 'upload_file_id_desc',
  XLocationAsc = 'x_location_asc',
  XLocationDesc = 'x_location_desc',
  YLocationAsc = 'y_location_asc',
  YLocationDesc = 'y_location_desc'
}

export type PdfDocumentAnnotationType = Node & {
  __typename?: 'PDFDocumentAnnotationType';
  annotationPageNumber?: Maybe<Scalars['Int']['output']>;
  authorId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  genericCompanyHypothesisId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  pdfDocumentAnnotationTypeId?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  uploadFileId?: Maybe<Scalars['Int']['output']>;
  xLocation?: Maybe<Scalars['Int']['output']>;
  yLocation?: Maybe<Scalars['Int']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PatternCreateInput = {
  classificationTarget: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  patternText: Scalars['String']['input'];
  patternType: Scalars['String']['input'];
  semanticCategory?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type PatternEffectivenessType = {
  __typename?: 'PatternEffectivenessType';
  classificationTarget?: Maybe<Scalars['String']['output']>;
  correctMatches?: Maybe<Scalars['Int']['output']>;
  helpfulCount?: Maybe<Scalars['Int']['output']>;
  incorrectMatches?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  misleadingCount?: Maybe<Scalars['Int']['output']>;
  patternId?: Maybe<Scalars['Int']['output']>;
  patternText?: Maybe<Scalars['String']['output']>;
  pendingMatches?: Maybe<Scalars['Int']['output']>;
  precisionPct?: Maybe<Scalars['Float']['output']>;
  totalMatches?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PatternGenerationResultType = {
  __typename?: 'PatternGenerationResultType';
  createdCount?: Maybe<Scalars['Int']['output']>;
  createdPatterns?: Maybe<Scalars['JSONString']['output']>;
  errors?: Maybe<Scalars['JSONString']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PatternMatchResultType = {
  __typename?: 'PatternMatchResultType';
  classificationTarget?: Maybe<Scalars['String']['output']>;
  matchedText?: Maybe<Scalars['String']['output']>;
  patternId?: Maybe<Scalars['Int']['output']>;
  patternText?: Maybe<Scalars['String']['output']>;
  patternType?: Maybe<Scalars['String']['output']>;
  signalType?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PatternOverlapCheckResultType = {
  __typename?: 'PatternOverlapCheckResultType';
  hasOverlaps?: Maybe<Scalars['Boolean']['output']>;
  overlaps?: Maybe<Array<Maybe<PatternOverlapType>>>;
  overlapsCount?: Maybe<Scalars['Int']['output']>;
  rejectionMessage?: Maybe<Scalars['String']['output']>;
};

export type PatternOverlapType = {
  __typename?: 'PatternOverlapType';
  existingClassificationTarget?: Maybe<Scalars['String']['output']>;
  existingPatternId?: Maybe<Scalars['Int']['output']>;
  existingPatternText?: Maybe<Scalars['String']['output']>;
  existingPatternType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  overlapType?: Maybe<Scalars['String']['output']>;
};

export type PatternUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  semanticCategory?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type PerformanceStatsType = {
  __typename?: 'PerformanceStatsType';
  apolloCallRate?: Maybe<Scalars['Float']['output']>;
  apolloSuccessRate?: Maybe<Scalars['Float']['output']>;
  avgApolloTimeMs: Scalars['Float']['output'];
  avgCacheHitRate: Scalars['Float']['output'];
  avgExistingTimeMs: Scalars['Float']['output'];
  avgFirecrawlTimeMs: Scalars['Float']['output'];
  avgTotalTimeMs: Scalars['Float']['output'];
  firecrawlSuccessRate?: Maybe<Scalars['Float']['output']>;
  totalApolloCredits?: Maybe<Scalars['Float']['output']>;
  totalEnrichments: Scalars['Int']['output'];
  totalFirecrawlCredits: Scalars['Float']['output'];
  totalPagesCached: Scalars['Int']['output'];
  totalPagesScraped: Scalars['Int']['output'];
};

export type PerformanceSummaryType = {
  __typename?: 'PerformanceSummaryType';
  endDate: Scalars['DateTime']['output'];
  insights?: Maybe<Array<Maybe<InsightType>>>;
  layerTiming?: Maybe<LayerTimingType>;
  methodBreakdown?: Maybe<Array<Maybe<MethodBreakdownType>>>;
  startDate: Scalars['DateTime']['output'];
  summary?: Maybe<PerformanceStatsType>;
  timeRange: Scalars['String']['output'];
};

export type PipedriveActivityType = {
  __typename?: 'PipedriveActivityType';
  actionType?: Maybe<Scalars['String']['output']>;
  companyDomain?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['JSONString']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pipedriveId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type PipedriveDealType = {
  __typename?: 'PipedriveDealType';
  address?: Maybe<Scalars['String']['output']>;
  cortexId?: Maybe<Scalars['Int']['output']>;
  cortexUrl?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customerIndustrySic?: Maybe<Scalars['String']['output']>;
  dealId: Scalars['Int']['output'];
  dealProbability?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dfm?: Maybe<Scalars['Boolean']['output']>;
  ebit?: Maybe<Scalars['Float']['output']>;
  ebitda?: Maybe<Scalars['Float']['output']>;
  evBase?: Maybe<Scalars['String']['output']>;
  evEbitMultiple?: Maybe<Scalars['Float']['output']>;
  expectedCloseDate?: Maybe<Scalars['Date']['output']>;
  financialBase?: Maybe<Scalars['String']['output']>;
  fte?: Maybe<Scalars['Float']['output']>;
  grossArrChurn?: Maybe<Scalars['Float']['output']>;
  isB2bSoftware?: Maybe<Scalars['Boolean']['output']>;
  lostReason?: Maybe<Scalars['String']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  pipelineId?: Maybe<Scalars['Int']['output']>;
  platformOrganization?: Maybe<PipedriveOrganizationType>;
  platformOrganizationId?: Maybe<Scalars['Int']['output']>;
  recurringRevenueShare?: Maybe<Scalars['Float']['output']>;
  sales?: Maybe<Scalars['Float']['output']>;
  salesGrowth?: Maybe<Scalars['Float']['output']>;
  sector?: Maybe<Scalars['Int']['output']>;
  softwareShare?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetOrganizationId?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  top3CustomerShare?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PipedriveOrganizationType = {
  __typename?: 'PipedriveOrganizationType';
  addOnForName?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  cortexId?: Maybe<Scalars['Int']['output']>;
  cortexUrl?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  customerIndustries?: Maybe<Scalars['String']['output']>;
  dealId?: Maybe<Scalars['String']['output']>;
  deals?: Maybe<Array<Maybe<PipedriveDealType>>>;
  description?: Maybe<Scalars['String']['output']>;
  foundingYear?: Maybe<Scalars['String']['output']>;
  foundingYearInt?: Maybe<Scalars['Int']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  labelInt?: Maybe<Scalars['Int']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
  organizationType?: Maybe<Scalars['String']['output']>;
  platformOrganization?: Maybe<PipedriveOrganizationType>;
  platformOrganizationId?: Maybe<Scalars['Int']['output']>;
  softwareCompanyIndicator?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PipelineCoverageType = {
  __typename?: 'PipelineCoverageType';
  callCount?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  hasBeenCalled?: Maybe<Scalars['Boolean']['output']>;
  hasSurvey?: Maybe<Scalars['Boolean']['output']>;
  lastCallDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PnlYearRowType = {
  __typename?: 'PnlYearRowType';
  cogs?: Maybe<Scalars['Float']['output']>;
  da?: Maybe<Scalars['Float']['output']>;
  ebit?: Maybe<Scalars['Float']['output']>;
  ebitda?: Maybe<Scalars['Float']['output']>;
  fte?: Maybe<Scalars['Float']['output']>;
  grossProfit?: Maybe<Scalars['Float']['output']>;
  isForecast?: Maybe<Scalars['Boolean']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  pex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueGrowth?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type PreCalculateAllKpIs = {
  __typename?: 'PreCalculateAllKPIs';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type PreCalculateKpIs = {
  __typename?: 'PreCalculateKPIs';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PredictBuyAndBuildRelevanceForCompany = {
  __typename?: 'PredictBuyAndBuildRelevanceForCompany';
  prediction?: Maybe<Scalars['Float']['output']>;
};

export type PredictCallabilityForCompany = {
  __typename?: 'PredictCallabilityForCompany';
  prediction?: Maybe<Scalars['Float']['output']>;
};

export type PricingTierInput = {
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  priceDisplay?: InputMaybe<Scalars['String']['input']>;
  priceNumeric?: InputMaybe<Scalars['Float']['input']>;
  pricingModelType?: InputMaybe<Scalars['String']['input']>;
  tierName?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessG2Snapshot = {
  __typename?: 'ProcessG2Snapshot';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductCategorizationConnection = {
  __typename?: 'ProductCategorizationConnection';
  edges: Array<Maybe<ProductCategorizationEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type ProductCategorizationEdge = {
  __typename?: 'ProductCategorizationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ProductCategorizationType>;
};

export type ProductCategorizationType = Node & {
  __typename?: 'ProductCategorizationType';
  certainty?: Maybe<Scalars['Float']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  maxDistance?: Maybe<Scalars['Float']['output']>;
  minDistance?: Maybe<Scalars['Float']['output']>;
  softwareCategory?: Maybe<SoftwareCategoryType>;
  softwareCategoryCertainty?: Maybe<Scalars['Float']['output']>;
  softwareCategoryId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type ProductCategorizationTypeConnection = {
  __typename?: 'ProductCategorizationTypeConnection';
  edges: Array<Maybe<ProductCategorizationTypeEdge>>;
  pageInfo: PageInfo;
};

export type ProductCategorizationTypeEdge = {
  __typename?: 'ProductCategorizationTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ProductCategorizationType>;
};

export type ProductCategoryTrendPointType = {
  __typename?: 'ProductCategoryTrendPointType';
  date?: Maybe<Scalars['Date']['output']>;
  interest?: Maybe<Scalars['Int']['output']>;
  softwareCategoryId?: Maybe<Scalars['Int']['output']>;
  subCategory1?: Maybe<Scalars['String']['output']>;
};

export type ProductPricingModelType = Node & {
  __typename?: 'ProductPricingModelType';
  billingPeriod?: Maybe<Scalars['String']['output']>;
  classificationSessionId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  companyProduct?: Maybe<CompanyProductType>;
  companyProductId?: Maybe<Scalars['Int']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  crawlResultId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hasFreeTier?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCustomPricing?: Maybe<Scalars['Boolean']['output']>;
  isMostRecent?: Maybe<Scalars['Boolean']['output']>;
  keyFeatures?: Maybe<Scalars['String']['output']>;
  priceCadence?: Maybe<Scalars['String']['output']>;
  priceDisplay?: Maybe<Scalars['String']['output']>;
  priceNumeric?: Maybe<Scalars['Float']['output']>;
  priceUnit?: Maybe<Scalars['String']['output']>;
  priceUnitNormalized?: Maybe<Scalars['String']['output']>;
  pricingModelType?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  tierName?: Maybe<Scalars['String']['output']>;
  tierOrdinal?: Maybe<Scalars['Int']['output']>;
};

export type ProductTechnologylType = Node & {
  __typename?: 'ProductTechnologylType';
  ageOfTechnology?: Maybe<Scalars['Int']['output']>;
  breadcrumb?: Maybe<Scalars['String']['output']>;
  currentPrPopularity?: Maybe<Scalars['Float']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  followers?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isApiFramework?: Maybe<Scalars['Boolean']['output']>;
  isBackendFramework?: Maybe<Scalars['Boolean']['output']>;
  isFrontendFramework?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nerName?: Maybe<Scalars['String']['output']>;
  noOfPullRequestsLtm?: Maybe<Scalars['Int']['output']>;
  stacksUsed?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usedIn?: Maybe<GenericCompanyTechUseWithStackshareToolSqlTypeConnection>;
  votes?: Maybe<Scalars['Int']['output']>;
  yearOfInitialRelease?: Maybe<Scalars['Int']['output']>;
};


export type ProductTechnologylTypeUsedInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectionsType = {
  __typename?: 'ProjectionsType';
  monthlyCostProjection: Scalars['Float']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeQuestionnaire?: Maybe<QuestionnaireType>;
  activeRagValidations?: Maybe<Scalars['JSONString']['output']>;
  aiOpportunityFactors?: Maybe<Array<Maybe<AiOpportunityFactorType>>>;
  aiRiskFactors?: Maybe<Array<Maybe<AiRiskFactorType>>>;
  allBalanceSheets?: Maybe<BenchmarkBalanceSheetConnection>;
  allBenchmarkingData?: Maybe<BenchmarkingBaseModelConnection>;
  allCompanies?: Maybe<CompanyAssesmentConnection>;
  allCustomersAggregated?: Maybe<BenchmarkCustomersAggregatedConnection>;
  allCustomersList?: Maybe<BenchmarkCustomersListConnection>;
  allFte?: Maybe<BenchmarkFteConnection>;
  allG2Products?: Maybe<Array<Maybe<G2ProductType>>>;
  allInvestmentTransactions?: Maybe<InvestTransactionConnection>;
  allPl?: Maybe<BenchmarkPlConnection>;
  allPricing?: Maybe<BenchmarkPricingConnection>;
  analyzeValidatedKeywords?: Maybe<KeywordAnalysisResultType>;
  availableGoogleDrives?: Maybe<Array<Maybe<AvailableGoogleDriveType>>>;
  backfillStatus?: Maybe<Scalars['String']['output']>;
  cacheStatus?: Maybe<CacheStatusType>;
  cddClaim?: Maybe<ClaimV2Type>;
  cddClaims?: Maybe<Array<Maybe<ClaimV2Type>>>;
  cddConfigStatus?: Maybe<CddConfigStatusType>;
  cddEvidenceSource?: Maybe<EvidenceSourceV2Type>;
  cddEvidenceSources?: Maybe<Array<Maybe<EvidenceSourceV2Type>>>;
  cddExhibit?: Maybe<ExhibitV2Type>;
  cddExhibits?: Maybe<Array<Maybe<ExhibitV2Type>>>;
  cddJobStatus?: Maybe<CddJobStatusType>;
  cddReport?: Maybe<CddReportType>;
  cddReportV2?: Maybe<CddReportV2Type>;
  cddReports?: Maybe<Array<Maybe<CddReportSummaryType>>>;
  cddReportsV2List?: Maybe<Array<Maybe<CddReportV2SummaryType>>>;
  centroidRatingQueue?: Maybe<Array<Maybe<CentroidRatingQueueItemType>>>;
  centroidThresholdStats?: Maybe<CentroidThresholdStatsType>;
  certifications?: Maybe<Array<Maybe<CertificationType>>>;
  chatJobStatus?: Maybe<ChatJobStatusType>;
  chatMessages?: Maybe<ChatMessageListResponseType>;
  chatSessions?: Maybe<ChatSessionListResponseType>;
  chatWithCortex?: Maybe<Scalars['String']['output']>;
  checkPatternOverlaps?: Maybe<PatternOverlapCheckResultType>;
  classificationPatterns?: Maybe<Array<Maybe<ClassificationPatternType>>>;
  companiesByCategories?: Maybe<Array<Maybe<CompanyAssessmentType>>>;
  companiesByIndustries?: Maybe<Array<Maybe<CompanyAssessmentType>>>;
  companiesByIndustryAndCategory?: Maybe<Array<Maybe<CompanyAssessmentType>>>;
  companiesForDealflowMeeting?: Maybe<CompanyAssesmentConnection>;
  companyAssesment?: Maybe<CompanyAssesmentConnection>;
  companyAssessmentBenchmark?: Maybe<Array<Maybe<CompanyAssessmentType>>>;
  companyAssessmentsForDealflowMeeting?: Maybe<CompanyAssesmentConnection>;
  companyCertifications?: Maybe<Array<Maybe<CompanyCertificationType>>>;
  companyContacts?: Maybe<Array<Maybe<CompanyContactType>>>;
  companyInboxList?: Maybe<Array<Maybe<CompanyInboxType>>>;
  companyPnlForecast?: Maybe<CompanyPnlForecastType>;
  companySurveyAggregation?: Maybe<CompanySurveyAggregationType>;
  competitionCpcKeywords?: Maybe<KeywordResultRawConnection>;
  conversionTracking?: Maybe<Array<Maybe<ConversionTrackingType>>>;
  cortexConfig?: Maybe<CortexConfigType>;
  cortexFirms?: Maybe<CompanyAssesmentConnection>;
  crawlQueueEntries?: Maybe<Array<Maybe<CrawlQueueType>>>;
  crawlQueueStats?: Maybe<CrawlQueueStatsType>;
  crawlerAlerts?: Maybe<Array<Maybe<AlertType>>>;
  crawlerDomainHistory?: Maybe<DomainHistoryType>;
  crawlerDomainLeaderboard?: Maybe<Array<Maybe<DomainPerformanceType>>>;
  crawlerErrorBreakdown?: Maybe<ErrorBreakdownType>;
  crawlerFindingStatistics?: Maybe<FindingStatisticsType>;
  crawlerHybridScraperEnabled?: Maybe<Scalars['Boolean']['output']>;
  crawlerInbox?: Maybe<Array<Maybe<CrawlerInboxItemType>>>;
  crawlerOverview?: Maybe<CrawlerOverviewMetrics>;
  crawlerTimeline?: Maybe<Array<Maybe<TimeSeriesDataPointType>>>;
  customerIndustryGrowthRates?: Maybe<CustomerGrowthRateRawConnection>;
  customerSegmentation?: Maybe<Array<Maybe<CustomerSegment>>>;
  customerSegments?: Maybe<Array<CustomerSegmentType>>;
  employeeStatics?: Maybe<EmployeeStaticsRawConnection>;
  enrichmentAnalytics?: Maybe<PerformanceSummaryType>;
  enrichmentCostAnalysis?: Maybe<CostAnalysisType>;
  enrichmentJobStatus?: Maybe<EnrichmentJobStatusType>;
  enrichmentLayerSuccess?: Maybe<LayerSuccessRatesType>;
  enrichmentStatus?: Maybe<EnrichmentStatusType>;
  enrichmentTimeSeries?: Maybe<EnrichmentTimeSeriesType>;
  environmentConfiguration?: Maybe<EnvironmentConfiguration>;
  excelCell?: Maybe<UploadExcelCellType>;
  excelCells?: Maybe<Array<Maybe<UploadExcelCellType>>>;
  excelFile?: Maybe<UploadExcelFileType>;
  excelFiles?: Maybe<Array<Maybe<UploadExcelFileType>>>;
  excelSheet?: Maybe<UploadExcelSheetType>;
  excelSheets?: Maybe<Array<Maybe<UploadExcelSheetType>>>;
  exchangeRateHistories?: Maybe<Array<Maybe<ExchangeRateHistoryType>>>;
  falseNegativeInbox?: Maybe<Array<Maybe<RecentPlatformCrawlType>>>;
  financialForecastOutputs?: Maybe<Array<Maybe<FinancialForecastOutputType>>>;
  financialForecastParams?: Maybe<FinancialForecastParamsType>;
  fteHistory?: Maybe<Array<Maybe<FteHistoryEntryType>>>;
  g2Product?: Maybe<G2ProductType>;
  g2ProductsByCategory?: Maybe<Array<Maybe<G2ProductType>>>;
  g2ProductsBySeller?: Maybe<Array<Maybe<G2ProductType>>>;
  gatherHandelsregisterData?: Maybe<HrOrganizationConnection>;
  getAllCompaniesForPipedriveId?: Maybe<CompanyAssesmentConnection>;
  getAllPdfDocumentAnnotations?: Maybe<PdfDocumentAnnotationConnection>;
  getAllSicCodes?: Maybe<SicCodeConnection>;
  getBackendFrameworks?: Maybe<StackshareToolConnection>;
  getBenchmarkingSet?: Maybe<RecentPlatformCrawlConnection>;
  getBuyAndBuildPlatforms?: Maybe<CompanyConnection>;
  getCompany?: Maybe<CompanyConnection>;
  getCompanyCoreKeywords?: Maybe<CompanyCoreKeywordConnection>;
  getCompanyProducts?: Maybe<CompanyProductConnection>;
  getCrawlResults?: Maybe<RawGenericCrawlResultConnection>;
  getCrawlerFindingTokens?: Maybe<CrawlerFindingTokenConnection>;
  getCustomerIndustrySicCodes?: Maybe<CustomerIndustrySicCodeConnection>;
  getCustomerReferences?: Maybe<CustomerReferenceRawTypeConnection>;
  getCustomerSegmentation?: Maybe<CustomerSegmentationType>;
  getEventsOfLastMins?: Maybe<Array<Maybe<DynamoDbEventType>>>;
  getFinancialData?: Maybe<BenchmarkingBaseModelConnection>;
  getFinancialDataAvailability?: Maybe<FinancialDataAvailabilityType>;
  getFrontendFrameworks?: Maybe<StackshareToolConnection>;
  getImageFindings?: Maybe<ImageFindingConnection>;
  getLatestCrawlRun?: Maybe<CrawlRunSqlType>;
  getMlModelFindings?: Maybe<MlModelFindingConnection>;
  getNextBatchRun?: Maybe<NextBatchRunType>;
  getOpenaiVotes?: Maybe<OpenAiVoteConnection>;
  getPdfDocumentAnnotations?: Maybe<PdfDocumentAnnotationConnection>;
  getPipedriveActivities?: Maybe<Array<Maybe<PipedriveActivityType>>>;
  getPipedriveOrganization?: Maybe<PipedriveOrganizationType>;
  getProgrammingLanguages?: Maybe<StackshareToolConnection>;
  getRecentStealthPlatformCrawls?: Maybe<RecentPlatformCrawlConnection>;
  getSoftwareCategories?: Maybe<SoftwareCategoryConnection>;
  getStackshareToolCategories?: Maybe<StackshareToolConnection>;
  getStackshareTools?: Maybe<StackshareToolConnection>;
  getSuggestedKeywords?: Maybe<SuggestedKeywords>;
  getTechnologiesUsed?: Maybe<StackshareToolConnection>;
  getTextFindings?: Maybe<TextFindingConnection>;
  getUpcomingDeals?: Maybe<Array<Maybe<PipedriveDealType>>>;
  getValidationAnalytics?: Maybe<ValidationAnalytics>;
  geteLogo?: Maybe<KlazifyDomainConnection>;
  hasCompanyBeenValidated?: Maybe<GenericCrawlResultConnection>;
  industryBenchmarkData?: Maybe<Array<Maybe<CustomerGrowthRateRawType>>>;
  kpiBenchmarks?: Maybe<Array<Maybe<KpiBenchmarkType>>>;
  kpiCalculationStatus?: Maybe<KpiStatusSummary>;
  listResearchSessions?: Maybe<Array<Maybe<ResearchSessionSummaryType>>>;
  lookupCortexId?: Maybe<CortexIdType>;
  meeting?: Maybe<MeetingType>;
  meetings?: Maybe<Array<Maybe<MeetingType>>>;
  meetingsCalendarData?: Maybe<Array<Maybe<CalendarMeetingType>>>;
  mlModelDetailedStats?: Maybe<MlModelDetailedStatsType>;
  mlModelStatistics?: Maybe<Array<Maybe<MlModelStatisticsType>>>;
  node?: Maybe<Node>;
  originationsWaterfall?: Maybe<WaterfallDataType>;
  patternById?: Maybe<ClassificationPatternType>;
  patternEffectiveness?: Maybe<Array<Maybe<PatternEffectivenessType>>>;
  patternMatchesForCompany?: Maybe<Array<Maybe<ClassificationPatternMatchType>>>;
  pdfDocumentAnnotationsMenuCategories?: Maybe<Array<Maybe<Scalars['JSONScalar']['output']>>>;
  pendingPatternMatches?: Maybe<Array<Maybe<ClassificationPatternMatchType>>>;
  pipelineCoverage?: Maybe<Array<Maybe<PipelineCoverageType>>>;
  probationaryPatterns?: Maybe<Array<Maybe<ClassificationPatternType>>>;
  productCategoryList?: Maybe<SoftwareCategoryConnection>;
  productCategoryTrends?: Maybe<Array<Maybe<ProductCategoryTrendPointType>>>;
  questionnaireVersions?: Maybe<Array<Maybe<QuestionnaireType>>>;
  ragJobStatus?: Maybe<RagJobStatusType>;
  recentCompanyTasks?: Maybe<Array<Maybe<CompanyTaskSummary>>>;
  recentValidatedKeywords?: Maybe<Array<Maybe<ValidatedKeywordsSummaryType>>>;
  redbeatSchedules?: Maybe<Array<Maybe<RedBeatEntryType>>>;
  researchJobStatus?: Maybe<ResearchJobStatusType>;
  researchResult?: Maybe<ResearchResultType>;
  researchSessionStatus?: Maybe<ResearchSessionSummaryType>;
  scheduledTasksEnabled?: Maybe<Scalars['Boolean']['output']>;
  searchCompanyDomainByName?: Maybe<Scalars['String']['output']>;
  searchGenericShareholders?: Maybe<GenericShareHolderConnection>;
  searchGoogleDriveDirectory?: Maybe<Array<Maybe<Scalars['JSONScalar']['output']>>>;
  sicCodes?: Maybe<Array<Maybe<SicCodeType>>>;
  signalsForCompany?: Maybe<CompanySignalSummaryType>;
  signalsForValidation?: Maybe<Array<Maybe<RagValidationSignalType>>>;
  softwareCategoryAiScores?: Maybe<Array<Maybe<SoftwareCategoryWithScoreType>>>;
  softwareCategoryGrowthRates?: Maybe<SoftwareCategoryGrowthRateRawConnection>;
  softwareFirms?: Maybe<CompanyAssesmentConnection>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  swCentroidStats?: Maybe<SwCentroidStatsType>;
  swFalsePositiveCompanies?: Maybe<Array<Maybe<SwFalsePositiveCompanyType>>>;
  swPredictionSummary?: Maybe<SwPredictionSummaryType>;
  swPredictionTimeSeries?: Maybe<SwPredictionTimeSeriesType>;
  swTrainingDataStats?: Maybe<SwTrainingDataStatsType>;
  swValidationFeedback?: Maybe<SwValidationFeedbackType>;
  uploadedMetaDataByPipedriveId?: Maybe<CompanyWithLatestUpload>;
  userActivityStats?: Maybe<Array<Maybe<UserActivityStatsType>>>;
  userEmailByAuthId?: Maybe<Scalars['String']['output']>;
  userIdByAuthId?: Maybe<Scalars['Int']['output']>;
  userNameByAuthId?: Maybe<Scalars['String']['output']>;
  userStats?: Maybe<Array<Maybe<UserStatsType>>>;
  validatedKeywordsForCompany?: Maybe<ValidatedKeywordsSummaryType>;
  validationAccuracyByPrompt?: Maybe<Array<Maybe<ValidationAccuracyType>>>;
  validationInbox?: Maybe<Array<Maybe<ValidationInboxItemType>>>;
  verificationSessionUser?: Maybe<Scalars['String']['output']>;
  vibeCodingIdeas?: Maybe<Array<Maybe<VibeCodingIdeaType>>>;
  waterfallDrillDown?: Maybe<Array<Maybe<WaterfallDrillDownType>>>;
  xoviKeywordsForCrawlResult?: Maybe<Array<Maybe<XoviKeywordType>>>;
  ycCompanies?: Maybe<Array<Maybe<YcCompanyType>>>;
  ycCompaniesForPortfolio?: Maybe<Array<Maybe<YcCompanyType>>>;
  ycStartupsForCompany?: Maybe<YcStartupsResultType>;
  ycStats?: Maybe<YcStatsType>;
};


export type QueryActiveRagValidationsArgs = {
  companyDomains: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryAllBalanceSheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BenchmarkBalanceSheetSortEnum>>>;
};


export type QueryAllBenchmarkingDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BenchmarkingBaseModelSortEnum>>>;
};


export type QueryAllCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isSoftwareCompany?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCompanySortEnum>>>;
};


export type QueryAllCustomersAggregatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BenchmarkCustomersAggregatedSortEnum>>>;
};


export type QueryAllCustomersListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BenchmarkCustomersListSortEnum>>>;
};


export type QueryAllFteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BenchmarkFteSortEnum>>>;
};


export type QueryAllG2ProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllInvestmentTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllPlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BenchmarkPlSortEnum>>>;
};


export type QueryAllPricingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BenchmarkPricingSortEnum>>>;
};


export type QueryAnalyzeValidatedKeywordsArgs = {
  classificationFilter?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  minOccurrences?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBackfillStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryCacheStatusArgs = {
  domain: Scalars['String']['input'];
  maxPageAgeDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCddClaimArgs = {
  claimId: Scalars['ID']['input'];
};


export type QueryCddClaimsArgs = {
  claimIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryCddEvidenceSourceArgs = {
  sourceId: Scalars['ID']['input'];
};


export type QueryCddEvidenceSourcesArgs = {
  sourceIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryCddExhibitArgs = {
  exhibitId: Scalars['ID']['input'];
};


export type QueryCddExhibitsArgs = {
  exhibitIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryCddJobStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryCddReportArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryCddReportV2Args = {
  reportId: Scalars['ID']['input'];
};


export type QueryCddReportsArgs = {
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCddReportsV2ListArgs = {
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCentroidRatingQueueArgs = {
  sessionSize?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type QueryCertificationsArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatJobStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryChatMessagesArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryChatSessionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatWithCortexArgs = {
  companyId: Scalars['Int']['input'];
  userQuery: Scalars['String']['input'];
};


export type QueryCheckPatternOverlapsArgs = {
  classificationTarget: Scalars['String']['input'];
  patternText: Scalars['String']['input'];
  patternType: Scalars['String']['input'];
};


export type QueryClassificationPatternsArgs = {
  classificationTarget?: InputMaybe<Scalars['String']['input']>;
  excludeProbationary?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompaniesByCategoriesArgs = {
  softwareCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subCategory1?: InputMaybe<Scalars['String']['input']>;
  subCategory2?: InputMaybe<Scalars['String']['input']>;
  subCategory3?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompaniesByIndustriesArgs = {
  sicCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCompaniesByIndustryAndCategoryArgs = {
  sicCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  softwareCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subCategory1?: InputMaybe<Scalars['String']['input']>;
  subCategory2?: InputMaybe<Scalars['String']['input']>;
  subCategory3?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompaniesForDealflowMeetingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCompanySortEnum>>>;
};


export type QueryCompanyAssesmentArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCompanySortEnum>>>;
};


export type QueryCompanyAssessmentsForDealflowMeetingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCompanySortEnum>>>;
};


export type QueryCompanyCertificationsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryCompanyContactsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryCompanyInboxListArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  falseNegatives?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  newPlatforms?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  prioritizedPlatforms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanyPnlForecastArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryCompanySurveyAggregationArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryCompetitionCpcKeywordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<XoviKeywordsSortEnum>>>;
};


export type QueryConversionTrackingArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCortexFirmsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCompanySortEnum>>>;
};


export type QueryCrawlQueueEntriesArgs = {
  crawlStarted?: InputMaybe<Scalars['Boolean']['input']>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCrawlerAlertsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrawlerDomainHistoryArgs = {
  domain: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCrawlerDomainLeaderboardArgs = {
  endDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryCrawlerErrorBreakdownArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryCrawlerFindingStatisticsArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryCrawlerInboxArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCrawlerOverviewArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrawlerTimelineArgs = {
  endDate: Scalars['String']['input'];
  interval?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryCustomerIndustryGrowthRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<IndustryClassificationSampleSortEnum>>>;
};


export type QueryCustomerSegmentationArgs = {
  bidGroupCompanyId: Scalars['Int']['input'];
};


export type QueryCustomerSegmentsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryEmployeeStaticsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericEmploymentSortEnum>>>;
};


export type QueryEnrichmentAnalyticsArgs = {
  timeRange?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnrichmentCostAnalysisArgs = {
  timeRange?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnrichmentJobStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryEnrichmentLayerSuccessArgs = {
  timeRange?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnrichmentStatusArgs = {
  companyId: Scalars['Int']['input'];
  enrichmentMaxAgeDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEnrichmentTimeSeriesArgs = {
  timeRange?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExcelCellArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExcelCellsArgs = {
  column?: InputMaybe<Scalars['Int']['input']>;
  row?: InputMaybe<Scalars['Int']['input']>;
  sheetId: Scalars['Int']['input'];
};


export type QueryExcelFileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExcelSheetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExcelSheetsArgs = {
  fileId: Scalars['Int']['input'];
};


export type QueryExchangeRateHistoriesArgs = {
  startDate?: InputMaybe<Scalars['Date']['input']>;
  targetCurrency: Scalars['String']['input'];
};


export type QueryFalseNegativeInboxArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFinancialForecastOutputsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFteHistoryArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryG2ProductArgs = {
  softwareProductId: Scalars['String']['input'];
};


export type QueryG2ProductsByCategoryArgs = {
  category: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryG2ProductsBySellerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  seller: Scalars['String']['input'];
};


export type QueryGatherHandelsregisterDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<HrOrganizationSortEnum>>>;
};


export type QueryGetAllCompaniesForPipedriveIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pipedriveId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCompanySortEnum>>>;
};


export type QueryGetAllPdfDocumentAnnotationsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllSicCodesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SicCodeSortEnum>>>;
};


export type QueryGetBackendFrameworksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetBenchmarkingSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCrawlResultSortEnum>>>;
};


export type QueryGetBuyAndBuildPlatformsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  excludeAddOns?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCompanySortEnum>>>;
  sortForTargetId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCompanyArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doNotCrawl?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isBidPortfolioCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isGenericIndustryCompany?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sicCodeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<GenericCompanySortEnum>>>;
};


export type QueryGetCompanyCoreKeywordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CompanyCoreKeywordSortEnum>>>;
};


export type QueryGetCompanyProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CompanyProductSortEnum>>>;
};


export type QueryGetCrawlResultsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  recent?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCrawlResultSortEnum>>>;
};


export type QueryGetCrawlerFindingTokensArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCustomerIndustrySicCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCustomerReferenceSortEnum>>>;
};


export type QueryGetCustomerReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCustomerSegmentationArgs = {
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  onlyLlmHits?: InputMaybe<Scalars['Boolean']['input']>;
  softwareCompanyId?: InputMaybe<Scalars['Int']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEventsOfLastMinsArgs = {
  noOfMinutes?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFinancialDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  bmType?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  periods?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<BenchmarkingBaseModelSortEnum>>>;
};


export type QueryGetFinancialDataAvailabilityArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryGetFrontendFrameworksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetImageFindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genericCrawlResultId?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericUrlFacesCountSortEnum>>>;
};


export type QueryGetLatestCrawlRunArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryGetMlModelFindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericLanguageModelFindingsSortEnum>>>;
};


export type QueryGetOpenaiVotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericLanguageModelFindingsSortEnum>>>;
};


export type QueryGetPdfDocumentAnnotationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PdfDocumentAnnotationSortEnum>>>;
  uploadFileId: Scalars['Int']['input'];
};


export type QueryGetPipedriveActivitiesArgs = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  noOfMinutes?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPipedriveOrganizationArgs = {
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  includeDeals?: InputMaybe<Scalars['Boolean']['input']>;
  pipedriveId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProgrammingLanguagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StackshareToolSortEnum>>>;
};


export type QueryGetRecentStealthPlatformCrawlsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCrawlResultSortEnum>>>;
};


export type QueryGetSoftwareCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SoftwareCategorySortEnum>>>;
  subCategory1?: InputMaybe<Scalars['String']['input']>;
  subCategory2?: InputMaybe<Scalars['String']['input']>;
  subCategory3?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStackshareToolCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StackshareToolSortEnum>>>;
};


export type QueryGetStackshareToolsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StackshareToolSortEnum>>>;
};


export type QueryGetSuggestedKeywordsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryGetTechnologiesUsedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTextFindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genericCrawlResultId?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericUrlTextFindingSortEnum>>>;
};


export type QueryGetUpcomingDealsArgs = {
  filterId?: InputMaybe<Scalars['Int']['input']>;
  includeOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetValidationAnalyticsArgs = {
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  minValidations?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGeteLogoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<KlazifyDomainSortEnum>>>;
};


export type QueryHasCompanyBeenValidatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCrawlResultSortEnum>>>;
};


export type QueryKpiCalculationStatusArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryListResearchSessionsArgs = {
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  researchType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResearchStatusEnum>;
};


export type QueryLookupCortexIdArgs = {
  pipedriveId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMeetingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMeetingsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMeetingsCalendarDataArgs = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
};


export type QueryMlModelDetailedStatsArgs = {
  modelName: Scalars['String']['input'];
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOriginationsWaterfallArgs = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryPatternByIdArgs = {
  patternId: Scalars['Int']['input'];
};


export type QueryPatternEffectivenessArgs = {
  minMatches?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPatternMatchesForCompanyArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryPendingPatternMatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProbationaryPatternsArgs = {
  classificationTarget?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductCategoryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SoftwareCategorySortEnum>>>;
  subCategory1?: InputMaybe<Scalars['String']['input']>;
  subCategory2?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductCategoryTrendsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryRagJobStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryRecentCompanyTasksArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  env?: InputMaybe<Scalars['String']['input']>;
  lastTaskOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRecentValidatedKeywordsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResearchJobStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryResearchResultArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryResearchSessionStatusArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QuerySearchCompanyDomainByNameArgs = {
  companyName: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  returnDomainOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchGenericShareholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericShareholderSortEnum>>>;
};


export type QuerySearchGoogleDriveDirectoryArgs = {
  rootDirectoryId: Scalars['String']['input'];
  searchPhrase: Scalars['String']['input'];
};


export type QuerySignalsForCompanyArgs = {
  companyId: Scalars['Int']['input'];
};


export type QuerySignalsForValidationArgs = {
  validationResultId: Scalars['Int']['input'];
};


export type QuerySoftwareCategoryAiScoresArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  scoredOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySoftwareCategoryGrowthRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCompanySortEnum>>>;
};


export type QuerySoftwareFirmsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericCompanySortEnum>>>;
};


export type QueryStatusMessageArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySwFalsePositiveCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySwPredictionSummaryArgs = {
  timeRange?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySwPredictionTimeSeriesArgs = {
  timeRange?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUploadedMetaDataByPipedriveIdArgs = {
  pipedriveId: Scalars['Int']['input'];
};


export type QueryUserActivityStatsArgs = {
  timeframe?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserEmailByAuthIdArgs = {
  authId: Scalars['String']['input'];
};


export type QueryUserIdByAuthIdArgs = {
  authId: Scalars['String']['input'];
};


export type QueryUserNameByAuthIdArgs = {
  authId: Scalars['String']['input'];
};


export type QueryUserStatsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidatedKeywordsForCompanyArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryValidationAccuracyByPromptArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidationInboxArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  validationNeeded?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVerificationSessionUserArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryVibeCodingIdeasArgs = {
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  portfolioCompanyId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWaterfallDrillDownArgs = {
  barLabel: Scalars['String']['input'];
  dateFrom: Scalars['DateTime']['input'];
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryXoviKeywordsForCrawlResultArgs = {
  crawlResultId: Scalars['Int']['input'];
};


export type QueryYcCompaniesArgs = {
  batch?: InputMaybe<Scalars['String']['input']>;
  hiringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  topOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryYcCompaniesForPortfolioArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  portfolioCompanyId: Scalars['Int']['input'];
};


export type QueryYcStartupsForCompanyArgs = {
  companyId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  minSimilarity?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionType = {
  __typename?: 'QuestionType';
  key: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type QuestionnaireType = {
  __typename?: 'QuestionnaireType';
  description?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  questions: Array<Maybe<QuestionType>>;
  title: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type RagJobProgressType = {
  __typename?: 'RAGJobProgressType';
  message?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
};

export type RagJobStatusType = {
  __typename?: 'RAGJobStatusType';
  error?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  progress?: Maybe<RagJobProgressType>;
  result?: Maybe<Scalars['JSONString']['output']>;
  status: Scalars['String']['output'];
};

export type RagSignalFeedbackType = {
  __typename?: 'RagSignalFeedbackType';
  cortexVerificationId: Scalars['Int']['output'];
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  feedbackNote?: Maybe<Scalars['String']['output']>;
  feedbackRating: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  signal?: Maybe<RagValidationSignalType>;
  signalId: Scalars['Int']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type RagValidationResultType = {
  __typename?: 'RagValidationResultType';
  actualPrompt?: Maybe<Scalars['String']['output']>;
  celeryTaskId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<BuyAndBuildTargetAssessmentType>;
  companyId: Scalars['Int']['output'];
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSoftware?: Maybe<Scalars['Boolean']['output']>;
  langfuseTraceId?: Maybe<Scalars['String']['output']>;
  modelUsed?: Maybe<Scalars['String']['output']>;
  overwriteEnabled?: Maybe<Scalars['Boolean']['output']>;
  overwrittenFields?: Maybe<Scalars['JSONString']['output']>;
  parsedFindings?: Maybe<Scalars['JSONString']['output']>;
  patternMatches?: Maybe<Array<Maybe<ClassificationPatternMatchType>>>;
  predictionBusinessModel?: Maybe<Scalars['String']['output']>;
  predictionIsSoftware?: Maybe<Scalars['Boolean']['output']>;
  previousValues?: Maybe<Scalars['JSONString']['output']>;
  promptTemplate?: Maybe<Scalars['String']['output']>;
  promptVariant?: Maybe<Scalars['String']['output']>;
  promptVersion?: Maybe<Scalars['String']['output']>;
  rawResponse?: Maybe<Scalars['JSONString']['output']>;
  recommendations?: Maybe<Scalars['JSONString']['output']>;
  retryCount?: Maybe<Scalars['Int']['output']>;
  signals?: Maybe<Array<Maybe<RagValidationSignalType>>>;
  suggestedAdditions?: Maybe<Scalars['JSONString']['output']>;
  suggestedKeywords?: Maybe<Scalars['JSONString']['output']>;
  suggestedRemovals?: Maybe<Scalars['JSONString']['output']>;
  totalNonSoftwareScore?: Maybe<Scalars['Float']['output']>;
  totalSoftwareScore?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  validatedAttributes?: Maybe<Scalars['JSONString']['output']>;
  validatedCustomers?: Maybe<Scalars['JSONString']['output']>;
  validatedKeywords?: Maybe<Scalars['JSONString']['output']>;
  validationConfidence?: Maybe<Scalars['Float']['output']>;
  validationKeyword?: Maybe<Scalars['String']['output']>;
  validationSource?: Maybe<Scalars['String']['output']>;
  validationStatus: Scalars['String']['output'];
  validationTimestamp: Scalars['DateTime']['output'];
  validationType: Scalars['String']['output'];
};

export type RagValidationSignalType = {
  __typename?: 'RagValidationSignalType';
  company?: Maybe<BuyAndBuildTargetAssessmentType>;
  companyId: Scalars['Int']['output'];
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  feedback?: Maybe<Array<Maybe<RagSignalFeedbackType>>>;
  feedbackList?: Maybe<Array<Maybe<RagSignalFeedbackType>>>;
  id: Scalars['ID']['output'];
  netClassificationScore?: Maybe<Scalars['Float']['output']>;
  patternsMatched?: Maybe<Scalars['JSONString']['output']>;
  signalMetadata?: Maybe<Scalars['JSONString']['output']>;
  signalSource?: Maybe<Scalars['String']['output']>;
  signalText: Scalars['String']['output'];
  signalType: Scalars['String']['output'];
  validationResult?: Maybe<RagValidationResultType>;
  validationResultId: Scalars['Int']['output'];
};

export type RawGenericCrawlResultConnection = {
  __typename?: 'RawGenericCrawlResultConnection';
  edges: Array<Maybe<RawGenericCrawlResultEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type RawGenericCrawlResultEdge = {
  __typename?: 'RawGenericCrawlResultEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RawGenericCrawlResultSqlType>;
};

export type RawGenericCrawlResultSqlType = Node & {
  __typename?: 'RawGenericCrawlResultSQLType';
  classificationSessionId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyType>;
  companyId?: Maybe<Scalars['Int']['output']>;
  crawlFinishedTime?: Maybe<Scalars['DateTime']['output']>;
  crawlResultObject?: Maybe<Scalars['JSONString']['output']>;
  crawlRunId?: Maybe<Scalars['Int']['output']>;
  crawlType: Scalars['String']['output'];
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  employeeEmailCallbackHasHappened?: Maybe<Scalars['Boolean']['output']>;
  expensiveAnalysisExecutionTime?: Maybe<Scalars['DateTime']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  fteAnalysisObject?: Maybe<Scalars['JSONString']['output']>;
  hadMlModelApplied?: Maybe<Scalars['Boolean']['output']>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  hasCompanyBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  linkedinFte?: Maybe<Scalars['Int']['output']>;
  linkedinLowerFte?: Maybe<Scalars['Int']['output']>;
  linkedinUpperFte?: Maybe<Scalars['Int']['output']>;
  listOfEmails?: Maybe<Scalars['JSONString']['output']>;
  listOfMds?: Maybe<Scalars['JSONString']['output']>;
  mongoEmbeddingCreationTime?: Maybe<Scalars['DateTime']['output']>;
  sizeJustification?: Maybe<Scalars['String']['output']>;
  socialResultObject?: Maybe<Scalars['JSONString']['output']>;
  softwareCategory?: Maybe<SoftwareCategorySqlType>;
  softwareCategoryCertainty?: Maybe<Scalars['Float']['output']>;
  softwareCategoryId?: Maybe<Scalars['Int']['output']>;
  specialXoviKeywords?: Maybe<KeywordForCompanySqlTypeConnection>;
  status: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  xoviKeywords?: Maybe<XoviKeywordConnection>;
};


export type RawGenericCrawlResultSqlTypeSpecialXoviKeywordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RawGenericCrawlResultSqlTypeXoviKeywordsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  cpc?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPlaceholderForEmptyXoviResponse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  markedAsIrrelevant?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<XoviKeywordOrderEnum>>>;
};

export type RecentPlatformCrawlConnection = {
  __typename?: 'RecentPlatformCrawlConnection';
  edges: Array<Maybe<RecentPlatformCrawlEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type RecentPlatformCrawlEdge = {
  __typename?: 'RecentPlatformCrawlEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RecentPlatformCrawlType>;
};

export type RecentPlatformCrawlType = {
  __typename?: 'RecentPlatformCrawlType';
  classificationSessionId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<BuyAndBuildTargetAssessmentType>;
  companyCountry?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  crawlFinishedTime?: Maybe<Scalars['DateTime']['output']>;
  crawlResultObject?: Maybe<Scalars['JSONString']['output']>;
  crawlRunId?: Maybe<Scalars['Int']['output']>;
  crawlType: Scalars['String']['output'];
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  employeeEmailCallbackHasHappened?: Maybe<Scalars['Boolean']['output']>;
  expensiveAnalysisExecutionTime?: Maybe<Scalars['DateTime']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  fteAnalysis?: Maybe<Scalars['Int']['output']>;
  fteAnalysisObject?: Maybe<Scalars['JSONString']['output']>;
  hadMlModelApplied?: Maybe<Scalars['Boolean']['output']>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  iabDomainCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  linkedinFte?: Maybe<Scalars['Int']['output']>;
  linkedinLowerFte?: Maybe<Scalars['Int']['output']>;
  linkedinUpperFte?: Maybe<Scalars['Int']['output']>;
  listOfEmails?: Maybe<Scalars['JSONString']['output']>;
  listOfMds?: Maybe<Scalars['JSONString']['output']>;
  mongoEmbeddingCreationTime?: Maybe<Scalars['DateTime']['output']>;
  peOwned?: Maybe<Scalars['Boolean']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  privateCompany?: Maybe<Scalars['Boolean']['output']>;
  privateOwned?: Maybe<Scalars['Boolean']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  sicCodeCertainty?: Maybe<Scalars['Float']['output']>;
  sizeJustification?: Maybe<Scalars['String']['output']>;
  socialResultObject?: Maybe<Scalars['JSONString']['output']>;
  softwareCategory?: Maybe<SoftwareCategoryType>;
  softwareCategoryCertainty?: Maybe<Scalars['Float']['output']>;
  softwareCategoryId?: Maybe<Scalars['Int']['output']>;
  specialXoviKeywords?: Maybe<KeywordForCompanySqlTypeConnection>;
  status: Scalars['String']['output'];
  systemType?: Maybe<Scalars['String']['output']>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  xoviKeywords?: Maybe<KeywordForCompanySqlTypeConnection>;
};


export type RecentPlatformCrawlTypeSpecialXoviKeywordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RecentPlatformCrawlTypeXoviKeywordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ReclassifyCustomerSegmentMutation = {
  __typename?: 'ReclassifyCustomerSegmentMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RecomputeCentroidThresholds = {
  __typename?: 'RecomputeCentroidThresholds';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<CentroidThresholdComputeResultType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReconcileCrawlerInboxMutation = {
  __typename?: 'ReconcileCrawlerInboxMutation';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
};

export type RecordPatternMatchFeedback = {
  __typename?: 'RecordPatternMatchFeedback';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RecordSignalFeedback = {
  __typename?: 'RecordSignalFeedback';
  error?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<RagSignalFeedbackType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RedBeatEntryType = {
  __typename?: 'RedBeatEntryType';
  crontabDayOfMonth?: Maybe<Scalars['String']['output']>;
  crontabDayOfWeek?: Maybe<Scalars['String']['output']>;
  crontabHour?: Maybe<Scalars['String']['output']>;
  crontabMinute?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  intervalSeconds?: Maybe<Scalars['Float']['output']>;
  kwargs?: Maybe<Scalars['JSONString']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  scheduleType?: Maybe<Scalars['String']['output']>;
  task?: Maybe<Scalars['String']['output']>;
  totalRunCount?: Maybe<Scalars['Int']['output']>;
};

export type RefreshCompanyGoogleDriveFiles = {
  __typename?: 'RefreshCompanyGoogleDriveFiles';
  autoConfigured?: Maybe<Scalars['Boolean']['output']>;
  configEstimate?: Maybe<GDriveConfigEstimateType>;
  message?: Maybe<Scalars['String']['output']>;
  requiresConfiguration?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RefreshResearch = {
  __typename?: 'RefreshResearch';
  error?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RefreshValidationInbox = {
  __typename?: 'RefreshValidationInbox';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RegenerateAllDAs = {
  __typename?: 'RegenerateAllDAs';
  cortexConfig?: Maybe<CortexConfigType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RejectCoreKeyword = {
  __typename?: 'RejectCoreKeyword';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReleaseValidationLock = {
  __typename?: 'ReleaseValidationLock';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveCompanyCertification = {
  __typename?: 'RemoveCompanyCertification';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveShortlistedBuyAndBuildTarget = {
  __typename?: 'RemoveShortlistedBuyAndBuildTarget';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RenewValidationLock = {
  __typename?: 'RenewValidationLock';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResearchEvidenceSourceType = {
  __typename?: 'ResearchEvidenceSourceType';
  relevanceScore?: Maybe<Scalars['Float']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ResearchJobProgressType = {
  __typename?: 'ResearchJobProgressType';
  message?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
};

export type ResearchJobStatusType = {
  __typename?: 'ResearchJobStatusType';
  error?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  progress?: Maybe<ResearchJobProgressType>;
  result?: Maybe<Scalars['JSONString']['output']>;
  status: Scalars['String']['output'];
};

export type ResearchResultType = {
  __typename?: 'ResearchResultType';
  citationIndex?: Maybe<Scalars['JSONString']['output']>;
  companyDomain: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  evidenceSources?: Maybe<Array<Maybe<ResearchEvidenceSourceType>>>;
  researchType: Scalars['String']['output'];
  resultData: Scalars['JSONString']['output'];
  sessionId?: Maybe<Scalars['ID']['output']>;
  stages?: Maybe<Array<Maybe<StageResultType>>>;
  startedAt: Scalars['DateTime']['output'];
  status: ResearchStatusEnum;
};

export type ResearchSessionSummaryType = {
  __typename?: 'ResearchSessionSummaryType';
  companyDomain: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  researchType: Scalars['String']['output'];
  sessionId: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: ResearchStatusEnum;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum ResearchStatusEnum {
  Cached = 'CACHED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Timeout = 'TIMEOUT'
}

export type ResegmentAllCustomerWithLlmHitsMutation = {
  __typename?: 'ResegmentAllCustomerWithLLMHitsMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResegmentAllCustomersMutation = {
  __typename?: 'ResegmentAllCustomersMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetDealAssessmentUpload = {
  __typename?: 'ResetDealAssessmentUpload';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetrieveSeoDataForKeywords = {
  __typename?: 'RetrieveSeoDataForKeywords';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SicCodeConnection = {
  __typename?: 'SICCodeConnection';
  edges: Array<Maybe<SicCodeEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type SicCodeEdge = {
  __typename?: 'SICCodeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<SicCodeSqlType>;
};

export type SicCodeSqlType = Node & {
  __typename?: 'SICCodeSQLType';
  canonicalLabel?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryGroup?: Maybe<Scalars['Int']['output']>;
  majorGroup?: Maybe<Scalars['Int']['output']>;
  sicCodeInt?: Maybe<Scalars['Int']['output']>;
  sicCodeStr?: Maybe<Scalars['String']['output']>;
};

export enum SicCodeSortEnum {
  CanonicalLabelAsc = 'canonical_label_asc',
  CanonicalLabelDesc = 'canonical_label_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DescriptionAsc = 'description_asc',
  DescriptionDesc = 'description_desc',
  DivisionAsc = 'division_asc',
  DivisionDesc = 'division_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IndustryGroupAsc = 'industry_group_asc',
  IndustryGroupDesc = 'industry_group_desc',
  MajorGroupAsc = 'major_group_asc',
  MajorGroupDesc = 'major_group_desc',
  SicCodeIntAsc = 'sic_code_int_asc',
  SicCodeIntDesc = 'sic_code_int_desc',
  SicCodeStrAsc = 'sic_code_str_asc',
  SicCodeStrDesc = 'sic_code_str_desc'
}

export type SicCodeType = Node & {
  __typename?: 'SICCodeType';
  dbId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryGroup?: Maybe<Scalars['Int']['output']>;
  majorGroup?: Maybe<Scalars['Int']['output']>;
  sicCodeInt?: Maybe<Scalars['Int']['output']>;
  sicCodeStr?: Maybe<Scalars['String']['output']>;
};

export type SwCentroidStatsType = {
  __typename?: 'SWCentroidStatsType';
  auc?: Maybe<Scalars['Float']['output']>;
  computedAt?: Maybe<Scalars['DateTime']['output']>;
  filterRate?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  nonSwCount?: Maybe<Scalars['Int']['output']>;
  precision?: Maybe<Scalars['Float']['output']>;
  recall?: Maybe<Scalars['Float']['output']>;
  separation?: Maybe<Scalars['Float']['output']>;
  swCount?: Maybe<Scalars['Int']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
  threshold95?: Maybe<Scalars['Float']['output']>;
  threshold97?: Maybe<Scalars['Float']['output']>;
  threshold99?: Maybe<Scalars['Float']['output']>;
  threshold995?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type SwFalsePositiveCompanyType = {
  __typename?: 'SWFalsePositiveCompanyType';
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  validationDate?: Maybe<Scalars['DateTime']['output']>;
};

export type SwPredictionSummaryType = {
  __typename?: 'SWPredictionSummaryType';
  avgSimilarity?: Maybe<Scalars['Float']['output']>;
  filterRate?: Maybe<Scalars['Float']['output']>;
  nonSwCount?: Maybe<Scalars['Int']['output']>;
  swCount?: Maybe<Scalars['Int']['output']>;
  timeRange?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SwPredictionTimeSeriesPointType = {
  __typename?: 'SWPredictionTimeSeriesPointType';
  avgSimilarity?: Maybe<Scalars['Float']['output']>;
  filterRate?: Maybe<Scalars['Float']['output']>;
  nonSwCount?: Maybe<Scalars['Int']['output']>;
  swCount?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SwPredictionTimeSeriesType = {
  __typename?: 'SWPredictionTimeSeriesType';
  dataPoints?: Maybe<Array<Maybe<SwPredictionTimeSeriesPointType>>>;
  timeRange?: Maybe<Scalars['String']['output']>;
};

export type SwTrainingDataStatsType = {
  __typename?: 'SWTrainingDataStatsType';
  fpCount?: Maybe<Scalars['Int']['output']>;
  fpEmbedded?: Maybe<Scalars['Int']['output']>;
  lastRetrain?: Maybe<Scalars['DateTime']['output']>;
  nonSwCount?: Maybe<Scalars['Int']['output']>;
  nonSwEmbedded?: Maybe<Scalars['Int']['output']>;
  swCount?: Maybe<Scalars['Int']['output']>;
  swEmbedded?: Maybe<Scalars['Int']['output']>;
};

export type SwValidationFeedbackType = {
  __typename?: 'SWValidationFeedbackType';
  accuracy?: Maybe<Scalars['Float']['output']>;
  fn?: Maybe<Scalars['Int']['output']>;
  fp?: Maybe<Scalars['Int']['output']>;
  precision?: Maybe<Scalars['Float']['output']>;
  recall?: Maybe<Scalars['Float']['output']>;
  tn?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  tp?: Maybe<Scalars['Int']['output']>;
};

export type SaveAnnotation = {
  __typename?: 'SaveAnnotation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveDealTransaction = {
  __typename?: 'SaveDealTransaction';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveValidationKeywordResult = {
  __typename?: 'SaveValidationKeywordResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ScheduledMongoEmbeddingCreationForCompanies = {
  __typename?: 'ScheduledMongoEmbeddingCreationForCompanies';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ScheduledRetrievalOfOpenaiBatchJobs = {
  __typename?: 'ScheduledRetrievalOfOpenaiBatchJobs';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ScheduledValidationResult = {
  __typename?: 'ScheduledValidationResult';
  byInbox?: Maybe<Scalars['JSONString']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  totalQueued?: Maybe<Scalars['Int']['output']>;
};

export type SearchForSourceScrubTags = {
  __typename?: 'SearchForSourceScrubTags';
  companies?: Maybe<Array<Maybe<CompanyType>>>;
};

export type SeedCertificationTaxonomy = {
  __typename?: 'SeedCertificationTaxonomy';
  count?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SeedHomepageGateDataMutation = {
  __typename?: 'SeedHomepageGateDataMutation';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SegmentCustomerInputType = {
  active?: InputMaybe<Scalars['Int']['input']>;
  arr?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  industryCode?: InputMaybe<Scalars['String']['input']>;
  lossReason?: InputMaybe<Scalars['String']['input']>;
  lostYear?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noOfUsers?: InputMaybe<Scalars['Int']['input']>;
  nps?: InputMaybe<Scalars['Int']['input']>;
  revenueYearOne?: InputMaybe<Scalars['Int']['input']>;
  revenueYearTwo?: InputMaybe<Scalars['Int']['input']>;
  wonYear?: InputMaybe<Scalars['Int']['input']>;
};

export type SegmentCustomerMutation = {
  __typename?: 'SegmentCustomerMutation';
  companyDomain?: Maybe<Scalars['String']['output']>;
  customerSicCode?: Maybe<Scalars['String']['output']>;
  hasBeenQueued?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  segmentId?: Maybe<Scalars['Int']['output']>;
  segmentName?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
};

export type SendMessageInput = {
  content: Scalars['String']['input'];
  cubeStatus?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetCompanyGoogleDriveRootDir = {
  __typename?: 'SetCompanyGoogleDriveRootDir';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SetCompanySize = {
  __typename?: 'SetCompanySize';
  company?: Maybe<CompanyType>;
  findingUrl?: Maybe<Scalars['String']['output']>;
  fte?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  typeOfFinding?: Maybe<Scalars['Int']['output']>;
};

export type SetProductCategoryToZero = {
  __typename?: 'SetProductCategoryToZero';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ShareholderInputType = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  dbId?: InputMaybe<Scalars['Int']['input']>;
  holding?: InputMaybe<Scalars['Float']['input']>;
  isNaturalPerson?: InputMaybe<Scalars['Boolean']['input']>;
  isPe?: InputMaybe<Scalars['Boolean']['input']>;
  isTradeBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  typeOfInvestor?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  yearBornOrFounded?: InputMaybe<Scalars['Int']['input']>;
};

export type ShortlistBuyAndBuildTarget = {
  __typename?: 'ShortlistBuyAndBuildTarget';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SignalEvaluationResultType = {
  __typename?: 'SignalEvaluationResultType';
  matches?: Maybe<Array<Maybe<PatternMatchResultType>>>;
  netScore?: Maybe<Scalars['Float']['output']>;
  signalsStored?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  totalNonSoftwareScore?: Maybe<Scalars['Float']['output']>;
  totalSoftwareScore?: Maybe<Scalars['Float']['output']>;
};

export type SignalFeedbackInput = {
  cortexVerificationId: Scalars['Int']['input'];
  feedbackNote?: InputMaybe<Scalars['String']['input']>;
  feedbackRating: Scalars['String']['input'];
  signalId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type SignalInput = {
  metadataJson?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type SoftwareCategoryConnection = {
  __typename?: 'SoftwareCategoryConnection';
  edges: Array<Maybe<SoftwareCategoryEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type SoftwareCategoryEdge = {
  __typename?: 'SoftwareCategoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<SoftwareCategoryType>;
};

export type SoftwareCategoryGrowthRateRawConnection = {
  __typename?: 'SoftwareCategoryGrowthRateRawConnection';
  edges: Array<Maybe<SoftwareCategoryGrowthRateRawEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type SoftwareCategoryGrowthRateRawEdge = {
  __typename?: 'SoftwareCategoryGrowthRateRawEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<SoftwareCategoryGrowthRateRawType>;
};

export type SoftwareCategoryGrowthRateRawType = Node & {
  __typename?: 'SoftwareCategoryGrowthRateRawType';
  address?: Maybe<Scalars['String']['output']>;
  avgAlltimeInterest?: Maybe<Scalars['Float']['output']>;
  avgInterest24To12MonthsAgo?: Maybe<Scalars['Float']['output']>;
  avgInterestLast12Months?: Maybe<Scalars['Float']['output']>;
  benchmarkingIndex?: Maybe<Scalars['Int']['output']>;
  buyAndBuildSources?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  buyAndBuildTargets?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  city?: Maybe<Scalars['String']['output']>;
  companyAnalyses?: Maybe<CompanyAnalysisTypeConnection>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactEmailConfidence?: Maybe<Scalars['Float']['output']>;
  contactEmailType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Scalars['String']['output']>;
  crawlResults?: Maybe<Array<Maybe<RecentPlatformCrawlType>>>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  doNotCrawl?: Maybe<Scalars['Boolean']['output']>;
  dueDilligence?: Maybe<Scalars['Boolean']['output']>;
  emailPattern?: Maybe<Scalars['String']['output']>;
  excelFiles?: Maybe<Array<Maybe<UploadExcelFileType>>>;
  foundingYear?: Maybe<Scalars['Int']['output']>;
  gdriveDirectoryId: Scalars['String']['output'];
  gdriveDirectoryName: Scalars['String']['output'];
  gdriveSharedDriveId: Scalars['String']['output'];
  gdriveSharedDriveName: Scalars['String']['output'];
  genericShareholdings?: Maybe<GenericShareholdingSqlTypeConnection>;
  hasBeenValidated?: Maybe<Scalars['Boolean']['output']>;
  hrbNumber?: Maybe<Scalars['String']['output']>;
  iabDomainCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialSource?: Maybe<Scalars['String']['output']>;
  interestGrowthRate?: Maybe<Scalars['Float']['output']>;
  isBidPortfolioCompany?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isGenericIndustryCompany?: Maybe<Scalars['Boolean']['output']>;
  isHorizontalSoftware?: Maybe<Scalars['Boolean']['output']>;
  isItCompanyCompany?: Maybe<Scalars['Boolean']['output']>;
  isSaasCompany?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  managingDirector?: Maybe<Scalars['String']['output']>;
  mergedIntoId?: Maybe<Scalars['Int']['output']>;
  numberOfFailedCrawls?: Maybe<Scalars['Int']['output']>;
  parentCompany?: Maybe<BuyAndBuildTargetAssessmentType>;
  patternMatches?: Maybe<Array<Maybe<ClassificationPatternMatchType>>>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  precalculatedKpis?: Maybe<KpiPreCalculationTypeConnection>;
  ragValidations?: Maybe<Array<Maybe<RagValidationResultType>>>;
  shareholders?: Maybe<GenericShareHolderTypeConnection>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  sicCodeCertainty?: Maybe<Scalars['Float']['output']>;
  sicCodeJustification?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  subCategory1?: Maybe<Scalars['String']['output']>;
  subsidiaries?: Maybe<BuyAndBuildTargetAssessmentTypeConnection>;
  subsidiaryOf?: Maybe<Scalars['Int']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
  validationDatetime?: Maybe<Scalars['DateTime']['output']>;
  validationLockedAt?: Maybe<Scalars['DateTime']['output']>;
  validationLockedBy?: Maybe<Scalars['Int']['output']>;
  validationSignals?: Maybe<Array<Maybe<RagValidationSignalType>>>;
  validationUser?: Maybe<Scalars['String']['output']>;
  ycCompany?: Maybe<YcCompanyTypeConnection>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type SoftwareCategoryGrowthRateRawTypeBuyAndBuildSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SoftwareCategoryGrowthRateRawTypeBuyAndBuildTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SoftwareCategoryGrowthRateRawTypeCompanyAnalysesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SoftwareCategoryGrowthRateRawTypeGenericShareholdingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SoftwareCategoryGrowthRateRawTypePrecalculatedKpisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SoftwareCategoryGrowthRateRawTypeShareholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SoftwareCategoryGrowthRateRawTypeSubsidiariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SoftwareCategoryGrowthRateRawTypeYcCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SoftwareCategoryGrowthRateType = Node & {
  __typename?: 'SoftwareCategoryGrowthRateType';
  avgAlltimeInterest?: Maybe<Scalars['Float']['output']>;
  avgInterest24To12MonthsAgo?: Maybe<Scalars['Float']['output']>;
  avgInterestLast12Months?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  interestGrowthRate?: Maybe<Scalars['Float']['output']>;
  subCategory1?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type SoftwareCategorySqlType = Node & {
  __typename?: 'SoftwareCategorySQLType';
  categoryDescription?: Maybe<Scalars['String']['output']>;
  categoryDescriptionEmbedding?: Maybe<Scalars['JSONString']['output']>;
  categoryDescriptionEmbeddingV2?: Maybe<Scalars['JSONString']['output']>;
  companyProducts?: Maybe<CompanyProductTypeConnection>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  g2Url?: Maybe<Scalars['String']['output']>;
  genericCrawlResults?: Maybe<Array<Maybe<RecentPlatformCrawlType>>>;
  googleTerm?: Maybe<GoogleTermType>;
  googleTermId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  industryVertical?: Maybe<Scalars['String']['output']>;
  isHorizontalCategory?: Maybe<Scalars['Boolean']['output']>;
  productCategorizations?: Maybe<ProductCategorizationTypeConnection>;
  subCategory1?: Maybe<Scalars['String']['output']>;
  subCategory2?: Maybe<Scalars['String']['output']>;
  subCategory3?: Maybe<Scalars['String']['output']>;
  subCategory4?: Maybe<Scalars['String']['output']>;
};


export type SoftwareCategorySqlTypeCompanyProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SoftwareCategorySqlTypeProductCategorizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum SoftwareCategorySortEnum {
  CategoryDescriptionAsc = 'category_description_asc',
  CategoryDescriptionDesc = 'category_description_desc',
  CategoryDescriptionEmbeddingAsc = 'category_description_embedding_asc',
  CategoryDescriptionEmbeddingDesc = 'category_description_embedding_desc',
  CategoryDescriptionEmbeddingV2Asc = 'category_description_embedding_v2_asc',
  CategoryDescriptionEmbeddingV2Desc = 'category_description_embedding_v2_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  G2UrlAsc = 'g2_url_asc',
  G2UrlDesc = 'g2_url_desc',
  GoogleTermIdAsc = 'google_term_id_asc',
  GoogleTermIdDesc = 'google_term_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IndustryVerticalAsc = 'industry_vertical_asc',
  IndustryVerticalDesc = 'industry_vertical_desc',
  IsHorizontalCategoryAsc = 'is_horizontal_category_asc',
  IsHorizontalCategoryDesc = 'is_horizontal_category_desc',
  SubCategory_1Asc = 'sub_category_1_asc',
  SubCategory_1Desc = 'sub_category_1_desc',
  SubCategory_2Asc = 'sub_category_2_asc',
  SubCategory_2Desc = 'sub_category_2_desc',
  SubCategory_3Asc = 'sub_category_3_asc',
  SubCategory_3Desc = 'sub_category_3_desc',
  SubCategory_4Asc = 'sub_category_4_asc',
  SubCategory_4Desc = 'sub_category_4_desc'
}

export type SoftwareCategoryType = Node & {
  __typename?: 'SoftwareCategoryType';
  categoryDescription?: Maybe<Scalars['String']['output']>;
  categoryDescriptionEmbedding?: Maybe<Scalars['JSONString']['output']>;
  categoryDescriptionEmbeddingV2?: Maybe<Scalars['JSONString']['output']>;
  companyProducts?: Maybe<CompanyProductTypeConnection>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  g2Url?: Maybe<Scalars['String']['output']>;
  genericCrawlResults?: Maybe<Array<Maybe<RecentPlatformCrawlType>>>;
  googleTerm?: Maybe<GoogleTermType>;
  googleTermId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  industryVertical?: Maybe<Scalars['String']['output']>;
  isHorizontalCategory?: Maybe<Scalars['Boolean']['output']>;
  productCategorizations?: Maybe<ProductCategorizationTypeConnection>;
  subCategory1?: Maybe<Scalars['String']['output']>;
  subCategory2?: Maybe<Scalars['String']['output']>;
  subCategory3?: Maybe<Scalars['String']['output']>;
  subCategory4?: Maybe<Scalars['String']['output']>;
};


export type SoftwareCategoryTypeCompanyProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SoftwareCategoryTypeProductCategorizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SoftwareCategoryTypeConnection = {
  __typename?: 'SoftwareCategoryTypeConnection';
  edges: Array<Maybe<SoftwareCategoryTypeEdge>>;
  pageInfo: PageInfo;
};

export type SoftwareCategoryTypeEdge = {
  __typename?: 'SoftwareCategoryTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<SoftwareCategoryType>;
};

export type SoftwareCategoryWithScoreType = {
  __typename?: 'SoftwareCategoryWithScoreType';
  aiOpportunity?: Maybe<Scalars['Float']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  compositeScore?: Maybe<Scalars['Float']['output']>;
  dimensionReasoning?: Maybe<Scalars['JSONString']['output']>;
  dimensionScores?: Maybe<Scalars['JSONString']['output']>;
  disruptionRisk?: Maybe<Scalars['Float']['output']>;
  hasScore?: Maybe<Scalars['Boolean']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  scoringVersion?: Maybe<Scalars['String']['output']>;
  taxonomyPath?: Maybe<Scalars['String']['output']>;
};

export type StackshareToolConnection = {
  __typename?: 'StackshareToolConnection';
  edges: Array<Maybe<StackshareToolEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type StackshareToolEdge = {
  __typename?: 'StackshareToolEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<StackshareToolType>;
};

export enum StackshareToolSortEnum {
  BreadcrumbAsc = 'breadcrumb_asc',
  BreadcrumbDesc = 'breadcrumb_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  DescriptionAsc = 'description_asc',
  DescriptionDesc = 'description_desc',
  FollowersAsc = 'followers_asc',
  FollowersDesc = 'followers_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsApiFrameworkAsc = 'is_api_framework_asc',
  IsApiFrameworkDesc = 'is_api_framework_desc',
  IsBackendFrameworkAsc = 'is_backend_framework_asc',
  IsBackendFrameworkDesc = 'is_backend_framework_desc',
  IsFrontendFrameworkAsc = 'is_frontend_framework_asc',
  IsFrontendFrameworkDesc = 'is_frontend_framework_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  NerNameAsc = 'ner_name_asc',
  NerNameDesc = 'ner_name_desc',
  StacksUsedAsc = 'stacks_used_asc',
  StacksUsedDesc = 'stacks_used_desc',
  TypeAsc = 'type_asc',
  TypeDesc = 'type_desc',
  UrlAsc = 'url_asc',
  UrlDesc = 'url_desc',
  VotesAsc = 'votes_asc',
  VotesDesc = 'votes_desc',
  YearOfInitialReleaseAsc = 'year_of_initial_release_asc',
  YearOfInitialReleaseDesc = 'year_of_initial_release_desc'
}

export type StackshareToolType = Node & {
  __typename?: 'StackshareToolType';
  breadcrumb?: Maybe<Scalars['String']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  followers?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isApiFramework?: Maybe<Scalars['Boolean']['output']>;
  isBackendFramework?: Maybe<Scalars['Boolean']['output']>;
  isFrontendFramework?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nerName?: Maybe<Scalars['String']['output']>;
  stacksUsed?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usedIn?: Maybe<GenericCompanyTechUseWithStackshareToolSqlTypeConnection>;
  votes?: Maybe<Scalars['Int']['output']>;
  yearOfInitialRelease?: Maybe<Scalars['Int']['output']>;
};


export type StackshareToolTypeUsedInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StageResultType = {
  __typename?: 'StageResultType';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  evidenceSources?: Maybe<Array<Maybe<ResearchEvidenceSourceType>>>;
  resultData: Scalars['JSONString']['output'];
  stageName: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: ResearchStatusEnum;
};

export type StartCddAnalysisInput = {
  companyDomain: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  promptLabel?: InputMaybe<Scalars['String']['input']>;
};

export type StartCddAnalysisMutation = {
  __typename?: 'StartCDDAnalysisMutation';
  jobId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type StartCddExperimentInput = {
  companyDomain: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  variants: Array<InputMaybe<Scalars['String']['input']>>;
};

export type StartCddExperimentMutation = {
  __typename?: 'StartCDDExperimentMutation';
  jobId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type StartCompanyVerificationSession = {
  __typename?: 'StartCompanyVerificationSession';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StartCrawlerMutation = {
  __typename?: 'StartCrawlerMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StartResearch = {
  __typename?: 'StartResearch';
  error?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StartResearchInput = {
  companyDomain: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSONString']['input']>;
  researchType: Scalars['String']['input'];
};

export type StrategyStatistics = {
  __typename?: 'StrategyStatistics';
  failed?: Maybe<Scalars['Int']['output']>;
  successRate?: Maybe<Scalars['Float']['output']>;
  successful?: Maybe<Scalars['Int']['output']>;
  tested?: Maybe<Scalars['Int']['output']>;
};

export type SubmitCentroidRating = {
  __typename?: 'SubmitCentroidRating';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<CentroidRatingResultType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmitSurveyResponse = {
  __typename?: 'SubmitSurveyResponse';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  surveyResponse?: Maybe<SurveyResponseType>;
};

export type SuggestedKeywords = {
  __typename?: 'SuggestedKeywords';
  nonSoftware?: Maybe<Array<Maybe<KeywordSuggestion>>>;
  software?: Maybe<Array<Maybe<KeywordSuggestion>>>;
};

export type SurveyResponseType = {
  __typename?: 'SurveyResponseType';
  answers?: Maybe<Scalars['JSONString']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  meetingId?: Maybe<Scalars['Int']['output']>;
  questionnaireId: Scalars['Int']['output'];
  respondentId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type SyncYcCompanies = {
  __typename?: 'SyncYCCompanies';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SynthesizeCompanyAnalysisMutation = {
  __typename?: 'SynthesizeCompanyAnalysisMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SynthesizeCoreKeywords = {
  __typename?: 'SynthesizeCoreKeywords';
  keywordCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskLog = {
  __typename?: 'TaskLog';
  environment?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
  taskTime?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type TaxonomyV2Type = {
  __typename?: 'TaxonomyV2Type';
  cortexFitAssessment: Scalars['String']['output'];
  deploymentModel: Scalars['String']['output'];
  horizontalityScore: Scalars['String']['output'];
  integrationEcosystem?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryCategory: Scalars['String']['output'];
  subcategories: Array<Maybe<Scalars['String']['output']>>;
  technologyLayer: Scalars['String']['output'];
};

export type TeamQualityType = {
  __typename?: 'TeamQualityType';
  medianEmploymentMonths?: Maybe<Scalars['Float']['output']>;
  medianPreviousEmployers?: Maybe<Scalars['Float']['output']>;
  medianTotalEmploymentMonths?: Maybe<Scalars['Float']['output']>;
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  teamQualityPercentage?: Maybe<Scalars['String']['output']>;
};

export type TechUseType = Node & {
  __typename?: 'TechUseType';
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  findingUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  markedAsFalsePositive?: Maybe<Scalars['Boolean']['output']>;
  matchRelevance?: Maybe<Scalars['Float']['output']>;
  stackshareTool?: Maybe<ProductTechnologylType>;
  stackshareToolId?: Maybe<Scalars['Int']['output']>;
};

export type TestBrightdataLinkedinCompanyData = {
  __typename?: 'TestBrightdataLinkedinCompanyData';
  companyData?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TestCompanyNameFinder = {
  __typename?: 'TestCompanyNameFinder';
  companyUrl?: Maybe<Scalars['String']['output']>;
};

export type TestDirectoryNameFinder = {
  __typename?: 'TestDirectoryNameFinder';
  companyId?: Maybe<Scalars['Int']['output']>;
};

export type TestEmailSending = {
  __typename?: 'TestEmailSending';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TestFteExtraction = {
  __typename?: 'TestFTEExtraction';
  extractedFte?: Maybe<Scalars['Int']['output']>;
  originalExtraction?: Maybe<Scalars['Int']['output']>;
  testUrl?: Maybe<Scalars['String']['output']>;
  wasFiltered?: Maybe<Scalars['Boolean']['output']>;
};

export type TestGetSourcescrubData = {
  __typename?: 'TestGetSourcescrubData';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TestLlmCustomerSegmentationMutation = {
  __typename?: 'TestLLMCustomerSegmentationMutation';
  jobId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TestPipedriveDealCreation = {
  __typename?: 'TestPipedriveDealCreation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TestRetrievalOfOpenaiBatchJob = {
  __typename?: 'TestRetrievalOfOpenaiBatchJob';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TestS3Event = {
  __typename?: 'TestS3Event';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TestStackshareToolAnalysis = {
  __typename?: 'TestStackshareToolAnalysis';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TextFindingConnection = {
  __typename?: 'TextFindingConnection';
  edges: Array<Maybe<TextFindingEdge>>;
  pageInfo?: Maybe<DbIdPageInfo>;
};

export type TextFindingEdge = {
  __typename?: 'TextFindingEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TextFindingType>;
};

export type TextFindingType = {
  __typename?: 'TextFindingType';
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  fteCount?: Maybe<Scalars['Int']['output']>;
  genericCrawlResultId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type TimeSeriesDataPointType = {
  __typename?: 'TimeSeriesDataPointType';
  executedCount?: Maybe<Scalars['Int']['output']>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
  successRate?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ToolCallType = {
  __typename?: 'ToolCallType';
  arguments: Scalars['JSONString']['output'];
  name: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
};

export type TrainBuyAndBuildRelevanceModel = {
  __typename?: 'TrainBuyAndBuildRelevanceModel';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TrainCallabilityModel = {
  __typename?: 'TrainCallabilityModel';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TrainSizeEstimatorModel = {
  __typename?: 'TrainSizeEstimatorModel';
  nTestSamples?: Maybe<Scalars['Int']['output']>;
  nTrainingSamples?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  r2?: Maybe<Scalars['Float']['output']>;
  rmse?: Maybe<Scalars['Float']['output']>;
};

export type TransferBuyAndBuildTargetsToPipedrive = {
  __typename?: 'TransferBuyAndBuildTargetsToPipedrive';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TransferXoviKeywordToCoreKeywords = {
  __typename?: 'TransferXOVIKeywordToCoreKeywords';
  coreKeywordId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TrendType = {
  __typename?: 'TrendType';
  changePct?: Maybe<Scalars['Float']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
};

export type TriggerCategoryAiScoring = {
  __typename?: 'TriggerCategoryAIScoring';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TriggerInboxV2Recrawl = {
  __typename?: 'TriggerInboxV2Recrawl';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TriggerPatternEvaluation = {
  __typename?: 'TriggerPatternEvaluation';
  activatedCount?: Maybe<Scalars['Int']['output']>;
  activatedPatterns?: Maybe<Scalars['JSONString']['output']>;
  deletedCount?: Maybe<Scalars['Int']['output']>;
  deletedPatterns?: Maybe<Scalars['JSONString']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stillProbationaryCount?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TriggerPatternGeneration = {
  __typename?: 'TriggerPatternGeneration';
  createdCount?: Maybe<Scalars['Int']['output']>;
  createdPatterns?: Maybe<Scalars['JSONString']['output']>;
  errorCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rejectedCount?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TriggerValidationResult = {
  __typename?: 'TriggerValidationResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
};

export type TriggerValuationForecast = {
  __typename?: 'TriggerValuationForecast';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TriggerValuationForecastAll = {
  __typename?: 'TriggerValuationForecastAll';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TriggerYcCrawls = {
  __typename?: 'TriggerYCCrawls';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnitEconomicsType = {
  __typename?: 'UnitEconomicsType';
  businessModel: Scalars['String']['output'];
  cortexRating: CortexRatingEnum;
  estimatedArr?: Maybe<Scalars['String']['output']>;
  estimatedCac?: Maybe<Scalars['String']['output']>;
  estimatedLtv?: Maybe<Scalars['String']['output']>;
  expansionRevenuePotential?: Maybe<Scalars['String']['output']>;
  grossMarginEstimate?: Maybe<Scalars['String']['output']>;
  ltvCacRatio?: Maybe<Scalars['String']['output']>;
  pricingModel?: Maybe<Scalars['String']['output']>;
  ratingRationale: Scalars['String']['output'];
  revenueStreams: Array<Maybe<Scalars['String']['output']>>;
  scalabilityFactors: Array<Maybe<Scalars['String']['output']>>;
  scalabilityRisks: Array<Maybe<Scalars['String']['output']>>;
};

export type UnitEconomicsV2Type = {
  __typename?: 'UnitEconomicsV2Type';
  businessModel: Scalars['String']['output'];
  claimIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cortexRating: CortexRatingEnumV2;
  estimatedArr?: Maybe<Scalars['String']['output']>;
  estimatedCac?: Maybe<Scalars['String']['output']>;
  estimatedLtv?: Maybe<Scalars['String']['output']>;
  exhibitIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  grossMarginEstimate?: Maybe<Scalars['String']['output']>;
  ltvCacRatio?: Maybe<Scalars['String']['output']>;
  pricingModel?: Maybe<Scalars['String']['output']>;
  ratingRationale: Scalars['String']['output'];
  revenueStreams: Array<Maybe<Scalars['String']['output']>>;
  scalabilityFactors: Array<Maybe<Scalars['String']['output']>>;
  scalabilityRisks: Array<Maybe<Scalars['String']['output']>>;
  summary: Scalars['String']['output'];
};

export type UnlockCrawlQueueEntries = {
  __typename?: 'UnlockCrawlQueueEntries';
  ok?: Maybe<Scalars['Boolean']['output']>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

export type UpdateAllExchangeRates = {
  __typename?: 'UpdateAllExchangeRates';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCertification = {
  __typename?: 'UpdateCertification';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateClassificationPattern = {
  __typename?: 'UpdateClassificationPattern';
  error?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<ClassificationPatternType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCompanyGoogleDriveConfig = {
  __typename?: 'UpdateCompanyGoogleDriveConfig';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCompanyProduct = {
  __typename?: 'UpdateCompanyProduct';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCortexConfig = {
  __typename?: 'UpdateCortexConfig';
  cortexConfig?: Maybe<CortexConfigType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCrawlQueueConfig = {
  __typename?: 'UpdateCrawlQueueConfig';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCustomerSegmentMutation = {
  __typename?: 'UpdateCustomerSegmentMutation';
  definitionUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  segmentDescription?: Maybe<Scalars['String']['output']>;
  segmentName?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateFinancialForecastParams = {
  __typename?: 'UpdateFinancialForecastParams';
  ok?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type UpdatePatternOutcomesForCompany = {
  __typename?: 'UpdatePatternOutcomesForCompany';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

export type UpdateProductPricing = {
  __typename?: 'UpdateProductPricing';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateRedBeatSchedule = {
  __typename?: 'UpdateRedBeatSchedule';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSoftwareCategoryAiScore = {
  __typename?: 'UpdateSoftwareCategoryAIScore';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateVibeCodingIdea = {
  __typename?: 'UpdateVibeCodingIdea';
  idea?: Maybe<VibeCodingIdeaType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadExcelCellInput = {
  callPythonType: Scalars['String']['input'];
  cellFormula?: InputMaybe<Scalars['String']['input']>;
  cellType: Scalars['String']['input'];
  cellValue: Scalars['String']['input'];
  column: Scalars['Int']['input'];
  isHeader?: InputMaybe<Scalars['Boolean']['input']>;
  row: Scalars['Int']['input'];
  sheetId: Scalars['Int']['input'];
};

export type UploadExcelCellMutation = {
  __typename?: 'UploadExcelCellMutation';
  cell?: Maybe<UploadExcelCellType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadExcelCellType = {
  __typename?: 'UploadExcelCellType';
  callPythonType?: Maybe<Scalars['String']['output']>;
  cellFormula?: Maybe<Scalars['String']['output']>;
  cellType?: Maybe<Scalars['String']['output']>;
  cellValue?: Maybe<Scalars['String']['output']>;
  column?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isHeader?: Maybe<Scalars['Boolean']['output']>;
  row?: Maybe<Scalars['Int']['output']>;
  sheet?: Maybe<UploadExcelSheetType>;
  sheetId?: Maybe<Scalars['Int']['output']>;
};

export type UploadExcelFileChunkMutation = {
  __typename?: 'UploadExcelFileChunkMutation';
  file?: Maybe<UploadExcelFileType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadExcelFileInput = {
  blobContent?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  isBenchmarkingFile?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomerFile?: InputMaybe<Scalars['Boolean']['input']>;
  isLboFile?: InputMaybe<Scalars['Boolean']['input']>;
  uploaderName?: InputMaybe<Scalars['String']['input']>;
};

export type UploadExcelFileMutation = {
  __typename?: 'UploadExcelFileMutation';
  file?: Maybe<UploadExcelFileType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadExcelFileType = {
  __typename?: 'UploadExcelFileType';
  blobContent?: Maybe<Scalars['JSONString']['output']>;
  company?: Maybe<BuyAndBuildTargetAssessmentType>;
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isBenchmarkingFile?: Maybe<Scalars['Boolean']['output']>;
  isCustomerFile?: Maybe<Scalars['Boolean']['output']>;
  isLboFile?: Maybe<Scalars['Boolean']['output']>;
  sheets?: Maybe<Array<Maybe<UploadExcelSheetType>>>;
  uploadCompleted?: Maybe<Scalars['Boolean']['output']>;
  uploadDate?: Maybe<Scalars['DateTime']['output']>;
  uploaderName?: Maybe<Scalars['String']['output']>;
};

export type UploadExcelRowInput = {
  cells?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Int']['input']>;
  rows?: InputMaybe<Array<InputMaybe<ExcelRowInput>>>;
  sheetId: Scalars['Int']['input'];
  startRow?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadExcelRowMutation = {
  __typename?: 'UploadExcelRowMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadExcelSheetInput = {
  excelFileId: Scalars['Int']['input'];
  sheetName: Scalars['String']['input'];
};

export type UploadExcelSheetMutation = {
  __typename?: 'UploadExcelSheetMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  sheet?: Maybe<UploadExcelSheetType>;
};

export type UploadExcelSheetType = {
  __typename?: 'UploadExcelSheetType';
  cells?: Maybe<Array<Maybe<UploadExcelCellType>>>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  excelFile?: Maybe<UploadExcelFileType>;
  excelFileId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  sheetName?: Maybe<Scalars['String']['output']>;
};

export type UploadFileResponse = {
  __typename?: 'UploadFileResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadIndustryBenchmarkData = {
  __typename?: 'UploadIndustryBenchmarkData';
  count?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpvoteFindingsToken = {
  __typename?: 'UpvoteFindingsToken';
  ok?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<FindingsTokenType>;
};

export type UsageType = {
  __typename?: 'UsageType';
  apolloCallRate: Scalars['Float']['output'];
  apolloCreditsUsed: Scalars['Float']['output'];
  firecrawlCreditsUsed: Scalars['Float']['output'];
  totalEnrichments: Scalars['Int']['output'];
};

export type UserActivityStatsType = {
  __typename?: 'UserActivityStatsType';
  dealCreatedCount?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  orgCreatedCount?: Maybe<Scalars['Int']['output']>;
  totalValidations?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserStatsType = {
  __typename?: 'UserStatsType';
  callCount?: Maybe<Scalars['Int']['output']>;
  companiesContacted?: Maybe<Scalars['Int']['output']>;
  dealsTotal?: Maybe<Scalars['Int']['output']>;
  dealsWon?: Maybe<Scalars['Int']['output']>;
  surveyCompletionRate?: Maybe<Scalars['Float']['output']>;
  surveyCount?: Maybe<Scalars['Int']['output']>;
  totalActivities?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ValidateCompanyWithRag = {
  __typename?: 'ValidateCompanyWithRAG';
  jobId?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  taskChainId?: Maybe<Scalars['String']['output']>;
};

export type ValidatedKeywordEntryType = {
  __typename?: 'ValidatedKeywordEntryType';
  keyword?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  relevanceScore?: Maybe<Scalars['Float']['output']>;
  selectedByUser?: Maybe<Scalars['Boolean']['output']>;
  selectionTimestamp?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ValidatedKeywordsSummaryType = {
  __typename?: 'ValidatedKeywordsSummaryType';
  companyDomain?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  isSoftware?: Maybe<Scalars['Boolean']['output']>;
  suggestedKeywords?: Maybe<Scalars['JSONString']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  validatedKeywords?: Maybe<Array<Maybe<ValidatedKeywordEntryType>>>;
  validationTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type ValidationAccuracyType = {
  __typename?: 'ValidationAccuracyType';
  accuracyPct?: Maybe<Scalars['Float']['output']>;
  correct?: Maybe<Scalars['Int']['output']>;
  falseNegatives?: Maybe<Scalars['Int']['output']>;
  falsePositiveRate?: Maybe<Scalars['Float']['output']>;
  falsePositives?: Maybe<Scalars['Int']['output']>;
  promptVariant?: Maybe<Scalars['String']['output']>;
  promptVersion?: Maybe<Scalars['String']['output']>;
  totalValidations?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['String']['output']>;
};

export type ValidationAnalytics = {
  __typename?: 'ValidationAnalytics';
  nonSoftware?: Maybe<Array<Maybe<KeywordStatistics>>>;
  software?: Maybe<Array<Maybe<KeywordStatistics>>>;
};

export type ValidationInboxItemType = {
  __typename?: 'ValidationInboxItemType';
  analysisFte?: Maybe<Scalars['Int']['output']>;
  callabilityScore?: Maybe<Scalars['Float']['output']>;
  companyCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  companyValidated?: Maybe<Scalars['Boolean']['output']>;
  companyValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  crawlFte?: Maybe<Scalars['Int']['output']>;
  crawlUrl?: Maybe<Scalars['String']['output']>;
  crawlWasFinished?: Maybe<Scalars['Boolean']['output']>;
  isSoftwareCompany?: Maybe<Scalars['Boolean']['output']>;
  lastValidatedCrCreated?: Maybe<Scalars['DateTime']['output']>;
  latestCrCreated?: Maybe<Scalars['DateTime']['output']>;
  latestCrValidated?: Maybe<Scalars['Boolean']['output']>;
  latestCrawlResultId?: Maybe<Scalars['Int']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  uniqueDomain?: Maybe<Scalars['String']['output']>;
  validationLockedAt?: Maybe<Scalars['DateTime']['output']>;
  validationLockedBy?: Maybe<Scalars['Int']['output']>;
  validationNeeded?: Maybe<Scalars['String']['output']>;
};

export type ValidationTestResult = {
  __typename?: 'ValidationTestResult';
  companyId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  taskIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  validationIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type VerifyCompanyCertification = {
  __typename?: 'VerifyCompanyCertification';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VibeCodingIdeaType = Node & {
  __typename?: 'VibeCodingIdeaType';
  businessImpact?: Maybe<Scalars['String']['output']>;
  competitiveAngle?: Maybe<Scalars['String']['output']>;
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  estimatedComplexity?: Maybe<Scalars['String']['output']>;
  generationModel?: Maybe<Scalars['String']['output']>;
  generationPromptVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryVertical?: Maybe<Scalars['String']['output']>;
  isBookmarked?: Maybe<Scalars['Boolean']['output']>;
  portfolioCompany?: Maybe<BuyAndBuildTargetAssessmentType>;
  portfolioCompanyId: Scalars['Int']['output'];
  problemStatement?: Maybe<Scalars['String']['output']>;
  proposedSolution?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  techStackSuggestion?: Maybe<Scalars['JSONString']['output']>;
  title: Scalars['String']['output'];
  userNotes?: Maybe<Scalars['String']['output']>;
  userRating?: Maybe<Scalars['Int']['output']>;
  ycCompany?: Maybe<YcCompanyType>;
  ycCompanyId?: Maybe<Scalars['Int']['output']>;
  ycStartupName?: Maybe<Scalars['String']['output']>;
  ycStartupOneLiner?: Maybe<Scalars['String']['output']>;
};

export type VibeCodingIdeaTypeConnection = {
  __typename?: 'VibeCodingIdeaTypeConnection';
  edges: Array<Maybe<VibeCodingIdeaTypeEdge>>;
  pageInfo: PageInfo;
};

export type VibeCodingIdeaTypeEdge = {
  __typename?: 'VibeCodingIdeaTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<VibeCodingIdeaType>;
};

export type WaterfallBarType = {
  __typename?: 'WaterfallBarType';
  companyIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type WaterfallDataType = {
  __typename?: 'WaterfallDataType';
  bars?: Maybe<Array<Maybe<WaterfallBarType>>>;
  funnelPercentage?: Maybe<Scalars['Float']['output']>;
  initialCallsUnvalidated?: Maybe<Scalars['Int']['output']>;
  initialCallsUnvalidatedCompanyIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type WaterfallDrillDownType = {
  __typename?: 'WaterfallDrillDownType';
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  meetingHolders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WeightAdjustmentResultType = {
  __typename?: 'WeightAdjustmentResultType';
  adjustments?: Maybe<Array<Maybe<WeightAdjustmentType>>>;
  adjustmentsCount?: Maybe<Scalars['Int']['output']>;
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type WeightAdjustmentType = {
  __typename?: 'WeightAdjustmentType';
  applied?: Maybe<Scalars['Boolean']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  currentWeight?: Maybe<Scalars['Float']['output']>;
  patternId?: Maybe<Scalars['Int']['output']>;
  patternText?: Maybe<Scalars['String']['output']>;
  suggestedWeight?: Maybe<Scalars['Float']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
  weightChange?: Maybe<Scalars['Float']['output']>;
};

export type XoviKeywordType = {
  __typename?: 'XOVIKeywordType';
  cpc?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPlaceholderForEmptyXoviResponse?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  markedAsIrrelevant?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  searchEngine?: Maybe<Scalars['String']['output']>;
  sevo?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum XoviKeywordsSortEnum {
  ChangeAsc = 'change_asc',
  ChangeDesc = 'change_desc',
  CompetitorDensityAsc = 'competitorDensity_asc',
  CompetitorDensityDesc = 'competitorDensity_desc',
  CpcAsc = 'cpc_asc',
  CpcDesc = 'cpc_desc',
  CreatedFromDataForSeoAsc = 'created_from_data_for_seo_asc',
  CreatedFromDataForSeoDesc = 'created_from_data_for_seo_desc',
  DatetimeCreatedAsc = 'datetime_created_asc',
  DatetimeCreatedDesc = 'datetime_created_desc',
  DatetimeModifiedAsc = 'datetime_modified_asc',
  DatetimeModifiedDesc = 'datetime_modified_desc',
  GenericCrawlResultIdAsc = 'generic_crawl_result_id_asc',
  GenericCrawlResultIdDesc = 'generic_crawl_result_id_desc',
  GoogleTermIdAsc = 'google_term_id_asc',
  GoogleTermIdDesc = 'google_term_id_desc',
  HasBeenSearchedAsc = 'has_been_searched_asc',
  HasBeenSearchedDesc = 'has_been_searched_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsPlaceholderForEmptyXoviResponseAsc = 'is_placeholder_for_empty_xovi_response_asc',
  IsPlaceholderForEmptyXoviResponseDesc = 'is_placeholder_for_empty_xovi_response_desc',
  KeywordAsc = 'keyword_asc',
  KeywordDesc = 'keyword_desc',
  KeywordEmbeddingAsc = 'keyword_embedding_asc',
  KeywordEmbeddingDesc = 'keyword_embedding_desc',
  KeywordEmbeddingV2Asc = 'keyword_embedding_v2_asc',
  KeywordEmbeddingV2Desc = 'keyword_embedding_v2_desc',
  KeywordLanguageAsc = 'keyword_language_asc',
  KeywordLanguageDesc = 'keyword_language_desc',
  MarkedAsIrrelevantAsc = 'marked_as_irrelevant_asc',
  MarkedAsIrrelevantDesc = 'marked_as_irrelevant_desc',
  PositionAsc = 'position_asc',
  PositionDesc = 'position_desc',
  SearchEngineAsc = 'search_engine_asc',
  SearchEngineDesc = 'search_engine_desc',
  SeoDataAnalysisIdAsc = 'seo_data_analysis_id_asc',
  SeoDataAnalysisIdDesc = 'seo_data_analysis_id_desc',
  SevoAsc = 'sevo_asc',
  SevoDesc = 'sevo_desc',
  UrlAsc = 'url_asc',
  UrlDesc = 'url_desc'
}

export type XoviKeywordConnection = {
  __typename?: 'XoviKeywordConnection';
  edges: Array<Maybe<XoviKeywordEdge>>;
  pageInfo: PageInfo;
};

export type XoviKeywordEdge = {
  __typename?: 'XoviKeywordEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<XoviKeywordSqlType>;
};

export enum XoviKeywordOrderEnum {
  CpcAsc = 'CPC_ASC',
  CpcDesc = 'CPC_DESC'
}

export type XoviKeywordSqlType = Node & {
  __typename?: 'XoviKeywordSQLType';
  change?: Maybe<Scalars['Int']['output']>;
  competitorDensity?: Maybe<Scalars['Int']['output']>;
  cpc?: Maybe<Scalars['Float']['output']>;
  createdFromDataForSeo?: Maybe<Scalars['Boolean']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  genericCrawlResultId?: Maybe<Scalars['Int']['output']>;
  genericCrawlResults?: Maybe<RecentPlatformCrawlType>;
  googleTermId?: Maybe<Scalars['Int']['output']>;
  hasBeenSearched?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isPlaceholderForEmptyXoviResponse?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  keywordEmbedding?: Maybe<Scalars['JSONString']['output']>;
  keywordEmbeddingV2?: Maybe<Scalars['JSONString']['output']>;
  keywordLanguage?: Maybe<Scalars['String']['output']>;
  markedAsIrrelevant?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  searchEngine?: Maybe<Scalars['String']['output']>;
  seoDataAnalysisId?: Maybe<Scalars['Int']['output']>;
  sevo?: Maybe<Scalars['Int']['output']>;
  specialGenericCrawlResults?: Maybe<RecentPlatformCrawlType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type YcCompanyType = Node & {
  __typename?: 'YCCompanyType';
  allLocations?: Maybe<Scalars['String']['output']>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  batch?: Maybe<Scalars['String']['output']>;
  company?: Maybe<BuyAndBuildTargetAssessmentType>;
  companyId?: Maybe<Scalars['Int']['output']>;
  datetimeCreated?: Maybe<Scalars['DateTime']['output']>;
  datetimeModified?: Maybe<Scalars['DateTime']['output']>;
  dbId?: Maybe<Scalars['Int']['output']>;
  formerNames?: Maybe<Scalars['JSONString']['output']>;
  highlightBlack?: Maybe<Scalars['Boolean']['output']>;
  highlightLatinx?: Maybe<Scalars['Boolean']['output']>;
  highlightWomen?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Scalars['JSONString']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  isHiring?: Maybe<Scalars['Boolean']['output']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  launchedAt?: Maybe<Scalars['DateTime']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonprofit?: Maybe<Scalars['Boolean']['output']>;
  oneLiner?: Maybe<Scalars['String']['output']>;
  regions?: Maybe<Scalars['JSONString']['output']>;
  slug: Scalars['String']['output'];
  smallLogoThumbUrl?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subindustry?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['JSONString']['output']>;
  teamSize?: Maybe<Scalars['Int']['output']>;
  topCompany?: Maybe<Scalars['Boolean']['output']>;
  vibeCodingIdeas?: Maybe<VibeCodingIdeaTypeConnection>;
  website?: Maybe<Scalars['String']['output']>;
  ycId: Scalars['Int']['output'];
  ycUrl?: Maybe<Scalars['String']['output']>;
};


export type YcCompanyTypeVibeCodingIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type YcCompanyTypeConnection = {
  __typename?: 'YCCompanyTypeConnection';
  edges: Array<Maybe<YcCompanyTypeEdge>>;
  pageInfo: PageInfo;
};

export type YcCompanyTypeEdge = {
  __typename?: 'YCCompanyTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<YcCompanyType>;
};

export type YcStartupWithScoreType = {
  __typename?: 'YCStartupWithScoreType';
  similarityScore?: Maybe<Scalars['Float']['output']>;
  ycCompany?: Maybe<YcCompanyType>;
};

export type YcStartupsResultType = {
  __typename?: 'YCStartupsResultType';
  items?: Maybe<Array<Maybe<YcStartupWithScoreType>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type YcStatsType = {
  __typename?: 'YCStatsType';
  active?: Maybe<Scalars['Int']['output']>;
  linkedToGenericCompany?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  unlinked?: Maybe<Scalars['Int']['output']>;
};

export type DeleteAllBmForCompany = {
  __typename?: 'deleteAllBmForCompany';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FinishExcelFileUpload = {
  __typename?: 'finishExcelFileUpload';
  file?: Maybe<UploadExcelFileType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type LoadImageLearnerMutation = {
  __typename?: 'loadImageLearnerMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkCustomerReferenceObsolete = {
  __typename?: 'markCustomerReferenceObsolete';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpgradeAlembic = {
  __typename?: 'upgradeAlembic';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DbIdPageInfoFragmentFragment = { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null };

export type AcquireValidationLockMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}>;


export type AcquireValidationLockMutation = { __typename?: 'Mutations', acquireValidationLock?: { __typename?: 'AcquireValidationLock', success?: boolean | null, message?: string | null, lockedBy?: number | null, lockedAt?: any | null } | null };

export type AddBuyAndBuildTargetMutationVariables = Exact<{
  softwareCompanyId: Scalars['Int']['input'];
  targetCompanyUrl: Scalars['String']['input'];
  quality?: InputMaybe<Scalars['Float']['input']>;
  setManualScore?: InputMaybe<Scalars['Boolean']['input']>;
  sourcescrubTags?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddBuyAndBuildTargetMutation = { __typename?: 'Mutations', addBuyAndBuildTarget?: { __typename?: 'AddBuyAndBuildTarget', ok?: boolean | null } | null };

export type AddBuyAndBuildTargetsFromSourcescrubMutationVariables = Exact<{
  authId?: InputMaybe<Scalars['String']['input']>;
  softwareCompanyId: Scalars['Int']['input'];
}>;


export type AddBuyAndBuildTargetsFromSourcescrubMutation = { __typename?: 'Mutations', addBuyAndBuildTargetsFromSourcescrub?: { __typename?: 'AddBuyAndBuildTargetsFromSourcescrub', ok?: boolean | null } | null };

export type AddCompanyCertificationMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  certificationId: Scalars['Int']['input'];
}>;


export type AddCompanyCertificationMutation = { __typename?: 'Mutations', addCompanyCertification?: { __typename?: 'AddCompanyCertification', success?: boolean | null, message?: string | null, companyCertificationId?: number | null } | null };

export type AddCoreKeywordMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  keyword: Scalars['String']['input'];
}>;


export type AddCoreKeywordMutation = { __typename?: 'Mutations', addCoreKeyword?: { __typename?: 'AddCoreKeyword', success?: boolean | null, message?: string | null, dbId?: number | null } | null };

export type AddSegmentCustomerMutationVariables = Exact<{
  input: CustomerSegmentInput;
}>;


export type AddSegmentCustomerMutation = { __typename?: 'Mutations', addCustomerSegment?: { __typename?: 'AddCustomerSegmentMutation', success?: boolean | null } | null };

export type AddIndustryMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  referencedAt: Scalars['String']['input'];
  sicCode: Scalars['String']['input'];
}>;


export type AddIndustryMutation = { __typename?: 'Mutations', addIndustry?: { __typename?: 'AddIndustry', companyId?: number | null, sicCode?: string | null, referencedAt?: string | null } | null };

export type AddSoftwareCategoryToCompanyMutationVariables = Exact<{
  softwareCategoryId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
}>;


export type AddSoftwareCategoryToCompanyMutation = { __typename?: 'Mutations', addSoftwareCategoryToCompany?: { __typename?: 'AddSoftwareCategoryToCompany', success?: boolean | null } | null };

export type AddTechnologyFindingTextMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  findingText: Scalars['String']['input'];
}>;


export type AddTechnologyFindingTextMutation = { __typename?: 'Mutations', addTechnologyFindingText?: { __typename?: 'AddTechnologyFindingText', companyId?: number | null, findingText?: string | null } | null };

export type AddTechnologyFindingUrlMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  findingUrl: Scalars['String']['input'];
}>;


export type AddTechnologyFindingUrlMutation = { __typename?: 'Mutations', addTechnologyFindingUrl?: { __typename?: 'AddTechnologyFindingUrl', companyId?: number | null, findingUrl?: string | null } | null };

export type CreateCertificationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  issuer?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  aiMoatLevel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCertificationMutation = { __typename?: 'Mutations', createCertification?: { __typename?: 'CreateCertification', success?: boolean | null, message?: string | null, certificationId?: number | null } | null };

export type UpdateCertificationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  aiMoatLevel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCertificationMutation = { __typename?: 'Mutations', updateCertification?: { __typename?: 'UpdateCertification', success?: boolean | null, message?: string | null } | null };

export type DeleteCertificationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCertificationMutation = { __typename?: 'Mutations', deleteCertification?: { __typename?: 'DeleteCertification', success?: boolean | null, message?: string | null } | null };

export type UpdateSoftwareCategoryAiScoreMutationVariables = Exact<{
  categoryId: Scalars['Int']['input'];
  disruptionRisk?: InputMaybe<Scalars['Float']['input']>;
  aiOpportunity?: InputMaybe<Scalars['Float']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  dimensionScores?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpdateSoftwareCategoryAiScoreMutation = { __typename?: 'Mutations', updateSoftwareCategoryAiScore?: { __typename?: 'UpdateSoftwareCategoryAIScore', success?: boolean | null, message?: string | null } | null };

export type DeleteSoftwareCategoryAiScoreMutationVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type DeleteSoftwareCategoryAiScoreMutation = { __typename?: 'Mutations', deleteSoftwareCategoryAiScore?: { __typename?: 'DeleteSoftwareCategoryAIScore', success?: boolean | null, message?: string | null } | null };

export type TriggerCategoryAiScoringMutationVariables = Exact<{
  batchSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TriggerCategoryAiScoringMutation = { __typename?: 'Mutations', triggerCategoryAiScoring?: { __typename?: 'TriggerCategoryAIScoring', success?: boolean | null, message?: string | null } | null };

export type SeedCertificationTaxonomyMutationVariables = Exact<{ [key: string]: never; }>;


export type SeedCertificationTaxonomyMutation = { __typename?: 'Mutations', seedCertificationTaxonomy?: { __typename?: 'SeedCertificationTaxonomy', success?: boolean | null, message?: string | null, count?: number | null } | null };

export type BulkEstimateGdriveConfigMutationVariables = Exact<{
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  autoConfigureHighConfidence?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BulkEstimateGdriveConfigMutation = { __typename?: 'Mutations', bulkEstimateGdriveConfig?: { __typename?: 'BulkEstimateGDriveConfig', success?: boolean | null, message?: string | null, totalProcessed?: number | null, autoConfiguredCount?: number | null, requiresConfirmationCount?: number | null, results?: Array<{ __typename?: 'BulkGDriveConfigEstimateResult', companyId: number, companyName?: string | null, error?: string | null, estimate?: { __typename?: 'GDriveConfigEstimateType', sharedDriveName: string, directoryName: string, directoryId?: string | null, confidence: string, alternatives: Array<string | null>, requiresUserConfirmation: boolean } | null } | null> | null } | null };

export type ConfirmCompanyGdriveConfigMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  sharedDriveName: Scalars['String']['input'];
  directoryName: Scalars['String']['input'];
  createIfNotExists?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConfirmCompanyGdriveConfigMutation = { __typename?: 'Mutations', confirmCompanyGdriveConfig?: { __typename?: 'ConfirmCompanyGDriveConfig', success?: boolean | null, message?: string | null, directoryId?: string | null } | null };

export type ConfirmFteSizeMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  crawlResultId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  newFte: Scalars['Int']['input'];
  isConfirmedChange: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmFteSizeMutation = { __typename?: 'Mutations', confirmFteSize?: { __typename?: 'ConfirmFteSize', success?: boolean | null, message?: string | null, fteChanged?: boolean | null, previousFte?: number | null } | null };

export type CortexFeedbackPipedriveBridgeMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  addOnForBidId: Scalars['Int']['input'];
}>;


export type CortexFeedbackPipedriveBridgeMutation = { __typename?: 'Mutations', cortexFeedbackPipedriveBridge?: { __typename?: 'CortexFeedbackPipedriveBridge', success?: boolean | null } | null };

export type CreateBenchmarkPlMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  category1: Scalars['String']['input'];
  category2: Scalars['String']['input'];
  category3: Scalars['String']['input'];
  valuationLevel: Scalars['Int']['input'];
  period: Scalars['Int']['input'];
  periodType: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  value: Scalars['Float']['input'];
}>;


export type CreateBenchmarkPlMutation = { __typename?: 'Mutations', createBenchmarkPl?: { __typename?: 'CreateBenchmarkPL', benchmarkingData?: { __typename?: 'BenchmarkPLType', id: string, companyId?: number | null, value?: number | null } | null } | null };

export type CreateCompanyProductMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  productName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  pricing?: InputMaybe<Array<InputMaybe<PricingTierInput>> | InputMaybe<PricingTierInput>>;
}>;


export type CreateCompanyProductMutation = { __typename?: 'Mutations', createCompanyProduct?: { __typename?: 'CreateCompanyProduct', success?: boolean | null, message?: string | null, productId?: number | null } | null };

export type CreateKeywordsMutationVariables = Exact<{
  genericCrawlResultId: Scalars['Int']['input'];
  keywords: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  searchEngine?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateKeywordsMutation = { __typename?: 'Mutations', createKeywords?: { __typename?: 'CreateXoviKeywords', keywords?: string | null, genericCrawlResultId?: number | null } | null };

export type CreateMeetingMutationVariables = Exact<{
  domain: Scalars['String']['input'];
  meetingDate: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  attendeeUserIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMeetingMutation = { __typename?: 'Mutations', createMeeting?: { __typename?: 'CreateMeeting', ok: boolean, error?: string | null, meeting?: { __typename?: 'MeetingType', id: number, domain: string, companyId?: number | null, title?: string | null, meetingDate: any } | null } | null };

export type CreatePdOrganizationMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  authId?: InputMaybe<Scalars['String']['input']>;
  newPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  addOnExisting?: InputMaybe<Scalars['Boolean']['input']>;
  addOnFuture?: InputMaybe<Scalars['Boolean']['input']>;
  saas?: InputMaybe<Scalars['Boolean']['input']>;
  venture?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Scalars['Boolean']['input']>;
  partOfGroup?: InputMaybe<Scalars['Boolean']['input']>;
  otherOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  sellsHardware?: InputMaybe<Scalars['Boolean']['input']>;
  tooMuchConsulting?: InputMaybe<Scalars['Boolean']['input']>;
  reseller?: InputMaybe<Scalars['Boolean']['input']>;
  wrongBusinessModel?: InputMaybe<Scalars['Boolean']['input']>;
  b2c?: InputMaybe<Scalars['Boolean']['input']>;
  wrongGeography?: InputMaybe<Scalars['Boolean']['input']>;
  tooBig?: InputMaybe<Scalars['Boolean']['input']>;
  tooSmall?: InputMaybe<Scalars['Boolean']['input']>;
  createOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  createDeal?: InputMaybe<Scalars['Boolean']['input']>;
  selectValue?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePdOrganizationMutation = { __typename?: 'Mutations', cortexFeedbackPipedriveBridge?: { __typename?: 'CortexFeedbackPipedriveBridge', success?: boolean | null, message?: string | null } | null };

export type CreateQuestionnaireVersionMutationVariables = Exact<{
  title: Scalars['String']['input'];
  questions: Scalars['JSONString']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateQuestionnaireVersionMutation = { __typename?: 'Mutations', createQuestionnaireVersion?: { __typename?: 'CreateQuestionnaireVersion', ok: boolean, error?: string | null, questionnaire?: { __typename?: 'QuestionnaireType', id: number, version: number, title: string } | null } | null };

export type CreateRedbeatScheduleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  task: Scalars['String']['input'];
  scheduleType: Scalars['String']['input'];
  intervalSeconds?: InputMaybe<Scalars['Float']['input']>;
  crontabMinute?: InputMaybe<Scalars['String']['input']>;
  crontabHour?: InputMaybe<Scalars['String']['input']>;
  crontabDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  crontabDayOfMonth?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  kwargs?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type CreateRedbeatScheduleMutation = { __typename?: 'Mutations', createRedbeatSchedule?: { __typename?: 'CreateRedBeatSchedule', ok?: boolean | null } | null };

export type CreateUpdateCompanyTechUseMutationVariables = Exact<{
  stackshareToolId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
}>;


export type CreateUpdateCompanyTechUseMutation = { __typename?: 'Mutations', createUpdateCompanyTechUse?: { __typename?: 'CreateUpdateCompanyTechUse', companyId?: number | null } | null };

export type CreateUpdateGenericShareholderMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  typeOfInvestor?: InputMaybe<Scalars['String']['input']>;
  yearBornOrFounded?: InputMaybe<Scalars['Int']['input']>;
  genericCompanyId?: InputMaybe<Scalars['Int']['input']>;
  genericShareholderId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateUpdateGenericShareholderMutation = { __typename?: 'Mutations', createUpdateGenericShareholder?: { __typename?: 'CreateUpdateGenericShareholder', dbId?: number | null, name?: string | null } | null };

export type CreateUpdateGenericShareholdingMutationVariables = Exact<{
  genericCompanyId?: InputMaybe<Scalars['Int']['input']>;
  genericShareholderId?: InputMaybe<Scalars['Int']['input']>;
  genericShareholdingId?: InputMaybe<Scalars['Int']['input']>;
  holding?: InputMaybe<Scalars['Float']['input']>;
  holdingCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateUpdateGenericShareholdingMutation = { __typename?: 'Mutations', createUpdateGenericShareholding?: { __typename?: 'CreateUpdateGenericShareholding', genericCompanyId?: number | null, genericShareholderId?: number | null, holdingCount?: number | null, holding?: number | null } | null };

export type CreateUpdateKeywordMutationVariables = Exact<{
  genericCrawlResultId: Scalars['Int']['input'];
  keyword: Scalars['String']['input'];
  searchEngine?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUpdateKeywordMutation = { __typename?: 'Mutations', createUpdateKeyword?: { __typename?: 'CreateUpdateXoviKeyword', keyword?: string | null, searchEngine?: string | null } | null };

export type DeleteAllBmForCompanyMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type DeleteAllBmForCompanyMutation = { __typename?: 'Mutations', deleteAllBmForCompany?: { __typename?: 'deleteAllBmForCompany', success?: boolean | null } | null };

export type DeleteCompanyProductMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type DeleteCompanyProductMutation = { __typename?: 'Mutations', deleteCompanyProduct?: { __typename?: 'DeleteCompanyProduct', success?: boolean | null, message?: string | null } | null };

export type DeleteCompanyTechUseMutationVariables = Exact<{
  techUseId: Scalars['Int']['input'];
}>;


export type DeleteCompanyTechUseMutation = { __typename?: 'Mutations', deleteCompanyTechUse?: { __typename?: 'DeleteCompanyTechUse', message?: string | null, success?: boolean | null } | null };

export type DeleteCrawlQueueEntriesMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type DeleteCrawlQueueEntriesMutation = { __typename?: 'Mutations', deleteCrawlQueueEntries?: { __typename?: 'DeleteCrawlQueueEntries', ok?: boolean | null, deletedCount?: number | null } | null };

export type DeleteCustomerReferenceMutationVariables = Exact<{
  customerReferenceId: Scalars['Int']['input'];
}>;


export type DeleteCustomerReferenceMutation = { __typename?: 'Mutations', deleteCustomerReference?: { __typename?: 'DeleteCustomerReference', success?: boolean | null, message?: string | null } | null };

export type DeleteSegmentMutationVariables = Exact<{
  segmentId: Scalars['Int']['input'];
}>;


export type DeleteSegmentMutation = { __typename?: 'Mutations', deleteCustomerSegment?: { __typename?: 'DeleteCustomerSegmentMutation', success?: boolean | null } | null };

export type DeleteGenericShareholdingMutationVariables = Exact<{
  genericShareholdingId: Scalars['Int']['input'];
}>;


export type DeleteGenericShareholdingMutation = { __typename?: 'Mutations', deleteGenericShareholding?: { __typename?: 'DeleteGenericShareholding', success?: boolean | null } | null };

export type DeleteKeywordMutationVariables = Exact<{
  keywordId: Scalars['Int']['input'];
}>;


export type DeleteKeywordMutation = { __typename?: 'Mutations', deleteKeyword?: { __typename?: 'MarkXOVIKeywordAsIrrelevant', success?: boolean | null, message?: string | null } | null };

export type DeleteKeywordsMutationVariables = Exact<{
  keywordIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type DeleteKeywordsMutation = { __typename?: 'Mutations', deleteKeywords?: { __typename?: 'MarkXOVIKeywordsAsIrrelevant', success?: boolean | null, message?: string | null } | null };

export type DeleteRedbeatScheduleMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteRedbeatScheduleMutation = { __typename?: 'Mutations', deleteRedbeatSchedule?: { __typename?: 'DeleteRedBeatSchedule', ok?: boolean | null } | null };

export type DeleteSelectedCompanyTechUseMutationVariables = Exact<{
  techUseIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type DeleteSelectedCompanyTechUseMutation = { __typename?: 'Mutations', deleteSelectedCompanyTechUse?: { __typename?: 'DeleteSelectedCompanyTechUse', success?: boolean | null, message?: string | null } | null };

export type DownvoteFindingsTokenMutationVariables = Exact<{
  tokenId: Scalars['Int']['input'];
}>;


export type DownvoteFindingsTokenMutation = { __typename?: 'Mutations', downvoteFindingsToken?: { __typename?: 'DownvoteFindingsToken', ok?: boolean | null, token?: { __typename?: 'FindingsTokenType', id: string } | null } | null };

export type EditCompanyMutationVariables = Exact<{
  benchmarkingIndex?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyDescription?: InputMaybe<Scalars['String']['input']>;
  buyAndBuildFocus?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['String']['input']>;
  foundingYear?: InputMaybe<Scalars['Int']['input']>;
  hrbNumber?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  pipedriveId?: InputMaybe<Scalars['Int']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  sicCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditCompanyMutation = { __typename?: 'Mutations', editCompany?: { __typename?: 'EditCompany', legalName?: string | null, shortName?: string | null, companyDescription?: string | null, buyAndBuildFocus?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: string | null, linkedinUrl?: string | null, pipedriveId?: number | null, hrbNumber?: string | null, court?: string | null, benchmarkingIndex?: number | null, sicCode?: string | null, foundingYear?: number | null } | null };

export type EditCustomerReferenceMutationVariables = Exact<{
  customerReferenceId: Scalars['Int']['input'];
  customerReferenceName?: InputMaybe<Scalars['String']['input']>;
  wonYear?: InputMaybe<Scalars['Int']['input']>;
  revenueYearOne?: InputMaybe<Scalars['Int']['input']>;
  revenueYearTwo?: InputMaybe<Scalars['Int']['input']>;
  shareOfRevenue?: InputMaybe<Scalars['Float']['input']>;
  arr?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  lostYear?: InputMaybe<Scalars['Int']['input']>;
  lossReason?: InputMaybe<Scalars['String']['input']>;
  nps?: InputMaybe<Scalars['Int']['input']>;
  isDdDatapoint?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditCustomerReferenceMutation = { __typename?: 'Mutations', editCustomerReference?: { __typename?: 'EditCustomerReference', message?: string | null, success?: boolean | null } | null };

export type EnrichContactMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type EnrichContactMutation = { __typename?: 'Mutations', enrichCompanyContact?: { __typename?: 'EnrichCompanyContactMutation', success: boolean, message: string, taskId?: string | null, operationId?: string | null } | null };

export type EstimateCompanyGdriveConfigMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type EstimateCompanyGdriveConfigMutation = { __typename?: 'Mutations', estimateCompanyGdriveConfig?: { __typename?: 'EstimateCompanyGDriveConfig', success?: boolean | null, message?: string | null, estimate?: { __typename?: 'GDriveConfigEstimateType', sharedDriveName: string, directoryName: string, directoryId?: string | null, confidence: string, alternatives: Array<string | null>, requiresUserConfirmation: boolean } | null } | null };

export type ExcelUploadFileMutationVariables = Exact<{
  input: UploadExcelFileInput;
}>;


export type ExcelUploadFileMutation = { __typename?: 'Mutations', uploadExcelFile?: { __typename?: 'UploadExcelFileMutation', ok?: boolean | null, file?: { __typename?: 'UploadExcelFileType', id: string, fileName?: string | null } | null } | null };

export type ExcelUploadRowMutationVariables = Exact<{
  input: UploadExcelRowInput;
}>;


export type ExcelUploadRowMutation = { __typename?: 'Mutations', uploadExcelRow?: { __typename?: 'UploadExcelRowMutation', ok?: boolean | null } | null };

export type ExcelUploadSheetMutationVariables = Exact<{
  input: UploadExcelSheetInput;
}>;


export type ExcelUploadSheetMutation = { __typename?: 'Mutations', uploadExcelSheet?: { __typename?: 'UploadExcelSheetMutation', ok?: boolean | null, sheet?: { __typename?: 'UploadExcelSheetType', id: string, sheetName?: string | null } | null } | null };

export type UpdateFinancialForecastParamsMutationVariables = Exact<{
  params: Scalars['JSONString']['input'];
}>;


export type UpdateFinancialForecastParamsMutation = { __typename?: 'Mutations', updateFinancialForecastParams?: { __typename?: 'UpdateFinancialForecastParams', ok?: boolean | null, version?: number | null } | null };

export type TriggerValuationForecastMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type TriggerValuationForecastMutation = { __typename?: 'Mutations', triggerValuationForecast?: { __typename?: 'TriggerValuationForecast', success?: boolean | null } | null };

export type TriggerValuationForecastAllMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerValuationForecastAllMutation = { __typename?: 'Mutations', triggerValuationForecastAll?: { __typename?: 'TriggerValuationForecastAll', success?: boolean | null } | null };

export type FinishCompanyValidationMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  authId: Scalars['String']['input'];
}>;


export type FinishCompanyValidationMutation = { __typename?: 'Mutations', finishCompanyValidation?: { __typename?: 'FinishCompanyValidation', success?: boolean | null, message?: string | null } | null };

export type FinishCrawlResultValidationMutationVariables = Exact<{
  crawlResultId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  authId: Scalars['String']['input'];
}>;


export type FinishCrawlResultValidationMutation = { __typename?: 'Mutations', finishCrawlResultValidation?: { __typename?: 'FinishCrawlResultValidation', success?: boolean | null, message?: string | null, batchValidatedCount?: number | null } | null };

export type FinishExcelFileUploadMutationVariables = Exact<{
  input: Scalars['Int']['input'];
  onlyFinancialKpis?: InputMaybe<Scalars['Boolean']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinishExcelFileUploadMutation = { __typename?: 'Mutations', finishExcelFileUpload?: { __typename?: 'finishExcelFileUpload', ok?: boolean | null } | null };

export type GenerateVibeCodingIdeasMutationVariables = Exact<{
  portfolioCompanyId: Scalars['Int']['input'];
  maxIdeas?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GenerateVibeCodingIdeasMutation = { __typename?: 'Mutations', generateVibeCodingIdeas?: { __typename?: 'GenerateVibeCodingIdeas', success?: boolean | null, message?: string | null } | null };

export type InsertCertainProductCategoryMutationVariables = Exact<{
  productCategorizationId: Scalars['Int']['input'];
}>;


export type InsertCertainProductCategoryMutation = { __typename?: 'Mutations', insertCertainProductCategory?: { __typename?: 'InsertCertainProductCategory', message?: string | null, success?: boolean | null } | null };

export type LabelBuyAndBuildTargetQualityMutationVariables = Exact<{
  quality: Scalars['Float']['input'];
  softwareCompanyId: Scalars['Int']['input'];
  targetCompanyId: Scalars['Int']['input'];
}>;


export type LabelBuyAndBuildTargetQualityMutation = { __typename?: 'Mutations', labelBuyAndBuildTargetQuality?: { __typename?: 'LabelBuyAndBuildTargetQuality', ok?: boolean | null } | null };

export type LockCrawlQueueEntriesMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type LockCrawlQueueEntriesMutation = { __typename?: 'Mutations', lockCrawlQueueEntries?: { __typename?: 'LockCrawlQueueEntries', ok?: boolean | null, updatedCount?: number | null } | null };

export type MarkCompanyAsNotSoftwareMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type MarkCompanyAsNotSoftwareMutation = { __typename?: 'Mutations', markCompanyAsNotSoftware?: { __typename?: 'MarkCompanyAsNotSoftware', ok?: boolean | null } | null };

export type MarkCompanyAsSoftwareMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  crawlResultId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarkCompanyAsSoftwareMutation = { __typename?: 'Mutations', markCompanyAsSoftware?: { __typename?: 'MarkCompanyAsSoftware', ok?: boolean | null } | null };

export type MarkCustomerReferenceObsoleteMutationVariables = Exact<{
  customerReferenceId: Scalars['Int']['input'];
}>;


export type MarkCustomerReferenceObsoleteMutation = { __typename?: 'Mutations', markCustomerReferenceObsolete?: { __typename?: 'markCustomerReferenceObsolete', success?: boolean | null, message?: string | null } | null };

export type MarkProductAsHorizontalMutationVariables = Exact<{
  softwareCompanyId: Scalars['Int']['input'];
}>;


export type MarkProductAsHorizontalMutation = { __typename?: 'Mutations', markProductAsHorizontal?: { __typename?: 'MarkProductAsHorizontal', message?: string | null, success?: boolean | null } | null };

export type PrecalculateAllKpisMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type PrecalculateAllKpisMutation = { __typename?: 'Mutations', precalculateAllKpis?: { __typename?: 'PreCalculateAllKPIs', ok?: boolean | null } | null };

export type RecalculateCompanyKpisMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type RecalculateCompanyKpisMutation = { __typename?: 'Mutations', precalculateAllKpis?: { __typename?: 'PreCalculateAllKPIs', ok?: boolean | null } | null };

export type RefreshCompanyGoogleDriveFilesMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type RefreshCompanyGoogleDriveFilesMutation = { __typename?: 'Mutations', refreshCompanyGoogleDriveFiles?: { __typename?: 'RefreshCompanyGoogleDriveFiles', success?: boolean | null, message?: string | null, autoConfigured?: boolean | null, requiresConfiguration?: boolean | null, configEstimate?: { __typename?: 'GDriveConfigEstimateType', sharedDriveName: string, directoryName: string, directoryId?: string | null, confidence: string, alternatives: Array<string | null>, requiresUserConfirmation: boolean } | null } | null };

export type RefreshValidationInboxMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshValidationInboxMutation = { __typename?: 'Mutations', refreshValidationInbox?: { __typename?: 'RefreshValidationInbox', success?: boolean | null, message?: string | null } | null };

export type RegenerateAllDAsMutationVariables = Exact<{ [key: string]: never; }>;


export type RegenerateAllDAsMutation = { __typename?: 'Mutations', regenerateAllDas?: { __typename?: 'RegenerateAllDAs', ok?: boolean | null, cortexConfig?: { __typename?: 'CortexConfigType', assessmentXlsUploadTime?: any | null } | null } | null };

export type RejectCoreKeywordMutationVariables = Exact<{
  keywordId: Scalars['Int']['input'];
}>;


export type RejectCoreKeywordMutation = { __typename?: 'Mutations', rejectCoreKeyword?: { __typename?: 'RejectCoreKeyword', success?: boolean | null, message?: string | null } | null };

export type ReleaseValidationLockMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}>;


export type ReleaseValidationLockMutation = { __typename?: 'Mutations', releaseValidationLock?: { __typename?: 'ReleaseValidationLock', success?: boolean | null, message?: string | null } | null };

export type RemoveCompanyCertificationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveCompanyCertificationMutation = { __typename?: 'Mutations', removeCompanyCertification?: { __typename?: 'RemoveCompanyCertification', success?: boolean | null, message?: string | null } | null };

export type RemoveShortlistedBuyAndBuildTargetsMutationVariables = Exact<{
  softwareCompanyId: Scalars['Int']['input'];
  targetCompanyId: Scalars['Int']['input'];
}>;


export type RemoveShortlistedBuyAndBuildTargetsMutation = { __typename?: 'Mutations', removeShortlistedBuyAndBuildTargets?: { __typename?: 'RemoveShortlistedBuyAndBuildTarget', ok?: boolean | null } | null };

export type RenewValidationLockMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}>;


export type RenewValidationLockMutation = { __typename?: 'Mutations', renewValidationLock?: { __typename?: 'RenewValidationLock', success?: boolean | null, message?: string | null } | null };

export type ResegmentCustomersMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type ResegmentCustomersMutation = { __typename?: 'Mutations', resegmentAllCustomers?: { __typename?: 'ResegmentAllCustomersMutation', success?: boolean | null } | null };

export type ResetDealAssessmentUploadMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type ResetDealAssessmentUploadMutation = { __typename?: 'Mutations', resetDealAssessmentUpload?: { __typename?: 'ResetDealAssessmentUpload', success?: boolean | null, message?: string | null } | null };

export type SaveDealTransactionMutationVariables = Exact<{
  targetCompanyName?: InputMaybe<Scalars['String']['input']>;
  targetCompanyDomain: Scalars['String']['input'];
  targetCompanyCountry?: InputMaybe<Scalars['String']['input']>;
  targetCompanyId?: InputMaybe<Scalars['Int']['input']>;
  forceTargetIsSoftwareCompany?: InputMaybe<Scalars['Boolean']['input']>;
  transactionType?: InputMaybe<Scalars['String']['input']>;
  amountRaised?: InputMaybe<Scalars['Float']['input']>;
  totalAmountRaised?: InputMaybe<Scalars['Float']['input']>;
  dateOfTransaction?: InputMaybe<Scalars['String']['input']>;
  typeOfTransaction?: InputMaybe<Scalars['String']['input']>;
  listOfBuyers: Array<ShareholderInputType> | ShareholderInputType;
  listOfSellers: Array<ShareholderInputType> | ShareholderInputType;
}>;


export type SaveDealTransactionMutation = { __typename?: 'Mutations', saveDealTransaction?: { __typename?: 'SaveDealTransaction', success?: boolean | null, message?: string | null } | null };

export type SetCompanySizeMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  fte: Scalars['Int']['input'];
  findingUrl: Scalars['String']['input'];
  typeOfFinding: Scalars['Int']['input'];
}>;


export type SetCompanySizeMutation = { __typename?: 'Mutations', setCompanySize?: { __typename?: 'SetCompanySize', ok?: boolean | null, typeOfFinding?: number | null, findingUrl?: string | null, fte?: number | null } | null };

export type SetProductCategoryToZeroMutationVariables = Exact<{
  productCategorizationId: Scalars['Int']['input'];
}>;


export type SetProductCategoryToZeroMutation = { __typename?: 'Mutations', setProductCategoryToZero?: { __typename?: 'SetProductCategoryToZero', message?: string | null, success?: boolean | null } | null };

export type ShortlistBuyAndBuildTargetMutationVariables = Exact<{
  softwareCompanyId: Scalars['Int']['input'];
  targetCompanyId: Scalars['Int']['input'];
}>;


export type ShortlistBuyAndBuildTargetMutation = { __typename?: 'Mutations', shortlistBuyAndBuildTarget?: { __typename?: 'ShortlistBuyAndBuildTarget', ok?: boolean | null } | null };

export type CreateClassificationPatternMutationVariables = Exact<{
  input: PatternCreateInput;
  createdBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateClassificationPatternMutation = { __typename?: 'Mutations', createClassificationPattern?: { __typename?: 'CreateClassificationPattern', success?: boolean | null, error?: string | null, pattern?: { __typename?: 'ClassificationPatternType', dbId?: number | null, patternText: string, patternType: string, classificationTarget: string, weight?: number | null, isActive: boolean, description?: string | null } | null } | null };

export type UpdateClassificationPatternMutationVariables = Exact<{
  patternId: Scalars['Int']['input'];
  input: PatternUpdateInput;
}>;


export type UpdateClassificationPatternMutation = { __typename?: 'Mutations', updateClassificationPattern?: { __typename?: 'UpdateClassificationPattern', success?: boolean | null, error?: string | null, pattern?: { __typename?: 'ClassificationPatternType', dbId?: number | null, patternText: string, patternType: string, classificationTarget: string, weight?: number | null, isActive: boolean, description?: string | null } | null } | null };

export type DeleteClassificationPatternMutationVariables = Exact<{
  patternId: Scalars['Int']['input'];
}>;


export type DeleteClassificationPatternMutation = { __typename?: 'Mutations', deleteClassificationPattern?: { __typename?: 'DeleteClassificationPattern', success?: boolean | null, error?: string | null } | null };

export type RecordPatternMatchFeedbackMutationVariables = Exact<{
  patternMatchId: Scalars['Int']['input'];
  wasCorrect: Scalars['Boolean']['input'];
  userFeedback?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordPatternMatchFeedbackMutation = { __typename?: 'Mutations', recordPatternMatchFeedback?: { __typename?: 'RecordPatternMatchFeedback', success?: boolean | null, error?: string | null } | null };

export type ActivateProbationaryPatternMutationVariables = Exact<{
  patternId: Scalars['Int']['input'];
}>;


export type ActivateProbationaryPatternMutation = { __typename?: 'Mutations', activateProbationaryPattern?: { __typename?: 'ActivateProbationaryPattern', success?: boolean | null, error?: string | null, pattern?: { __typename?: 'ClassificationPatternType', dbId?: number | null, patternText: string, patternType: string, classificationTarget: string, weight?: number | null, isActive: boolean, isProbationary?: boolean | null, probationMetadata?: any | null, description?: string | null } | null } | null };

export type DeleteProbationaryPatternMutationVariables = Exact<{
  patternId: Scalars['Int']['input'];
}>;


export type DeleteProbationaryPatternMutation = { __typename?: 'Mutations', deleteProbationaryPattern?: { __typename?: 'DeleteProbationaryPattern', success?: boolean | null, error?: string | null } | null };

export type TriggerPatternGenerationMutationVariables = Exact<{
  minOccurrences?: InputMaybe<Scalars['Int']['input']>;
  minConsistency?: InputMaybe<Scalars['Float']['input']>;
  daysLookback?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TriggerPatternGenerationMutation = { __typename?: 'Mutations', triggerPatternGeneration?: { __typename?: 'TriggerPatternGeneration', createdCount?: number | null, rejectedCount?: number | null, errorCount?: number | null, success?: boolean | null, message?: string | null, createdPatterns?: any | null } | null };

export type TriggerPatternEvaluationMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerPatternEvaluationMutation = { __typename?: 'Mutations', triggerPatternEvaluation?: { __typename?: 'TriggerPatternEvaluation', activatedCount?: number | null, deletedCount?: number | null, stillProbationaryCount?: number | null, success?: boolean | null, message?: string | null, activatedPatterns?: any | null, deletedPatterns?: any | null } | null };

export type StartAiThreatResearchMutationVariables = Exact<{
  input: StartResearchInput;
}>;


export type StartAiThreatResearchMutation = { __typename?: 'Mutations', startResearch?: { __typename?: 'StartResearch', success: boolean, jobId?: string | null, status?: string | null, error?: string | null } | null };

export type StartCddReportMutationVariables = Exact<{
  input: StartCddAnalysisInput;
}>;


export type StartCddReportMutation = { __typename?: 'Mutations', startCddAnalysis?: { __typename?: 'StartCDDAnalysisMutation', jobId: string, status: string } | null };

export type StartCrawlMutationVariables = Exact<{
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  forceDeepAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  forceSw?: InputMaybe<Scalars['Boolean']['input']>;
  pipedriveId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StartCrawlMutation = { __typename?: 'Mutations', startCrawler?: { __typename?: 'StartCrawlerMutation', success?: boolean | null } | null };

export type StartVerificationSessionMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  authId: Scalars['String']['input'];
}>;


export type StartVerificationSessionMutation = { __typename?: 'Mutations', startCompanyVerificationSession?: { __typename?: 'StartCompanyVerificationSession', success?: boolean | null, message?: string | null } | null };

export type SubmitSurveyResponseMutationVariables = Exact<{
  meetingId: Scalars['Int']['input'];
  answers: Scalars['JSONString']['input'];
}>;


export type SubmitSurveyResponseMutation = { __typename?: 'Mutations', submitSurveyResponse?: { __typename?: 'SubmitSurveyResponse', ok: boolean, error?: string | null, surveyResponse?: { __typename?: 'SurveyResponseType', id: number, datetimeCreated?: any | null } | null } | null };

export type TransferBuyAndBuildTargetsToPipedriveMutationVariables = Exact<{
  softwareCompanyId: Scalars['Int']['input'];
}>;


export type TransferBuyAndBuildTargetsToPipedriveMutation = { __typename?: 'Mutations', transferBuyAndBuildTargetsToPipedrive?: { __typename?: 'TransferBuyAndBuildTargetsToPipedrive', ok?: boolean | null } | null };

export type TransferXoviKeywordToCoreKeywordsMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  xoviKeywordId: Scalars['Int']['input'];
}>;


export type TransferXoviKeywordToCoreKeywordsMutation = { __typename?: 'Mutations', transferXoviKeywordToCoreKeywords?: { __typename?: 'TransferXOVIKeywordToCoreKeywords', success?: boolean | null, message?: string | null, coreKeywordId?: number | null } | null };

export type TriggerScheduledAiValidationMutationVariables = Exact<{
  forceRefreshView?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TriggerScheduledAiValidationMutation = { __typename?: 'Mutations', triggerScheduledAiValidation?: { __typename?: 'ScheduledValidationResult', success?: boolean | null, message?: string | null, totalQueued?: number | null, byInbox?: any | null, taskId?: string | null } | null };

export type UnlockCrawlQueueEntriesMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type UnlockCrawlQueueEntriesMutation = { __typename?: 'Mutations', unlockCrawlQueueEntries?: { __typename?: 'UnlockCrawlQueueEntries', ok?: boolean | null, updatedCount?: number | null } | null };

export type UpdateCompanyGoogleDriveConfigMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  gdriveSharedDriveName?: InputMaybe<Scalars['String']['input']>;
  gdriveDirectoryName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCompanyGoogleDriveConfigMutation = { __typename?: 'Mutations', updateCompanyGoogleDriveConfig?: { __typename?: 'UpdateCompanyGoogleDriveConfig', success?: boolean | null, message?: string | null } | null };

export type UpdateCompanyProductMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCompanyProductMutation = { __typename?: 'Mutations', updateCompanyProduct?: { __typename?: 'UpdateCompanyProduct', success?: boolean | null, message?: string | null } | null };

export type UpdateCortexConfigMutationVariables = Exact<{
  attributes: Scalars['JSONString']['input'];
}>;


export type UpdateCortexConfigMutation = { __typename?: 'Mutations', updateCortexConfig?: { __typename?: 'UpdateCortexConfig', ok?: boolean | null } | null };

export type UpdateCrawlQueueConfigMutationVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  intervalSeconds?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateCrawlQueueConfigMutation = { __typename?: 'Mutations', updateCrawlQueueConfig?: { __typename?: 'UpdateCrawlQueueConfig', ok?: boolean | null } | null };

export type UpdateSegmentForCustomerMutationVariables = Exact<{
  input: CustomerSegmentInput;
  segmentId: Scalars['Int']['input'];
}>;


export type UpdateSegmentForCustomerMutation = { __typename?: 'Mutations', updateCustomerSegment?: { __typename?: 'UpdateCustomerSegmentMutation', success?: boolean | null } | null };

export type UpdateProductPricingMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  pricing: Array<InputMaybe<PricingTierInput>> | InputMaybe<PricingTierInput>;
}>;


export type UpdateProductPricingMutation = { __typename?: 'Mutations', updateProductPricing?: { __typename?: 'UpdateProductPricing', success?: boolean | null, message?: string | null } | null };

export type UpdateRedbeatScheduleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  task?: InputMaybe<Scalars['String']['input']>;
  scheduleType?: InputMaybe<Scalars['String']['input']>;
  intervalSeconds?: InputMaybe<Scalars['Float']['input']>;
  crontabMinute?: InputMaybe<Scalars['String']['input']>;
  crontabHour?: InputMaybe<Scalars['String']['input']>;
  crontabDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  crontabDayOfMonth?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  kwargs?: InputMaybe<Scalars['JSONString']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateRedbeatScheduleMutation = { __typename?: 'Mutations', updateRedbeatSchedule?: { __typename?: 'UpdateRedBeatSchedule', ok?: boolean | null } | null };

export type UpdateVibeCodingIdeaMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  userRating?: InputMaybe<Scalars['Int']['input']>;
  userNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateVibeCodingIdeaMutation = { __typename?: 'Mutations', updateVibeCodingIdea?: { __typename?: 'UpdateVibeCodingIdea', success?: boolean | null, message?: string | null } | null };

export type UploadFileMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  file: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  isBmFile: Scalars['Boolean']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutations', uploadFile?: { __typename?: 'UploadFileResponse', url?: string | null } | null };

export type UploadIndustryBenchmarkDataMutationVariables = Exact<{
  data: Array<IndustryBenchmarkInput> | IndustryBenchmarkInput;
}>;


export type UploadIndustryBenchmarkDataMutation = { __typename?: 'Mutations', uploadIndustryBenchmarkData?: { __typename?: 'UploadIndustryBenchmarkData', success?: boolean | null, count?: number | null, errors?: Array<string | null> | null } | null };

export type UpvoteFindingsTokenMutationVariables = Exact<{
  tokenId: Scalars['Int']['input'];
}>;


export type UpvoteFindingsTokenMutation = { __typename?: 'Mutations', upvoteFindingsToken?: { __typename?: 'UpvoteFindingsToken', ok?: boolean | null, token?: { __typename?: 'FindingsTokenType', id: string } | null } | null };

export type ValidateCompanyWithRagMutationVariables = Exact<{
  companyDomain: Scalars['String']['input'];
  shadowMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ValidateCompanyWithRagMutation = { __typename?: 'Mutations', validateCompanyWithRag?: { __typename?: 'ValidateCompanyWithRAG', success?: boolean | null, message?: string | null, taskChainId?: string | null, jobId?: string | null } | null };

export type VerifyCompanyCertificationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  isVerified: Scalars['Boolean']['input'];
}>;


export type VerifyCompanyCertificationMutation = { __typename?: 'Mutations', verifyCompanyCertification?: { __typename?: 'VerifyCompanyCertification', success?: boolean | null, message?: string | null } | null };

export type GetCertificationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCertificationsQuery = { __typename?: 'Query', certifications?: Array<{ __typename?: 'CertificationType', dbId?: number | null, name: string, issuer?: string | null, domain?: string | null, level?: string | null, aiMoatLevel?: string | null, description?: string | null } | null> | null };

export type GetSoftwareCategoryAiScoresQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  scoredOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSoftwareCategoryAiScoresQuery = { __typename?: 'Query', softwareCategoryAiScores?: Array<{ __typename?: 'SoftwareCategoryWithScoreType', categoryId?: number | null, categoryName?: string | null, taxonomyPath?: string | null, hasScore?: boolean | null, disruptionRisk?: number | null, aiOpportunity?: number | null, compositeScore?: number | null, rationale?: string | null, scoringVersion?: string | null, dimensionScores?: any | null, dimensionReasoning?: any | null } | null> | null };

export type GetAiRiskFactorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiRiskFactorsQuery = { __typename?: 'Query', aiRiskFactors?: Array<{ __typename?: 'AIRiskFactorType', id?: string | null, name?: string | null, column?: string | null, weight?: number | null, description?: string | null, signals?: Array<string | null> | null, rubricHigh?: string | null, rubricMedium?: string | null, rubricLow?: string | null, relevance?: string | null, aiErosionRisk?: string | null, aiErosionNote?: string | null, examples?: string | null } | null> | null };

export type GetAiOpportunityFactorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiOpportunityFactorsQuery = { __typename?: 'Query', aiOpportunityFactors?: Array<{ __typename?: 'AIOpportunityFactorType', id?: string | null, name?: string | null, column?: string | null, weight?: number | null, description?: string | null, signals?: Array<string | null> | null, rubricHigh?: string | null, rubricMedium?: string | null, rubricLow?: string | null, relevance?: string | null, examples?: string | null } | null> | null };

export type BuyAndBuildListQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
  isShortlisted?: InputMaybe<Scalars['Boolean']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type BuyAndBuildListQuery = { __typename?: 'Query', companyAssesment?: { __typename?: 'CompanyAssesmentConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyAssesmentEdge', node?: { __typename?: 'CompanyAssessmentType', dbId?: number | null, buyAndBuildTargets?: { __typename?: 'GenericBuyAndBuildRelevanceConnection', pageInfo?: { __typename?: 'DbIdPageInfo', startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'GenericBuyAndBuildRelevanceEdge', node?: { __typename?: 'GenericBuyAndBuildRelevanceSQLType', isShortlistedCompany1?: boolean | null, manuallyLabeledScore?: number | null, buyAndBuildRelevance?: number | null, company?: { __typename?: 'BABCompanyType', dbId?: number | null, uniqueDomain?: string | null, iabDomainCategory?: string | null, fte?: number | null, country?: string | null, summaryDescription?: string | null, validated?: boolean | null, pipedriveId?: number | null, productCategorization?: { __typename?: 'ProductCategorizationConnection', edges: Array<{ __typename?: 'ProductCategorizationEdge', node?: { __typename?: 'ProductCategorizationType', softwareCategoryCertainty?: number | null, softwareCategory?: { __typename?: 'SoftwareCategoryType', subCategory1?: string | null, subCategory2?: string | null, subCategory3?: string | null } | null } | null } | null> } | null, latestCrawlResult?: { __typename?: 'GenericCrawlResultSQLType', xoviKeywords?: { __typename?: 'XoviKeywordConnection', edges: Array<{ __typename?: 'XoviKeywordEdge', node?: { __typename?: 'XoviKeywordSQLType', keyword?: string | null, cpc?: number | null } | null } | null> } | null } | null } | null } | null } | null> } | null } | null } | null> } | null };

export type CompaniesByCategoriesQueryVariables = Exact<{
  subCategory1?: InputMaybe<Scalars['String']['input']>;
  subCategory2?: InputMaybe<Scalars['String']['input']>;
  subCategory3?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompaniesByCategoriesQuery = { __typename?: 'Query', companiesByCategories?: Array<{ __typename?: 'CompanyAssessmentType', id: string, dbId?: number | null, shortName?: string | null, country?: string | null, uniqueDomain?: string | null } | null> | null };

export type CompaniesByIndustriesQueryVariables = Exact<{
  sicCodes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type CompaniesByIndustriesQuery = { __typename?: 'Query', companiesByIndustries?: Array<{ __typename?: 'CompanyAssessmentType', id: string, dbId?: number | null, shortName?: string | null, country?: string | null, uniqueDomain?: string | null } | null> | null };

export type CompaniesByIndustryAndCategoryQueryVariables = Exact<{
  sicCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  subCategory1?: InputMaybe<Scalars['String']['input']>;
  subCategory2?: InputMaybe<Scalars['String']['input']>;
  subCategory3?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompaniesByIndustryAndCategoryQuery = { __typename?: 'Query', companiesByIndustryAndCategory?: Array<{ __typename?: 'CompanyAssessmentType', id: string, dbId?: number | null, shortName?: string | null, country?: string | null, uniqueDomain?: string | null } | null> | null };

export type CompanyAssesmentQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type CompanyAssesmentQuery = { __typename?: 'Query', companyAssesment?: { __typename?: 'CompanyAssesmentConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyAssesmentEdge', cursor: string, node?: { __typename?: 'CompanyAssessmentType', id: string, maxFte?: number | null } | null } | null> } | null };

export type CompanyCertificationsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type CompanyCertificationsQuery = { __typename?: 'Query', companyCertifications?: Array<{ __typename?: 'CompanyCertificationType', id?: number | null, companyId?: number | null, certificationId?: number | null, extractionMethod?: string | null, extractionConfidence?: number | null, sourceUrl?: string | null, contextSnippet?: string | null, isVerified?: boolean | null, datetimeCreated?: any | null, certificationName?: string | null, certificationIssuer?: string | null, certificationDomain?: string | null, certificationLevel?: string | null, certificationAiMoatLevel?: string | null, certificationDescription?: string | null } | null> | null };

export type CompanyContactsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type CompanyContactsQuery = { __typename?: 'Query', companyContacts?: Array<{ __typename?: 'CompanyContactType', name: string, email?: string | null, contactType: string, pdPersonId?: number | null } | null> | null };

export type GetCompanyCoreKeywordsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetCompanyCoreKeywordsQuery = { __typename?: 'Query', getCompanyCoreKeywords?: { __typename?: 'CompanyCoreKeywordConnection', edges: Array<{ __typename?: 'CompanyCoreKeywordEdge', node?: { __typename?: 'CompanyCoreKeywordType', dbId?: number | null, keyword: string, keywordType?: string | null, cpc?: number | null, searchVolume?: number | null, competitionIndex?: number | null, source?: string | null } | null } | null> } | null };

export type CompanyInboxListQueryVariables = Exact<{
  country?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  newPlatforms?: InputMaybe<Scalars['Boolean']['input']>;
  prioritizedPlatforms?: InputMaybe<Scalars['Boolean']['input']>;
  falseNegatives?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompanyInboxListQuery = { __typename?: 'Query', companyInboxList?: Array<{ __typename?: 'CompanyInboxType', dbId?: number | null, shortName?: string | null, uniqueDomain?: string | null, logoUrl?: string | null, crawlUrl?: string | null, country?: string | null, sicCode?: string | null, sicCodeCertainty?: number | null, sicCodeJustification?: string | null, fte?: number | null, topRelatedCompanyName?: string | null, topRelatedCompanyLogoUrl?: string | null, aiValidationScore?: number | null, datetimeCreated?: any | null, systemType?: string | null, iabDomainCategory?: string | null, productCategorization?: { __typename?: 'ProductCategorizationConnection', edges: Array<{ __typename?: 'ProductCategorizationEdge', node?: { __typename?: 'ProductCategorizationType', id: string, softwareCategory?: { __typename?: 'SoftwareCategoryType', subCategory1?: string | null } | null } | null } | null> } | null } | null> | null };

export type CompanyPnlForecastQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type CompanyPnlForecastQuery = { __typename?: 'Query', companyPnlForecast?: { __typename?: 'CompanyPnlForecastType', recurringRevenueShare?: number | null, lastFiscalYear?: number | null, rows?: Array<{ __typename?: 'PnlYearRowType', year?: number | null, isForecast?: boolean | null, revenue?: number | null, cogs?: number | null, grossProfit?: number | null, opex?: number | null, ebitda?: number | null, da?: number | null, ebit?: number | null, fte?: number | null, revenueGrowth?: number | null } | null> | null } | null };

export type CompetitionCpcKeywordsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompetitionCpcKeywordsQuery = { __typename?: 'Query', competitionCpcKeywords?: { __typename?: 'KeywordResultRawConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'KeywordResultRawEdge', cursor: string, node?: { __typename?: 'KeywordResultRawType', cpc?: number | null, keyword?: string | null, dbId?: any | null } | null } | null> } | null };

export type ConversionTrackingQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ConversionTrackingQuery = { __typename?: 'Query', conversionTracking?: Array<{ __typename?: 'ConversionTrackingType', pipedriveDealId?: number | null, title?: string | null, status?: string | null, stageName?: string | null, pipelineName?: string | null, value?: number | null, companyName?: string | null, dealCreatedAt?: any | null, dealClosedAt?: any | null, linkedMeetingCount?: number | null, initialCallCount?: number | null, followupCallCount?: number | null, firstCallDate?: any | null } | null> | null };

export type CortexConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type CortexConfigQuery = { __typename?: 'Query', cortexConfig?: { __typename?: 'CortexConfigType', postToZapier?: boolean | null, aiValidationOverwriteEnabled?: boolean | null, maxRecursionDepth?: number | null, mongoSiteCacheInDays?: number | null, minFacesForGroupPicture?: number | null, maxCrawledPagesPerDomain?: number | null, macAcceptableWebsitePopularity?: number | null, assessmentXlsUploadTime?: any | null, assessmentXlsTemplateId?: string | null, initialBbWeightForSourcescrubTags?: number | null, pipedriveDfmTargetDealsFilterId?: number | null, pipedriveOpenTargetDealsLimit?: number | null, pipedriveSoftwareCompanyOrgTypeIndicator?: number | null, pipedriveCortexLabelId?: number | null, pipedriveHotLeadLabelId?: number | null, sourcescrubTagIdForGenericGenericCompanyLabel?: number | null, crawlQueueEnabled?: boolean | null, crawlQueueBatchSize?: number | null, crawlQueueIntervalSeconds?: number | null, scheduledCrawlerBatchSize?: number | null, v2RecrawlBatchSize?: number | null } | null };

export type CrawlQueueEntriesQueryVariables = Exact<{
  crawlStarted?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CrawlQueueEntriesQuery = { __typename?: 'Query', crawlQueueEntries?: Array<{ __typename?: 'CrawlQueueType', id: string, datetimeCreated?: any | null, companyId: number, crawlStarted?: boolean | null, locked?: boolean | null, domain: string, companyName?: string | null, triggeredBy?: string | null, errorMessage?: string | null } | null> | null };

export type CrawlQueueStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type CrawlQueueStatsQuery = { __typename?: 'Query', crawlQueueStats?: { __typename?: 'CrawlQueueStatsType', total?: number | null, pending?: number | null, locked?: number | null, started?: number | null, errored?: number | null } | null };

export type CrawlerInboxQueryVariables = Exact<{
  country?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CrawlerInboxQuery = { __typename?: 'Query', crawlerInbox?: Array<{ __typename?: 'CrawlerInboxItemType', companyId?: number | null, shortName?: string | null, uniqueDomain?: string | null, country?: string | null, logoUrl?: string | null, crawlUrl?: string | null, sicCode?: string | null, sicCodeCertainty?: number | null, sicCodeJustification?: string | null, iabDomainCategory?: string | null, productName?: string | null, systemType?: string | null, customerVertical?: string | null, fte?: number | null, callabilityScore?: number | null, aiValidationScore?: number | null, manuallyLabeledScore?: number | null, buyAndBuildRelevance?: number | null, topBidPlatformName?: string | null, topBidPlatformLogoUrl?: string | null, companyValidated?: boolean | null, crawlResultValidated?: boolean | null, validationNeeded?: string | null, crawlResultId?: number | null, crawlRunId?: number | null, pipedriveId?: number | null, validationLockedBy?: number | null, validationLockedAt?: any | null, peOwned?: boolean | null, privateOwned?: boolean | null, crawlCompletedAt?: any | null, companyCreatedAt?: any | null } | null> | null };

export type CustomerIndustryGrowthRatesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerIndustryGrowthRatesQuery = { __typename?: 'Query', customerIndustryGrowthRates?: { __typename?: 'CustomerGrowthRateRawConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CustomerGrowthRateRawEdge', cursor: string, node?: { __typename?: 'CustomerGrowthRateRawType', adjustedMedianGrowth?: number | null, sampleSize?: number | null, sicDesc?: string | null, dbId?: number | null } | null } | null> } | null };

export type CustomerSegmentsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type CustomerSegmentsQuery = { __typename?: 'Query', customerSegments?: Array<{ __typename?: 'CustomerSegmentType', id?: number | null, segmentName?: string | null, segmentDescription?: string | null, keyword1?: string | null, bidGroupCompanyId?: number | null }> | null };

export type DealAssessmentFileUrlQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DealAssessmentFileUrlQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyEdge', cursor: string, node?: { __typename?: 'CompanyType', id: string, dbId?: number | null, dealAssessmentFileUrl?: { __typename?: 'DealAssessmentFileType', downloadUrl?: string | null, generationTriggered?: boolean | null, noDataUploaded?: boolean | null, dateOfFile?: any | null, previousGenerationStillRunning?: boolean | null, progress?: { __typename?: 'DealAssessmentProgressType', step?: string | null, timestamp?: string | null, secondsSinceLastUpdate?: number | null } | null } | null } | null } | null> } | null };

export type EmployeeStaticsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmployeeStaticsQuery = { __typename?: 'Query', employeeStatics?: { __typename?: 'EmployeeStaticsRawConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'EmployeeStaticsRawEdge', cursor: string, node?: { __typename?: 'EmployeeStaticsRawType', medianEmploymentMonths?: number | null, medianTotalEmploymentMonths?: number | null, medianPreviousEmployers?: number | null, numberOfEmployees?: number | null, teamQualityPercentage?: string | null, dbId?: number | null } | null } | null> } | null };

export type GetEnrichmentJobStatusQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type GetEnrichmentJobStatusQuery = { __typename?: 'Query', enrichmentJobStatus?: { __typename?: 'EnrichmentJobStatusType', jobId: string, status: string, result?: any | null, error?: string | null, progress?: { __typename?: 'EnrichmentJobProgressType', stage?: string | null, percent?: number | null, message?: string | null } | null } | null };

export type EnvironmentConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type EnvironmentConfigurationQuery = { __typename?: 'Query', environmentConfiguration?: { __typename?: 'EnvironmentConfiguration', dopplerProject?: string | null, dopplerConfig?: string | null, alembicRevision?: string | null, gitBranch?: string | null, gitCommit?: string | null, latestMigrationVersion?: string | null, stepsBehindLatestMigration?: number | null } | null };

export type FinancialForecastParamsQueryVariables = Exact<{ [key: string]: never; }>;


export type FinancialForecastParamsQuery = { __typename?: 'Query', financialForecastParams?: { __typename?: 'FinancialForecastParamsType', version?: number | null, updatedAt?: any | null, params?: any | null } | null };

export type FinancialForecastOutputsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FinancialForecastOutputsQuery = { __typename?: 'Query', financialForecastOutputs?: Array<{ __typename?: 'FinancialForecastOutputType', companyId?: number | null, companyName?: string | null, evModelAppreciation5y?: number | null, evModelCagr5y?: number | null, ebitMarginForecastChange?: number | null, lastCalculated?: any | null } | null> | null };

export type FteHistoryQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type FteHistoryQuery = { __typename?: 'Query', fteHistory?: Array<{ __typename?: 'FteHistoryEntryType', id?: number | null, fte?: number | null, sourceType?: string | null, sourceCrawlResultId?: number | null, observedAt?: any | null, confirmedBy?: number | null, confirmedAt?: any | null, isConfirmedChange?: boolean | null, notes?: string | null, datetimeCreated?: any | null } | null> | null };

export type GetActiveQuestionnaireQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveQuestionnaireQuery = { __typename?: 'Query', activeQuestionnaire?: { __typename?: 'QuestionnaireType', id: number, version: number, title: string, description?: string | null, questions: Array<{ __typename?: 'QuestionType', key: string, text: string, type: string, order: number, options?: Array<string | null> | null } | null> } | null };

export type GetActiveRagValidationsQueryVariables = Exact<{
  companyDomains: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type GetActiveRagValidationsQuery = { __typename?: 'Query', activeRagValidations?: any | null };

export type GetAllInvestmentTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInvestmentTransactionsQuery = { __typename?: 'Query', allInvestmentTransactions?: { __typename?: 'InvestTransactionConnection', edges: Array<{ __typename?: 'InvestTransactionEdge', node?: { __typename?: 'InvestTransactionType', id: string, dbId?: number | null, round?: string | null, role?: string | null, dateOfTransaction?: any | null, typeOfTransaction?: string | null, amountRaised?: number | null, totalAmountRaised?: number | null, targetCompany?: { __typename?: 'CompanyType', dbId?: number | null, shortName?: string | null, uniqueDomain?: string | null } | null, buyer?: { __typename?: 'GenericShareHolderType', dbId?: number | null, name?: string | null } | null, seller?: { __typename?: 'GenericShareHolderType', dbId?: number | null, name?: string | null } | null } | null } | null> } | null };

export type GetAllShareholdersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllShareholdersQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', edges: Array<{ __typename?: 'CompanyEdge', node?: { __typename?: 'CompanyType', shareholders?: { __typename?: 'GenericShareHolderTypeConnection', edges: Array<{ __typename?: 'GenericShareHolderTypeEdge', node?: { __typename?: 'GenericShareHolderType', dbId?: number | null, name?: string | null } | null } | null> } | null } | null } | null> } | null };

export type GetAllShareholdingsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllShareholdingsQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', edges: Array<{ __typename?: 'CompanyEdge', node?: { __typename?: 'CompanyType', genericShareholdings?: { __typename?: 'GenericShareholdingConnection', edges: Array<{ __typename?: 'GenericShareholdingEdge', node?: { __typename?: 'GenericShareholdingSQLType', id: string, dbId?: number | null, genericShareholderId?: number | null, genericCompanyId?: number | null, holding?: number | null, holdingCount?: number | null, shareholdingSold?: boolean | null, genericShareholder?: { __typename?: 'GenericShareHolderType', dbId?: number | null, name?: string | null, isPe?: boolean | null, isTradeBuyer?: boolean | null, isNaturalPerson?: boolean | null, yearBornOrFounded?: number | null, typeOfInvestor?: string | null } | null } | null } | null> } | null } | null } | null> } | null };

export type GetAllSicCodesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllSicCodesQuery = { __typename?: 'Query', getAllSicCodes?: { __typename?: 'SICCodeConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'SICCodeEdge', cursor: string, node?: { __typename?: 'SICCodeSQLType', sicCodeStr?: string | null, description?: string | null, id: string } | null } | null> } | null };

export type GetAvailableGoogleDrivesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableGoogleDrivesQuery = { __typename?: 'Query', availableGoogleDrives?: Array<{ __typename?: 'AvailableGoogleDriveType', name?: string | null } | null> | null };

export type GetBuyAndBuildPlatformsQueryVariables = Exact<{
  sortForTargetId?: InputMaybe<Scalars['Int']['input']>;
  excludeAddOns?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBuyAndBuildPlatformsQuery = { __typename?: 'Query', getBuyAndBuildPlatforms?: { __typename?: 'CompanyConnection', edges: Array<{ __typename?: 'CompanyEdge', cursor: string, node?: { __typename?: 'CompanyType', dbId?: number | null, shortName?: string | null, pipedriveId?: number | null } | null } | null> } | null };

export type GetCddJobStatusQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type GetCddJobStatusQuery = { __typename?: 'Query', cddJobStatus?: { __typename?: 'CDDJobStatusType', jobId: string, status: string, result?: any | null, error?: string | null, progress?: { __typename?: 'CDDJobProgressType', stage?: string | null, percent?: number | null, message?: string | null } | null } | null };

export type GetCompanyQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCompanyQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyEdge', cursor: string, node?: { __typename?: 'CompanyType', id: string, legalName?: string | null, shortName?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: string | null, linkedinUrl?: string | null, pipedriveId?: number | null, hrbNumber?: string | null, court?: string | null, benchmarkingIndex?: number | null, sicCode?: string | null, foundingYear?: number | null, isSoftwareCompany?: boolean | null, sicCodeCertainty?: number | null, sicCodeJustification?: string | null, uniqueDomain?: string | null } | null } | null> } | null };

export type GetCompanyForDfmQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCompanyForDfmQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyEdge', cursor: string, node?: { __typename?: 'CompanyType', id: string, dbId?: number | null, shortName?: string | null, pipedriveId?: number | null, uniqueDomain?: string | null, legalName?: string | null, address?: string | null, sicCode?: string | null, validated?: boolean | null, managingDirector?: string | null, contactEmail?: string | null, contactEmailType?: string | null, linkedinDescription?: string | null, hrbNumber?: string | null, court?: string | null, city?: string | null, street?: string | null, zipCode?: string | null, country?: string | null, crawlUrl?: string | null, linkedinUrl?: string | null, emailPattern?: string | null, foundingYear?: number | null, latestUrl?: string | null, buyAndBuildFocus?: string | null, iabDomainCategory?: string | null, isRelevant?: boolean | null, datetimeCreated?: any | null, datetimeModified?: any | null, contactEnrichmentLog?: Array<{ __typename?: 'ContactEnrichmentLogEntryType', timestamp?: any | null, extractionMethod?: string | null, contactEmailExtracted?: boolean | null, contactEmailSource?: string | null, managingDirectorExtracted?: boolean | null, managingDirectorSource?: string | null, hunterCalled?: boolean | null, firecrawlSuccess?: boolean | null, errorMessage?: string | null, processingTimeSeconds?: number | null } | null> | null, companyAnalyses?: { __typename?: 'CompanyAnalysisTypeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CompanyAnalysisTypeEdge', cursor: string, node?: { __typename?: 'CompanyAnalysisType', id: string, fte?: number | null, ebitda?: number | null, revenue?: number | null } | null } | null> } | null } | null } | null> } | null };

export type GetCompanyGDriveInfoQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetCompanyGDriveInfoQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', edges: Array<{ __typename?: 'CompanyEdge', node?: { __typename?: 'CompanyType', id: string, gdriveSharedDriveName: string, gdriveDirectoryName: string, gdriveSyncStatus?: { __typename?: 'GDriveSyncStatusType', lastSyncRequested?: any | null, lastSyncCompleted?: any | null, totalFilesSynced?: number | null, lastFileModified?: any | null, isSyncing?: boolean | null, cooldownEndsAt?: any | null } | null } | null } | null> } | null };

export type GetCompanyProductsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetCompanyProductsQuery = { __typename?: 'Query', getCompanyProducts?: { __typename?: 'CompanyProductConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyProductEdge', cursor: string, node?: { __typename?: 'CompanyProductType', dbId?: number | null, productName: string, description?: string | null, productUrl?: string | null, fullProductUrl?: string | null, productType?: string | null, confidence?: number | null, source?: string | null, sourceUrl?: string | null, fullSourceUrl?: string | null, softwareCategory?: { __typename?: 'SoftwareCategoryType', dbId?: number | null, subCategory1?: string | null, subCategory2?: string | null, subCategory3?: string | null } | null, pricingModels?: Array<{ __typename?: 'ProductPricingModelType', dbId?: number | null, pricingModelType?: string | null, tierName?: string | null, tierOrdinal?: number | null, priceDisplay?: string | null, priceNumeric?: number | null, priceUnit?: string | null, priceUnitNormalized?: string | null, priceCadence?: string | null, currency?: string | null, billingPeriod?: string | null, hasFreeTier?: boolean | null, isCustomPricing?: boolean | null, keyFeatures?: string | null, confidence?: number | null } | null> | null } | null } | null> } | null };

export type GetCompanySizeQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCompanySizeQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyEdge', cursor: string, node?: { __typename?: 'CompanyType', maxFte?: number | null, linkedinFte?: number | null, sizeJustification?: string | null, id: string } | null } | null> } | null };

export type GetCrawlerAlertsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCrawlerAlertsQuery = { __typename?: 'Query', crawlerAlerts?: Array<{ __typename?: 'AlertType', severity?: string | null, type?: string | null, message?: string | null, currentValue?: number | null, threshold?: number | null } | null> | null };

export type GetCrawlerDomainLeaderboardQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCrawlerDomainLeaderboardQuery = { __typename?: 'Query', crawlerDomainLeaderboard?: Array<{ __typename?: 'DomainPerformanceType', domain?: string | null, crawlCount?: number | null, executedCount?: number | null, lastCrawl?: string | null, reputationScore?: number | null, reputationCategory?: string | null, successCount?: number | null, failureCount?: number | null, totalRequests?: number | null, successRate?: number | null, avgResponseTimeMs?: number | null, isAllowlisted?: boolean | null, isBlocklisted?: boolean | null } | null> | null };

export type GetCrawlerErrorBreakdownQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetCrawlerErrorBreakdownQuery = { __typename?: 'Query', crawlerErrorBreakdown?: { __typename?: 'ErrorBreakdownType', totalFailures?: number | null, errorRate?: number | null, categories?: { __typename?: 'ErrorCategoryType', blocked?: number | null, poorReputation?: number | null, fairReputation?: number | null } | null } | null };

export type GetCrawlerFindingTokensQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCrawlerFindingTokensQuery = { __typename?: 'Query', getCrawlerFindingTokens?: { __typename?: 'CrawlerFindingTokenConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CrawlerFindingTokenEdge', cursor: string, node?: { __typename?: 'CrawlerFindingTokenType', id: string, url?: string | null, fte?: number | null, isImageFinding?: boolean | null, isTextFinding?: boolean | null, imageUrl?: string | null } | null } | null> } | null };

export type GetCrawlerOverviewQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCrawlerOverviewQuery = { __typename?: 'Query', crawlerOverview?: { __typename?: 'CrawlerOverviewMetrics', totalRequests?: number | null, successCount?: number | null, failureCount?: number | null, successRate?: number | null, avgResponseTimeMs?: number | null, totalCrawls?: number | null, executedCrawls?: number | null, skippedCrawls?: number | null, timestamp?: string | null, trend?: { __typename?: 'TrendType', changePct?: number | null, direction?: string | null } | null } | null };

export type GetCrawlerTimelineQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  interval?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCrawlerTimelineQuery = { __typename?: 'Query', crawlerTimeline?: Array<{ __typename?: 'TimeSeriesDataPointType', timestamp?: string | null, totalCount?: number | null, executedCount?: number | null, skippedCount?: number | null, successRate?: number | null } | null> | null };

export type GetCustomerReferencesQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetCustomerReferencesQuery = { __typename?: 'Query', getCustomerReferences?: { __typename?: 'CustomerReferenceRawTypeConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CustomerReferenceRawTypeEdge', cursor: string, node?: { __typename?: 'CustomerReferenceRawType', IAB1?: string | null, shortName?: string | null, crawlUrl?: string | null, findingUrl?: string | null, genericCustomer?: boolean | null, ISDd?: boolean | null, sicCode?: string | null, IAB2?: string | null, IAB3?: string | null, dbId?: number | null, shareOfRevenue?: number | null } | null } | null> } | null };

export type GetEmailOfAuthUserQueryVariables = Exact<{
  authId: Scalars['String']['input'];
}>;


export type GetEmailOfAuthUserQuery = { __typename?: 'Query', userEmailByAuthId?: string | null };

export type GetGenericCrawlResultIdQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetGenericCrawlResultIdQuery = { __typename?: 'Query', getCrawlResults?: { __typename?: 'RawGenericCrawlResultConnection', edges: Array<{ __typename?: 'RawGenericCrawlResultEdge', node?: { __typename?: 'RawGenericCrawlResultSQLType', dbId?: number | null } | null } | null> } | null };

export type GetIndustryBenchmarkDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndustryBenchmarkDataQuery = { __typename?: 'Query', industryBenchmarkData?: Array<{ __typename?: 'CustomerGrowthRateRawType', id: string, identifier: string, name?: string | null, url?: string | null, year?: number | null, date?: string | null, region?: string | null, country?: string | null, sic?: number | null, ebitdaAssets?: number | null, oneYearSalesGrowth?: number | null, evAssets?: number | null, ebitdaSales?: number | null, zScore?: number | null, evEbitda?: number | null, genericCompanyId?: number | null } | null> | null, sicCodes?: Array<{ __typename?: 'SICCodeType', sicCodeInt?: number | null, description?: string | null } | null> | null };

export type GetKeywordsForCompanyQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetKeywordsForCompanyQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyEdge', cursor: string, node?: { __typename?: 'CompanyType', crawlResults?: { __typename?: 'GenericCrawlResultConnection', edges: Array<{ __typename?: 'GenericCrawlResultEdge', node?: { __typename?: 'GenericCrawlResultSQLType', dbId?: number | null, xoviKeywords?: { __typename?: 'XoviKeywordConnection', edges: Array<{ __typename?: 'XoviKeywordEdge', node?: { __typename?: 'XoviKeywordSQLType', dbId?: number | null, id: string, keyword?: string | null, searchEngine?: string | null, position?: number | null, cpc?: number | null, sevo?: number | null, competitorDensity?: number | null, markedAsIrrelevant?: boolean | null } | null } | null> } | null } | null } | null> } | null } | null } | null> } | null };

export type GetLatestCrawlRunQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetLatestCrawlRunQuery = { __typename?: 'Query', getLatestCrawlRun?: { __typename?: 'CrawlRunSQLType', dbId?: number | null, startedAt?: any | null, finishedAt?: any | null, status?: string | null, triggeredBy?: string | null, steps?: Array<{ __typename?: 'CrawlTimestampStepType', dbId?: number | null, stepName?: string | null, sequence?: number | null, startTime?: any | null, finishTime?: any | null, status?: string | null, success?: boolean | null, failed?: boolean | null, noOfAttempts?: number | null, errorMessage?: string | null } | null> | null } | null };

export type GetNameOfAuthUserQueryVariables = Exact<{
  authId: Scalars['String']['input'];
}>;


export type GetNameOfAuthUserQuery = { __typename?: 'Query', userNameByAuthId?: string | null };

export type GetNextBatchRunQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextBatchRunQuery = { __typename?: 'Query', getNextBatchRun?: { __typename?: 'NextBatchRunType', nextRunUtc?: any | null, enabled?: boolean | null, scheduleLabel?: string | null, weekdaySchedule?: string | null, weekendSchedule?: string | null } | null };

export type GetOpenaiVotesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOpenaiVotesQuery = { __typename?: 'Query', getOpenaiVotes?: { __typename?: 'OpenAIVoteConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'OpenAIVoteEdge', cursor: string, node?: { __typename?: 'OpenAIVoteType', softwareVotes?: number | null, serviceVotes?: number | null, undecidable?: number | null } | null } | null> } | null };

export type GetPipedriveOrganizationQueryVariables = Exact<{
  pipedriveId?: InputMaybe<Scalars['Int']['input']>;
  companyDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPipedriveOrganizationQuery = { __typename?: 'Query', getPipedriveOrganization?: { __typename?: 'PipedriveOrganizationType', organizationId: number, name: string, deals?: Array<{ __typename?: 'PipedriveDealType', dealId: number, title: string, stage?: string | null, status?: string | null, lostReason?: string | null } | null> | null } | null };

export type GetProductCategoriesForCompanyQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductCategoriesForCompanyQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyEdge', cursor: string, node?: { __typename?: 'CompanyType', productCategorization?: { __typename?: 'ProductCategorizationConnection', edges: Array<{ __typename?: 'ProductCategorizationEdge', node?: { __typename?: 'ProductCategorizationType', id: string, dbId?: number | null, softwareCategoryCertainty?: number | null, softwareCategory?: { __typename?: 'SoftwareCategoryType', dbId?: number | null, subCategory1?: string | null, subCategory2?: string | null, subCategory3?: string | null, g2Url?: string | null } | null } | null } | null> } | null } | null } | null> } | null };

export type GetProgrammingLanguagesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProgrammingLanguagesQuery = { __typename?: 'Query', getProgrammingLanguages?: { __typename?: 'StackshareToolConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'StackshareToolEdge', cursor: string, node?: { __typename?: 'StackshareToolType', dbId?: number | null, name?: string | null } | null } | null> } | null };

export type GetQuestionnaireVersionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionnaireVersionsQuery = { __typename?: 'Query', questionnaireVersions?: Array<{ __typename?: 'QuestionnaireType', id: number, version: number, title: string, effectiveFrom?: any | null, effectiveUntil?: any | null } | null> | null };

export type GetRagJobStatusQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type GetRagJobStatusQuery = { __typename?: 'Query', ragJobStatus?: { __typename?: 'RAGJobStatusType', jobId: string, status: string, result?: any | null, error?: string | null, progress?: { __typename?: 'RAGJobProgressType', stage?: string | null, percent?: number | null, message?: string | null } | null } | null };

export type GetResearchSoftwareCategoriesQueryVariables = Exact<{
  subCategory1?: InputMaybe<Scalars['String']['input']>;
  subCategory2?: InputMaybe<Scalars['String']['input']>;
  subCategory3?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetResearchSoftwareCategoriesQuery = { __typename?: 'Query', getSoftwareCategories?: { __typename?: 'SoftwareCategoryConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'SoftwareCategoryEdge', cursor: string, node?: { __typename?: 'SoftwareCategoryType', id: string, subCategory1?: string | null, subCategory2?: string | null, subCategory3?: string | null, categoryDescription?: string | null, googleTerm?: { __typename?: 'GoogleTermType', googleTrends?: Array<{ __typename?: 'GoogleTrendType', interest?: number | null, date?: string | null } | null> | null } | null } | null } | null> } | null };

export type GetShortCompanyQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetShortCompanyQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyEdge', cursor: string, node?: { __typename?: 'CompanyType', id: string, dbId?: number | null, shortName?: string | null, uniqueDomain?: string | null, linkedinUrl?: string | null, crawlUrl?: string | null, hasBeenValidated?: boolean | null, latestCrawlResult?: { __typename?: 'GenericCrawlResultSQLType', dbId?: number | null } | null } | null } | null> } | null };

export type GetSoftwareCategoriesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSoftwareCategoriesQuery = { __typename?: 'Query', getSoftwareCategories?: { __typename?: 'SoftwareCategoryConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'SoftwareCategoryEdge', cursor: string, node?: { __typename?: 'SoftwareCategoryType', id: string, dbId?: number | null, subCategory1?: string | null, subCategory2?: string | null, subCategory3?: string | null, subCategory4?: string | null } | null } | null> } | null };

export type GetSoftwareFirmsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSoftwareFirmsQuery = { __typename?: 'Query', softwareFirms?: { __typename?: 'CompanyAssesmentConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyAssesmentEdge', cursor: string, node?: { __typename?: 'CompanyAssessmentType', id: string, dbId?: number | null, shortName?: string | null, uniqueDomain?: string | null, country?: string | null, validated?: boolean | null, linkedinUrl?: string | null, foundingYear?: number | null, sicCode?: string | null, datetimeCreated?: any | null, datetimeModified?: any | null } | null } | null> } | null };

export type GetStackshareToolCategoriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStackshareToolCategoriesQuery = { __typename?: 'Query', getStackshareToolCategories?: { __typename?: 'StackshareToolConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'StackshareToolEdge', cursor: string, node?: { __typename?: 'StackshareToolType', breadcrumb?: string | null, id: string, dbId?: number | null } | null } | null> } | null };

export type GetStackshareToolsQueryVariables = Exact<{
  category: Scalars['String']['input'];
}>;


export type GetStackshareToolsQuery = { __typename?: 'Query', getStackshareTools?: { __typename?: 'StackshareToolConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'StackshareToolEdge', cursor: string, node?: { __typename?: 'StackshareToolType', name?: string | null, id: string, dbId?: number | null } | null } | null> } | null };

export type GetSurveyForMeetingQueryVariables = Exact<{
  meetingId: Scalars['Int']['input'];
}>;


export type GetSurveyForMeetingQuery = { __typename?: 'Query', meeting?: { __typename?: 'MeetingType', id: number, domain: string, companyId?: number | null, title?: string | null, meetingDate: any, surveyResponses?: Array<{ __typename?: 'SurveyResponseType', id: number, respondentId?: number | null, answers?: any | null, datetimeCreated?: any | null } | null> | null } | null };

export type GetTechnologyUseQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTechnologyUseQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyEdge', cursor: string, node?: { __typename?: 'CompanyType', id: string, crawlUrl?: string | null, techUse?: { __typename?: 'GenericCompanyTechUseConnection', edges: Array<{ __typename?: 'GenericCompanyTechUseEdge', node?: { __typename?: 'TechUseType', dbId?: number | null, findingUrl?: string | null, stackshareTool?: { __typename?: 'ProductTechnologylType', id: string, breadcrumb?: string | null, name?: string | null, stacksUsed?: number | null, votes?: number | null, url?: string | null } | null } | null } | null> } | null } | null } | null> } | null };

export type GetUploadedMetaDataQueryVariables = Exact<{
  pipedriveId: Scalars['Int']['input'];
}>;


export type GetUploadedMetaDataQuery = { __typename?: 'Query', uploadedMetaDataByPipedriveId?: { __typename?: 'CompanyWithLatestUpload', uploadTime?: any | null, uploaderName?: string | null, company?: { __typename?: 'CompanyType', dbId?: number | null, shortName?: string | null, uniqueDomain?: string | null } | null } | null };

export type GetUserActivityStatsQueryVariables = Exact<{
  timeframe?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserActivityStatsQuery = { __typename?: 'Query', userActivityStats?: Array<{ __typename?: 'UserActivityStatsType', userId?: number | null, displayName?: string | null, totalValidations?: number | null, orgCreatedCount?: number | null, dealCreatedCount?: number | null } | null> | null };

export type GetUserIdByAuthIdQueryVariables = Exact<{
  authId: Scalars['String']['input'];
}>;


export type GetUserIdByAuthIdQuery = { __typename?: 'Query', userIdByAuthId?: number | null };

export type GetVibeCodingIdeasQueryVariables = Exact<{
  portfolioCompanyId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVibeCodingIdeasQuery = { __typename?: 'Query', vibeCodingIdeas?: Array<{ __typename?: 'VibeCodingIdeaType', dbId?: number | null, title: string, description: string, problemStatement?: string | null, proposedSolution?: string | null, techStackSuggestion?: any | null, estimatedComplexity?: string | null, businessImpact?: string | null, ycStartupName?: string | null, ycStartupOneLiner?: string | null, competitiveAngle?: string | null, industryVertical?: string | null, generationModel?: string | null, isBookmarked?: boolean | null, userRating?: number | null, userNotes?: string | null, status?: string | null } | null> | null };

export type GetYcStartupsForCompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  minSimilarity?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetYcStartupsForCompanyQuery = { __typename?: 'Query', ycStartupsForCompany?: { __typename?: 'YCStartupsResultType', totalCount?: number | null, items?: Array<{ __typename?: 'YCStartupWithScoreType', similarityScore?: number | null, ycCompany?: { __typename?: 'YCCompanyType', dbId?: number | null, name?: string | null, slug: string, oneLiner?: string | null, longDescription?: string | null, batch?: string | null, status?: string | null, stage?: string | null, teamSize?: number | null, industry?: string | null, subindustry?: string | null, tags?: any | null, website?: string | null, smallLogoThumbUrl?: string | null, isHiring?: boolean | null, topCompany?: boolean | null, launchedAt?: any | null } | null } | null> | null } | null };

export type GetKpiBenchmarksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKpiBenchmarksQuery = { __typename?: 'Query', kpiBenchmarks?: Array<{ __typename?: 'KPIBenchmarkType', kpiName?: string | null, percentile25?: number | null, percentile50?: number | null, percentile75?: number | null, nonNullCount?: number | null } | null> | null };

export type KpiCalculationStatusQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type KpiCalculationStatusQuery = { __typename?: 'Query', kpiCalculationStatus?: { __typename?: 'KPIStatusSummary', companyId?: number | null, lastKpiCalculation?: any | null, lastDataUpload?: any | null, totalKpis?: number | null, calculatedKpis?: number | null, outdatedKpis?: number | null, missingDataKpis?: number | null, needsRecalculation?: boolean | null, benchmarkControlDataId?: number | null, lastFiscalYear?: number | null, kpiStatuses?: Array<{ __typename?: 'KPICalculationStatus', kpiName?: string | null, displayName?: string | null, value?: number | null, isCalculated?: boolean | null, lastCalculated?: any | null, isUpToDate?: boolean | null, requiredDataMissing?: Array<string | null> | null, kpiType?: string | null, dataAvailability?: { __typename?: 'KPIDataAvailability', kpiName?: string | null, hasRawData?: boolean | null, availableYears?: Array<number | null> | null, latestYear?: number | null, dataSources?: Array<string | null> | null } | null } | null> | null } | null };

export type ListResearchSessionsQueryVariables = Exact<{
  researchType?: InputMaybe<Scalars['String']['input']>;
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResearchStatusEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListResearchSessionsQuery = { __typename?: 'Query', listResearchSessions?: Array<{ __typename?: 'ResearchSessionSummaryType', sessionId: string, researchType: string, companyName: string, companyDomain: string, status: ResearchStatusEnum, jobId?: string | null, startedAt: any, completedAt?: any | null, durationSeconds?: number | null } | null> | null };

export type GetMlModelStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMlModelStatisticsQuery = { __typename?: 'Query', mlModelStatistics?: Array<{ __typename?: 'MLModelStatisticsType', modelName?: string | null, modelType?: string | null, latestVersion?: number | null, currentTrainingSamples?: number | null, currentTestSamples?: number | null, totalCurrentSamples?: number | null, currentR2?: number | null, currentAccuracy?: number | null, currentF1Score?: number | null, currentPrecision?: number | null, currentRecall?: number | null, currentMse?: number | null, currentRmse?: number | null, samplesChange1w?: number | null, samplesChange4w?: number | null, samplesChange1wPercent?: number | null, samplesChange4wPercent?: number | null, modelCreatedAt?: any | null, modelUpdatedAt?: any | null, totalVersions?: number | null, topFeatures?: Array<{ __typename?: 'MLFeatureImportanceType', featureName?: string | null, importance?: number | null } | null> | null } | null> | null };

export type GetMlModelDetailedStatsQueryVariables = Exact<{
  modelName: Scalars['String']['input'];
}>;


export type GetMlModelDetailedStatsQuery = { __typename?: 'Query', mlModelDetailedStats?: { __typename?: 'MLModelDetailedStatsType', modelName?: string | null, modelType?: string | null, statistics?: { __typename?: 'MLModelStatisticsType', modelName?: string | null, modelType?: string | null, latestVersion?: number | null, currentTrainingSamples?: number | null, currentTestSamples?: number | null, totalCurrentSamples?: number | null, currentR2?: number | null, currentAccuracy?: number | null, currentF1Score?: number | null, currentPrecision?: number | null, currentRecall?: number | null, currentMse?: number | null, currentRmse?: number | null, samplesChange1w?: number | null, samplesChange4w?: number | null, samplesChange1wPercent?: number | null, samplesChange4wPercent?: number | null, modelCreatedAt?: any | null, modelUpdatedAt?: any | null, totalVersions?: number | null, topFeatures?: Array<{ __typename?: 'MLFeatureImportanceType', featureName?: string | null, importance?: number | null } | null> | null } | null, historicalData?: Array<{ __typename?: 'MLModelHistoricalDataPoint', date?: any | null, version?: number | null, totalSamples?: number | null, trainingSamples?: number | null, testSamples?: number | null, r2?: number | null, accuracy?: number | null, f1Score?: number | null } | null> | null } | null };

export type OpenregCompaniesQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type OpenregCompaniesQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', edges: Array<{ __typename?: 'CompanyEdge', node?: { __typename?: 'CompanyType', legalName?: string | null, street?: string | null, city?: string | null, openregCompanies?: { __typename?: 'OpenRegCompanyConnection', edges: Array<{ __typename?: 'OpenRegCompanyEdge', node?: { __typename?: 'OpenRegCompanySQLType', companyName?: string | null, addressStreet?: string | null, addressPlace?: string | null, addressZipcode?: string | null, referenceCourtCode?: string | null, referenceCourtName?: string | null, foundedDate?: string | null, dbId?: number | null } | null } | null> } | null } | null } | null> } | null };

export type OriginationsWaterfallQueryVariables = Exact<{
  dateFrom: Scalars['DateTime']['input'];
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type OriginationsWaterfallQuery = { __typename?: 'Query', originationsWaterfall?: { __typename?: 'WaterfallDataType', funnelPercentage?: number | null, initialCallsUnvalidated?: number | null, initialCallsUnvalidatedCompanyIds?: Array<number | null> | null, bars?: Array<{ __typename?: 'WaterfallBarType', label: string, count: number, companyIds?: Array<number | null> | null } | null> | null } | null };

export type PipelineCoverageQueryVariables = Exact<{ [key: string]: never; }>;


export type PipelineCoverageQuery = { __typename?: 'Query', pipelineCoverage?: Array<{ __typename?: 'PipelineCoverageType', companyId?: number | null, companyName?: string | null, domain?: string | null, hasBeenCalled?: boolean | null, lastCallDate?: any | null, callCount?: number | null, hasSurvey?: boolean | null } | null> | null };

export type PrecalculatedKpisQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type PrecalculatedKpisQuery = { __typename?: 'Query', companyAssesment?: { __typename?: 'CompanyAssesmentConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyAssesmentEdge', node?: { __typename?: 'CompanyAssessmentType', precalculatedKpis?: { __typename?: 'KPIPrecalculationConnection', edges: Array<{ __typename?: 'KPIPrecalculationEdge', node?: { __typename?: 'KPIPreCalculationType', id: string, softwareShare?: number | null, salesGrowth?: number | null, absEbit?: number | null, recurringRevenueShare?: number | null, cogsRatio?: number | null, top3CustomerShare?: number | null, netNewCustomerSalesGrowth?: number | null, customerLifetimeValueDistribution?: number | null, cLevelQuality?: number | null, softwareCategoryGrowth?: number | null, onlineVisibility?: number | null, pricePerGoogleKeywordClick?: number | null, consultingManRate?: number | null, mostExpensiveKeyword?: string | null, customerIndustryGrowth?: number | null, employeeConcentrationRatio?: number | null, teamQuality?: number | null, ageOfProgrammingLanguage?: number | null, popularityOfProgrammingLanguage?: number | null, useOfBackendFramework?: boolean | null, useOfFrontendFramework?: boolean | null, buyAndBuildScore?: number | null, callabilityScore?: number | null, fteNetContributionMargin?: number | null, opexRatio?: number | null, ebitdaMargin?: number | null, ebitMargin?: number | null, grossArrChurn?: number | null, netArrChurn?: number | null, grossArrChurnRate?: number | null, netArrChurnRate?: number | null, grossLogoChurn?: number | null, netLogoChurn?: number | null, grossLogoChurnRate?: number | null, netLogoChurnRate?: number | null, downgradeArr?: number | null, expansionArr?: number | null, downgradeArrRate?: number | null, expansionArrRate?: number | null, grossRetentionRate?: number | null, netRetentionRate?: number | null, grossNewCustomerSalesGrowth?: number | null, grossNewCustomerLogoGrowth?: number | null, grossNewCustomerSalesGrowthRate?: number | null, grossNewCustomerLogoGrowthRate?: number | null, absSales?: number | null, absFte?: number | null, absEbitda?: number | null, customerIndustrySic?: string | null, financialBaseForValuation?: string | null, enterpriseValueEstimation?: number | null } | null } | null> } | null } | null } | null> } | null };

export type ProductCategoryListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductCategoryListQuery = { __typename?: 'Query', productCategoryList?: { __typename?: 'SoftwareCategoryConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'SoftwareCategoryEdge', cursor: string, node?: { __typename?: 'SoftwareCategoryType', id: string, dbId?: number | null, subCategory1?: string | null } | null } | null> } | null };

export type ProductCategoryTrendsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type ProductCategoryTrendsQuery = { __typename?: 'Query', productCategoryTrends?: Array<{ __typename?: 'ProductCategoryTrendPointType', softwareCategoryId?: number | null, subCategory1?: string | null, date?: any | null, interest?: number | null } | null> | null };

export type ProductSubCategory3ListQueryVariables = Exact<{
  subCategory2?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductSubCategory3ListQuery = { __typename?: 'Query', productCategoryList?: { __typename?: 'SoftwareCategoryConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'SoftwareCategoryEdge', cursor: string, node?: { __typename?: 'SoftwareCategoryType', id: string, dbId?: number | null, subCategory3?: string | null } | null } | null> } | null };

export type ProductSubCategoryListQueryVariables = Exact<{
  subCategory1?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductSubCategoryListQuery = { __typename?: 'Query', productCategoryList?: { __typename?: 'SoftwareCategoryConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'SoftwareCategoryEdge', cursor: string, node?: { __typename?: 'SoftwareCategoryType', id: string, dbId?: number | null, subCategory2?: string | null } | null } | null> } | null };

export type RedbeatSchedulesQueryVariables = Exact<{ [key: string]: never; }>;


export type RedbeatSchedulesQuery = { __typename?: 'Query', redbeatSchedules?: Array<{ __typename?: 'RedBeatEntryType', name?: string | null, task?: string | null, enabled?: boolean | null, scheduleType?: string | null, intervalSeconds?: number | null, crontabMinute?: string | null, crontabHour?: string | null, crontabDayOfWeek?: string | null, crontabDayOfMonth?: string | null, queue?: string | null, kwargs?: any | null, totalRunCount?: number | null, lastRunAt?: any | null } | null> | null };

export type ResearchJobStatusQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type ResearchJobStatusQuery = { __typename?: 'Query', researchJobStatus?: { __typename?: 'ResearchJobStatusType', jobId: string, status: string, result?: any | null, error?: string | null, progress?: { __typename?: 'ResearchJobProgressType', stage?: string | null, percent?: number | null, message?: string | null } | null } | null };

export type ResearchResultQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type ResearchResultQuery = { __typename?: 'Query', researchResult?: { __typename?: 'ResearchResultType', sessionId?: string | null, researchType: string, companyDomain: string, status: ResearchStatusEnum, resultData: any, citationIndex?: any | null, errorMessage?: string | null, startedAt: any, completedAt?: any | null, durationSeconds?: number | null, evidenceSources?: Array<{ __typename?: 'ResearchEvidenceSourceType', sourceType: string, url?: string | null, title?: string | null, snippet?: string | null, relevanceScore?: number | null } | null> | null } | null };

export type ScheduledTasksEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type ScheduledTasksEnabledQuery = { __typename?: 'Query', scheduledTasksEnabled?: boolean | null };

export type SearchCompanyQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCompanyQuery = { __typename?: 'Query', cortexFirms?: { __typename?: 'CompanyAssesmentConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyAssesmentEdge', node?: { __typename?: 'CompanyAssessmentType', dbId?: number | null, shortName?: string | null, uniqueDomain?: string | null, country?: string | null, validated?: boolean | null, isSoftwareCompany?: boolean | null, sicCode?: string | null, doNotCrawl?: boolean | null } | null } | null> } | null };

export type SearchCompanyDomainByNameQueryVariables = Exact<{
  companyName: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  returnDomainOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchCompanyDomainByNameQuery = { __typename?: 'Query', searchCompanyDomainByName?: string | null };

export type SearchCompanyForEvaluationQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCompanyForEvaluationQuery = { __typename?: 'Query', cortexFirms?: { __typename?: 'CompanyAssesmentConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyAssesmentEdge', node?: { __typename?: 'CompanyAssessmentType', dbId?: number | null, shortName?: string | null, uniqueDomain?: string | null, country?: string | null, validated?: boolean | null } | null } | null> } | null };

export type GetClassificationPatternsQueryVariables = Exact<{
  classificationTarget?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  excludeProbationary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetClassificationPatternsQuery = { __typename?: 'Query', classificationPatterns?: Array<{ __typename?: 'ClassificationPatternType', dbId?: number | null, patternText: string, patternType: string, classificationTarget: string, weight?: number | null, isActive: boolean, isProbationary?: boolean | null, probationMetadata?: any | null, description?: string | null, language?: string | null, source?: string | null, createdBy?: string | null, datetimeCreated?: any | null, datetimeModified?: any | null } | null> | null };

export type GetProbationaryPatternsQueryVariables = Exact<{
  classificationTarget?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProbationaryPatternsQuery = { __typename?: 'Query', probationaryPatterns?: Array<{ __typename?: 'ClassificationPatternType', dbId?: number | null, patternText: string, patternType: string, classificationTarget: string, weight?: number | null, isActive: boolean, isProbationary?: boolean | null, probationMetadata?: any | null, description?: string | null, language?: string | null, source?: string | null, createdBy?: string | null, datetimeCreated?: any | null, datetimeModified?: any | null } | null> | null };

export type GetPatternEffectivenessQueryVariables = Exact<{
  minMatches?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPatternEffectivenessQuery = { __typename?: 'Query', patternEffectiveness?: Array<{ __typename?: 'PatternEffectivenessType', patternId?: number | null, patternText?: string | null, classificationTarget?: string | null, isActive?: boolean | null, weight?: number | null, totalMatches?: number | null, correctMatches?: number | null, incorrectMatches?: number | null, pendingMatches?: number | null, precisionPct?: number | null, helpfulCount?: number | null, misleadingCount?: number | null } | null> | null };

export type GetPendingPatternMatchesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPendingPatternMatchesQuery = { __typename?: 'Query', pendingPatternMatches?: Array<{ __typename?: 'ClassificationPatternMatchType', dbId?: number | null, companyId: number, matchedIn?: string | null, matchedText?: string | null, matchConfidence?: number | null, wasCorrect?: boolean | null, userFeedback?: string | null, datetimeCreated?: any | null, pattern?: { __typename?: 'ClassificationPatternType', patternText: string, classificationTarget: string } | null, companyInfo?: { __typename?: 'ClassificationPatternMatchCompanyType', dbId?: number | null, uniqueDomain?: string | null, shortName?: string | null, websiteUrl?: string | null } | null } | null> | null };

export type GetValidationAccuracyByPromptQueryVariables = Exact<{
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetValidationAccuracyByPromptQuery = { __typename?: 'Query', validationAccuracyByPrompt?: Array<{ __typename?: 'ValidationAccuracyType', promptVersion?: string | null, promptVariant?: string | null, week?: string | null, totalValidations?: number | null, falsePositives?: number | null, falseNegatives?: number | null, correct?: number | null, accuracyPct?: number | null, falsePositiveRate?: number | null } | null> | null };

export type GetRecentValidatedKeywordsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecentValidatedKeywordsQuery = { __typename?: 'Query', recentValidatedKeywords?: Array<{ __typename?: 'ValidatedKeywordsSummaryType', dbId?: number | null, companyId?: number | null, companyDomain?: string | null, companyName?: string | null, userId?: number | null, isSoftware?: boolean | null, validationTimestamp?: any | null, suggestedKeywords?: any | null, validatedKeywords?: Array<{ __typename?: 'ValidatedKeywordEntryType', keyword?: string | null, relevanceScore?: number | null, reason?: string | null, selectedByUser?: boolean | null, userId?: number | null, selectionTimestamp?: string | null } | null> | null } | null> | null };

export type GeneratePatternsFromKeywordsMutationVariables = Exact<{
  keywords: Array<Scalars['String']['input']> | Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  autoActivate?: InputMaybe<Scalars['Boolean']['input']>;
  classificationTarget?: InputMaybe<Scalars['String']['input']>;
}>;


export type GeneratePatternsFromKeywordsMutation = { __typename?: 'Mutations', generatePatternsFromKeywords?: { __typename?: 'GeneratePatternsFromKeywords', result?: { __typename?: 'PatternGenerationResultType', createdCount?: number | null, success?: boolean | null, message?: string | null, createdPatterns?: any | null, errors?: any | null } | null } | null };

export type AdjustPatternWeightsMutationVariables = Exact<{
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdjustPatternWeightsMutation = { __typename?: 'Mutations', adjustPatternWeights?: { __typename?: 'AdjustPatternWeights', result?: { __typename?: 'WeightAdjustmentResultType', dryRun?: boolean | null, adjustmentsCount?: number | null, success?: boolean | null, message?: string | null, adjustments?: Array<{ __typename?: 'WeightAdjustmentType', patternId?: number | null, patternText?: string | null, currentWeight?: number | null, suggestedWeight?: number | null, weightChange?: number | null, usageCount?: number | null, confidence?: number | null, applied?: boolean | null } | null> | null } | null } | null };

export type SoftwareCategoryGrowthRatesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SoftwareCategoryGrowthRatesQuery = { __typename?: 'Query', softwareCategoryGrowthRates?: { __typename?: 'SoftwareCategoryGrowthRateRawConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'SoftwareCategoryGrowthRateRawEdge', cursor: string, node?: { __typename?: 'SoftwareCategoryGrowthRateRawType', dbId?: number | null, term?: string | null, avgAlltimeInterest?: number | null, avgInterest24To12MonthsAgo?: number | null, avgInterestLast12Months?: number | null, interestGrowthRate?: number | null } | null } | null> } | null };

export type SpecialCpcKeywordsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SpecialCpcKeywordsQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyEdge', node?: { __typename?: 'CompanyType', crawlResults?: { __typename?: 'GenericCrawlResultConnection', edges: Array<{ __typename?: 'GenericCrawlResultEdge', node?: { __typename?: 'GenericCrawlResultSQLType', dbId?: number | null, xoviKeywords?: { __typename?: 'XoviKeywordConnection', edges: Array<{ __typename?: 'XoviKeywordEdge', node?: { __typename?: 'XoviKeywordSQLType', id: string, keyword?: string | null, searchEngine?: string | null } | null } | null> } | null } | null } | null> } | null } | null } | null> } | null };

export type StatusMessageQueryVariables = Exact<{
  clientId: Scalars['String']['input'];
}>;


export type StatusMessageQuery = { __typename?: 'Query', statusMessage?: string | null };

export type SwCentroidStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type SwCentroidStatsQuery = { __typename?: 'Query', swCentroidStats?: { __typename?: 'SWCentroidStatsType', version?: number | null, threshold?: number | null, auc?: number | null, recall?: number | null, precision?: number | null, filterRate?: number | null, separation?: number | null, swCount?: number | null, nonSwCount?: number | null, computedAt?: any | null, model?: string | null, threshold95?: number | null, threshold97?: number | null, threshold99?: number | null, threshold995?: number | null } | null };

export type SwFalsePositiveCompaniesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SwFalsePositiveCompaniesQuery = { __typename?: 'Query', swFalsePositiveCompanies?: Array<{ __typename?: 'SWFalsePositiveCompanyType', companyId?: number | null, domain?: string | null, companyName?: string | null, validationDate?: any | null } | null> | null };

export type SwPredictionSummaryQueryVariables = Exact<{
  timeRange?: InputMaybe<Scalars['String']['input']>;
}>;


export type SwPredictionSummaryQuery = { __typename?: 'Query', swPredictionSummary?: { __typename?: 'SWPredictionSummaryType', timeRange?: string | null, total?: number | null, swCount?: number | null, nonSwCount?: number | null, filterRate?: number | null, avgSimilarity?: number | null } | null };

export type SwPredictionTimeSeriesQueryVariables = Exact<{
  timeRange?: InputMaybe<Scalars['String']['input']>;
}>;


export type SwPredictionTimeSeriesQuery = { __typename?: 'Query', swPredictionTimeSeries?: { __typename?: 'SWPredictionTimeSeriesType', timeRange?: string | null, dataPoints?: Array<{ __typename?: 'SWPredictionTimeSeriesPointType', timestamp?: any | null, total?: number | null, swCount?: number | null, nonSwCount?: number | null, filterRate?: number | null, avgSimilarity?: number | null } | null> | null } | null };

export type SwTrainingDataStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type SwTrainingDataStatsQuery = { __typename?: 'Query', swTrainingDataStats?: { __typename?: 'SWTrainingDataStatsType', swCount?: number | null, swEmbedded?: number | null, nonSwCount?: number | null, nonSwEmbedded?: number | null, fpCount?: number | null, fpEmbedded?: number | null, lastRetrain?: any | null } | null };

export type SwValidationFeedbackQueryVariables = Exact<{ [key: string]: never; }>;


export type SwValidationFeedbackQuery = { __typename?: 'Query', swValidationFeedback?: { __typename?: 'SWValidationFeedbackType', tp?: number | null, fp?: number | null, tn?: number | null, fn?: number | null, total?: number | null, accuracy?: number | null, precision?: number | null, recall?: number | null } | null };

export type TopCpcKeywordQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TopCpcKeywordQuery = { __typename?: 'Query', getCompany?: { __typename?: 'CompanyConnection', pageInfo?: { __typename?: 'DbIdPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startId?: number | null, endId?: number | null } | null, edges: Array<{ __typename?: 'CompanyEdge', node?: { __typename?: 'CompanyType', crawlResults?: { __typename?: 'GenericCrawlResultConnection', edges: Array<{ __typename?: 'GenericCrawlResultEdge', node?: { __typename?: 'GenericCrawlResultSQLType', dbId?: number | null, xoviKeywords?: { __typename?: 'XoviKeywordConnection', edges: Array<{ __typename?: 'XoviKeywordEdge', node?: { __typename?: 'XoviKeywordSQLType', id: string, keyword?: string | null, searchEngine?: string | null } | null } | null> } | null } | null } | null> } | null } | null } | null> } | null };

export type UserStatsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UserStatsQuery = { __typename?: 'Query', userStats?: Array<{ __typename?: 'UserStatsType', userId?: number | null, userName?: string | null, callCount?: number | null, surveyCount?: number | null, surveyCompletionRate?: number | null, companiesContacted?: number | null, dealsTotal?: number | null, dealsWon?: number | null, totalActivities?: number | null } | null> | null };

export type ValidationInboxQueryVariables = Exact<{
  country?: InputMaybe<Scalars['String']['input']>;
  validationNeeded?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ValidationInboxQuery = { __typename?: 'Query', validationInbox?: Array<{ __typename?: 'ValidationInboxItemType', companyId?: number | null, shortName?: string | null, country?: string | null, uniqueDomain?: string | null, isSoftwareCompany?: boolean | null, companyValidated?: boolean | null, companyValidatedAt?: any | null, companyCreatedAt?: any | null, pipedriveId?: number | null, crawlUrl?: string | null, sicCode?: string | null, latestCrawlResultId?: number | null, latestCrValidated?: boolean | null, latestCrCreated?: any | null, crawlFte?: number | null, lastValidatedCrCreated?: any | null, analysisFte?: number | null, validationNeeded?: string | null, callabilityScore?: number | null, productName?: string | null, logoUrl?: string | null, crawlWasFinished?: boolean | null, validationLockedBy?: number | null, validationLockedAt?: any | null } | null> | null };

export type WaterfallDrillDownQueryVariables = Exact<{
  barLabel: Scalars['String']['input'];
  dateFrom: Scalars['DateTime']['input'];
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type WaterfallDrillDownQuery = { __typename?: 'Query', waterfallDrillDown?: Array<{ __typename?: 'WaterfallDrillDownType', companyId?: number | null, companyName?: string | null, domain?: string | null, meetingHolders?: Array<string | null> | null } | null> | null };

export type XoviKeywordsForCrawlResultQueryVariables = Exact<{
  crawlResultId: Scalars['Int']['input'];
}>;


export type XoviKeywordsForCrawlResultQuery = { __typename?: 'Query', xoviKeywordsForCrawlResult?: Array<{ __typename?: 'XOVIKeywordType', id?: number | null, keyword?: string | null, cpc?: number | null, sevo?: number | null, position?: number | null, url?: string | null, searchEngine?: string | null, isPlaceholderForEmptyXoviResponse?: boolean | null, markedAsIrrelevant?: boolean | null } | null> | null };

export type EnrichmentAnalyticsQueryVariables = Exact<{
  timeRange: Scalars['String']['input'];
}>;


export type EnrichmentAnalyticsQuery = { __typename?: 'Query', enrichmentAnalytics?: { __typename?: 'PerformanceSummaryType', timeRange: string, startDate: any, endDate: any, summary?: { __typename?: 'PerformanceStatsType', totalEnrichments: number, avgTotalTimeMs: number, avgExistingTimeMs: number, avgFirecrawlTimeMs: number, avgApolloTimeMs: number, avgCacheHitRate: number, totalPagesScraped: number, totalPagesCached: number, totalFirecrawlCredits: number, totalApolloCredits?: number | null, firecrawlSuccessRate?: number | null, apolloCallRate?: number | null, apolloSuccessRate?: number | null } | null, methodBreakdown?: Array<{ __typename?: 'MethodBreakdownType', method: string, count: number, avgTimeMs: number, percentage: number } | null> | null, layerTiming?: { __typename?: 'LayerTimingType', existingPercent?: number | null, firecrawlPercent?: number | null, apolloPercent?: number | null } | null, insights?: Array<{ __typename?: 'InsightType', type: string, category: string, title: string, message: string, priority: string } | null> | null } | null };

export type EnrichmentCostAnalysisQueryVariables = Exact<{
  timeRange: Scalars['String']['input'];
}>;


export type EnrichmentCostAnalysisQuery = { __typename?: 'Query', enrichmentCostAnalysis?: { __typename?: 'CostAnalysisType', timeRange: string, recommendations?: Array<string | null> | null, costs?: { __typename?: 'CostsType', firecrawlCost: number, apolloCost: number, totalCost: number, avgCostPerEnrichment: number } | null, usage?: { __typename?: 'UsageType', totalEnrichments: number, firecrawlCreditsUsed: number, apolloCreditsUsed: number, apolloCallRate: number } | null, cacheImpact?: { __typename?: 'CacheImpactType', cacheHitRate: number, pagesCached: number, pagesScraped: number, estimatedSavings: number } | null, projections?: { __typename?: 'ProjectionsType', monthlyCostProjection: number } | null } | null };

export type EnrichmentTimeSeriesQueryVariables = Exact<{
  timeRange: Scalars['String']['input'];
}>;


export type EnrichmentTimeSeriesQuery = { __typename?: 'Query', enrichmentTimeSeries?: { __typename?: 'EnrichmentTimeSeriesType', timeRange: string, dataPoints?: Array<{ __typename?: 'EnrichmentDataPointType', timestamp: any, count: number, avgTimeMs: number, avgCacheRate: number } | null> | null } | null };

export type EnrichmentLayerSuccessQueryVariables = Exact<{
  timeRange: Scalars['String']['input'];
}>;


export type EnrichmentLayerSuccessQuery = { __typename?: 'Query', enrichmentLayerSuccess?: { __typename?: 'LayerSuccessRatesType', timeRange: string, startDate: any, endDate: any, totalEnrichmentsAnalyzed: number, overallSuccessRate: number, existingPerformance?: { __typename?: 'LayerSuccessType', successfulExtractions: number, successRate: number } | null, firecrawlPerformance?: { __typename?: 'LayerSuccessType', successfulExtractions: number, successRate: number } | null, apolloPerformance?: { __typename?: 'LayerSuccessType', successfulExtractions: number, successRate: number } | null, contactEmailCoverage?: { __typename?: 'DataCoverageType', totalFound: number, existingCount: number, firecrawlCount: number, apolloCount: number, coverageRate: number } | null, managingDirectorCoverage?: { __typename?: 'DataCoverageType', totalFound: number, existingCount: number, firecrawlCount: number, apolloCount: number, coverageRate: number } | null, insights?: Array<{ __typename?: 'InsightType', type: string, category: string, title: string, message: string, priority: string } | null> | null } | null };

export type GetSuggestedKeywordsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetSuggestedKeywordsQuery = { __typename?: 'Query', getSuggestedKeywords?: { __typename?: 'SuggestedKeywords', software?: Array<{ __typename?: 'KeywordSuggestion', keyword?: string | null, source?: string | null, confidence?: number | null, weight?: number | null, matchCount?: number | null, patternId?: number | null } | null> | null, nonSoftware?: Array<{ __typename?: 'KeywordSuggestion', keyword?: string | null, source?: string | null, confidence?: number | null, weight?: number | null, matchCount?: number | null, patternId?: number | null } | null> | null } | null };

export type SaveValidationKeywordMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  keyword: Scalars['String']['input'];
  source: Scalars['String']['input'];
  confidence?: InputMaybe<Scalars['Float']['input']>;
  isSoftware?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaveValidationKeywordMutation = { __typename?: 'Mutations', saveValidationKeyword?: { __typename?: 'SaveValidationKeywordResult', success?: boolean | null, message?: string | null } | null };

export const DbIdPageInfoFragmentFragmentDoc = gql`
    fragment DbIdPageInfoFragment on DbIdPageInfo {
  hasNextPage
  hasPreviousPage
  startId
  endId
}
    `;
export const AcquireValidationLockDocument = gql`
    mutation acquireValidationLock($companyId: Int!, $userId: Int!) {
  acquireValidationLock(companyId: $companyId, userId: $userId) {
    success
    message
    lockedBy
    lockedAt
  }
}
    `;
export type AcquireValidationLockMutationFn = Apollo.MutationFunction<AcquireValidationLockMutation, AcquireValidationLockMutationVariables>;

/**
 * __useAcquireValidationLockMutation__
 *
 * To run a mutation, you first call `useAcquireValidationLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcquireValidationLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acquireValidationLockMutation, { data, loading, error }] = useAcquireValidationLockMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAcquireValidationLockMutation(baseOptions?: Apollo.MutationHookOptions<AcquireValidationLockMutation, AcquireValidationLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcquireValidationLockMutation, AcquireValidationLockMutationVariables>(AcquireValidationLockDocument, options);
      }
export type AcquireValidationLockMutationHookResult = ReturnType<typeof useAcquireValidationLockMutation>;
export type AcquireValidationLockMutationResult = Apollo.MutationResult<AcquireValidationLockMutation>;
export type AcquireValidationLockMutationOptions = Apollo.BaseMutationOptions<AcquireValidationLockMutation, AcquireValidationLockMutationVariables>;
export const AddBuyAndBuildTargetDocument = gql`
    mutation addBuyAndBuildTarget($softwareCompanyId: Int!, $targetCompanyUrl: String!, $quality: Float, $setManualScore: Boolean, $sourcescrubTags: String) {
  addBuyAndBuildTarget(
    softwareCompanyId: $softwareCompanyId
    targetCompanyUrl: $targetCompanyUrl
    quality: $quality
    setManualScore: $setManualScore
    sourcescrubTags: $sourcescrubTags
  ) {
    ok
  }
}
    `;
export type AddBuyAndBuildTargetMutationFn = Apollo.MutationFunction<AddBuyAndBuildTargetMutation, AddBuyAndBuildTargetMutationVariables>;

/**
 * __useAddBuyAndBuildTargetMutation__
 *
 * To run a mutation, you first call `useAddBuyAndBuildTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBuyAndBuildTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBuyAndBuildTargetMutation, { data, loading, error }] = useAddBuyAndBuildTargetMutation({
 *   variables: {
 *      softwareCompanyId: // value for 'softwareCompanyId'
 *      targetCompanyUrl: // value for 'targetCompanyUrl'
 *      quality: // value for 'quality'
 *      setManualScore: // value for 'setManualScore'
 *      sourcescrubTags: // value for 'sourcescrubTags'
 *   },
 * });
 */
export function useAddBuyAndBuildTargetMutation(baseOptions?: Apollo.MutationHookOptions<AddBuyAndBuildTargetMutation, AddBuyAndBuildTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBuyAndBuildTargetMutation, AddBuyAndBuildTargetMutationVariables>(AddBuyAndBuildTargetDocument, options);
      }
export type AddBuyAndBuildTargetMutationHookResult = ReturnType<typeof useAddBuyAndBuildTargetMutation>;
export type AddBuyAndBuildTargetMutationResult = Apollo.MutationResult<AddBuyAndBuildTargetMutation>;
export type AddBuyAndBuildTargetMutationOptions = Apollo.BaseMutationOptions<AddBuyAndBuildTargetMutation, AddBuyAndBuildTargetMutationVariables>;
export const AddBuyAndBuildTargetsFromSourcescrubDocument = gql`
    mutation addBuyAndBuildTargetsFromSourcescrub($authId: String, $softwareCompanyId: Int!) {
  addBuyAndBuildTargetsFromSourcescrub(
    authId: $authId
    softwareCompanyId: $softwareCompanyId
  ) {
    ok
  }
}
    `;
export type AddBuyAndBuildTargetsFromSourcescrubMutationFn = Apollo.MutationFunction<AddBuyAndBuildTargetsFromSourcescrubMutation, AddBuyAndBuildTargetsFromSourcescrubMutationVariables>;

/**
 * __useAddBuyAndBuildTargetsFromSourcescrubMutation__
 *
 * To run a mutation, you first call `useAddBuyAndBuildTargetsFromSourcescrubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBuyAndBuildTargetsFromSourcescrubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBuyAndBuildTargetsFromSourcescrubMutation, { data, loading, error }] = useAddBuyAndBuildTargetsFromSourcescrubMutation({
 *   variables: {
 *      authId: // value for 'authId'
 *      softwareCompanyId: // value for 'softwareCompanyId'
 *   },
 * });
 */
export function useAddBuyAndBuildTargetsFromSourcescrubMutation(baseOptions?: Apollo.MutationHookOptions<AddBuyAndBuildTargetsFromSourcescrubMutation, AddBuyAndBuildTargetsFromSourcescrubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBuyAndBuildTargetsFromSourcescrubMutation, AddBuyAndBuildTargetsFromSourcescrubMutationVariables>(AddBuyAndBuildTargetsFromSourcescrubDocument, options);
      }
export type AddBuyAndBuildTargetsFromSourcescrubMutationHookResult = ReturnType<typeof useAddBuyAndBuildTargetsFromSourcescrubMutation>;
export type AddBuyAndBuildTargetsFromSourcescrubMutationResult = Apollo.MutationResult<AddBuyAndBuildTargetsFromSourcescrubMutation>;
export type AddBuyAndBuildTargetsFromSourcescrubMutationOptions = Apollo.BaseMutationOptions<AddBuyAndBuildTargetsFromSourcescrubMutation, AddBuyAndBuildTargetsFromSourcescrubMutationVariables>;
export const AddCompanyCertificationDocument = gql`
    mutation addCompanyCertification($companyId: Int!, $certificationId: Int!) {
  addCompanyCertification(
    companyId: $companyId
    certificationId: $certificationId
  ) {
    success
    message
    companyCertificationId
  }
}
    `;
export type AddCompanyCertificationMutationFn = Apollo.MutationFunction<AddCompanyCertificationMutation, AddCompanyCertificationMutationVariables>;

/**
 * __useAddCompanyCertificationMutation__
 *
 * To run a mutation, you first call `useAddCompanyCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyCertificationMutation, { data, loading, error }] = useAddCompanyCertificationMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      certificationId: // value for 'certificationId'
 *   },
 * });
 */
export function useAddCompanyCertificationMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyCertificationMutation, AddCompanyCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyCertificationMutation, AddCompanyCertificationMutationVariables>(AddCompanyCertificationDocument, options);
      }
export type AddCompanyCertificationMutationHookResult = ReturnType<typeof useAddCompanyCertificationMutation>;
export type AddCompanyCertificationMutationResult = Apollo.MutationResult<AddCompanyCertificationMutation>;
export type AddCompanyCertificationMutationOptions = Apollo.BaseMutationOptions<AddCompanyCertificationMutation, AddCompanyCertificationMutationVariables>;
export const AddCoreKeywordDocument = gql`
    mutation addCoreKeyword($companyId: Int!, $keyword: String!) {
  addCoreKeyword(companyId: $companyId, keyword: $keyword) {
    success
    message
    dbId
  }
}
    `;
export type AddCoreKeywordMutationFn = Apollo.MutationFunction<AddCoreKeywordMutation, AddCoreKeywordMutationVariables>;

/**
 * __useAddCoreKeywordMutation__
 *
 * To run a mutation, you first call `useAddCoreKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCoreKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCoreKeywordMutation, { data, loading, error }] = useAddCoreKeywordMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useAddCoreKeywordMutation(baseOptions?: Apollo.MutationHookOptions<AddCoreKeywordMutation, AddCoreKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCoreKeywordMutation, AddCoreKeywordMutationVariables>(AddCoreKeywordDocument, options);
      }
export type AddCoreKeywordMutationHookResult = ReturnType<typeof useAddCoreKeywordMutation>;
export type AddCoreKeywordMutationResult = Apollo.MutationResult<AddCoreKeywordMutation>;
export type AddCoreKeywordMutationOptions = Apollo.BaseMutationOptions<AddCoreKeywordMutation, AddCoreKeywordMutationVariables>;
export const AddSegmentCustomerDocument = gql`
    mutation addSegmentCustomer($input: CustomerSegmentInput!) {
  addCustomerSegment(input: $input) {
    success
  }
}
    `;
export type AddSegmentCustomerMutationFn = Apollo.MutationFunction<AddSegmentCustomerMutation, AddSegmentCustomerMutationVariables>;

/**
 * __useAddSegmentCustomerMutation__
 *
 * To run a mutation, you first call `useAddSegmentCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSegmentCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSegmentCustomerMutation, { data, loading, error }] = useAddSegmentCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSegmentCustomerMutation(baseOptions?: Apollo.MutationHookOptions<AddSegmentCustomerMutation, AddSegmentCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSegmentCustomerMutation, AddSegmentCustomerMutationVariables>(AddSegmentCustomerDocument, options);
      }
export type AddSegmentCustomerMutationHookResult = ReturnType<typeof useAddSegmentCustomerMutation>;
export type AddSegmentCustomerMutationResult = Apollo.MutationResult<AddSegmentCustomerMutation>;
export type AddSegmentCustomerMutationOptions = Apollo.BaseMutationOptions<AddSegmentCustomerMutation, AddSegmentCustomerMutationVariables>;
export const AddIndustryDocument = gql`
    mutation addIndustry($companyId: Int!, $referencedAt: String!, $sicCode: String!) {
  addIndustry(
    companyId: $companyId
    referencedAt: $referencedAt
    sicCode: $sicCode
  ) {
    companyId
    sicCode
    referencedAt
  }
}
    `;
export type AddIndustryMutationFn = Apollo.MutationFunction<AddIndustryMutation, AddIndustryMutationVariables>;

/**
 * __useAddIndustryMutation__
 *
 * To run a mutation, you first call `useAddIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIndustryMutation, { data, loading, error }] = useAddIndustryMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      referencedAt: // value for 'referencedAt'
 *      sicCode: // value for 'sicCode'
 *   },
 * });
 */
export function useAddIndustryMutation(baseOptions?: Apollo.MutationHookOptions<AddIndustryMutation, AddIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIndustryMutation, AddIndustryMutationVariables>(AddIndustryDocument, options);
      }
export type AddIndustryMutationHookResult = ReturnType<typeof useAddIndustryMutation>;
export type AddIndustryMutationResult = Apollo.MutationResult<AddIndustryMutation>;
export type AddIndustryMutationOptions = Apollo.BaseMutationOptions<AddIndustryMutation, AddIndustryMutationVariables>;
export const AddSoftwareCategoryToCompanyDocument = gql`
    mutation addSoftwareCategoryToCompany($softwareCategoryId: Int!, $companyId: Int!) {
  addSoftwareCategoryToCompany(
    softwareCategoryId: $softwareCategoryId
    companyId: $companyId
  ) {
    success
  }
}
    `;
export type AddSoftwareCategoryToCompanyMutationFn = Apollo.MutationFunction<AddSoftwareCategoryToCompanyMutation, AddSoftwareCategoryToCompanyMutationVariables>;

/**
 * __useAddSoftwareCategoryToCompanyMutation__
 *
 * To run a mutation, you first call `useAddSoftwareCategoryToCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSoftwareCategoryToCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSoftwareCategoryToCompanyMutation, { data, loading, error }] = useAddSoftwareCategoryToCompanyMutation({
 *   variables: {
 *      softwareCategoryId: // value for 'softwareCategoryId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAddSoftwareCategoryToCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AddSoftwareCategoryToCompanyMutation, AddSoftwareCategoryToCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSoftwareCategoryToCompanyMutation, AddSoftwareCategoryToCompanyMutationVariables>(AddSoftwareCategoryToCompanyDocument, options);
      }
export type AddSoftwareCategoryToCompanyMutationHookResult = ReturnType<typeof useAddSoftwareCategoryToCompanyMutation>;
export type AddSoftwareCategoryToCompanyMutationResult = Apollo.MutationResult<AddSoftwareCategoryToCompanyMutation>;
export type AddSoftwareCategoryToCompanyMutationOptions = Apollo.BaseMutationOptions<AddSoftwareCategoryToCompanyMutation, AddSoftwareCategoryToCompanyMutationVariables>;
export const AddTechnologyFindingTextDocument = gql`
    mutation AddTechnologyFindingText($companyId: Int!, $findingText: String!) {
  addTechnologyFindingText(companyId: $companyId, findingText: $findingText) {
    companyId
    findingText
  }
}
    `;
export type AddTechnologyFindingTextMutationFn = Apollo.MutationFunction<AddTechnologyFindingTextMutation, AddTechnologyFindingTextMutationVariables>;

/**
 * __useAddTechnologyFindingTextMutation__
 *
 * To run a mutation, you first call `useAddTechnologyFindingTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTechnologyFindingTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTechnologyFindingTextMutation, { data, loading, error }] = useAddTechnologyFindingTextMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      findingText: // value for 'findingText'
 *   },
 * });
 */
export function useAddTechnologyFindingTextMutation(baseOptions?: Apollo.MutationHookOptions<AddTechnologyFindingTextMutation, AddTechnologyFindingTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTechnologyFindingTextMutation, AddTechnologyFindingTextMutationVariables>(AddTechnologyFindingTextDocument, options);
      }
export type AddTechnologyFindingTextMutationHookResult = ReturnType<typeof useAddTechnologyFindingTextMutation>;
export type AddTechnologyFindingTextMutationResult = Apollo.MutationResult<AddTechnologyFindingTextMutation>;
export type AddTechnologyFindingTextMutationOptions = Apollo.BaseMutationOptions<AddTechnologyFindingTextMutation, AddTechnologyFindingTextMutationVariables>;
export const AddTechnologyFindingUrlDocument = gql`
    mutation AddTechnologyFindingUrl($companyId: Int!, $findingUrl: String!) {
  addTechnologyFindingUrl(companyId: $companyId, findingUrl: $findingUrl) {
    companyId
    findingUrl
  }
}
    `;
export type AddTechnologyFindingUrlMutationFn = Apollo.MutationFunction<AddTechnologyFindingUrlMutation, AddTechnologyFindingUrlMutationVariables>;

/**
 * __useAddTechnologyFindingUrlMutation__
 *
 * To run a mutation, you first call `useAddTechnologyFindingUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTechnologyFindingUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTechnologyFindingUrlMutation, { data, loading, error }] = useAddTechnologyFindingUrlMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      findingUrl: // value for 'findingUrl'
 *   },
 * });
 */
export function useAddTechnologyFindingUrlMutation(baseOptions?: Apollo.MutationHookOptions<AddTechnologyFindingUrlMutation, AddTechnologyFindingUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTechnologyFindingUrlMutation, AddTechnologyFindingUrlMutationVariables>(AddTechnologyFindingUrlDocument, options);
      }
export type AddTechnologyFindingUrlMutationHookResult = ReturnType<typeof useAddTechnologyFindingUrlMutation>;
export type AddTechnologyFindingUrlMutationResult = Apollo.MutationResult<AddTechnologyFindingUrlMutation>;
export type AddTechnologyFindingUrlMutationOptions = Apollo.BaseMutationOptions<AddTechnologyFindingUrlMutation, AddTechnologyFindingUrlMutationVariables>;
export const CreateCertificationDocument = gql`
    mutation CreateCertification($name: String!, $issuer: String, $domain: String, $level: String, $aiMoatLevel: String, $description: String) {
  createCertification(
    name: $name
    issuer: $issuer
    domain: $domain
    level: $level
    aiMoatLevel: $aiMoatLevel
    description: $description
  ) {
    success
    message
    certificationId
  }
}
    `;
export type CreateCertificationMutationFn = Apollo.MutationFunction<CreateCertificationMutation, CreateCertificationMutationVariables>;

/**
 * __useCreateCertificationMutation__
 *
 * To run a mutation, you first call `useCreateCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCertificationMutation, { data, loading, error }] = useCreateCertificationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      issuer: // value for 'issuer'
 *      domain: // value for 'domain'
 *      level: // value for 'level'
 *      aiMoatLevel: // value for 'aiMoatLevel'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateCertificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCertificationMutation, CreateCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCertificationMutation, CreateCertificationMutationVariables>(CreateCertificationDocument, options);
      }
export type CreateCertificationMutationHookResult = ReturnType<typeof useCreateCertificationMutation>;
export type CreateCertificationMutationResult = Apollo.MutationResult<CreateCertificationMutation>;
export type CreateCertificationMutationOptions = Apollo.BaseMutationOptions<CreateCertificationMutation, CreateCertificationMutationVariables>;
export const UpdateCertificationDocument = gql`
    mutation UpdateCertification($id: Int!, $name: String, $issuer: String, $domain: String, $level: String, $aiMoatLevel: String, $description: String) {
  updateCertification(
    id: $id
    name: $name
    issuer: $issuer
    domain: $domain
    level: $level
    aiMoatLevel: $aiMoatLevel
    description: $description
  ) {
    success
    message
  }
}
    `;
export type UpdateCertificationMutationFn = Apollo.MutationFunction<UpdateCertificationMutation, UpdateCertificationMutationVariables>;

/**
 * __useUpdateCertificationMutation__
 *
 * To run a mutation, you first call `useUpdateCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCertificationMutation, { data, loading, error }] = useUpdateCertificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      issuer: // value for 'issuer'
 *      domain: // value for 'domain'
 *      level: // value for 'level'
 *      aiMoatLevel: // value for 'aiMoatLevel'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateCertificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCertificationMutation, UpdateCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCertificationMutation, UpdateCertificationMutationVariables>(UpdateCertificationDocument, options);
      }
export type UpdateCertificationMutationHookResult = ReturnType<typeof useUpdateCertificationMutation>;
export type UpdateCertificationMutationResult = Apollo.MutationResult<UpdateCertificationMutation>;
export type UpdateCertificationMutationOptions = Apollo.BaseMutationOptions<UpdateCertificationMutation, UpdateCertificationMutationVariables>;
export const DeleteCertificationDocument = gql`
    mutation DeleteCertification($id: Int!) {
  deleteCertification(id: $id) {
    success
    message
  }
}
    `;
export type DeleteCertificationMutationFn = Apollo.MutationFunction<DeleteCertificationMutation, DeleteCertificationMutationVariables>;

/**
 * __useDeleteCertificationMutation__
 *
 * To run a mutation, you first call `useDeleteCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCertificationMutation, { data, loading, error }] = useDeleteCertificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCertificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCertificationMutation, DeleteCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCertificationMutation, DeleteCertificationMutationVariables>(DeleteCertificationDocument, options);
      }
export type DeleteCertificationMutationHookResult = ReturnType<typeof useDeleteCertificationMutation>;
export type DeleteCertificationMutationResult = Apollo.MutationResult<DeleteCertificationMutation>;
export type DeleteCertificationMutationOptions = Apollo.BaseMutationOptions<DeleteCertificationMutation, DeleteCertificationMutationVariables>;
export const UpdateSoftwareCategoryAiScoreDocument = gql`
    mutation UpdateSoftwareCategoryAiScore($categoryId: Int!, $disruptionRisk: Float, $aiOpportunity: Float, $rationale: String, $dimensionScores: JSONString) {
  updateSoftwareCategoryAiScore(
    categoryId: $categoryId
    disruptionRisk: $disruptionRisk
    aiOpportunity: $aiOpportunity
    rationale: $rationale
    dimensionScores: $dimensionScores
  ) {
    success
    message
  }
}
    `;
export type UpdateSoftwareCategoryAiScoreMutationFn = Apollo.MutationFunction<UpdateSoftwareCategoryAiScoreMutation, UpdateSoftwareCategoryAiScoreMutationVariables>;

/**
 * __useUpdateSoftwareCategoryAiScoreMutation__
 *
 * To run a mutation, you first call `useUpdateSoftwareCategoryAiScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSoftwareCategoryAiScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSoftwareCategoryAiScoreMutation, { data, loading, error }] = useUpdateSoftwareCategoryAiScoreMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      disruptionRisk: // value for 'disruptionRisk'
 *      aiOpportunity: // value for 'aiOpportunity'
 *      rationale: // value for 'rationale'
 *      dimensionScores: // value for 'dimensionScores'
 *   },
 * });
 */
export function useUpdateSoftwareCategoryAiScoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSoftwareCategoryAiScoreMutation, UpdateSoftwareCategoryAiScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSoftwareCategoryAiScoreMutation, UpdateSoftwareCategoryAiScoreMutationVariables>(UpdateSoftwareCategoryAiScoreDocument, options);
      }
export type UpdateSoftwareCategoryAiScoreMutationHookResult = ReturnType<typeof useUpdateSoftwareCategoryAiScoreMutation>;
export type UpdateSoftwareCategoryAiScoreMutationResult = Apollo.MutationResult<UpdateSoftwareCategoryAiScoreMutation>;
export type UpdateSoftwareCategoryAiScoreMutationOptions = Apollo.BaseMutationOptions<UpdateSoftwareCategoryAiScoreMutation, UpdateSoftwareCategoryAiScoreMutationVariables>;
export const DeleteSoftwareCategoryAiScoreDocument = gql`
    mutation DeleteSoftwareCategoryAiScore($categoryId: Int!) {
  deleteSoftwareCategoryAiScore(categoryId: $categoryId) {
    success
    message
  }
}
    `;
export type DeleteSoftwareCategoryAiScoreMutationFn = Apollo.MutationFunction<DeleteSoftwareCategoryAiScoreMutation, DeleteSoftwareCategoryAiScoreMutationVariables>;

/**
 * __useDeleteSoftwareCategoryAiScoreMutation__
 *
 * To run a mutation, you first call `useDeleteSoftwareCategoryAiScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSoftwareCategoryAiScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSoftwareCategoryAiScoreMutation, { data, loading, error }] = useDeleteSoftwareCategoryAiScoreMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDeleteSoftwareCategoryAiScoreMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSoftwareCategoryAiScoreMutation, DeleteSoftwareCategoryAiScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSoftwareCategoryAiScoreMutation, DeleteSoftwareCategoryAiScoreMutationVariables>(DeleteSoftwareCategoryAiScoreDocument, options);
      }
export type DeleteSoftwareCategoryAiScoreMutationHookResult = ReturnType<typeof useDeleteSoftwareCategoryAiScoreMutation>;
export type DeleteSoftwareCategoryAiScoreMutationResult = Apollo.MutationResult<DeleteSoftwareCategoryAiScoreMutation>;
export type DeleteSoftwareCategoryAiScoreMutationOptions = Apollo.BaseMutationOptions<DeleteSoftwareCategoryAiScoreMutation, DeleteSoftwareCategoryAiScoreMutationVariables>;
export const TriggerCategoryAiScoringDocument = gql`
    mutation TriggerCategoryAiScoring($batchSize: Int) {
  triggerCategoryAiScoring(batchSize: $batchSize) {
    success
    message
  }
}
    `;
export type TriggerCategoryAiScoringMutationFn = Apollo.MutationFunction<TriggerCategoryAiScoringMutation, TriggerCategoryAiScoringMutationVariables>;

/**
 * __useTriggerCategoryAiScoringMutation__
 *
 * To run a mutation, you first call `useTriggerCategoryAiScoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerCategoryAiScoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerCategoryAiScoringMutation, { data, loading, error }] = useTriggerCategoryAiScoringMutation({
 *   variables: {
 *      batchSize: // value for 'batchSize'
 *   },
 * });
 */
export function useTriggerCategoryAiScoringMutation(baseOptions?: Apollo.MutationHookOptions<TriggerCategoryAiScoringMutation, TriggerCategoryAiScoringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerCategoryAiScoringMutation, TriggerCategoryAiScoringMutationVariables>(TriggerCategoryAiScoringDocument, options);
      }
export type TriggerCategoryAiScoringMutationHookResult = ReturnType<typeof useTriggerCategoryAiScoringMutation>;
export type TriggerCategoryAiScoringMutationResult = Apollo.MutationResult<TriggerCategoryAiScoringMutation>;
export type TriggerCategoryAiScoringMutationOptions = Apollo.BaseMutationOptions<TriggerCategoryAiScoringMutation, TriggerCategoryAiScoringMutationVariables>;
export const SeedCertificationTaxonomyDocument = gql`
    mutation SeedCertificationTaxonomy {
  seedCertificationTaxonomy {
    success
    message
    count
  }
}
    `;
export type SeedCertificationTaxonomyMutationFn = Apollo.MutationFunction<SeedCertificationTaxonomyMutation, SeedCertificationTaxonomyMutationVariables>;

/**
 * __useSeedCertificationTaxonomyMutation__
 *
 * To run a mutation, you first call `useSeedCertificationTaxonomyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedCertificationTaxonomyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedCertificationTaxonomyMutation, { data, loading, error }] = useSeedCertificationTaxonomyMutation({
 *   variables: {
 *   },
 * });
 */
export function useSeedCertificationTaxonomyMutation(baseOptions?: Apollo.MutationHookOptions<SeedCertificationTaxonomyMutation, SeedCertificationTaxonomyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SeedCertificationTaxonomyMutation, SeedCertificationTaxonomyMutationVariables>(SeedCertificationTaxonomyDocument, options);
      }
export type SeedCertificationTaxonomyMutationHookResult = ReturnType<typeof useSeedCertificationTaxonomyMutation>;
export type SeedCertificationTaxonomyMutationResult = Apollo.MutationResult<SeedCertificationTaxonomyMutation>;
export type SeedCertificationTaxonomyMutationOptions = Apollo.BaseMutationOptions<SeedCertificationTaxonomyMutation, SeedCertificationTaxonomyMutationVariables>;
export const BulkEstimateGdriveConfigDocument = gql`
    mutation bulkEstimateGdriveConfig($companyIds: [Int], $limit: Int, $autoConfigureHighConfidence: Boolean) {
  bulkEstimateGdriveConfig(
    companyIds: $companyIds
    limit: $limit
    autoConfigureHighConfidence: $autoConfigureHighConfidence
  ) {
    success
    message
    totalProcessed
    autoConfiguredCount
    requiresConfirmationCount
    results {
      companyId
      companyName
      estimate {
        sharedDriveName
        directoryName
        directoryId
        confidence
        alternatives
        requiresUserConfirmation
      }
      error
    }
  }
}
    `;
export type BulkEstimateGdriveConfigMutationFn = Apollo.MutationFunction<BulkEstimateGdriveConfigMutation, BulkEstimateGdriveConfigMutationVariables>;

/**
 * __useBulkEstimateGdriveConfigMutation__
 *
 * To run a mutation, you first call `useBulkEstimateGdriveConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEstimateGdriveConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEstimateGdriveConfigMutation, { data, loading, error }] = useBulkEstimateGdriveConfigMutation({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *      limit: // value for 'limit'
 *      autoConfigureHighConfidence: // value for 'autoConfigureHighConfidence'
 *   },
 * });
 */
export function useBulkEstimateGdriveConfigMutation(baseOptions?: Apollo.MutationHookOptions<BulkEstimateGdriveConfigMutation, BulkEstimateGdriveConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkEstimateGdriveConfigMutation, BulkEstimateGdriveConfigMutationVariables>(BulkEstimateGdriveConfigDocument, options);
      }
export type BulkEstimateGdriveConfigMutationHookResult = ReturnType<typeof useBulkEstimateGdriveConfigMutation>;
export type BulkEstimateGdriveConfigMutationResult = Apollo.MutationResult<BulkEstimateGdriveConfigMutation>;
export type BulkEstimateGdriveConfigMutationOptions = Apollo.BaseMutationOptions<BulkEstimateGdriveConfigMutation, BulkEstimateGdriveConfigMutationVariables>;
export const ConfirmCompanyGdriveConfigDocument = gql`
    mutation confirmCompanyGdriveConfig($companyId: Int!, $sharedDriveName: String!, $directoryName: String!, $createIfNotExists: Boolean) {
  confirmCompanyGdriveConfig(
    companyId: $companyId
    sharedDriveName: $sharedDriveName
    directoryName: $directoryName
    createIfNotExists: $createIfNotExists
  ) {
    success
    message
    directoryId
  }
}
    `;
export type ConfirmCompanyGdriveConfigMutationFn = Apollo.MutationFunction<ConfirmCompanyGdriveConfigMutation, ConfirmCompanyGdriveConfigMutationVariables>;

/**
 * __useConfirmCompanyGdriveConfigMutation__
 *
 * To run a mutation, you first call `useConfirmCompanyGdriveConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCompanyGdriveConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCompanyGdriveConfigMutation, { data, loading, error }] = useConfirmCompanyGdriveConfigMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      sharedDriveName: // value for 'sharedDriveName'
 *      directoryName: // value for 'directoryName'
 *      createIfNotExists: // value for 'createIfNotExists'
 *   },
 * });
 */
export function useConfirmCompanyGdriveConfigMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCompanyGdriveConfigMutation, ConfirmCompanyGdriveConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCompanyGdriveConfigMutation, ConfirmCompanyGdriveConfigMutationVariables>(ConfirmCompanyGdriveConfigDocument, options);
      }
export type ConfirmCompanyGdriveConfigMutationHookResult = ReturnType<typeof useConfirmCompanyGdriveConfigMutation>;
export type ConfirmCompanyGdriveConfigMutationResult = Apollo.MutationResult<ConfirmCompanyGdriveConfigMutation>;
export type ConfirmCompanyGdriveConfigMutationOptions = Apollo.BaseMutationOptions<ConfirmCompanyGdriveConfigMutation, ConfirmCompanyGdriveConfigMutationVariables>;
export const ConfirmFteSizeDocument = gql`
    mutation confirmFteSize($companyId: Int!, $crawlResultId: Int!, $userId: Int!, $newFte: Int!, $isConfirmedChange: Boolean!, $notes: String) {
  confirmFteSize(
    companyId: $companyId
    crawlResultId: $crawlResultId
    userId: $userId
    newFte: $newFte
    isConfirmedChange: $isConfirmedChange
    notes: $notes
  ) {
    success
    message
    fteChanged
    previousFte
  }
}
    `;
export type ConfirmFteSizeMutationFn = Apollo.MutationFunction<ConfirmFteSizeMutation, ConfirmFteSizeMutationVariables>;

/**
 * __useConfirmFteSizeMutation__
 *
 * To run a mutation, you first call `useConfirmFteSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmFteSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmFteSizeMutation, { data, loading, error }] = useConfirmFteSizeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      crawlResultId: // value for 'crawlResultId'
 *      userId: // value for 'userId'
 *      newFte: // value for 'newFte'
 *      isConfirmedChange: // value for 'isConfirmedChange'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useConfirmFteSizeMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmFteSizeMutation, ConfirmFteSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmFteSizeMutation, ConfirmFteSizeMutationVariables>(ConfirmFteSizeDocument, options);
      }
export type ConfirmFteSizeMutationHookResult = ReturnType<typeof useConfirmFteSizeMutation>;
export type ConfirmFteSizeMutationResult = Apollo.MutationResult<ConfirmFteSizeMutation>;
export type ConfirmFteSizeMutationOptions = Apollo.BaseMutationOptions<ConfirmFteSizeMutation, ConfirmFteSizeMutationVariables>;
export const CortexFeedbackPipedriveBridgeDocument = gql`
    mutation cortexFeedbackPipedriveBridge($companyId: Int!, $addOnForBidId: Int!) {
  cortexFeedbackPipedriveBridge(
    companyId: $companyId
    addOnForBidId: $addOnForBidId
  ) {
    success
  }
}
    `;
export type CortexFeedbackPipedriveBridgeMutationFn = Apollo.MutationFunction<CortexFeedbackPipedriveBridgeMutation, CortexFeedbackPipedriveBridgeMutationVariables>;

/**
 * __useCortexFeedbackPipedriveBridgeMutation__
 *
 * To run a mutation, you first call `useCortexFeedbackPipedriveBridgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCortexFeedbackPipedriveBridgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cortexFeedbackPipedriveBridgeMutation, { data, loading, error }] = useCortexFeedbackPipedriveBridgeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      addOnForBidId: // value for 'addOnForBidId'
 *   },
 * });
 */
export function useCortexFeedbackPipedriveBridgeMutation(baseOptions?: Apollo.MutationHookOptions<CortexFeedbackPipedriveBridgeMutation, CortexFeedbackPipedriveBridgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CortexFeedbackPipedriveBridgeMutation, CortexFeedbackPipedriveBridgeMutationVariables>(CortexFeedbackPipedriveBridgeDocument, options);
      }
export type CortexFeedbackPipedriveBridgeMutationHookResult = ReturnType<typeof useCortexFeedbackPipedriveBridgeMutation>;
export type CortexFeedbackPipedriveBridgeMutationResult = Apollo.MutationResult<CortexFeedbackPipedriveBridgeMutation>;
export type CortexFeedbackPipedriveBridgeMutationOptions = Apollo.BaseMutationOptions<CortexFeedbackPipedriveBridgeMutation, CortexFeedbackPipedriveBridgeMutationVariables>;
export const CreateBenchmarkPlDocument = gql`
    mutation createBenchmarkPL($companyId: Int!, $category1: String!, $category2: String!, $category3: String!, $valuationLevel: Int!, $period: Int!, $periodType: String!, $currency: String!, $value: Float!) {
  createBenchmarkPl(
    companyId: $companyId
    category1: $category1
    category2: $category2
    category3: $category3
    valuationLevel: $valuationLevel
    period: $period
    periodType: $periodType
    currency: $currency
    value: $value
  ) {
    benchmarkingData {
      id
      companyId
      value
    }
  }
}
    `;
export type CreateBenchmarkPlMutationFn = Apollo.MutationFunction<CreateBenchmarkPlMutation, CreateBenchmarkPlMutationVariables>;

/**
 * __useCreateBenchmarkPlMutation__
 *
 * To run a mutation, you first call `useCreateBenchmarkPlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBenchmarkPlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBenchmarkPlMutation, { data, loading, error }] = useCreateBenchmarkPlMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      category1: // value for 'category1'
 *      category2: // value for 'category2'
 *      category3: // value for 'category3'
 *      valuationLevel: // value for 'valuationLevel'
 *      period: // value for 'period'
 *      periodType: // value for 'periodType'
 *      currency: // value for 'currency'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateBenchmarkPlMutation(baseOptions?: Apollo.MutationHookOptions<CreateBenchmarkPlMutation, CreateBenchmarkPlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBenchmarkPlMutation, CreateBenchmarkPlMutationVariables>(CreateBenchmarkPlDocument, options);
      }
export type CreateBenchmarkPlMutationHookResult = ReturnType<typeof useCreateBenchmarkPlMutation>;
export type CreateBenchmarkPlMutationResult = Apollo.MutationResult<CreateBenchmarkPlMutation>;
export type CreateBenchmarkPlMutationOptions = Apollo.BaseMutationOptions<CreateBenchmarkPlMutation, CreateBenchmarkPlMutationVariables>;
export const CreateCompanyProductDocument = gql`
    mutation CreateCompanyProduct($companyId: Int!, $productName: String!, $description: String, $productType: String, $pricing: [PricingTierInput]) {
  createCompanyProduct(
    companyId: $companyId
    productName: $productName
    description: $description
    productType: $productType
    pricing: $pricing
  ) {
    success
    message
    productId
  }
}
    `;
export type CreateCompanyProductMutationFn = Apollo.MutationFunction<CreateCompanyProductMutation, CreateCompanyProductMutationVariables>;

/**
 * __useCreateCompanyProductMutation__
 *
 * To run a mutation, you first call `useCreateCompanyProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyProductMutation, { data, loading, error }] = useCreateCompanyProductMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      productName: // value for 'productName'
 *      description: // value for 'description'
 *      productType: // value for 'productType'
 *      pricing: // value for 'pricing'
 *   },
 * });
 */
export function useCreateCompanyProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyProductMutation, CreateCompanyProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyProductMutation, CreateCompanyProductMutationVariables>(CreateCompanyProductDocument, options);
      }
export type CreateCompanyProductMutationHookResult = ReturnType<typeof useCreateCompanyProductMutation>;
export type CreateCompanyProductMutationResult = Apollo.MutationResult<CreateCompanyProductMutation>;
export type CreateCompanyProductMutationOptions = Apollo.BaseMutationOptions<CreateCompanyProductMutation, CreateCompanyProductMutationVariables>;
export const CreateKeywordsDocument = gql`
    mutation createKeywords($genericCrawlResultId: Int!, $keywords: [String]!, $searchEngine: String) {
  createKeywords(
    genericCrawlResultId: $genericCrawlResultId
    keywords: $keywords
    searchEngine: $searchEngine
  ) {
    keywords
    genericCrawlResultId
  }
}
    `;
export type CreateKeywordsMutationFn = Apollo.MutationFunction<CreateKeywordsMutation, CreateKeywordsMutationVariables>;

/**
 * __useCreateKeywordsMutation__
 *
 * To run a mutation, you first call `useCreateKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeywordsMutation, { data, loading, error }] = useCreateKeywordsMutation({
 *   variables: {
 *      genericCrawlResultId: // value for 'genericCrawlResultId'
 *      keywords: // value for 'keywords'
 *      searchEngine: // value for 'searchEngine'
 *   },
 * });
 */
export function useCreateKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<CreateKeywordsMutation, CreateKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKeywordsMutation, CreateKeywordsMutationVariables>(CreateKeywordsDocument, options);
      }
export type CreateKeywordsMutationHookResult = ReturnType<typeof useCreateKeywordsMutation>;
export type CreateKeywordsMutationResult = Apollo.MutationResult<CreateKeywordsMutation>;
export type CreateKeywordsMutationOptions = Apollo.BaseMutationOptions<CreateKeywordsMutation, CreateKeywordsMutationVariables>;
export const CreateMeetingDocument = gql`
    mutation createMeeting($domain: String!, $meetingDate: DateTime!, $title: String, $companyId: Int, $durationMinutes: Int, $attendeeUserIds: [Int], $notes: String) {
  createMeeting(
    domain: $domain
    meetingDate: $meetingDate
    title: $title
    companyId: $companyId
    durationMinutes: $durationMinutes
    attendeeUserIds: $attendeeUserIds
    notes: $notes
  ) {
    ok
    meeting {
      id
      domain
      companyId
      title
      meetingDate
    }
    error
  }
}
    `;
export type CreateMeetingMutationFn = Apollo.MutationFunction<CreateMeetingMutation, CreateMeetingMutationVariables>;

/**
 * __useCreateMeetingMutation__
 *
 * To run a mutation, you first call `useCreateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingMutation, { data, loading, error }] = useCreateMeetingMutation({
 *   variables: {
 *      domain: // value for 'domain'
 *      meetingDate: // value for 'meetingDate'
 *      title: // value for 'title'
 *      companyId: // value for 'companyId'
 *      durationMinutes: // value for 'durationMinutes'
 *      attendeeUserIds: // value for 'attendeeUserIds'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCreateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeetingMutation, CreateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMeetingMutation, CreateMeetingMutationVariables>(CreateMeetingDocument, options);
      }
export type CreateMeetingMutationHookResult = ReturnType<typeof useCreateMeetingMutation>;
export type CreateMeetingMutationResult = Apollo.MutationResult<CreateMeetingMutation>;
export type CreateMeetingMutationOptions = Apollo.BaseMutationOptions<CreateMeetingMutation, CreateMeetingMutationVariables>;
export const CreatePdOrganizationDocument = gql`
    mutation CreatePDOrganization($companyId: Int!, $authId: String, $newPlatform: Boolean, $addOnExisting: Boolean, $addOnFuture: Boolean, $saas: Boolean, $venture: Boolean, $none: Boolean, $partOfGroup: Boolean, $otherOwnership: Boolean, $sellsHardware: Boolean, $tooMuchConsulting: Boolean, $reseller: Boolean, $wrongBusinessModel: Boolean, $b2c: Boolean, $wrongGeography: Boolean, $tooBig: Boolean, $tooSmall: Boolean, $createOrganization: Boolean, $createDeal: Boolean, $selectValue: String, $note: String) {
  cortexFeedbackPipedriveBridge(
    companyId: $companyId
    authId: $authId
    newPlatform: $newPlatform
    addOnExisting: $addOnExisting
    addOnFuture: $addOnFuture
    saas: $saas
    venture: $venture
    none: $none
    partOfGroup: $partOfGroup
    otherOwnership: $otherOwnership
    sellsHardware: $sellsHardware
    tooMuchConsulting: $tooMuchConsulting
    reseller: $reseller
    wrongBusinessModel: $wrongBusinessModel
    b2c: $b2c
    wrongGeography: $wrongGeography
    tooBig: $tooBig
    tooSmall: $tooSmall
    createOrganization: $createOrganization
    createDeal: $createDeal
    selectValue: $selectValue
    note: $note
  ) {
    success
    message
  }
}
    `;
export type CreatePdOrganizationMutationFn = Apollo.MutationFunction<CreatePdOrganizationMutation, CreatePdOrganizationMutationVariables>;

/**
 * __useCreatePdOrganizationMutation__
 *
 * To run a mutation, you first call `useCreatePdOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePdOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPdOrganizationMutation, { data, loading, error }] = useCreatePdOrganizationMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      authId: // value for 'authId'
 *      newPlatform: // value for 'newPlatform'
 *      addOnExisting: // value for 'addOnExisting'
 *      addOnFuture: // value for 'addOnFuture'
 *      saas: // value for 'saas'
 *      venture: // value for 'venture'
 *      none: // value for 'none'
 *      partOfGroup: // value for 'partOfGroup'
 *      otherOwnership: // value for 'otherOwnership'
 *      sellsHardware: // value for 'sellsHardware'
 *      tooMuchConsulting: // value for 'tooMuchConsulting'
 *      reseller: // value for 'reseller'
 *      wrongBusinessModel: // value for 'wrongBusinessModel'
 *      b2c: // value for 'b2c'
 *      wrongGeography: // value for 'wrongGeography'
 *      tooBig: // value for 'tooBig'
 *      tooSmall: // value for 'tooSmall'
 *      createOrganization: // value for 'createOrganization'
 *      createDeal: // value for 'createDeal'
 *      selectValue: // value for 'selectValue'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreatePdOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePdOrganizationMutation, CreatePdOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePdOrganizationMutation, CreatePdOrganizationMutationVariables>(CreatePdOrganizationDocument, options);
      }
export type CreatePdOrganizationMutationHookResult = ReturnType<typeof useCreatePdOrganizationMutation>;
export type CreatePdOrganizationMutationResult = Apollo.MutationResult<CreatePdOrganizationMutation>;
export type CreatePdOrganizationMutationOptions = Apollo.BaseMutationOptions<CreatePdOrganizationMutation, CreatePdOrganizationMutationVariables>;
export const CreateQuestionnaireVersionDocument = gql`
    mutation createQuestionnaireVersion($title: String!, $questions: JSONString!, $description: String) {
  createQuestionnaireVersion(
    title: $title
    questions: $questions
    description: $description
  ) {
    ok
    questionnaire {
      id
      version
      title
    }
    error
  }
}
    `;
export type CreateQuestionnaireVersionMutationFn = Apollo.MutationFunction<CreateQuestionnaireVersionMutation, CreateQuestionnaireVersionMutationVariables>;

/**
 * __useCreateQuestionnaireVersionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionnaireVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionnaireVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionnaireVersionMutation, { data, loading, error }] = useCreateQuestionnaireVersionMutation({
 *   variables: {
 *      title: // value for 'title'
 *      questions: // value for 'questions'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateQuestionnaireVersionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionnaireVersionMutation, CreateQuestionnaireVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionnaireVersionMutation, CreateQuestionnaireVersionMutationVariables>(CreateQuestionnaireVersionDocument, options);
      }
export type CreateQuestionnaireVersionMutationHookResult = ReturnType<typeof useCreateQuestionnaireVersionMutation>;
export type CreateQuestionnaireVersionMutationResult = Apollo.MutationResult<CreateQuestionnaireVersionMutation>;
export type CreateQuestionnaireVersionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionnaireVersionMutation, CreateQuestionnaireVersionMutationVariables>;
export const CreateRedbeatScheduleDocument = gql`
    mutation createRedbeatSchedule($name: String!, $task: String!, $scheduleType: String!, $intervalSeconds: Float, $crontabMinute: String, $crontabHour: String, $crontabDayOfWeek: String, $crontabDayOfMonth: String, $queue: String, $kwargs: JSONString) {
  createRedbeatSchedule(
    name: $name
    task: $task
    scheduleType: $scheduleType
    intervalSeconds: $intervalSeconds
    crontabMinute: $crontabMinute
    crontabHour: $crontabHour
    crontabDayOfWeek: $crontabDayOfWeek
    crontabDayOfMonth: $crontabDayOfMonth
    queue: $queue
    kwargs: $kwargs
  ) {
    ok
  }
}
    `;
export type CreateRedbeatScheduleMutationFn = Apollo.MutationFunction<CreateRedbeatScheduleMutation, CreateRedbeatScheduleMutationVariables>;

/**
 * __useCreateRedbeatScheduleMutation__
 *
 * To run a mutation, you first call `useCreateRedbeatScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRedbeatScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRedbeatScheduleMutation, { data, loading, error }] = useCreateRedbeatScheduleMutation({
 *   variables: {
 *      name: // value for 'name'
 *      task: // value for 'task'
 *      scheduleType: // value for 'scheduleType'
 *      intervalSeconds: // value for 'intervalSeconds'
 *      crontabMinute: // value for 'crontabMinute'
 *      crontabHour: // value for 'crontabHour'
 *      crontabDayOfWeek: // value for 'crontabDayOfWeek'
 *      crontabDayOfMonth: // value for 'crontabDayOfMonth'
 *      queue: // value for 'queue'
 *      kwargs: // value for 'kwargs'
 *   },
 * });
 */
export function useCreateRedbeatScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRedbeatScheduleMutation, CreateRedbeatScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRedbeatScheduleMutation, CreateRedbeatScheduleMutationVariables>(CreateRedbeatScheduleDocument, options);
      }
export type CreateRedbeatScheduleMutationHookResult = ReturnType<typeof useCreateRedbeatScheduleMutation>;
export type CreateRedbeatScheduleMutationResult = Apollo.MutationResult<CreateRedbeatScheduleMutation>;
export type CreateRedbeatScheduleMutationOptions = Apollo.BaseMutationOptions<CreateRedbeatScheduleMutation, CreateRedbeatScheduleMutationVariables>;
export const CreateUpdateCompanyTechUseDocument = gql`
    mutation createUpdateCompanyTechUse($stackshareToolId: Int!, $companyId: Int!) {
  createUpdateCompanyTechUse(
    stackshareToolId: $stackshareToolId
    companyId: $companyId
  ) {
    companyId
  }
}
    `;
export type CreateUpdateCompanyTechUseMutationFn = Apollo.MutationFunction<CreateUpdateCompanyTechUseMutation, CreateUpdateCompanyTechUseMutationVariables>;

/**
 * __useCreateUpdateCompanyTechUseMutation__
 *
 * To run a mutation, you first call `useCreateUpdateCompanyTechUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateCompanyTechUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateCompanyTechUseMutation, { data, loading, error }] = useCreateUpdateCompanyTechUseMutation({
 *   variables: {
 *      stackshareToolId: // value for 'stackshareToolId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCreateUpdateCompanyTechUseMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateCompanyTechUseMutation, CreateUpdateCompanyTechUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateCompanyTechUseMutation, CreateUpdateCompanyTechUseMutationVariables>(CreateUpdateCompanyTechUseDocument, options);
      }
export type CreateUpdateCompanyTechUseMutationHookResult = ReturnType<typeof useCreateUpdateCompanyTechUseMutation>;
export type CreateUpdateCompanyTechUseMutationResult = Apollo.MutationResult<CreateUpdateCompanyTechUseMutation>;
export type CreateUpdateCompanyTechUseMutationOptions = Apollo.BaseMutationOptions<CreateUpdateCompanyTechUseMutation, CreateUpdateCompanyTechUseMutationVariables>;
export const CreateUpdateGenericShareholderDocument = gql`
    mutation createUpdateGenericShareholder($name: String, $typeOfInvestor: String, $yearBornOrFounded: Int, $genericCompanyId: Int, $genericShareholderId: Int) {
  createUpdateGenericShareholder(
    name: $name
    typeOfInvestor: $typeOfInvestor
    yearBornOrFounded: $yearBornOrFounded
    genericCompanyId: $genericCompanyId
    genericShareholderId: $genericShareholderId
  ) {
    dbId
    name
  }
}
    `;
export type CreateUpdateGenericShareholderMutationFn = Apollo.MutationFunction<CreateUpdateGenericShareholderMutation, CreateUpdateGenericShareholderMutationVariables>;

/**
 * __useCreateUpdateGenericShareholderMutation__
 *
 * To run a mutation, you first call `useCreateUpdateGenericShareholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateGenericShareholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateGenericShareholderMutation, { data, loading, error }] = useCreateUpdateGenericShareholderMutation({
 *   variables: {
 *      name: // value for 'name'
 *      typeOfInvestor: // value for 'typeOfInvestor'
 *      yearBornOrFounded: // value for 'yearBornOrFounded'
 *      genericCompanyId: // value for 'genericCompanyId'
 *      genericShareholderId: // value for 'genericShareholderId'
 *   },
 * });
 */
export function useCreateUpdateGenericShareholderMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateGenericShareholderMutation, CreateUpdateGenericShareholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateGenericShareholderMutation, CreateUpdateGenericShareholderMutationVariables>(CreateUpdateGenericShareholderDocument, options);
      }
export type CreateUpdateGenericShareholderMutationHookResult = ReturnType<typeof useCreateUpdateGenericShareholderMutation>;
export type CreateUpdateGenericShareholderMutationResult = Apollo.MutationResult<CreateUpdateGenericShareholderMutation>;
export type CreateUpdateGenericShareholderMutationOptions = Apollo.BaseMutationOptions<CreateUpdateGenericShareholderMutation, CreateUpdateGenericShareholderMutationVariables>;
export const CreateUpdateGenericShareholdingDocument = gql`
    mutation createUpdateGenericShareholding($genericCompanyId: Int, $genericShareholderId: Int, $genericShareholdingId: Int, $holding: Float, $holdingCount: Int) {
  createUpdateGenericShareholding(
    genericCompanyId: $genericCompanyId
    genericShareholderId: $genericShareholderId
    genericShareholdingId: $genericShareholdingId
    holding: $holding
    holdingCount: $holdingCount
  ) {
    genericCompanyId
    genericShareholderId
    holdingCount
    holding
  }
}
    `;
export type CreateUpdateGenericShareholdingMutationFn = Apollo.MutationFunction<CreateUpdateGenericShareholdingMutation, CreateUpdateGenericShareholdingMutationVariables>;

/**
 * __useCreateUpdateGenericShareholdingMutation__
 *
 * To run a mutation, you first call `useCreateUpdateGenericShareholdingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateGenericShareholdingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateGenericShareholdingMutation, { data, loading, error }] = useCreateUpdateGenericShareholdingMutation({
 *   variables: {
 *      genericCompanyId: // value for 'genericCompanyId'
 *      genericShareholderId: // value for 'genericShareholderId'
 *      genericShareholdingId: // value for 'genericShareholdingId'
 *      holding: // value for 'holding'
 *      holdingCount: // value for 'holdingCount'
 *   },
 * });
 */
export function useCreateUpdateGenericShareholdingMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateGenericShareholdingMutation, CreateUpdateGenericShareholdingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateGenericShareholdingMutation, CreateUpdateGenericShareholdingMutationVariables>(CreateUpdateGenericShareholdingDocument, options);
      }
export type CreateUpdateGenericShareholdingMutationHookResult = ReturnType<typeof useCreateUpdateGenericShareholdingMutation>;
export type CreateUpdateGenericShareholdingMutationResult = Apollo.MutationResult<CreateUpdateGenericShareholdingMutation>;
export type CreateUpdateGenericShareholdingMutationOptions = Apollo.BaseMutationOptions<CreateUpdateGenericShareholdingMutation, CreateUpdateGenericShareholdingMutationVariables>;
export const CreateUpdateKeywordDocument = gql`
    mutation createUpdateKeyword($genericCrawlResultId: Int!, $keyword: String!, $searchEngine: String) {
  createUpdateKeyword(
    genericCrawlResultId: $genericCrawlResultId
    keyword: $keyword
    searchEngine: $searchEngine
  ) {
    keyword
    searchEngine
  }
}
    `;
export type CreateUpdateKeywordMutationFn = Apollo.MutationFunction<CreateUpdateKeywordMutation, CreateUpdateKeywordMutationVariables>;

/**
 * __useCreateUpdateKeywordMutation__
 *
 * To run a mutation, you first call `useCreateUpdateKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateKeywordMutation, { data, loading, error }] = useCreateUpdateKeywordMutation({
 *   variables: {
 *      genericCrawlResultId: // value for 'genericCrawlResultId'
 *      keyword: // value for 'keyword'
 *      searchEngine: // value for 'searchEngine'
 *   },
 * });
 */
export function useCreateUpdateKeywordMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateKeywordMutation, CreateUpdateKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateKeywordMutation, CreateUpdateKeywordMutationVariables>(CreateUpdateKeywordDocument, options);
      }
export type CreateUpdateKeywordMutationHookResult = ReturnType<typeof useCreateUpdateKeywordMutation>;
export type CreateUpdateKeywordMutationResult = Apollo.MutationResult<CreateUpdateKeywordMutation>;
export type CreateUpdateKeywordMutationOptions = Apollo.BaseMutationOptions<CreateUpdateKeywordMutation, CreateUpdateKeywordMutationVariables>;
export const DeleteAllBmForCompanyDocument = gql`
    mutation deleteAllBmForCompany($companyId: Int!) {
  deleteAllBmForCompany(companyId: $companyId) {
    success
  }
}
    `;
export type DeleteAllBmForCompanyMutationFn = Apollo.MutationFunction<DeleteAllBmForCompanyMutation, DeleteAllBmForCompanyMutationVariables>;

/**
 * __useDeleteAllBmForCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteAllBmForCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllBmForCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllBmForCompanyMutation, { data, loading, error }] = useDeleteAllBmForCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteAllBmForCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllBmForCompanyMutation, DeleteAllBmForCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllBmForCompanyMutation, DeleteAllBmForCompanyMutationVariables>(DeleteAllBmForCompanyDocument, options);
      }
export type DeleteAllBmForCompanyMutationHookResult = ReturnType<typeof useDeleteAllBmForCompanyMutation>;
export type DeleteAllBmForCompanyMutationResult = Apollo.MutationResult<DeleteAllBmForCompanyMutation>;
export type DeleteAllBmForCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteAllBmForCompanyMutation, DeleteAllBmForCompanyMutationVariables>;
export const DeleteCompanyProductDocument = gql`
    mutation DeleteCompanyProduct($productId: Int!) {
  deleteCompanyProduct(productId: $productId) {
    success
    message
  }
}
    `;
export type DeleteCompanyProductMutationFn = Apollo.MutationFunction<DeleteCompanyProductMutation, DeleteCompanyProductMutationVariables>;

/**
 * __useDeleteCompanyProductMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyProductMutation, { data, loading, error }] = useDeleteCompanyProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDeleteCompanyProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyProductMutation, DeleteCompanyProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyProductMutation, DeleteCompanyProductMutationVariables>(DeleteCompanyProductDocument, options);
      }
export type DeleteCompanyProductMutationHookResult = ReturnType<typeof useDeleteCompanyProductMutation>;
export type DeleteCompanyProductMutationResult = Apollo.MutationResult<DeleteCompanyProductMutation>;
export type DeleteCompanyProductMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyProductMutation, DeleteCompanyProductMutationVariables>;
export const DeleteCompanyTechUseDocument = gql`
    mutation deleteCompanyTechUse($techUseId: Int!) {
  deleteCompanyTechUse(techUseId: $techUseId) {
    message
    success
  }
}
    `;
export type DeleteCompanyTechUseMutationFn = Apollo.MutationFunction<DeleteCompanyTechUseMutation, DeleteCompanyTechUseMutationVariables>;

/**
 * __useDeleteCompanyTechUseMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyTechUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyTechUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyTechUseMutation, { data, loading, error }] = useDeleteCompanyTechUseMutation({
 *   variables: {
 *      techUseId: // value for 'techUseId'
 *   },
 * });
 */
export function useDeleteCompanyTechUseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyTechUseMutation, DeleteCompanyTechUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyTechUseMutation, DeleteCompanyTechUseMutationVariables>(DeleteCompanyTechUseDocument, options);
      }
export type DeleteCompanyTechUseMutationHookResult = ReturnType<typeof useDeleteCompanyTechUseMutation>;
export type DeleteCompanyTechUseMutationResult = Apollo.MutationResult<DeleteCompanyTechUseMutation>;
export type DeleteCompanyTechUseMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyTechUseMutation, DeleteCompanyTechUseMutationVariables>;
export const DeleteCrawlQueueEntriesDocument = gql`
    mutation deleteCrawlQueueEntries($ids: [Int]!) {
  deleteCrawlQueueEntries(ids: $ids) {
    ok
    deletedCount
  }
}
    `;
export type DeleteCrawlQueueEntriesMutationFn = Apollo.MutationFunction<DeleteCrawlQueueEntriesMutation, DeleteCrawlQueueEntriesMutationVariables>;

/**
 * __useDeleteCrawlQueueEntriesMutation__
 *
 * To run a mutation, you first call `useDeleteCrawlQueueEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCrawlQueueEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCrawlQueueEntriesMutation, { data, loading, error }] = useDeleteCrawlQueueEntriesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCrawlQueueEntriesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCrawlQueueEntriesMutation, DeleteCrawlQueueEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCrawlQueueEntriesMutation, DeleteCrawlQueueEntriesMutationVariables>(DeleteCrawlQueueEntriesDocument, options);
      }
export type DeleteCrawlQueueEntriesMutationHookResult = ReturnType<typeof useDeleteCrawlQueueEntriesMutation>;
export type DeleteCrawlQueueEntriesMutationResult = Apollo.MutationResult<DeleteCrawlQueueEntriesMutation>;
export type DeleteCrawlQueueEntriesMutationOptions = Apollo.BaseMutationOptions<DeleteCrawlQueueEntriesMutation, DeleteCrawlQueueEntriesMutationVariables>;
export const DeleteCustomerReferenceDocument = gql`
    mutation deleteCustomerReference($customerReferenceId: Int!) {
  deleteCustomerReference(customerReferenceId: $customerReferenceId) {
    success
    message
  }
}
    `;
export type DeleteCustomerReferenceMutationFn = Apollo.MutationFunction<DeleteCustomerReferenceMutation, DeleteCustomerReferenceMutationVariables>;

/**
 * __useDeleteCustomerReferenceMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerReferenceMutation, { data, loading, error }] = useDeleteCustomerReferenceMutation({
 *   variables: {
 *      customerReferenceId: // value for 'customerReferenceId'
 *   },
 * });
 */
export function useDeleteCustomerReferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerReferenceMutation, DeleteCustomerReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerReferenceMutation, DeleteCustomerReferenceMutationVariables>(DeleteCustomerReferenceDocument, options);
      }
export type DeleteCustomerReferenceMutationHookResult = ReturnType<typeof useDeleteCustomerReferenceMutation>;
export type DeleteCustomerReferenceMutationResult = Apollo.MutationResult<DeleteCustomerReferenceMutation>;
export type DeleteCustomerReferenceMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerReferenceMutation, DeleteCustomerReferenceMutationVariables>;
export const DeleteSegmentDocument = gql`
    mutation deleteSegment($segmentId: Int!) {
  deleteCustomerSegment(segmentId: $segmentId) {
    success
  }
}
    `;
export type DeleteSegmentMutationFn = Apollo.MutationFunction<DeleteSegmentMutation, DeleteSegmentMutationVariables>;

/**
 * __useDeleteSegmentMutation__
 *
 * To run a mutation, you first call `useDeleteSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSegmentMutation, { data, loading, error }] = useDeleteSegmentMutation({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useDeleteSegmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSegmentMutation, DeleteSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSegmentMutation, DeleteSegmentMutationVariables>(DeleteSegmentDocument, options);
      }
export type DeleteSegmentMutationHookResult = ReturnType<typeof useDeleteSegmentMutation>;
export type DeleteSegmentMutationResult = Apollo.MutationResult<DeleteSegmentMutation>;
export type DeleteSegmentMutationOptions = Apollo.BaseMutationOptions<DeleteSegmentMutation, DeleteSegmentMutationVariables>;
export const DeleteGenericShareholdingDocument = gql`
    mutation deleteGenericShareholding($genericShareholdingId: Int!) {
  deleteGenericShareholding(genericShareholdingId: $genericShareholdingId) {
    success
  }
}
    `;
export type DeleteGenericShareholdingMutationFn = Apollo.MutationFunction<DeleteGenericShareholdingMutation, DeleteGenericShareholdingMutationVariables>;

/**
 * __useDeleteGenericShareholdingMutation__
 *
 * To run a mutation, you first call `useDeleteGenericShareholdingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenericShareholdingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGenericShareholdingMutation, { data, loading, error }] = useDeleteGenericShareholdingMutation({
 *   variables: {
 *      genericShareholdingId: // value for 'genericShareholdingId'
 *   },
 * });
 */
export function useDeleteGenericShareholdingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGenericShareholdingMutation, DeleteGenericShareholdingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGenericShareholdingMutation, DeleteGenericShareholdingMutationVariables>(DeleteGenericShareholdingDocument, options);
      }
export type DeleteGenericShareholdingMutationHookResult = ReturnType<typeof useDeleteGenericShareholdingMutation>;
export type DeleteGenericShareholdingMutationResult = Apollo.MutationResult<DeleteGenericShareholdingMutation>;
export type DeleteGenericShareholdingMutationOptions = Apollo.BaseMutationOptions<DeleteGenericShareholdingMutation, DeleteGenericShareholdingMutationVariables>;
export const DeleteKeywordDocument = gql`
    mutation deleteKeyword($keywordId: Int!) {
  deleteKeyword(keywordId: $keywordId) {
    success
    message
  }
}
    `;
export type DeleteKeywordMutationFn = Apollo.MutationFunction<DeleteKeywordMutation, DeleteKeywordMutationVariables>;

/**
 * __useDeleteKeywordMutation__
 *
 * To run a mutation, you first call `useDeleteKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKeywordMutation, { data, loading, error }] = useDeleteKeywordMutation({
 *   variables: {
 *      keywordId: // value for 'keywordId'
 *   },
 * });
 */
export function useDeleteKeywordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKeywordMutation, DeleteKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKeywordMutation, DeleteKeywordMutationVariables>(DeleteKeywordDocument, options);
      }
export type DeleteKeywordMutationHookResult = ReturnType<typeof useDeleteKeywordMutation>;
export type DeleteKeywordMutationResult = Apollo.MutationResult<DeleteKeywordMutation>;
export type DeleteKeywordMutationOptions = Apollo.BaseMutationOptions<DeleteKeywordMutation, DeleteKeywordMutationVariables>;
export const DeleteKeywordsDocument = gql`
    mutation deleteKeywords($keywordIds: [Int]!) {
  deleteKeywords(keywordIds: $keywordIds) {
    success
    message
  }
}
    `;
export type DeleteKeywordsMutationFn = Apollo.MutationFunction<DeleteKeywordsMutation, DeleteKeywordsMutationVariables>;

/**
 * __useDeleteKeywordsMutation__
 *
 * To run a mutation, you first call `useDeleteKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKeywordsMutation, { data, loading, error }] = useDeleteKeywordsMutation({
 *   variables: {
 *      keywordIds: // value for 'keywordIds'
 *   },
 * });
 */
export function useDeleteKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKeywordsMutation, DeleteKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKeywordsMutation, DeleteKeywordsMutationVariables>(DeleteKeywordsDocument, options);
      }
export type DeleteKeywordsMutationHookResult = ReturnType<typeof useDeleteKeywordsMutation>;
export type DeleteKeywordsMutationResult = Apollo.MutationResult<DeleteKeywordsMutation>;
export type DeleteKeywordsMutationOptions = Apollo.BaseMutationOptions<DeleteKeywordsMutation, DeleteKeywordsMutationVariables>;
export const DeleteRedbeatScheduleDocument = gql`
    mutation deleteRedbeatSchedule($name: String!) {
  deleteRedbeatSchedule(name: $name) {
    ok
  }
}
    `;
export type DeleteRedbeatScheduleMutationFn = Apollo.MutationFunction<DeleteRedbeatScheduleMutation, DeleteRedbeatScheduleMutationVariables>;

/**
 * __useDeleteRedbeatScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteRedbeatScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRedbeatScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRedbeatScheduleMutation, { data, loading, error }] = useDeleteRedbeatScheduleMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteRedbeatScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRedbeatScheduleMutation, DeleteRedbeatScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRedbeatScheduleMutation, DeleteRedbeatScheduleMutationVariables>(DeleteRedbeatScheduleDocument, options);
      }
export type DeleteRedbeatScheduleMutationHookResult = ReturnType<typeof useDeleteRedbeatScheduleMutation>;
export type DeleteRedbeatScheduleMutationResult = Apollo.MutationResult<DeleteRedbeatScheduleMutation>;
export type DeleteRedbeatScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteRedbeatScheduleMutation, DeleteRedbeatScheduleMutationVariables>;
export const DeleteSelectedCompanyTechUseDocument = gql`
    mutation deleteSelectedCompanyTechUse($techUseIds: [Int]!) {
  deleteSelectedCompanyTechUse(techUseIds: $techUseIds) {
    success
    message
  }
}
    `;
export type DeleteSelectedCompanyTechUseMutationFn = Apollo.MutationFunction<DeleteSelectedCompanyTechUseMutation, DeleteSelectedCompanyTechUseMutationVariables>;

/**
 * __useDeleteSelectedCompanyTechUseMutation__
 *
 * To run a mutation, you first call `useDeleteSelectedCompanyTechUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSelectedCompanyTechUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSelectedCompanyTechUseMutation, { data, loading, error }] = useDeleteSelectedCompanyTechUseMutation({
 *   variables: {
 *      techUseIds: // value for 'techUseIds'
 *   },
 * });
 */
export function useDeleteSelectedCompanyTechUseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSelectedCompanyTechUseMutation, DeleteSelectedCompanyTechUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSelectedCompanyTechUseMutation, DeleteSelectedCompanyTechUseMutationVariables>(DeleteSelectedCompanyTechUseDocument, options);
      }
export type DeleteSelectedCompanyTechUseMutationHookResult = ReturnType<typeof useDeleteSelectedCompanyTechUseMutation>;
export type DeleteSelectedCompanyTechUseMutationResult = Apollo.MutationResult<DeleteSelectedCompanyTechUseMutation>;
export type DeleteSelectedCompanyTechUseMutationOptions = Apollo.BaseMutationOptions<DeleteSelectedCompanyTechUseMutation, DeleteSelectedCompanyTechUseMutationVariables>;
export const DownvoteFindingsTokenDocument = gql`
    mutation downvoteFindingsToken($tokenId: Int!) {
  downvoteFindingsToken(tokenId: $tokenId) {
    ok
    token {
      id
    }
  }
}
    `;
export type DownvoteFindingsTokenMutationFn = Apollo.MutationFunction<DownvoteFindingsTokenMutation, DownvoteFindingsTokenMutationVariables>;

/**
 * __useDownvoteFindingsTokenMutation__
 *
 * To run a mutation, you first call `useDownvoteFindingsTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownvoteFindingsTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downvoteFindingsTokenMutation, { data, loading, error }] = useDownvoteFindingsTokenMutation({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useDownvoteFindingsTokenMutation(baseOptions?: Apollo.MutationHookOptions<DownvoteFindingsTokenMutation, DownvoteFindingsTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownvoteFindingsTokenMutation, DownvoteFindingsTokenMutationVariables>(DownvoteFindingsTokenDocument, options);
      }
export type DownvoteFindingsTokenMutationHookResult = ReturnType<typeof useDownvoteFindingsTokenMutation>;
export type DownvoteFindingsTokenMutationResult = Apollo.MutationResult<DownvoteFindingsTokenMutation>;
export type DownvoteFindingsTokenMutationOptions = Apollo.BaseMutationOptions<DownvoteFindingsTokenMutation, DownvoteFindingsTokenMutationVariables>;
export const EditCompanyDocument = gql`
    mutation editCompany($benchmarkingIndex: Int, $city: String, $companyDescription: String, $buyAndBuildFocus: String, $companyId: Int!, $country: String, $court: String, $foundingYear: Int, $hrbNumber: String, $legalName: String, $linkedinUrl: String, $pipedriveId: Int, $shortName: String, $sicCode: String, $street: String, $zipCode: String) {
  editCompany(
    benchmarkingIndex: $benchmarkingIndex
    city: $city
    companyDescription: $companyDescription
    buyAndBuildFocus: $buyAndBuildFocus
    companyId: $companyId
    country: $country
    court: $court
    foundingYear: $foundingYear
    hrbNumber: $hrbNumber
    legalName: $legalName
    linkedinUrl: $linkedinUrl
    pipedriveId: $pipedriveId
    shortName: $shortName
    sicCode: $sicCode
    street: $street
    zipCode: $zipCode
  ) {
    legalName
    shortName
    companyDescription
    buyAndBuildFocus
    street
    city
    zipCode
    country
    linkedinUrl
    pipedriveId
    hrbNumber
    court
    benchmarkingIndex
    sicCode
    foundingYear
  }
}
    `;
export type EditCompanyMutationFn = Apollo.MutationFunction<EditCompanyMutation, EditCompanyMutationVariables>;

/**
 * __useEditCompanyMutation__
 *
 * To run a mutation, you first call `useEditCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyMutation, { data, loading, error }] = useEditCompanyMutation({
 *   variables: {
 *      benchmarkingIndex: // value for 'benchmarkingIndex'
 *      city: // value for 'city'
 *      companyDescription: // value for 'companyDescription'
 *      buyAndBuildFocus: // value for 'buyAndBuildFocus'
 *      companyId: // value for 'companyId'
 *      country: // value for 'country'
 *      court: // value for 'court'
 *      foundingYear: // value for 'foundingYear'
 *      hrbNumber: // value for 'hrbNumber'
 *      legalName: // value for 'legalName'
 *      linkedinUrl: // value for 'linkedinUrl'
 *      pipedriveId: // value for 'pipedriveId'
 *      shortName: // value for 'shortName'
 *      sicCode: // value for 'sicCode'
 *      street: // value for 'street'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useEditCompanyMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyMutation, EditCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompanyMutation, EditCompanyMutationVariables>(EditCompanyDocument, options);
      }
export type EditCompanyMutationHookResult = ReturnType<typeof useEditCompanyMutation>;
export type EditCompanyMutationResult = Apollo.MutationResult<EditCompanyMutation>;
export type EditCompanyMutationOptions = Apollo.BaseMutationOptions<EditCompanyMutation, EditCompanyMutationVariables>;
export const EditCustomerReferenceDocument = gql`
    mutation EditCustomerReference($customerReferenceId: Int!, $customerReferenceName: String, $wonYear: Int, $revenueYearOne: Int, $revenueYearTwo: Int, $shareOfRevenue: Float, $arr: Int, $users: Int, $active: Boolean, $lostYear: Int, $lossReason: String, $nps: Int, $isDdDatapoint: Boolean) {
  editCustomerReference(
    customerReferenceId: $customerReferenceId
    customerReferenceName: $customerReferenceName
    wonYear: $wonYear
    revenueYearOne: $revenueYearOne
    revenueYearTwo: $revenueYearTwo
    shareOfRevenue: $shareOfRevenue
    arr: $arr
    users: $users
    active: $active
    lostYear: $lostYear
    lossReason: $lossReason
    nps: $nps
    isDdDatapoint: $isDdDatapoint
  ) {
    message
    success
  }
}
    `;
export type EditCustomerReferenceMutationFn = Apollo.MutationFunction<EditCustomerReferenceMutation, EditCustomerReferenceMutationVariables>;

/**
 * __useEditCustomerReferenceMutation__
 *
 * To run a mutation, you first call `useEditCustomerReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomerReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomerReferenceMutation, { data, loading, error }] = useEditCustomerReferenceMutation({
 *   variables: {
 *      customerReferenceId: // value for 'customerReferenceId'
 *      customerReferenceName: // value for 'customerReferenceName'
 *      wonYear: // value for 'wonYear'
 *      revenueYearOne: // value for 'revenueYearOne'
 *      revenueYearTwo: // value for 'revenueYearTwo'
 *      shareOfRevenue: // value for 'shareOfRevenue'
 *      arr: // value for 'arr'
 *      users: // value for 'users'
 *      active: // value for 'active'
 *      lostYear: // value for 'lostYear'
 *      lossReason: // value for 'lossReason'
 *      nps: // value for 'nps'
 *      isDdDatapoint: // value for 'isDdDatapoint'
 *   },
 * });
 */
export function useEditCustomerReferenceMutation(baseOptions?: Apollo.MutationHookOptions<EditCustomerReferenceMutation, EditCustomerReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCustomerReferenceMutation, EditCustomerReferenceMutationVariables>(EditCustomerReferenceDocument, options);
      }
export type EditCustomerReferenceMutationHookResult = ReturnType<typeof useEditCustomerReferenceMutation>;
export type EditCustomerReferenceMutationResult = Apollo.MutationResult<EditCustomerReferenceMutation>;
export type EditCustomerReferenceMutationOptions = Apollo.BaseMutationOptions<EditCustomerReferenceMutation, EditCustomerReferenceMutationVariables>;
export const EnrichContactDocument = gql`
    mutation EnrichContact($companyId: Int!) {
  enrichCompanyContact(input: {companyId: $companyId, asyncMode: true}) {
    success
    message
    taskId
    operationId
  }
}
    `;
export type EnrichContactMutationFn = Apollo.MutationFunction<EnrichContactMutation, EnrichContactMutationVariables>;

/**
 * __useEnrichContactMutation__
 *
 * To run a mutation, you first call `useEnrichContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrichContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrichContactMutation, { data, loading, error }] = useEnrichContactMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useEnrichContactMutation(baseOptions?: Apollo.MutationHookOptions<EnrichContactMutation, EnrichContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrichContactMutation, EnrichContactMutationVariables>(EnrichContactDocument, options);
      }
export type EnrichContactMutationHookResult = ReturnType<typeof useEnrichContactMutation>;
export type EnrichContactMutationResult = Apollo.MutationResult<EnrichContactMutation>;
export type EnrichContactMutationOptions = Apollo.BaseMutationOptions<EnrichContactMutation, EnrichContactMutationVariables>;
export const EstimateCompanyGdriveConfigDocument = gql`
    mutation estimateCompanyGdriveConfig($companyId: Int!) {
  estimateCompanyGdriveConfig(companyId: $companyId) {
    success
    message
    estimate {
      sharedDriveName
      directoryName
      directoryId
      confidence
      alternatives
      requiresUserConfirmation
    }
  }
}
    `;
export type EstimateCompanyGdriveConfigMutationFn = Apollo.MutationFunction<EstimateCompanyGdriveConfigMutation, EstimateCompanyGdriveConfigMutationVariables>;

/**
 * __useEstimateCompanyGdriveConfigMutation__
 *
 * To run a mutation, you first call `useEstimateCompanyGdriveConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEstimateCompanyGdriveConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [estimateCompanyGdriveConfigMutation, { data, loading, error }] = useEstimateCompanyGdriveConfigMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useEstimateCompanyGdriveConfigMutation(baseOptions?: Apollo.MutationHookOptions<EstimateCompanyGdriveConfigMutation, EstimateCompanyGdriveConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EstimateCompanyGdriveConfigMutation, EstimateCompanyGdriveConfigMutationVariables>(EstimateCompanyGdriveConfigDocument, options);
      }
export type EstimateCompanyGdriveConfigMutationHookResult = ReturnType<typeof useEstimateCompanyGdriveConfigMutation>;
export type EstimateCompanyGdriveConfigMutationResult = Apollo.MutationResult<EstimateCompanyGdriveConfigMutation>;
export type EstimateCompanyGdriveConfigMutationOptions = Apollo.BaseMutationOptions<EstimateCompanyGdriveConfigMutation, EstimateCompanyGdriveConfigMutationVariables>;
export const ExcelUploadFileDocument = gql`
    mutation excelUploadFile($input: UploadExcelFileInput!) {
  uploadExcelFile(input: $input) {
    ok
    file {
      id
      fileName
    }
  }
}
    `;
export type ExcelUploadFileMutationFn = Apollo.MutationFunction<ExcelUploadFileMutation, ExcelUploadFileMutationVariables>;

/**
 * __useExcelUploadFileMutation__
 *
 * To run a mutation, you first call `useExcelUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcelUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excelUploadFileMutation, { data, loading, error }] = useExcelUploadFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExcelUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<ExcelUploadFileMutation, ExcelUploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExcelUploadFileMutation, ExcelUploadFileMutationVariables>(ExcelUploadFileDocument, options);
      }
export type ExcelUploadFileMutationHookResult = ReturnType<typeof useExcelUploadFileMutation>;
export type ExcelUploadFileMutationResult = Apollo.MutationResult<ExcelUploadFileMutation>;
export type ExcelUploadFileMutationOptions = Apollo.BaseMutationOptions<ExcelUploadFileMutation, ExcelUploadFileMutationVariables>;
export const ExcelUploadRowDocument = gql`
    mutation excelUploadRow($input: UploadExcelRowInput!) {
  uploadExcelRow(input: $input) {
    ok
  }
}
    `;
export type ExcelUploadRowMutationFn = Apollo.MutationFunction<ExcelUploadRowMutation, ExcelUploadRowMutationVariables>;

/**
 * __useExcelUploadRowMutation__
 *
 * To run a mutation, you first call `useExcelUploadRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcelUploadRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excelUploadRowMutation, { data, loading, error }] = useExcelUploadRowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExcelUploadRowMutation(baseOptions?: Apollo.MutationHookOptions<ExcelUploadRowMutation, ExcelUploadRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExcelUploadRowMutation, ExcelUploadRowMutationVariables>(ExcelUploadRowDocument, options);
      }
export type ExcelUploadRowMutationHookResult = ReturnType<typeof useExcelUploadRowMutation>;
export type ExcelUploadRowMutationResult = Apollo.MutationResult<ExcelUploadRowMutation>;
export type ExcelUploadRowMutationOptions = Apollo.BaseMutationOptions<ExcelUploadRowMutation, ExcelUploadRowMutationVariables>;
export const ExcelUploadSheetDocument = gql`
    mutation excelUploadSheet($input: UploadExcelSheetInput!) {
  uploadExcelSheet(input: $input) {
    ok
    sheet {
      id
      sheetName
    }
  }
}
    `;
export type ExcelUploadSheetMutationFn = Apollo.MutationFunction<ExcelUploadSheetMutation, ExcelUploadSheetMutationVariables>;

/**
 * __useExcelUploadSheetMutation__
 *
 * To run a mutation, you first call `useExcelUploadSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcelUploadSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excelUploadSheetMutation, { data, loading, error }] = useExcelUploadSheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExcelUploadSheetMutation(baseOptions?: Apollo.MutationHookOptions<ExcelUploadSheetMutation, ExcelUploadSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExcelUploadSheetMutation, ExcelUploadSheetMutationVariables>(ExcelUploadSheetDocument, options);
      }
export type ExcelUploadSheetMutationHookResult = ReturnType<typeof useExcelUploadSheetMutation>;
export type ExcelUploadSheetMutationResult = Apollo.MutationResult<ExcelUploadSheetMutation>;
export type ExcelUploadSheetMutationOptions = Apollo.BaseMutationOptions<ExcelUploadSheetMutation, ExcelUploadSheetMutationVariables>;
export const UpdateFinancialForecastParamsDocument = gql`
    mutation UpdateFinancialForecastParams($params: JSONString!) {
  updateFinancialForecastParams(params: $params) {
    ok
    version
  }
}
    `;
export type UpdateFinancialForecastParamsMutationFn = Apollo.MutationFunction<UpdateFinancialForecastParamsMutation, UpdateFinancialForecastParamsMutationVariables>;

/**
 * __useUpdateFinancialForecastParamsMutation__
 *
 * To run a mutation, you first call `useUpdateFinancialForecastParamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialForecastParamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialForecastParamsMutation, { data, loading, error }] = useUpdateFinancialForecastParamsMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateFinancialForecastParamsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinancialForecastParamsMutation, UpdateFinancialForecastParamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinancialForecastParamsMutation, UpdateFinancialForecastParamsMutationVariables>(UpdateFinancialForecastParamsDocument, options);
      }
export type UpdateFinancialForecastParamsMutationHookResult = ReturnType<typeof useUpdateFinancialForecastParamsMutation>;
export type UpdateFinancialForecastParamsMutationResult = Apollo.MutationResult<UpdateFinancialForecastParamsMutation>;
export type UpdateFinancialForecastParamsMutationOptions = Apollo.BaseMutationOptions<UpdateFinancialForecastParamsMutation, UpdateFinancialForecastParamsMutationVariables>;
export const TriggerValuationForecastDocument = gql`
    mutation TriggerValuationForecast($companyId: Int!) {
  triggerValuationForecast(companyId: $companyId) {
    success
  }
}
    `;
export type TriggerValuationForecastMutationFn = Apollo.MutationFunction<TriggerValuationForecastMutation, TriggerValuationForecastMutationVariables>;

/**
 * __useTriggerValuationForecastMutation__
 *
 * To run a mutation, you first call `useTriggerValuationForecastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerValuationForecastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerValuationForecastMutation, { data, loading, error }] = useTriggerValuationForecastMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useTriggerValuationForecastMutation(baseOptions?: Apollo.MutationHookOptions<TriggerValuationForecastMutation, TriggerValuationForecastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerValuationForecastMutation, TriggerValuationForecastMutationVariables>(TriggerValuationForecastDocument, options);
      }
export type TriggerValuationForecastMutationHookResult = ReturnType<typeof useTriggerValuationForecastMutation>;
export type TriggerValuationForecastMutationResult = Apollo.MutationResult<TriggerValuationForecastMutation>;
export type TriggerValuationForecastMutationOptions = Apollo.BaseMutationOptions<TriggerValuationForecastMutation, TriggerValuationForecastMutationVariables>;
export const TriggerValuationForecastAllDocument = gql`
    mutation TriggerValuationForecastAll {
  triggerValuationForecastAll {
    success
  }
}
    `;
export type TriggerValuationForecastAllMutationFn = Apollo.MutationFunction<TriggerValuationForecastAllMutation, TriggerValuationForecastAllMutationVariables>;

/**
 * __useTriggerValuationForecastAllMutation__
 *
 * To run a mutation, you first call `useTriggerValuationForecastAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerValuationForecastAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerValuationForecastAllMutation, { data, loading, error }] = useTriggerValuationForecastAllMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerValuationForecastAllMutation(baseOptions?: Apollo.MutationHookOptions<TriggerValuationForecastAllMutation, TriggerValuationForecastAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerValuationForecastAllMutation, TriggerValuationForecastAllMutationVariables>(TriggerValuationForecastAllDocument, options);
      }
export type TriggerValuationForecastAllMutationHookResult = ReturnType<typeof useTriggerValuationForecastAllMutation>;
export type TriggerValuationForecastAllMutationResult = Apollo.MutationResult<TriggerValuationForecastAllMutation>;
export type TriggerValuationForecastAllMutationOptions = Apollo.BaseMutationOptions<TriggerValuationForecastAllMutation, TriggerValuationForecastAllMutationVariables>;
export const FinishCompanyValidationDocument = gql`
    mutation finishCompanyValidation($companyId: Int!, $userId: Int!, $authId: String!) {
  finishCompanyValidation(companyId: $companyId, userId: $userId, authId: $authId) {
    success
    message
  }
}
    `;
export type FinishCompanyValidationMutationFn = Apollo.MutationFunction<FinishCompanyValidationMutation, FinishCompanyValidationMutationVariables>;

/**
 * __useFinishCompanyValidationMutation__
 *
 * To run a mutation, you first call `useFinishCompanyValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishCompanyValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishCompanyValidationMutation, { data, loading, error }] = useFinishCompanyValidationMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      authId: // value for 'authId'
 *   },
 * });
 */
export function useFinishCompanyValidationMutation(baseOptions?: Apollo.MutationHookOptions<FinishCompanyValidationMutation, FinishCompanyValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishCompanyValidationMutation, FinishCompanyValidationMutationVariables>(FinishCompanyValidationDocument, options);
      }
export type FinishCompanyValidationMutationHookResult = ReturnType<typeof useFinishCompanyValidationMutation>;
export type FinishCompanyValidationMutationResult = Apollo.MutationResult<FinishCompanyValidationMutation>;
export type FinishCompanyValidationMutationOptions = Apollo.BaseMutationOptions<FinishCompanyValidationMutation, FinishCompanyValidationMutationVariables>;
export const FinishCrawlResultValidationDocument = gql`
    mutation finishCrawlResultValidation($crawlResultId: Int!, $userId: Int!, $authId: String!) {
  finishCrawlResultValidation(
    crawlResultId: $crawlResultId
    userId: $userId
    authId: $authId
  ) {
    success
    message
    batchValidatedCount
  }
}
    `;
export type FinishCrawlResultValidationMutationFn = Apollo.MutationFunction<FinishCrawlResultValidationMutation, FinishCrawlResultValidationMutationVariables>;

/**
 * __useFinishCrawlResultValidationMutation__
 *
 * To run a mutation, you first call `useFinishCrawlResultValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishCrawlResultValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishCrawlResultValidationMutation, { data, loading, error }] = useFinishCrawlResultValidationMutation({
 *   variables: {
 *      crawlResultId: // value for 'crawlResultId'
 *      userId: // value for 'userId'
 *      authId: // value for 'authId'
 *   },
 * });
 */
export function useFinishCrawlResultValidationMutation(baseOptions?: Apollo.MutationHookOptions<FinishCrawlResultValidationMutation, FinishCrawlResultValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishCrawlResultValidationMutation, FinishCrawlResultValidationMutationVariables>(FinishCrawlResultValidationDocument, options);
      }
export type FinishCrawlResultValidationMutationHookResult = ReturnType<typeof useFinishCrawlResultValidationMutation>;
export type FinishCrawlResultValidationMutationResult = Apollo.MutationResult<FinishCrawlResultValidationMutation>;
export type FinishCrawlResultValidationMutationOptions = Apollo.BaseMutationOptions<FinishCrawlResultValidationMutation, FinishCrawlResultValidationMutationVariables>;
export const FinishExcelFileUploadDocument = gql`
    mutation finishExcelFileUpload($input: Int!, $onlyFinancialKpis: Boolean, $userEmail: String) {
  finishExcelFileUpload(
    fileId: $input
    onlyFinancialKpis: $onlyFinancialKpis
    userEmail: $userEmail
  ) {
    ok
  }
}
    `;
export type FinishExcelFileUploadMutationFn = Apollo.MutationFunction<FinishExcelFileUploadMutation, FinishExcelFileUploadMutationVariables>;

/**
 * __useFinishExcelFileUploadMutation__
 *
 * To run a mutation, you first call `useFinishExcelFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishExcelFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishExcelFileUploadMutation, { data, loading, error }] = useFinishExcelFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *      onlyFinancialKpis: // value for 'onlyFinancialKpis'
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useFinishExcelFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<FinishExcelFileUploadMutation, FinishExcelFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishExcelFileUploadMutation, FinishExcelFileUploadMutationVariables>(FinishExcelFileUploadDocument, options);
      }
export type FinishExcelFileUploadMutationHookResult = ReturnType<typeof useFinishExcelFileUploadMutation>;
export type FinishExcelFileUploadMutationResult = Apollo.MutationResult<FinishExcelFileUploadMutation>;
export type FinishExcelFileUploadMutationOptions = Apollo.BaseMutationOptions<FinishExcelFileUploadMutation, FinishExcelFileUploadMutationVariables>;
export const GenerateVibeCodingIdeasDocument = gql`
    mutation generateVibeCodingIdeas($portfolioCompanyId: Int!, $maxIdeas: Int) {
  generateVibeCodingIdeas(
    portfolioCompanyId: $portfolioCompanyId
    maxIdeas: $maxIdeas
  ) {
    success
    message
  }
}
    `;
export type GenerateVibeCodingIdeasMutationFn = Apollo.MutationFunction<GenerateVibeCodingIdeasMutation, GenerateVibeCodingIdeasMutationVariables>;

/**
 * __useGenerateVibeCodingIdeasMutation__
 *
 * To run a mutation, you first call `useGenerateVibeCodingIdeasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateVibeCodingIdeasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateVibeCodingIdeasMutation, { data, loading, error }] = useGenerateVibeCodingIdeasMutation({
 *   variables: {
 *      portfolioCompanyId: // value for 'portfolioCompanyId'
 *      maxIdeas: // value for 'maxIdeas'
 *   },
 * });
 */
export function useGenerateVibeCodingIdeasMutation(baseOptions?: Apollo.MutationHookOptions<GenerateVibeCodingIdeasMutation, GenerateVibeCodingIdeasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateVibeCodingIdeasMutation, GenerateVibeCodingIdeasMutationVariables>(GenerateVibeCodingIdeasDocument, options);
      }
export type GenerateVibeCodingIdeasMutationHookResult = ReturnType<typeof useGenerateVibeCodingIdeasMutation>;
export type GenerateVibeCodingIdeasMutationResult = Apollo.MutationResult<GenerateVibeCodingIdeasMutation>;
export type GenerateVibeCodingIdeasMutationOptions = Apollo.BaseMutationOptions<GenerateVibeCodingIdeasMutation, GenerateVibeCodingIdeasMutationVariables>;
export const InsertCertainProductCategoryDocument = gql`
    mutation insertCertainProductCategory($productCategorizationId: Int!) {
  insertCertainProductCategory(productCategorizationId: $productCategorizationId) {
    message
    success
  }
}
    `;
export type InsertCertainProductCategoryMutationFn = Apollo.MutationFunction<InsertCertainProductCategoryMutation, InsertCertainProductCategoryMutationVariables>;

/**
 * __useInsertCertainProductCategoryMutation__
 *
 * To run a mutation, you first call `useInsertCertainProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCertainProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCertainProductCategoryMutation, { data, loading, error }] = useInsertCertainProductCategoryMutation({
 *   variables: {
 *      productCategorizationId: // value for 'productCategorizationId'
 *   },
 * });
 */
export function useInsertCertainProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<InsertCertainProductCategoryMutation, InsertCertainProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCertainProductCategoryMutation, InsertCertainProductCategoryMutationVariables>(InsertCertainProductCategoryDocument, options);
      }
export type InsertCertainProductCategoryMutationHookResult = ReturnType<typeof useInsertCertainProductCategoryMutation>;
export type InsertCertainProductCategoryMutationResult = Apollo.MutationResult<InsertCertainProductCategoryMutation>;
export type InsertCertainProductCategoryMutationOptions = Apollo.BaseMutationOptions<InsertCertainProductCategoryMutation, InsertCertainProductCategoryMutationVariables>;
export const LabelBuyAndBuildTargetQualityDocument = gql`
    mutation labelBuyAndBuildTargetQuality($quality: Float!, $softwareCompanyId: Int!, $targetCompanyId: Int!) {
  labelBuyAndBuildTargetQuality(
    quality: $quality
    softwareCompanyId: $softwareCompanyId
    targetCompanyId: $targetCompanyId
  ) {
    ok
  }
}
    `;
export type LabelBuyAndBuildTargetQualityMutationFn = Apollo.MutationFunction<LabelBuyAndBuildTargetQualityMutation, LabelBuyAndBuildTargetQualityMutationVariables>;

/**
 * __useLabelBuyAndBuildTargetQualityMutation__
 *
 * To run a mutation, you first call `useLabelBuyAndBuildTargetQualityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLabelBuyAndBuildTargetQualityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [labelBuyAndBuildTargetQualityMutation, { data, loading, error }] = useLabelBuyAndBuildTargetQualityMutation({
 *   variables: {
 *      quality: // value for 'quality'
 *      softwareCompanyId: // value for 'softwareCompanyId'
 *      targetCompanyId: // value for 'targetCompanyId'
 *   },
 * });
 */
export function useLabelBuyAndBuildTargetQualityMutation(baseOptions?: Apollo.MutationHookOptions<LabelBuyAndBuildTargetQualityMutation, LabelBuyAndBuildTargetQualityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LabelBuyAndBuildTargetQualityMutation, LabelBuyAndBuildTargetQualityMutationVariables>(LabelBuyAndBuildTargetQualityDocument, options);
      }
export type LabelBuyAndBuildTargetQualityMutationHookResult = ReturnType<typeof useLabelBuyAndBuildTargetQualityMutation>;
export type LabelBuyAndBuildTargetQualityMutationResult = Apollo.MutationResult<LabelBuyAndBuildTargetQualityMutation>;
export type LabelBuyAndBuildTargetQualityMutationOptions = Apollo.BaseMutationOptions<LabelBuyAndBuildTargetQualityMutation, LabelBuyAndBuildTargetQualityMutationVariables>;
export const LockCrawlQueueEntriesDocument = gql`
    mutation lockCrawlQueueEntries($ids: [Int]!) {
  lockCrawlQueueEntries(ids: $ids) {
    ok
    updatedCount
  }
}
    `;
export type LockCrawlQueueEntriesMutationFn = Apollo.MutationFunction<LockCrawlQueueEntriesMutation, LockCrawlQueueEntriesMutationVariables>;

/**
 * __useLockCrawlQueueEntriesMutation__
 *
 * To run a mutation, you first call `useLockCrawlQueueEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockCrawlQueueEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockCrawlQueueEntriesMutation, { data, loading, error }] = useLockCrawlQueueEntriesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLockCrawlQueueEntriesMutation(baseOptions?: Apollo.MutationHookOptions<LockCrawlQueueEntriesMutation, LockCrawlQueueEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockCrawlQueueEntriesMutation, LockCrawlQueueEntriesMutationVariables>(LockCrawlQueueEntriesDocument, options);
      }
export type LockCrawlQueueEntriesMutationHookResult = ReturnType<typeof useLockCrawlQueueEntriesMutation>;
export type LockCrawlQueueEntriesMutationResult = Apollo.MutationResult<LockCrawlQueueEntriesMutation>;
export type LockCrawlQueueEntriesMutationOptions = Apollo.BaseMutationOptions<LockCrawlQueueEntriesMutation, LockCrawlQueueEntriesMutationVariables>;
export const MarkCompanyAsNotSoftwareDocument = gql`
    mutation markCompanyAsNotSoftware($companyId: Int!) {
  markCompanyAsNotSoftware(companyId: $companyId) {
    ok
  }
}
    `;
export type MarkCompanyAsNotSoftwareMutationFn = Apollo.MutationFunction<MarkCompanyAsNotSoftwareMutation, MarkCompanyAsNotSoftwareMutationVariables>;

/**
 * __useMarkCompanyAsNotSoftwareMutation__
 *
 * To run a mutation, you first call `useMarkCompanyAsNotSoftwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCompanyAsNotSoftwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCompanyAsNotSoftwareMutation, { data, loading, error }] = useMarkCompanyAsNotSoftwareMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMarkCompanyAsNotSoftwareMutation(baseOptions?: Apollo.MutationHookOptions<MarkCompanyAsNotSoftwareMutation, MarkCompanyAsNotSoftwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCompanyAsNotSoftwareMutation, MarkCompanyAsNotSoftwareMutationVariables>(MarkCompanyAsNotSoftwareDocument, options);
      }
export type MarkCompanyAsNotSoftwareMutationHookResult = ReturnType<typeof useMarkCompanyAsNotSoftwareMutation>;
export type MarkCompanyAsNotSoftwareMutationResult = Apollo.MutationResult<MarkCompanyAsNotSoftwareMutation>;
export type MarkCompanyAsNotSoftwareMutationOptions = Apollo.BaseMutationOptions<MarkCompanyAsNotSoftwareMutation, MarkCompanyAsNotSoftwareMutationVariables>;
export const MarkCompanyAsSoftwareDocument = gql`
    mutation markCompanyAsSoftware($companyId: Int!, $crawlResultId: Int) {
  markCompanyAsSoftware(companyId: $companyId, crawlResultId: $crawlResultId) {
    ok
  }
}
    `;
export type MarkCompanyAsSoftwareMutationFn = Apollo.MutationFunction<MarkCompanyAsSoftwareMutation, MarkCompanyAsSoftwareMutationVariables>;

/**
 * __useMarkCompanyAsSoftwareMutation__
 *
 * To run a mutation, you first call `useMarkCompanyAsSoftwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCompanyAsSoftwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCompanyAsSoftwareMutation, { data, loading, error }] = useMarkCompanyAsSoftwareMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      crawlResultId: // value for 'crawlResultId'
 *   },
 * });
 */
export function useMarkCompanyAsSoftwareMutation(baseOptions?: Apollo.MutationHookOptions<MarkCompanyAsSoftwareMutation, MarkCompanyAsSoftwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCompanyAsSoftwareMutation, MarkCompanyAsSoftwareMutationVariables>(MarkCompanyAsSoftwareDocument, options);
      }
export type MarkCompanyAsSoftwareMutationHookResult = ReturnType<typeof useMarkCompanyAsSoftwareMutation>;
export type MarkCompanyAsSoftwareMutationResult = Apollo.MutationResult<MarkCompanyAsSoftwareMutation>;
export type MarkCompanyAsSoftwareMutationOptions = Apollo.BaseMutationOptions<MarkCompanyAsSoftwareMutation, MarkCompanyAsSoftwareMutationVariables>;
export const MarkCustomerReferenceObsoleteDocument = gql`
    mutation markCustomerReferenceObsolete($customerReferenceId: Int!) {
  markCustomerReferenceObsolete(customerReferenceId: $customerReferenceId) {
    success
    message
  }
}
    `;
export type MarkCustomerReferenceObsoleteMutationFn = Apollo.MutationFunction<MarkCustomerReferenceObsoleteMutation, MarkCustomerReferenceObsoleteMutationVariables>;

/**
 * __useMarkCustomerReferenceObsoleteMutation__
 *
 * To run a mutation, you first call `useMarkCustomerReferenceObsoleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCustomerReferenceObsoleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCustomerReferenceObsoleteMutation, { data, loading, error }] = useMarkCustomerReferenceObsoleteMutation({
 *   variables: {
 *      customerReferenceId: // value for 'customerReferenceId'
 *   },
 * });
 */
export function useMarkCustomerReferenceObsoleteMutation(baseOptions?: Apollo.MutationHookOptions<MarkCustomerReferenceObsoleteMutation, MarkCustomerReferenceObsoleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCustomerReferenceObsoleteMutation, MarkCustomerReferenceObsoleteMutationVariables>(MarkCustomerReferenceObsoleteDocument, options);
      }
export type MarkCustomerReferenceObsoleteMutationHookResult = ReturnType<typeof useMarkCustomerReferenceObsoleteMutation>;
export type MarkCustomerReferenceObsoleteMutationResult = Apollo.MutationResult<MarkCustomerReferenceObsoleteMutation>;
export type MarkCustomerReferenceObsoleteMutationOptions = Apollo.BaseMutationOptions<MarkCustomerReferenceObsoleteMutation, MarkCustomerReferenceObsoleteMutationVariables>;
export const MarkProductAsHorizontalDocument = gql`
    mutation markProductAsHorizontal($softwareCompanyId: Int!) {
  markProductAsHorizontal(softwareCompanyId: $softwareCompanyId) {
    message
    success
  }
}
    `;
export type MarkProductAsHorizontalMutationFn = Apollo.MutationFunction<MarkProductAsHorizontalMutation, MarkProductAsHorizontalMutationVariables>;

/**
 * __useMarkProductAsHorizontalMutation__
 *
 * To run a mutation, you first call `useMarkProductAsHorizontalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProductAsHorizontalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProductAsHorizontalMutation, { data, loading, error }] = useMarkProductAsHorizontalMutation({
 *   variables: {
 *      softwareCompanyId: // value for 'softwareCompanyId'
 *   },
 * });
 */
export function useMarkProductAsHorizontalMutation(baseOptions?: Apollo.MutationHookOptions<MarkProductAsHorizontalMutation, MarkProductAsHorizontalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkProductAsHorizontalMutation, MarkProductAsHorizontalMutationVariables>(MarkProductAsHorizontalDocument, options);
      }
export type MarkProductAsHorizontalMutationHookResult = ReturnType<typeof useMarkProductAsHorizontalMutation>;
export type MarkProductAsHorizontalMutationResult = Apollo.MutationResult<MarkProductAsHorizontalMutation>;
export type MarkProductAsHorizontalMutationOptions = Apollo.BaseMutationOptions<MarkProductAsHorizontalMutation, MarkProductAsHorizontalMutationVariables>;
export const PrecalculateAllKpisDocument = gql`
    mutation precalculateAllKpis($companyId: Int!) {
  precalculateAllKpis(companyId: $companyId) {
    ok
  }
}
    `;
export type PrecalculateAllKpisMutationFn = Apollo.MutationFunction<PrecalculateAllKpisMutation, PrecalculateAllKpisMutationVariables>;

/**
 * __usePrecalculateAllKpisMutation__
 *
 * To run a mutation, you first call `usePrecalculateAllKpisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrecalculateAllKpisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [precalculateAllKpisMutation, { data, loading, error }] = usePrecalculateAllKpisMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function usePrecalculateAllKpisMutation(baseOptions?: Apollo.MutationHookOptions<PrecalculateAllKpisMutation, PrecalculateAllKpisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrecalculateAllKpisMutation, PrecalculateAllKpisMutationVariables>(PrecalculateAllKpisDocument, options);
      }
export type PrecalculateAllKpisMutationHookResult = ReturnType<typeof usePrecalculateAllKpisMutation>;
export type PrecalculateAllKpisMutationResult = Apollo.MutationResult<PrecalculateAllKpisMutation>;
export type PrecalculateAllKpisMutationOptions = Apollo.BaseMutationOptions<PrecalculateAllKpisMutation, PrecalculateAllKpisMutationVariables>;
export const RecalculateCompanyKpisDocument = gql`
    mutation RecalculateCompanyKpis($companyId: Int!) {
  precalculateAllKpis(companyId: $companyId) {
    ok
  }
}
    `;
export type RecalculateCompanyKpisMutationFn = Apollo.MutationFunction<RecalculateCompanyKpisMutation, RecalculateCompanyKpisMutationVariables>;

/**
 * __useRecalculateCompanyKpisMutation__
 *
 * To run a mutation, you first call `useRecalculateCompanyKpisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateCompanyKpisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculateCompanyKpisMutation, { data, loading, error }] = useRecalculateCompanyKpisMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useRecalculateCompanyKpisMutation(baseOptions?: Apollo.MutationHookOptions<RecalculateCompanyKpisMutation, RecalculateCompanyKpisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculateCompanyKpisMutation, RecalculateCompanyKpisMutationVariables>(RecalculateCompanyKpisDocument, options);
      }
export type RecalculateCompanyKpisMutationHookResult = ReturnType<typeof useRecalculateCompanyKpisMutation>;
export type RecalculateCompanyKpisMutationResult = Apollo.MutationResult<RecalculateCompanyKpisMutation>;
export type RecalculateCompanyKpisMutationOptions = Apollo.BaseMutationOptions<RecalculateCompanyKpisMutation, RecalculateCompanyKpisMutationVariables>;
export const RefreshCompanyGoogleDriveFilesDocument = gql`
    mutation refreshCompanyGoogleDriveFiles($companyId: Int!) {
  refreshCompanyGoogleDriveFiles(companyId: $companyId) {
    success
    message
    autoConfigured
    requiresConfiguration
    configEstimate {
      sharedDriveName
      directoryName
      directoryId
      confidence
      alternatives
      requiresUserConfirmation
    }
  }
}
    `;
export type RefreshCompanyGoogleDriveFilesMutationFn = Apollo.MutationFunction<RefreshCompanyGoogleDriveFilesMutation, RefreshCompanyGoogleDriveFilesMutationVariables>;

/**
 * __useRefreshCompanyGoogleDriveFilesMutation__
 *
 * To run a mutation, you first call `useRefreshCompanyGoogleDriveFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCompanyGoogleDriveFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCompanyGoogleDriveFilesMutation, { data, loading, error }] = useRefreshCompanyGoogleDriveFilesMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useRefreshCompanyGoogleDriveFilesMutation(baseOptions?: Apollo.MutationHookOptions<RefreshCompanyGoogleDriveFilesMutation, RefreshCompanyGoogleDriveFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshCompanyGoogleDriveFilesMutation, RefreshCompanyGoogleDriveFilesMutationVariables>(RefreshCompanyGoogleDriveFilesDocument, options);
      }
export type RefreshCompanyGoogleDriveFilesMutationHookResult = ReturnType<typeof useRefreshCompanyGoogleDriveFilesMutation>;
export type RefreshCompanyGoogleDriveFilesMutationResult = Apollo.MutationResult<RefreshCompanyGoogleDriveFilesMutation>;
export type RefreshCompanyGoogleDriveFilesMutationOptions = Apollo.BaseMutationOptions<RefreshCompanyGoogleDriveFilesMutation, RefreshCompanyGoogleDriveFilesMutationVariables>;
export const RefreshValidationInboxDocument = gql`
    mutation refreshValidationInbox {
  refreshValidationInbox {
    success
    message
  }
}
    `;
export type RefreshValidationInboxMutationFn = Apollo.MutationFunction<RefreshValidationInboxMutation, RefreshValidationInboxMutationVariables>;

/**
 * __useRefreshValidationInboxMutation__
 *
 * To run a mutation, you first call `useRefreshValidationInboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshValidationInboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshValidationInboxMutation, { data, loading, error }] = useRefreshValidationInboxMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshValidationInboxMutation(baseOptions?: Apollo.MutationHookOptions<RefreshValidationInboxMutation, RefreshValidationInboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshValidationInboxMutation, RefreshValidationInboxMutationVariables>(RefreshValidationInboxDocument, options);
      }
export type RefreshValidationInboxMutationHookResult = ReturnType<typeof useRefreshValidationInboxMutation>;
export type RefreshValidationInboxMutationResult = Apollo.MutationResult<RefreshValidationInboxMutation>;
export type RefreshValidationInboxMutationOptions = Apollo.BaseMutationOptions<RefreshValidationInboxMutation, RefreshValidationInboxMutationVariables>;
export const RegenerateAllDAsDocument = gql`
    mutation RegenerateAllDAs {
  regenerateAllDas {
    ok
    cortexConfig {
      assessmentXlsUploadTime
    }
  }
}
    `;
export type RegenerateAllDAsMutationFn = Apollo.MutationFunction<RegenerateAllDAsMutation, RegenerateAllDAsMutationVariables>;

/**
 * __useRegenerateAllDAsMutation__
 *
 * To run a mutation, you first call `useRegenerateAllDAsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateAllDAsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateAllDAsMutation, { data, loading, error }] = useRegenerateAllDAsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegenerateAllDAsMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateAllDAsMutation, RegenerateAllDAsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateAllDAsMutation, RegenerateAllDAsMutationVariables>(RegenerateAllDAsDocument, options);
      }
export type RegenerateAllDAsMutationHookResult = ReturnType<typeof useRegenerateAllDAsMutation>;
export type RegenerateAllDAsMutationResult = Apollo.MutationResult<RegenerateAllDAsMutation>;
export type RegenerateAllDAsMutationOptions = Apollo.BaseMutationOptions<RegenerateAllDAsMutation, RegenerateAllDAsMutationVariables>;
export const RejectCoreKeywordDocument = gql`
    mutation rejectCoreKeyword($keywordId: Int!) {
  rejectCoreKeyword(keywordId: $keywordId) {
    success
    message
  }
}
    `;
export type RejectCoreKeywordMutationFn = Apollo.MutationFunction<RejectCoreKeywordMutation, RejectCoreKeywordMutationVariables>;

/**
 * __useRejectCoreKeywordMutation__
 *
 * To run a mutation, you first call `useRejectCoreKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCoreKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCoreKeywordMutation, { data, loading, error }] = useRejectCoreKeywordMutation({
 *   variables: {
 *      keywordId: // value for 'keywordId'
 *   },
 * });
 */
export function useRejectCoreKeywordMutation(baseOptions?: Apollo.MutationHookOptions<RejectCoreKeywordMutation, RejectCoreKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectCoreKeywordMutation, RejectCoreKeywordMutationVariables>(RejectCoreKeywordDocument, options);
      }
export type RejectCoreKeywordMutationHookResult = ReturnType<typeof useRejectCoreKeywordMutation>;
export type RejectCoreKeywordMutationResult = Apollo.MutationResult<RejectCoreKeywordMutation>;
export type RejectCoreKeywordMutationOptions = Apollo.BaseMutationOptions<RejectCoreKeywordMutation, RejectCoreKeywordMutationVariables>;
export const ReleaseValidationLockDocument = gql`
    mutation releaseValidationLock($companyId: Int!, $userId: Int!) {
  releaseValidationLock(companyId: $companyId, userId: $userId) {
    success
    message
  }
}
    `;
export type ReleaseValidationLockMutationFn = Apollo.MutationFunction<ReleaseValidationLockMutation, ReleaseValidationLockMutationVariables>;

/**
 * __useReleaseValidationLockMutation__
 *
 * To run a mutation, you first call `useReleaseValidationLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseValidationLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseValidationLockMutation, { data, loading, error }] = useReleaseValidationLockMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useReleaseValidationLockMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseValidationLockMutation, ReleaseValidationLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseValidationLockMutation, ReleaseValidationLockMutationVariables>(ReleaseValidationLockDocument, options);
      }
export type ReleaseValidationLockMutationHookResult = ReturnType<typeof useReleaseValidationLockMutation>;
export type ReleaseValidationLockMutationResult = Apollo.MutationResult<ReleaseValidationLockMutation>;
export type ReleaseValidationLockMutationOptions = Apollo.BaseMutationOptions<ReleaseValidationLockMutation, ReleaseValidationLockMutationVariables>;
export const RemoveCompanyCertificationDocument = gql`
    mutation removeCompanyCertification($id: Int!) {
  removeCompanyCertification(id: $id) {
    success
    message
  }
}
    `;
export type RemoveCompanyCertificationMutationFn = Apollo.MutationFunction<RemoveCompanyCertificationMutation, RemoveCompanyCertificationMutationVariables>;

/**
 * __useRemoveCompanyCertificationMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyCertificationMutation, { data, loading, error }] = useRemoveCompanyCertificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCompanyCertificationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyCertificationMutation, RemoveCompanyCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyCertificationMutation, RemoveCompanyCertificationMutationVariables>(RemoveCompanyCertificationDocument, options);
      }
export type RemoveCompanyCertificationMutationHookResult = ReturnType<typeof useRemoveCompanyCertificationMutation>;
export type RemoveCompanyCertificationMutationResult = Apollo.MutationResult<RemoveCompanyCertificationMutation>;
export type RemoveCompanyCertificationMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyCertificationMutation, RemoveCompanyCertificationMutationVariables>;
export const RemoveShortlistedBuyAndBuildTargetsDocument = gql`
    mutation removeShortlistedBuyAndBuildTargets($softwareCompanyId: Int!, $targetCompanyId: Int!) {
  removeShortlistedBuyAndBuildTargets(
    softwareCompanyId: $softwareCompanyId
    targetCompanyId: $targetCompanyId
  ) {
    ok
  }
}
    `;
export type RemoveShortlistedBuyAndBuildTargetsMutationFn = Apollo.MutationFunction<RemoveShortlistedBuyAndBuildTargetsMutation, RemoveShortlistedBuyAndBuildTargetsMutationVariables>;

/**
 * __useRemoveShortlistedBuyAndBuildTargetsMutation__
 *
 * To run a mutation, you first call `useRemoveShortlistedBuyAndBuildTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveShortlistedBuyAndBuildTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeShortlistedBuyAndBuildTargetsMutation, { data, loading, error }] = useRemoveShortlistedBuyAndBuildTargetsMutation({
 *   variables: {
 *      softwareCompanyId: // value for 'softwareCompanyId'
 *      targetCompanyId: // value for 'targetCompanyId'
 *   },
 * });
 */
export function useRemoveShortlistedBuyAndBuildTargetsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveShortlistedBuyAndBuildTargetsMutation, RemoveShortlistedBuyAndBuildTargetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveShortlistedBuyAndBuildTargetsMutation, RemoveShortlistedBuyAndBuildTargetsMutationVariables>(RemoveShortlistedBuyAndBuildTargetsDocument, options);
      }
export type RemoveShortlistedBuyAndBuildTargetsMutationHookResult = ReturnType<typeof useRemoveShortlistedBuyAndBuildTargetsMutation>;
export type RemoveShortlistedBuyAndBuildTargetsMutationResult = Apollo.MutationResult<RemoveShortlistedBuyAndBuildTargetsMutation>;
export type RemoveShortlistedBuyAndBuildTargetsMutationOptions = Apollo.BaseMutationOptions<RemoveShortlistedBuyAndBuildTargetsMutation, RemoveShortlistedBuyAndBuildTargetsMutationVariables>;
export const RenewValidationLockDocument = gql`
    mutation renewValidationLock($companyId: Int!, $userId: Int!) {
  renewValidationLock(companyId: $companyId, userId: $userId) {
    success
    message
  }
}
    `;
export type RenewValidationLockMutationFn = Apollo.MutationFunction<RenewValidationLockMutation, RenewValidationLockMutationVariables>;

/**
 * __useRenewValidationLockMutation__
 *
 * To run a mutation, you first call `useRenewValidationLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewValidationLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewValidationLockMutation, { data, loading, error }] = useRenewValidationLockMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRenewValidationLockMutation(baseOptions?: Apollo.MutationHookOptions<RenewValidationLockMutation, RenewValidationLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewValidationLockMutation, RenewValidationLockMutationVariables>(RenewValidationLockDocument, options);
      }
export type RenewValidationLockMutationHookResult = ReturnType<typeof useRenewValidationLockMutation>;
export type RenewValidationLockMutationResult = Apollo.MutationResult<RenewValidationLockMutation>;
export type RenewValidationLockMutationOptions = Apollo.BaseMutationOptions<RenewValidationLockMutation, RenewValidationLockMutationVariables>;
export const ResegmentCustomersDocument = gql`
    mutation resegmentCustomers($companyId: Int!) {
  resegmentAllCustomers(companyId: $companyId) {
    success
  }
}
    `;
export type ResegmentCustomersMutationFn = Apollo.MutationFunction<ResegmentCustomersMutation, ResegmentCustomersMutationVariables>;

/**
 * __useResegmentCustomersMutation__
 *
 * To run a mutation, you first call `useResegmentCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResegmentCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resegmentCustomersMutation, { data, loading, error }] = useResegmentCustomersMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useResegmentCustomersMutation(baseOptions?: Apollo.MutationHookOptions<ResegmentCustomersMutation, ResegmentCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResegmentCustomersMutation, ResegmentCustomersMutationVariables>(ResegmentCustomersDocument, options);
      }
export type ResegmentCustomersMutationHookResult = ReturnType<typeof useResegmentCustomersMutation>;
export type ResegmentCustomersMutationResult = Apollo.MutationResult<ResegmentCustomersMutation>;
export type ResegmentCustomersMutationOptions = Apollo.BaseMutationOptions<ResegmentCustomersMutation, ResegmentCustomersMutationVariables>;
export const ResetDealAssessmentUploadDocument = gql`
    mutation ResetDealAssessmentUpload($companyId: Int!) {
  resetDealAssessmentUpload(companyId: $companyId) {
    success
    message
  }
}
    `;
export type ResetDealAssessmentUploadMutationFn = Apollo.MutationFunction<ResetDealAssessmentUploadMutation, ResetDealAssessmentUploadMutationVariables>;

/**
 * __useResetDealAssessmentUploadMutation__
 *
 * To run a mutation, you first call `useResetDealAssessmentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetDealAssessmentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetDealAssessmentUploadMutation, { data, loading, error }] = useResetDealAssessmentUploadMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useResetDealAssessmentUploadMutation(baseOptions?: Apollo.MutationHookOptions<ResetDealAssessmentUploadMutation, ResetDealAssessmentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetDealAssessmentUploadMutation, ResetDealAssessmentUploadMutationVariables>(ResetDealAssessmentUploadDocument, options);
      }
export type ResetDealAssessmentUploadMutationHookResult = ReturnType<typeof useResetDealAssessmentUploadMutation>;
export type ResetDealAssessmentUploadMutationResult = Apollo.MutationResult<ResetDealAssessmentUploadMutation>;
export type ResetDealAssessmentUploadMutationOptions = Apollo.BaseMutationOptions<ResetDealAssessmentUploadMutation, ResetDealAssessmentUploadMutationVariables>;
export const SaveDealTransactionDocument = gql`
    mutation SaveDealTransaction($targetCompanyName: String, $targetCompanyDomain: String!, $targetCompanyCountry: String, $targetCompanyId: Int, $forceTargetIsSoftwareCompany: Boolean, $transactionType: String, $amountRaised: Float, $totalAmountRaised: Float, $dateOfTransaction: String, $typeOfTransaction: String, $listOfBuyers: [ShareholderInputType!]!, $listOfSellers: [ShareholderInputType!]!) {
  saveDealTransaction(
    targetCompanyName: $targetCompanyName
    targetCompanyDomain: $targetCompanyDomain
    targetCompanyCountry: $targetCompanyCountry
    targetCompanyId: $targetCompanyId
    forceTargetIsSoftwareCompany: $forceTargetIsSoftwareCompany
    transactionType: $transactionType
    amountRaised: $amountRaised
    totalAmountRaised: $totalAmountRaised
    dateOfTransaction: $dateOfTransaction
    typeOfTransaction: $typeOfTransaction
    listOfBuyers: $listOfBuyers
    listOfSellers: $listOfSellers
  ) {
    success
    message
  }
}
    `;
export type SaveDealTransactionMutationFn = Apollo.MutationFunction<SaveDealTransactionMutation, SaveDealTransactionMutationVariables>;

/**
 * __useSaveDealTransactionMutation__
 *
 * To run a mutation, you first call `useSaveDealTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDealTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDealTransactionMutation, { data, loading, error }] = useSaveDealTransactionMutation({
 *   variables: {
 *      targetCompanyName: // value for 'targetCompanyName'
 *      targetCompanyDomain: // value for 'targetCompanyDomain'
 *      targetCompanyCountry: // value for 'targetCompanyCountry'
 *      targetCompanyId: // value for 'targetCompanyId'
 *      forceTargetIsSoftwareCompany: // value for 'forceTargetIsSoftwareCompany'
 *      transactionType: // value for 'transactionType'
 *      amountRaised: // value for 'amountRaised'
 *      totalAmountRaised: // value for 'totalAmountRaised'
 *      dateOfTransaction: // value for 'dateOfTransaction'
 *      typeOfTransaction: // value for 'typeOfTransaction'
 *      listOfBuyers: // value for 'listOfBuyers'
 *      listOfSellers: // value for 'listOfSellers'
 *   },
 * });
 */
export function useSaveDealTransactionMutation(baseOptions?: Apollo.MutationHookOptions<SaveDealTransactionMutation, SaveDealTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDealTransactionMutation, SaveDealTransactionMutationVariables>(SaveDealTransactionDocument, options);
      }
export type SaveDealTransactionMutationHookResult = ReturnType<typeof useSaveDealTransactionMutation>;
export type SaveDealTransactionMutationResult = Apollo.MutationResult<SaveDealTransactionMutation>;
export type SaveDealTransactionMutationOptions = Apollo.BaseMutationOptions<SaveDealTransactionMutation, SaveDealTransactionMutationVariables>;
export const SetCompanySizeDocument = gql`
    mutation setCompanySize($companyId: Int!, $fte: Int!, $findingUrl: String!, $typeOfFinding: Int!) {
  setCompanySize(
    companyId: $companyId
    fte: $fte
    findingUrl: $findingUrl
    typeOfFinding: $typeOfFinding
  ) {
    ok
    typeOfFinding
    findingUrl
    fte
  }
}
    `;
export type SetCompanySizeMutationFn = Apollo.MutationFunction<SetCompanySizeMutation, SetCompanySizeMutationVariables>;

/**
 * __useSetCompanySizeMutation__
 *
 * To run a mutation, you first call `useSetCompanySizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCompanySizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCompanySizeMutation, { data, loading, error }] = useSetCompanySizeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      fte: // value for 'fte'
 *      findingUrl: // value for 'findingUrl'
 *      typeOfFinding: // value for 'typeOfFinding'
 *   },
 * });
 */
export function useSetCompanySizeMutation(baseOptions?: Apollo.MutationHookOptions<SetCompanySizeMutation, SetCompanySizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCompanySizeMutation, SetCompanySizeMutationVariables>(SetCompanySizeDocument, options);
      }
export type SetCompanySizeMutationHookResult = ReturnType<typeof useSetCompanySizeMutation>;
export type SetCompanySizeMutationResult = Apollo.MutationResult<SetCompanySizeMutation>;
export type SetCompanySizeMutationOptions = Apollo.BaseMutationOptions<SetCompanySizeMutation, SetCompanySizeMutationVariables>;
export const SetProductCategoryToZeroDocument = gql`
    mutation setProductCategoryToZero($productCategorizationId: Int!) {
  setProductCategoryToZero(productCategorizationId: $productCategorizationId) {
    message
    success
  }
}
    `;
export type SetProductCategoryToZeroMutationFn = Apollo.MutationFunction<SetProductCategoryToZeroMutation, SetProductCategoryToZeroMutationVariables>;

/**
 * __useSetProductCategoryToZeroMutation__
 *
 * To run a mutation, you first call `useSetProductCategoryToZeroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProductCategoryToZeroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProductCategoryToZeroMutation, { data, loading, error }] = useSetProductCategoryToZeroMutation({
 *   variables: {
 *      productCategorizationId: // value for 'productCategorizationId'
 *   },
 * });
 */
export function useSetProductCategoryToZeroMutation(baseOptions?: Apollo.MutationHookOptions<SetProductCategoryToZeroMutation, SetProductCategoryToZeroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProductCategoryToZeroMutation, SetProductCategoryToZeroMutationVariables>(SetProductCategoryToZeroDocument, options);
      }
export type SetProductCategoryToZeroMutationHookResult = ReturnType<typeof useSetProductCategoryToZeroMutation>;
export type SetProductCategoryToZeroMutationResult = Apollo.MutationResult<SetProductCategoryToZeroMutation>;
export type SetProductCategoryToZeroMutationOptions = Apollo.BaseMutationOptions<SetProductCategoryToZeroMutation, SetProductCategoryToZeroMutationVariables>;
export const ShortlistBuyAndBuildTargetDocument = gql`
    mutation shortlistBuyAndBuildTarget($softwareCompanyId: Int!, $targetCompanyId: Int!) {
  shortlistBuyAndBuildTarget(
    softwareCompanyId: $softwareCompanyId
    targetCompanyId: $targetCompanyId
  ) {
    ok
  }
}
    `;
export type ShortlistBuyAndBuildTargetMutationFn = Apollo.MutationFunction<ShortlistBuyAndBuildTargetMutation, ShortlistBuyAndBuildTargetMutationVariables>;

/**
 * __useShortlistBuyAndBuildTargetMutation__
 *
 * To run a mutation, you first call `useShortlistBuyAndBuildTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShortlistBuyAndBuildTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shortlistBuyAndBuildTargetMutation, { data, loading, error }] = useShortlistBuyAndBuildTargetMutation({
 *   variables: {
 *      softwareCompanyId: // value for 'softwareCompanyId'
 *      targetCompanyId: // value for 'targetCompanyId'
 *   },
 * });
 */
export function useShortlistBuyAndBuildTargetMutation(baseOptions?: Apollo.MutationHookOptions<ShortlistBuyAndBuildTargetMutation, ShortlistBuyAndBuildTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShortlistBuyAndBuildTargetMutation, ShortlistBuyAndBuildTargetMutationVariables>(ShortlistBuyAndBuildTargetDocument, options);
      }
export type ShortlistBuyAndBuildTargetMutationHookResult = ReturnType<typeof useShortlistBuyAndBuildTargetMutation>;
export type ShortlistBuyAndBuildTargetMutationResult = Apollo.MutationResult<ShortlistBuyAndBuildTargetMutation>;
export type ShortlistBuyAndBuildTargetMutationOptions = Apollo.BaseMutationOptions<ShortlistBuyAndBuildTargetMutation, ShortlistBuyAndBuildTargetMutationVariables>;
export const CreateClassificationPatternDocument = gql`
    mutation CreateClassificationPattern($input: PatternCreateInput!, $createdBy: String) {
  createClassificationPattern(input: $input, createdBy: $createdBy) {
    pattern {
      dbId
      patternText
      patternType
      classificationTarget
      weight
      isActive
      description
    }
    success
    error
  }
}
    `;
export type CreateClassificationPatternMutationFn = Apollo.MutationFunction<CreateClassificationPatternMutation, CreateClassificationPatternMutationVariables>;

/**
 * __useCreateClassificationPatternMutation__
 *
 * To run a mutation, you first call `useCreateClassificationPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassificationPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassificationPatternMutation, { data, loading, error }] = useCreateClassificationPatternMutation({
 *   variables: {
 *      input: // value for 'input'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useCreateClassificationPatternMutation(baseOptions?: Apollo.MutationHookOptions<CreateClassificationPatternMutation, CreateClassificationPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClassificationPatternMutation, CreateClassificationPatternMutationVariables>(CreateClassificationPatternDocument, options);
      }
export type CreateClassificationPatternMutationHookResult = ReturnType<typeof useCreateClassificationPatternMutation>;
export type CreateClassificationPatternMutationResult = Apollo.MutationResult<CreateClassificationPatternMutation>;
export type CreateClassificationPatternMutationOptions = Apollo.BaseMutationOptions<CreateClassificationPatternMutation, CreateClassificationPatternMutationVariables>;
export const UpdateClassificationPatternDocument = gql`
    mutation UpdateClassificationPattern($patternId: Int!, $input: PatternUpdateInput!) {
  updateClassificationPattern(patternId: $patternId, input: $input) {
    pattern {
      dbId
      patternText
      patternType
      classificationTarget
      weight
      isActive
      description
    }
    success
    error
  }
}
    `;
export type UpdateClassificationPatternMutationFn = Apollo.MutationFunction<UpdateClassificationPatternMutation, UpdateClassificationPatternMutationVariables>;

/**
 * __useUpdateClassificationPatternMutation__
 *
 * To run a mutation, you first call `useUpdateClassificationPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassificationPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassificationPatternMutation, { data, loading, error }] = useUpdateClassificationPatternMutation({
 *   variables: {
 *      patternId: // value for 'patternId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassificationPatternMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassificationPatternMutation, UpdateClassificationPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClassificationPatternMutation, UpdateClassificationPatternMutationVariables>(UpdateClassificationPatternDocument, options);
      }
export type UpdateClassificationPatternMutationHookResult = ReturnType<typeof useUpdateClassificationPatternMutation>;
export type UpdateClassificationPatternMutationResult = Apollo.MutationResult<UpdateClassificationPatternMutation>;
export type UpdateClassificationPatternMutationOptions = Apollo.BaseMutationOptions<UpdateClassificationPatternMutation, UpdateClassificationPatternMutationVariables>;
export const DeleteClassificationPatternDocument = gql`
    mutation DeleteClassificationPattern($patternId: Int!) {
  deleteClassificationPattern(patternId: $patternId) {
    success
    error
  }
}
    `;
export type DeleteClassificationPatternMutationFn = Apollo.MutationFunction<DeleteClassificationPatternMutation, DeleteClassificationPatternMutationVariables>;

/**
 * __useDeleteClassificationPatternMutation__
 *
 * To run a mutation, you first call `useDeleteClassificationPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassificationPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassificationPatternMutation, { data, loading, error }] = useDeleteClassificationPatternMutation({
 *   variables: {
 *      patternId: // value for 'patternId'
 *   },
 * });
 */
export function useDeleteClassificationPatternMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClassificationPatternMutation, DeleteClassificationPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClassificationPatternMutation, DeleteClassificationPatternMutationVariables>(DeleteClassificationPatternDocument, options);
      }
export type DeleteClassificationPatternMutationHookResult = ReturnType<typeof useDeleteClassificationPatternMutation>;
export type DeleteClassificationPatternMutationResult = Apollo.MutationResult<DeleteClassificationPatternMutation>;
export type DeleteClassificationPatternMutationOptions = Apollo.BaseMutationOptions<DeleteClassificationPatternMutation, DeleteClassificationPatternMutationVariables>;
export const RecordPatternMatchFeedbackDocument = gql`
    mutation RecordPatternMatchFeedback($patternMatchId: Int!, $wasCorrect: Boolean!, $userFeedback: String) {
  recordPatternMatchFeedback(
    patternMatchId: $patternMatchId
    wasCorrect: $wasCorrect
    userFeedback: $userFeedback
  ) {
    success
    error
  }
}
    `;
export type RecordPatternMatchFeedbackMutationFn = Apollo.MutationFunction<RecordPatternMatchFeedbackMutation, RecordPatternMatchFeedbackMutationVariables>;

/**
 * __useRecordPatternMatchFeedbackMutation__
 *
 * To run a mutation, you first call `useRecordPatternMatchFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPatternMatchFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPatternMatchFeedbackMutation, { data, loading, error }] = useRecordPatternMatchFeedbackMutation({
 *   variables: {
 *      patternMatchId: // value for 'patternMatchId'
 *      wasCorrect: // value for 'wasCorrect'
 *      userFeedback: // value for 'userFeedback'
 *   },
 * });
 */
export function useRecordPatternMatchFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<RecordPatternMatchFeedbackMutation, RecordPatternMatchFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordPatternMatchFeedbackMutation, RecordPatternMatchFeedbackMutationVariables>(RecordPatternMatchFeedbackDocument, options);
      }
export type RecordPatternMatchFeedbackMutationHookResult = ReturnType<typeof useRecordPatternMatchFeedbackMutation>;
export type RecordPatternMatchFeedbackMutationResult = Apollo.MutationResult<RecordPatternMatchFeedbackMutation>;
export type RecordPatternMatchFeedbackMutationOptions = Apollo.BaseMutationOptions<RecordPatternMatchFeedbackMutation, RecordPatternMatchFeedbackMutationVariables>;
export const ActivateProbationaryPatternDocument = gql`
    mutation ActivateProbationaryPattern($patternId: Int!) {
  activateProbationaryPattern(patternId: $patternId) {
    pattern {
      dbId
      patternText
      patternType
      classificationTarget
      weight
      isActive
      isProbationary
      probationMetadata
      description
    }
    success
    error
  }
}
    `;
export type ActivateProbationaryPatternMutationFn = Apollo.MutationFunction<ActivateProbationaryPatternMutation, ActivateProbationaryPatternMutationVariables>;

/**
 * __useActivateProbationaryPatternMutation__
 *
 * To run a mutation, you first call `useActivateProbationaryPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateProbationaryPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateProbationaryPatternMutation, { data, loading, error }] = useActivateProbationaryPatternMutation({
 *   variables: {
 *      patternId: // value for 'patternId'
 *   },
 * });
 */
export function useActivateProbationaryPatternMutation(baseOptions?: Apollo.MutationHookOptions<ActivateProbationaryPatternMutation, ActivateProbationaryPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateProbationaryPatternMutation, ActivateProbationaryPatternMutationVariables>(ActivateProbationaryPatternDocument, options);
      }
export type ActivateProbationaryPatternMutationHookResult = ReturnType<typeof useActivateProbationaryPatternMutation>;
export type ActivateProbationaryPatternMutationResult = Apollo.MutationResult<ActivateProbationaryPatternMutation>;
export type ActivateProbationaryPatternMutationOptions = Apollo.BaseMutationOptions<ActivateProbationaryPatternMutation, ActivateProbationaryPatternMutationVariables>;
export const DeleteProbationaryPatternDocument = gql`
    mutation DeleteProbationaryPattern($patternId: Int!) {
  deleteProbationaryPattern(patternId: $patternId) {
    success
    error
  }
}
    `;
export type DeleteProbationaryPatternMutationFn = Apollo.MutationFunction<DeleteProbationaryPatternMutation, DeleteProbationaryPatternMutationVariables>;

/**
 * __useDeleteProbationaryPatternMutation__
 *
 * To run a mutation, you first call `useDeleteProbationaryPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProbationaryPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProbationaryPatternMutation, { data, loading, error }] = useDeleteProbationaryPatternMutation({
 *   variables: {
 *      patternId: // value for 'patternId'
 *   },
 * });
 */
export function useDeleteProbationaryPatternMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProbationaryPatternMutation, DeleteProbationaryPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProbationaryPatternMutation, DeleteProbationaryPatternMutationVariables>(DeleteProbationaryPatternDocument, options);
      }
export type DeleteProbationaryPatternMutationHookResult = ReturnType<typeof useDeleteProbationaryPatternMutation>;
export type DeleteProbationaryPatternMutationResult = Apollo.MutationResult<DeleteProbationaryPatternMutation>;
export type DeleteProbationaryPatternMutationOptions = Apollo.BaseMutationOptions<DeleteProbationaryPatternMutation, DeleteProbationaryPatternMutationVariables>;
export const TriggerPatternGenerationDocument = gql`
    mutation TriggerPatternGeneration($minOccurrences: Int, $minConsistency: Float, $daysLookback: Int) {
  triggerPatternGeneration(
    minOccurrences: $minOccurrences
    minConsistency: $minConsistency
    daysLookback: $daysLookback
  ) {
    createdCount
    rejectedCount
    errorCount
    success
    message
    createdPatterns
  }
}
    `;
export type TriggerPatternGenerationMutationFn = Apollo.MutationFunction<TriggerPatternGenerationMutation, TriggerPatternGenerationMutationVariables>;

/**
 * __useTriggerPatternGenerationMutation__
 *
 * To run a mutation, you first call `useTriggerPatternGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerPatternGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerPatternGenerationMutation, { data, loading, error }] = useTriggerPatternGenerationMutation({
 *   variables: {
 *      minOccurrences: // value for 'minOccurrences'
 *      minConsistency: // value for 'minConsistency'
 *      daysLookback: // value for 'daysLookback'
 *   },
 * });
 */
export function useTriggerPatternGenerationMutation(baseOptions?: Apollo.MutationHookOptions<TriggerPatternGenerationMutation, TriggerPatternGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerPatternGenerationMutation, TriggerPatternGenerationMutationVariables>(TriggerPatternGenerationDocument, options);
      }
export type TriggerPatternGenerationMutationHookResult = ReturnType<typeof useTriggerPatternGenerationMutation>;
export type TriggerPatternGenerationMutationResult = Apollo.MutationResult<TriggerPatternGenerationMutation>;
export type TriggerPatternGenerationMutationOptions = Apollo.BaseMutationOptions<TriggerPatternGenerationMutation, TriggerPatternGenerationMutationVariables>;
export const TriggerPatternEvaluationDocument = gql`
    mutation TriggerPatternEvaluation {
  triggerPatternEvaluation {
    activatedCount
    deletedCount
    stillProbationaryCount
    success
    message
    activatedPatterns
    deletedPatterns
  }
}
    `;
export type TriggerPatternEvaluationMutationFn = Apollo.MutationFunction<TriggerPatternEvaluationMutation, TriggerPatternEvaluationMutationVariables>;

/**
 * __useTriggerPatternEvaluationMutation__
 *
 * To run a mutation, you first call `useTriggerPatternEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerPatternEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerPatternEvaluationMutation, { data, loading, error }] = useTriggerPatternEvaluationMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerPatternEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<TriggerPatternEvaluationMutation, TriggerPatternEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerPatternEvaluationMutation, TriggerPatternEvaluationMutationVariables>(TriggerPatternEvaluationDocument, options);
      }
export type TriggerPatternEvaluationMutationHookResult = ReturnType<typeof useTriggerPatternEvaluationMutation>;
export type TriggerPatternEvaluationMutationResult = Apollo.MutationResult<TriggerPatternEvaluationMutation>;
export type TriggerPatternEvaluationMutationOptions = Apollo.BaseMutationOptions<TriggerPatternEvaluationMutation, TriggerPatternEvaluationMutationVariables>;
export const StartAiThreatResearchDocument = gql`
    mutation startAIThreatResearch($input: StartResearchInput!) {
  startResearch(input: $input) {
    success
    jobId
    status
    error
  }
}
    `;
export type StartAiThreatResearchMutationFn = Apollo.MutationFunction<StartAiThreatResearchMutation, StartAiThreatResearchMutationVariables>;

/**
 * __useStartAiThreatResearchMutation__
 *
 * To run a mutation, you first call `useStartAiThreatResearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAiThreatResearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAiThreatResearchMutation, { data, loading, error }] = useStartAiThreatResearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAiThreatResearchMutation(baseOptions?: Apollo.MutationHookOptions<StartAiThreatResearchMutation, StartAiThreatResearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAiThreatResearchMutation, StartAiThreatResearchMutationVariables>(StartAiThreatResearchDocument, options);
      }
export type StartAiThreatResearchMutationHookResult = ReturnType<typeof useStartAiThreatResearchMutation>;
export type StartAiThreatResearchMutationResult = Apollo.MutationResult<StartAiThreatResearchMutation>;
export type StartAiThreatResearchMutationOptions = Apollo.BaseMutationOptions<StartAiThreatResearchMutation, StartAiThreatResearchMutationVariables>;
export const StartCddReportDocument = gql`
    mutation StartCddReport($input: StartCDDAnalysisInput!) {
  startCddAnalysis(input: $input) {
    jobId
    status
  }
}
    `;
export type StartCddReportMutationFn = Apollo.MutationFunction<StartCddReportMutation, StartCddReportMutationVariables>;

/**
 * __useStartCddReportMutation__
 *
 * To run a mutation, you first call `useStartCddReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCddReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCddReportMutation, { data, loading, error }] = useStartCddReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartCddReportMutation(baseOptions?: Apollo.MutationHookOptions<StartCddReportMutation, StartCddReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCddReportMutation, StartCddReportMutationVariables>(StartCddReportDocument, options);
      }
export type StartCddReportMutationHookResult = ReturnType<typeof useStartCddReportMutation>;
export type StartCddReportMutationResult = Apollo.MutationResult<StartCddReportMutation>;
export type StartCddReportMutationOptions = Apollo.BaseMutationOptions<StartCddReportMutation, StartCddReportMutationVariables>;
export const StartCrawlDocument = gql`
    mutation startCrawl($companyAddress: String, $companyName: String, $domain: String!, $forceDeepAnalysis: Boolean, $forceSw: Boolean, $pipedriveId: Int) {
  startCrawler(
    companyAddress: $companyAddress
    companyName: $companyName
    domain: $domain
    forceDeepAnalysis: $forceDeepAnalysis
    forceSw: $forceSw
    pipedriveId: $pipedriveId
  ) {
    success
  }
}
    `;
export type StartCrawlMutationFn = Apollo.MutationFunction<StartCrawlMutation, StartCrawlMutationVariables>;

/**
 * __useStartCrawlMutation__
 *
 * To run a mutation, you first call `useStartCrawlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCrawlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCrawlMutation, { data, loading, error }] = useStartCrawlMutation({
 *   variables: {
 *      companyAddress: // value for 'companyAddress'
 *      companyName: // value for 'companyName'
 *      domain: // value for 'domain'
 *      forceDeepAnalysis: // value for 'forceDeepAnalysis'
 *      forceSw: // value for 'forceSw'
 *      pipedriveId: // value for 'pipedriveId'
 *   },
 * });
 */
export function useStartCrawlMutation(baseOptions?: Apollo.MutationHookOptions<StartCrawlMutation, StartCrawlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCrawlMutation, StartCrawlMutationVariables>(StartCrawlDocument, options);
      }
export type StartCrawlMutationHookResult = ReturnType<typeof useStartCrawlMutation>;
export type StartCrawlMutationResult = Apollo.MutationResult<StartCrawlMutation>;
export type StartCrawlMutationOptions = Apollo.BaseMutationOptions<StartCrawlMutation, StartCrawlMutationVariables>;
export const StartVerificationSessionDocument = gql`
    mutation startVerificationSession($companyId: Int!, $authId: String!) {
  startCompanyVerificationSession(companyId: $companyId, authId: $authId) {
    success
    message
  }
}
    `;
export type StartVerificationSessionMutationFn = Apollo.MutationFunction<StartVerificationSessionMutation, StartVerificationSessionMutationVariables>;

/**
 * __useStartVerificationSessionMutation__
 *
 * To run a mutation, you first call `useStartVerificationSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartVerificationSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startVerificationSessionMutation, { data, loading, error }] = useStartVerificationSessionMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      authId: // value for 'authId'
 *   },
 * });
 */
export function useStartVerificationSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartVerificationSessionMutation, StartVerificationSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartVerificationSessionMutation, StartVerificationSessionMutationVariables>(StartVerificationSessionDocument, options);
      }
export type StartVerificationSessionMutationHookResult = ReturnType<typeof useStartVerificationSessionMutation>;
export type StartVerificationSessionMutationResult = Apollo.MutationResult<StartVerificationSessionMutation>;
export type StartVerificationSessionMutationOptions = Apollo.BaseMutationOptions<StartVerificationSessionMutation, StartVerificationSessionMutationVariables>;
export const SubmitSurveyResponseDocument = gql`
    mutation submitSurveyResponse($meetingId: Int!, $answers: JSONString!) {
  submitSurveyResponse(meetingId: $meetingId, answers: $answers) {
    ok
    surveyResponse {
      id
      datetimeCreated
    }
    error
  }
}
    `;
export type SubmitSurveyResponseMutationFn = Apollo.MutationFunction<SubmitSurveyResponseMutation, SubmitSurveyResponseMutationVariables>;

/**
 * __useSubmitSurveyResponseMutation__
 *
 * To run a mutation, you first call `useSubmitSurveyResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSurveyResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSurveyResponseMutation, { data, loading, error }] = useSubmitSurveyResponseMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useSubmitSurveyResponseMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSurveyResponseMutation, SubmitSurveyResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSurveyResponseMutation, SubmitSurveyResponseMutationVariables>(SubmitSurveyResponseDocument, options);
      }
export type SubmitSurveyResponseMutationHookResult = ReturnType<typeof useSubmitSurveyResponseMutation>;
export type SubmitSurveyResponseMutationResult = Apollo.MutationResult<SubmitSurveyResponseMutation>;
export type SubmitSurveyResponseMutationOptions = Apollo.BaseMutationOptions<SubmitSurveyResponseMutation, SubmitSurveyResponseMutationVariables>;
export const TransferBuyAndBuildTargetsToPipedriveDocument = gql`
    mutation transferBuyAndBuildTargetsToPipedrive($softwareCompanyId: Int!) {
  transferBuyAndBuildTargetsToPipedrive(softwareCompanyId: $softwareCompanyId) {
    ok
  }
}
    `;
export type TransferBuyAndBuildTargetsToPipedriveMutationFn = Apollo.MutationFunction<TransferBuyAndBuildTargetsToPipedriveMutation, TransferBuyAndBuildTargetsToPipedriveMutationVariables>;

/**
 * __useTransferBuyAndBuildTargetsToPipedriveMutation__
 *
 * To run a mutation, you first call `useTransferBuyAndBuildTargetsToPipedriveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferBuyAndBuildTargetsToPipedriveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferBuyAndBuildTargetsToPipedriveMutation, { data, loading, error }] = useTransferBuyAndBuildTargetsToPipedriveMutation({
 *   variables: {
 *      softwareCompanyId: // value for 'softwareCompanyId'
 *   },
 * });
 */
export function useTransferBuyAndBuildTargetsToPipedriveMutation(baseOptions?: Apollo.MutationHookOptions<TransferBuyAndBuildTargetsToPipedriveMutation, TransferBuyAndBuildTargetsToPipedriveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferBuyAndBuildTargetsToPipedriveMutation, TransferBuyAndBuildTargetsToPipedriveMutationVariables>(TransferBuyAndBuildTargetsToPipedriveDocument, options);
      }
export type TransferBuyAndBuildTargetsToPipedriveMutationHookResult = ReturnType<typeof useTransferBuyAndBuildTargetsToPipedriveMutation>;
export type TransferBuyAndBuildTargetsToPipedriveMutationResult = Apollo.MutationResult<TransferBuyAndBuildTargetsToPipedriveMutation>;
export type TransferBuyAndBuildTargetsToPipedriveMutationOptions = Apollo.BaseMutationOptions<TransferBuyAndBuildTargetsToPipedriveMutation, TransferBuyAndBuildTargetsToPipedriveMutationVariables>;
export const TransferXoviKeywordToCoreKeywordsDocument = gql`
    mutation transferXoviKeywordToCoreKeywords($companyId: Int!, $xoviKeywordId: Int!) {
  transferXoviKeywordToCoreKeywords(
    companyId: $companyId
    xoviKeywordId: $xoviKeywordId
  ) {
    success
    message
    coreKeywordId
  }
}
    `;
export type TransferXoviKeywordToCoreKeywordsMutationFn = Apollo.MutationFunction<TransferXoviKeywordToCoreKeywordsMutation, TransferXoviKeywordToCoreKeywordsMutationVariables>;

/**
 * __useTransferXoviKeywordToCoreKeywordsMutation__
 *
 * To run a mutation, you first call `useTransferXoviKeywordToCoreKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferXoviKeywordToCoreKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferXoviKeywordToCoreKeywordsMutation, { data, loading, error }] = useTransferXoviKeywordToCoreKeywordsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      xoviKeywordId: // value for 'xoviKeywordId'
 *   },
 * });
 */
export function useTransferXoviKeywordToCoreKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<TransferXoviKeywordToCoreKeywordsMutation, TransferXoviKeywordToCoreKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferXoviKeywordToCoreKeywordsMutation, TransferXoviKeywordToCoreKeywordsMutationVariables>(TransferXoviKeywordToCoreKeywordsDocument, options);
      }
export type TransferXoviKeywordToCoreKeywordsMutationHookResult = ReturnType<typeof useTransferXoviKeywordToCoreKeywordsMutation>;
export type TransferXoviKeywordToCoreKeywordsMutationResult = Apollo.MutationResult<TransferXoviKeywordToCoreKeywordsMutation>;
export type TransferXoviKeywordToCoreKeywordsMutationOptions = Apollo.BaseMutationOptions<TransferXoviKeywordToCoreKeywordsMutation, TransferXoviKeywordToCoreKeywordsMutationVariables>;
export const TriggerScheduledAiValidationDocument = gql`
    mutation TriggerScheduledAIValidation($forceRefreshView: Boolean) {
  triggerScheduledAiValidation(forceRefreshView: $forceRefreshView) {
    success
    message
    totalQueued
    byInbox
    taskId
  }
}
    `;
export type TriggerScheduledAiValidationMutationFn = Apollo.MutationFunction<TriggerScheduledAiValidationMutation, TriggerScheduledAiValidationMutationVariables>;

/**
 * __useTriggerScheduledAiValidationMutation__
 *
 * To run a mutation, you first call `useTriggerScheduledAiValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduledAiValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerScheduledAiValidationMutation, { data, loading, error }] = useTriggerScheduledAiValidationMutation({
 *   variables: {
 *      forceRefreshView: // value for 'forceRefreshView'
 *   },
 * });
 */
export function useTriggerScheduledAiValidationMutation(baseOptions?: Apollo.MutationHookOptions<TriggerScheduledAiValidationMutation, TriggerScheduledAiValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerScheduledAiValidationMutation, TriggerScheduledAiValidationMutationVariables>(TriggerScheduledAiValidationDocument, options);
      }
export type TriggerScheduledAiValidationMutationHookResult = ReturnType<typeof useTriggerScheduledAiValidationMutation>;
export type TriggerScheduledAiValidationMutationResult = Apollo.MutationResult<TriggerScheduledAiValidationMutation>;
export type TriggerScheduledAiValidationMutationOptions = Apollo.BaseMutationOptions<TriggerScheduledAiValidationMutation, TriggerScheduledAiValidationMutationVariables>;
export const UnlockCrawlQueueEntriesDocument = gql`
    mutation unlockCrawlQueueEntries($ids: [Int]!) {
  unlockCrawlQueueEntries(ids: $ids) {
    ok
    updatedCount
  }
}
    `;
export type UnlockCrawlQueueEntriesMutationFn = Apollo.MutationFunction<UnlockCrawlQueueEntriesMutation, UnlockCrawlQueueEntriesMutationVariables>;

/**
 * __useUnlockCrawlQueueEntriesMutation__
 *
 * To run a mutation, you first call `useUnlockCrawlQueueEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockCrawlQueueEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockCrawlQueueEntriesMutation, { data, loading, error }] = useUnlockCrawlQueueEntriesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnlockCrawlQueueEntriesMutation(baseOptions?: Apollo.MutationHookOptions<UnlockCrawlQueueEntriesMutation, UnlockCrawlQueueEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockCrawlQueueEntriesMutation, UnlockCrawlQueueEntriesMutationVariables>(UnlockCrawlQueueEntriesDocument, options);
      }
export type UnlockCrawlQueueEntriesMutationHookResult = ReturnType<typeof useUnlockCrawlQueueEntriesMutation>;
export type UnlockCrawlQueueEntriesMutationResult = Apollo.MutationResult<UnlockCrawlQueueEntriesMutation>;
export type UnlockCrawlQueueEntriesMutationOptions = Apollo.BaseMutationOptions<UnlockCrawlQueueEntriesMutation, UnlockCrawlQueueEntriesMutationVariables>;
export const UpdateCompanyGoogleDriveConfigDocument = gql`
    mutation updateCompanyGoogleDriveConfig($companyId: Int!, $gdriveSharedDriveName: String, $gdriveDirectoryName: String) {
  updateCompanyGoogleDriveConfig(
    companyId: $companyId
    gdriveSharedDriveName: $gdriveSharedDriveName
    gdriveDirectoryName: $gdriveDirectoryName
  ) {
    success
    message
  }
}
    `;
export type UpdateCompanyGoogleDriveConfigMutationFn = Apollo.MutationFunction<UpdateCompanyGoogleDriveConfigMutation, UpdateCompanyGoogleDriveConfigMutationVariables>;

/**
 * __useUpdateCompanyGoogleDriveConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyGoogleDriveConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyGoogleDriveConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyGoogleDriveConfigMutation, { data, loading, error }] = useUpdateCompanyGoogleDriveConfigMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      gdriveSharedDriveName: // value for 'gdriveSharedDriveName'
 *      gdriveDirectoryName: // value for 'gdriveDirectoryName'
 *   },
 * });
 */
export function useUpdateCompanyGoogleDriveConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyGoogleDriveConfigMutation, UpdateCompanyGoogleDriveConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyGoogleDriveConfigMutation, UpdateCompanyGoogleDriveConfigMutationVariables>(UpdateCompanyGoogleDriveConfigDocument, options);
      }
export type UpdateCompanyGoogleDriveConfigMutationHookResult = ReturnType<typeof useUpdateCompanyGoogleDriveConfigMutation>;
export type UpdateCompanyGoogleDriveConfigMutationResult = Apollo.MutationResult<UpdateCompanyGoogleDriveConfigMutation>;
export type UpdateCompanyGoogleDriveConfigMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyGoogleDriveConfigMutation, UpdateCompanyGoogleDriveConfigMutationVariables>;
export const UpdateCompanyProductDocument = gql`
    mutation UpdateCompanyProduct($productId: Int!, $productName: String, $description: String, $productType: String) {
  updateCompanyProduct(
    productId: $productId
    productName: $productName
    description: $description
    productType: $productType
  ) {
    success
    message
  }
}
    `;
export type UpdateCompanyProductMutationFn = Apollo.MutationFunction<UpdateCompanyProductMutation, UpdateCompanyProductMutationVariables>;

/**
 * __useUpdateCompanyProductMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyProductMutation, { data, loading, error }] = useUpdateCompanyProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      productName: // value for 'productName'
 *      description: // value for 'description'
 *      productType: // value for 'productType'
 *   },
 * });
 */
export function useUpdateCompanyProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyProductMutation, UpdateCompanyProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyProductMutation, UpdateCompanyProductMutationVariables>(UpdateCompanyProductDocument, options);
      }
export type UpdateCompanyProductMutationHookResult = ReturnType<typeof useUpdateCompanyProductMutation>;
export type UpdateCompanyProductMutationResult = Apollo.MutationResult<UpdateCompanyProductMutation>;
export type UpdateCompanyProductMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyProductMutation, UpdateCompanyProductMutationVariables>;
export const UpdateCortexConfigDocument = gql`
    mutation UpdateCortexConfig($attributes: JSONString!) {
  updateCortexConfig(attributes: $attributes) {
    ok
  }
}
    `;
export type UpdateCortexConfigMutationFn = Apollo.MutationFunction<UpdateCortexConfigMutation, UpdateCortexConfigMutationVariables>;

/**
 * __useUpdateCortexConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCortexConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCortexConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCortexConfigMutation, { data, loading, error }] = useUpdateCortexConfigMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateCortexConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCortexConfigMutation, UpdateCortexConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCortexConfigMutation, UpdateCortexConfigMutationVariables>(UpdateCortexConfigDocument, options);
      }
export type UpdateCortexConfigMutationHookResult = ReturnType<typeof useUpdateCortexConfigMutation>;
export type UpdateCortexConfigMutationResult = Apollo.MutationResult<UpdateCortexConfigMutation>;
export type UpdateCortexConfigMutationOptions = Apollo.BaseMutationOptions<UpdateCortexConfigMutation, UpdateCortexConfigMutationVariables>;
export const UpdateCrawlQueueConfigDocument = gql`
    mutation updateCrawlQueueConfig($enabled: Boolean, $batchSize: Int, $intervalSeconds: Int) {
  updateCrawlQueueConfig(
    enabled: $enabled
    batchSize: $batchSize
    intervalSeconds: $intervalSeconds
  ) {
    ok
  }
}
    `;
export type UpdateCrawlQueueConfigMutationFn = Apollo.MutationFunction<UpdateCrawlQueueConfigMutation, UpdateCrawlQueueConfigMutationVariables>;

/**
 * __useUpdateCrawlQueueConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCrawlQueueConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrawlQueueConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrawlQueueConfigMutation, { data, loading, error }] = useUpdateCrawlQueueConfigMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      batchSize: // value for 'batchSize'
 *      intervalSeconds: // value for 'intervalSeconds'
 *   },
 * });
 */
export function useUpdateCrawlQueueConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrawlQueueConfigMutation, UpdateCrawlQueueConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCrawlQueueConfigMutation, UpdateCrawlQueueConfigMutationVariables>(UpdateCrawlQueueConfigDocument, options);
      }
export type UpdateCrawlQueueConfigMutationHookResult = ReturnType<typeof useUpdateCrawlQueueConfigMutation>;
export type UpdateCrawlQueueConfigMutationResult = Apollo.MutationResult<UpdateCrawlQueueConfigMutation>;
export type UpdateCrawlQueueConfigMutationOptions = Apollo.BaseMutationOptions<UpdateCrawlQueueConfigMutation, UpdateCrawlQueueConfigMutationVariables>;
export const UpdateSegmentForCustomerDocument = gql`
    mutation updateSegmentForCustomer($input: CustomerSegmentInput!, $segmentId: Int!) {
  updateCustomerSegment(input: $input, segmentId: $segmentId) {
    success
  }
}
    `;
export type UpdateSegmentForCustomerMutationFn = Apollo.MutationFunction<UpdateSegmentForCustomerMutation, UpdateSegmentForCustomerMutationVariables>;

/**
 * __useUpdateSegmentForCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentForCustomerMutation, { data, loading, error }] = useUpdateSegmentForCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useUpdateSegmentForCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSegmentForCustomerMutation, UpdateSegmentForCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSegmentForCustomerMutation, UpdateSegmentForCustomerMutationVariables>(UpdateSegmentForCustomerDocument, options);
      }
export type UpdateSegmentForCustomerMutationHookResult = ReturnType<typeof useUpdateSegmentForCustomerMutation>;
export type UpdateSegmentForCustomerMutationResult = Apollo.MutationResult<UpdateSegmentForCustomerMutation>;
export type UpdateSegmentForCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateSegmentForCustomerMutation, UpdateSegmentForCustomerMutationVariables>;
export const UpdateProductPricingDocument = gql`
    mutation UpdateProductPricing($productId: Int!, $pricing: [PricingTierInput]!) {
  updateProductPricing(productId: $productId, pricing: $pricing) {
    success
    message
  }
}
    `;
export type UpdateProductPricingMutationFn = Apollo.MutationFunction<UpdateProductPricingMutation, UpdateProductPricingMutationVariables>;

/**
 * __useUpdateProductPricingMutation__
 *
 * To run a mutation, you first call `useUpdateProductPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductPricingMutation, { data, loading, error }] = useUpdateProductPricingMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      pricing: // value for 'pricing'
 *   },
 * });
 */
export function useUpdateProductPricingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductPricingMutation, UpdateProductPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductPricingMutation, UpdateProductPricingMutationVariables>(UpdateProductPricingDocument, options);
      }
export type UpdateProductPricingMutationHookResult = ReturnType<typeof useUpdateProductPricingMutation>;
export type UpdateProductPricingMutationResult = Apollo.MutationResult<UpdateProductPricingMutation>;
export type UpdateProductPricingMutationOptions = Apollo.BaseMutationOptions<UpdateProductPricingMutation, UpdateProductPricingMutationVariables>;
export const UpdateRedbeatScheduleDocument = gql`
    mutation updateRedbeatSchedule($name: String!, $task: String, $scheduleType: String, $intervalSeconds: Float, $crontabMinute: String, $crontabHour: String, $crontabDayOfWeek: String, $crontabDayOfMonth: String, $queue: String, $kwargs: JSONString, $enabled: Boolean) {
  updateRedbeatSchedule(
    name: $name
    task: $task
    scheduleType: $scheduleType
    intervalSeconds: $intervalSeconds
    crontabMinute: $crontabMinute
    crontabHour: $crontabHour
    crontabDayOfWeek: $crontabDayOfWeek
    crontabDayOfMonth: $crontabDayOfMonth
    queue: $queue
    kwargs: $kwargs
    enabled: $enabled
  ) {
    ok
  }
}
    `;
export type UpdateRedbeatScheduleMutationFn = Apollo.MutationFunction<UpdateRedbeatScheduleMutation, UpdateRedbeatScheduleMutationVariables>;

/**
 * __useUpdateRedbeatScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateRedbeatScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRedbeatScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRedbeatScheduleMutation, { data, loading, error }] = useUpdateRedbeatScheduleMutation({
 *   variables: {
 *      name: // value for 'name'
 *      task: // value for 'task'
 *      scheduleType: // value for 'scheduleType'
 *      intervalSeconds: // value for 'intervalSeconds'
 *      crontabMinute: // value for 'crontabMinute'
 *      crontabHour: // value for 'crontabHour'
 *      crontabDayOfWeek: // value for 'crontabDayOfWeek'
 *      crontabDayOfMonth: // value for 'crontabDayOfMonth'
 *      queue: // value for 'queue'
 *      kwargs: // value for 'kwargs'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateRedbeatScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRedbeatScheduleMutation, UpdateRedbeatScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRedbeatScheduleMutation, UpdateRedbeatScheduleMutationVariables>(UpdateRedbeatScheduleDocument, options);
      }
export type UpdateRedbeatScheduleMutationHookResult = ReturnType<typeof useUpdateRedbeatScheduleMutation>;
export type UpdateRedbeatScheduleMutationResult = Apollo.MutationResult<UpdateRedbeatScheduleMutation>;
export type UpdateRedbeatScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateRedbeatScheduleMutation, UpdateRedbeatScheduleMutationVariables>;
export const UpdateVibeCodingIdeaDocument = gql`
    mutation updateVibeCodingIdea($id: Int!, $isBookmarked: Boolean, $userRating: Int, $userNotes: String, $status: String) {
  updateVibeCodingIdea(
    id: $id
    isBookmarked: $isBookmarked
    userRating: $userRating
    userNotes: $userNotes
    status: $status
  ) {
    success
    message
  }
}
    `;
export type UpdateVibeCodingIdeaMutationFn = Apollo.MutationFunction<UpdateVibeCodingIdeaMutation, UpdateVibeCodingIdeaMutationVariables>;

/**
 * __useUpdateVibeCodingIdeaMutation__
 *
 * To run a mutation, you first call `useUpdateVibeCodingIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVibeCodingIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVibeCodingIdeaMutation, { data, loading, error }] = useUpdateVibeCodingIdeaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isBookmarked: // value for 'isBookmarked'
 *      userRating: // value for 'userRating'
 *      userNotes: // value for 'userNotes'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateVibeCodingIdeaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVibeCodingIdeaMutation, UpdateVibeCodingIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVibeCodingIdeaMutation, UpdateVibeCodingIdeaMutationVariables>(UpdateVibeCodingIdeaDocument, options);
      }
export type UpdateVibeCodingIdeaMutationHookResult = ReturnType<typeof useUpdateVibeCodingIdeaMutation>;
export type UpdateVibeCodingIdeaMutationResult = Apollo.MutationResult<UpdateVibeCodingIdeaMutation>;
export type UpdateVibeCodingIdeaMutationOptions = Apollo.BaseMutationOptions<UpdateVibeCodingIdeaMutation, UpdateVibeCodingIdeaMutationVariables>;
export const UploadFileDocument = gql`
    mutation uploadFile($companyId: Int!, $file: String!, $fileName: String!, $isBmFile: Boolean!) {
  uploadFile(
    companyId: $companyId
    file: $file
    fileName: $fileName
    isBmFile: $isBmFile
  ) {
    url
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      file: // value for 'file'
 *      fileName: // value for 'fileName'
 *      isBmFile: // value for 'isBmFile'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const UploadIndustryBenchmarkDataDocument = gql`
    mutation UploadIndustryBenchmarkData($data: [IndustryBenchmarkInput!]!) {
  uploadIndustryBenchmarkData(data: $data) {
    success
    count
    errors
  }
}
    `;
export type UploadIndustryBenchmarkDataMutationFn = Apollo.MutationFunction<UploadIndustryBenchmarkDataMutation, UploadIndustryBenchmarkDataMutationVariables>;

/**
 * __useUploadIndustryBenchmarkDataMutation__
 *
 * To run a mutation, you first call `useUploadIndustryBenchmarkDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadIndustryBenchmarkDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadIndustryBenchmarkDataMutation, { data, loading, error }] = useUploadIndustryBenchmarkDataMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadIndustryBenchmarkDataMutation(baseOptions?: Apollo.MutationHookOptions<UploadIndustryBenchmarkDataMutation, UploadIndustryBenchmarkDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadIndustryBenchmarkDataMutation, UploadIndustryBenchmarkDataMutationVariables>(UploadIndustryBenchmarkDataDocument, options);
      }
export type UploadIndustryBenchmarkDataMutationHookResult = ReturnType<typeof useUploadIndustryBenchmarkDataMutation>;
export type UploadIndustryBenchmarkDataMutationResult = Apollo.MutationResult<UploadIndustryBenchmarkDataMutation>;
export type UploadIndustryBenchmarkDataMutationOptions = Apollo.BaseMutationOptions<UploadIndustryBenchmarkDataMutation, UploadIndustryBenchmarkDataMutationVariables>;
export const UpvoteFindingsTokenDocument = gql`
    mutation upvoteFindingsToken($tokenId: Int!) {
  upvoteFindingsToken(tokenId: $tokenId) {
    ok
    token {
      id
    }
  }
}
    `;
export type UpvoteFindingsTokenMutationFn = Apollo.MutationFunction<UpvoteFindingsTokenMutation, UpvoteFindingsTokenMutationVariables>;

/**
 * __useUpvoteFindingsTokenMutation__
 *
 * To run a mutation, you first call `useUpvoteFindingsTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpvoteFindingsTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upvoteFindingsTokenMutation, { data, loading, error }] = useUpvoteFindingsTokenMutation({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useUpvoteFindingsTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpvoteFindingsTokenMutation, UpvoteFindingsTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpvoteFindingsTokenMutation, UpvoteFindingsTokenMutationVariables>(UpvoteFindingsTokenDocument, options);
      }
export type UpvoteFindingsTokenMutationHookResult = ReturnType<typeof useUpvoteFindingsTokenMutation>;
export type UpvoteFindingsTokenMutationResult = Apollo.MutationResult<UpvoteFindingsTokenMutation>;
export type UpvoteFindingsTokenMutationOptions = Apollo.BaseMutationOptions<UpvoteFindingsTokenMutation, UpvoteFindingsTokenMutationVariables>;
export const ValidateCompanyWithRagDocument = gql`
    mutation ValidateCompanyWithRag($companyDomain: String!, $shadowMode: Boolean) {
  validateCompanyWithRag(companyDomain: $companyDomain, shadowMode: $shadowMode) {
    success
    message
    taskChainId
    jobId
  }
}
    `;
export type ValidateCompanyWithRagMutationFn = Apollo.MutationFunction<ValidateCompanyWithRagMutation, ValidateCompanyWithRagMutationVariables>;

/**
 * __useValidateCompanyWithRagMutation__
 *
 * To run a mutation, you first call `useValidateCompanyWithRagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCompanyWithRagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCompanyWithRagMutation, { data, loading, error }] = useValidateCompanyWithRagMutation({
 *   variables: {
 *      companyDomain: // value for 'companyDomain'
 *      shadowMode: // value for 'shadowMode'
 *   },
 * });
 */
export function useValidateCompanyWithRagMutation(baseOptions?: Apollo.MutationHookOptions<ValidateCompanyWithRagMutation, ValidateCompanyWithRagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateCompanyWithRagMutation, ValidateCompanyWithRagMutationVariables>(ValidateCompanyWithRagDocument, options);
      }
export type ValidateCompanyWithRagMutationHookResult = ReturnType<typeof useValidateCompanyWithRagMutation>;
export type ValidateCompanyWithRagMutationResult = Apollo.MutationResult<ValidateCompanyWithRagMutation>;
export type ValidateCompanyWithRagMutationOptions = Apollo.BaseMutationOptions<ValidateCompanyWithRagMutation, ValidateCompanyWithRagMutationVariables>;
export const VerifyCompanyCertificationDocument = gql`
    mutation verifyCompanyCertification($id: Int!, $isVerified: Boolean!) {
  verifyCompanyCertification(id: $id, isVerified: $isVerified) {
    success
    message
  }
}
    `;
export type VerifyCompanyCertificationMutationFn = Apollo.MutationFunction<VerifyCompanyCertificationMutation, VerifyCompanyCertificationMutationVariables>;

/**
 * __useVerifyCompanyCertificationMutation__
 *
 * To run a mutation, you first call `useVerifyCompanyCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCompanyCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCompanyCertificationMutation, { data, loading, error }] = useVerifyCompanyCertificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isVerified: // value for 'isVerified'
 *   },
 * });
 */
export function useVerifyCompanyCertificationMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCompanyCertificationMutation, VerifyCompanyCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCompanyCertificationMutation, VerifyCompanyCertificationMutationVariables>(VerifyCompanyCertificationDocument, options);
      }
export type VerifyCompanyCertificationMutationHookResult = ReturnType<typeof useVerifyCompanyCertificationMutation>;
export type VerifyCompanyCertificationMutationResult = Apollo.MutationResult<VerifyCompanyCertificationMutation>;
export type VerifyCompanyCertificationMutationOptions = Apollo.BaseMutationOptions<VerifyCompanyCertificationMutation, VerifyCompanyCertificationMutationVariables>;
export const GetCertificationsDocument = gql`
    query GetCertifications($search: String, $domain: String) {
  certifications(search: $search, domain: $domain) {
    dbId
    name
    issuer
    domain
    level
    aiMoatLevel
    description
  }
}
    `;

/**
 * __useGetCertificationsQuery__
 *
 * To run a query within a React component, call `useGetCertificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetCertificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetCertificationsQuery, GetCertificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCertificationsQuery, GetCertificationsQueryVariables>(GetCertificationsDocument, options);
      }
export function useGetCertificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCertificationsQuery, GetCertificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCertificationsQuery, GetCertificationsQueryVariables>(GetCertificationsDocument, options);
        }
export function useGetCertificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCertificationsQuery, GetCertificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCertificationsQuery, GetCertificationsQueryVariables>(GetCertificationsDocument, options);
        }
export type GetCertificationsQueryHookResult = ReturnType<typeof useGetCertificationsQuery>;
export type GetCertificationsLazyQueryHookResult = ReturnType<typeof useGetCertificationsLazyQuery>;
export type GetCertificationsSuspenseQueryHookResult = ReturnType<typeof useGetCertificationsSuspenseQuery>;
export type GetCertificationsQueryResult = Apollo.QueryResult<GetCertificationsQuery, GetCertificationsQueryVariables>;
export const GetSoftwareCategoryAiScoresDocument = gql`
    query GetSoftwareCategoryAiScores($search: String, $scoredOnly: Boolean, $sortBy: String, $limit: Int, $offset: Int) {
  softwareCategoryAiScores(
    search: $search
    scoredOnly: $scoredOnly
    sortBy: $sortBy
    limit: $limit
    offset: $offset
  ) {
    categoryId
    categoryName
    taxonomyPath
    hasScore
    disruptionRisk
    aiOpportunity
    compositeScore
    rationale
    scoringVersion
    dimensionScores
    dimensionReasoning
  }
}
    `;

/**
 * __useGetSoftwareCategoryAiScoresQuery__
 *
 * To run a query within a React component, call `useGetSoftwareCategoryAiScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSoftwareCategoryAiScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSoftwareCategoryAiScoresQuery({
 *   variables: {
 *      search: // value for 'search'
 *      scoredOnly: // value for 'scoredOnly'
 *      sortBy: // value for 'sortBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSoftwareCategoryAiScoresQuery(baseOptions?: Apollo.QueryHookOptions<GetSoftwareCategoryAiScoresQuery, GetSoftwareCategoryAiScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSoftwareCategoryAiScoresQuery, GetSoftwareCategoryAiScoresQueryVariables>(GetSoftwareCategoryAiScoresDocument, options);
      }
export function useGetSoftwareCategoryAiScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSoftwareCategoryAiScoresQuery, GetSoftwareCategoryAiScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSoftwareCategoryAiScoresQuery, GetSoftwareCategoryAiScoresQueryVariables>(GetSoftwareCategoryAiScoresDocument, options);
        }
export function useGetSoftwareCategoryAiScoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSoftwareCategoryAiScoresQuery, GetSoftwareCategoryAiScoresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSoftwareCategoryAiScoresQuery, GetSoftwareCategoryAiScoresQueryVariables>(GetSoftwareCategoryAiScoresDocument, options);
        }
export type GetSoftwareCategoryAiScoresQueryHookResult = ReturnType<typeof useGetSoftwareCategoryAiScoresQuery>;
export type GetSoftwareCategoryAiScoresLazyQueryHookResult = ReturnType<typeof useGetSoftwareCategoryAiScoresLazyQuery>;
export type GetSoftwareCategoryAiScoresSuspenseQueryHookResult = ReturnType<typeof useGetSoftwareCategoryAiScoresSuspenseQuery>;
export type GetSoftwareCategoryAiScoresQueryResult = Apollo.QueryResult<GetSoftwareCategoryAiScoresQuery, GetSoftwareCategoryAiScoresQueryVariables>;
export const GetAiRiskFactorsDocument = gql`
    query GetAiRiskFactors {
  aiRiskFactors {
    id
    name
    column
    weight
    description
    signals
    rubricHigh
    rubricMedium
    rubricLow
    relevance
    aiErosionRisk
    aiErosionNote
    examples
  }
}
    `;

/**
 * __useGetAiRiskFactorsQuery__
 *
 * To run a query within a React component, call `useGetAiRiskFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiRiskFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiRiskFactorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiRiskFactorsQuery(baseOptions?: Apollo.QueryHookOptions<GetAiRiskFactorsQuery, GetAiRiskFactorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiRiskFactorsQuery, GetAiRiskFactorsQueryVariables>(GetAiRiskFactorsDocument, options);
      }
export function useGetAiRiskFactorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiRiskFactorsQuery, GetAiRiskFactorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiRiskFactorsQuery, GetAiRiskFactorsQueryVariables>(GetAiRiskFactorsDocument, options);
        }
export function useGetAiRiskFactorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiRiskFactorsQuery, GetAiRiskFactorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiRiskFactorsQuery, GetAiRiskFactorsQueryVariables>(GetAiRiskFactorsDocument, options);
        }
export type GetAiRiskFactorsQueryHookResult = ReturnType<typeof useGetAiRiskFactorsQuery>;
export type GetAiRiskFactorsLazyQueryHookResult = ReturnType<typeof useGetAiRiskFactorsLazyQuery>;
export type GetAiRiskFactorsSuspenseQueryHookResult = ReturnType<typeof useGetAiRiskFactorsSuspenseQuery>;
export type GetAiRiskFactorsQueryResult = Apollo.QueryResult<GetAiRiskFactorsQuery, GetAiRiskFactorsQueryVariables>;
export const GetAiOpportunityFactorsDocument = gql`
    query GetAiOpportunityFactors {
  aiOpportunityFactors {
    id
    name
    column
    weight
    description
    signals
    rubricHigh
    rubricMedium
    rubricLow
    relevance
    examples
  }
}
    `;

/**
 * __useGetAiOpportunityFactorsQuery__
 *
 * To run a query within a React component, call `useGetAiOpportunityFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiOpportunityFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiOpportunityFactorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiOpportunityFactorsQuery(baseOptions?: Apollo.QueryHookOptions<GetAiOpportunityFactorsQuery, GetAiOpportunityFactorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiOpportunityFactorsQuery, GetAiOpportunityFactorsQueryVariables>(GetAiOpportunityFactorsDocument, options);
      }
export function useGetAiOpportunityFactorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiOpportunityFactorsQuery, GetAiOpportunityFactorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiOpportunityFactorsQuery, GetAiOpportunityFactorsQueryVariables>(GetAiOpportunityFactorsDocument, options);
        }
export function useGetAiOpportunityFactorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiOpportunityFactorsQuery, GetAiOpportunityFactorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiOpportunityFactorsQuery, GetAiOpportunityFactorsQueryVariables>(GetAiOpportunityFactorsDocument, options);
        }
export type GetAiOpportunityFactorsQueryHookResult = ReturnType<typeof useGetAiOpportunityFactorsQuery>;
export type GetAiOpportunityFactorsLazyQueryHookResult = ReturnType<typeof useGetAiOpportunityFactorsLazyQuery>;
export type GetAiOpportunityFactorsSuspenseQueryHookResult = ReturnType<typeof useGetAiOpportunityFactorsSuspenseQuery>;
export type GetAiOpportunityFactorsQueryResult = Apollo.QueryResult<GetAiOpportunityFactorsQuery, GetAiOpportunityFactorsQueryVariables>;
export const BuyAndBuildListDocument = gql`
    query buyAndBuildList($companyId: Int!, $first: Int, $after: Int, $before: Int, $isShortlisted: Boolean, $validated: Boolean, $country: String) {
  companyAssesment(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      node {
        dbId
        buyAndBuildTargets(
          first: $first
          before: $before
          after: $after
          isShortlisted: $isShortlisted
          validated: $validated
          country: $country
        ) {
          pageInfo {
            startId
            endId
          }
          edges {
            node {
              isShortlistedCompany1
              manuallyLabeledScore
              buyAndBuildRelevance
              company {
                dbId
                uniqueDomain
                iabDomainCategory
                fte
                country
                summaryDescription
                validated
                pipedriveId
                productCategorization {
                  edges {
                    node {
                      softwareCategory {
                        subCategory1
                        subCategory2
                        subCategory3
                      }
                      softwareCategoryCertainty
                    }
                  }
                }
                latestCrawlResult {
                  xoviKeywords {
                    edges {
                      node {
                        keyword
                        cpc
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useBuyAndBuildListQuery__
 *
 * To run a query within a React component, call `useBuyAndBuildListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyAndBuildListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyAndBuildListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      isShortlisted: // value for 'isShortlisted'
 *      validated: // value for 'validated'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useBuyAndBuildListQuery(baseOptions: Apollo.QueryHookOptions<BuyAndBuildListQuery, BuyAndBuildListQueryVariables> & ({ variables: BuyAndBuildListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyAndBuildListQuery, BuyAndBuildListQueryVariables>(BuyAndBuildListDocument, options);
      }
export function useBuyAndBuildListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyAndBuildListQuery, BuyAndBuildListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyAndBuildListQuery, BuyAndBuildListQueryVariables>(BuyAndBuildListDocument, options);
        }
export function useBuyAndBuildListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BuyAndBuildListQuery, BuyAndBuildListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuyAndBuildListQuery, BuyAndBuildListQueryVariables>(BuyAndBuildListDocument, options);
        }
export type BuyAndBuildListQueryHookResult = ReturnType<typeof useBuyAndBuildListQuery>;
export type BuyAndBuildListLazyQueryHookResult = ReturnType<typeof useBuyAndBuildListLazyQuery>;
export type BuyAndBuildListSuspenseQueryHookResult = ReturnType<typeof useBuyAndBuildListSuspenseQuery>;
export type BuyAndBuildListQueryResult = Apollo.QueryResult<BuyAndBuildListQuery, BuyAndBuildListQueryVariables>;
export const CompaniesByCategoriesDocument = gql`
    query companiesByCategories($subCategory1: String, $subCategory2: String, $subCategory3: String) {
  companiesByCategories(
    subCategory1: $subCategory1
    subCategory2: $subCategory2
    subCategory3: $subCategory3
  ) {
    id
    dbId
    shortName
    country
    uniqueDomain
  }
}
    `;

/**
 * __useCompaniesByCategoriesQuery__
 *
 * To run a query within a React component, call `useCompaniesByCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesByCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesByCategoriesQuery({
 *   variables: {
 *      subCategory1: // value for 'subCategory1'
 *      subCategory2: // value for 'subCategory2'
 *      subCategory3: // value for 'subCategory3'
 *   },
 * });
 */
export function useCompaniesByCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesByCategoriesQuery, CompaniesByCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesByCategoriesQuery, CompaniesByCategoriesQueryVariables>(CompaniesByCategoriesDocument, options);
      }
export function useCompaniesByCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesByCategoriesQuery, CompaniesByCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesByCategoriesQuery, CompaniesByCategoriesQueryVariables>(CompaniesByCategoriesDocument, options);
        }
export function useCompaniesByCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesByCategoriesQuery, CompaniesByCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesByCategoriesQuery, CompaniesByCategoriesQueryVariables>(CompaniesByCategoriesDocument, options);
        }
export type CompaniesByCategoriesQueryHookResult = ReturnType<typeof useCompaniesByCategoriesQuery>;
export type CompaniesByCategoriesLazyQueryHookResult = ReturnType<typeof useCompaniesByCategoriesLazyQuery>;
export type CompaniesByCategoriesSuspenseQueryHookResult = ReturnType<typeof useCompaniesByCategoriesSuspenseQuery>;
export type CompaniesByCategoriesQueryResult = Apollo.QueryResult<CompaniesByCategoriesQuery, CompaniesByCategoriesQueryVariables>;
export const CompaniesByIndustriesDocument = gql`
    query companiesByIndustries($sicCodes: [String]!) {
  companiesByIndustries(sicCodes: $sicCodes) {
    id
    dbId
    shortName
    country
    uniqueDomain
  }
}
    `;

/**
 * __useCompaniesByIndustriesQuery__
 *
 * To run a query within a React component, call `useCompaniesByIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesByIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesByIndustriesQuery({
 *   variables: {
 *      sicCodes: // value for 'sicCodes'
 *   },
 * });
 */
export function useCompaniesByIndustriesQuery(baseOptions: Apollo.QueryHookOptions<CompaniesByIndustriesQuery, CompaniesByIndustriesQueryVariables> & ({ variables: CompaniesByIndustriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesByIndustriesQuery, CompaniesByIndustriesQueryVariables>(CompaniesByIndustriesDocument, options);
      }
export function useCompaniesByIndustriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesByIndustriesQuery, CompaniesByIndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesByIndustriesQuery, CompaniesByIndustriesQueryVariables>(CompaniesByIndustriesDocument, options);
        }
export function useCompaniesByIndustriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesByIndustriesQuery, CompaniesByIndustriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesByIndustriesQuery, CompaniesByIndustriesQueryVariables>(CompaniesByIndustriesDocument, options);
        }
export type CompaniesByIndustriesQueryHookResult = ReturnType<typeof useCompaniesByIndustriesQuery>;
export type CompaniesByIndustriesLazyQueryHookResult = ReturnType<typeof useCompaniesByIndustriesLazyQuery>;
export type CompaniesByIndustriesSuspenseQueryHookResult = ReturnType<typeof useCompaniesByIndustriesSuspenseQuery>;
export type CompaniesByIndustriesQueryResult = Apollo.QueryResult<CompaniesByIndustriesQuery, CompaniesByIndustriesQueryVariables>;
export const CompaniesByIndustryAndCategoryDocument = gql`
    query companiesByIndustryAndCategory($sicCodes: [String], $subCategory1: String, $subCategory2: String, $subCategory3: String) {
  companiesByIndustryAndCategory(
    sicCodes: $sicCodes
    subCategory1: $subCategory1
    subCategory2: $subCategory2
    subCategory3: $subCategory3
  ) {
    id
    dbId
    shortName
    country
    uniqueDomain
  }
}
    `;

/**
 * __useCompaniesByIndustryAndCategoryQuery__
 *
 * To run a query within a React component, call `useCompaniesByIndustryAndCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesByIndustryAndCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesByIndustryAndCategoryQuery({
 *   variables: {
 *      sicCodes: // value for 'sicCodes'
 *      subCategory1: // value for 'subCategory1'
 *      subCategory2: // value for 'subCategory2'
 *      subCategory3: // value for 'subCategory3'
 *   },
 * });
 */
export function useCompaniesByIndustryAndCategoryQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesByIndustryAndCategoryQuery, CompaniesByIndustryAndCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesByIndustryAndCategoryQuery, CompaniesByIndustryAndCategoryQueryVariables>(CompaniesByIndustryAndCategoryDocument, options);
      }
export function useCompaniesByIndustryAndCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesByIndustryAndCategoryQuery, CompaniesByIndustryAndCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesByIndustryAndCategoryQuery, CompaniesByIndustryAndCategoryQueryVariables>(CompaniesByIndustryAndCategoryDocument, options);
        }
export function useCompaniesByIndustryAndCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesByIndustryAndCategoryQuery, CompaniesByIndustryAndCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesByIndustryAndCategoryQuery, CompaniesByIndustryAndCategoryQueryVariables>(CompaniesByIndustryAndCategoryDocument, options);
        }
export type CompaniesByIndustryAndCategoryQueryHookResult = ReturnType<typeof useCompaniesByIndustryAndCategoryQuery>;
export type CompaniesByIndustryAndCategoryLazyQueryHookResult = ReturnType<typeof useCompaniesByIndustryAndCategoryLazyQuery>;
export type CompaniesByIndustryAndCategorySuspenseQueryHookResult = ReturnType<typeof useCompaniesByIndustryAndCategorySuspenseQuery>;
export type CompaniesByIndustryAndCategoryQueryResult = Apollo.QueryResult<CompaniesByIndustryAndCategoryQuery, CompaniesByIndustryAndCategoryQueryVariables>;
export const CompanyAssesmentDocument = gql`
    query companyAssesment($domain: String!) {
  companyAssesment(domain: $domain) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        maxFte
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useCompanyAssesmentQuery__
 *
 * To run a query within a React component, call `useCompanyAssesmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAssesmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAssesmentQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useCompanyAssesmentQuery(baseOptions: Apollo.QueryHookOptions<CompanyAssesmentQuery, CompanyAssesmentQueryVariables> & ({ variables: CompanyAssesmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAssesmentQuery, CompanyAssesmentQueryVariables>(CompanyAssesmentDocument, options);
      }
export function useCompanyAssesmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAssesmentQuery, CompanyAssesmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAssesmentQuery, CompanyAssesmentQueryVariables>(CompanyAssesmentDocument, options);
        }
export function useCompanyAssesmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyAssesmentQuery, CompanyAssesmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyAssesmentQuery, CompanyAssesmentQueryVariables>(CompanyAssesmentDocument, options);
        }
export type CompanyAssesmentQueryHookResult = ReturnType<typeof useCompanyAssesmentQuery>;
export type CompanyAssesmentLazyQueryHookResult = ReturnType<typeof useCompanyAssesmentLazyQuery>;
export type CompanyAssesmentSuspenseQueryHookResult = ReturnType<typeof useCompanyAssesmentSuspenseQuery>;
export type CompanyAssesmentQueryResult = Apollo.QueryResult<CompanyAssesmentQuery, CompanyAssesmentQueryVariables>;
export const CompanyCertificationsDocument = gql`
    query companyCertifications($companyId: Int!) {
  companyCertifications(companyId: $companyId) {
    id
    companyId
    certificationId
    extractionMethod
    extractionConfidence
    sourceUrl
    contextSnippet
    isVerified
    datetimeCreated
    certificationName
    certificationIssuer
    certificationDomain
    certificationLevel
    certificationAiMoatLevel
    certificationDescription
  }
}
    `;

/**
 * __useCompanyCertificationsQuery__
 *
 * To run a query within a React component, call `useCompanyCertificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyCertificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyCertificationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyCertificationsQuery(baseOptions: Apollo.QueryHookOptions<CompanyCertificationsQuery, CompanyCertificationsQueryVariables> & ({ variables: CompanyCertificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyCertificationsQuery, CompanyCertificationsQueryVariables>(CompanyCertificationsDocument, options);
      }
export function useCompanyCertificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyCertificationsQuery, CompanyCertificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyCertificationsQuery, CompanyCertificationsQueryVariables>(CompanyCertificationsDocument, options);
        }
export function useCompanyCertificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyCertificationsQuery, CompanyCertificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyCertificationsQuery, CompanyCertificationsQueryVariables>(CompanyCertificationsDocument, options);
        }
export type CompanyCertificationsQueryHookResult = ReturnType<typeof useCompanyCertificationsQuery>;
export type CompanyCertificationsLazyQueryHookResult = ReturnType<typeof useCompanyCertificationsLazyQuery>;
export type CompanyCertificationsSuspenseQueryHookResult = ReturnType<typeof useCompanyCertificationsSuspenseQuery>;
export type CompanyCertificationsQueryResult = Apollo.QueryResult<CompanyCertificationsQuery, CompanyCertificationsQueryVariables>;
export const CompanyContactsDocument = gql`
    query CompanyContacts($companyId: Int!) {
  companyContacts(companyId: $companyId) {
    name
    email
    contactType
    pdPersonId
  }
}
    `;

/**
 * __useCompanyContactsQuery__
 *
 * To run a query within a React component, call `useCompanyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyContactsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyContactsQuery(baseOptions: Apollo.QueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables> & ({ variables: CompanyContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
      }
export function useCompanyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
        }
export function useCompanyContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
        }
export type CompanyContactsQueryHookResult = ReturnType<typeof useCompanyContactsQuery>;
export type CompanyContactsLazyQueryHookResult = ReturnType<typeof useCompanyContactsLazyQuery>;
export type CompanyContactsSuspenseQueryHookResult = ReturnType<typeof useCompanyContactsSuspenseQuery>;
export type CompanyContactsQueryResult = Apollo.QueryResult<CompanyContactsQuery, CompanyContactsQueryVariables>;
export const GetCompanyCoreKeywordsDocument = gql`
    query getCompanyCoreKeywords($companyId: Int!) {
  getCompanyCoreKeywords(companyId: $companyId) {
    edges {
      node {
        dbId
        keyword
        keywordType
        cpc
        searchVolume
        competitionIndex
        source
      }
    }
  }
}
    `;

/**
 * __useGetCompanyCoreKeywordsQuery__
 *
 * To run a query within a React component, call `useGetCompanyCoreKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyCoreKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyCoreKeywordsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyCoreKeywordsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyCoreKeywordsQuery, GetCompanyCoreKeywordsQueryVariables> & ({ variables: GetCompanyCoreKeywordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyCoreKeywordsQuery, GetCompanyCoreKeywordsQueryVariables>(GetCompanyCoreKeywordsDocument, options);
      }
export function useGetCompanyCoreKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyCoreKeywordsQuery, GetCompanyCoreKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyCoreKeywordsQuery, GetCompanyCoreKeywordsQueryVariables>(GetCompanyCoreKeywordsDocument, options);
        }
export function useGetCompanyCoreKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyCoreKeywordsQuery, GetCompanyCoreKeywordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyCoreKeywordsQuery, GetCompanyCoreKeywordsQueryVariables>(GetCompanyCoreKeywordsDocument, options);
        }
export type GetCompanyCoreKeywordsQueryHookResult = ReturnType<typeof useGetCompanyCoreKeywordsQuery>;
export type GetCompanyCoreKeywordsLazyQueryHookResult = ReturnType<typeof useGetCompanyCoreKeywordsLazyQuery>;
export type GetCompanyCoreKeywordsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyCoreKeywordsSuspenseQuery>;
export type GetCompanyCoreKeywordsQueryResult = Apollo.QueryResult<GetCompanyCoreKeywordsQuery, GetCompanyCoreKeywordsQueryVariables>;
export const CompanyInboxListDocument = gql`
    query companyInboxList($country: String, $platformId: Int, $newPlatforms: Boolean, $prioritizedPlatforms: Boolean, $falseNegatives: Boolean) {
  companyInboxList(
    country: $country
    platformId: $platformId
    newPlatforms: $newPlatforms
    prioritizedPlatforms: $prioritizedPlatforms
    falseNegatives: $falseNegatives
  ) {
    dbId
    shortName
    uniqueDomain
    logoUrl
    crawlUrl
    country
    sicCode
    sicCodeCertainty
    sicCodeJustification
    fte
    topRelatedCompanyName
    topRelatedCompanyLogoUrl
    aiValidationScore
    datetimeCreated
    systemType
    productCategorization(first: 1) {
      edges {
        node {
          id
          softwareCategory {
            subCategory1
          }
        }
      }
    }
    iabDomainCategory
  }
}
    `;

/**
 * __useCompanyInboxListQuery__
 *
 * To run a query within a React component, call `useCompanyInboxListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInboxListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInboxListQuery({
 *   variables: {
 *      country: // value for 'country'
 *      platformId: // value for 'platformId'
 *      newPlatforms: // value for 'newPlatforms'
 *      prioritizedPlatforms: // value for 'prioritizedPlatforms'
 *      falseNegatives: // value for 'falseNegatives'
 *   },
 * });
 */
export function useCompanyInboxListQuery(baseOptions?: Apollo.QueryHookOptions<CompanyInboxListQuery, CompanyInboxListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyInboxListQuery, CompanyInboxListQueryVariables>(CompanyInboxListDocument, options);
      }
export function useCompanyInboxListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyInboxListQuery, CompanyInboxListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyInboxListQuery, CompanyInboxListQueryVariables>(CompanyInboxListDocument, options);
        }
export function useCompanyInboxListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyInboxListQuery, CompanyInboxListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyInboxListQuery, CompanyInboxListQueryVariables>(CompanyInboxListDocument, options);
        }
export type CompanyInboxListQueryHookResult = ReturnType<typeof useCompanyInboxListQuery>;
export type CompanyInboxListLazyQueryHookResult = ReturnType<typeof useCompanyInboxListLazyQuery>;
export type CompanyInboxListSuspenseQueryHookResult = ReturnType<typeof useCompanyInboxListSuspenseQuery>;
export type CompanyInboxListQueryResult = Apollo.QueryResult<CompanyInboxListQuery, CompanyInboxListQueryVariables>;
export const CompanyPnlForecastDocument = gql`
    query CompanyPnlForecast($companyId: Int!) {
  companyPnlForecast(companyId: $companyId) {
    recurringRevenueShare
    lastFiscalYear
    rows {
      year
      isForecast
      revenue
      cogs
      grossProfit
      opex
      ebitda
      da
      ebit
      fte
      revenueGrowth
    }
  }
}
    `;

/**
 * __useCompanyPnlForecastQuery__
 *
 * To run a query within a React component, call `useCompanyPnlForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyPnlForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyPnlForecastQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyPnlForecastQuery(baseOptions: Apollo.QueryHookOptions<CompanyPnlForecastQuery, CompanyPnlForecastQueryVariables> & ({ variables: CompanyPnlForecastQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyPnlForecastQuery, CompanyPnlForecastQueryVariables>(CompanyPnlForecastDocument, options);
      }
export function useCompanyPnlForecastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyPnlForecastQuery, CompanyPnlForecastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyPnlForecastQuery, CompanyPnlForecastQueryVariables>(CompanyPnlForecastDocument, options);
        }
export function useCompanyPnlForecastSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyPnlForecastQuery, CompanyPnlForecastQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyPnlForecastQuery, CompanyPnlForecastQueryVariables>(CompanyPnlForecastDocument, options);
        }
export type CompanyPnlForecastQueryHookResult = ReturnType<typeof useCompanyPnlForecastQuery>;
export type CompanyPnlForecastLazyQueryHookResult = ReturnType<typeof useCompanyPnlForecastLazyQuery>;
export type CompanyPnlForecastSuspenseQueryHookResult = ReturnType<typeof useCompanyPnlForecastSuspenseQuery>;
export type CompanyPnlForecastQueryResult = Apollo.QueryResult<CompanyPnlForecastQuery, CompanyPnlForecastQueryVariables>;
export const CompetitionCpcKeywordsDocument = gql`
    query competitionCpcKeywords($companyId: Int) {
  competitionCpcKeywords(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        cpc
        keyword
        dbId
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useCompetitionCpcKeywordsQuery__
 *
 * To run a query within a React component, call `useCompetitionCpcKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetitionCpcKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetitionCpcKeywordsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompetitionCpcKeywordsQuery(baseOptions?: Apollo.QueryHookOptions<CompetitionCpcKeywordsQuery, CompetitionCpcKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetitionCpcKeywordsQuery, CompetitionCpcKeywordsQueryVariables>(CompetitionCpcKeywordsDocument, options);
      }
export function useCompetitionCpcKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetitionCpcKeywordsQuery, CompetitionCpcKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetitionCpcKeywordsQuery, CompetitionCpcKeywordsQueryVariables>(CompetitionCpcKeywordsDocument, options);
        }
export function useCompetitionCpcKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetitionCpcKeywordsQuery, CompetitionCpcKeywordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetitionCpcKeywordsQuery, CompetitionCpcKeywordsQueryVariables>(CompetitionCpcKeywordsDocument, options);
        }
export type CompetitionCpcKeywordsQueryHookResult = ReturnType<typeof useCompetitionCpcKeywordsQuery>;
export type CompetitionCpcKeywordsLazyQueryHookResult = ReturnType<typeof useCompetitionCpcKeywordsLazyQuery>;
export type CompetitionCpcKeywordsSuspenseQueryHookResult = ReturnType<typeof useCompetitionCpcKeywordsSuspenseQuery>;
export type CompetitionCpcKeywordsQueryResult = Apollo.QueryResult<CompetitionCpcKeywordsQuery, CompetitionCpcKeywordsQueryVariables>;
export const ConversionTrackingDocument = gql`
    query ConversionTracking($userId: Int, $dateFrom: DateTime, $dateTo: DateTime) {
  conversionTracking(userId: $userId, dateFrom: $dateFrom, dateTo: $dateTo) {
    pipedriveDealId
    title
    status
    stageName
    pipelineName
    value
    companyName
    dealCreatedAt
    dealClosedAt
    linkedMeetingCount
    initialCallCount
    followupCallCount
    firstCallDate
  }
}
    `;

/**
 * __useConversionTrackingQuery__
 *
 * To run a query within a React component, call `useConversionTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversionTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversionTrackingQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useConversionTrackingQuery(baseOptions?: Apollo.QueryHookOptions<ConversionTrackingQuery, ConversionTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversionTrackingQuery, ConversionTrackingQueryVariables>(ConversionTrackingDocument, options);
      }
export function useConversionTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversionTrackingQuery, ConversionTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversionTrackingQuery, ConversionTrackingQueryVariables>(ConversionTrackingDocument, options);
        }
export function useConversionTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConversionTrackingQuery, ConversionTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConversionTrackingQuery, ConversionTrackingQueryVariables>(ConversionTrackingDocument, options);
        }
export type ConversionTrackingQueryHookResult = ReturnType<typeof useConversionTrackingQuery>;
export type ConversionTrackingLazyQueryHookResult = ReturnType<typeof useConversionTrackingLazyQuery>;
export type ConversionTrackingSuspenseQueryHookResult = ReturnType<typeof useConversionTrackingSuspenseQuery>;
export type ConversionTrackingQueryResult = Apollo.QueryResult<ConversionTrackingQuery, ConversionTrackingQueryVariables>;
export const CortexConfigDocument = gql`
    query cortexConfig {
  cortexConfig {
    postToZapier
    aiValidationOverwriteEnabled
    maxRecursionDepth
    mongoSiteCacheInDays
    minFacesForGroupPicture
    maxCrawledPagesPerDomain
    macAcceptableWebsitePopularity
    assessmentXlsUploadTime
    assessmentXlsTemplateId
    initialBbWeightForSourcescrubTags
    pipedriveDfmTargetDealsFilterId
    pipedriveOpenTargetDealsLimit
    pipedriveSoftwareCompanyOrgTypeIndicator
    pipedriveCortexLabelId
    pipedriveHotLeadLabelId
    sourcescrubTagIdForGenericGenericCompanyLabel
    crawlQueueEnabled
    crawlQueueBatchSize
    crawlQueueIntervalSeconds
    scheduledCrawlerBatchSize
    v2RecrawlBatchSize
  }
}
    `;

/**
 * __useCortexConfigQuery__
 *
 * To run a query within a React component, call `useCortexConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCortexConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCortexConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useCortexConfigQuery(baseOptions?: Apollo.QueryHookOptions<CortexConfigQuery, CortexConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CortexConfigQuery, CortexConfigQueryVariables>(CortexConfigDocument, options);
      }
export function useCortexConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CortexConfigQuery, CortexConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CortexConfigQuery, CortexConfigQueryVariables>(CortexConfigDocument, options);
        }
export function useCortexConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CortexConfigQuery, CortexConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CortexConfigQuery, CortexConfigQueryVariables>(CortexConfigDocument, options);
        }
export type CortexConfigQueryHookResult = ReturnType<typeof useCortexConfigQuery>;
export type CortexConfigLazyQueryHookResult = ReturnType<typeof useCortexConfigLazyQuery>;
export type CortexConfigSuspenseQueryHookResult = ReturnType<typeof useCortexConfigSuspenseQuery>;
export type CortexConfigQueryResult = Apollo.QueryResult<CortexConfigQuery, CortexConfigQueryVariables>;
export const CrawlQueueEntriesDocument = gql`
    query crawlQueueEntries($crawlStarted: Boolean, $locked: Boolean, $hasError: Boolean, $limit: Int, $offset: Int) {
  crawlQueueEntries(
    crawlStarted: $crawlStarted
    locked: $locked
    hasError: $hasError
    limit: $limit
    offset: $offset
  ) {
    id
    datetimeCreated
    companyId
    crawlStarted
    locked
    domain
    companyName
    triggeredBy
    errorMessage
  }
}
    `;

/**
 * __useCrawlQueueEntriesQuery__
 *
 * To run a query within a React component, call `useCrawlQueueEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrawlQueueEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrawlQueueEntriesQuery({
 *   variables: {
 *      crawlStarted: // value for 'crawlStarted'
 *      locked: // value for 'locked'
 *      hasError: // value for 'hasError'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useCrawlQueueEntriesQuery(baseOptions?: Apollo.QueryHookOptions<CrawlQueueEntriesQuery, CrawlQueueEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrawlQueueEntriesQuery, CrawlQueueEntriesQueryVariables>(CrawlQueueEntriesDocument, options);
      }
export function useCrawlQueueEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrawlQueueEntriesQuery, CrawlQueueEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrawlQueueEntriesQuery, CrawlQueueEntriesQueryVariables>(CrawlQueueEntriesDocument, options);
        }
export function useCrawlQueueEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrawlQueueEntriesQuery, CrawlQueueEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrawlQueueEntriesQuery, CrawlQueueEntriesQueryVariables>(CrawlQueueEntriesDocument, options);
        }
export type CrawlQueueEntriesQueryHookResult = ReturnType<typeof useCrawlQueueEntriesQuery>;
export type CrawlQueueEntriesLazyQueryHookResult = ReturnType<typeof useCrawlQueueEntriesLazyQuery>;
export type CrawlQueueEntriesSuspenseQueryHookResult = ReturnType<typeof useCrawlQueueEntriesSuspenseQuery>;
export type CrawlQueueEntriesQueryResult = Apollo.QueryResult<CrawlQueueEntriesQuery, CrawlQueueEntriesQueryVariables>;
export const CrawlQueueStatsDocument = gql`
    query crawlQueueStats {
  crawlQueueStats {
    total
    pending
    locked
    started
    errored
  }
}
    `;

/**
 * __useCrawlQueueStatsQuery__
 *
 * To run a query within a React component, call `useCrawlQueueStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrawlQueueStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrawlQueueStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrawlQueueStatsQuery(baseOptions?: Apollo.QueryHookOptions<CrawlQueueStatsQuery, CrawlQueueStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrawlQueueStatsQuery, CrawlQueueStatsQueryVariables>(CrawlQueueStatsDocument, options);
      }
export function useCrawlQueueStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrawlQueueStatsQuery, CrawlQueueStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrawlQueueStatsQuery, CrawlQueueStatsQueryVariables>(CrawlQueueStatsDocument, options);
        }
export function useCrawlQueueStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrawlQueueStatsQuery, CrawlQueueStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrawlQueueStatsQuery, CrawlQueueStatsQueryVariables>(CrawlQueueStatsDocument, options);
        }
export type CrawlQueueStatsQueryHookResult = ReturnType<typeof useCrawlQueueStatsQuery>;
export type CrawlQueueStatsLazyQueryHookResult = ReturnType<typeof useCrawlQueueStatsLazyQuery>;
export type CrawlQueueStatsSuspenseQueryHookResult = ReturnType<typeof useCrawlQueueStatsSuspenseQuery>;
export type CrawlQueueStatsQueryResult = Apollo.QueryResult<CrawlQueueStatsQuery, CrawlQueueStatsQueryVariables>;
export const CrawlerInboxDocument = gql`
    query crawlerInbox($country: String, $platformId: Int, $limit: Int, $offset: Int) {
  crawlerInbox(
    country: $country
    platformId: $platformId
    limit: $limit
    offset: $offset
  ) {
    companyId
    shortName
    uniqueDomain
    country
    logoUrl
    crawlUrl
    sicCode
    sicCodeCertainty
    sicCodeJustification
    iabDomainCategory
    productName
    systemType
    customerVertical
    fte
    callabilityScore
    aiValidationScore
    manuallyLabeledScore
    buyAndBuildRelevance
    topBidPlatformName
    topBidPlatformLogoUrl
    companyValidated
    crawlResultValidated
    validationNeeded
    crawlResultId
    crawlRunId
    pipedriveId
    validationLockedBy
    validationLockedAt
    peOwned
    privateOwned
    crawlCompletedAt
    companyCreatedAt
  }
}
    `;

/**
 * __useCrawlerInboxQuery__
 *
 * To run a query within a React component, call `useCrawlerInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrawlerInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrawlerInboxQuery({
 *   variables: {
 *      country: // value for 'country'
 *      platformId: // value for 'platformId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useCrawlerInboxQuery(baseOptions?: Apollo.QueryHookOptions<CrawlerInboxQuery, CrawlerInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrawlerInboxQuery, CrawlerInboxQueryVariables>(CrawlerInboxDocument, options);
      }
export function useCrawlerInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrawlerInboxQuery, CrawlerInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrawlerInboxQuery, CrawlerInboxQueryVariables>(CrawlerInboxDocument, options);
        }
export function useCrawlerInboxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrawlerInboxQuery, CrawlerInboxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrawlerInboxQuery, CrawlerInboxQueryVariables>(CrawlerInboxDocument, options);
        }
export type CrawlerInboxQueryHookResult = ReturnType<typeof useCrawlerInboxQuery>;
export type CrawlerInboxLazyQueryHookResult = ReturnType<typeof useCrawlerInboxLazyQuery>;
export type CrawlerInboxSuspenseQueryHookResult = ReturnType<typeof useCrawlerInboxSuspenseQuery>;
export type CrawlerInboxQueryResult = Apollo.QueryResult<CrawlerInboxQuery, CrawlerInboxQueryVariables>;
export const CustomerIndustryGrowthRatesDocument = gql`
    query customerIndustryGrowthRates($companyId: Int) {
  customerIndustryGrowthRates(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        adjustedMedianGrowth
        sampleSize
        sicDesc
        dbId
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useCustomerIndustryGrowthRatesQuery__
 *
 * To run a query within a React component, call `useCustomerIndustryGrowthRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerIndustryGrowthRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerIndustryGrowthRatesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCustomerIndustryGrowthRatesQuery(baseOptions?: Apollo.QueryHookOptions<CustomerIndustryGrowthRatesQuery, CustomerIndustryGrowthRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerIndustryGrowthRatesQuery, CustomerIndustryGrowthRatesQueryVariables>(CustomerIndustryGrowthRatesDocument, options);
      }
export function useCustomerIndustryGrowthRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerIndustryGrowthRatesQuery, CustomerIndustryGrowthRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerIndustryGrowthRatesQuery, CustomerIndustryGrowthRatesQueryVariables>(CustomerIndustryGrowthRatesDocument, options);
        }
export function useCustomerIndustryGrowthRatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerIndustryGrowthRatesQuery, CustomerIndustryGrowthRatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerIndustryGrowthRatesQuery, CustomerIndustryGrowthRatesQueryVariables>(CustomerIndustryGrowthRatesDocument, options);
        }
export type CustomerIndustryGrowthRatesQueryHookResult = ReturnType<typeof useCustomerIndustryGrowthRatesQuery>;
export type CustomerIndustryGrowthRatesLazyQueryHookResult = ReturnType<typeof useCustomerIndustryGrowthRatesLazyQuery>;
export type CustomerIndustryGrowthRatesSuspenseQueryHookResult = ReturnType<typeof useCustomerIndustryGrowthRatesSuspenseQuery>;
export type CustomerIndustryGrowthRatesQueryResult = Apollo.QueryResult<CustomerIndustryGrowthRatesQuery, CustomerIndustryGrowthRatesQueryVariables>;
export const CustomerSegmentsDocument = gql`
    query customerSegments($companyId: Int!) {
  customerSegments(companyId: $companyId) {
    id
    segmentName
    segmentDescription
    keyword1
    bidGroupCompanyId
  }
}
    `;

/**
 * __useCustomerSegmentsQuery__
 *
 * To run a query within a React component, call `useCustomerSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSegmentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCustomerSegmentsQuery(baseOptions: Apollo.QueryHookOptions<CustomerSegmentsQuery, CustomerSegmentsQueryVariables> & ({ variables: CustomerSegmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>(CustomerSegmentsDocument, options);
      }
export function useCustomerSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>(CustomerSegmentsDocument, options);
        }
export function useCustomerSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>(CustomerSegmentsDocument, options);
        }
export type CustomerSegmentsQueryHookResult = ReturnType<typeof useCustomerSegmentsQuery>;
export type CustomerSegmentsLazyQueryHookResult = ReturnType<typeof useCustomerSegmentsLazyQuery>;
export type CustomerSegmentsSuspenseQueryHookResult = ReturnType<typeof useCustomerSegmentsSuspenseQuery>;
export type CustomerSegmentsQueryResult = Apollo.QueryResult<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>;
export const DealAssessmentFileUrlDocument = gql`
    query dealAssessmentFileUrl($companyId: Int) {
  getCompany(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        dbId
        dealAssessmentFileUrl {
          downloadUrl
          generationTriggered
          noDataUploaded
          dateOfFile
          previousGenerationStillRunning
          progress {
            step
            timestamp
            secondsSinceLastUpdate
          }
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useDealAssessmentFileUrlQuery__
 *
 * To run a query within a React component, call `useDealAssessmentFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealAssessmentFileUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealAssessmentFileUrlQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDealAssessmentFileUrlQuery(baseOptions?: Apollo.QueryHookOptions<DealAssessmentFileUrlQuery, DealAssessmentFileUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealAssessmentFileUrlQuery, DealAssessmentFileUrlQueryVariables>(DealAssessmentFileUrlDocument, options);
      }
export function useDealAssessmentFileUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealAssessmentFileUrlQuery, DealAssessmentFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealAssessmentFileUrlQuery, DealAssessmentFileUrlQueryVariables>(DealAssessmentFileUrlDocument, options);
        }
export function useDealAssessmentFileUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DealAssessmentFileUrlQuery, DealAssessmentFileUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DealAssessmentFileUrlQuery, DealAssessmentFileUrlQueryVariables>(DealAssessmentFileUrlDocument, options);
        }
export type DealAssessmentFileUrlQueryHookResult = ReturnType<typeof useDealAssessmentFileUrlQuery>;
export type DealAssessmentFileUrlLazyQueryHookResult = ReturnType<typeof useDealAssessmentFileUrlLazyQuery>;
export type DealAssessmentFileUrlSuspenseQueryHookResult = ReturnType<typeof useDealAssessmentFileUrlSuspenseQuery>;
export type DealAssessmentFileUrlQueryResult = Apollo.QueryResult<DealAssessmentFileUrlQuery, DealAssessmentFileUrlQueryVariables>;
export const EmployeeStaticsDocument = gql`
    query employeeStatics($companyId: Int) {
  employeeStatics(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        medianEmploymentMonths
        medianTotalEmploymentMonths
        medianPreviousEmployers
        numberOfEmployees
        teamQualityPercentage
        dbId
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useEmployeeStaticsQuery__
 *
 * To run a query within a React component, call `useEmployeeStaticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeStaticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeStaticsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useEmployeeStaticsQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeStaticsQuery, EmployeeStaticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeStaticsQuery, EmployeeStaticsQueryVariables>(EmployeeStaticsDocument, options);
      }
export function useEmployeeStaticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeStaticsQuery, EmployeeStaticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeStaticsQuery, EmployeeStaticsQueryVariables>(EmployeeStaticsDocument, options);
        }
export function useEmployeeStaticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeStaticsQuery, EmployeeStaticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeStaticsQuery, EmployeeStaticsQueryVariables>(EmployeeStaticsDocument, options);
        }
export type EmployeeStaticsQueryHookResult = ReturnType<typeof useEmployeeStaticsQuery>;
export type EmployeeStaticsLazyQueryHookResult = ReturnType<typeof useEmployeeStaticsLazyQuery>;
export type EmployeeStaticsSuspenseQueryHookResult = ReturnType<typeof useEmployeeStaticsSuspenseQuery>;
export type EmployeeStaticsQueryResult = Apollo.QueryResult<EmployeeStaticsQuery, EmployeeStaticsQueryVariables>;
export const GetEnrichmentJobStatusDocument = gql`
    query getEnrichmentJobStatus($jobId: ID!) {
  enrichmentJobStatus(jobId: $jobId) {
    jobId
    status
    progress {
      stage
      percent
      message
    }
    result
    error
  }
}
    `;

/**
 * __useGetEnrichmentJobStatusQuery__
 *
 * To run a query within a React component, call `useGetEnrichmentJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrichmentJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrichmentJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetEnrichmentJobStatusQuery(baseOptions: Apollo.QueryHookOptions<GetEnrichmentJobStatusQuery, GetEnrichmentJobStatusQueryVariables> & ({ variables: GetEnrichmentJobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnrichmentJobStatusQuery, GetEnrichmentJobStatusQueryVariables>(GetEnrichmentJobStatusDocument, options);
      }
export function useGetEnrichmentJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnrichmentJobStatusQuery, GetEnrichmentJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnrichmentJobStatusQuery, GetEnrichmentJobStatusQueryVariables>(GetEnrichmentJobStatusDocument, options);
        }
export function useGetEnrichmentJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEnrichmentJobStatusQuery, GetEnrichmentJobStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEnrichmentJobStatusQuery, GetEnrichmentJobStatusQueryVariables>(GetEnrichmentJobStatusDocument, options);
        }
export type GetEnrichmentJobStatusQueryHookResult = ReturnType<typeof useGetEnrichmentJobStatusQuery>;
export type GetEnrichmentJobStatusLazyQueryHookResult = ReturnType<typeof useGetEnrichmentJobStatusLazyQuery>;
export type GetEnrichmentJobStatusSuspenseQueryHookResult = ReturnType<typeof useGetEnrichmentJobStatusSuspenseQuery>;
export type GetEnrichmentJobStatusQueryResult = Apollo.QueryResult<GetEnrichmentJobStatusQuery, GetEnrichmentJobStatusQueryVariables>;
export const EnvironmentConfigurationDocument = gql`
    query EnvironmentConfiguration {
  environmentConfiguration {
    dopplerProject
    dopplerConfig
    alembicRevision
    gitBranch
    gitCommit
    latestMigrationVersion
    stepsBehindLatestMigration
  }
}
    `;

/**
 * __useEnvironmentConfigurationQuery__
 *
 * To run a query within a React component, call `useEnvironmentConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnvironmentConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentConfigurationQuery, EnvironmentConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentConfigurationQuery, EnvironmentConfigurationQueryVariables>(EnvironmentConfigurationDocument, options);
      }
export function useEnvironmentConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentConfigurationQuery, EnvironmentConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentConfigurationQuery, EnvironmentConfigurationQueryVariables>(EnvironmentConfigurationDocument, options);
        }
export function useEnvironmentConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnvironmentConfigurationQuery, EnvironmentConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnvironmentConfigurationQuery, EnvironmentConfigurationQueryVariables>(EnvironmentConfigurationDocument, options);
        }
export type EnvironmentConfigurationQueryHookResult = ReturnType<typeof useEnvironmentConfigurationQuery>;
export type EnvironmentConfigurationLazyQueryHookResult = ReturnType<typeof useEnvironmentConfigurationLazyQuery>;
export type EnvironmentConfigurationSuspenseQueryHookResult = ReturnType<typeof useEnvironmentConfigurationSuspenseQuery>;
export type EnvironmentConfigurationQueryResult = Apollo.QueryResult<EnvironmentConfigurationQuery, EnvironmentConfigurationQueryVariables>;
export const FinancialForecastParamsDocument = gql`
    query FinancialForecastParams {
  financialForecastParams {
    version
    updatedAt
    params
  }
}
    `;

/**
 * __useFinancialForecastParamsQuery__
 *
 * To run a query within a React component, call `useFinancialForecastParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialForecastParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialForecastParamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinancialForecastParamsQuery(baseOptions?: Apollo.QueryHookOptions<FinancialForecastParamsQuery, FinancialForecastParamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancialForecastParamsQuery, FinancialForecastParamsQueryVariables>(FinancialForecastParamsDocument, options);
      }
export function useFinancialForecastParamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancialForecastParamsQuery, FinancialForecastParamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancialForecastParamsQuery, FinancialForecastParamsQueryVariables>(FinancialForecastParamsDocument, options);
        }
export function useFinancialForecastParamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancialForecastParamsQuery, FinancialForecastParamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancialForecastParamsQuery, FinancialForecastParamsQueryVariables>(FinancialForecastParamsDocument, options);
        }
export type FinancialForecastParamsQueryHookResult = ReturnType<typeof useFinancialForecastParamsQuery>;
export type FinancialForecastParamsLazyQueryHookResult = ReturnType<typeof useFinancialForecastParamsLazyQuery>;
export type FinancialForecastParamsSuspenseQueryHookResult = ReturnType<typeof useFinancialForecastParamsSuspenseQuery>;
export type FinancialForecastParamsQueryResult = Apollo.QueryResult<FinancialForecastParamsQuery, FinancialForecastParamsQueryVariables>;
export const FinancialForecastOutputsDocument = gql`
    query FinancialForecastOutputs($limit: Int) {
  financialForecastOutputs(limit: $limit) {
    companyId
    companyName
    evModelAppreciation5y
    evModelCagr5y
    ebitMarginForecastChange
    lastCalculated
  }
}
    `;

/**
 * __useFinancialForecastOutputsQuery__
 *
 * To run a query within a React component, call `useFinancialForecastOutputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialForecastOutputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialForecastOutputsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFinancialForecastOutputsQuery(baseOptions?: Apollo.QueryHookOptions<FinancialForecastOutputsQuery, FinancialForecastOutputsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancialForecastOutputsQuery, FinancialForecastOutputsQueryVariables>(FinancialForecastOutputsDocument, options);
      }
export function useFinancialForecastOutputsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancialForecastOutputsQuery, FinancialForecastOutputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancialForecastOutputsQuery, FinancialForecastOutputsQueryVariables>(FinancialForecastOutputsDocument, options);
        }
export function useFinancialForecastOutputsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancialForecastOutputsQuery, FinancialForecastOutputsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancialForecastOutputsQuery, FinancialForecastOutputsQueryVariables>(FinancialForecastOutputsDocument, options);
        }
export type FinancialForecastOutputsQueryHookResult = ReturnType<typeof useFinancialForecastOutputsQuery>;
export type FinancialForecastOutputsLazyQueryHookResult = ReturnType<typeof useFinancialForecastOutputsLazyQuery>;
export type FinancialForecastOutputsSuspenseQueryHookResult = ReturnType<typeof useFinancialForecastOutputsSuspenseQuery>;
export type FinancialForecastOutputsQueryResult = Apollo.QueryResult<FinancialForecastOutputsQuery, FinancialForecastOutputsQueryVariables>;
export const FteHistoryDocument = gql`
    query fteHistory($companyId: Int!) {
  fteHistory(companyId: $companyId) {
    id
    fte
    sourceType
    sourceCrawlResultId
    observedAt
    confirmedBy
    confirmedAt
    isConfirmedChange
    notes
    datetimeCreated
  }
}
    `;

/**
 * __useFteHistoryQuery__
 *
 * To run a query within a React component, call `useFteHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFteHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFteHistoryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFteHistoryQuery(baseOptions: Apollo.QueryHookOptions<FteHistoryQuery, FteHistoryQueryVariables> & ({ variables: FteHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FteHistoryQuery, FteHistoryQueryVariables>(FteHistoryDocument, options);
      }
export function useFteHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FteHistoryQuery, FteHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FteHistoryQuery, FteHistoryQueryVariables>(FteHistoryDocument, options);
        }
export function useFteHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FteHistoryQuery, FteHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FteHistoryQuery, FteHistoryQueryVariables>(FteHistoryDocument, options);
        }
export type FteHistoryQueryHookResult = ReturnType<typeof useFteHistoryQuery>;
export type FteHistoryLazyQueryHookResult = ReturnType<typeof useFteHistoryLazyQuery>;
export type FteHistorySuspenseQueryHookResult = ReturnType<typeof useFteHistorySuspenseQuery>;
export type FteHistoryQueryResult = Apollo.QueryResult<FteHistoryQuery, FteHistoryQueryVariables>;
export const GetActiveQuestionnaireDocument = gql`
    query getActiveQuestionnaire {
  activeQuestionnaire {
    id
    version
    title
    description
    questions {
      key
      text
      type
      order
      options
    }
  }
}
    `;

/**
 * __useGetActiveQuestionnaireQuery__
 *
 * To run a query within a React component, call `useGetActiveQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveQuestionnaireQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveQuestionnaireQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveQuestionnaireQuery, GetActiveQuestionnaireQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveQuestionnaireQuery, GetActiveQuestionnaireQueryVariables>(GetActiveQuestionnaireDocument, options);
      }
export function useGetActiveQuestionnaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveQuestionnaireQuery, GetActiveQuestionnaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveQuestionnaireQuery, GetActiveQuestionnaireQueryVariables>(GetActiveQuestionnaireDocument, options);
        }
export function useGetActiveQuestionnaireSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveQuestionnaireQuery, GetActiveQuestionnaireQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveQuestionnaireQuery, GetActiveQuestionnaireQueryVariables>(GetActiveQuestionnaireDocument, options);
        }
export type GetActiveQuestionnaireQueryHookResult = ReturnType<typeof useGetActiveQuestionnaireQuery>;
export type GetActiveQuestionnaireLazyQueryHookResult = ReturnType<typeof useGetActiveQuestionnaireLazyQuery>;
export type GetActiveQuestionnaireSuspenseQueryHookResult = ReturnType<typeof useGetActiveQuestionnaireSuspenseQuery>;
export type GetActiveQuestionnaireQueryResult = Apollo.QueryResult<GetActiveQuestionnaireQuery, GetActiveQuestionnaireQueryVariables>;
export const GetActiveRagValidationsDocument = gql`
    query getActiveRagValidations($companyDomains: [String]!) {
  activeRagValidations(companyDomains: $companyDomains)
}
    `;

/**
 * __useGetActiveRagValidationsQuery__
 *
 * To run a query within a React component, call `useGetActiveRagValidationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveRagValidationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveRagValidationsQuery({
 *   variables: {
 *      companyDomains: // value for 'companyDomains'
 *   },
 * });
 */
export function useGetActiveRagValidationsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveRagValidationsQuery, GetActiveRagValidationsQueryVariables> & ({ variables: GetActiveRagValidationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveRagValidationsQuery, GetActiveRagValidationsQueryVariables>(GetActiveRagValidationsDocument, options);
      }
export function useGetActiveRagValidationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveRagValidationsQuery, GetActiveRagValidationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveRagValidationsQuery, GetActiveRagValidationsQueryVariables>(GetActiveRagValidationsDocument, options);
        }
export function useGetActiveRagValidationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveRagValidationsQuery, GetActiveRagValidationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveRagValidationsQuery, GetActiveRagValidationsQueryVariables>(GetActiveRagValidationsDocument, options);
        }
export type GetActiveRagValidationsQueryHookResult = ReturnType<typeof useGetActiveRagValidationsQuery>;
export type GetActiveRagValidationsLazyQueryHookResult = ReturnType<typeof useGetActiveRagValidationsLazyQuery>;
export type GetActiveRagValidationsSuspenseQueryHookResult = ReturnType<typeof useGetActiveRagValidationsSuspenseQuery>;
export type GetActiveRagValidationsQueryResult = Apollo.QueryResult<GetActiveRagValidationsQuery, GetActiveRagValidationsQueryVariables>;
export const GetAllInvestmentTransactionsDocument = gql`
    query getAllInvestmentTransactions {
  allInvestmentTransactions(first: 300) {
    edges {
      node {
        id
        dbId
        round
        role
        dateOfTransaction
        typeOfTransaction
        amountRaised
        totalAmountRaised
        targetCompany {
          dbId
          shortName
          uniqueDomain
        }
        buyer {
          dbId
          name
        }
        seller {
          dbId
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllInvestmentTransactionsQuery__
 *
 * To run a query within a React component, call `useGetAllInvestmentTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInvestmentTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInvestmentTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllInvestmentTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllInvestmentTransactionsQuery, GetAllInvestmentTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllInvestmentTransactionsQuery, GetAllInvestmentTransactionsQueryVariables>(GetAllInvestmentTransactionsDocument, options);
      }
export function useGetAllInvestmentTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllInvestmentTransactionsQuery, GetAllInvestmentTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllInvestmentTransactionsQuery, GetAllInvestmentTransactionsQueryVariables>(GetAllInvestmentTransactionsDocument, options);
        }
export function useGetAllInvestmentTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllInvestmentTransactionsQuery, GetAllInvestmentTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllInvestmentTransactionsQuery, GetAllInvestmentTransactionsQueryVariables>(GetAllInvestmentTransactionsDocument, options);
        }
export type GetAllInvestmentTransactionsQueryHookResult = ReturnType<typeof useGetAllInvestmentTransactionsQuery>;
export type GetAllInvestmentTransactionsLazyQueryHookResult = ReturnType<typeof useGetAllInvestmentTransactionsLazyQuery>;
export type GetAllInvestmentTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetAllInvestmentTransactionsSuspenseQuery>;
export type GetAllInvestmentTransactionsQueryResult = Apollo.QueryResult<GetAllInvestmentTransactionsQuery, GetAllInvestmentTransactionsQueryVariables>;
export const GetAllShareholdersDocument = gql`
    query getAllShareholders($companyId: Int) {
  getCompany(companyId: $companyId) {
    edges {
      node {
        shareholders {
          edges {
            node {
              dbId
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllShareholdersQuery__
 *
 * To run a query within a React component, call `useGetAllShareholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllShareholdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllShareholdersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetAllShareholdersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllShareholdersQuery, GetAllShareholdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllShareholdersQuery, GetAllShareholdersQueryVariables>(GetAllShareholdersDocument, options);
      }
export function useGetAllShareholdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllShareholdersQuery, GetAllShareholdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllShareholdersQuery, GetAllShareholdersQueryVariables>(GetAllShareholdersDocument, options);
        }
export function useGetAllShareholdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllShareholdersQuery, GetAllShareholdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllShareholdersQuery, GetAllShareholdersQueryVariables>(GetAllShareholdersDocument, options);
        }
export type GetAllShareholdersQueryHookResult = ReturnType<typeof useGetAllShareholdersQuery>;
export type GetAllShareholdersLazyQueryHookResult = ReturnType<typeof useGetAllShareholdersLazyQuery>;
export type GetAllShareholdersSuspenseQueryHookResult = ReturnType<typeof useGetAllShareholdersSuspenseQuery>;
export type GetAllShareholdersQueryResult = Apollo.QueryResult<GetAllShareholdersQuery, GetAllShareholdersQueryVariables>;
export const GetAllShareholdingsDocument = gql`
    query getAllShareholdings($companyId: Int) {
  getCompany(companyId: $companyId) {
    edges {
      node {
        genericShareholdings {
          edges {
            node {
              id
              dbId
              genericShareholderId
              genericCompanyId
              holding
              holdingCount
              shareholdingSold
              genericShareholder {
                dbId
                name
                isPe
                isTradeBuyer
                isNaturalPerson
                yearBornOrFounded
                typeOfInvestor
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllShareholdingsQuery__
 *
 * To run a query within a React component, call `useGetAllShareholdingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllShareholdingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllShareholdingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetAllShareholdingsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllShareholdingsQuery, GetAllShareholdingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllShareholdingsQuery, GetAllShareholdingsQueryVariables>(GetAllShareholdingsDocument, options);
      }
export function useGetAllShareholdingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllShareholdingsQuery, GetAllShareholdingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllShareholdingsQuery, GetAllShareholdingsQueryVariables>(GetAllShareholdingsDocument, options);
        }
export function useGetAllShareholdingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllShareholdingsQuery, GetAllShareholdingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllShareholdingsQuery, GetAllShareholdingsQueryVariables>(GetAllShareholdingsDocument, options);
        }
export type GetAllShareholdingsQueryHookResult = ReturnType<typeof useGetAllShareholdingsQuery>;
export type GetAllShareholdingsLazyQueryHookResult = ReturnType<typeof useGetAllShareholdingsLazyQuery>;
export type GetAllShareholdingsSuspenseQueryHookResult = ReturnType<typeof useGetAllShareholdingsSuspenseQuery>;
export type GetAllShareholdingsQueryResult = Apollo.QueryResult<GetAllShareholdingsQuery, GetAllShareholdingsQueryVariables>;
export const GetAllSicCodesDocument = gql`
    query getAllSicCodes($first: Int, $searchTerm: String) {
  getAllSicCodes(first: $first, searchTerm: $searchTerm) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        sicCodeStr
        description
        id
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetAllSicCodesQuery__
 *
 * To run a query within a React component, call `useGetAllSicCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSicCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSicCodesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetAllSicCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSicCodesQuery, GetAllSicCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSicCodesQuery, GetAllSicCodesQueryVariables>(GetAllSicCodesDocument, options);
      }
export function useGetAllSicCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSicCodesQuery, GetAllSicCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSicCodesQuery, GetAllSicCodesQueryVariables>(GetAllSicCodesDocument, options);
        }
export function useGetAllSicCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSicCodesQuery, GetAllSicCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSicCodesQuery, GetAllSicCodesQueryVariables>(GetAllSicCodesDocument, options);
        }
export type GetAllSicCodesQueryHookResult = ReturnType<typeof useGetAllSicCodesQuery>;
export type GetAllSicCodesLazyQueryHookResult = ReturnType<typeof useGetAllSicCodesLazyQuery>;
export type GetAllSicCodesSuspenseQueryHookResult = ReturnType<typeof useGetAllSicCodesSuspenseQuery>;
export type GetAllSicCodesQueryResult = Apollo.QueryResult<GetAllSicCodesQuery, GetAllSicCodesQueryVariables>;
export const GetAvailableGoogleDrivesDocument = gql`
    query getAvailableGoogleDrives {
  availableGoogleDrives {
    name
  }
}
    `;

/**
 * __useGetAvailableGoogleDrivesQuery__
 *
 * To run a query within a React component, call `useGetAvailableGoogleDrivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableGoogleDrivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableGoogleDrivesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableGoogleDrivesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableGoogleDrivesQuery, GetAvailableGoogleDrivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableGoogleDrivesQuery, GetAvailableGoogleDrivesQueryVariables>(GetAvailableGoogleDrivesDocument, options);
      }
export function useGetAvailableGoogleDrivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableGoogleDrivesQuery, GetAvailableGoogleDrivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableGoogleDrivesQuery, GetAvailableGoogleDrivesQueryVariables>(GetAvailableGoogleDrivesDocument, options);
        }
export function useGetAvailableGoogleDrivesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableGoogleDrivesQuery, GetAvailableGoogleDrivesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableGoogleDrivesQuery, GetAvailableGoogleDrivesQueryVariables>(GetAvailableGoogleDrivesDocument, options);
        }
export type GetAvailableGoogleDrivesQueryHookResult = ReturnType<typeof useGetAvailableGoogleDrivesQuery>;
export type GetAvailableGoogleDrivesLazyQueryHookResult = ReturnType<typeof useGetAvailableGoogleDrivesLazyQuery>;
export type GetAvailableGoogleDrivesSuspenseQueryHookResult = ReturnType<typeof useGetAvailableGoogleDrivesSuspenseQuery>;
export type GetAvailableGoogleDrivesQueryResult = Apollo.QueryResult<GetAvailableGoogleDrivesQuery, GetAvailableGoogleDrivesQueryVariables>;
export const GetBuyAndBuildPlatformsDocument = gql`
    query getBuyAndBuildPlatforms($sortForTargetId: Int, $excludeAddOns: Boolean) {
  getBuyAndBuildPlatforms(
    sortForTargetId: $sortForTargetId
    excludeAddOns: $excludeAddOns
  ) {
    edges {
      cursor
      node {
        dbId
        shortName
        pipedriveId
      }
    }
  }
}
    `;

/**
 * __useGetBuyAndBuildPlatformsQuery__
 *
 * To run a query within a React component, call `useGetBuyAndBuildPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyAndBuildPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyAndBuildPlatformsQuery({
 *   variables: {
 *      sortForTargetId: // value for 'sortForTargetId'
 *      excludeAddOns: // value for 'excludeAddOns'
 *   },
 * });
 */
export function useGetBuyAndBuildPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<GetBuyAndBuildPlatformsQuery, GetBuyAndBuildPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuyAndBuildPlatformsQuery, GetBuyAndBuildPlatformsQueryVariables>(GetBuyAndBuildPlatformsDocument, options);
      }
export function useGetBuyAndBuildPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuyAndBuildPlatformsQuery, GetBuyAndBuildPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuyAndBuildPlatformsQuery, GetBuyAndBuildPlatformsQueryVariables>(GetBuyAndBuildPlatformsDocument, options);
        }
export function useGetBuyAndBuildPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBuyAndBuildPlatformsQuery, GetBuyAndBuildPlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuyAndBuildPlatformsQuery, GetBuyAndBuildPlatformsQueryVariables>(GetBuyAndBuildPlatformsDocument, options);
        }
export type GetBuyAndBuildPlatformsQueryHookResult = ReturnType<typeof useGetBuyAndBuildPlatformsQuery>;
export type GetBuyAndBuildPlatformsLazyQueryHookResult = ReturnType<typeof useGetBuyAndBuildPlatformsLazyQuery>;
export type GetBuyAndBuildPlatformsSuspenseQueryHookResult = ReturnType<typeof useGetBuyAndBuildPlatformsSuspenseQuery>;
export type GetBuyAndBuildPlatformsQueryResult = Apollo.QueryResult<GetBuyAndBuildPlatformsQuery, GetBuyAndBuildPlatformsQueryVariables>;
export const GetCddJobStatusDocument = gql`
    query getCddJobStatus($jobId: ID!) {
  cddJobStatus(jobId: $jobId) {
    jobId
    status
    progress {
      stage
      percent
      message
    }
    result
    error
  }
}
    `;

/**
 * __useGetCddJobStatusQuery__
 *
 * To run a query within a React component, call `useGetCddJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCddJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCddJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetCddJobStatusQuery(baseOptions: Apollo.QueryHookOptions<GetCddJobStatusQuery, GetCddJobStatusQueryVariables> & ({ variables: GetCddJobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCddJobStatusQuery, GetCddJobStatusQueryVariables>(GetCddJobStatusDocument, options);
      }
export function useGetCddJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCddJobStatusQuery, GetCddJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCddJobStatusQuery, GetCddJobStatusQueryVariables>(GetCddJobStatusDocument, options);
        }
export function useGetCddJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCddJobStatusQuery, GetCddJobStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCddJobStatusQuery, GetCddJobStatusQueryVariables>(GetCddJobStatusDocument, options);
        }
export type GetCddJobStatusQueryHookResult = ReturnType<typeof useGetCddJobStatusQuery>;
export type GetCddJobStatusLazyQueryHookResult = ReturnType<typeof useGetCddJobStatusLazyQuery>;
export type GetCddJobStatusSuspenseQueryHookResult = ReturnType<typeof useGetCddJobStatusSuspenseQuery>;
export type GetCddJobStatusQueryResult = Apollo.QueryResult<GetCddJobStatusQuery, GetCddJobStatusQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany($companyId: Int) {
  getCompany(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        legalName
        shortName
        street
        city
        zipCode
        country
        linkedinUrl
        pipedriveId
        hrbNumber
        court
        benchmarkingIndex
        sicCode
        foundingYear
        isSoftwareCompany
        sicCodeCertainty
        sicCodeJustification
        uniqueDomain
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanySuspenseQueryHookResult = ReturnType<typeof useGetCompanySuspenseQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanyForDfmDocument = gql`
    query getCompanyForDFM($companyId: Int) {
  getCompany(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        dbId
        shortName
        pipedriveId
        uniqueDomain
        legalName
        address
        sicCode
        validated
        managingDirector
        contactEmail
        contactEmailType
        linkedinDescription
        hrbNumber
        court
        city
        street
        zipCode
        country
        crawlUrl
        linkedinUrl
        emailPattern
        foundingYear
        latestUrl
        linkedinDescription
        buyAndBuildFocus
        iabDomainCategory
        isRelevant
        contactEnrichmentLog {
          timestamp
          extractionMethod
          contactEmailExtracted
          contactEmailSource
          managingDirectorExtracted
          managingDirectorSource
          hunterCalled
          firecrawlSuccess
          errorMessage
          processingTimeSeconds
        }
        datetimeCreated
        datetimeModified
        companyAnalyses {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            cursor
            node {
              id
              fte
              ebitda
              revenue
            }
          }
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetCompanyForDfmQuery__
 *
 * To run a query within a React component, call `useGetCompanyForDfmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyForDfmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyForDfmQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyForDfmQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyForDfmQuery, GetCompanyForDfmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyForDfmQuery, GetCompanyForDfmQueryVariables>(GetCompanyForDfmDocument, options);
      }
export function useGetCompanyForDfmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyForDfmQuery, GetCompanyForDfmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyForDfmQuery, GetCompanyForDfmQueryVariables>(GetCompanyForDfmDocument, options);
        }
export function useGetCompanyForDfmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyForDfmQuery, GetCompanyForDfmQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyForDfmQuery, GetCompanyForDfmQueryVariables>(GetCompanyForDfmDocument, options);
        }
export type GetCompanyForDfmQueryHookResult = ReturnType<typeof useGetCompanyForDfmQuery>;
export type GetCompanyForDfmLazyQueryHookResult = ReturnType<typeof useGetCompanyForDfmLazyQuery>;
export type GetCompanyForDfmSuspenseQueryHookResult = ReturnType<typeof useGetCompanyForDfmSuspenseQuery>;
export type GetCompanyForDfmQueryResult = Apollo.QueryResult<GetCompanyForDfmQuery, GetCompanyForDfmQueryVariables>;
export const GetCompanyGDriveInfoDocument = gql`
    query getCompanyGDriveInfo($companyId: Int!) {
  getCompany(companyId: $companyId, first: 1) {
    edges {
      node {
        id
        gdriveSharedDriveName
        gdriveDirectoryName
        gdriveSyncStatus {
          lastSyncRequested
          lastSyncCompleted
          totalFilesSynced
          lastFileModified
          isSyncing
          cooldownEndsAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyGDriveInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyGDriveInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyGDriveInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyGDriveInfoQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyGDriveInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyGDriveInfoQuery, GetCompanyGDriveInfoQueryVariables> & ({ variables: GetCompanyGDriveInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyGDriveInfoQuery, GetCompanyGDriveInfoQueryVariables>(GetCompanyGDriveInfoDocument, options);
      }
export function useGetCompanyGDriveInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyGDriveInfoQuery, GetCompanyGDriveInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyGDriveInfoQuery, GetCompanyGDriveInfoQueryVariables>(GetCompanyGDriveInfoDocument, options);
        }
export function useGetCompanyGDriveInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyGDriveInfoQuery, GetCompanyGDriveInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyGDriveInfoQuery, GetCompanyGDriveInfoQueryVariables>(GetCompanyGDriveInfoDocument, options);
        }
export type GetCompanyGDriveInfoQueryHookResult = ReturnType<typeof useGetCompanyGDriveInfoQuery>;
export type GetCompanyGDriveInfoLazyQueryHookResult = ReturnType<typeof useGetCompanyGDriveInfoLazyQuery>;
export type GetCompanyGDriveInfoSuspenseQueryHookResult = ReturnType<typeof useGetCompanyGDriveInfoSuspenseQuery>;
export type GetCompanyGDriveInfoQueryResult = Apollo.QueryResult<GetCompanyGDriveInfoQuery, GetCompanyGDriveInfoQueryVariables>;
export const GetCompanyProductsDocument = gql`
    query getCompanyProducts($companyId: Int!) {
  getCompanyProducts(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        dbId
        productName
        description
        productUrl
        fullProductUrl
        productType
        confidence
        source
        sourceUrl
        fullSourceUrl
        softwareCategory {
          dbId
          subCategory1
          subCategory2
          subCategory3
        }
        pricingModels {
          dbId
          pricingModelType
          tierName
          tierOrdinal
          priceDisplay
          priceNumeric
          priceUnit
          priceUnitNormalized
          priceCadence
          currency
          billingPeriod
          hasFreeTier
          isCustomPricing
          keyFeatures
          confidence
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetCompanyProductsQuery__
 *
 * To run a query within a React component, call `useGetCompanyProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyProductsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyProductsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyProductsQuery, GetCompanyProductsQueryVariables> & ({ variables: GetCompanyProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyProductsQuery, GetCompanyProductsQueryVariables>(GetCompanyProductsDocument, options);
      }
export function useGetCompanyProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyProductsQuery, GetCompanyProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyProductsQuery, GetCompanyProductsQueryVariables>(GetCompanyProductsDocument, options);
        }
export function useGetCompanyProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyProductsQuery, GetCompanyProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyProductsQuery, GetCompanyProductsQueryVariables>(GetCompanyProductsDocument, options);
        }
export type GetCompanyProductsQueryHookResult = ReturnType<typeof useGetCompanyProductsQuery>;
export type GetCompanyProductsLazyQueryHookResult = ReturnType<typeof useGetCompanyProductsLazyQuery>;
export type GetCompanyProductsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyProductsSuspenseQuery>;
export type GetCompanyProductsQueryResult = Apollo.QueryResult<GetCompanyProductsQuery, GetCompanyProductsQueryVariables>;
export const GetCompanySizeDocument = gql`
    query getCompanySize($companyId: Int) {
  getCompany(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        maxFte
        linkedinFte
        sizeJustification
        id
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetCompanySizeQuery__
 *
 * To run a query within a React component, call `useGetCompanySizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySizeQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanySizeQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanySizeQuery, GetCompanySizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanySizeQuery, GetCompanySizeQueryVariables>(GetCompanySizeDocument, options);
      }
export function useGetCompanySizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanySizeQuery, GetCompanySizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanySizeQuery, GetCompanySizeQueryVariables>(GetCompanySizeDocument, options);
        }
export function useGetCompanySizeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanySizeQuery, GetCompanySizeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanySizeQuery, GetCompanySizeQueryVariables>(GetCompanySizeDocument, options);
        }
export type GetCompanySizeQueryHookResult = ReturnType<typeof useGetCompanySizeQuery>;
export type GetCompanySizeLazyQueryHookResult = ReturnType<typeof useGetCompanySizeLazyQuery>;
export type GetCompanySizeSuspenseQueryHookResult = ReturnType<typeof useGetCompanySizeSuspenseQuery>;
export type GetCompanySizeQueryResult = Apollo.QueryResult<GetCompanySizeQuery, GetCompanySizeQueryVariables>;
export const GetCrawlerAlertsDocument = gql`
    query getCrawlerAlerts($startDate: String, $endDate: String) {
  crawlerAlerts(startDate: $startDate, endDate: $endDate) {
    severity
    type
    message
    currentValue
    threshold
  }
}
    `;

/**
 * __useGetCrawlerAlertsQuery__
 *
 * To run a query within a React component, call `useGetCrawlerAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrawlerAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrawlerAlertsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCrawlerAlertsQuery(baseOptions?: Apollo.QueryHookOptions<GetCrawlerAlertsQuery, GetCrawlerAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrawlerAlertsQuery, GetCrawlerAlertsQueryVariables>(GetCrawlerAlertsDocument, options);
      }
export function useGetCrawlerAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrawlerAlertsQuery, GetCrawlerAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrawlerAlertsQuery, GetCrawlerAlertsQueryVariables>(GetCrawlerAlertsDocument, options);
        }
export function useGetCrawlerAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCrawlerAlertsQuery, GetCrawlerAlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCrawlerAlertsQuery, GetCrawlerAlertsQueryVariables>(GetCrawlerAlertsDocument, options);
        }
export type GetCrawlerAlertsQueryHookResult = ReturnType<typeof useGetCrawlerAlertsQuery>;
export type GetCrawlerAlertsLazyQueryHookResult = ReturnType<typeof useGetCrawlerAlertsLazyQuery>;
export type GetCrawlerAlertsSuspenseQueryHookResult = ReturnType<typeof useGetCrawlerAlertsSuspenseQuery>;
export type GetCrawlerAlertsQueryResult = Apollo.QueryResult<GetCrawlerAlertsQuery, GetCrawlerAlertsQueryVariables>;
export const GetCrawlerDomainLeaderboardDocument = gql`
    query getCrawlerDomainLeaderboard($startDate: String!, $endDate: String!, $sortBy: String, $order: String, $limit: Int) {
  crawlerDomainLeaderboard(
    startDate: $startDate
    endDate: $endDate
    sortBy: $sortBy
    order: $order
    limit: $limit
  ) {
    domain
    crawlCount
    executedCount
    lastCrawl
    reputationScore
    reputationCategory
    successCount
    failureCount
    totalRequests
    successRate
    avgResponseTimeMs
    isAllowlisted
    isBlocklisted
  }
}
    `;

/**
 * __useGetCrawlerDomainLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetCrawlerDomainLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrawlerDomainLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrawlerDomainLeaderboardQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sortBy: // value for 'sortBy'
 *      order: // value for 'order'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCrawlerDomainLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<GetCrawlerDomainLeaderboardQuery, GetCrawlerDomainLeaderboardQueryVariables> & ({ variables: GetCrawlerDomainLeaderboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrawlerDomainLeaderboardQuery, GetCrawlerDomainLeaderboardQueryVariables>(GetCrawlerDomainLeaderboardDocument, options);
      }
export function useGetCrawlerDomainLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrawlerDomainLeaderboardQuery, GetCrawlerDomainLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrawlerDomainLeaderboardQuery, GetCrawlerDomainLeaderboardQueryVariables>(GetCrawlerDomainLeaderboardDocument, options);
        }
export function useGetCrawlerDomainLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCrawlerDomainLeaderboardQuery, GetCrawlerDomainLeaderboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCrawlerDomainLeaderboardQuery, GetCrawlerDomainLeaderboardQueryVariables>(GetCrawlerDomainLeaderboardDocument, options);
        }
export type GetCrawlerDomainLeaderboardQueryHookResult = ReturnType<typeof useGetCrawlerDomainLeaderboardQuery>;
export type GetCrawlerDomainLeaderboardLazyQueryHookResult = ReturnType<typeof useGetCrawlerDomainLeaderboardLazyQuery>;
export type GetCrawlerDomainLeaderboardSuspenseQueryHookResult = ReturnType<typeof useGetCrawlerDomainLeaderboardSuspenseQuery>;
export type GetCrawlerDomainLeaderboardQueryResult = Apollo.QueryResult<GetCrawlerDomainLeaderboardQuery, GetCrawlerDomainLeaderboardQueryVariables>;
export const GetCrawlerErrorBreakdownDocument = gql`
    query getCrawlerErrorBreakdown($startDate: String!, $endDate: String!) {
  crawlerErrorBreakdown(startDate: $startDate, endDate: $endDate) {
    totalFailures
    categories {
      blocked
      poorReputation
      fairReputation
    }
    errorRate
  }
}
    `;

/**
 * __useGetCrawlerErrorBreakdownQuery__
 *
 * To run a query within a React component, call `useGetCrawlerErrorBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrawlerErrorBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrawlerErrorBreakdownQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCrawlerErrorBreakdownQuery(baseOptions: Apollo.QueryHookOptions<GetCrawlerErrorBreakdownQuery, GetCrawlerErrorBreakdownQueryVariables> & ({ variables: GetCrawlerErrorBreakdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrawlerErrorBreakdownQuery, GetCrawlerErrorBreakdownQueryVariables>(GetCrawlerErrorBreakdownDocument, options);
      }
export function useGetCrawlerErrorBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrawlerErrorBreakdownQuery, GetCrawlerErrorBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrawlerErrorBreakdownQuery, GetCrawlerErrorBreakdownQueryVariables>(GetCrawlerErrorBreakdownDocument, options);
        }
export function useGetCrawlerErrorBreakdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCrawlerErrorBreakdownQuery, GetCrawlerErrorBreakdownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCrawlerErrorBreakdownQuery, GetCrawlerErrorBreakdownQueryVariables>(GetCrawlerErrorBreakdownDocument, options);
        }
export type GetCrawlerErrorBreakdownQueryHookResult = ReturnType<typeof useGetCrawlerErrorBreakdownQuery>;
export type GetCrawlerErrorBreakdownLazyQueryHookResult = ReturnType<typeof useGetCrawlerErrorBreakdownLazyQuery>;
export type GetCrawlerErrorBreakdownSuspenseQueryHookResult = ReturnType<typeof useGetCrawlerErrorBreakdownSuspenseQuery>;
export type GetCrawlerErrorBreakdownQueryResult = Apollo.QueryResult<GetCrawlerErrorBreakdownQuery, GetCrawlerErrorBreakdownQueryVariables>;
export const GetCrawlerFindingTokensDocument = gql`
    query getCrawlerFindingTokens($companyId: Int) {
  getCrawlerFindingTokens(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        url
        fte
        isImageFinding
        isTextFinding
        imageUrl
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetCrawlerFindingTokensQuery__
 *
 * To run a query within a React component, call `useGetCrawlerFindingTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrawlerFindingTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrawlerFindingTokensQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCrawlerFindingTokensQuery(baseOptions?: Apollo.QueryHookOptions<GetCrawlerFindingTokensQuery, GetCrawlerFindingTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrawlerFindingTokensQuery, GetCrawlerFindingTokensQueryVariables>(GetCrawlerFindingTokensDocument, options);
      }
export function useGetCrawlerFindingTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrawlerFindingTokensQuery, GetCrawlerFindingTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrawlerFindingTokensQuery, GetCrawlerFindingTokensQueryVariables>(GetCrawlerFindingTokensDocument, options);
        }
export function useGetCrawlerFindingTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCrawlerFindingTokensQuery, GetCrawlerFindingTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCrawlerFindingTokensQuery, GetCrawlerFindingTokensQueryVariables>(GetCrawlerFindingTokensDocument, options);
        }
export type GetCrawlerFindingTokensQueryHookResult = ReturnType<typeof useGetCrawlerFindingTokensQuery>;
export type GetCrawlerFindingTokensLazyQueryHookResult = ReturnType<typeof useGetCrawlerFindingTokensLazyQuery>;
export type GetCrawlerFindingTokensSuspenseQueryHookResult = ReturnType<typeof useGetCrawlerFindingTokensSuspenseQuery>;
export type GetCrawlerFindingTokensQueryResult = Apollo.QueryResult<GetCrawlerFindingTokensQuery, GetCrawlerFindingTokensQueryVariables>;
export const GetCrawlerOverviewDocument = gql`
    query getCrawlerOverview($startDate: String, $endDate: String) {
  crawlerOverview(startDate: $startDate, endDate: $endDate) {
    totalRequests
    successCount
    failureCount
    successRate
    avgResponseTimeMs
    totalCrawls
    executedCrawls
    skippedCrawls
    trend {
      changePct
      direction
    }
    timestamp
  }
}
    `;

/**
 * __useGetCrawlerOverviewQuery__
 *
 * To run a query within a React component, call `useGetCrawlerOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrawlerOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrawlerOverviewQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCrawlerOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetCrawlerOverviewQuery, GetCrawlerOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrawlerOverviewQuery, GetCrawlerOverviewQueryVariables>(GetCrawlerOverviewDocument, options);
      }
export function useGetCrawlerOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrawlerOverviewQuery, GetCrawlerOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrawlerOverviewQuery, GetCrawlerOverviewQueryVariables>(GetCrawlerOverviewDocument, options);
        }
export function useGetCrawlerOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCrawlerOverviewQuery, GetCrawlerOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCrawlerOverviewQuery, GetCrawlerOverviewQueryVariables>(GetCrawlerOverviewDocument, options);
        }
export type GetCrawlerOverviewQueryHookResult = ReturnType<typeof useGetCrawlerOverviewQuery>;
export type GetCrawlerOverviewLazyQueryHookResult = ReturnType<typeof useGetCrawlerOverviewLazyQuery>;
export type GetCrawlerOverviewSuspenseQueryHookResult = ReturnType<typeof useGetCrawlerOverviewSuspenseQuery>;
export type GetCrawlerOverviewQueryResult = Apollo.QueryResult<GetCrawlerOverviewQuery, GetCrawlerOverviewQueryVariables>;
export const GetCrawlerTimelineDocument = gql`
    query getCrawlerTimeline($startDate: String!, $endDate: String!, $interval: String) {
  crawlerTimeline(startDate: $startDate, endDate: $endDate, interval: $interval) {
    timestamp
    totalCount
    executedCount
    skippedCount
    successRate
  }
}
    `;

/**
 * __useGetCrawlerTimelineQuery__
 *
 * To run a query within a React component, call `useGetCrawlerTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrawlerTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrawlerTimelineQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useGetCrawlerTimelineQuery(baseOptions: Apollo.QueryHookOptions<GetCrawlerTimelineQuery, GetCrawlerTimelineQueryVariables> & ({ variables: GetCrawlerTimelineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrawlerTimelineQuery, GetCrawlerTimelineQueryVariables>(GetCrawlerTimelineDocument, options);
      }
export function useGetCrawlerTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrawlerTimelineQuery, GetCrawlerTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrawlerTimelineQuery, GetCrawlerTimelineQueryVariables>(GetCrawlerTimelineDocument, options);
        }
export function useGetCrawlerTimelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCrawlerTimelineQuery, GetCrawlerTimelineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCrawlerTimelineQuery, GetCrawlerTimelineQueryVariables>(GetCrawlerTimelineDocument, options);
        }
export type GetCrawlerTimelineQueryHookResult = ReturnType<typeof useGetCrawlerTimelineQuery>;
export type GetCrawlerTimelineLazyQueryHookResult = ReturnType<typeof useGetCrawlerTimelineLazyQuery>;
export type GetCrawlerTimelineSuspenseQueryHookResult = ReturnType<typeof useGetCrawlerTimelineSuspenseQuery>;
export type GetCrawlerTimelineQueryResult = Apollo.QueryResult<GetCrawlerTimelineQuery, GetCrawlerTimelineQueryVariables>;
export const GetCustomerReferencesDocument = gql`
    query getCustomerReferences($companyId: Int!) {
  getCustomerReferences(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        IAB1
        shortName
        crawlUrl
        findingUrl
        genericCustomer
        ISDd
        sicCode
        IAB2
        IAB3
        dbId
        shareOfRevenue
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetCustomerReferencesQuery__
 *
 * To run a query within a React component, call `useGetCustomerReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerReferencesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCustomerReferencesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerReferencesQuery, GetCustomerReferencesQueryVariables> & ({ variables: GetCustomerReferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerReferencesQuery, GetCustomerReferencesQueryVariables>(GetCustomerReferencesDocument, options);
      }
export function useGetCustomerReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerReferencesQuery, GetCustomerReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerReferencesQuery, GetCustomerReferencesQueryVariables>(GetCustomerReferencesDocument, options);
        }
export function useGetCustomerReferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerReferencesQuery, GetCustomerReferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerReferencesQuery, GetCustomerReferencesQueryVariables>(GetCustomerReferencesDocument, options);
        }
export type GetCustomerReferencesQueryHookResult = ReturnType<typeof useGetCustomerReferencesQuery>;
export type GetCustomerReferencesLazyQueryHookResult = ReturnType<typeof useGetCustomerReferencesLazyQuery>;
export type GetCustomerReferencesSuspenseQueryHookResult = ReturnType<typeof useGetCustomerReferencesSuspenseQuery>;
export type GetCustomerReferencesQueryResult = Apollo.QueryResult<GetCustomerReferencesQuery, GetCustomerReferencesQueryVariables>;
export const GetEmailOfAuthUserDocument = gql`
    query getEmailOfAuthUser($authId: String!) {
  userEmailByAuthId(authId: $authId)
}
    `;

/**
 * __useGetEmailOfAuthUserQuery__
 *
 * To run a query within a React component, call `useGetEmailOfAuthUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailOfAuthUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailOfAuthUserQuery({
 *   variables: {
 *      authId: // value for 'authId'
 *   },
 * });
 */
export function useGetEmailOfAuthUserQuery(baseOptions: Apollo.QueryHookOptions<GetEmailOfAuthUserQuery, GetEmailOfAuthUserQueryVariables> & ({ variables: GetEmailOfAuthUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailOfAuthUserQuery, GetEmailOfAuthUserQueryVariables>(GetEmailOfAuthUserDocument, options);
      }
export function useGetEmailOfAuthUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailOfAuthUserQuery, GetEmailOfAuthUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailOfAuthUserQuery, GetEmailOfAuthUserQueryVariables>(GetEmailOfAuthUserDocument, options);
        }
export function useGetEmailOfAuthUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailOfAuthUserQuery, GetEmailOfAuthUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailOfAuthUserQuery, GetEmailOfAuthUserQueryVariables>(GetEmailOfAuthUserDocument, options);
        }
export type GetEmailOfAuthUserQueryHookResult = ReturnType<typeof useGetEmailOfAuthUserQuery>;
export type GetEmailOfAuthUserLazyQueryHookResult = ReturnType<typeof useGetEmailOfAuthUserLazyQuery>;
export type GetEmailOfAuthUserSuspenseQueryHookResult = ReturnType<typeof useGetEmailOfAuthUserSuspenseQuery>;
export type GetEmailOfAuthUserQueryResult = Apollo.QueryResult<GetEmailOfAuthUserQuery, GetEmailOfAuthUserQueryVariables>;
export const GetGenericCrawlResultIdDocument = gql`
    query getGenericCrawlResultId($companyId: Int!) {
  getCrawlResults(companyId: $companyId) {
    edges {
      node {
        dbId
      }
    }
  }
}
    `;

/**
 * __useGetGenericCrawlResultIdQuery__
 *
 * To run a query within a React component, call `useGetGenericCrawlResultIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericCrawlResultIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericCrawlResultIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetGenericCrawlResultIdQuery(baseOptions: Apollo.QueryHookOptions<GetGenericCrawlResultIdQuery, GetGenericCrawlResultIdQueryVariables> & ({ variables: GetGenericCrawlResultIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericCrawlResultIdQuery, GetGenericCrawlResultIdQueryVariables>(GetGenericCrawlResultIdDocument, options);
      }
export function useGetGenericCrawlResultIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericCrawlResultIdQuery, GetGenericCrawlResultIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericCrawlResultIdQuery, GetGenericCrawlResultIdQueryVariables>(GetGenericCrawlResultIdDocument, options);
        }
export function useGetGenericCrawlResultIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericCrawlResultIdQuery, GetGenericCrawlResultIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericCrawlResultIdQuery, GetGenericCrawlResultIdQueryVariables>(GetGenericCrawlResultIdDocument, options);
        }
export type GetGenericCrawlResultIdQueryHookResult = ReturnType<typeof useGetGenericCrawlResultIdQuery>;
export type GetGenericCrawlResultIdLazyQueryHookResult = ReturnType<typeof useGetGenericCrawlResultIdLazyQuery>;
export type GetGenericCrawlResultIdSuspenseQueryHookResult = ReturnType<typeof useGetGenericCrawlResultIdSuspenseQuery>;
export type GetGenericCrawlResultIdQueryResult = Apollo.QueryResult<GetGenericCrawlResultIdQuery, GetGenericCrawlResultIdQueryVariables>;
export const GetIndustryBenchmarkDataDocument = gql`
    query GetIndustryBenchmarkData {
  industryBenchmarkData {
    id
    identifier
    name
    url
    year
    date
    region
    country
    sic
    ebitdaAssets
    oneYearSalesGrowth
    evAssets
    ebitdaSales
    zScore
    evEbitda
    genericCompanyId
  }
  sicCodes {
    sicCodeInt
    description
  }
}
    `;

/**
 * __useGetIndustryBenchmarkDataQuery__
 *
 * To run a query within a React component, call `useGetIndustryBenchmarkDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustryBenchmarkDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustryBenchmarkDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIndustryBenchmarkDataQuery(baseOptions?: Apollo.QueryHookOptions<GetIndustryBenchmarkDataQuery, GetIndustryBenchmarkDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustryBenchmarkDataQuery, GetIndustryBenchmarkDataQueryVariables>(GetIndustryBenchmarkDataDocument, options);
      }
export function useGetIndustryBenchmarkDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustryBenchmarkDataQuery, GetIndustryBenchmarkDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustryBenchmarkDataQuery, GetIndustryBenchmarkDataQueryVariables>(GetIndustryBenchmarkDataDocument, options);
        }
export function useGetIndustryBenchmarkDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryBenchmarkDataQuery, GetIndustryBenchmarkDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustryBenchmarkDataQuery, GetIndustryBenchmarkDataQueryVariables>(GetIndustryBenchmarkDataDocument, options);
        }
export type GetIndustryBenchmarkDataQueryHookResult = ReturnType<typeof useGetIndustryBenchmarkDataQuery>;
export type GetIndustryBenchmarkDataLazyQueryHookResult = ReturnType<typeof useGetIndustryBenchmarkDataLazyQuery>;
export type GetIndustryBenchmarkDataSuspenseQueryHookResult = ReturnType<typeof useGetIndustryBenchmarkDataSuspenseQuery>;
export type GetIndustryBenchmarkDataQueryResult = Apollo.QueryResult<GetIndustryBenchmarkDataQuery, GetIndustryBenchmarkDataQueryVariables>;
export const GetKeywordsForCompanyDocument = gql`
    query getKeywordsForCompany($companyId: Int) {
  getCompany(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        crawlResults {
          edges {
            node {
              dbId
              xoviKeywords {
                edges {
                  node {
                    dbId
                    id
                    keyword
                    searchEngine
                    position
                    cpc
                    sevo
                    competitorDensity
                    markedAsIrrelevant
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetKeywordsForCompanyQuery__
 *
 * To run a query within a React component, call `useGetKeywordsForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeywordsForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeywordsForCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetKeywordsForCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetKeywordsForCompanyQuery, GetKeywordsForCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeywordsForCompanyQuery, GetKeywordsForCompanyQueryVariables>(GetKeywordsForCompanyDocument, options);
      }
export function useGetKeywordsForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeywordsForCompanyQuery, GetKeywordsForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeywordsForCompanyQuery, GetKeywordsForCompanyQueryVariables>(GetKeywordsForCompanyDocument, options);
        }
export function useGetKeywordsForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKeywordsForCompanyQuery, GetKeywordsForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKeywordsForCompanyQuery, GetKeywordsForCompanyQueryVariables>(GetKeywordsForCompanyDocument, options);
        }
export type GetKeywordsForCompanyQueryHookResult = ReturnType<typeof useGetKeywordsForCompanyQuery>;
export type GetKeywordsForCompanyLazyQueryHookResult = ReturnType<typeof useGetKeywordsForCompanyLazyQuery>;
export type GetKeywordsForCompanySuspenseQueryHookResult = ReturnType<typeof useGetKeywordsForCompanySuspenseQuery>;
export type GetKeywordsForCompanyQueryResult = Apollo.QueryResult<GetKeywordsForCompanyQuery, GetKeywordsForCompanyQueryVariables>;
export const GetLatestCrawlRunDocument = gql`
    query getLatestCrawlRun($companyId: Int!) {
  getLatestCrawlRun(companyId: $companyId) {
    dbId
    startedAt
    finishedAt
    status
    triggeredBy
    steps {
      dbId
      stepName
      sequence
      startTime
      finishTime
      status
      success
      failed
      noOfAttempts
      errorMessage
    }
  }
}
    `;

/**
 * __useGetLatestCrawlRunQuery__
 *
 * To run a query within a React component, call `useGetLatestCrawlRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestCrawlRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestCrawlRunQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetLatestCrawlRunQuery(baseOptions: Apollo.QueryHookOptions<GetLatestCrawlRunQuery, GetLatestCrawlRunQueryVariables> & ({ variables: GetLatestCrawlRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestCrawlRunQuery, GetLatestCrawlRunQueryVariables>(GetLatestCrawlRunDocument, options);
      }
export function useGetLatestCrawlRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestCrawlRunQuery, GetLatestCrawlRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestCrawlRunQuery, GetLatestCrawlRunQueryVariables>(GetLatestCrawlRunDocument, options);
        }
export function useGetLatestCrawlRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestCrawlRunQuery, GetLatestCrawlRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestCrawlRunQuery, GetLatestCrawlRunQueryVariables>(GetLatestCrawlRunDocument, options);
        }
export type GetLatestCrawlRunQueryHookResult = ReturnType<typeof useGetLatestCrawlRunQuery>;
export type GetLatestCrawlRunLazyQueryHookResult = ReturnType<typeof useGetLatestCrawlRunLazyQuery>;
export type GetLatestCrawlRunSuspenseQueryHookResult = ReturnType<typeof useGetLatestCrawlRunSuspenseQuery>;
export type GetLatestCrawlRunQueryResult = Apollo.QueryResult<GetLatestCrawlRunQuery, GetLatestCrawlRunQueryVariables>;
export const GetNameOfAuthUserDocument = gql`
    query getNameOfAuthUser($authId: String!) {
  userNameByAuthId(authId: $authId)
}
    `;

/**
 * __useGetNameOfAuthUserQuery__
 *
 * To run a query within a React component, call `useGetNameOfAuthUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNameOfAuthUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNameOfAuthUserQuery({
 *   variables: {
 *      authId: // value for 'authId'
 *   },
 * });
 */
export function useGetNameOfAuthUserQuery(baseOptions: Apollo.QueryHookOptions<GetNameOfAuthUserQuery, GetNameOfAuthUserQueryVariables> & ({ variables: GetNameOfAuthUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNameOfAuthUserQuery, GetNameOfAuthUserQueryVariables>(GetNameOfAuthUserDocument, options);
      }
export function useGetNameOfAuthUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNameOfAuthUserQuery, GetNameOfAuthUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNameOfAuthUserQuery, GetNameOfAuthUserQueryVariables>(GetNameOfAuthUserDocument, options);
        }
export function useGetNameOfAuthUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNameOfAuthUserQuery, GetNameOfAuthUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNameOfAuthUserQuery, GetNameOfAuthUserQueryVariables>(GetNameOfAuthUserDocument, options);
        }
export type GetNameOfAuthUserQueryHookResult = ReturnType<typeof useGetNameOfAuthUserQuery>;
export type GetNameOfAuthUserLazyQueryHookResult = ReturnType<typeof useGetNameOfAuthUserLazyQuery>;
export type GetNameOfAuthUserSuspenseQueryHookResult = ReturnType<typeof useGetNameOfAuthUserSuspenseQuery>;
export type GetNameOfAuthUserQueryResult = Apollo.QueryResult<GetNameOfAuthUserQuery, GetNameOfAuthUserQueryVariables>;
export const GetNextBatchRunDocument = gql`
    query getNextBatchRun {
  getNextBatchRun {
    nextRunUtc
    enabled
    scheduleLabel
    weekdaySchedule
    weekendSchedule
  }
}
    `;

/**
 * __useGetNextBatchRunQuery__
 *
 * To run a query within a React component, call `useGetNextBatchRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextBatchRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextBatchRunQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextBatchRunQuery(baseOptions?: Apollo.QueryHookOptions<GetNextBatchRunQuery, GetNextBatchRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextBatchRunQuery, GetNextBatchRunQueryVariables>(GetNextBatchRunDocument, options);
      }
export function useGetNextBatchRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextBatchRunQuery, GetNextBatchRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextBatchRunQuery, GetNextBatchRunQueryVariables>(GetNextBatchRunDocument, options);
        }
export function useGetNextBatchRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNextBatchRunQuery, GetNextBatchRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNextBatchRunQuery, GetNextBatchRunQueryVariables>(GetNextBatchRunDocument, options);
        }
export type GetNextBatchRunQueryHookResult = ReturnType<typeof useGetNextBatchRunQuery>;
export type GetNextBatchRunLazyQueryHookResult = ReturnType<typeof useGetNextBatchRunLazyQuery>;
export type GetNextBatchRunSuspenseQueryHookResult = ReturnType<typeof useGetNextBatchRunSuspenseQuery>;
export type GetNextBatchRunQueryResult = Apollo.QueryResult<GetNextBatchRunQuery, GetNextBatchRunQueryVariables>;
export const GetOpenaiVotesDocument = gql`
    query getOpenaiVotes($companyId: Int) {
  getOpenaiVotes(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        softwareVotes
        serviceVotes
        undecidable
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetOpenaiVotesQuery__
 *
 * To run a query within a React component, call `useGetOpenaiVotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenaiVotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenaiVotesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetOpenaiVotesQuery(baseOptions?: Apollo.QueryHookOptions<GetOpenaiVotesQuery, GetOpenaiVotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenaiVotesQuery, GetOpenaiVotesQueryVariables>(GetOpenaiVotesDocument, options);
      }
export function useGetOpenaiVotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenaiVotesQuery, GetOpenaiVotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenaiVotesQuery, GetOpenaiVotesQueryVariables>(GetOpenaiVotesDocument, options);
        }
export function useGetOpenaiVotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOpenaiVotesQuery, GetOpenaiVotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpenaiVotesQuery, GetOpenaiVotesQueryVariables>(GetOpenaiVotesDocument, options);
        }
export type GetOpenaiVotesQueryHookResult = ReturnType<typeof useGetOpenaiVotesQuery>;
export type GetOpenaiVotesLazyQueryHookResult = ReturnType<typeof useGetOpenaiVotesLazyQuery>;
export type GetOpenaiVotesSuspenseQueryHookResult = ReturnType<typeof useGetOpenaiVotesSuspenseQuery>;
export type GetOpenaiVotesQueryResult = Apollo.QueryResult<GetOpenaiVotesQuery, GetOpenaiVotesQueryVariables>;
export const GetPipedriveOrganizationDocument = gql`
    query GetPipedriveOrganization($pipedriveId: Int, $companyDomain: String) {
  getPipedriveOrganization(
    pipedriveId: $pipedriveId
    companyDomain: $companyDomain
  ) {
    organizationId
    name
    deals {
      dealId
      title
      stage
      status
      lostReason
    }
  }
}
    `;

/**
 * __useGetPipedriveOrganizationQuery__
 *
 * To run a query within a React component, call `useGetPipedriveOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipedriveOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipedriveOrganizationQuery({
 *   variables: {
 *      pipedriveId: // value for 'pipedriveId'
 *      companyDomain: // value for 'companyDomain'
 *   },
 * });
 */
export function useGetPipedriveOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetPipedriveOrganizationQuery, GetPipedriveOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPipedriveOrganizationQuery, GetPipedriveOrganizationQueryVariables>(GetPipedriveOrganizationDocument, options);
      }
export function useGetPipedriveOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPipedriveOrganizationQuery, GetPipedriveOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPipedriveOrganizationQuery, GetPipedriveOrganizationQueryVariables>(GetPipedriveOrganizationDocument, options);
        }
export function useGetPipedriveOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPipedriveOrganizationQuery, GetPipedriveOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPipedriveOrganizationQuery, GetPipedriveOrganizationQueryVariables>(GetPipedriveOrganizationDocument, options);
        }
export type GetPipedriveOrganizationQueryHookResult = ReturnType<typeof useGetPipedriveOrganizationQuery>;
export type GetPipedriveOrganizationLazyQueryHookResult = ReturnType<typeof useGetPipedriveOrganizationLazyQuery>;
export type GetPipedriveOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetPipedriveOrganizationSuspenseQuery>;
export type GetPipedriveOrganizationQueryResult = Apollo.QueryResult<GetPipedriveOrganizationQuery, GetPipedriveOrganizationQueryVariables>;
export const GetProductCategoriesForCompanyDocument = gql`
    query getProductCategoriesForCompany($companyId: Int) {
  getCompany(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        productCategorization {
          edges {
            node {
              id
              dbId
              softwareCategory {
                dbId
                subCategory1
                subCategory2
                subCategory3
                g2Url
              }
              softwareCategoryCertainty
            }
          }
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetProductCategoriesForCompanyQuery__
 *
 * To run a query within a React component, call `useGetProductCategoriesForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoriesForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoriesForCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetProductCategoriesForCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCategoriesForCompanyQuery, GetProductCategoriesForCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoriesForCompanyQuery, GetProductCategoriesForCompanyQueryVariables>(GetProductCategoriesForCompanyDocument, options);
      }
export function useGetProductCategoriesForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoriesForCompanyQuery, GetProductCategoriesForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoriesForCompanyQuery, GetProductCategoriesForCompanyQueryVariables>(GetProductCategoriesForCompanyDocument, options);
        }
export function useGetProductCategoriesForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductCategoriesForCompanyQuery, GetProductCategoriesForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductCategoriesForCompanyQuery, GetProductCategoriesForCompanyQueryVariables>(GetProductCategoriesForCompanyDocument, options);
        }
export type GetProductCategoriesForCompanyQueryHookResult = ReturnType<typeof useGetProductCategoriesForCompanyQuery>;
export type GetProductCategoriesForCompanyLazyQueryHookResult = ReturnType<typeof useGetProductCategoriesForCompanyLazyQuery>;
export type GetProductCategoriesForCompanySuspenseQueryHookResult = ReturnType<typeof useGetProductCategoriesForCompanySuspenseQuery>;
export type GetProductCategoriesForCompanyQueryResult = Apollo.QueryResult<GetProductCategoriesForCompanyQuery, GetProductCategoriesForCompanyQueryVariables>;
export const GetProgrammingLanguagesDocument = gql`
    query getProgrammingLanguages($companyId: Int) {
  getProgrammingLanguages(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        dbId
        name
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetProgrammingLanguagesQuery__
 *
 * To run a query within a React component, call `useGetProgrammingLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgrammingLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgrammingLanguagesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetProgrammingLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<GetProgrammingLanguagesQuery, GetProgrammingLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgrammingLanguagesQuery, GetProgrammingLanguagesQueryVariables>(GetProgrammingLanguagesDocument, options);
      }
export function useGetProgrammingLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgrammingLanguagesQuery, GetProgrammingLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgrammingLanguagesQuery, GetProgrammingLanguagesQueryVariables>(GetProgrammingLanguagesDocument, options);
        }
export function useGetProgrammingLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgrammingLanguagesQuery, GetProgrammingLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgrammingLanguagesQuery, GetProgrammingLanguagesQueryVariables>(GetProgrammingLanguagesDocument, options);
        }
export type GetProgrammingLanguagesQueryHookResult = ReturnType<typeof useGetProgrammingLanguagesQuery>;
export type GetProgrammingLanguagesLazyQueryHookResult = ReturnType<typeof useGetProgrammingLanguagesLazyQuery>;
export type GetProgrammingLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetProgrammingLanguagesSuspenseQuery>;
export type GetProgrammingLanguagesQueryResult = Apollo.QueryResult<GetProgrammingLanguagesQuery, GetProgrammingLanguagesQueryVariables>;
export const GetQuestionnaireVersionsDocument = gql`
    query getQuestionnaireVersions {
  questionnaireVersions {
    id
    version
    title
    effectiveFrom
    effectiveUntil
  }
}
    `;

/**
 * __useGetQuestionnaireVersionsQuery__
 *
 * To run a query within a React component, call `useGetQuestionnaireVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionnaireVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuestionnaireVersionsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuestionnaireVersionsQuery, GetQuestionnaireVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionnaireVersionsQuery, GetQuestionnaireVersionsQueryVariables>(GetQuestionnaireVersionsDocument, options);
      }
export function useGetQuestionnaireVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionnaireVersionsQuery, GetQuestionnaireVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionnaireVersionsQuery, GetQuestionnaireVersionsQueryVariables>(GetQuestionnaireVersionsDocument, options);
        }
export function useGetQuestionnaireVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionnaireVersionsQuery, GetQuestionnaireVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionnaireVersionsQuery, GetQuestionnaireVersionsQueryVariables>(GetQuestionnaireVersionsDocument, options);
        }
export type GetQuestionnaireVersionsQueryHookResult = ReturnType<typeof useGetQuestionnaireVersionsQuery>;
export type GetQuestionnaireVersionsLazyQueryHookResult = ReturnType<typeof useGetQuestionnaireVersionsLazyQuery>;
export type GetQuestionnaireVersionsSuspenseQueryHookResult = ReturnType<typeof useGetQuestionnaireVersionsSuspenseQuery>;
export type GetQuestionnaireVersionsQueryResult = Apollo.QueryResult<GetQuestionnaireVersionsQuery, GetQuestionnaireVersionsQueryVariables>;
export const GetRagJobStatusDocument = gql`
    query getRagJobStatus($jobId: ID!) {
  ragJobStatus(jobId: $jobId) {
    jobId
    status
    progress {
      stage
      percent
      message
    }
    result
    error
  }
}
    `;

/**
 * __useGetRagJobStatusQuery__
 *
 * To run a query within a React component, call `useGetRagJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRagJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRagJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetRagJobStatusQuery(baseOptions: Apollo.QueryHookOptions<GetRagJobStatusQuery, GetRagJobStatusQueryVariables> & ({ variables: GetRagJobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRagJobStatusQuery, GetRagJobStatusQueryVariables>(GetRagJobStatusDocument, options);
      }
export function useGetRagJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRagJobStatusQuery, GetRagJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRagJobStatusQuery, GetRagJobStatusQueryVariables>(GetRagJobStatusDocument, options);
        }
export function useGetRagJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRagJobStatusQuery, GetRagJobStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRagJobStatusQuery, GetRagJobStatusQueryVariables>(GetRagJobStatusDocument, options);
        }
export type GetRagJobStatusQueryHookResult = ReturnType<typeof useGetRagJobStatusQuery>;
export type GetRagJobStatusLazyQueryHookResult = ReturnType<typeof useGetRagJobStatusLazyQuery>;
export type GetRagJobStatusSuspenseQueryHookResult = ReturnType<typeof useGetRagJobStatusSuspenseQuery>;
export type GetRagJobStatusQueryResult = Apollo.QueryResult<GetRagJobStatusQuery, GetRagJobStatusQueryVariables>;
export const GetResearchSoftwareCategoriesDocument = gql`
    query getResearchSoftwareCategories($subCategory1: String, $subCategory2: String, $subCategory3: String) {
  getSoftwareCategories(
    subCategory1: $subCategory1
    subCategory2: $subCategory2
    subCategory3: $subCategory3
  ) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        subCategory1
        subCategory2
        subCategory3
        categoryDescription
        googleTerm {
          googleTrends {
            interest
            date
          }
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetResearchSoftwareCategoriesQuery__
 *
 * To run a query within a React component, call `useGetResearchSoftwareCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResearchSoftwareCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResearchSoftwareCategoriesQuery({
 *   variables: {
 *      subCategory1: // value for 'subCategory1'
 *      subCategory2: // value for 'subCategory2'
 *      subCategory3: // value for 'subCategory3'
 *   },
 * });
 */
export function useGetResearchSoftwareCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetResearchSoftwareCategoriesQuery, GetResearchSoftwareCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResearchSoftwareCategoriesQuery, GetResearchSoftwareCategoriesQueryVariables>(GetResearchSoftwareCategoriesDocument, options);
      }
export function useGetResearchSoftwareCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResearchSoftwareCategoriesQuery, GetResearchSoftwareCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResearchSoftwareCategoriesQuery, GetResearchSoftwareCategoriesQueryVariables>(GetResearchSoftwareCategoriesDocument, options);
        }
export function useGetResearchSoftwareCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResearchSoftwareCategoriesQuery, GetResearchSoftwareCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResearchSoftwareCategoriesQuery, GetResearchSoftwareCategoriesQueryVariables>(GetResearchSoftwareCategoriesDocument, options);
        }
export type GetResearchSoftwareCategoriesQueryHookResult = ReturnType<typeof useGetResearchSoftwareCategoriesQuery>;
export type GetResearchSoftwareCategoriesLazyQueryHookResult = ReturnType<typeof useGetResearchSoftwareCategoriesLazyQuery>;
export type GetResearchSoftwareCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetResearchSoftwareCategoriesSuspenseQuery>;
export type GetResearchSoftwareCategoriesQueryResult = Apollo.QueryResult<GetResearchSoftwareCategoriesQuery, GetResearchSoftwareCategoriesQueryVariables>;
export const GetShortCompanyDocument = gql`
    query getShortCompany($companyId: Int) {
  getCompany(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        dbId
        shortName
        uniqueDomain
        linkedinUrl
        crawlUrl
        hasBeenValidated
        latestCrawlResult {
          dbId
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetShortCompanyQuery__
 *
 * To run a query within a React component, call `useGetShortCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShortCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShortCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetShortCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetShortCompanyQuery, GetShortCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShortCompanyQuery, GetShortCompanyQueryVariables>(GetShortCompanyDocument, options);
      }
export function useGetShortCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShortCompanyQuery, GetShortCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShortCompanyQuery, GetShortCompanyQueryVariables>(GetShortCompanyDocument, options);
        }
export function useGetShortCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShortCompanyQuery, GetShortCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShortCompanyQuery, GetShortCompanyQueryVariables>(GetShortCompanyDocument, options);
        }
export type GetShortCompanyQueryHookResult = ReturnType<typeof useGetShortCompanyQuery>;
export type GetShortCompanyLazyQueryHookResult = ReturnType<typeof useGetShortCompanyLazyQuery>;
export type GetShortCompanySuspenseQueryHookResult = ReturnType<typeof useGetShortCompanySuspenseQuery>;
export type GetShortCompanyQueryResult = Apollo.QueryResult<GetShortCompanyQuery, GetShortCompanyQueryVariables>;
export const GetSoftwareCategoriesDocument = gql`
    query getSoftwareCategories($name: String) {
  getSoftwareCategories(name: $name) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        dbId
        subCategory1
        subCategory2
        subCategory3
        subCategory4
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetSoftwareCategoriesQuery__
 *
 * To run a query within a React component, call `useGetSoftwareCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSoftwareCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSoftwareCategoriesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetSoftwareCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetSoftwareCategoriesQuery, GetSoftwareCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSoftwareCategoriesQuery, GetSoftwareCategoriesQueryVariables>(GetSoftwareCategoriesDocument, options);
      }
export function useGetSoftwareCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSoftwareCategoriesQuery, GetSoftwareCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSoftwareCategoriesQuery, GetSoftwareCategoriesQueryVariables>(GetSoftwareCategoriesDocument, options);
        }
export function useGetSoftwareCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSoftwareCategoriesQuery, GetSoftwareCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSoftwareCategoriesQuery, GetSoftwareCategoriesQueryVariables>(GetSoftwareCategoriesDocument, options);
        }
export type GetSoftwareCategoriesQueryHookResult = ReturnType<typeof useGetSoftwareCategoriesQuery>;
export type GetSoftwareCategoriesLazyQueryHookResult = ReturnType<typeof useGetSoftwareCategoriesLazyQuery>;
export type GetSoftwareCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetSoftwareCategoriesSuspenseQuery>;
export type GetSoftwareCategoriesQueryResult = Apollo.QueryResult<GetSoftwareCategoriesQuery, GetSoftwareCategoriesQueryVariables>;
export const GetSoftwareFirmsDocument = gql`
    query getSoftwareFirms($first: Int, $last: Int, $searchTerm: String, $after: Int, $before: Int) {
  softwareFirms(
    first: $first
    last: $last
    searchTerm: $searchTerm
    after: $after
    before: $before
  ) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        dbId
        shortName
        uniqueDomain
        country
        validated
        linkedinUrl
        foundingYear
        sicCode
        datetimeCreated
        datetimeModified
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetSoftwareFirmsQuery__
 *
 * To run a query within a React component, call `useGetSoftwareFirmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSoftwareFirmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSoftwareFirmsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      searchTerm: // value for 'searchTerm'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetSoftwareFirmsQuery(baseOptions?: Apollo.QueryHookOptions<GetSoftwareFirmsQuery, GetSoftwareFirmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSoftwareFirmsQuery, GetSoftwareFirmsQueryVariables>(GetSoftwareFirmsDocument, options);
      }
export function useGetSoftwareFirmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSoftwareFirmsQuery, GetSoftwareFirmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSoftwareFirmsQuery, GetSoftwareFirmsQueryVariables>(GetSoftwareFirmsDocument, options);
        }
export function useGetSoftwareFirmsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSoftwareFirmsQuery, GetSoftwareFirmsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSoftwareFirmsQuery, GetSoftwareFirmsQueryVariables>(GetSoftwareFirmsDocument, options);
        }
export type GetSoftwareFirmsQueryHookResult = ReturnType<typeof useGetSoftwareFirmsQuery>;
export type GetSoftwareFirmsLazyQueryHookResult = ReturnType<typeof useGetSoftwareFirmsLazyQuery>;
export type GetSoftwareFirmsSuspenseQueryHookResult = ReturnType<typeof useGetSoftwareFirmsSuspenseQuery>;
export type GetSoftwareFirmsQueryResult = Apollo.QueryResult<GetSoftwareFirmsQuery, GetSoftwareFirmsQueryVariables>;
export const GetStackshareToolCategoriesDocument = gql`
    query getStackshareToolCategories($first: Int) {
  getStackshareToolCategories(first: $first) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        breadcrumb
        id
        dbId
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetStackshareToolCategoriesQuery__
 *
 * To run a query within a React component, call `useGetStackshareToolCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStackshareToolCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStackshareToolCategoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetStackshareToolCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetStackshareToolCategoriesQuery, GetStackshareToolCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStackshareToolCategoriesQuery, GetStackshareToolCategoriesQueryVariables>(GetStackshareToolCategoriesDocument, options);
      }
export function useGetStackshareToolCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStackshareToolCategoriesQuery, GetStackshareToolCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStackshareToolCategoriesQuery, GetStackshareToolCategoriesQueryVariables>(GetStackshareToolCategoriesDocument, options);
        }
export function useGetStackshareToolCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStackshareToolCategoriesQuery, GetStackshareToolCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStackshareToolCategoriesQuery, GetStackshareToolCategoriesQueryVariables>(GetStackshareToolCategoriesDocument, options);
        }
export type GetStackshareToolCategoriesQueryHookResult = ReturnType<typeof useGetStackshareToolCategoriesQuery>;
export type GetStackshareToolCategoriesLazyQueryHookResult = ReturnType<typeof useGetStackshareToolCategoriesLazyQuery>;
export type GetStackshareToolCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetStackshareToolCategoriesSuspenseQuery>;
export type GetStackshareToolCategoriesQueryResult = Apollo.QueryResult<GetStackshareToolCategoriesQuery, GetStackshareToolCategoriesQueryVariables>;
export const GetStackshareToolsDocument = gql`
    query getStackshareTools($category: String!) {
  getStackshareTools(category: $category) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        name
        id
        dbId
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetStackshareToolsQuery__
 *
 * To run a query within a React component, call `useGetStackshareToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStackshareToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStackshareToolsQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetStackshareToolsQuery(baseOptions: Apollo.QueryHookOptions<GetStackshareToolsQuery, GetStackshareToolsQueryVariables> & ({ variables: GetStackshareToolsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStackshareToolsQuery, GetStackshareToolsQueryVariables>(GetStackshareToolsDocument, options);
      }
export function useGetStackshareToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStackshareToolsQuery, GetStackshareToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStackshareToolsQuery, GetStackshareToolsQueryVariables>(GetStackshareToolsDocument, options);
        }
export function useGetStackshareToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStackshareToolsQuery, GetStackshareToolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStackshareToolsQuery, GetStackshareToolsQueryVariables>(GetStackshareToolsDocument, options);
        }
export type GetStackshareToolsQueryHookResult = ReturnType<typeof useGetStackshareToolsQuery>;
export type GetStackshareToolsLazyQueryHookResult = ReturnType<typeof useGetStackshareToolsLazyQuery>;
export type GetStackshareToolsSuspenseQueryHookResult = ReturnType<typeof useGetStackshareToolsSuspenseQuery>;
export type GetStackshareToolsQueryResult = Apollo.QueryResult<GetStackshareToolsQuery, GetStackshareToolsQueryVariables>;
export const GetSurveyForMeetingDocument = gql`
    query getSurveyForMeeting($meetingId: Int!) {
  meeting(id: $meetingId) {
    id
    domain
    companyId
    title
    meetingDate
    surveyResponses {
      id
      respondentId
      answers
      datetimeCreated
    }
  }
}
    `;

/**
 * __useGetSurveyForMeetingQuery__
 *
 * To run a query within a React component, call `useGetSurveyForMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyForMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyForMeetingQuery({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useGetSurveyForMeetingQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyForMeetingQuery, GetSurveyForMeetingQueryVariables> & ({ variables: GetSurveyForMeetingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyForMeetingQuery, GetSurveyForMeetingQueryVariables>(GetSurveyForMeetingDocument, options);
      }
export function useGetSurveyForMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyForMeetingQuery, GetSurveyForMeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyForMeetingQuery, GetSurveyForMeetingQueryVariables>(GetSurveyForMeetingDocument, options);
        }
export function useGetSurveyForMeetingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyForMeetingQuery, GetSurveyForMeetingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSurveyForMeetingQuery, GetSurveyForMeetingQueryVariables>(GetSurveyForMeetingDocument, options);
        }
export type GetSurveyForMeetingQueryHookResult = ReturnType<typeof useGetSurveyForMeetingQuery>;
export type GetSurveyForMeetingLazyQueryHookResult = ReturnType<typeof useGetSurveyForMeetingLazyQuery>;
export type GetSurveyForMeetingSuspenseQueryHookResult = ReturnType<typeof useGetSurveyForMeetingSuspenseQuery>;
export type GetSurveyForMeetingQueryResult = Apollo.QueryResult<GetSurveyForMeetingQuery, GetSurveyForMeetingQueryVariables>;
export const GetTechnologyUseDocument = gql`
    query getTechnologyUse($companyId: Int) {
  getCompany(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        crawlUrl
        techUse {
          edges {
            node {
              dbId
              findingUrl
              stackshareTool {
                id
                breadcrumb
                name
                stacksUsed
                votes
                url
              }
            }
          }
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useGetTechnologyUseQuery__
 *
 * To run a query within a React component, call `useGetTechnologyUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechnologyUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTechnologyUseQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetTechnologyUseQuery(baseOptions?: Apollo.QueryHookOptions<GetTechnologyUseQuery, GetTechnologyUseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTechnologyUseQuery, GetTechnologyUseQueryVariables>(GetTechnologyUseDocument, options);
      }
export function useGetTechnologyUseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTechnologyUseQuery, GetTechnologyUseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTechnologyUseQuery, GetTechnologyUseQueryVariables>(GetTechnologyUseDocument, options);
        }
export function useGetTechnologyUseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTechnologyUseQuery, GetTechnologyUseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTechnologyUseQuery, GetTechnologyUseQueryVariables>(GetTechnologyUseDocument, options);
        }
export type GetTechnologyUseQueryHookResult = ReturnType<typeof useGetTechnologyUseQuery>;
export type GetTechnologyUseLazyQueryHookResult = ReturnType<typeof useGetTechnologyUseLazyQuery>;
export type GetTechnologyUseSuspenseQueryHookResult = ReturnType<typeof useGetTechnologyUseSuspenseQuery>;
export type GetTechnologyUseQueryResult = Apollo.QueryResult<GetTechnologyUseQuery, GetTechnologyUseQueryVariables>;
export const GetUploadedMetaDataDocument = gql`
    query getUploadedMetaData($pipedriveId: Int!) {
  uploadedMetaDataByPipedriveId(pipedriveId: $pipedriveId) {
    company {
      dbId
      shortName
      uniqueDomain
    }
    uploadTime
    uploaderName
  }
}
    `;

/**
 * __useGetUploadedMetaDataQuery__
 *
 * To run a query within a React component, call `useGetUploadedMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadedMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadedMetaDataQuery({
 *   variables: {
 *      pipedriveId: // value for 'pipedriveId'
 *   },
 * });
 */
export function useGetUploadedMetaDataQuery(baseOptions: Apollo.QueryHookOptions<GetUploadedMetaDataQuery, GetUploadedMetaDataQueryVariables> & ({ variables: GetUploadedMetaDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadedMetaDataQuery, GetUploadedMetaDataQueryVariables>(GetUploadedMetaDataDocument, options);
      }
export function useGetUploadedMetaDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadedMetaDataQuery, GetUploadedMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadedMetaDataQuery, GetUploadedMetaDataQueryVariables>(GetUploadedMetaDataDocument, options);
        }
export function useGetUploadedMetaDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadedMetaDataQuery, GetUploadedMetaDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadedMetaDataQuery, GetUploadedMetaDataQueryVariables>(GetUploadedMetaDataDocument, options);
        }
export type GetUploadedMetaDataQueryHookResult = ReturnType<typeof useGetUploadedMetaDataQuery>;
export type GetUploadedMetaDataLazyQueryHookResult = ReturnType<typeof useGetUploadedMetaDataLazyQuery>;
export type GetUploadedMetaDataSuspenseQueryHookResult = ReturnType<typeof useGetUploadedMetaDataSuspenseQuery>;
export type GetUploadedMetaDataQueryResult = Apollo.QueryResult<GetUploadedMetaDataQuery, GetUploadedMetaDataQueryVariables>;
export const GetUserActivityStatsDocument = gql`
    query getUserActivityStats($timeframe: String) {
  userActivityStats(timeframe: $timeframe) {
    userId
    displayName
    totalValidations
    orgCreatedCount
    dealCreatedCount
  }
}
    `;

/**
 * __useGetUserActivityStatsQuery__
 *
 * To run a query within a React component, call `useGetUserActivityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivityStatsQuery({
 *   variables: {
 *      timeframe: // value for 'timeframe'
 *   },
 * });
 */
export function useGetUserActivityStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserActivityStatsQuery, GetUserActivityStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActivityStatsQuery, GetUserActivityStatsQueryVariables>(GetUserActivityStatsDocument, options);
      }
export function useGetUserActivityStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActivityStatsQuery, GetUserActivityStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActivityStatsQuery, GetUserActivityStatsQueryVariables>(GetUserActivityStatsDocument, options);
        }
export function useGetUserActivityStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserActivityStatsQuery, GetUserActivityStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserActivityStatsQuery, GetUserActivityStatsQueryVariables>(GetUserActivityStatsDocument, options);
        }
export type GetUserActivityStatsQueryHookResult = ReturnType<typeof useGetUserActivityStatsQuery>;
export type GetUserActivityStatsLazyQueryHookResult = ReturnType<typeof useGetUserActivityStatsLazyQuery>;
export type GetUserActivityStatsSuspenseQueryHookResult = ReturnType<typeof useGetUserActivityStatsSuspenseQuery>;
export type GetUserActivityStatsQueryResult = Apollo.QueryResult<GetUserActivityStatsQuery, GetUserActivityStatsQueryVariables>;
export const GetUserIdByAuthIdDocument = gql`
    query getUserIdByAuthId($authId: String!) {
  userIdByAuthId(authId: $authId)
}
    `;

/**
 * __useGetUserIdByAuthIdQuery__
 *
 * To run a query within a React component, call `useGetUserIdByAuthIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIdByAuthIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIdByAuthIdQuery({
 *   variables: {
 *      authId: // value for 'authId'
 *   },
 * });
 */
export function useGetUserIdByAuthIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserIdByAuthIdQuery, GetUserIdByAuthIdQueryVariables> & ({ variables: GetUserIdByAuthIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserIdByAuthIdQuery, GetUserIdByAuthIdQueryVariables>(GetUserIdByAuthIdDocument, options);
      }
export function useGetUserIdByAuthIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserIdByAuthIdQuery, GetUserIdByAuthIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserIdByAuthIdQuery, GetUserIdByAuthIdQueryVariables>(GetUserIdByAuthIdDocument, options);
        }
export function useGetUserIdByAuthIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserIdByAuthIdQuery, GetUserIdByAuthIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserIdByAuthIdQuery, GetUserIdByAuthIdQueryVariables>(GetUserIdByAuthIdDocument, options);
        }
export type GetUserIdByAuthIdQueryHookResult = ReturnType<typeof useGetUserIdByAuthIdQuery>;
export type GetUserIdByAuthIdLazyQueryHookResult = ReturnType<typeof useGetUserIdByAuthIdLazyQuery>;
export type GetUserIdByAuthIdSuspenseQueryHookResult = ReturnType<typeof useGetUserIdByAuthIdSuspenseQuery>;
export type GetUserIdByAuthIdQueryResult = Apollo.QueryResult<GetUserIdByAuthIdQuery, GetUserIdByAuthIdQueryVariables>;
export const GetVibeCodingIdeasDocument = gql`
    query getVibeCodingIdeas($portfolioCompanyId: Int, $status: String, $isBookmarked: Boolean, $limit: Int, $offset: Int) {
  vibeCodingIdeas(
    portfolioCompanyId: $portfolioCompanyId
    status: $status
    isBookmarked: $isBookmarked
    limit: $limit
    offset: $offset
  ) {
    dbId
    title
    description
    problemStatement
    proposedSolution
    techStackSuggestion
    estimatedComplexity
    businessImpact
    ycStartupName
    ycStartupOneLiner
    competitiveAngle
    industryVertical
    generationModel
    isBookmarked
    userRating
    userNotes
    status
  }
}
    `;

/**
 * __useGetVibeCodingIdeasQuery__
 *
 * To run a query within a React component, call `useGetVibeCodingIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVibeCodingIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVibeCodingIdeasQuery({
 *   variables: {
 *      portfolioCompanyId: // value for 'portfolioCompanyId'
 *      status: // value for 'status'
 *      isBookmarked: // value for 'isBookmarked'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetVibeCodingIdeasQuery(baseOptions?: Apollo.QueryHookOptions<GetVibeCodingIdeasQuery, GetVibeCodingIdeasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVibeCodingIdeasQuery, GetVibeCodingIdeasQueryVariables>(GetVibeCodingIdeasDocument, options);
      }
export function useGetVibeCodingIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVibeCodingIdeasQuery, GetVibeCodingIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVibeCodingIdeasQuery, GetVibeCodingIdeasQueryVariables>(GetVibeCodingIdeasDocument, options);
        }
export function useGetVibeCodingIdeasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVibeCodingIdeasQuery, GetVibeCodingIdeasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVibeCodingIdeasQuery, GetVibeCodingIdeasQueryVariables>(GetVibeCodingIdeasDocument, options);
        }
export type GetVibeCodingIdeasQueryHookResult = ReturnType<typeof useGetVibeCodingIdeasQuery>;
export type GetVibeCodingIdeasLazyQueryHookResult = ReturnType<typeof useGetVibeCodingIdeasLazyQuery>;
export type GetVibeCodingIdeasSuspenseQueryHookResult = ReturnType<typeof useGetVibeCodingIdeasSuspenseQuery>;
export type GetVibeCodingIdeasQueryResult = Apollo.QueryResult<GetVibeCodingIdeasQuery, GetVibeCodingIdeasQueryVariables>;
export const GetYcStartupsForCompanyDocument = gql`
    query getYcStartupsForCompany($companyId: Int!, $minSimilarity: Float, $limit: Int, $offset: Int) {
  ycStartupsForCompany(
    companyId: $companyId
    minSimilarity: $minSimilarity
    limit: $limit
    offset: $offset
  ) {
    totalCount
    items {
      similarityScore
      ycCompany {
        dbId
        name
        slug
        oneLiner
        longDescription
        batch
        status
        stage
        teamSize
        industry
        subindustry
        tags
        website
        smallLogoThumbUrl
        isHiring
        topCompany
        launchedAt
      }
    }
  }
}
    `;

/**
 * __useGetYcStartupsForCompanyQuery__
 *
 * To run a query within a React component, call `useGetYcStartupsForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYcStartupsForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYcStartupsForCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      minSimilarity: // value for 'minSimilarity'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetYcStartupsForCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetYcStartupsForCompanyQuery, GetYcStartupsForCompanyQueryVariables> & ({ variables: GetYcStartupsForCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYcStartupsForCompanyQuery, GetYcStartupsForCompanyQueryVariables>(GetYcStartupsForCompanyDocument, options);
      }
export function useGetYcStartupsForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYcStartupsForCompanyQuery, GetYcStartupsForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYcStartupsForCompanyQuery, GetYcStartupsForCompanyQueryVariables>(GetYcStartupsForCompanyDocument, options);
        }
export function useGetYcStartupsForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetYcStartupsForCompanyQuery, GetYcStartupsForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetYcStartupsForCompanyQuery, GetYcStartupsForCompanyQueryVariables>(GetYcStartupsForCompanyDocument, options);
        }
export type GetYcStartupsForCompanyQueryHookResult = ReturnType<typeof useGetYcStartupsForCompanyQuery>;
export type GetYcStartupsForCompanyLazyQueryHookResult = ReturnType<typeof useGetYcStartupsForCompanyLazyQuery>;
export type GetYcStartupsForCompanySuspenseQueryHookResult = ReturnType<typeof useGetYcStartupsForCompanySuspenseQuery>;
export type GetYcStartupsForCompanyQueryResult = Apollo.QueryResult<GetYcStartupsForCompanyQuery, GetYcStartupsForCompanyQueryVariables>;
export const GetKpiBenchmarksDocument = gql`
    query getKPIBenchmarks {
  kpiBenchmarks {
    kpiName
    percentile25
    percentile50
    percentile75
    nonNullCount
  }
}
    `;

/**
 * __useGetKpiBenchmarksQuery__
 *
 * To run a query within a React component, call `useGetKpiBenchmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiBenchmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiBenchmarksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKpiBenchmarksQuery(baseOptions?: Apollo.QueryHookOptions<GetKpiBenchmarksQuery, GetKpiBenchmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKpiBenchmarksQuery, GetKpiBenchmarksQueryVariables>(GetKpiBenchmarksDocument, options);
      }
export function useGetKpiBenchmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKpiBenchmarksQuery, GetKpiBenchmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKpiBenchmarksQuery, GetKpiBenchmarksQueryVariables>(GetKpiBenchmarksDocument, options);
        }
export function useGetKpiBenchmarksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKpiBenchmarksQuery, GetKpiBenchmarksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKpiBenchmarksQuery, GetKpiBenchmarksQueryVariables>(GetKpiBenchmarksDocument, options);
        }
export type GetKpiBenchmarksQueryHookResult = ReturnType<typeof useGetKpiBenchmarksQuery>;
export type GetKpiBenchmarksLazyQueryHookResult = ReturnType<typeof useGetKpiBenchmarksLazyQuery>;
export type GetKpiBenchmarksSuspenseQueryHookResult = ReturnType<typeof useGetKpiBenchmarksSuspenseQuery>;
export type GetKpiBenchmarksQueryResult = Apollo.QueryResult<GetKpiBenchmarksQuery, GetKpiBenchmarksQueryVariables>;
export const KpiCalculationStatusDocument = gql`
    query KpiCalculationStatus($companyId: Int!) {
  kpiCalculationStatus(companyId: $companyId) {
    companyId
    lastKpiCalculation
    lastDataUpload
    totalKpis
    calculatedKpis
    outdatedKpis
    missingDataKpis
    needsRecalculation
    benchmarkControlDataId
    lastFiscalYear
    kpiStatuses {
      kpiName
      displayName
      value
      isCalculated
      lastCalculated
      isUpToDate
      requiredDataMissing
      kpiType
      dataAvailability {
        kpiName
        hasRawData
        availableYears
        latestYear
        dataSources
      }
    }
  }
}
    `;

/**
 * __useKpiCalculationStatusQuery__
 *
 * To run a query within a React component, call `useKpiCalculationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiCalculationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiCalculationStatusQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useKpiCalculationStatusQuery(baseOptions: Apollo.QueryHookOptions<KpiCalculationStatusQuery, KpiCalculationStatusQueryVariables> & ({ variables: KpiCalculationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KpiCalculationStatusQuery, KpiCalculationStatusQueryVariables>(KpiCalculationStatusDocument, options);
      }
export function useKpiCalculationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiCalculationStatusQuery, KpiCalculationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KpiCalculationStatusQuery, KpiCalculationStatusQueryVariables>(KpiCalculationStatusDocument, options);
        }
export function useKpiCalculationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KpiCalculationStatusQuery, KpiCalculationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KpiCalculationStatusQuery, KpiCalculationStatusQueryVariables>(KpiCalculationStatusDocument, options);
        }
export type KpiCalculationStatusQueryHookResult = ReturnType<typeof useKpiCalculationStatusQuery>;
export type KpiCalculationStatusLazyQueryHookResult = ReturnType<typeof useKpiCalculationStatusLazyQuery>;
export type KpiCalculationStatusSuspenseQueryHookResult = ReturnType<typeof useKpiCalculationStatusSuspenseQuery>;
export type KpiCalculationStatusQueryResult = Apollo.QueryResult<KpiCalculationStatusQuery, KpiCalculationStatusQueryVariables>;
export const ListResearchSessionsDocument = gql`
    query listResearchSessions($researchType: String, $companyDomain: String, $status: ResearchStatusEnum, $limit: Int) {
  listResearchSessions(
    researchType: $researchType
    companyDomain: $companyDomain
    status: $status
    limit: $limit
  ) {
    sessionId
    researchType
    companyName
    companyDomain
    status
    jobId
    startedAt
    completedAt
    durationSeconds
  }
}
    `;

/**
 * __useListResearchSessionsQuery__
 *
 * To run a query within a React component, call `useListResearchSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResearchSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResearchSessionsQuery({
 *   variables: {
 *      researchType: // value for 'researchType'
 *      companyDomain: // value for 'companyDomain'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListResearchSessionsQuery(baseOptions?: Apollo.QueryHookOptions<ListResearchSessionsQuery, ListResearchSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListResearchSessionsQuery, ListResearchSessionsQueryVariables>(ListResearchSessionsDocument, options);
      }
export function useListResearchSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListResearchSessionsQuery, ListResearchSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListResearchSessionsQuery, ListResearchSessionsQueryVariables>(ListResearchSessionsDocument, options);
        }
export function useListResearchSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListResearchSessionsQuery, ListResearchSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListResearchSessionsQuery, ListResearchSessionsQueryVariables>(ListResearchSessionsDocument, options);
        }
export type ListResearchSessionsQueryHookResult = ReturnType<typeof useListResearchSessionsQuery>;
export type ListResearchSessionsLazyQueryHookResult = ReturnType<typeof useListResearchSessionsLazyQuery>;
export type ListResearchSessionsSuspenseQueryHookResult = ReturnType<typeof useListResearchSessionsSuspenseQuery>;
export type ListResearchSessionsQueryResult = Apollo.QueryResult<ListResearchSessionsQuery, ListResearchSessionsQueryVariables>;
export const GetMlModelStatisticsDocument = gql`
    query GetMLModelStatistics {
  mlModelStatistics {
    modelName
    modelType
    latestVersion
    currentTrainingSamples
    currentTestSamples
    totalCurrentSamples
    currentR2
    currentAccuracy
    currentF1Score
    currentPrecision
    currentRecall
    currentMse
    currentRmse
    samplesChange1w
    samplesChange4w
    samplesChange1wPercent
    samplesChange4wPercent
    topFeatures {
      featureName
      importance
    }
    modelCreatedAt
    modelUpdatedAt
    totalVersions
  }
}
    `;

/**
 * __useGetMlModelStatisticsQuery__
 *
 * To run a query within a React component, call `useGetMlModelStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlModelStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlModelStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMlModelStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetMlModelStatisticsQuery, GetMlModelStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlModelStatisticsQuery, GetMlModelStatisticsQueryVariables>(GetMlModelStatisticsDocument, options);
      }
export function useGetMlModelStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlModelStatisticsQuery, GetMlModelStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlModelStatisticsQuery, GetMlModelStatisticsQueryVariables>(GetMlModelStatisticsDocument, options);
        }
export function useGetMlModelStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMlModelStatisticsQuery, GetMlModelStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMlModelStatisticsQuery, GetMlModelStatisticsQueryVariables>(GetMlModelStatisticsDocument, options);
        }
export type GetMlModelStatisticsQueryHookResult = ReturnType<typeof useGetMlModelStatisticsQuery>;
export type GetMlModelStatisticsLazyQueryHookResult = ReturnType<typeof useGetMlModelStatisticsLazyQuery>;
export type GetMlModelStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetMlModelStatisticsSuspenseQuery>;
export type GetMlModelStatisticsQueryResult = Apollo.QueryResult<GetMlModelStatisticsQuery, GetMlModelStatisticsQueryVariables>;
export const GetMlModelDetailedStatsDocument = gql`
    query GetMLModelDetailedStats($modelName: String!) {
  mlModelDetailedStats(modelName: $modelName) {
    modelName
    modelType
    statistics {
      modelName
      modelType
      latestVersion
      currentTrainingSamples
      currentTestSamples
      totalCurrentSamples
      currentR2
      currentAccuracy
      currentF1Score
      currentPrecision
      currentRecall
      currentMse
      currentRmse
      samplesChange1w
      samplesChange4w
      samplesChange1wPercent
      samplesChange4wPercent
      topFeatures {
        featureName
        importance
      }
      modelCreatedAt
      modelUpdatedAt
      totalVersions
    }
    historicalData {
      date
      version
      totalSamples
      trainingSamples
      testSamples
      r2
      accuracy
      f1Score
    }
  }
}
    `;

/**
 * __useGetMlModelDetailedStatsQuery__
 *
 * To run a query within a React component, call `useGetMlModelDetailedStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlModelDetailedStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlModelDetailedStatsQuery({
 *   variables: {
 *      modelName: // value for 'modelName'
 *   },
 * });
 */
export function useGetMlModelDetailedStatsQuery(baseOptions: Apollo.QueryHookOptions<GetMlModelDetailedStatsQuery, GetMlModelDetailedStatsQueryVariables> & ({ variables: GetMlModelDetailedStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlModelDetailedStatsQuery, GetMlModelDetailedStatsQueryVariables>(GetMlModelDetailedStatsDocument, options);
      }
export function useGetMlModelDetailedStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlModelDetailedStatsQuery, GetMlModelDetailedStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlModelDetailedStatsQuery, GetMlModelDetailedStatsQueryVariables>(GetMlModelDetailedStatsDocument, options);
        }
export function useGetMlModelDetailedStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMlModelDetailedStatsQuery, GetMlModelDetailedStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMlModelDetailedStatsQuery, GetMlModelDetailedStatsQueryVariables>(GetMlModelDetailedStatsDocument, options);
        }
export type GetMlModelDetailedStatsQueryHookResult = ReturnType<typeof useGetMlModelDetailedStatsQuery>;
export type GetMlModelDetailedStatsLazyQueryHookResult = ReturnType<typeof useGetMlModelDetailedStatsLazyQuery>;
export type GetMlModelDetailedStatsSuspenseQueryHookResult = ReturnType<typeof useGetMlModelDetailedStatsSuspenseQuery>;
export type GetMlModelDetailedStatsQueryResult = Apollo.QueryResult<GetMlModelDetailedStatsQuery, GetMlModelDetailedStatsQueryVariables>;
export const OpenregCompaniesDocument = gql`
    query openregCompanies($companyId: Int!) {
  getCompany(companyId: $companyId) {
    edges {
      node {
        legalName
        street
        city
        openregCompanies {
          edges {
            node {
              companyName
              addressStreet
              addressPlace
              addressZipcode
              referenceCourtCode
              referenceCourtName
              foundedDate
              dbId
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOpenregCompaniesQuery__
 *
 * To run a query within a React component, call `useOpenregCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenregCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenregCompaniesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOpenregCompaniesQuery(baseOptions: Apollo.QueryHookOptions<OpenregCompaniesQuery, OpenregCompaniesQueryVariables> & ({ variables: OpenregCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenregCompaniesQuery, OpenregCompaniesQueryVariables>(OpenregCompaniesDocument, options);
      }
export function useOpenregCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenregCompaniesQuery, OpenregCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenregCompaniesQuery, OpenregCompaniesQueryVariables>(OpenregCompaniesDocument, options);
        }
export function useOpenregCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenregCompaniesQuery, OpenregCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenregCompaniesQuery, OpenregCompaniesQueryVariables>(OpenregCompaniesDocument, options);
        }
export type OpenregCompaniesQueryHookResult = ReturnType<typeof useOpenregCompaniesQuery>;
export type OpenregCompaniesLazyQueryHookResult = ReturnType<typeof useOpenregCompaniesLazyQuery>;
export type OpenregCompaniesSuspenseQueryHookResult = ReturnType<typeof useOpenregCompaniesSuspenseQuery>;
export type OpenregCompaniesQueryResult = Apollo.QueryResult<OpenregCompaniesQuery, OpenregCompaniesQueryVariables>;
export const OriginationsWaterfallDocument = gql`
    query originationsWaterfall($dateFrom: DateTime!, $dateTo: DateTime) {
  originationsWaterfall(dateFrom: $dateFrom, dateTo: $dateTo) {
    bars {
      label
      count
      companyIds
    }
    funnelPercentage
    initialCallsUnvalidated
    initialCallsUnvalidatedCompanyIds
  }
}
    `;

/**
 * __useOriginationsWaterfallQuery__
 *
 * To run a query within a React component, call `useOriginationsWaterfallQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginationsWaterfallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginationsWaterfallQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useOriginationsWaterfallQuery(baseOptions: Apollo.QueryHookOptions<OriginationsWaterfallQuery, OriginationsWaterfallQueryVariables> & ({ variables: OriginationsWaterfallQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginationsWaterfallQuery, OriginationsWaterfallQueryVariables>(OriginationsWaterfallDocument, options);
      }
export function useOriginationsWaterfallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginationsWaterfallQuery, OriginationsWaterfallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginationsWaterfallQuery, OriginationsWaterfallQueryVariables>(OriginationsWaterfallDocument, options);
        }
export function useOriginationsWaterfallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OriginationsWaterfallQuery, OriginationsWaterfallQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OriginationsWaterfallQuery, OriginationsWaterfallQueryVariables>(OriginationsWaterfallDocument, options);
        }
export type OriginationsWaterfallQueryHookResult = ReturnType<typeof useOriginationsWaterfallQuery>;
export type OriginationsWaterfallLazyQueryHookResult = ReturnType<typeof useOriginationsWaterfallLazyQuery>;
export type OriginationsWaterfallSuspenseQueryHookResult = ReturnType<typeof useOriginationsWaterfallSuspenseQuery>;
export type OriginationsWaterfallQueryResult = Apollo.QueryResult<OriginationsWaterfallQuery, OriginationsWaterfallQueryVariables>;
export const PipelineCoverageDocument = gql`
    query PipelineCoverage {
  pipelineCoverage {
    companyId
    companyName
    domain
    hasBeenCalled
    lastCallDate
    callCount
    hasSurvey
  }
}
    `;

/**
 * __usePipelineCoverageQuery__
 *
 * To run a query within a React component, call `usePipelineCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineCoverageQuery({
 *   variables: {
 *   },
 * });
 */
export function usePipelineCoverageQuery(baseOptions?: Apollo.QueryHookOptions<PipelineCoverageQuery, PipelineCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineCoverageQuery, PipelineCoverageQueryVariables>(PipelineCoverageDocument, options);
      }
export function usePipelineCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineCoverageQuery, PipelineCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineCoverageQuery, PipelineCoverageQueryVariables>(PipelineCoverageDocument, options);
        }
export function usePipelineCoverageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineCoverageQuery, PipelineCoverageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipelineCoverageQuery, PipelineCoverageQueryVariables>(PipelineCoverageDocument, options);
        }
export type PipelineCoverageQueryHookResult = ReturnType<typeof usePipelineCoverageQuery>;
export type PipelineCoverageLazyQueryHookResult = ReturnType<typeof usePipelineCoverageLazyQuery>;
export type PipelineCoverageSuspenseQueryHookResult = ReturnType<typeof usePipelineCoverageSuspenseQuery>;
export type PipelineCoverageQueryResult = Apollo.QueryResult<PipelineCoverageQuery, PipelineCoverageQueryVariables>;
export const PrecalculatedKpisDocument = gql`
    query precalculatedKpis($companyId: Int!) {
  companyAssesment(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      node {
        precalculatedKpis {
          edges {
            node {
              id
              softwareShare
              salesGrowth
              absEbit
              recurringRevenueShare
              cogsRatio
              top3CustomerShare
              netNewCustomerSalesGrowth
              customerLifetimeValueDistribution
              cLevelQuality
              softwareCategoryGrowth
              onlineVisibility
              pricePerGoogleKeywordClick
              consultingManRate
              mostExpensiveKeyword
              customerIndustryGrowth
              employeeConcentrationRatio
              teamQuality
              ageOfProgrammingLanguage
              popularityOfProgrammingLanguage
              useOfBackendFramework
              useOfFrontendFramework
              buyAndBuildScore
              callabilityScore
              fteNetContributionMargin
              opexRatio
              ebitdaMargin
              ebitMargin
              grossArrChurn
              netArrChurn
              grossArrChurnRate
              netArrChurnRate
              grossLogoChurn
              netLogoChurn
              grossLogoChurnRate
              netLogoChurnRate
              downgradeArr
              expansionArr
              downgradeArrRate
              expansionArrRate
              grossRetentionRate
              netRetentionRate
              grossNewCustomerSalesGrowth
              grossNewCustomerLogoGrowth
              grossNewCustomerSalesGrowthRate
              grossNewCustomerLogoGrowthRate
              absSales
              absFte
              absEbitda
              customerIndustrySic
              financialBaseForValuation
              enterpriseValueEstimation
            }
          }
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __usePrecalculatedKpisQuery__
 *
 * To run a query within a React component, call `usePrecalculatedKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrecalculatedKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrecalculatedKpisQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function usePrecalculatedKpisQuery(baseOptions: Apollo.QueryHookOptions<PrecalculatedKpisQuery, PrecalculatedKpisQueryVariables> & ({ variables: PrecalculatedKpisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrecalculatedKpisQuery, PrecalculatedKpisQueryVariables>(PrecalculatedKpisDocument, options);
      }
export function usePrecalculatedKpisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrecalculatedKpisQuery, PrecalculatedKpisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrecalculatedKpisQuery, PrecalculatedKpisQueryVariables>(PrecalculatedKpisDocument, options);
        }
export function usePrecalculatedKpisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrecalculatedKpisQuery, PrecalculatedKpisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrecalculatedKpisQuery, PrecalculatedKpisQueryVariables>(PrecalculatedKpisDocument, options);
        }
export type PrecalculatedKpisQueryHookResult = ReturnType<typeof usePrecalculatedKpisQuery>;
export type PrecalculatedKpisLazyQueryHookResult = ReturnType<typeof usePrecalculatedKpisLazyQuery>;
export type PrecalculatedKpisSuspenseQueryHookResult = ReturnType<typeof usePrecalculatedKpisSuspenseQuery>;
export type PrecalculatedKpisQueryResult = Apollo.QueryResult<PrecalculatedKpisQuery, PrecalculatedKpisQueryVariables>;
export const ProductCategoryListDocument = gql`
    query productCategoryList($first: Int) {
  productCategoryList(first: $first) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        dbId
        subCategory1
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useProductCategoryListQuery__
 *
 * To run a query within a React component, call `useProductCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoryListQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useProductCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<ProductCategoryListQuery, ProductCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoryListQuery, ProductCategoryListQueryVariables>(ProductCategoryListDocument, options);
      }
export function useProductCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoryListQuery, ProductCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoryListQuery, ProductCategoryListQueryVariables>(ProductCategoryListDocument, options);
        }
export function useProductCategoryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCategoryListQuery, ProductCategoryListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCategoryListQuery, ProductCategoryListQueryVariables>(ProductCategoryListDocument, options);
        }
export type ProductCategoryListQueryHookResult = ReturnType<typeof useProductCategoryListQuery>;
export type ProductCategoryListLazyQueryHookResult = ReturnType<typeof useProductCategoryListLazyQuery>;
export type ProductCategoryListSuspenseQueryHookResult = ReturnType<typeof useProductCategoryListSuspenseQuery>;
export type ProductCategoryListQueryResult = Apollo.QueryResult<ProductCategoryListQuery, ProductCategoryListQueryVariables>;
export const ProductCategoryTrendsDocument = gql`
    query productCategoryTrends($companyId: Int!) {
  productCategoryTrends(companyId: $companyId) {
    softwareCategoryId
    subCategory1
    date
    interest
  }
}
    `;

/**
 * __useProductCategoryTrendsQuery__
 *
 * To run a query within a React component, call `useProductCategoryTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoryTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoryTrendsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useProductCategoryTrendsQuery(baseOptions: Apollo.QueryHookOptions<ProductCategoryTrendsQuery, ProductCategoryTrendsQueryVariables> & ({ variables: ProductCategoryTrendsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoryTrendsQuery, ProductCategoryTrendsQueryVariables>(ProductCategoryTrendsDocument, options);
      }
export function useProductCategoryTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoryTrendsQuery, ProductCategoryTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoryTrendsQuery, ProductCategoryTrendsQueryVariables>(ProductCategoryTrendsDocument, options);
        }
export function useProductCategoryTrendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCategoryTrendsQuery, ProductCategoryTrendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCategoryTrendsQuery, ProductCategoryTrendsQueryVariables>(ProductCategoryTrendsDocument, options);
        }
export type ProductCategoryTrendsQueryHookResult = ReturnType<typeof useProductCategoryTrendsQuery>;
export type ProductCategoryTrendsLazyQueryHookResult = ReturnType<typeof useProductCategoryTrendsLazyQuery>;
export type ProductCategoryTrendsSuspenseQueryHookResult = ReturnType<typeof useProductCategoryTrendsSuspenseQuery>;
export type ProductCategoryTrendsQueryResult = Apollo.QueryResult<ProductCategoryTrendsQuery, ProductCategoryTrendsQueryVariables>;
export const ProductSubCategory3ListDocument = gql`
    query productSubCategory3List($subCategory2: String) {
  productCategoryList(subCategory2: $subCategory2) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        dbId
        subCategory3
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useProductSubCategory3ListQuery__
 *
 * To run a query within a React component, call `useProductSubCategory3ListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSubCategory3ListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSubCategory3ListQuery({
 *   variables: {
 *      subCategory2: // value for 'subCategory2'
 *   },
 * });
 */
export function useProductSubCategory3ListQuery(baseOptions?: Apollo.QueryHookOptions<ProductSubCategory3ListQuery, ProductSubCategory3ListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSubCategory3ListQuery, ProductSubCategory3ListQueryVariables>(ProductSubCategory3ListDocument, options);
      }
export function useProductSubCategory3ListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSubCategory3ListQuery, ProductSubCategory3ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSubCategory3ListQuery, ProductSubCategory3ListQueryVariables>(ProductSubCategory3ListDocument, options);
        }
export function useProductSubCategory3ListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSubCategory3ListQuery, ProductSubCategory3ListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductSubCategory3ListQuery, ProductSubCategory3ListQueryVariables>(ProductSubCategory3ListDocument, options);
        }
export type ProductSubCategory3ListQueryHookResult = ReturnType<typeof useProductSubCategory3ListQuery>;
export type ProductSubCategory3ListLazyQueryHookResult = ReturnType<typeof useProductSubCategory3ListLazyQuery>;
export type ProductSubCategory3ListSuspenseQueryHookResult = ReturnType<typeof useProductSubCategory3ListSuspenseQuery>;
export type ProductSubCategory3ListQueryResult = Apollo.QueryResult<ProductSubCategory3ListQuery, ProductSubCategory3ListQueryVariables>;
export const ProductSubCategoryListDocument = gql`
    query productSubCategoryList($subCategory1: String) {
  productCategoryList(subCategory1: $subCategory1) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        id
        dbId
        subCategory2
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useProductSubCategoryListQuery__
 *
 * To run a query within a React component, call `useProductSubCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSubCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSubCategoryListQuery({
 *   variables: {
 *      subCategory1: // value for 'subCategory1'
 *   },
 * });
 */
export function useProductSubCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<ProductSubCategoryListQuery, ProductSubCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSubCategoryListQuery, ProductSubCategoryListQueryVariables>(ProductSubCategoryListDocument, options);
      }
export function useProductSubCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSubCategoryListQuery, ProductSubCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSubCategoryListQuery, ProductSubCategoryListQueryVariables>(ProductSubCategoryListDocument, options);
        }
export function useProductSubCategoryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSubCategoryListQuery, ProductSubCategoryListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductSubCategoryListQuery, ProductSubCategoryListQueryVariables>(ProductSubCategoryListDocument, options);
        }
export type ProductSubCategoryListQueryHookResult = ReturnType<typeof useProductSubCategoryListQuery>;
export type ProductSubCategoryListLazyQueryHookResult = ReturnType<typeof useProductSubCategoryListLazyQuery>;
export type ProductSubCategoryListSuspenseQueryHookResult = ReturnType<typeof useProductSubCategoryListSuspenseQuery>;
export type ProductSubCategoryListQueryResult = Apollo.QueryResult<ProductSubCategoryListQuery, ProductSubCategoryListQueryVariables>;
export const RedbeatSchedulesDocument = gql`
    query redbeatSchedules {
  redbeatSchedules {
    name
    task
    enabled
    scheduleType
    intervalSeconds
    crontabMinute
    crontabHour
    crontabDayOfWeek
    crontabDayOfMonth
    queue
    kwargs
    totalRunCount
    lastRunAt
  }
}
    `;

/**
 * __useRedbeatSchedulesQuery__
 *
 * To run a query within a React component, call `useRedbeatSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedbeatSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedbeatSchedulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRedbeatSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<RedbeatSchedulesQuery, RedbeatSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedbeatSchedulesQuery, RedbeatSchedulesQueryVariables>(RedbeatSchedulesDocument, options);
      }
export function useRedbeatSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedbeatSchedulesQuery, RedbeatSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedbeatSchedulesQuery, RedbeatSchedulesQueryVariables>(RedbeatSchedulesDocument, options);
        }
export function useRedbeatSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedbeatSchedulesQuery, RedbeatSchedulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedbeatSchedulesQuery, RedbeatSchedulesQueryVariables>(RedbeatSchedulesDocument, options);
        }
export type RedbeatSchedulesQueryHookResult = ReturnType<typeof useRedbeatSchedulesQuery>;
export type RedbeatSchedulesLazyQueryHookResult = ReturnType<typeof useRedbeatSchedulesLazyQuery>;
export type RedbeatSchedulesSuspenseQueryHookResult = ReturnType<typeof useRedbeatSchedulesSuspenseQuery>;
export type RedbeatSchedulesQueryResult = Apollo.QueryResult<RedbeatSchedulesQuery, RedbeatSchedulesQueryVariables>;
export const ResearchJobStatusDocument = gql`
    query researchJobStatus($jobId: ID!) {
  researchJobStatus(jobId: $jobId) {
    jobId
    status
    progress {
      stage
      percent
      message
    }
    result
    error
  }
}
    `;

/**
 * __useResearchJobStatusQuery__
 *
 * To run a query within a React component, call `useResearchJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useResearchJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResearchJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useResearchJobStatusQuery(baseOptions: Apollo.QueryHookOptions<ResearchJobStatusQuery, ResearchJobStatusQueryVariables> & ({ variables: ResearchJobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResearchJobStatusQuery, ResearchJobStatusQueryVariables>(ResearchJobStatusDocument, options);
      }
export function useResearchJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResearchJobStatusQuery, ResearchJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResearchJobStatusQuery, ResearchJobStatusQueryVariables>(ResearchJobStatusDocument, options);
        }
export function useResearchJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResearchJobStatusQuery, ResearchJobStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResearchJobStatusQuery, ResearchJobStatusQueryVariables>(ResearchJobStatusDocument, options);
        }
export type ResearchJobStatusQueryHookResult = ReturnType<typeof useResearchJobStatusQuery>;
export type ResearchJobStatusLazyQueryHookResult = ReturnType<typeof useResearchJobStatusLazyQuery>;
export type ResearchJobStatusSuspenseQueryHookResult = ReturnType<typeof useResearchJobStatusSuspenseQuery>;
export type ResearchJobStatusQueryResult = Apollo.QueryResult<ResearchJobStatusQuery, ResearchJobStatusQueryVariables>;
export const ResearchResultDocument = gql`
    query researchResult($sessionId: ID!) {
  researchResult(sessionId: $sessionId) {
    sessionId
    researchType
    companyDomain
    status
    resultData
    evidenceSources {
      sourceType
      url
      title
      snippet
      relevanceScore
    }
    citationIndex
    errorMessage
    startedAt
    completedAt
    durationSeconds
  }
}
    `;

/**
 * __useResearchResultQuery__
 *
 * To run a query within a React component, call `useResearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useResearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResearchResultQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useResearchResultQuery(baseOptions: Apollo.QueryHookOptions<ResearchResultQuery, ResearchResultQueryVariables> & ({ variables: ResearchResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResearchResultQuery, ResearchResultQueryVariables>(ResearchResultDocument, options);
      }
export function useResearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResearchResultQuery, ResearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResearchResultQuery, ResearchResultQueryVariables>(ResearchResultDocument, options);
        }
export function useResearchResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResearchResultQuery, ResearchResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResearchResultQuery, ResearchResultQueryVariables>(ResearchResultDocument, options);
        }
export type ResearchResultQueryHookResult = ReturnType<typeof useResearchResultQuery>;
export type ResearchResultLazyQueryHookResult = ReturnType<typeof useResearchResultLazyQuery>;
export type ResearchResultSuspenseQueryHookResult = ReturnType<typeof useResearchResultSuspenseQuery>;
export type ResearchResultQueryResult = Apollo.QueryResult<ResearchResultQuery, ResearchResultQueryVariables>;
export const ScheduledTasksEnabledDocument = gql`
    query ScheduledTasksEnabled {
  scheduledTasksEnabled
}
    `;

/**
 * __useScheduledTasksEnabledQuery__
 *
 * To run a query within a React component, call `useScheduledTasksEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledTasksEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledTasksEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduledTasksEnabledQuery(baseOptions?: Apollo.QueryHookOptions<ScheduledTasksEnabledQuery, ScheduledTasksEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledTasksEnabledQuery, ScheduledTasksEnabledQueryVariables>(ScheduledTasksEnabledDocument, options);
      }
export function useScheduledTasksEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledTasksEnabledQuery, ScheduledTasksEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledTasksEnabledQuery, ScheduledTasksEnabledQueryVariables>(ScheduledTasksEnabledDocument, options);
        }
export function useScheduledTasksEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduledTasksEnabledQuery, ScheduledTasksEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduledTasksEnabledQuery, ScheduledTasksEnabledQueryVariables>(ScheduledTasksEnabledDocument, options);
        }
export type ScheduledTasksEnabledQueryHookResult = ReturnType<typeof useScheduledTasksEnabledQuery>;
export type ScheduledTasksEnabledLazyQueryHookResult = ReturnType<typeof useScheduledTasksEnabledLazyQuery>;
export type ScheduledTasksEnabledSuspenseQueryHookResult = ReturnType<typeof useScheduledTasksEnabledSuspenseQuery>;
export type ScheduledTasksEnabledQueryResult = Apollo.QueryResult<ScheduledTasksEnabledQuery, ScheduledTasksEnabledQueryVariables>;
export const SearchCompanyDocument = gql`
    query searchCompany($searchTerm: String, $first: Int, $after: Int, $before: Int) {
  cortexFirms(
    searchTerm: $searchTerm
    first: $first
    after: $after
    before: $before
  ) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      node {
        dbId
        shortName
        uniqueDomain
        country
        validated
        isSoftwareCompany
        sicCode
        doNotCrawl
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useSearchCompanyQuery__
 *
 * To run a query within a React component, call `useSearchCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompanyQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useSearchCompanyQuery(baseOptions?: Apollo.QueryHookOptions<SearchCompanyQuery, SearchCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCompanyQuery, SearchCompanyQueryVariables>(SearchCompanyDocument, options);
      }
export function useSearchCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCompanyQuery, SearchCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCompanyQuery, SearchCompanyQueryVariables>(SearchCompanyDocument, options);
        }
export function useSearchCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCompanyQuery, SearchCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCompanyQuery, SearchCompanyQueryVariables>(SearchCompanyDocument, options);
        }
export type SearchCompanyQueryHookResult = ReturnType<typeof useSearchCompanyQuery>;
export type SearchCompanyLazyQueryHookResult = ReturnType<typeof useSearchCompanyLazyQuery>;
export type SearchCompanySuspenseQueryHookResult = ReturnType<typeof useSearchCompanySuspenseQuery>;
export type SearchCompanyQueryResult = Apollo.QueryResult<SearchCompanyQuery, SearchCompanyQueryVariables>;
export const SearchCompanyDomainByNameDocument = gql`
    query searchCompanyDomainByName($companyName: String!, $countryCode: String, $returnDomainOnly: Boolean) {
  searchCompanyDomainByName(
    companyName: $companyName
    countryCode: $countryCode
    returnDomainOnly: $returnDomainOnly
  )
}
    `;

/**
 * __useSearchCompanyDomainByNameQuery__
 *
 * To run a query within a React component, call `useSearchCompanyDomainByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompanyDomainByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompanyDomainByNameQuery({
 *   variables: {
 *      companyName: // value for 'companyName'
 *      countryCode: // value for 'countryCode'
 *      returnDomainOnly: // value for 'returnDomainOnly'
 *   },
 * });
 */
export function useSearchCompanyDomainByNameQuery(baseOptions: Apollo.QueryHookOptions<SearchCompanyDomainByNameQuery, SearchCompanyDomainByNameQueryVariables> & ({ variables: SearchCompanyDomainByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCompanyDomainByNameQuery, SearchCompanyDomainByNameQueryVariables>(SearchCompanyDomainByNameDocument, options);
      }
export function useSearchCompanyDomainByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCompanyDomainByNameQuery, SearchCompanyDomainByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCompanyDomainByNameQuery, SearchCompanyDomainByNameQueryVariables>(SearchCompanyDomainByNameDocument, options);
        }
export function useSearchCompanyDomainByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCompanyDomainByNameQuery, SearchCompanyDomainByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCompanyDomainByNameQuery, SearchCompanyDomainByNameQueryVariables>(SearchCompanyDomainByNameDocument, options);
        }
export type SearchCompanyDomainByNameQueryHookResult = ReturnType<typeof useSearchCompanyDomainByNameQuery>;
export type SearchCompanyDomainByNameLazyQueryHookResult = ReturnType<typeof useSearchCompanyDomainByNameLazyQuery>;
export type SearchCompanyDomainByNameSuspenseQueryHookResult = ReturnType<typeof useSearchCompanyDomainByNameSuspenseQuery>;
export type SearchCompanyDomainByNameQueryResult = Apollo.QueryResult<SearchCompanyDomainByNameQuery, SearchCompanyDomainByNameQueryVariables>;
export const SearchCompanyForEvaluationDocument = gql`
    query searchCompanyForEvaluation($searchTerm: String, $first: Int, $after: Int, $before: Int) {
  cortexFirms(
    searchTerm: $searchTerm
    first: $first
    after: $after
    before: $before
  ) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      node {
        dbId
        shortName
        uniqueDomain
        country
        validated
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useSearchCompanyForEvaluationQuery__
 *
 * To run a query within a React component, call `useSearchCompanyForEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompanyForEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompanyForEvaluationQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useSearchCompanyForEvaluationQuery(baseOptions?: Apollo.QueryHookOptions<SearchCompanyForEvaluationQuery, SearchCompanyForEvaluationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCompanyForEvaluationQuery, SearchCompanyForEvaluationQueryVariables>(SearchCompanyForEvaluationDocument, options);
      }
export function useSearchCompanyForEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCompanyForEvaluationQuery, SearchCompanyForEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCompanyForEvaluationQuery, SearchCompanyForEvaluationQueryVariables>(SearchCompanyForEvaluationDocument, options);
        }
export function useSearchCompanyForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCompanyForEvaluationQuery, SearchCompanyForEvaluationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCompanyForEvaluationQuery, SearchCompanyForEvaluationQueryVariables>(SearchCompanyForEvaluationDocument, options);
        }
export type SearchCompanyForEvaluationQueryHookResult = ReturnType<typeof useSearchCompanyForEvaluationQuery>;
export type SearchCompanyForEvaluationLazyQueryHookResult = ReturnType<typeof useSearchCompanyForEvaluationLazyQuery>;
export type SearchCompanyForEvaluationSuspenseQueryHookResult = ReturnType<typeof useSearchCompanyForEvaluationSuspenseQuery>;
export type SearchCompanyForEvaluationQueryResult = Apollo.QueryResult<SearchCompanyForEvaluationQuery, SearchCompanyForEvaluationQueryVariables>;
export const GetClassificationPatternsDocument = gql`
    query GetClassificationPatterns($classificationTarget: String, $isActive: Boolean, $language: String, $excludeProbationary: Boolean) {
  classificationPatterns(
    classificationTarget: $classificationTarget
    isActive: $isActive
    language: $language
    excludeProbationary: $excludeProbationary
  ) {
    dbId
    patternText
    patternType
    classificationTarget
    weight
    isActive
    isProbationary
    probationMetadata
    description
    language
    source
    createdBy
    datetimeCreated
    datetimeModified
  }
}
    `;

/**
 * __useGetClassificationPatternsQuery__
 *
 * To run a query within a React component, call `useGetClassificationPatternsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationPatternsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassificationPatternsQuery({
 *   variables: {
 *      classificationTarget: // value for 'classificationTarget'
 *      isActive: // value for 'isActive'
 *      language: // value for 'language'
 *      excludeProbationary: // value for 'excludeProbationary'
 *   },
 * });
 */
export function useGetClassificationPatternsQuery(baseOptions?: Apollo.QueryHookOptions<GetClassificationPatternsQuery, GetClassificationPatternsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassificationPatternsQuery, GetClassificationPatternsQueryVariables>(GetClassificationPatternsDocument, options);
      }
export function useGetClassificationPatternsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassificationPatternsQuery, GetClassificationPatternsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassificationPatternsQuery, GetClassificationPatternsQueryVariables>(GetClassificationPatternsDocument, options);
        }
export function useGetClassificationPatternsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationPatternsQuery, GetClassificationPatternsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClassificationPatternsQuery, GetClassificationPatternsQueryVariables>(GetClassificationPatternsDocument, options);
        }
export type GetClassificationPatternsQueryHookResult = ReturnType<typeof useGetClassificationPatternsQuery>;
export type GetClassificationPatternsLazyQueryHookResult = ReturnType<typeof useGetClassificationPatternsLazyQuery>;
export type GetClassificationPatternsSuspenseQueryHookResult = ReturnType<typeof useGetClassificationPatternsSuspenseQuery>;
export type GetClassificationPatternsQueryResult = Apollo.QueryResult<GetClassificationPatternsQuery, GetClassificationPatternsQueryVariables>;
export const GetProbationaryPatternsDocument = gql`
    query GetProbationaryPatterns($classificationTarget: String) {
  probationaryPatterns(classificationTarget: $classificationTarget) {
    dbId
    patternText
    patternType
    classificationTarget
    weight
    isActive
    isProbationary
    probationMetadata
    description
    language
    source
    createdBy
    datetimeCreated
    datetimeModified
  }
}
    `;

/**
 * __useGetProbationaryPatternsQuery__
 *
 * To run a query within a React component, call `useGetProbationaryPatternsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProbationaryPatternsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProbationaryPatternsQuery({
 *   variables: {
 *      classificationTarget: // value for 'classificationTarget'
 *   },
 * });
 */
export function useGetProbationaryPatternsQuery(baseOptions?: Apollo.QueryHookOptions<GetProbationaryPatternsQuery, GetProbationaryPatternsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProbationaryPatternsQuery, GetProbationaryPatternsQueryVariables>(GetProbationaryPatternsDocument, options);
      }
export function useGetProbationaryPatternsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProbationaryPatternsQuery, GetProbationaryPatternsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProbationaryPatternsQuery, GetProbationaryPatternsQueryVariables>(GetProbationaryPatternsDocument, options);
        }
export function useGetProbationaryPatternsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProbationaryPatternsQuery, GetProbationaryPatternsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProbationaryPatternsQuery, GetProbationaryPatternsQueryVariables>(GetProbationaryPatternsDocument, options);
        }
export type GetProbationaryPatternsQueryHookResult = ReturnType<typeof useGetProbationaryPatternsQuery>;
export type GetProbationaryPatternsLazyQueryHookResult = ReturnType<typeof useGetProbationaryPatternsLazyQuery>;
export type GetProbationaryPatternsSuspenseQueryHookResult = ReturnType<typeof useGetProbationaryPatternsSuspenseQuery>;
export type GetProbationaryPatternsQueryResult = Apollo.QueryResult<GetProbationaryPatternsQuery, GetProbationaryPatternsQueryVariables>;
export const GetPatternEffectivenessDocument = gql`
    query GetPatternEffectiveness($minMatches: Int) {
  patternEffectiveness(minMatches: $minMatches) {
    patternId
    patternText
    classificationTarget
    isActive
    weight
    totalMatches
    correctMatches
    incorrectMatches
    pendingMatches
    precisionPct
    helpfulCount
    misleadingCount
  }
}
    `;

/**
 * __useGetPatternEffectivenessQuery__
 *
 * To run a query within a React component, call `useGetPatternEffectivenessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatternEffectivenessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatternEffectivenessQuery({
 *   variables: {
 *      minMatches: // value for 'minMatches'
 *   },
 * });
 */
export function useGetPatternEffectivenessQuery(baseOptions?: Apollo.QueryHookOptions<GetPatternEffectivenessQuery, GetPatternEffectivenessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatternEffectivenessQuery, GetPatternEffectivenessQueryVariables>(GetPatternEffectivenessDocument, options);
      }
export function useGetPatternEffectivenessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatternEffectivenessQuery, GetPatternEffectivenessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatternEffectivenessQuery, GetPatternEffectivenessQueryVariables>(GetPatternEffectivenessDocument, options);
        }
export function useGetPatternEffectivenessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatternEffectivenessQuery, GetPatternEffectivenessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatternEffectivenessQuery, GetPatternEffectivenessQueryVariables>(GetPatternEffectivenessDocument, options);
        }
export type GetPatternEffectivenessQueryHookResult = ReturnType<typeof useGetPatternEffectivenessQuery>;
export type GetPatternEffectivenessLazyQueryHookResult = ReturnType<typeof useGetPatternEffectivenessLazyQuery>;
export type GetPatternEffectivenessSuspenseQueryHookResult = ReturnType<typeof useGetPatternEffectivenessSuspenseQuery>;
export type GetPatternEffectivenessQueryResult = Apollo.QueryResult<GetPatternEffectivenessQuery, GetPatternEffectivenessQueryVariables>;
export const GetPendingPatternMatchesDocument = gql`
    query GetPendingPatternMatches($limit: Int) {
  pendingPatternMatches(limit: $limit) {
    dbId
    companyId
    matchedIn
    matchedText
    matchConfidence
    wasCorrect
    userFeedback
    datetimeCreated
    pattern {
      patternText
      classificationTarget
    }
    companyInfo {
      dbId
      uniqueDomain
      shortName
      websiteUrl
    }
  }
}
    `;

/**
 * __useGetPendingPatternMatchesQuery__
 *
 * To run a query within a React component, call `useGetPendingPatternMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingPatternMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingPatternMatchesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPendingPatternMatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingPatternMatchesQuery, GetPendingPatternMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingPatternMatchesQuery, GetPendingPatternMatchesQueryVariables>(GetPendingPatternMatchesDocument, options);
      }
export function useGetPendingPatternMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingPatternMatchesQuery, GetPendingPatternMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingPatternMatchesQuery, GetPendingPatternMatchesQueryVariables>(GetPendingPatternMatchesDocument, options);
        }
export function useGetPendingPatternMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingPatternMatchesQuery, GetPendingPatternMatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingPatternMatchesQuery, GetPendingPatternMatchesQueryVariables>(GetPendingPatternMatchesDocument, options);
        }
export type GetPendingPatternMatchesQueryHookResult = ReturnType<typeof useGetPendingPatternMatchesQuery>;
export type GetPendingPatternMatchesLazyQueryHookResult = ReturnType<typeof useGetPendingPatternMatchesLazyQuery>;
export type GetPendingPatternMatchesSuspenseQueryHookResult = ReturnType<typeof useGetPendingPatternMatchesSuspenseQuery>;
export type GetPendingPatternMatchesQueryResult = Apollo.QueryResult<GetPendingPatternMatchesQuery, GetPendingPatternMatchesQueryVariables>;
export const GetValidationAccuracyByPromptDocument = gql`
    query GetValidationAccuracyByPrompt($days: Int) {
  validationAccuracyByPrompt(days: $days) {
    promptVersion
    promptVariant
    week
    totalValidations
    falsePositives
    falseNegatives
    correct
    accuracyPct
    falsePositiveRate
  }
}
    `;

/**
 * __useGetValidationAccuracyByPromptQuery__
 *
 * To run a query within a React component, call `useGetValidationAccuracyByPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidationAccuracyByPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidationAccuracyByPromptQuery({
 *   variables: {
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetValidationAccuracyByPromptQuery(baseOptions?: Apollo.QueryHookOptions<GetValidationAccuracyByPromptQuery, GetValidationAccuracyByPromptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidationAccuracyByPromptQuery, GetValidationAccuracyByPromptQueryVariables>(GetValidationAccuracyByPromptDocument, options);
      }
export function useGetValidationAccuracyByPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidationAccuracyByPromptQuery, GetValidationAccuracyByPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidationAccuracyByPromptQuery, GetValidationAccuracyByPromptQueryVariables>(GetValidationAccuracyByPromptDocument, options);
        }
export function useGetValidationAccuracyByPromptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetValidationAccuracyByPromptQuery, GetValidationAccuracyByPromptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetValidationAccuracyByPromptQuery, GetValidationAccuracyByPromptQueryVariables>(GetValidationAccuracyByPromptDocument, options);
        }
export type GetValidationAccuracyByPromptQueryHookResult = ReturnType<typeof useGetValidationAccuracyByPromptQuery>;
export type GetValidationAccuracyByPromptLazyQueryHookResult = ReturnType<typeof useGetValidationAccuracyByPromptLazyQuery>;
export type GetValidationAccuracyByPromptSuspenseQueryHookResult = ReturnType<typeof useGetValidationAccuracyByPromptSuspenseQuery>;
export type GetValidationAccuracyByPromptQueryResult = Apollo.QueryResult<GetValidationAccuracyByPromptQuery, GetValidationAccuracyByPromptQueryVariables>;
export const GetRecentValidatedKeywordsDocument = gql`
    query GetRecentValidatedKeywords($limit: Int, $days: Int) {
  recentValidatedKeywords(limit: $limit, days: $days) {
    dbId
    companyId
    companyDomain
    companyName
    userId
    isSoftware
    validationTimestamp
    validatedKeywords {
      keyword
      relevanceScore
      reason
      selectedByUser
      userId
      selectionTimestamp
    }
    suggestedKeywords
  }
}
    `;

/**
 * __useGetRecentValidatedKeywordsQuery__
 *
 * To run a query within a React component, call `useGetRecentValidatedKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentValidatedKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentValidatedKeywordsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetRecentValidatedKeywordsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentValidatedKeywordsQuery, GetRecentValidatedKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentValidatedKeywordsQuery, GetRecentValidatedKeywordsQueryVariables>(GetRecentValidatedKeywordsDocument, options);
      }
export function useGetRecentValidatedKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentValidatedKeywordsQuery, GetRecentValidatedKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentValidatedKeywordsQuery, GetRecentValidatedKeywordsQueryVariables>(GetRecentValidatedKeywordsDocument, options);
        }
export function useGetRecentValidatedKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentValidatedKeywordsQuery, GetRecentValidatedKeywordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentValidatedKeywordsQuery, GetRecentValidatedKeywordsQueryVariables>(GetRecentValidatedKeywordsDocument, options);
        }
export type GetRecentValidatedKeywordsQueryHookResult = ReturnType<typeof useGetRecentValidatedKeywordsQuery>;
export type GetRecentValidatedKeywordsLazyQueryHookResult = ReturnType<typeof useGetRecentValidatedKeywordsLazyQuery>;
export type GetRecentValidatedKeywordsSuspenseQueryHookResult = ReturnType<typeof useGetRecentValidatedKeywordsSuspenseQuery>;
export type GetRecentValidatedKeywordsQueryResult = Apollo.QueryResult<GetRecentValidatedKeywordsQuery, GetRecentValidatedKeywordsQueryVariables>;
export const GeneratePatternsFromKeywordsDocument = gql`
    mutation GeneratePatternsFromKeywords($keywords: [String!]!, $createdBy: String, $autoActivate: Boolean, $classificationTarget: String) {
  generatePatternsFromKeywords(
    keywords: $keywords
    createdBy: $createdBy
    autoActivate: $autoActivate
    classificationTarget: $classificationTarget
  ) {
    result {
      createdCount
      success
      message
      createdPatterns
      errors
    }
  }
}
    `;
export type GeneratePatternsFromKeywordsMutationFn = Apollo.MutationFunction<GeneratePatternsFromKeywordsMutation, GeneratePatternsFromKeywordsMutationVariables>;

/**
 * __useGeneratePatternsFromKeywordsMutation__
 *
 * To run a mutation, you first call `useGeneratePatternsFromKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePatternsFromKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePatternsFromKeywordsMutation, { data, loading, error }] = useGeneratePatternsFromKeywordsMutation({
 *   variables: {
 *      keywords: // value for 'keywords'
 *      createdBy: // value for 'createdBy'
 *      autoActivate: // value for 'autoActivate'
 *      classificationTarget: // value for 'classificationTarget'
 *   },
 * });
 */
export function useGeneratePatternsFromKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePatternsFromKeywordsMutation, GeneratePatternsFromKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePatternsFromKeywordsMutation, GeneratePatternsFromKeywordsMutationVariables>(GeneratePatternsFromKeywordsDocument, options);
      }
export type GeneratePatternsFromKeywordsMutationHookResult = ReturnType<typeof useGeneratePatternsFromKeywordsMutation>;
export type GeneratePatternsFromKeywordsMutationResult = Apollo.MutationResult<GeneratePatternsFromKeywordsMutation>;
export type GeneratePatternsFromKeywordsMutationOptions = Apollo.BaseMutationOptions<GeneratePatternsFromKeywordsMutation, GeneratePatternsFromKeywordsMutationVariables>;
export const AdjustPatternWeightsDocument = gql`
    mutation AdjustPatternWeights($dryRun: Boolean) {
  adjustPatternWeights(dryRun: $dryRun) {
    result {
      dryRun
      adjustmentsCount
      success
      message
      adjustments {
        patternId
        patternText
        currentWeight
        suggestedWeight
        weightChange
        usageCount
        confidence
        applied
      }
    }
  }
}
    `;
export type AdjustPatternWeightsMutationFn = Apollo.MutationFunction<AdjustPatternWeightsMutation, AdjustPatternWeightsMutationVariables>;

/**
 * __useAdjustPatternWeightsMutation__
 *
 * To run a mutation, you first call `useAdjustPatternWeightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustPatternWeightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustPatternWeightsMutation, { data, loading, error }] = useAdjustPatternWeightsMutation({
 *   variables: {
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useAdjustPatternWeightsMutation(baseOptions?: Apollo.MutationHookOptions<AdjustPatternWeightsMutation, AdjustPatternWeightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjustPatternWeightsMutation, AdjustPatternWeightsMutationVariables>(AdjustPatternWeightsDocument, options);
      }
export type AdjustPatternWeightsMutationHookResult = ReturnType<typeof useAdjustPatternWeightsMutation>;
export type AdjustPatternWeightsMutationResult = Apollo.MutationResult<AdjustPatternWeightsMutation>;
export type AdjustPatternWeightsMutationOptions = Apollo.BaseMutationOptions<AdjustPatternWeightsMutation, AdjustPatternWeightsMutationVariables>;
export const SoftwareCategoryGrowthRatesDocument = gql`
    query softwareCategoryGrowthRates($companyId: Int) {
  softwareCategoryGrowthRates(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      cursor
      node {
        dbId
        term
        avgAlltimeInterest
        avgInterest24To12MonthsAgo
        avgInterestLast12Months
        interestGrowthRate
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useSoftwareCategoryGrowthRatesQuery__
 *
 * To run a query within a React component, call `useSoftwareCategoryGrowthRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareCategoryGrowthRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareCategoryGrowthRatesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSoftwareCategoryGrowthRatesQuery(baseOptions?: Apollo.QueryHookOptions<SoftwareCategoryGrowthRatesQuery, SoftwareCategoryGrowthRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareCategoryGrowthRatesQuery, SoftwareCategoryGrowthRatesQueryVariables>(SoftwareCategoryGrowthRatesDocument, options);
      }
export function useSoftwareCategoryGrowthRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareCategoryGrowthRatesQuery, SoftwareCategoryGrowthRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareCategoryGrowthRatesQuery, SoftwareCategoryGrowthRatesQueryVariables>(SoftwareCategoryGrowthRatesDocument, options);
        }
export function useSoftwareCategoryGrowthRatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SoftwareCategoryGrowthRatesQuery, SoftwareCategoryGrowthRatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareCategoryGrowthRatesQuery, SoftwareCategoryGrowthRatesQueryVariables>(SoftwareCategoryGrowthRatesDocument, options);
        }
export type SoftwareCategoryGrowthRatesQueryHookResult = ReturnType<typeof useSoftwareCategoryGrowthRatesQuery>;
export type SoftwareCategoryGrowthRatesLazyQueryHookResult = ReturnType<typeof useSoftwareCategoryGrowthRatesLazyQuery>;
export type SoftwareCategoryGrowthRatesSuspenseQueryHookResult = ReturnType<typeof useSoftwareCategoryGrowthRatesSuspenseQuery>;
export type SoftwareCategoryGrowthRatesQueryResult = Apollo.QueryResult<SoftwareCategoryGrowthRatesQuery, SoftwareCategoryGrowthRatesQueryVariables>;
export const SpecialCpcKeywordsDocument = gql`
    query specialCpcKeywords($companyId: Int) {
  getCompany(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      node {
        crawlResults {
          edges {
            node {
              dbId
              xoviKeywords(cpc: -1) {
                edges {
                  node {
                    id
                    keyword
                    searchEngine
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useSpecialCpcKeywordsQuery__
 *
 * To run a query within a React component, call `useSpecialCpcKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialCpcKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialCpcKeywordsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSpecialCpcKeywordsQuery(baseOptions?: Apollo.QueryHookOptions<SpecialCpcKeywordsQuery, SpecialCpcKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecialCpcKeywordsQuery, SpecialCpcKeywordsQueryVariables>(SpecialCpcKeywordsDocument, options);
      }
export function useSpecialCpcKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialCpcKeywordsQuery, SpecialCpcKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecialCpcKeywordsQuery, SpecialCpcKeywordsQueryVariables>(SpecialCpcKeywordsDocument, options);
        }
export function useSpecialCpcKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpecialCpcKeywordsQuery, SpecialCpcKeywordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpecialCpcKeywordsQuery, SpecialCpcKeywordsQueryVariables>(SpecialCpcKeywordsDocument, options);
        }
export type SpecialCpcKeywordsQueryHookResult = ReturnType<typeof useSpecialCpcKeywordsQuery>;
export type SpecialCpcKeywordsLazyQueryHookResult = ReturnType<typeof useSpecialCpcKeywordsLazyQuery>;
export type SpecialCpcKeywordsSuspenseQueryHookResult = ReturnType<typeof useSpecialCpcKeywordsSuspenseQuery>;
export type SpecialCpcKeywordsQueryResult = Apollo.QueryResult<SpecialCpcKeywordsQuery, SpecialCpcKeywordsQueryVariables>;
export const StatusMessageDocument = gql`
    query statusMessage($clientId: String!) {
  statusMessage(clientId: $clientId)
}
    `;

/**
 * __useStatusMessageQuery__
 *
 * To run a query within a React component, call `useStatusMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatusMessageQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useStatusMessageQuery(baseOptions: Apollo.QueryHookOptions<StatusMessageQuery, StatusMessageQueryVariables> & ({ variables: StatusMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatusMessageQuery, StatusMessageQueryVariables>(StatusMessageDocument, options);
      }
export function useStatusMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatusMessageQuery, StatusMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatusMessageQuery, StatusMessageQueryVariables>(StatusMessageDocument, options);
        }
export function useStatusMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatusMessageQuery, StatusMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StatusMessageQuery, StatusMessageQueryVariables>(StatusMessageDocument, options);
        }
export type StatusMessageQueryHookResult = ReturnType<typeof useStatusMessageQuery>;
export type StatusMessageLazyQueryHookResult = ReturnType<typeof useStatusMessageLazyQuery>;
export type StatusMessageSuspenseQueryHookResult = ReturnType<typeof useStatusMessageSuspenseQuery>;
export type StatusMessageQueryResult = Apollo.QueryResult<StatusMessageQuery, StatusMessageQueryVariables>;
export const SwCentroidStatsDocument = gql`
    query swCentroidStats {
  swCentroidStats {
    version
    threshold
    auc
    recall
    precision
    filterRate
    separation
    swCount
    nonSwCount
    computedAt
    model
    threshold95
    threshold97
    threshold99
    threshold995
  }
}
    `;

/**
 * __useSwCentroidStatsQuery__
 *
 * To run a query within a React component, call `useSwCentroidStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwCentroidStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwCentroidStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSwCentroidStatsQuery(baseOptions?: Apollo.QueryHookOptions<SwCentroidStatsQuery, SwCentroidStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwCentroidStatsQuery, SwCentroidStatsQueryVariables>(SwCentroidStatsDocument, options);
      }
export function useSwCentroidStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwCentroidStatsQuery, SwCentroidStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwCentroidStatsQuery, SwCentroidStatsQueryVariables>(SwCentroidStatsDocument, options);
        }
export function useSwCentroidStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwCentroidStatsQuery, SwCentroidStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwCentroidStatsQuery, SwCentroidStatsQueryVariables>(SwCentroidStatsDocument, options);
        }
export type SwCentroidStatsQueryHookResult = ReturnType<typeof useSwCentroidStatsQuery>;
export type SwCentroidStatsLazyQueryHookResult = ReturnType<typeof useSwCentroidStatsLazyQuery>;
export type SwCentroidStatsSuspenseQueryHookResult = ReturnType<typeof useSwCentroidStatsSuspenseQuery>;
export type SwCentroidStatsQueryResult = Apollo.QueryResult<SwCentroidStatsQuery, SwCentroidStatsQueryVariables>;
export const SwFalsePositiveCompaniesDocument = gql`
    query swFalsePositiveCompanies($limit: Int) {
  swFalsePositiveCompanies(limit: $limit) {
    companyId
    domain
    companyName
    validationDate
  }
}
    `;

/**
 * __useSwFalsePositiveCompaniesQuery__
 *
 * To run a query within a React component, call `useSwFalsePositiveCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwFalsePositiveCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwFalsePositiveCompaniesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSwFalsePositiveCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<SwFalsePositiveCompaniesQuery, SwFalsePositiveCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwFalsePositiveCompaniesQuery, SwFalsePositiveCompaniesQueryVariables>(SwFalsePositiveCompaniesDocument, options);
      }
export function useSwFalsePositiveCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwFalsePositiveCompaniesQuery, SwFalsePositiveCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwFalsePositiveCompaniesQuery, SwFalsePositiveCompaniesQueryVariables>(SwFalsePositiveCompaniesDocument, options);
        }
export function useSwFalsePositiveCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwFalsePositiveCompaniesQuery, SwFalsePositiveCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwFalsePositiveCompaniesQuery, SwFalsePositiveCompaniesQueryVariables>(SwFalsePositiveCompaniesDocument, options);
        }
export type SwFalsePositiveCompaniesQueryHookResult = ReturnType<typeof useSwFalsePositiveCompaniesQuery>;
export type SwFalsePositiveCompaniesLazyQueryHookResult = ReturnType<typeof useSwFalsePositiveCompaniesLazyQuery>;
export type SwFalsePositiveCompaniesSuspenseQueryHookResult = ReturnType<typeof useSwFalsePositiveCompaniesSuspenseQuery>;
export type SwFalsePositiveCompaniesQueryResult = Apollo.QueryResult<SwFalsePositiveCompaniesQuery, SwFalsePositiveCompaniesQueryVariables>;
export const SwPredictionSummaryDocument = gql`
    query swPredictionSummary($timeRange: String) {
  swPredictionSummary(timeRange: $timeRange) {
    timeRange
    total
    swCount
    nonSwCount
    filterRate
    avgSimilarity
  }
}
    `;

/**
 * __useSwPredictionSummaryQuery__
 *
 * To run a query within a React component, call `useSwPredictionSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwPredictionSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwPredictionSummaryQuery({
 *   variables: {
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useSwPredictionSummaryQuery(baseOptions?: Apollo.QueryHookOptions<SwPredictionSummaryQuery, SwPredictionSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwPredictionSummaryQuery, SwPredictionSummaryQueryVariables>(SwPredictionSummaryDocument, options);
      }
export function useSwPredictionSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwPredictionSummaryQuery, SwPredictionSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwPredictionSummaryQuery, SwPredictionSummaryQueryVariables>(SwPredictionSummaryDocument, options);
        }
export function useSwPredictionSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwPredictionSummaryQuery, SwPredictionSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwPredictionSummaryQuery, SwPredictionSummaryQueryVariables>(SwPredictionSummaryDocument, options);
        }
export type SwPredictionSummaryQueryHookResult = ReturnType<typeof useSwPredictionSummaryQuery>;
export type SwPredictionSummaryLazyQueryHookResult = ReturnType<typeof useSwPredictionSummaryLazyQuery>;
export type SwPredictionSummarySuspenseQueryHookResult = ReturnType<typeof useSwPredictionSummarySuspenseQuery>;
export type SwPredictionSummaryQueryResult = Apollo.QueryResult<SwPredictionSummaryQuery, SwPredictionSummaryQueryVariables>;
export const SwPredictionTimeSeriesDocument = gql`
    query swPredictionTimeSeries($timeRange: String) {
  swPredictionTimeSeries(timeRange: $timeRange) {
    timeRange
    dataPoints {
      timestamp
      total
      swCount
      nonSwCount
      filterRate
      avgSimilarity
    }
  }
}
    `;

/**
 * __useSwPredictionTimeSeriesQuery__
 *
 * To run a query within a React component, call `useSwPredictionTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwPredictionTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwPredictionTimeSeriesQuery({
 *   variables: {
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useSwPredictionTimeSeriesQuery(baseOptions?: Apollo.QueryHookOptions<SwPredictionTimeSeriesQuery, SwPredictionTimeSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwPredictionTimeSeriesQuery, SwPredictionTimeSeriesQueryVariables>(SwPredictionTimeSeriesDocument, options);
      }
export function useSwPredictionTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwPredictionTimeSeriesQuery, SwPredictionTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwPredictionTimeSeriesQuery, SwPredictionTimeSeriesQueryVariables>(SwPredictionTimeSeriesDocument, options);
        }
export function useSwPredictionTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwPredictionTimeSeriesQuery, SwPredictionTimeSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwPredictionTimeSeriesQuery, SwPredictionTimeSeriesQueryVariables>(SwPredictionTimeSeriesDocument, options);
        }
export type SwPredictionTimeSeriesQueryHookResult = ReturnType<typeof useSwPredictionTimeSeriesQuery>;
export type SwPredictionTimeSeriesLazyQueryHookResult = ReturnType<typeof useSwPredictionTimeSeriesLazyQuery>;
export type SwPredictionTimeSeriesSuspenseQueryHookResult = ReturnType<typeof useSwPredictionTimeSeriesSuspenseQuery>;
export type SwPredictionTimeSeriesQueryResult = Apollo.QueryResult<SwPredictionTimeSeriesQuery, SwPredictionTimeSeriesQueryVariables>;
export const SwTrainingDataStatsDocument = gql`
    query swTrainingDataStats {
  swTrainingDataStats {
    swCount
    swEmbedded
    nonSwCount
    nonSwEmbedded
    fpCount
    fpEmbedded
    lastRetrain
  }
}
    `;

/**
 * __useSwTrainingDataStatsQuery__
 *
 * To run a query within a React component, call `useSwTrainingDataStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwTrainingDataStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwTrainingDataStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSwTrainingDataStatsQuery(baseOptions?: Apollo.QueryHookOptions<SwTrainingDataStatsQuery, SwTrainingDataStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwTrainingDataStatsQuery, SwTrainingDataStatsQueryVariables>(SwTrainingDataStatsDocument, options);
      }
export function useSwTrainingDataStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwTrainingDataStatsQuery, SwTrainingDataStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwTrainingDataStatsQuery, SwTrainingDataStatsQueryVariables>(SwTrainingDataStatsDocument, options);
        }
export function useSwTrainingDataStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwTrainingDataStatsQuery, SwTrainingDataStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwTrainingDataStatsQuery, SwTrainingDataStatsQueryVariables>(SwTrainingDataStatsDocument, options);
        }
export type SwTrainingDataStatsQueryHookResult = ReturnType<typeof useSwTrainingDataStatsQuery>;
export type SwTrainingDataStatsLazyQueryHookResult = ReturnType<typeof useSwTrainingDataStatsLazyQuery>;
export type SwTrainingDataStatsSuspenseQueryHookResult = ReturnType<typeof useSwTrainingDataStatsSuspenseQuery>;
export type SwTrainingDataStatsQueryResult = Apollo.QueryResult<SwTrainingDataStatsQuery, SwTrainingDataStatsQueryVariables>;
export const SwValidationFeedbackDocument = gql`
    query swValidationFeedback {
  swValidationFeedback {
    tp
    fp
    tn
    fn
    total
    accuracy
    precision
    recall
  }
}
    `;

/**
 * __useSwValidationFeedbackQuery__
 *
 * To run a query within a React component, call `useSwValidationFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwValidationFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwValidationFeedbackQuery({
 *   variables: {
 *   },
 * });
 */
export function useSwValidationFeedbackQuery(baseOptions?: Apollo.QueryHookOptions<SwValidationFeedbackQuery, SwValidationFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwValidationFeedbackQuery, SwValidationFeedbackQueryVariables>(SwValidationFeedbackDocument, options);
      }
export function useSwValidationFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwValidationFeedbackQuery, SwValidationFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwValidationFeedbackQuery, SwValidationFeedbackQueryVariables>(SwValidationFeedbackDocument, options);
        }
export function useSwValidationFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwValidationFeedbackQuery, SwValidationFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwValidationFeedbackQuery, SwValidationFeedbackQueryVariables>(SwValidationFeedbackDocument, options);
        }
export type SwValidationFeedbackQueryHookResult = ReturnType<typeof useSwValidationFeedbackQuery>;
export type SwValidationFeedbackLazyQueryHookResult = ReturnType<typeof useSwValidationFeedbackLazyQuery>;
export type SwValidationFeedbackSuspenseQueryHookResult = ReturnType<typeof useSwValidationFeedbackSuspenseQuery>;
export type SwValidationFeedbackQueryResult = Apollo.QueryResult<SwValidationFeedbackQuery, SwValidationFeedbackQueryVariables>;
export const TopCpcKeywordDocument = gql`
    query topCpcKeyword($companyId: Int) {
  getCompany(companyId: $companyId) {
    pageInfo {
      ...DbIdPageInfoFragment
    }
    edges {
      node {
        crawlResults {
          edges {
            node {
              dbId
              xoviKeywords(orderBy: CPC_DESC) {
                edges {
                  node {
                    id
                    keyword
                    searchEngine
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DbIdPageInfoFragmentFragmentDoc}`;

/**
 * __useTopCpcKeywordQuery__
 *
 * To run a query within a React component, call `useTopCpcKeywordQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopCpcKeywordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopCpcKeywordQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useTopCpcKeywordQuery(baseOptions?: Apollo.QueryHookOptions<TopCpcKeywordQuery, TopCpcKeywordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopCpcKeywordQuery, TopCpcKeywordQueryVariables>(TopCpcKeywordDocument, options);
      }
export function useTopCpcKeywordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopCpcKeywordQuery, TopCpcKeywordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopCpcKeywordQuery, TopCpcKeywordQueryVariables>(TopCpcKeywordDocument, options);
        }
export function useTopCpcKeywordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopCpcKeywordQuery, TopCpcKeywordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopCpcKeywordQuery, TopCpcKeywordQueryVariables>(TopCpcKeywordDocument, options);
        }
export type TopCpcKeywordQueryHookResult = ReturnType<typeof useTopCpcKeywordQuery>;
export type TopCpcKeywordLazyQueryHookResult = ReturnType<typeof useTopCpcKeywordLazyQuery>;
export type TopCpcKeywordSuspenseQueryHookResult = ReturnType<typeof useTopCpcKeywordSuspenseQuery>;
export type TopCpcKeywordQueryResult = Apollo.QueryResult<TopCpcKeywordQuery, TopCpcKeywordQueryVariables>;
export const UserStatsDocument = gql`
    query UserStats($userId: Int, $dateFrom: DateTime, $dateTo: DateTime) {
  userStats(userId: $userId, dateFrom: $dateFrom, dateTo: $dateTo) {
    userId
    userName
    callCount
    surveyCount
    surveyCompletionRate
    companiesContacted
    dealsTotal
    dealsWon
    totalActivities
  }
}
    `;

/**
 * __useUserStatsQuery__
 *
 * To run a query within a React component, call `useUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStatsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useUserStatsQuery(baseOptions?: Apollo.QueryHookOptions<UserStatsQuery, UserStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserStatsQuery, UserStatsQueryVariables>(UserStatsDocument, options);
      }
export function useUserStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserStatsQuery, UserStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserStatsQuery, UserStatsQueryVariables>(UserStatsDocument, options);
        }
export function useUserStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserStatsQuery, UserStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserStatsQuery, UserStatsQueryVariables>(UserStatsDocument, options);
        }
export type UserStatsQueryHookResult = ReturnType<typeof useUserStatsQuery>;
export type UserStatsLazyQueryHookResult = ReturnType<typeof useUserStatsLazyQuery>;
export type UserStatsSuspenseQueryHookResult = ReturnType<typeof useUserStatsSuspenseQuery>;
export type UserStatsQueryResult = Apollo.QueryResult<UserStatsQuery, UserStatsQueryVariables>;
export const ValidationInboxDocument = gql`
    query validationInbox($country: String, $validationNeeded: String, $limit: Int, $offset: Int) {
  validationInbox(
    country: $country
    validationNeeded: $validationNeeded
    limit: $limit
    offset: $offset
  ) {
    companyId
    shortName
    country
    uniqueDomain
    isSoftwareCompany
    companyValidated
    companyValidatedAt
    companyCreatedAt
    pipedriveId
    crawlUrl
    sicCode
    latestCrawlResultId
    latestCrValidated
    latestCrCreated
    crawlFte
    lastValidatedCrCreated
    analysisFte
    validationNeeded
    callabilityScore
    productName
    logoUrl
    crawlWasFinished
    validationLockedBy
    validationLockedAt
  }
}
    `;

/**
 * __useValidationInboxQuery__
 *
 * To run a query within a React component, call `useValidationInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidationInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidationInboxQuery({
 *   variables: {
 *      country: // value for 'country'
 *      validationNeeded: // value for 'validationNeeded'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useValidationInboxQuery(baseOptions?: Apollo.QueryHookOptions<ValidationInboxQuery, ValidationInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidationInboxQuery, ValidationInboxQueryVariables>(ValidationInboxDocument, options);
      }
export function useValidationInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidationInboxQuery, ValidationInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidationInboxQuery, ValidationInboxQueryVariables>(ValidationInboxDocument, options);
        }
export function useValidationInboxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidationInboxQuery, ValidationInboxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidationInboxQuery, ValidationInboxQueryVariables>(ValidationInboxDocument, options);
        }
export type ValidationInboxQueryHookResult = ReturnType<typeof useValidationInboxQuery>;
export type ValidationInboxLazyQueryHookResult = ReturnType<typeof useValidationInboxLazyQuery>;
export type ValidationInboxSuspenseQueryHookResult = ReturnType<typeof useValidationInboxSuspenseQuery>;
export type ValidationInboxQueryResult = Apollo.QueryResult<ValidationInboxQuery, ValidationInboxQueryVariables>;
export const WaterfallDrillDownDocument = gql`
    query waterfallDrillDown($barLabel: String!, $dateFrom: DateTime!, $dateTo: DateTime) {
  waterfallDrillDown(barLabel: $barLabel, dateFrom: $dateFrom, dateTo: $dateTo) {
    companyId
    companyName
    domain
    meetingHolders
  }
}
    `;

/**
 * __useWaterfallDrillDownQuery__
 *
 * To run a query within a React component, call `useWaterfallDrillDownQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaterfallDrillDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaterfallDrillDownQuery({
 *   variables: {
 *      barLabel: // value for 'barLabel'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useWaterfallDrillDownQuery(baseOptions: Apollo.QueryHookOptions<WaterfallDrillDownQuery, WaterfallDrillDownQueryVariables> & ({ variables: WaterfallDrillDownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaterfallDrillDownQuery, WaterfallDrillDownQueryVariables>(WaterfallDrillDownDocument, options);
      }
export function useWaterfallDrillDownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaterfallDrillDownQuery, WaterfallDrillDownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaterfallDrillDownQuery, WaterfallDrillDownQueryVariables>(WaterfallDrillDownDocument, options);
        }
export function useWaterfallDrillDownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaterfallDrillDownQuery, WaterfallDrillDownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WaterfallDrillDownQuery, WaterfallDrillDownQueryVariables>(WaterfallDrillDownDocument, options);
        }
export type WaterfallDrillDownQueryHookResult = ReturnType<typeof useWaterfallDrillDownQuery>;
export type WaterfallDrillDownLazyQueryHookResult = ReturnType<typeof useWaterfallDrillDownLazyQuery>;
export type WaterfallDrillDownSuspenseQueryHookResult = ReturnType<typeof useWaterfallDrillDownSuspenseQuery>;
export type WaterfallDrillDownQueryResult = Apollo.QueryResult<WaterfallDrillDownQuery, WaterfallDrillDownQueryVariables>;
export const XoviKeywordsForCrawlResultDocument = gql`
    query xoviKeywordsForCrawlResult($crawlResultId: Int!) {
  xoviKeywordsForCrawlResult(crawlResultId: $crawlResultId) {
    id
    keyword
    cpc
    sevo
    position
    url
    searchEngine
    isPlaceholderForEmptyXoviResponse
    markedAsIrrelevant
  }
}
    `;

/**
 * __useXoviKeywordsForCrawlResultQuery__
 *
 * To run a query within a React component, call `useXoviKeywordsForCrawlResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useXoviKeywordsForCrawlResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useXoviKeywordsForCrawlResultQuery({
 *   variables: {
 *      crawlResultId: // value for 'crawlResultId'
 *   },
 * });
 */
export function useXoviKeywordsForCrawlResultQuery(baseOptions: Apollo.QueryHookOptions<XoviKeywordsForCrawlResultQuery, XoviKeywordsForCrawlResultQueryVariables> & ({ variables: XoviKeywordsForCrawlResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<XoviKeywordsForCrawlResultQuery, XoviKeywordsForCrawlResultQueryVariables>(XoviKeywordsForCrawlResultDocument, options);
      }
export function useXoviKeywordsForCrawlResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<XoviKeywordsForCrawlResultQuery, XoviKeywordsForCrawlResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<XoviKeywordsForCrawlResultQuery, XoviKeywordsForCrawlResultQueryVariables>(XoviKeywordsForCrawlResultDocument, options);
        }
export function useXoviKeywordsForCrawlResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<XoviKeywordsForCrawlResultQuery, XoviKeywordsForCrawlResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<XoviKeywordsForCrawlResultQuery, XoviKeywordsForCrawlResultQueryVariables>(XoviKeywordsForCrawlResultDocument, options);
        }
export type XoviKeywordsForCrawlResultQueryHookResult = ReturnType<typeof useXoviKeywordsForCrawlResultQuery>;
export type XoviKeywordsForCrawlResultLazyQueryHookResult = ReturnType<typeof useXoviKeywordsForCrawlResultLazyQuery>;
export type XoviKeywordsForCrawlResultSuspenseQueryHookResult = ReturnType<typeof useXoviKeywordsForCrawlResultSuspenseQuery>;
export type XoviKeywordsForCrawlResultQueryResult = Apollo.QueryResult<XoviKeywordsForCrawlResultQuery, XoviKeywordsForCrawlResultQueryVariables>;
export const EnrichmentAnalyticsDocument = gql`
    query EnrichmentAnalytics($timeRange: String!) {
  enrichmentAnalytics(timeRange: $timeRange) {
    timeRange
    startDate
    endDate
    summary {
      totalEnrichments
      avgTotalTimeMs
      avgExistingTimeMs
      avgFirecrawlTimeMs
      avgApolloTimeMs
      avgCacheHitRate
      totalPagesScraped
      totalPagesCached
      totalFirecrawlCredits
      totalApolloCredits
      firecrawlSuccessRate
      apolloCallRate
      apolloSuccessRate
    }
    methodBreakdown {
      method
      count
      avgTimeMs
      percentage
    }
    layerTiming {
      existingPercent
      firecrawlPercent
      apolloPercent
    }
    insights {
      type
      category
      title
      message
      priority
    }
  }
}
    `;

/**
 * __useEnrichmentAnalyticsQuery__
 *
 * To run a query within a React component, call `useEnrichmentAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentAnalyticsQuery({
 *   variables: {
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useEnrichmentAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentAnalyticsQuery, EnrichmentAnalyticsQueryVariables> & ({ variables: EnrichmentAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentAnalyticsQuery, EnrichmentAnalyticsQueryVariables>(EnrichmentAnalyticsDocument, options);
      }
export function useEnrichmentAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentAnalyticsQuery, EnrichmentAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentAnalyticsQuery, EnrichmentAnalyticsQueryVariables>(EnrichmentAnalyticsDocument, options);
        }
export function useEnrichmentAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnrichmentAnalyticsQuery, EnrichmentAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnrichmentAnalyticsQuery, EnrichmentAnalyticsQueryVariables>(EnrichmentAnalyticsDocument, options);
        }
export type EnrichmentAnalyticsQueryHookResult = ReturnType<typeof useEnrichmentAnalyticsQuery>;
export type EnrichmentAnalyticsLazyQueryHookResult = ReturnType<typeof useEnrichmentAnalyticsLazyQuery>;
export type EnrichmentAnalyticsSuspenseQueryHookResult = ReturnType<typeof useEnrichmentAnalyticsSuspenseQuery>;
export type EnrichmentAnalyticsQueryResult = Apollo.QueryResult<EnrichmentAnalyticsQuery, EnrichmentAnalyticsQueryVariables>;
export const EnrichmentCostAnalysisDocument = gql`
    query EnrichmentCostAnalysis($timeRange: String!) {
  enrichmentCostAnalysis(timeRange: $timeRange) {
    timeRange
    costs {
      firecrawlCost
      apolloCost
      totalCost
      avgCostPerEnrichment
    }
    usage {
      totalEnrichments
      firecrawlCreditsUsed
      apolloCreditsUsed
      apolloCallRate
    }
    cacheImpact {
      cacheHitRate
      pagesCached
      pagesScraped
      estimatedSavings
    }
    projections {
      monthlyCostProjection
    }
    recommendations
  }
}
    `;

/**
 * __useEnrichmentCostAnalysisQuery__
 *
 * To run a query within a React component, call `useEnrichmentCostAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentCostAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentCostAnalysisQuery({
 *   variables: {
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useEnrichmentCostAnalysisQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentCostAnalysisQuery, EnrichmentCostAnalysisQueryVariables> & ({ variables: EnrichmentCostAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentCostAnalysisQuery, EnrichmentCostAnalysisQueryVariables>(EnrichmentCostAnalysisDocument, options);
      }
export function useEnrichmentCostAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentCostAnalysisQuery, EnrichmentCostAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentCostAnalysisQuery, EnrichmentCostAnalysisQueryVariables>(EnrichmentCostAnalysisDocument, options);
        }
export function useEnrichmentCostAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnrichmentCostAnalysisQuery, EnrichmentCostAnalysisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnrichmentCostAnalysisQuery, EnrichmentCostAnalysisQueryVariables>(EnrichmentCostAnalysisDocument, options);
        }
export type EnrichmentCostAnalysisQueryHookResult = ReturnType<typeof useEnrichmentCostAnalysisQuery>;
export type EnrichmentCostAnalysisLazyQueryHookResult = ReturnType<typeof useEnrichmentCostAnalysisLazyQuery>;
export type EnrichmentCostAnalysisSuspenseQueryHookResult = ReturnType<typeof useEnrichmentCostAnalysisSuspenseQuery>;
export type EnrichmentCostAnalysisQueryResult = Apollo.QueryResult<EnrichmentCostAnalysisQuery, EnrichmentCostAnalysisQueryVariables>;
export const EnrichmentTimeSeriesDocument = gql`
    query EnrichmentTimeSeries($timeRange: String!) {
  enrichmentTimeSeries(timeRange: $timeRange) {
    timeRange
    dataPoints {
      timestamp
      count
      avgTimeMs
      avgCacheRate
    }
  }
}
    `;

/**
 * __useEnrichmentTimeSeriesQuery__
 *
 * To run a query within a React component, call `useEnrichmentTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentTimeSeriesQuery({
 *   variables: {
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useEnrichmentTimeSeriesQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentTimeSeriesQuery, EnrichmentTimeSeriesQueryVariables> & ({ variables: EnrichmentTimeSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentTimeSeriesQuery, EnrichmentTimeSeriesQueryVariables>(EnrichmentTimeSeriesDocument, options);
      }
export function useEnrichmentTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentTimeSeriesQuery, EnrichmentTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentTimeSeriesQuery, EnrichmentTimeSeriesQueryVariables>(EnrichmentTimeSeriesDocument, options);
        }
export function useEnrichmentTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnrichmentTimeSeriesQuery, EnrichmentTimeSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnrichmentTimeSeriesQuery, EnrichmentTimeSeriesQueryVariables>(EnrichmentTimeSeriesDocument, options);
        }
export type EnrichmentTimeSeriesQueryHookResult = ReturnType<typeof useEnrichmentTimeSeriesQuery>;
export type EnrichmentTimeSeriesLazyQueryHookResult = ReturnType<typeof useEnrichmentTimeSeriesLazyQuery>;
export type EnrichmentTimeSeriesSuspenseQueryHookResult = ReturnType<typeof useEnrichmentTimeSeriesSuspenseQuery>;
export type EnrichmentTimeSeriesQueryResult = Apollo.QueryResult<EnrichmentTimeSeriesQuery, EnrichmentTimeSeriesQueryVariables>;
export const EnrichmentLayerSuccessDocument = gql`
    query EnrichmentLayerSuccess($timeRange: String!) {
  enrichmentLayerSuccess(timeRange: $timeRange) {
    timeRange
    startDate
    endDate
    totalEnrichmentsAnalyzed
    overallSuccessRate
    existingPerformance {
      successfulExtractions
      successRate
    }
    firecrawlPerformance {
      successfulExtractions
      successRate
    }
    apolloPerformance {
      successfulExtractions
      successRate
    }
    contactEmailCoverage {
      totalFound
      existingCount
      firecrawlCount
      apolloCount
      coverageRate
    }
    managingDirectorCoverage {
      totalFound
      existingCount
      firecrawlCount
      apolloCount
      coverageRate
    }
    insights {
      type
      category
      title
      message
      priority
    }
  }
}
    `;

/**
 * __useEnrichmentLayerSuccessQuery__
 *
 * To run a query within a React component, call `useEnrichmentLayerSuccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentLayerSuccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentLayerSuccessQuery({
 *   variables: {
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useEnrichmentLayerSuccessQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentLayerSuccessQuery, EnrichmentLayerSuccessQueryVariables> & ({ variables: EnrichmentLayerSuccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentLayerSuccessQuery, EnrichmentLayerSuccessQueryVariables>(EnrichmentLayerSuccessDocument, options);
      }
export function useEnrichmentLayerSuccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentLayerSuccessQuery, EnrichmentLayerSuccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentLayerSuccessQuery, EnrichmentLayerSuccessQueryVariables>(EnrichmentLayerSuccessDocument, options);
        }
export function useEnrichmentLayerSuccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnrichmentLayerSuccessQuery, EnrichmentLayerSuccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnrichmentLayerSuccessQuery, EnrichmentLayerSuccessQueryVariables>(EnrichmentLayerSuccessDocument, options);
        }
export type EnrichmentLayerSuccessQueryHookResult = ReturnType<typeof useEnrichmentLayerSuccessQuery>;
export type EnrichmentLayerSuccessLazyQueryHookResult = ReturnType<typeof useEnrichmentLayerSuccessLazyQuery>;
export type EnrichmentLayerSuccessSuspenseQueryHookResult = ReturnType<typeof useEnrichmentLayerSuccessSuspenseQuery>;
export type EnrichmentLayerSuccessQueryResult = Apollo.QueryResult<EnrichmentLayerSuccessQuery, EnrichmentLayerSuccessQueryVariables>;
export const GetSuggestedKeywordsDocument = gql`
    query GetSuggestedKeywords($companyId: Int!) {
  getSuggestedKeywords(companyId: $companyId) {
    software {
      keyword
      source
      confidence
      weight
      matchCount
      patternId
    }
    nonSoftware {
      keyword
      source
      confidence
      weight
      matchCount
      patternId
    }
  }
}
    `;

/**
 * __useGetSuggestedKeywordsQuery__
 *
 * To run a query within a React component, call `useGetSuggestedKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedKeywordsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetSuggestedKeywordsQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestedKeywordsQuery, GetSuggestedKeywordsQueryVariables> & ({ variables: GetSuggestedKeywordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedKeywordsQuery, GetSuggestedKeywordsQueryVariables>(GetSuggestedKeywordsDocument, options);
      }
export function useGetSuggestedKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedKeywordsQuery, GetSuggestedKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedKeywordsQuery, GetSuggestedKeywordsQueryVariables>(GetSuggestedKeywordsDocument, options);
        }
export function useGetSuggestedKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedKeywordsQuery, GetSuggestedKeywordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuggestedKeywordsQuery, GetSuggestedKeywordsQueryVariables>(GetSuggestedKeywordsDocument, options);
        }
export type GetSuggestedKeywordsQueryHookResult = ReturnType<typeof useGetSuggestedKeywordsQuery>;
export type GetSuggestedKeywordsLazyQueryHookResult = ReturnType<typeof useGetSuggestedKeywordsLazyQuery>;
export type GetSuggestedKeywordsSuspenseQueryHookResult = ReturnType<typeof useGetSuggestedKeywordsSuspenseQuery>;
export type GetSuggestedKeywordsQueryResult = Apollo.QueryResult<GetSuggestedKeywordsQuery, GetSuggestedKeywordsQueryVariables>;
export const SaveValidationKeywordDocument = gql`
    mutation SaveValidationKeyword($companyId: Int!, $userId: Int!, $keyword: String!, $source: String!, $confidence: Float, $isSoftware: Boolean) {
  saveValidationKeyword(
    companyId: $companyId
    userId: $userId
    keyword: $keyword
    source: $source
    confidence: $confidence
    isSoftware: $isSoftware
  ) {
    success
    message
  }
}
    `;
export type SaveValidationKeywordMutationFn = Apollo.MutationFunction<SaveValidationKeywordMutation, SaveValidationKeywordMutationVariables>;

/**
 * __useSaveValidationKeywordMutation__
 *
 * To run a mutation, you first call `useSaveValidationKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveValidationKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveValidationKeywordMutation, { data, loading, error }] = useSaveValidationKeywordMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      keyword: // value for 'keyword'
 *      source: // value for 'source'
 *      confidence: // value for 'confidence'
 *      isSoftware: // value for 'isSoftware'
 *   },
 * });
 */
export function useSaveValidationKeywordMutation(baseOptions?: Apollo.MutationHookOptions<SaveValidationKeywordMutation, SaveValidationKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveValidationKeywordMutation, SaveValidationKeywordMutationVariables>(SaveValidationKeywordDocument, options);
      }
export type SaveValidationKeywordMutationHookResult = ReturnType<typeof useSaveValidationKeywordMutation>;
export type SaveValidationKeywordMutationResult = Apollo.MutationResult<SaveValidationKeywordMutation>;
export type SaveValidationKeywordMutationOptions = Apollo.BaseMutationOptions<SaveValidationKeywordMutation, SaveValidationKeywordMutationVariables>;